import * as th from "vue";
import { defineComponent as U, ref as se, provide as tt, createElementBlock as B, openBlock as $, renderSlot as V, inject as je, createBlock as ne, Transition as lp, withCtx as Y, withDirectives as Dr, createElementVNode as X, unref as S, vShow as li, computed as re, watch as at, getCurrentScope as Bs, onScopeDispose as up, isRef as us, reactive as ws, toRef as _s, readonly as qs, customRef as $0, onMounted as Lt, nextTick as Qe, getCurrentInstance as rn, hasInjectionContext as C0, toRefs as Qr, toValue as $r, shallowRef as Zr, watchEffect as Pr, normalizeClass as Te, createCommentVNode as _e, createVNode as ie, shallowReadonly as Fo, onUnmounted as Co, resolveComponent as Nw, normalizeProps as zr, guardReactiveProps as ko, resolveDynamicComponent as er, mergeProps as We, normalizeStyle as $t, createTextVNode as et, toDisplayString as Ie, watchSyncEffect as zw, withKeys as cs, withModifiers as Ss, camelize as k0, h as Cr, Fragment as qt, renderList as sr, markRaw as Tf, toHandlerKey as jw, Comment as Uw, cloneVNode as Ww, mergeDefaults as P0, watchPostEffect as Vw, effectScope as I0, Teleport as Hw, onBeforeUnmount as Gw, onBeforeUpdate as Kw, onUpdated as Yw, mergeModels as br, useModel as wr, vModelCheckbox as D0, vModelText as Jw, vModelRadio as R0, useSlots as Zw, vModelSelect as Xw } from "vue";
const Qw = { class: "w-full" }, v6 = /* @__PURE__ */ U({
  __name: "Accordion",
  props: {
    orientation: { default: "vertical" }
  },
  setup(e) {
    const t = se(null);
    return tt("activeAccordionItem", t), (r, n) => ($(), B("div", Qw, [
      V(r.$slots, "default")
    ]));
  }
}), e_ = ["id"], t_ = { class: "py-3" }, g6 = /* @__PURE__ */ U({
  __name: "AccordionContent",
  setup(e) {
    const t = je("accordionItemActive"), r = je("accordionItemId");
    function n(s) {
      s.style.height = "0";
    }
    function o(s) {
      s.style.height = s.scrollHeight + "px";
    }
    function a(s) {
      s.style.height = s.scrollHeight + "px";
    }
    function i(s) {
      s.style.height = "0";
    }
    return (s, l) => ($(), ne(lp, {
      name: "accordion",
      onEnter: o,
      onLeave: i,
      onBeforeEnter: n,
      onBeforeLeave: a
    }, {
      default: Y(() => [
        Dr(X("div", {
          id: S(r),
          class: "transition-all duration-200 ease-in-out overflow-hidden",
          role: "region"
        }, [
          X("div", t_, [
            V(s.$slots, "default")
          ])
        ], 8, e_), [
          [li, S(t)]
        ])
      ]),
      _: 3
    }));
  }
});
var Ht = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function ui(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function r_(e) {
  if (Object.prototype.hasOwnProperty.call(e, "__esModule")) return e;
  var t = e.default;
  if (typeof t == "function") {
    var r = function n() {
      return this instanceof n ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    r.prototype = t.prototype;
  } else r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(e).forEach(function(n) {
    var o = Object.getOwnPropertyDescriptor(e, n);
    Object.defineProperty(r, n, o.get ? o : {
      enumerable: !0,
      get: function() {
        return e[n];
      }
    });
  }), r;
}
var al = {}, sl = {}, ll = {}, rh;
function M0() {
  return rh || (rh = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "default", {
      enumerable: !0,
      get: function() {
        return t;
      }
    });
    function t(r) {
      if (r = `${r}`, r === "0")
        return "0";
      if (/^[+-]?(\d+|\d*\.\d+)(e[+-]?\d+)?(%|\w+)?$/.test(r))
        return r.replace(/^[+-]?/, (o) => o === "-" ? "" : "-");
      let n = [
        "var",
        "calc",
        "min",
        "max",
        "clamp"
      ];
      for (const o of n)
        if (r.includes(`${o}(`))
          return `calc(${r} * -1)`;
    }
  }(ll)), ll;
}
var ul = {}, nh;
function n_() {
  return nh || (nh = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "default", {
      enumerable: !0,
      get: function() {
        return t;
      }
    });
    const t = [
      "preflight",
      "container",
      "accessibility",
      "pointerEvents",
      "visibility",
      "position",
      "inset",
      "isolation",
      "zIndex",
      "order",
      "gridColumn",
      "gridColumnStart",
      "gridColumnEnd",
      "gridRow",
      "gridRowStart",
      "gridRowEnd",
      "float",
      "clear",
      "margin",
      "boxSizing",
      "lineClamp",
      "display",
      "aspectRatio",
      "size",
      "height",
      "maxHeight",
      "minHeight",
      "width",
      "minWidth",
      "maxWidth",
      "flex",
      "flexShrink",
      "flexGrow",
      "flexBasis",
      "tableLayout",
      "captionSide",
      "borderCollapse",
      "borderSpacing",
      "transformOrigin",
      "translate",
      "rotate",
      "skew",
      "scale",
      "transform",
      "animation",
      "cursor",
      "touchAction",
      "userSelect",
      "resize",
      "scrollSnapType",
      "scrollSnapAlign",
      "scrollSnapStop",
      "scrollMargin",
      "scrollPadding",
      "listStylePosition",
      "listStyleType",
      "listStyleImage",
      "appearance",
      "columns",
      "breakBefore",
      "breakInside",
      "breakAfter",
      "gridAutoColumns",
      "gridAutoFlow",
      "gridAutoRows",
      "gridTemplateColumns",
      "gridTemplateRows",
      "flexDirection",
      "flexWrap",
      "placeContent",
      "placeItems",
      "alignContent",
      "alignItems",
      "justifyContent",
      "justifyItems",
      "gap",
      "space",
      "divideWidth",
      "divideStyle",
      "divideColor",
      "divideOpacity",
      "placeSelf",
      "alignSelf",
      "justifySelf",
      "overflow",
      "overscrollBehavior",
      "scrollBehavior",
      "textOverflow",
      "hyphens",
      "whitespace",
      "textWrap",
      "wordBreak",
      "borderRadius",
      "borderWidth",
      "borderStyle",
      "borderColor",
      "borderOpacity",
      "backgroundColor",
      "backgroundOpacity",
      "backgroundImage",
      "gradientColorStops",
      "boxDecorationBreak",
      "backgroundSize",
      "backgroundAttachment",
      "backgroundClip",
      "backgroundPosition",
      "backgroundRepeat",
      "backgroundOrigin",
      "fill",
      "stroke",
      "strokeWidth",
      "objectFit",
      "objectPosition",
      "padding",
      "textAlign",
      "textIndent",
      "verticalAlign",
      "fontFamily",
      "fontSize",
      "fontWeight",
      "textTransform",
      "fontStyle",
      "fontVariantNumeric",
      "lineHeight",
      "letterSpacing",
      "textColor",
      "textOpacity",
      "textDecoration",
      "textDecorationColor",
      "textDecorationStyle",
      "textDecorationThickness",
      "textUnderlineOffset",
      "fontSmoothing",
      "placeholderColor",
      "placeholderOpacity",
      "caretColor",
      "accentColor",
      "opacity",
      "backgroundBlendMode",
      "mixBlendMode",
      "boxShadow",
      "boxShadowColor",
      "outlineStyle",
      "outlineWidth",
      "outlineOffset",
      "outlineColor",
      "ringWidth",
      "ringColor",
      "ringOpacity",
      "ringOffsetWidth",
      "ringOffsetColor",
      "blur",
      "brightness",
      "contrast",
      "dropShadow",
      "grayscale",
      "hueRotate",
      "invert",
      "saturate",
      "sepia",
      "filter",
      "backdropBlur",
      "backdropBrightness",
      "backdropContrast",
      "backdropGrayscale",
      "backdropHueRotate",
      "backdropInvert",
      "backdropOpacity",
      "backdropSaturate",
      "backdropSepia",
      "backdropFilter",
      "transitionProperty",
      "transitionDelay",
      "transitionDuration",
      "transitionTimingFunction",
      "willChange",
      "contain",
      "content",
      "forcedColorAdjust"
    ];
  }(ul)), ul;
}
var cl = {}, oh;
function o_() {
  return oh || (oh = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "default", {
      enumerable: !0,
      get: function() {
        return t;
      }
    });
    function t(r, n) {
      return r === void 0 ? n : Array.isArray(r) ? r : [
        ...new Set(n.filter((a) => r !== !1 && r[a] !== !1).concat(Object.keys(r).filter((a) => r[a] !== !1)))
      ];
    }
  }(cl)), cl;
}
var dl = {}, fl = {}, _a = { exports: {} }, ih;
function B0() {
  if (ih) return _a.exports;
  ih = 1;
  var e = String, t = function() {
    return { isColorSupported: !1, reset: e, bold: e, dim: e, italic: e, underline: e, inverse: e, hidden: e, strikethrough: e, black: e, red: e, green: e, yellow: e, blue: e, magenta: e, cyan: e, white: e, gray: e, bgBlack: e, bgRed: e, bgGreen: e, bgYellow: e, bgBlue: e, bgMagenta: e, bgCyan: e, bgWhite: e, blackBright: e, redBright: e, greenBright: e, yellowBright: e, blueBright: e, magentaBright: e, cyanBright: e, whiteBright: e, bgBlackBright: e, bgRedBright: e, bgGreenBright: e, bgYellowBright: e, bgBlueBright: e, bgMagentaBright: e, bgCyanBright: e, bgWhiteBright: e };
  };
  return _a.exports = t(), _a.exports.createColors = t, _a.exports;
}
var ah;
function cp() {
  return ah || (ah = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(l, u) {
      for (var c in u) Object.defineProperty(l, c, {
        enumerable: !0,
        get: u[c]
      });
    }
    t(e, {
      dim: function() {
        return i;
      },
      default: function() {
        return s;
      }
    });
    const r = /* @__PURE__ */ n(/* @__PURE__ */ B0());
    function n(l) {
      return l && l.__esModule ? l : {
        default: l
      };
    }
    let o = /* @__PURE__ */ new Set();
    function a(l, u, c) {
      typeof process < "u" && process.env.JEST_WORKER_ID || c && o.has(c) || (c && o.add(c), console.warn(""), u.forEach((d) => console.warn(l, "-", d)));
    }
    function i(l) {
      return r.default.dim(l);
    }
    const s = {
      info(l, u) {
        a(r.default.bold(r.default.cyan("info")), ...Array.isArray(l) ? [
          l
        ] : [
          u,
          l
        ]);
      },
      warn(l, u) {
        a(r.default.bold(r.default.yellow("warn")), ...Array.isArray(l) ? [
          l
        ] : [
          u,
          l
        ]);
      },
      risk(l, u) {
        a(r.default.bold(r.default.magenta("risk")), ...Array.isArray(l) ? [
          l
        ] : [
          u,
          l
        ]);
      }
    };
  }(fl)), fl;
}
var sh;
function q0() {
  return sh || (sh = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "default", {
      enumerable: !0,
      get: function() {
        return o;
      }
    });
    const t = /* @__PURE__ */ r(cp());
    function r(a) {
      return a && a.__esModule ? a : {
        default: a
      };
    }
    function n({ version: a, from: i, to: s }) {
      t.default.warn(`${i}-color-renamed`, [
        `As of Tailwind CSS ${a}, \`${i}\` has been renamed to \`${s}\`.`,
        "Update your configuration file to silence this warning."
      ]);
    }
    const o = {
      inherit: "inherit",
      current: "currentColor",
      transparent: "transparent",
      black: "#000",
      white: "#fff",
      slate: {
        50: "#f8fafc",
        100: "#f1f5f9",
        200: "#e2e8f0",
        300: "#cbd5e1",
        400: "#94a3b8",
        500: "#64748b",
        600: "#475569",
        700: "#334155",
        800: "#1e293b",
        900: "#0f172a",
        950: "#020617"
      },
      gray: {
        50: "#f9fafb",
        100: "#f3f4f6",
        200: "#e5e7eb",
        300: "#d1d5db",
        400: "#9ca3af",
        500: "#6b7280",
        600: "#4b5563",
        700: "#374151",
        800: "#1f2937",
        900: "#111827",
        950: "#030712"
      },
      zinc: {
        50: "#fafafa",
        100: "#f4f4f5",
        200: "#e4e4e7",
        300: "#d4d4d8",
        400: "#a1a1aa",
        500: "#71717a",
        600: "#52525b",
        700: "#3f3f46",
        800: "#27272a",
        900: "#18181b",
        950: "#09090b"
      },
      neutral: {
        50: "#fafafa",
        100: "#f5f5f5",
        200: "#e5e5e5",
        300: "#d4d4d4",
        400: "#a3a3a3",
        500: "#737373",
        600: "#525252",
        700: "#404040",
        800: "#262626",
        900: "#171717",
        950: "#0a0a0a"
      },
      stone: {
        50: "#fafaf9",
        100: "#f5f5f4",
        200: "#e7e5e4",
        300: "#d6d3d1",
        400: "#a8a29e",
        500: "#78716c",
        600: "#57534e",
        700: "#44403c",
        800: "#292524",
        900: "#1c1917",
        950: "#0c0a09"
      },
      red: {
        50: "#fef2f2",
        100: "#fee2e2",
        200: "#fecaca",
        300: "#fca5a5",
        400: "#f87171",
        500: "#ef4444",
        600: "#dc2626",
        700: "#b91c1c",
        800: "#991b1b",
        900: "#7f1d1d",
        950: "#450a0a"
      },
      orange: {
        50: "#fff7ed",
        100: "#ffedd5",
        200: "#fed7aa",
        300: "#fdba74",
        400: "#fb923c",
        500: "#f97316",
        600: "#ea580c",
        700: "#c2410c",
        800: "#9a3412",
        900: "#7c2d12",
        950: "#431407"
      },
      amber: {
        50: "#fffbeb",
        100: "#fef3c7",
        200: "#fde68a",
        300: "#fcd34d",
        400: "#fbbf24",
        500: "#f59e0b",
        600: "#d97706",
        700: "#b45309",
        800: "#92400e",
        900: "#78350f",
        950: "#451a03"
      },
      yellow: {
        50: "#fefce8",
        100: "#fef9c3",
        200: "#fef08a",
        300: "#fde047",
        400: "#facc15",
        500: "#eab308",
        600: "#ca8a04",
        700: "#a16207",
        800: "#854d0e",
        900: "#713f12",
        950: "#422006"
      },
      lime: {
        50: "#f7fee7",
        100: "#ecfccb",
        200: "#d9f99d",
        300: "#bef264",
        400: "#a3e635",
        500: "#84cc16",
        600: "#65a30d",
        700: "#4d7c0f",
        800: "#3f6212",
        900: "#365314",
        950: "#1a2e05"
      },
      green: {
        50: "#f0fdf4",
        100: "#dcfce7",
        200: "#bbf7d0",
        300: "#86efac",
        400: "#4ade80",
        500: "#22c55e",
        600: "#16a34a",
        700: "#15803d",
        800: "#166534",
        900: "#14532d",
        950: "#052e16"
      },
      emerald: {
        50: "#ecfdf5",
        100: "#d1fae5",
        200: "#a7f3d0",
        300: "#6ee7b7",
        400: "#34d399",
        500: "#10b981",
        600: "#059669",
        700: "#047857",
        800: "#065f46",
        900: "#064e3b",
        950: "#022c22"
      },
      teal: {
        50: "#f0fdfa",
        100: "#ccfbf1",
        200: "#99f6e4",
        300: "#5eead4",
        400: "#2dd4bf",
        500: "#14b8a6",
        600: "#0d9488",
        700: "#0f766e",
        800: "#115e59",
        900: "#134e4a",
        950: "#042f2e"
      },
      cyan: {
        50: "#ecfeff",
        100: "#cffafe",
        200: "#a5f3fc",
        300: "#67e8f9",
        400: "#22d3ee",
        500: "#06b6d4",
        600: "#0891b2",
        700: "#0e7490",
        800: "#155e75",
        900: "#164e63",
        950: "#083344"
      },
      sky: {
        50: "#f0f9ff",
        100: "#e0f2fe",
        200: "#bae6fd",
        300: "#7dd3fc",
        400: "#38bdf8",
        500: "#0ea5e9",
        600: "#0284c7",
        700: "#0369a1",
        800: "#075985",
        900: "#0c4a6e",
        950: "#082f49"
      },
      blue: {
        50: "#eff6ff",
        100: "#dbeafe",
        200: "#bfdbfe",
        300: "#93c5fd",
        400: "#60a5fa",
        500: "#3b82f6",
        600: "#2563eb",
        700: "#1d4ed8",
        800: "#1e40af",
        900: "#1e3a8a",
        950: "#172554"
      },
      indigo: {
        50: "#eef2ff",
        100: "#e0e7ff",
        200: "#c7d2fe",
        300: "#a5b4fc",
        400: "#818cf8",
        500: "#6366f1",
        600: "#4f46e5",
        700: "#4338ca",
        800: "#3730a3",
        900: "#312e81",
        950: "#1e1b4b"
      },
      violet: {
        50: "#f5f3ff",
        100: "#ede9fe",
        200: "#ddd6fe",
        300: "#c4b5fd",
        400: "#a78bfa",
        500: "#8b5cf6",
        600: "#7c3aed",
        700: "#6d28d9",
        800: "#5b21b6",
        900: "#4c1d95",
        950: "#2e1065"
      },
      purple: {
        50: "#faf5ff",
        100: "#f3e8ff",
        200: "#e9d5ff",
        300: "#d8b4fe",
        400: "#c084fc",
        500: "#a855f7",
        600: "#9333ea",
        700: "#7e22ce",
        800: "#6b21a8",
        900: "#581c87",
        950: "#3b0764"
      },
      fuchsia: {
        50: "#fdf4ff",
        100: "#fae8ff",
        200: "#f5d0fe",
        300: "#f0abfc",
        400: "#e879f9",
        500: "#d946ef",
        600: "#c026d3",
        700: "#a21caf",
        800: "#86198f",
        900: "#701a75",
        950: "#4a044e"
      },
      pink: {
        50: "#fdf2f8",
        100: "#fce7f3",
        200: "#fbcfe8",
        300: "#f9a8d4",
        400: "#f472b6",
        500: "#ec4899",
        600: "#db2777",
        700: "#be185d",
        800: "#9d174d",
        900: "#831843",
        950: "#500724"
      },
      rose: {
        50: "#fff1f2",
        100: "#ffe4e6",
        200: "#fecdd3",
        300: "#fda4af",
        400: "#fb7185",
        500: "#f43f5e",
        600: "#e11d48",
        700: "#be123c",
        800: "#9f1239",
        900: "#881337",
        950: "#4c0519"
      },
      get lightBlue() {
        return n({
          version: "v2.2",
          from: "lightBlue",
          to: "sky"
        }), this.sky;
      },
      get warmGray() {
        return n({
          version: "v3.0",
          from: "warmGray",
          to: "stone"
        }), this.stone;
      },
      get trueGray() {
        return n({
          version: "v3.0",
          from: "trueGray",
          to: "neutral"
        }), this.neutral;
      },
      get coolGray() {
        return n({
          version: "v3.0",
          from: "coolGray",
          to: "gray"
        }), this.gray;
      },
      get blueGray() {
        return n({
          version: "v3.0",
          from: "blueGray",
          to: "slate"
        }), this.slate;
      }
    };
  }(dl)), dl;
}
var pl = {}, lh;
function i_() {
  return lh || (lh = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "defaults", {
      enumerable: !0,
      get: function() {
        return t;
      }
    });
    function t(r, ...n) {
      for (let i of n) {
        for (let s in i) {
          var o;
          !(r == null || (o = r.hasOwnProperty) === null || o === void 0) && o.call(r, s) || (r[s] = i[s]);
        }
        for (let s of Object.getOwnPropertySymbols(i)) {
          var a;
          !(r == null || (a = r.hasOwnProperty) === null || a === void 0) && a.call(r, s) || (r[s] = i[s]);
        }
      }
      return r;
    }
  }(pl)), pl;
}
var hl = {}, uh;
function a_() {
  return uh || (uh = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "toPath", {
      enumerable: !0,
      get: function() {
        return t;
      }
    });
    function t(r) {
      if (Array.isArray(r)) return r;
      let n = r.split("[").length - 1, o = r.split("]").length - 1;
      if (n !== o)
        throw new Error(`Path is invalid. Has unbalanced brackets: ${r}`);
      return r.split(/\.(?![^\[]*\])|[\[\]]/g).filter(Boolean);
    }
  }(hl)), hl;
}
var ml = {}, vl = {}, ch;
function dp() {
  return ch || (ch = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(d, h) {
      for (var y in h) Object.defineProperty(d, y, {
        enumerable: !0,
        get: h[y]
      });
    }
    t(e, {
      flagEnabled: function() {
        return s;
      },
      issueFlagNotices: function() {
        return u;
      },
      default: function() {
        return c;
      }
    });
    const r = /* @__PURE__ */ o(/* @__PURE__ */ B0()), n = /* @__PURE__ */ o(cp());
    function o(d) {
      return d && d.__esModule ? d : {
        default: d
      };
    }
    let a = {
      optimizeUniversalDefaults: !1,
      generalizedModifiers: !0,
      disableColorOpacityUtilitiesByDefault: !1,
      relativeContentPathsByDefault: !1
    }, i = {
      future: [
        "hoverOnlyWhenSupported",
        "respectDefaultRingColorOpacity",
        "disableColorOpacityUtilitiesByDefault",
        "relativeContentPathsByDefault"
      ],
      experimental: [
        "optimizeUniversalDefaults",
        "generalizedModifiers"
      ]
    };
    function s(d, h) {
      if (i.future.includes(h)) {
        var y, m, p;
        return d.future === "all" || ((p = (m = d == null || (y = d.future) === null || y === void 0 ? void 0 : y[h]) !== null && m !== void 0 ? m : a[h]) !== null && p !== void 0 ? p : !1);
      }
      if (i.experimental.includes(h)) {
        var f, v, w;
        return d.experimental === "all" || ((w = (v = d == null || (f = d.experimental) === null || f === void 0 ? void 0 : f[h]) !== null && v !== void 0 ? v : a[h]) !== null && w !== void 0 ? w : !1);
      }
      return !1;
    }
    function l(d) {
      if (d.experimental === "all")
        return i.experimental;
      var h;
      return Object.keys((h = d == null ? void 0 : d.experimental) !== null && h !== void 0 ? h : {}).filter((y) => i.experimental.includes(y) && d.experimental[y]);
    }
    function u(d) {
      if (process.env.JEST_WORKER_ID === void 0 && l(d).length > 0) {
        let h = l(d).map((y) => r.default.yellow(y)).join(", ");
        n.default.warn("experimental-flags-enabled", [
          `You have enabled experimental features: ${h}`,
          "Experimental features in Tailwind CSS are not covered by semver, may introduce breaking changes, and can change at any time."
        ]);
      }
    }
    const c = i;
  }(vl)), vl;
}
var dh;
function s_() {
  return dh || (dh = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "normalizeConfig", {
      enumerable: !0,
      get: function() {
        return a;
      }
    });
    const t = dp(), r = /* @__PURE__ */ o(cp());
    function n(i) {
      if (typeof WeakMap != "function") return null;
      var s = /* @__PURE__ */ new WeakMap(), l = /* @__PURE__ */ new WeakMap();
      return (n = function(u) {
        return u ? l : s;
      })(i);
    }
    function o(i, s) {
      if (i && i.__esModule)
        return i;
      if (i === null || typeof i != "object" && typeof i != "function")
        return {
          default: i
        };
      var l = n(s);
      if (l && l.has(i))
        return l.get(i);
      var u = {}, c = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var d in i)
        if (d !== "default" && Object.prototype.hasOwnProperty.call(i, d)) {
          var h = c ? Object.getOwnPropertyDescriptor(i, d) : null;
          h && (h.get || h.set) ? Object.defineProperty(u, d, h) : u[d] = i[d];
        }
      return u.default = i, l && l.set(i, u), u;
    }
    function a(i) {
      if ((() => {
        if (i.purge || !i.content || !Array.isArray(i.content) && !(typeof i.content == "object" && i.content !== null))
          return !1;
        if (Array.isArray(i.content))
          return i.content.every((u) => typeof u == "string" ? !0 : !(typeof (u == null ? void 0 : u.raw) != "string" || u != null && u.extension && typeof (u == null ? void 0 : u.extension) != "string"));
        if (typeof i.content == "object" && i.content !== null) {
          if (Object.keys(i.content).some((u) => ![
            "files",
            "relative",
            "extract",
            "transform"
          ].includes(u)))
            return !1;
          if (Array.isArray(i.content.files)) {
            if (!i.content.files.every((u) => typeof u == "string" ? !0 : !(typeof (u == null ? void 0 : u.raw) != "string" || u != null && u.extension && typeof (u == null ? void 0 : u.extension) != "string")))
              return !1;
            if (typeof i.content.extract == "object") {
              for (let u of Object.values(i.content.extract))
                if (typeof u != "function")
                  return !1;
            } else if (!(i.content.extract === void 0 || typeof i.content.extract == "function"))
              return !1;
            if (typeof i.content.transform == "object") {
              for (let u of Object.values(i.content.transform))
                if (typeof u != "function")
                  return !1;
            } else if (!(i.content.transform === void 0 || typeof i.content.transform == "function"))
              return !1;
            if (typeof i.content.relative != "boolean" && typeof i.content.relative < "u")
              return !1;
          }
          return !0;
        }
        return !1;
      })() || r.default.warn("purge-deprecation", [
        "The `purge`/`content` options have changed in Tailwind CSS v3.0.",
        "Update your configuration file to eliminate this warning.",
        "https://tailwindcss.com/docs/upgrade-guide#configure-content-sources"
      ]), i.safelist = (() => {
        var u;
        let { content: c, purge: d, safelist: h } = i;
        return Array.isArray(h) ? h : Array.isArray(c == null ? void 0 : c.safelist) ? c.safelist : Array.isArray(d == null ? void 0 : d.safelist) ? d.safelist : Array.isArray(d == null || (u = d.options) === null || u === void 0 ? void 0 : u.safelist) ? d.options.safelist : [];
      })(), i.blocklist = (() => {
        let { blocklist: u } = i;
        if (Array.isArray(u)) {
          if (u.every((c) => typeof c == "string"))
            return u;
          r.default.warn("blocklist-invalid", [
            "The `blocklist` option must be an array of strings.",
            "https://tailwindcss.com/docs/content-configuration#discarding-classes"
          ]);
        }
        return [];
      })(), typeof i.prefix == "function")
        r.default.warn("prefix-function", [
          "As of Tailwind CSS v3.0, `prefix` cannot be a function.",
          "Update `prefix` in your configuration to be a string to eliminate this warning.",
          "https://tailwindcss.com/docs/upgrade-guide#prefix-cannot-be-a-function"
        ]), i.prefix = "";
      else {
        var l;
        i.prefix = (l = i.prefix) !== null && l !== void 0 ? l : "";
      }
      i.content = {
        relative: (() => {
          let { content: u } = i;
          return u != null && u.relative ? u.relative : (0, t.flagEnabled)(i, "relativeContentPathsByDefault");
        })(),
        files: (() => {
          let { content: u, purge: c } = i;
          return Array.isArray(c) ? c : Array.isArray(c == null ? void 0 : c.content) ? c.content : Array.isArray(u) ? u : Array.isArray(u == null ? void 0 : u.content) ? u.content : Array.isArray(u == null ? void 0 : u.files) ? u.files : [];
        })(),
        extract: (() => {
          let u = (() => {
            var h, y, m, p, f, v, w, _, T, A;
            return !((h = i.purge) === null || h === void 0) && h.extract ? i.purge.extract : !((y = i.content) === null || y === void 0) && y.extract ? i.content.extract : !((m = i.purge) === null || m === void 0 || (p = m.extract) === null || p === void 0) && p.DEFAULT ? i.purge.extract.DEFAULT : !((f = i.content) === null || f === void 0 || (v = f.extract) === null || v === void 0) && v.DEFAULT ? i.content.extract.DEFAULT : !((w = i.purge) === null || w === void 0 || (_ = w.options) === null || _ === void 0) && _.extractors ? i.purge.options.extractors : !((T = i.content) === null || T === void 0 || (A = T.options) === null || A === void 0) && A.extractors ? i.content.options.extractors : {};
          })(), c = {}, d = (() => {
            var h, y, m, p;
            if (!((h = i.purge) === null || h === void 0 || (y = h.options) === null || y === void 0) && y.defaultExtractor)
              return i.purge.options.defaultExtractor;
            if (!((m = i.content) === null || m === void 0 || (p = m.options) === null || p === void 0) && p.defaultExtractor)
              return i.content.options.defaultExtractor;
          })();
          if (d !== void 0 && (c.DEFAULT = d), typeof u == "function")
            c.DEFAULT = u;
          else if (Array.isArray(u))
            for (let { extensions: h, extractor: y } of u ?? [])
              for (let m of h)
                c[m] = y;
          else typeof u == "object" && u !== null && Object.assign(c, u);
          return c;
        })(),
        transform: (() => {
          let u = (() => {
            var d, h, y, m, p, f;
            return !((d = i.purge) === null || d === void 0) && d.transform ? i.purge.transform : !((h = i.content) === null || h === void 0) && h.transform ? i.content.transform : !((y = i.purge) === null || y === void 0 || (m = y.transform) === null || m === void 0) && m.DEFAULT ? i.purge.transform.DEFAULT : !((p = i.content) === null || p === void 0 || (f = p.transform) === null || f === void 0) && f.DEFAULT ? i.content.transform.DEFAULT : {};
          })(), c = {};
          return typeof u == "function" ? c.DEFAULT = u : typeof u == "object" && u !== null && Object.assign(c, u), c;
        })()
      };
      for (let u of i.content.files)
        if (typeof u == "string" && /{([^,]*?)}/g.test(u)) {
          r.default.warn("invalid-glob-braces", [
            `The glob pattern ${(0, r.dim)(u)} in your Tailwind CSS configuration is invalid.`,
            `Update it to ${(0, r.dim)(u.replace(/{([^,]*?)}/g, "$1"))} to silence this warning.`
          ]);
          break;
        }
      return i;
    }
  }(ml)), ml;
}
var gl = {}, fh;
function l_() {
  return fh || (fh = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "default", {
      enumerable: !0,
      get: function() {
        return t;
      }
    });
    function t(r) {
      if (Object.prototype.toString.call(r) !== "[object Object]")
        return !1;
      const n = Object.getPrototypeOf(r);
      return n === null || Object.getPrototypeOf(n) === null;
    }
  }(gl)), gl;
}
var yl = {}, ph;
function L0() {
  return ph || (ph = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "cloneDeep", {
      enumerable: !0,
      get: function() {
        return t;
      }
    });
    function t(r) {
      return Array.isArray(r) ? r.map((n) => t(n)) : typeof r == "object" && r !== null ? Object.fromEntries(Object.entries(r).map(([n, o]) => [
        n,
        t(o)
      ])) : r;
    }
  }(yl)), yl;
}
var bl = {}, wl = {}, hh;
function u_() {
  return hh || (hh = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "default", {
      enumerable: !0,
      get: function() {
        return t;
      }
    });
    function t(r) {
      return r.replace(/\\,/g, "\\2c ");
    }
  }(wl)), wl;
}
var _l = {}, Sl = {}, xl = {}, mh;
function c_() {
  return mh || (mh = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "default", {
      enumerable: !0,
      get: function() {
        return t;
      }
    });
    const t = {
      aliceblue: [
        240,
        248,
        255
      ],
      antiquewhite: [
        250,
        235,
        215
      ],
      aqua: [
        0,
        255,
        255
      ],
      aquamarine: [
        127,
        255,
        212
      ],
      azure: [
        240,
        255,
        255
      ],
      beige: [
        245,
        245,
        220
      ],
      bisque: [
        255,
        228,
        196
      ],
      black: [
        0,
        0,
        0
      ],
      blanchedalmond: [
        255,
        235,
        205
      ],
      blue: [
        0,
        0,
        255
      ],
      blueviolet: [
        138,
        43,
        226
      ],
      brown: [
        165,
        42,
        42
      ],
      burlywood: [
        222,
        184,
        135
      ],
      cadetblue: [
        95,
        158,
        160
      ],
      chartreuse: [
        127,
        255,
        0
      ],
      chocolate: [
        210,
        105,
        30
      ],
      coral: [
        255,
        127,
        80
      ],
      cornflowerblue: [
        100,
        149,
        237
      ],
      cornsilk: [
        255,
        248,
        220
      ],
      crimson: [
        220,
        20,
        60
      ],
      cyan: [
        0,
        255,
        255
      ],
      darkblue: [
        0,
        0,
        139
      ],
      darkcyan: [
        0,
        139,
        139
      ],
      darkgoldenrod: [
        184,
        134,
        11
      ],
      darkgray: [
        169,
        169,
        169
      ],
      darkgreen: [
        0,
        100,
        0
      ],
      darkgrey: [
        169,
        169,
        169
      ],
      darkkhaki: [
        189,
        183,
        107
      ],
      darkmagenta: [
        139,
        0,
        139
      ],
      darkolivegreen: [
        85,
        107,
        47
      ],
      darkorange: [
        255,
        140,
        0
      ],
      darkorchid: [
        153,
        50,
        204
      ],
      darkred: [
        139,
        0,
        0
      ],
      darksalmon: [
        233,
        150,
        122
      ],
      darkseagreen: [
        143,
        188,
        143
      ],
      darkslateblue: [
        72,
        61,
        139
      ],
      darkslategray: [
        47,
        79,
        79
      ],
      darkslategrey: [
        47,
        79,
        79
      ],
      darkturquoise: [
        0,
        206,
        209
      ],
      darkviolet: [
        148,
        0,
        211
      ],
      deeppink: [
        255,
        20,
        147
      ],
      deepskyblue: [
        0,
        191,
        255
      ],
      dimgray: [
        105,
        105,
        105
      ],
      dimgrey: [
        105,
        105,
        105
      ],
      dodgerblue: [
        30,
        144,
        255
      ],
      firebrick: [
        178,
        34,
        34
      ],
      floralwhite: [
        255,
        250,
        240
      ],
      forestgreen: [
        34,
        139,
        34
      ],
      fuchsia: [
        255,
        0,
        255
      ],
      gainsboro: [
        220,
        220,
        220
      ],
      ghostwhite: [
        248,
        248,
        255
      ],
      gold: [
        255,
        215,
        0
      ],
      goldenrod: [
        218,
        165,
        32
      ],
      gray: [
        128,
        128,
        128
      ],
      green: [
        0,
        128,
        0
      ],
      greenyellow: [
        173,
        255,
        47
      ],
      grey: [
        128,
        128,
        128
      ],
      honeydew: [
        240,
        255,
        240
      ],
      hotpink: [
        255,
        105,
        180
      ],
      indianred: [
        205,
        92,
        92
      ],
      indigo: [
        75,
        0,
        130
      ],
      ivory: [
        255,
        255,
        240
      ],
      khaki: [
        240,
        230,
        140
      ],
      lavender: [
        230,
        230,
        250
      ],
      lavenderblush: [
        255,
        240,
        245
      ],
      lawngreen: [
        124,
        252,
        0
      ],
      lemonchiffon: [
        255,
        250,
        205
      ],
      lightblue: [
        173,
        216,
        230
      ],
      lightcoral: [
        240,
        128,
        128
      ],
      lightcyan: [
        224,
        255,
        255
      ],
      lightgoldenrodyellow: [
        250,
        250,
        210
      ],
      lightgray: [
        211,
        211,
        211
      ],
      lightgreen: [
        144,
        238,
        144
      ],
      lightgrey: [
        211,
        211,
        211
      ],
      lightpink: [
        255,
        182,
        193
      ],
      lightsalmon: [
        255,
        160,
        122
      ],
      lightseagreen: [
        32,
        178,
        170
      ],
      lightskyblue: [
        135,
        206,
        250
      ],
      lightslategray: [
        119,
        136,
        153
      ],
      lightslategrey: [
        119,
        136,
        153
      ],
      lightsteelblue: [
        176,
        196,
        222
      ],
      lightyellow: [
        255,
        255,
        224
      ],
      lime: [
        0,
        255,
        0
      ],
      limegreen: [
        50,
        205,
        50
      ],
      linen: [
        250,
        240,
        230
      ],
      magenta: [
        255,
        0,
        255
      ],
      maroon: [
        128,
        0,
        0
      ],
      mediumaquamarine: [
        102,
        205,
        170
      ],
      mediumblue: [
        0,
        0,
        205
      ],
      mediumorchid: [
        186,
        85,
        211
      ],
      mediumpurple: [
        147,
        112,
        219
      ],
      mediumseagreen: [
        60,
        179,
        113
      ],
      mediumslateblue: [
        123,
        104,
        238
      ],
      mediumspringgreen: [
        0,
        250,
        154
      ],
      mediumturquoise: [
        72,
        209,
        204
      ],
      mediumvioletred: [
        199,
        21,
        133
      ],
      midnightblue: [
        25,
        25,
        112
      ],
      mintcream: [
        245,
        255,
        250
      ],
      mistyrose: [
        255,
        228,
        225
      ],
      moccasin: [
        255,
        228,
        181
      ],
      navajowhite: [
        255,
        222,
        173
      ],
      navy: [
        0,
        0,
        128
      ],
      oldlace: [
        253,
        245,
        230
      ],
      olive: [
        128,
        128,
        0
      ],
      olivedrab: [
        107,
        142,
        35
      ],
      orange: [
        255,
        165,
        0
      ],
      orangered: [
        255,
        69,
        0
      ],
      orchid: [
        218,
        112,
        214
      ],
      palegoldenrod: [
        238,
        232,
        170
      ],
      palegreen: [
        152,
        251,
        152
      ],
      paleturquoise: [
        175,
        238,
        238
      ],
      palevioletred: [
        219,
        112,
        147
      ],
      papayawhip: [
        255,
        239,
        213
      ],
      peachpuff: [
        255,
        218,
        185
      ],
      peru: [
        205,
        133,
        63
      ],
      pink: [
        255,
        192,
        203
      ],
      plum: [
        221,
        160,
        221
      ],
      powderblue: [
        176,
        224,
        230
      ],
      purple: [
        128,
        0,
        128
      ],
      rebeccapurple: [
        102,
        51,
        153
      ],
      red: [
        255,
        0,
        0
      ],
      rosybrown: [
        188,
        143,
        143
      ],
      royalblue: [
        65,
        105,
        225
      ],
      saddlebrown: [
        139,
        69,
        19
      ],
      salmon: [
        250,
        128,
        114
      ],
      sandybrown: [
        244,
        164,
        96
      ],
      seagreen: [
        46,
        139,
        87
      ],
      seashell: [
        255,
        245,
        238
      ],
      sienna: [
        160,
        82,
        45
      ],
      silver: [
        192,
        192,
        192
      ],
      skyblue: [
        135,
        206,
        235
      ],
      slateblue: [
        106,
        90,
        205
      ],
      slategray: [
        112,
        128,
        144
      ],
      slategrey: [
        112,
        128,
        144
      ],
      snow: [
        255,
        250,
        250
      ],
      springgreen: [
        0,
        255,
        127
      ],
      steelblue: [
        70,
        130,
        180
      ],
      tan: [
        210,
        180,
        140
      ],
      teal: [
        0,
        128,
        128
      ],
      thistle: [
        216,
        191,
        216
      ],
      tomato: [
        255,
        99,
        71
      ],
      turquoise: [
        64,
        224,
        208
      ],
      violet: [
        238,
        130,
        238
      ],
      wheat: [
        245,
        222,
        179
      ],
      white: [
        255,
        255,
        255
      ],
      whitesmoke: [
        245,
        245,
        245
      ],
      yellow: [
        255,
        255,
        0
      ],
      yellowgreen: [
        154,
        205,
        50
      ]
    };
  }(xl)), xl;
}
var vh;
function F0() {
  return vh || (vh = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(m, p) {
      for (var f in p) Object.defineProperty(m, f, {
        enumerable: !0,
        get: p[f]
      });
    }
    t(e, {
      parseColor: function() {
        return h;
      },
      formatColor: function() {
        return y;
      }
    });
    const r = /* @__PURE__ */ n(c_());
    function n(m) {
      return m && m.__esModule ? m : {
        default: m
      };
    }
    let o = /^#([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})?$/i, a = /^#([a-f\d])([a-f\d])([a-f\d])([a-f\d])?$/i, i = /(?:\d+|\d*\.\d+)%?/, s = /(?:\s*,\s*|\s+)/, l = /\s*[,/]\s*/, u = /var\(--(?:[^ )]*?)(?:,(?:[^ )]*?|var\(--[^ )]*?\)))?\)/, c = new RegExp(`^(rgba?)\\(\\s*(${i.source}|${u.source})(?:${s.source}(${i.source}|${u.source}))?(?:${s.source}(${i.source}|${u.source}))?(?:${l.source}(${i.source}|${u.source}))?\\s*\\)$`), d = new RegExp(`^(hsla?)\\(\\s*((?:${i.source})(?:deg|rad|grad|turn)?|${u.source})(?:${s.source}(${i.source}|${u.source}))?(?:${s.source}(${i.source}|${u.source}))?(?:${l.source}(${i.source}|${u.source}))?\\s*\\)$`);
    function h(m, { loose: p = !1 } = {}) {
      var f, v;
      if (typeof m != "string")
        return null;
      if (m = m.trim(), m === "transparent")
        return {
          mode: "rgb",
          color: [
            "0",
            "0",
            "0"
          ],
          alpha: "0"
        };
      if (m in r.default)
        return {
          mode: "rgb",
          color: r.default[m].map((O) => O.toString())
        };
      let w = m.replace(a, (O, M, I, C, E) => [
        "#",
        M,
        M,
        I,
        I,
        C,
        C,
        E ? E + E : ""
      ].join("")).match(o);
      if (w !== null)
        return {
          mode: "rgb",
          color: [
            parseInt(w[1], 16),
            parseInt(w[2], 16),
            parseInt(w[3], 16)
          ].map((O) => O.toString()),
          alpha: w[4] ? (parseInt(w[4], 16) / 255).toString() : void 0
        };
      var _;
      let T = (_ = m.match(c)) !== null && _ !== void 0 ? _ : m.match(d);
      if (T === null)
        return null;
      let A = [
        T[2],
        T[3],
        T[4]
      ].filter(Boolean).map((O) => O.toString());
      return A.length === 2 && A[0].startsWith("var(") ? {
        mode: T[1],
        color: [
          A[0]
        ],
        alpha: A[1]
      } : !p && A.length !== 3 || A.length < 3 && !A.some((O) => /^var\(.*?\)$/.test(O)) ? null : {
        mode: T[1],
        color: A,
        alpha: (f = T[5]) === null || f === void 0 || (v = f.toString) === null || v === void 0 ? void 0 : v.call(f)
      };
    }
    function y({ mode: m, color: p, alpha: f }) {
      let v = f !== void 0;
      return m === "rgba" || m === "hsla" ? `${m}(${p.join(", ")}${v ? `, ${f}` : ""})` : `${m}(${p.join(" ")}${v ? ` / ${f}` : ""})`;
    }
  }(Sl)), Sl;
}
var gh;
function N0() {
  return gh || (gh = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(a, i) {
      for (var s in i) Object.defineProperty(a, s, {
        enumerable: !0,
        get: i[s]
      });
    }
    t(e, {
      withAlphaValue: function() {
        return n;
      },
      default: function() {
        return o;
      }
    });
    const r = F0();
    function n(a, i, s) {
      if (typeof a == "function")
        return a({
          opacityValue: i
        });
      let l = (0, r.parseColor)(a, {
        loose: !0
      });
      return l === null ? s : (0, r.formatColor)({
        ...l,
        alpha: i
      });
    }
    function o({ color: a, property: i, variable: s }) {
      let l = [].concat(i);
      if (typeof a == "function")
        return {
          [s]: "1",
          ...Object.fromEntries(l.map((c) => [
            c,
            a({
              opacityVariable: s,
              opacityValue: `var(${s}, 1)`
            })
          ]))
        };
      const u = (0, r.parseColor)(a);
      return u === null ? Object.fromEntries(l.map((c) => [
        c,
        a
      ])) : u.alpha !== void 0 ? Object.fromEntries(l.map((c) => [
        c,
        a
      ])) : {
        [s]: "1",
        ...Object.fromEntries(l.map((c) => [
          c,
          (0, r.formatColor)({
            ...u,
            alpha: `var(${s}, 1)`
          })
        ]))
      };
    }
  }(_l)), _l;
}
var Al = {}, Tl = {}, El = {}, yh;
function fp() {
  return yh || (yh = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "splitAtTopLevelOnly", {
      enumerable: !0,
      get: function() {
        return t;
      }
    });
    function t(r, n) {
      let o = [], a = [], i = 0, s = !1;
      for (let l = 0; l < r.length; l++) {
        let u = r[l];
        o.length === 0 && u === n[0] && !s && (n.length === 1 || r.slice(l, l + n.length) === n) && (a.push(r.slice(i, l)), i = l + n.length), s = s ? !1 : u === "\\", u === "(" || u === "[" || u === "{" ? o.push(u) : (u === ")" && o[o.length - 1] === "(" || u === "]" && o[o.length - 1] === "[" || u === "}" && o[o.length - 1] === "{") && o.pop();
      }
      return a.push(r.slice(i)), a;
    }
  }(El)), El;
}
var bh;
function d_() {
  return bh || (bh = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(l, u) {
      for (var c in u) Object.defineProperty(l, c, {
        enumerable: !0,
        get: u[c]
      });
    }
    t(e, {
      parseBoxShadowValue: function() {
        return i;
      },
      formatBoxShadowValue: function() {
        return s;
      }
    });
    const r = fp();
    let n = /* @__PURE__ */ new Set([
      "inset",
      "inherit",
      "initial",
      "revert",
      "unset"
    ]), o = /\ +(?![^(]*\))/g, a = /^-?(\d+|\.\d+)(.*?)$/g;
    function i(l) {
      return (0, r.splitAtTopLevelOnly)(l, ",").map((c) => {
        let d = c.trim(), h = {
          raw: d
        }, y = d.split(o), m = /* @__PURE__ */ new Set();
        for (let p of y)
          a.lastIndex = 0, !m.has("KEYWORD") && n.has(p) ? (h.keyword = p, m.add("KEYWORD")) : a.test(p) ? m.has("X") ? m.has("Y") ? m.has("BLUR") ? m.has("SPREAD") || (h.spread = p, m.add("SPREAD")) : (h.blur = p, m.add("BLUR")) : (h.y = p, m.add("Y")) : (h.x = p, m.add("X")) : h.color ? (h.unknown || (h.unknown = []), h.unknown.push(p)) : h.color = p;
        return h.valid = h.x !== void 0 && h.y !== void 0, h;
      });
    }
    function s(l) {
      return l.map((u) => u.valid ? [
        u.keyword,
        u.x,
        u.y,
        u.blur,
        u.spread,
        u.color
      ].filter(Boolean).join(" ") : u.raw).join(", ");
    }
  }(Tl)), Tl;
}
var wh;
function z0() {
  return wh || (wh = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(j, D) {
      for (var H in D) Object.defineProperty(j, H, {
        enumerable: !0,
        get: D[H]
      });
    }
    t(e, {
      normalize: function() {
        return l;
      },
      normalizeAttributeSelectors: function() {
        return u;
      },
      url: function() {
        return d;
      },
      number: function() {
        return h;
      },
      percentage: function() {
        return y;
      },
      length: function() {
        return f;
      },
      lineWidth: function() {
        return w;
      },
      shadow: function() {
        return _;
      },
      color: function() {
        return T;
      },
      image: function() {
        return A;
      },
      gradient: function() {
        return M;
      },
      position: function() {
        return C;
      },
      familyName: function() {
        return E;
      },
      genericName: function() {
        return k;
      },
      absoluteSize: function() {
        return z;
      },
      relativeSize: function() {
        return q;
      }
    });
    const r = F0(), n = d_(), o = fp();
    let a = [
      "min",
      "max",
      "clamp",
      "calc"
    ];
    function i(j) {
      return a.some((D) => new RegExp(`^${D}\\(.*\\)`).test(j));
    }
    const s = /* @__PURE__ */ new Set([
      // Concrete properties
      "scroll-timeline-name",
      "timeline-scope",
      "view-timeline-name",
      "font-palette",
      "anchor-name",
      "anchor-scope",
      "position-anchor",
      "position-try-options",
      // Shorthand properties
      "scroll-timeline",
      "animation-timeline",
      "view-timeline",
      "position-try"
    ]);
    function l(j, D = null, H = !0) {
      let W = D && s.has(D.property);
      return j.startsWith("--") && !W ? `var(${j})` : j.includes("url(") ? j.split(/(url\(.*?\))/g).filter(Boolean).map((ee) => /^url\(.*?\)$/.test(ee) ? ee : l(ee, D, !1)).join("") : (j = j.replace(/([^\\])_+/g, (ee, oe) => oe + " ".repeat(ee.length - 1)).replace(/^_/g, " ").replace(/\\_/g, "_"), H && (j = j.trim()), j = c(j), j);
    }
    function u(j) {
      return j.includes("=") && (j = j.replace(/(=.*)/g, (D, H) => {
        if (H[1] === "'" || H[1] === '"')
          return H;
        if (H.length > 2) {
          let W = H[H.length - 1];
          if (H[H.length - 2] === " " && (W === "i" || W === "I" || W === "s" || W === "S"))
            return `="${H.slice(1, -2)}" ${H[H.length - 1]}`;
        }
        return `="${H.slice(1)}"`;
      })), j;
    }
    function c(j) {
      let D = [
        "theme"
      ], H = [
        "min-content",
        "max-content",
        "fit-content",
        // Env
        "safe-area-inset-top",
        "safe-area-inset-right",
        "safe-area-inset-bottom",
        "safe-area-inset-left",
        "titlebar-area-x",
        "titlebar-area-y",
        "titlebar-area-width",
        "titlebar-area-height",
        "keyboard-inset-top",
        "keyboard-inset-right",
        "keyboard-inset-bottom",
        "keyboard-inset-left",
        "keyboard-inset-width",
        "keyboard-inset-height",
        "radial-gradient",
        "linear-gradient",
        "conic-gradient",
        "repeating-radial-gradient",
        "repeating-linear-gradient",
        "repeating-conic-gradient",
        "anchor-size"
      ];
      return j.replace(/(calc|min|max|clamp)\(.+\)/g, (W) => {
        let ee = "";
        function oe() {
          let J = ee.trimEnd();
          return J[J.length - 1];
        }
        for (let J = 0; J < W.length; J++) {
          let N = function(G) {
            return G.split("").every((ce, be) => W[J + be] === ce);
          }, Q = function(G) {
            let ce = 1 / 0;
            for (let ve of G) {
              let fe = W.indexOf(ve, J);
              fe !== -1 && fe < ce && (ce = fe);
            }
            let be = W.slice(J, ce);
            return J += be.length - 1, be;
          }, de = W[J];
          if (N("var"))
            ee += Q([
              ")",
              ","
            ]);
          else if (H.some((G) => N(G))) {
            let G = H.find((ce) => N(ce));
            ee += G, J += G.length - 1;
          } else D.some((G) => N(G)) ? ee += Q([
            ")"
          ]) : N("[") ? ee += Q([
            "]"
          ]) : [
            "+",
            "-",
            "*",
            "/"
          ].includes(de) && ![
            "(",
            "+",
            "-",
            "*",
            "/",
            ","
          ].includes(oe()) ? ee += ` ${de} ` : ee += de;
        }
        return ee.replace(/\s+/g, " ");
      });
    }
    function d(j) {
      return j.startsWith("url(");
    }
    function h(j) {
      return !isNaN(Number(j)) || i(j);
    }
    function y(j) {
      return j.endsWith("%") && h(j.slice(0, -1)) || i(j);
    }
    let p = `(?:${[
      "cm",
      "mm",
      "Q",
      "in",
      "pc",
      "pt",
      "px",
      "em",
      "ex",
      "ch",
      "rem",
      "lh",
      "rlh",
      "vw",
      "vh",
      "vmin",
      "vmax",
      "vb",
      "vi",
      "svw",
      "svh",
      "lvw",
      "lvh",
      "dvw",
      "dvh",
      "cqw",
      "cqh",
      "cqi",
      "cqb",
      "cqmin",
      "cqmax"
    ].join("|")})`;
    function f(j) {
      return j === "0" || new RegExp(`^[+-]?[0-9]*.?[0-9]+(?:[eE][+-]?[0-9]+)?${p}$`).test(j) || i(j);
    }
    let v = /* @__PURE__ */ new Set([
      "thin",
      "medium",
      "thick"
    ]);
    function w(j) {
      return v.has(j);
    }
    function _(j) {
      let D = (0, n.parseBoxShadowValue)(l(j));
      for (let H of D)
        if (!H.valid)
          return !1;
      return !0;
    }
    function T(j) {
      let D = 0;
      return (0, o.splitAtTopLevelOnly)(j, "_").every((W) => (W = l(W), W.startsWith("var(") ? !0 : (0, r.parseColor)(W, {
        loose: !0
      }) !== null ? (D++, !0) : !1)) ? D > 0 : !1;
    }
    function A(j) {
      let D = 0;
      return (0, o.splitAtTopLevelOnly)(j, ",").every((W) => (W = l(W), W.startsWith("var(") ? !0 : d(W) || M(W) || [
        "element(",
        "image(",
        "cross-fade(",
        "image-set("
      ].some((ee) => W.startsWith(ee)) ? (D++, !0) : !1)) ? D > 0 : !1;
    }
    let O = /* @__PURE__ */ new Set([
      "conic-gradient",
      "linear-gradient",
      "radial-gradient",
      "repeating-conic-gradient",
      "repeating-linear-gradient",
      "repeating-radial-gradient"
    ]);
    function M(j) {
      j = l(j);
      for (let D of O)
        if (j.startsWith(`${D}(`))
          return !0;
      return !1;
    }
    let I = /* @__PURE__ */ new Set([
      "center",
      "top",
      "right",
      "bottom",
      "left"
    ]);
    function C(j) {
      let D = 0;
      return (0, o.splitAtTopLevelOnly)(j, "_").every((W) => (W = l(W), W.startsWith("var(") ? !0 : I.has(W) || f(W) || y(W) ? (D++, !0) : !1)) ? D > 0 : !1;
    }
    function E(j) {
      let D = 0;
      return (0, o.splitAtTopLevelOnly)(j, ",").every((W) => (W = l(W), W.startsWith("var(") ? !0 : W.includes(" ") && !/(['"])([^"']+)\1/g.test(W) || /^\d/g.test(W) ? !1 : (D++, !0))) ? D > 0 : !1;
    }
    let R = /* @__PURE__ */ new Set([
      "serif",
      "sans-serif",
      "monospace",
      "cursive",
      "fantasy",
      "system-ui",
      "ui-serif",
      "ui-sans-serif",
      "ui-monospace",
      "ui-rounded",
      "math",
      "emoji",
      "fangsong"
    ]);
    function k(j) {
      return R.has(j);
    }
    let L = /* @__PURE__ */ new Set([
      "xx-small",
      "x-small",
      "small",
      "medium",
      "large",
      "x-large",
      "xx-large",
      "xxx-large"
    ]);
    function z(j) {
      return L.has(j);
    }
    let F = /* @__PURE__ */ new Set([
      "larger",
      "smaller"
    ]);
    function q(j) {
      return F.has(j);
    }
  }(Al)), Al;
}
var Ol = {}, _h;
function f_() {
  return _h || (_h = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "backgroundSize", {
      enumerable: !0,
      get: function() {
        return n;
      }
    });
    const t = z0(), r = fp();
    function n(o) {
      let a = [
        "cover",
        "contain"
      ];
      return (0, r.splitAtTopLevelOnly)(o, ",").every((i) => {
        let s = (0, r.splitAtTopLevelOnly)(i, "_").filter(Boolean);
        return s.length === 1 && a.includes(s[0]) ? !0 : s.length !== 1 && s.length !== 2 ? !1 : s.every((l) => (0, t.length)(l) || (0, t.percentage)(l) || l === "auto");
      });
    }
  }(Ol)), Ol;
}
var Sh;
function p_() {
  return Sh || (Sh = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
    function t(C, E) {
      for (var R in E) Object.defineProperty(C, R, {
        enumerable: !0,
        get: E[R]
      });
    }
    t(e, {
      updateAllClasses: function() {
        return u;
      },
      asValue: function() {
        return h;
      },
      parseColorFormat: function() {
        return p;
      },
      asColor: function() {
        return v;
      },
      asLookupValue: function() {
        return w;
      },
      typeMap: function() {
        return T;
      },
      coerceValue: function() {
        return M;
      },
      getMatchingTypes: function() {
        return I;
      }
    });
    const r = /* @__PURE__ */ l(u_()), n = N0(), o = z0(), a = /* @__PURE__ */ l(M0()), i = f_(), s = dp();
    function l(C) {
      return C && C.__esModule ? C : {
        default: C
      };
    }
    function u(C, E) {
      C.walkClasses((R) => {
        R.value = E(R.value), R.raws && R.raws.value && (R.raws.value = (0, r.default)(R.raws.value));
      });
    }
    function c(C, E) {
      if (!y(C))
        return;
      let R = C.slice(1, -1);
      if (E(R))
        return (0, o.normalize)(R);
    }
    function d(C, E = {}, R) {
      let k = E[C];
      if (k !== void 0)
        return (0, a.default)(k);
      if (y(C)) {
        let L = c(C, R);
        return L === void 0 ? void 0 : (0, a.default)(L);
      }
    }
    function h(C, E = {}, { validate: R = () => !0 } = {}) {
      var k;
      let L = (k = E.values) === null || k === void 0 ? void 0 : k[C];
      return L !== void 0 ? L : E.supportsNegativeValues && C.startsWith("-") ? d(C.slice(1), E.values, R) : c(C, R);
    }
    function y(C) {
      return C.startsWith("[") && C.endsWith("]");
    }
    function m(C) {
      let E = C.lastIndexOf("/"), R = C.lastIndexOf("[", E), k = C.indexOf("]", E);
      return C[E - 1] === "]" || C[E + 1] === "[" || R !== -1 && k !== -1 && R < E && E < k && (E = C.lastIndexOf("/", R)), E === -1 || E === C.length - 1 ? [
        C,
        void 0
      ] : y(C) && !C.includes("]/[") ? [
        C,
        void 0
      ] : [
        C.slice(0, E),
        C.slice(E + 1)
      ];
    }
    function p(C) {
      if (typeof C == "string" && C.includes("<alpha-value>")) {
        let E = C;
        return ({ opacityValue: R = 1 }) => E.replace(/<alpha-value>/g, R);
      }
      return C;
    }
    function f(C) {
      return (0, o.normalize)(C.slice(1, -1));
    }
    function v(C, E = {}, { tailwindConfig: R = {} } = {}) {
      var k;
      if (((k = E.values) === null || k === void 0 ? void 0 : k[C]) !== void 0) {
        var L;
        return p((L = E.values) === null || L === void 0 ? void 0 : L[C]);
      }
      let [z, F] = m(C);
      if (F !== void 0) {
        var q, j, D, H;
        let W = (H = (q = E.values) === null || q === void 0 ? void 0 : q[z]) !== null && H !== void 0 ? H : y(z) ? z.slice(1, -1) : void 0;
        return W === void 0 ? void 0 : (W = p(W), y(F) ? (0, n.withAlphaValue)(W, f(F)) : ((j = R.theme) === null || j === void 0 || (D = j.opacity) === null || D === void 0 ? void 0 : D[F]) === void 0 ? void 0 : (0, n.withAlphaValue)(W, R.theme.opacity[F]));
      }
      return h(C, E, {
        validate: o.color
      });
    }
    function w(C, E = {}) {
      var R;
      return (R = E.values) === null || R === void 0 ? void 0 : R[C];
    }
    function _(C) {
      return (E, R) => h(E, R, {
        validate: C
      });
    }
    let T = {
      any: h,
      color: v,
      url: _(o.url),
      image: _(o.image),
      length: _(o.length),
      percentage: _(o.percentage),
      position: _(o.position),
      lookup: w,
      "generic-name": _(o.genericName),
      "family-name": _(o.familyName),
      number: _(o.number),
      "line-width": _(o.lineWidth),
      "absolute-size": _(o.absoluteSize),
      "relative-size": _(o.relativeSize),
      shadow: _(o.shadow),
      size: _(i.backgroundSize)
    }, A = Object.keys(T);
    function O(C, E) {
      let R = C.indexOf(E);
      return R === -1 ? [
        void 0,
        C
      ] : [
        C.slice(0, R),
        C.slice(R + 1)
      ];
    }
    function M(C, E, R, k) {
      if (R.values && E in R.values)
        for (let { type: z } of C ?? []) {
          let F = T[z](E, R, {
            tailwindConfig: k
          });
          if (F !== void 0)
            return [
              F,
              z,
              null
            ];
        }
      if (y(E)) {
        let z = E.slice(1, -1), [F, q] = O(z, ":");
        if (!/^[\w-_]+$/g.test(F))
          q = z;
        else if (F !== void 0 && !A.includes(F))
          return [];
        if (q.length > 0 && A.includes(F))
          return [
            h(`[${q}]`, R),
            F,
            null
          ];
      }
      let L = I(C, E, R, k);
      for (let z of L)
        return z;
      return [];
    }
    function* I(C, E, R, k) {
      let L = (0, s.flagEnabled)(k, "generalizedModifiers"), [z, F] = m(E);
      if (L && R.modifiers != null && (R.modifiers === "any" || typeof R.modifiers == "object" && (F && y(F) || F in R.modifiers)) || (z = E, F = void 0), F !== void 0 && z === "" && (z = "DEFAULT"), F !== void 0 && typeof R.modifiers == "object") {
        var j, D;
        let H = (D = (j = R.modifiers) === null || j === void 0 ? void 0 : j[F]) !== null && D !== void 0 ? D : null;
        H !== null ? F = H : y(F) && (F = f(F));
      }
      for (let { type: H } of C ?? []) {
        let W = T[H](z, R, {
          tailwindConfig: k
        });
        W !== void 0 && (yield [
          W,
          H,
          F ?? null
        ]);
      }
    }
  }(bl)), bl;
}
var $l = {}, xh;
function h_() {
  return xh || (xh = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "default", {
      enumerable: !0,
      get: function() {
        return t;
      }
    });
    function t(r) {
      return typeof r == "function" ? r({}) : r;
    }
  }($l)), $l;
}
var Ah;
function m_() {
  return Ah || (Ah = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "default", {
      enumerable: !0,
      get: function() {
        return R;
      }
    });
    const t = /* @__PURE__ */ y(M0()), r = /* @__PURE__ */ y(n_()), n = /* @__PURE__ */ y(o_()), o = /* @__PURE__ */ y(q0()), a = i_(), i = a_(), s = s_(), l = /* @__PURE__ */ y(l_()), u = L0(), c = p_(), d = N0(), h = /* @__PURE__ */ y(h_());
    function y(k) {
      return k && k.__esModule ? k : {
        default: k
      };
    }
    function m(k) {
      return typeof k == "function";
    }
    function p(k, ...L) {
      let z = L.pop();
      for (let F of L)
        for (let q in F) {
          let j = z(k[q], F[q]);
          j === void 0 ? (0, l.default)(k[q]) && (0, l.default)(F[q]) ? k[q] = p({}, k[q], F[q], z) : k[q] = F[q] : k[q] = j;
        }
      return k;
    }
    const f = {
      colors: o.default,
      negative(k) {
        return Object.keys(k).filter((L) => k[L] !== "0").reduce((L, z) => {
          let F = (0, t.default)(k[z]);
          return F !== void 0 && (L[`-${z}`] = F), L;
        }, {});
      },
      breakpoints(k) {
        return Object.keys(k).filter((L) => typeof k[L] == "string").reduce((L, z) => ({
          ...L,
          [`screen-${z}`]: k[z]
        }), {});
      }
    };
    function v(k, ...L) {
      return m(k) ? k(...L) : k;
    }
    function w(k) {
      return k.reduce((L, { extend: z }) => p(L, z, (F, q) => F === void 0 ? [
        q
      ] : Array.isArray(F) ? [
        q,
        ...F
      ] : [
        q,
        F
      ]), {});
    }
    function _(k) {
      return {
        ...k.reduce((L, z) => (0, a.defaults)(L, z), {}),
        // In order to resolve n config objects, we combine all of their `extend` properties
        // into arrays instead of objects so they aren't overridden.
        extend: w(k)
      };
    }
    function T(k, L) {
      if (Array.isArray(k) && (0, l.default)(k[0]))
        return k.concat(L);
      if (Array.isArray(L) && (0, l.default)(L[0]) && (0, l.default)(k))
        return [
          k,
          ...L
        ];
      if (Array.isArray(L))
        return L;
    }
    function A({ extend: k, ...L }) {
      return p(L, k, (z, F) => !m(z) && !F.some(m) ? p({}, z, ...F, T) : (q, j) => p({}, ...[
        z,
        ...F
      ].map((D) => v(D, q, j)), T));
    }
    function* O(k) {
      let L = (0, i.toPath)(k);
      if (L.length === 0 || (yield L, Array.isArray(k)))
        return;
      let z = /^(.*?)\s*\/\s*([^/]+)$/, F = k.match(z);
      if (F !== null) {
        let [, q, j] = F, D = (0, i.toPath)(q);
        D.alpha = j, yield D;
      }
    }
    function M(k) {
      const L = (z, F) => {
        for (const q of O(z)) {
          let j = 0, D = k;
          for (; D != null && j < q.length; )
            D = D[q[j++]], D = m(D) && (q.alpha === void 0 || j <= q.length - 1) ? D(L, f) : D;
          if (D !== void 0) {
            if (q.alpha !== void 0) {
              let H = (0, c.parseColorFormat)(D);
              return (0, d.withAlphaValue)(H, q.alpha, (0, h.default)(H));
            }
            return (0, l.default)(D) ? (0, u.cloneDeep)(D) : D;
          }
        }
        return F;
      };
      return Object.assign(L, {
        theme: L,
        ...f
      }), Object.keys(k).reduce((z, F) => (z[F] = m(k[F]) ? k[F](L, f) : k[F], z), {});
    }
    function I(k) {
      let L = [];
      return k.forEach((z) => {
        L = [
          ...L,
          z
        ];
        var F;
        const q = (F = z == null ? void 0 : z.plugins) !== null && F !== void 0 ? F : [];
        q.length !== 0 && q.forEach((j) => {
          j.__isOptionsFunction && (j = j());
          var D;
          L = [
            ...L,
            ...I([
              (D = j == null ? void 0 : j.config) !== null && D !== void 0 ? D : {}
            ])
          ];
        });
      }), L;
    }
    function C(k) {
      return [
        ...k
      ].reduceRight((z, F) => m(F) ? F({
        corePlugins: z
      }) : (0, n.default)(F, z), r.default);
    }
    function E(k) {
      return [
        ...k
      ].reduceRight((z, F) => [
        ...z,
        ...F
      ], []);
    }
    function R(k) {
      let L = [
        ...I(k),
        {
          prefix: "",
          important: !1,
          separator: ":"
        }
      ];
      var z, F;
      return (0, s.normalizeConfig)((0, a.defaults)({
        theme: M(A(_(L.map((q) => (z = q == null ? void 0 : q.theme) !== null && z !== void 0 ? z : {})))),
        corePlugins: C(L.map((q) => q.corePlugins)),
        plugins: E(k.map((q) => (F = q == null ? void 0 : q.plugins) !== null && F !== void 0 ? F : []))
      }, ...L));
    }
  }(sl)), sl;
}
var Cl = {}, kl, Th;
function j0() {
  return Th || (Th = 1, kl = {
    content: [],
    presets: [],
    darkMode: "media",
    // or 'class'
    theme: {
      accentColor: ({ theme: e }) => ({
        ...e("colors"),
        auto: "auto"
      }),
      animation: {
        none: "none",
        spin: "spin 1s linear infinite",
        ping: "ping 1s cubic-bezier(0, 0, 0.2, 1) infinite",
        pulse: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite",
        bounce: "bounce 1s infinite"
      },
      aria: {
        busy: 'busy="true"',
        checked: 'checked="true"',
        disabled: 'disabled="true"',
        expanded: 'expanded="true"',
        hidden: 'hidden="true"',
        pressed: 'pressed="true"',
        readonly: 'readonly="true"',
        required: 'required="true"',
        selected: 'selected="true"'
      },
      aspectRatio: {
        auto: "auto",
        square: "1 / 1",
        video: "16 / 9"
      },
      backdropBlur: ({ theme: e }) => e("blur"),
      backdropBrightness: ({ theme: e }) => e("brightness"),
      backdropContrast: ({ theme: e }) => e("contrast"),
      backdropGrayscale: ({ theme: e }) => e("grayscale"),
      backdropHueRotate: ({ theme: e }) => e("hueRotate"),
      backdropInvert: ({ theme: e }) => e("invert"),
      backdropOpacity: ({ theme: e }) => e("opacity"),
      backdropSaturate: ({ theme: e }) => e("saturate"),
      backdropSepia: ({ theme: e }) => e("sepia"),
      backgroundColor: ({ theme: e }) => e("colors"),
      backgroundImage: {
        none: "none",
        "gradient-to-t": "linear-gradient(to top, var(--tw-gradient-stops))",
        "gradient-to-tr": "linear-gradient(to top right, var(--tw-gradient-stops))",
        "gradient-to-r": "linear-gradient(to right, var(--tw-gradient-stops))",
        "gradient-to-br": "linear-gradient(to bottom right, var(--tw-gradient-stops))",
        "gradient-to-b": "linear-gradient(to bottom, var(--tw-gradient-stops))",
        "gradient-to-bl": "linear-gradient(to bottom left, var(--tw-gradient-stops))",
        "gradient-to-l": "linear-gradient(to left, var(--tw-gradient-stops))",
        "gradient-to-tl": "linear-gradient(to top left, var(--tw-gradient-stops))"
      },
      backgroundOpacity: ({ theme: e }) => e("opacity"),
      backgroundPosition: {
        bottom: "bottom",
        center: "center",
        left: "left",
        "left-bottom": "left bottom",
        "left-top": "left top",
        right: "right",
        "right-bottom": "right bottom",
        "right-top": "right top",
        top: "top"
      },
      backgroundSize: {
        auto: "auto",
        cover: "cover",
        contain: "contain"
      },
      blur: {
        0: "0",
        none: "",
        sm: "4px",
        DEFAULT: "8px",
        md: "12px",
        lg: "16px",
        xl: "24px",
        "2xl": "40px",
        "3xl": "64px"
      },
      borderColor: ({ theme: e }) => ({
        ...e("colors"),
        DEFAULT: e("colors.gray.200", "currentColor")
      }),
      borderOpacity: ({ theme: e }) => e("opacity"),
      borderRadius: {
        none: "0px",
        sm: "0.125rem",
        DEFAULT: "0.25rem",
        md: "0.375rem",
        lg: "0.5rem",
        xl: "0.75rem",
        "2xl": "1rem",
        "3xl": "1.5rem",
        full: "9999px"
      },
      borderSpacing: ({ theme: e }) => ({
        ...e("spacing")
      }),
      borderWidth: {
        DEFAULT: "1px",
        0: "0px",
        2: "2px",
        4: "4px",
        8: "8px"
      },
      boxShadow: {
        sm: "0 1px 2px 0 rgb(0 0 0 / 0.05)",
        DEFAULT: "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
        md: "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
        lg: "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
        xl: "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
        "2xl": "0 25px 50px -12px rgb(0 0 0 / 0.25)",
        inner: "inset 0 2px 4px 0 rgb(0 0 0 / 0.05)",
        none: "none"
      },
      boxShadowColor: ({ theme: e }) => e("colors"),
      brightness: {
        0: "0",
        50: ".5",
        75: ".75",
        90: ".9",
        95: ".95",
        100: "1",
        105: "1.05",
        110: "1.1",
        125: "1.25",
        150: "1.5",
        200: "2"
      },
      caretColor: ({ theme: e }) => e("colors"),
      colors: ({ colors: e }) => ({
        inherit: e.inherit,
        current: e.current,
        transparent: e.transparent,
        black: e.black,
        white: e.white,
        slate: e.slate,
        gray: e.gray,
        zinc: e.zinc,
        neutral: e.neutral,
        stone: e.stone,
        red: e.red,
        orange: e.orange,
        amber: e.amber,
        yellow: e.yellow,
        lime: e.lime,
        green: e.green,
        emerald: e.emerald,
        teal: e.teal,
        cyan: e.cyan,
        sky: e.sky,
        blue: e.blue,
        indigo: e.indigo,
        violet: e.violet,
        purple: e.purple,
        fuchsia: e.fuchsia,
        pink: e.pink,
        rose: e.rose
      }),
      columns: {
        auto: "auto",
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        10: "10",
        11: "11",
        12: "12",
        "3xs": "16rem",
        "2xs": "18rem",
        xs: "20rem",
        sm: "24rem",
        md: "28rem",
        lg: "32rem",
        xl: "36rem",
        "2xl": "42rem",
        "3xl": "48rem",
        "4xl": "56rem",
        "5xl": "64rem",
        "6xl": "72rem",
        "7xl": "80rem"
      },
      container: {},
      content: {
        none: "none"
      },
      contrast: {
        0: "0",
        50: ".5",
        75: ".75",
        100: "1",
        125: "1.25",
        150: "1.5",
        200: "2"
      },
      cursor: {
        auto: "auto",
        default: "default",
        pointer: "pointer",
        wait: "wait",
        text: "text",
        move: "move",
        help: "help",
        "not-allowed": "not-allowed",
        none: "none",
        "context-menu": "context-menu",
        progress: "progress",
        cell: "cell",
        crosshair: "crosshair",
        "vertical-text": "vertical-text",
        alias: "alias",
        copy: "copy",
        "no-drop": "no-drop",
        grab: "grab",
        grabbing: "grabbing",
        "all-scroll": "all-scroll",
        "col-resize": "col-resize",
        "row-resize": "row-resize",
        "n-resize": "n-resize",
        "e-resize": "e-resize",
        "s-resize": "s-resize",
        "w-resize": "w-resize",
        "ne-resize": "ne-resize",
        "nw-resize": "nw-resize",
        "se-resize": "se-resize",
        "sw-resize": "sw-resize",
        "ew-resize": "ew-resize",
        "ns-resize": "ns-resize",
        "nesw-resize": "nesw-resize",
        "nwse-resize": "nwse-resize",
        "zoom-in": "zoom-in",
        "zoom-out": "zoom-out"
      },
      divideColor: ({ theme: e }) => e("borderColor"),
      divideOpacity: ({ theme: e }) => e("borderOpacity"),
      divideWidth: ({ theme: e }) => e("borderWidth"),
      dropShadow: {
        sm: "0 1px 1px rgb(0 0 0 / 0.05)",
        DEFAULT: ["0 1px 2px rgb(0 0 0 / 0.1)", "0 1px 1px rgb(0 0 0 / 0.06)"],
        md: ["0 4px 3px rgb(0 0 0 / 0.07)", "0 2px 2px rgb(0 0 0 / 0.06)"],
        lg: ["0 10px 8px rgb(0 0 0 / 0.04)", "0 4px 3px rgb(0 0 0 / 0.1)"],
        xl: ["0 20px 13px rgb(0 0 0 / 0.03)", "0 8px 5px rgb(0 0 0 / 0.08)"],
        "2xl": "0 25px 25px rgb(0 0 0 / 0.15)",
        none: "0 0 #0000"
      },
      fill: ({ theme: e }) => ({
        none: "none",
        ...e("colors")
      }),
      flex: {
        1: "1 1 0%",
        auto: "1 1 auto",
        initial: "0 1 auto",
        none: "none"
      },
      flexBasis: ({ theme: e }) => ({
        auto: "auto",
        ...e("spacing"),
        "1/2": "50%",
        "1/3": "33.333333%",
        "2/3": "66.666667%",
        "1/4": "25%",
        "2/4": "50%",
        "3/4": "75%",
        "1/5": "20%",
        "2/5": "40%",
        "3/5": "60%",
        "4/5": "80%",
        "1/6": "16.666667%",
        "2/6": "33.333333%",
        "3/6": "50%",
        "4/6": "66.666667%",
        "5/6": "83.333333%",
        "1/12": "8.333333%",
        "2/12": "16.666667%",
        "3/12": "25%",
        "4/12": "33.333333%",
        "5/12": "41.666667%",
        "6/12": "50%",
        "7/12": "58.333333%",
        "8/12": "66.666667%",
        "9/12": "75%",
        "10/12": "83.333333%",
        "11/12": "91.666667%",
        full: "100%"
      }),
      flexGrow: {
        0: "0",
        DEFAULT: "1"
      },
      flexShrink: {
        0: "0",
        DEFAULT: "1"
      },
      fontFamily: {
        sans: [
          "ui-sans-serif",
          "system-ui",
          "sans-serif",
          '"Apple Color Emoji"',
          '"Segoe UI Emoji"',
          '"Segoe UI Symbol"',
          '"Noto Color Emoji"'
        ],
        serif: ["ui-serif", "Georgia", "Cambria", '"Times New Roman"', "Times", "serif"],
        mono: [
          "ui-monospace",
          "SFMono-Regular",
          "Menlo",
          "Monaco",
          "Consolas",
          '"Liberation Mono"',
          '"Courier New"',
          "monospace"
        ]
      },
      fontSize: {
        xs: ["0.75rem", { lineHeight: "1rem" }],
        sm: ["0.875rem", { lineHeight: "1.25rem" }],
        base: ["1rem", { lineHeight: "1.5rem" }],
        lg: ["1.125rem", { lineHeight: "1.75rem" }],
        xl: ["1.25rem", { lineHeight: "1.75rem" }],
        "2xl": ["1.5rem", { lineHeight: "2rem" }],
        "3xl": ["1.875rem", { lineHeight: "2.25rem" }],
        "4xl": ["2.25rem", { lineHeight: "2.5rem" }],
        "5xl": ["3rem", { lineHeight: "1" }],
        "6xl": ["3.75rem", { lineHeight: "1" }],
        "7xl": ["4.5rem", { lineHeight: "1" }],
        "8xl": ["6rem", { lineHeight: "1" }],
        "9xl": ["8rem", { lineHeight: "1" }]
      },
      fontWeight: {
        thin: "100",
        extralight: "200",
        light: "300",
        normal: "400",
        medium: "500",
        semibold: "600",
        bold: "700",
        extrabold: "800",
        black: "900"
      },
      gap: ({ theme: e }) => e("spacing"),
      gradientColorStops: ({ theme: e }) => e("colors"),
      gradientColorStopPositions: {
        "0%": "0%",
        "5%": "5%",
        "10%": "10%",
        "15%": "15%",
        "20%": "20%",
        "25%": "25%",
        "30%": "30%",
        "35%": "35%",
        "40%": "40%",
        "45%": "45%",
        "50%": "50%",
        "55%": "55%",
        "60%": "60%",
        "65%": "65%",
        "70%": "70%",
        "75%": "75%",
        "80%": "80%",
        "85%": "85%",
        "90%": "90%",
        "95%": "95%",
        "100%": "100%"
      },
      grayscale: {
        0: "0",
        DEFAULT: "100%"
      },
      gridAutoColumns: {
        auto: "auto",
        min: "min-content",
        max: "max-content",
        fr: "minmax(0, 1fr)"
      },
      gridAutoRows: {
        auto: "auto",
        min: "min-content",
        max: "max-content",
        fr: "minmax(0, 1fr)"
      },
      gridColumn: {
        auto: "auto",
        "span-1": "span 1 / span 1",
        "span-2": "span 2 / span 2",
        "span-3": "span 3 / span 3",
        "span-4": "span 4 / span 4",
        "span-5": "span 5 / span 5",
        "span-6": "span 6 / span 6",
        "span-7": "span 7 / span 7",
        "span-8": "span 8 / span 8",
        "span-9": "span 9 / span 9",
        "span-10": "span 10 / span 10",
        "span-11": "span 11 / span 11",
        "span-12": "span 12 / span 12",
        "span-full": "1 / -1"
      },
      gridColumnEnd: {
        auto: "auto",
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        10: "10",
        11: "11",
        12: "12",
        13: "13"
      },
      gridColumnStart: {
        auto: "auto",
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        10: "10",
        11: "11",
        12: "12",
        13: "13"
      },
      gridRow: {
        auto: "auto",
        "span-1": "span 1 / span 1",
        "span-2": "span 2 / span 2",
        "span-3": "span 3 / span 3",
        "span-4": "span 4 / span 4",
        "span-5": "span 5 / span 5",
        "span-6": "span 6 / span 6",
        "span-7": "span 7 / span 7",
        "span-8": "span 8 / span 8",
        "span-9": "span 9 / span 9",
        "span-10": "span 10 / span 10",
        "span-11": "span 11 / span 11",
        "span-12": "span 12 / span 12",
        "span-full": "1 / -1"
      },
      gridRowEnd: {
        auto: "auto",
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        10: "10",
        11: "11",
        12: "12",
        13: "13"
      },
      gridRowStart: {
        auto: "auto",
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        10: "10",
        11: "11",
        12: "12",
        13: "13"
      },
      gridTemplateColumns: {
        none: "none",
        subgrid: "subgrid",
        1: "repeat(1, minmax(0, 1fr))",
        2: "repeat(2, minmax(0, 1fr))",
        3: "repeat(3, minmax(0, 1fr))",
        4: "repeat(4, minmax(0, 1fr))",
        5: "repeat(5, minmax(0, 1fr))",
        6: "repeat(6, minmax(0, 1fr))",
        7: "repeat(7, minmax(0, 1fr))",
        8: "repeat(8, minmax(0, 1fr))",
        9: "repeat(9, minmax(0, 1fr))",
        10: "repeat(10, minmax(0, 1fr))",
        11: "repeat(11, minmax(0, 1fr))",
        12: "repeat(12, minmax(0, 1fr))"
      },
      gridTemplateRows: {
        none: "none",
        subgrid: "subgrid",
        1: "repeat(1, minmax(0, 1fr))",
        2: "repeat(2, minmax(0, 1fr))",
        3: "repeat(3, minmax(0, 1fr))",
        4: "repeat(4, minmax(0, 1fr))",
        5: "repeat(5, minmax(0, 1fr))",
        6: "repeat(6, minmax(0, 1fr))",
        7: "repeat(7, minmax(0, 1fr))",
        8: "repeat(8, minmax(0, 1fr))",
        9: "repeat(9, minmax(0, 1fr))",
        10: "repeat(10, minmax(0, 1fr))",
        11: "repeat(11, minmax(0, 1fr))",
        12: "repeat(12, minmax(0, 1fr))"
      },
      height: ({ theme: e }) => ({
        auto: "auto",
        ...e("spacing"),
        "1/2": "50%",
        "1/3": "33.333333%",
        "2/3": "66.666667%",
        "1/4": "25%",
        "2/4": "50%",
        "3/4": "75%",
        "1/5": "20%",
        "2/5": "40%",
        "3/5": "60%",
        "4/5": "80%",
        "1/6": "16.666667%",
        "2/6": "33.333333%",
        "3/6": "50%",
        "4/6": "66.666667%",
        "5/6": "83.333333%",
        full: "100%",
        screen: "100vh",
        svh: "100svh",
        lvh: "100lvh",
        dvh: "100dvh",
        min: "min-content",
        max: "max-content",
        fit: "fit-content"
      }),
      hueRotate: {
        0: "0deg",
        15: "15deg",
        30: "30deg",
        60: "60deg",
        90: "90deg",
        180: "180deg"
      },
      inset: ({ theme: e }) => ({
        auto: "auto",
        ...e("spacing"),
        "1/2": "50%",
        "1/3": "33.333333%",
        "2/3": "66.666667%",
        "1/4": "25%",
        "2/4": "50%",
        "3/4": "75%",
        full: "100%"
      }),
      invert: {
        0: "0",
        DEFAULT: "100%"
      },
      keyframes: {
        spin: {
          to: {
            transform: "rotate(360deg)"
          }
        },
        ping: {
          "75%, 100%": {
            transform: "scale(2)",
            opacity: "0"
          }
        },
        pulse: {
          "50%": {
            opacity: ".5"
          }
        },
        bounce: {
          "0%, 100%": {
            transform: "translateY(-25%)",
            animationTimingFunction: "cubic-bezier(0.8,0,1,1)"
          },
          "50%": {
            transform: "none",
            animationTimingFunction: "cubic-bezier(0,0,0.2,1)"
          }
        }
      },
      letterSpacing: {
        tighter: "-0.05em",
        tight: "-0.025em",
        normal: "0em",
        wide: "0.025em",
        wider: "0.05em",
        widest: "0.1em"
      },
      lineHeight: {
        none: "1",
        tight: "1.25",
        snug: "1.375",
        normal: "1.5",
        relaxed: "1.625",
        loose: "2",
        3: ".75rem",
        4: "1rem",
        5: "1.25rem",
        6: "1.5rem",
        7: "1.75rem",
        8: "2rem",
        9: "2.25rem",
        10: "2.5rem"
      },
      listStyleType: {
        none: "none",
        disc: "disc",
        decimal: "decimal"
      },
      listStyleImage: {
        none: "none"
      },
      margin: ({ theme: e }) => ({
        auto: "auto",
        ...e("spacing")
      }),
      lineClamp: {
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6"
      },
      maxHeight: ({ theme: e }) => ({
        ...e("spacing"),
        none: "none",
        full: "100%",
        screen: "100vh",
        svh: "100svh",
        lvh: "100lvh",
        dvh: "100dvh",
        min: "min-content",
        max: "max-content",
        fit: "fit-content"
      }),
      maxWidth: ({ theme: e, breakpoints: t }) => ({
        ...e("spacing"),
        none: "none",
        xs: "20rem",
        sm: "24rem",
        md: "28rem",
        lg: "32rem",
        xl: "36rem",
        "2xl": "42rem",
        "3xl": "48rem",
        "4xl": "56rem",
        "5xl": "64rem",
        "6xl": "72rem",
        "7xl": "80rem",
        full: "100%",
        min: "min-content",
        max: "max-content",
        fit: "fit-content",
        prose: "65ch",
        ...t(e("screens"))
      }),
      minHeight: ({ theme: e }) => ({
        ...e("spacing"),
        full: "100%",
        screen: "100vh",
        svh: "100svh",
        lvh: "100lvh",
        dvh: "100dvh",
        min: "min-content",
        max: "max-content",
        fit: "fit-content"
      }),
      minWidth: ({ theme: e }) => ({
        ...e("spacing"),
        full: "100%",
        min: "min-content",
        max: "max-content",
        fit: "fit-content"
      }),
      objectPosition: {
        bottom: "bottom",
        center: "center",
        left: "left",
        "left-bottom": "left bottom",
        "left-top": "left top",
        right: "right",
        "right-bottom": "right bottom",
        "right-top": "right top",
        top: "top"
      },
      opacity: {
        0: "0",
        5: "0.05",
        10: "0.1",
        15: "0.15",
        20: "0.2",
        25: "0.25",
        30: "0.3",
        35: "0.35",
        40: "0.4",
        45: "0.45",
        50: "0.5",
        55: "0.55",
        60: "0.6",
        65: "0.65",
        70: "0.7",
        75: "0.75",
        80: "0.8",
        85: "0.85",
        90: "0.9",
        95: "0.95",
        100: "1"
      },
      order: {
        first: "-9999",
        last: "9999",
        none: "0",
        1: "1",
        2: "2",
        3: "3",
        4: "4",
        5: "5",
        6: "6",
        7: "7",
        8: "8",
        9: "9",
        10: "10",
        11: "11",
        12: "12"
      },
      outlineColor: ({ theme: e }) => e("colors"),
      outlineOffset: {
        0: "0px",
        1: "1px",
        2: "2px",
        4: "4px",
        8: "8px"
      },
      outlineWidth: {
        0: "0px",
        1: "1px",
        2: "2px",
        4: "4px",
        8: "8px"
      },
      padding: ({ theme: e }) => e("spacing"),
      placeholderColor: ({ theme: e }) => e("colors"),
      placeholderOpacity: ({ theme: e }) => e("opacity"),
      ringColor: ({ theme: e }) => ({
        DEFAULT: e("colors.blue.500", "#3b82f6"),
        ...e("colors")
      }),
      ringOffsetColor: ({ theme: e }) => e("colors"),
      ringOffsetWidth: {
        0: "0px",
        1: "1px",
        2: "2px",
        4: "4px",
        8: "8px"
      },
      ringOpacity: ({ theme: e }) => ({
        DEFAULT: "0.5",
        ...e("opacity")
      }),
      ringWidth: {
        DEFAULT: "3px",
        0: "0px",
        1: "1px",
        2: "2px",
        4: "4px",
        8: "8px"
      },
      rotate: {
        0: "0deg",
        1: "1deg",
        2: "2deg",
        3: "3deg",
        6: "6deg",
        12: "12deg",
        45: "45deg",
        90: "90deg",
        180: "180deg"
      },
      saturate: {
        0: "0",
        50: ".5",
        100: "1",
        150: "1.5",
        200: "2"
      },
      scale: {
        0: "0",
        50: ".5",
        75: ".75",
        90: ".9",
        95: ".95",
        100: "1",
        105: "1.05",
        110: "1.1",
        125: "1.25",
        150: "1.5"
      },
      screens: {
        sm: "640px",
        md: "768px",
        lg: "1024px",
        xl: "1280px",
        "2xl": "1536px"
      },
      scrollMargin: ({ theme: e }) => ({
        ...e("spacing")
      }),
      scrollPadding: ({ theme: e }) => e("spacing"),
      sepia: {
        0: "0",
        DEFAULT: "100%"
      },
      skew: {
        0: "0deg",
        1: "1deg",
        2: "2deg",
        3: "3deg",
        6: "6deg",
        12: "12deg"
      },
      space: ({ theme: e }) => ({
        ...e("spacing")
      }),
      spacing: {
        px: "1px",
        0: "0px",
        0.5: "0.125rem",
        1: "0.25rem",
        1.5: "0.375rem",
        2: "0.5rem",
        2.5: "0.625rem",
        3: "0.75rem",
        3.5: "0.875rem",
        4: "1rem",
        5: "1.25rem",
        6: "1.5rem",
        7: "1.75rem",
        8: "2rem",
        9: "2.25rem",
        10: "2.5rem",
        11: "2.75rem",
        12: "3rem",
        14: "3.5rem",
        16: "4rem",
        20: "5rem",
        24: "6rem",
        28: "7rem",
        32: "8rem",
        36: "9rem",
        40: "10rem",
        44: "11rem",
        48: "12rem",
        52: "13rem",
        56: "14rem",
        60: "15rem",
        64: "16rem",
        72: "18rem",
        80: "20rem",
        96: "24rem"
      },
      stroke: ({ theme: e }) => ({
        none: "none",
        ...e("colors")
      }),
      strokeWidth: {
        0: "0",
        1: "1",
        2: "2"
      },
      supports: {},
      data: {},
      textColor: ({ theme: e }) => e("colors"),
      textDecorationColor: ({ theme: e }) => e("colors"),
      textDecorationThickness: {
        auto: "auto",
        "from-font": "from-font",
        0: "0px",
        1: "1px",
        2: "2px",
        4: "4px",
        8: "8px"
      },
      textIndent: ({ theme: e }) => ({
        ...e("spacing")
      }),
      textOpacity: ({ theme: e }) => e("opacity"),
      textUnderlineOffset: {
        auto: "auto",
        0: "0px",
        1: "1px",
        2: "2px",
        4: "4px",
        8: "8px"
      },
      transformOrigin: {
        center: "center",
        top: "top",
        "top-right": "top right",
        right: "right",
        "bottom-right": "bottom right",
        bottom: "bottom",
        "bottom-left": "bottom left",
        left: "left",
        "top-left": "top left"
      },
      transitionDelay: {
        0: "0s",
        75: "75ms",
        100: "100ms",
        150: "150ms",
        200: "200ms",
        300: "300ms",
        500: "500ms",
        700: "700ms",
        1e3: "1000ms"
      },
      transitionDuration: {
        DEFAULT: "150ms",
        0: "0s",
        75: "75ms",
        100: "100ms",
        150: "150ms",
        200: "200ms",
        300: "300ms",
        500: "500ms",
        700: "700ms",
        1e3: "1000ms"
      },
      transitionProperty: {
        none: "none",
        all: "all",
        DEFAULT: "color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter",
        colors: "color, background-color, border-color, text-decoration-color, fill, stroke",
        opacity: "opacity",
        shadow: "box-shadow",
        transform: "transform"
      },
      transitionTimingFunction: {
        DEFAULT: "cubic-bezier(0.4, 0, 0.2, 1)",
        linear: "linear",
        in: "cubic-bezier(0.4, 0, 1, 1)",
        out: "cubic-bezier(0, 0, 0.2, 1)",
        "in-out": "cubic-bezier(0.4, 0, 0.2, 1)"
      },
      translate: ({ theme: e }) => ({
        ...e("spacing"),
        "1/2": "50%",
        "1/3": "33.333333%",
        "2/3": "66.666667%",
        "1/4": "25%",
        "2/4": "50%",
        "3/4": "75%",
        full: "100%"
      }),
      size: ({ theme: e }) => ({
        auto: "auto",
        ...e("spacing"),
        "1/2": "50%",
        "1/3": "33.333333%",
        "2/3": "66.666667%",
        "1/4": "25%",
        "2/4": "50%",
        "3/4": "75%",
        "1/5": "20%",
        "2/5": "40%",
        "3/5": "60%",
        "4/5": "80%",
        "1/6": "16.666667%",
        "2/6": "33.333333%",
        "3/6": "50%",
        "4/6": "66.666667%",
        "5/6": "83.333333%",
        "1/12": "8.333333%",
        "2/12": "16.666667%",
        "3/12": "25%",
        "4/12": "33.333333%",
        "5/12": "41.666667%",
        "6/12": "50%",
        "7/12": "58.333333%",
        "8/12": "66.666667%",
        "9/12": "75%",
        "10/12": "83.333333%",
        "11/12": "91.666667%",
        full: "100%",
        min: "min-content",
        max: "max-content",
        fit: "fit-content"
      }),
      width: ({ theme: e }) => ({
        auto: "auto",
        ...e("spacing"),
        "1/2": "50%",
        "1/3": "33.333333%",
        "2/3": "66.666667%",
        "1/4": "25%",
        "2/4": "50%",
        "3/4": "75%",
        "1/5": "20%",
        "2/5": "40%",
        "3/5": "60%",
        "4/5": "80%",
        "1/6": "16.666667%",
        "2/6": "33.333333%",
        "3/6": "50%",
        "4/6": "66.666667%",
        "5/6": "83.333333%",
        "1/12": "8.333333%",
        "2/12": "16.666667%",
        "3/12": "25%",
        "4/12": "33.333333%",
        "5/12": "41.666667%",
        "6/12": "50%",
        "7/12": "58.333333%",
        "8/12": "66.666667%",
        "9/12": "75%",
        "10/12": "83.333333%",
        "11/12": "91.666667%",
        full: "100%",
        screen: "100vw",
        svw: "100svw",
        lvw: "100lvw",
        dvw: "100dvw",
        min: "min-content",
        max: "max-content",
        fit: "fit-content"
      }),
      willChange: {
        auto: "auto",
        scroll: "scroll-position",
        contents: "contents",
        transform: "transform"
      },
      zIndex: {
        auto: "auto",
        0: "0",
        10: "10",
        20: "20",
        30: "30",
        40: "40",
        50: "50"
      }
    },
    plugins: []
  }), kl;
}
var Eh;
function v_() {
  return Eh || (Eh = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "default", {
      enumerable: !0,
      get: function() {
        return o;
      }
    });
    const t = /* @__PURE__ */ n(j0()), r = dp();
    function n(a) {
      return a && a.__esModule ? a : {
        default: a
      };
    }
    function o(a) {
      var i;
      const s = ((i = a == null ? void 0 : a.presets) !== null && i !== void 0 ? i : [
        t.default
      ]).slice().reverse().flatMap((c) => o(c instanceof Function ? c() : c)), l = {
        // Add experimental configs here...
        respectDefaultRingColorOpacity: {
          theme: {
            ringColor: ({ theme: c }) => ({
              DEFAULT: "#3b82f67f",
              ...c("colors")
            })
          }
        },
        disableColorOpacityUtilitiesByDefault: {
          corePlugins: {
            backgroundOpacity: !1,
            borderOpacity: !1,
            divideOpacity: !1,
            placeholderOpacity: !1,
            ringOpacity: !1,
            textOpacity: !1
          }
        }
      }, u = Object.keys(l).filter((c) => (0, r.flagEnabled)(a, c)).map((c) => l[c]);
      return [
        a,
        ...u,
        ...s
      ];
    }
  }(Cl)), Cl;
}
var Oh;
function g_() {
  return Oh || (Oh = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "default", {
      enumerable: !0,
      get: function() {
        return o;
      }
    });
    const t = /* @__PURE__ */ n(m_()), r = /* @__PURE__ */ n(v_());
    function n(a) {
      return a && a.__esModule ? a : {
        default: a
      };
    }
    function o(...a) {
      let [, ...i] = (0, r.default)(a[0]);
      return (0, t.default)([
        ...a,
        ...i
      ]);
    }
  }(al)), al;
}
var Pl, $h;
function y_() {
  if ($h) return Pl;
  $h = 1;
  let e = g_();
  return Pl = (e.__esModule ? e : { default: e }).default, Pl;
}
var b_ = y_();
const w_ = /* @__PURE__ */ ui(b_);
var Il, Ch;
function U0() {
  if (Ch) return Il;
  Ch = 1;
  let e = q0();
  return Il = (e.__esModule ? e : { default: e }).default, Il;
}
var __ = U0();
const S_ = /* @__PURE__ */ ui(__);
var Dl = {}, kh;
function x_() {
  return kh || (kh = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "default", {
      enumerable: !0,
      get: function() {
        return o;
      }
    });
    const t = L0(), r = /* @__PURE__ */ n(j0());
    function n(a) {
      return a && a.__esModule ? a : {
        default: a
      };
    }
    const o = (0, t.cloneDeep)(r.default.theme);
  }(Dl)), Dl;
}
var Rl, Ph;
function A_() {
  if (Ph) return Rl;
  Ph = 1;
  let e = x_();
  return Rl = (e.__esModule ? e : { default: e }).default, Rl;
}
var T_ = A_();
const E_ = /* @__PURE__ */ ui(T_);
var Ml = {}, Bl = {}, Ih;
function O_() {
  return Ih || (Ih = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "default", {
      enumerable: !0,
      get: function() {
        return r;
      }
    });
    function t(n, o) {
      return {
        handler: n,
        config: o
      };
    }
    t.withOptions = function(n, o = () => ({})) {
      const a = function(i) {
        return {
          __options: i,
          handler: n(i),
          config: o(i)
        };
      };
      return a.__isOptionsFunction = !0, a.__pluginFunction = n, a.__configFunction = o, a;
    };
    const r = t;
  }(Bl)), Bl;
}
var Dh;
function $_() {
  return Dh || (Dh = 1, function(e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "default", {
      enumerable: !0,
      get: function() {
        return n;
      }
    });
    const t = /* @__PURE__ */ r(O_());
    function r(o) {
      return o && o.__esModule ? o : {
        default: o
      };
    }
    const n = t.default;
  }(Ml)), Ml;
}
var ql, Rh;
function C_() {
  if (Rh) return ql;
  Rh = 1;
  let e = $_();
  return ql = (e.__esModule ? e : { default: e }).default, ql;
}
var Hi = { exports: {} };
Hi.exports;
var Mh;
function k_() {
  return Mh || (Mh = 1, function(e, t) {
    var r = 200, n = "__lodash_hash_undefined__", o = 800, a = 16, i = 9007199254740991, s = "[object Arguments]", l = "[object Array]", u = "[object AsyncFunction]", c = "[object Boolean]", d = "[object Date]", h = "[object Error]", y = "[object Function]", m = "[object GeneratorFunction]", p = "[object Map]", f = "[object Number]", v = "[object Null]", w = "[object Object]", _ = "[object Proxy]", T = "[object RegExp]", A = "[object Set]", O = "[object String]", M = "[object Undefined]", I = "[object WeakMap]", C = "[object ArrayBuffer]", E = "[object DataView]", R = "[object Float32Array]", k = "[object Float64Array]", L = "[object Int8Array]", z = "[object Int16Array]", F = "[object Int32Array]", q = "[object Uint8Array]", j = "[object Uint8ClampedArray]", D = "[object Uint16Array]", H = "[object Uint32Array]", W = /[\\^$.*+?()[\]{}|]/g, ee = /^\[object .+?Constructor\]$/, oe = /^(?:0|[1-9]\d*)$/, J = {};
    J[R] = J[k] = J[L] = J[z] = J[F] = J[q] = J[j] = J[D] = J[H] = !0, J[s] = J[l] = J[C] = J[c] = J[E] = J[d] = J[h] = J[y] = J[p] = J[f] = J[w] = J[T] = J[A] = J[O] = J[I] = !1;
    var N = typeof Ht == "object" && Ht && Ht.Object === Object && Ht, Q = typeof self == "object" && self && self.Object === Object && self, de = N || Q || Function("return this")(), G = t && !t.nodeType && t, ce = G && !0 && e && !e.nodeType && e, be = ce && ce.exports === G, ve = be && N.process, fe = function() {
      try {
        var g = ce && ce.require && ce.require("util").types;
        return g || ve && ve.binding && ve.binding("util");
      } catch {
      }
    }(), Oe = fe && fe.isTypedArray;
    function Ge(g, x, P) {
      switch (P.length) {
        case 0:
          return g.call(x);
        case 1:
          return g.call(x, P[0]);
        case 2:
          return g.call(x, P[0], P[1]);
        case 3:
          return g.call(x, P[0], P[1], P[2]);
      }
      return g.apply(x, P);
    }
    function we(g, x) {
      for (var P = -1, ae = Array(g); ++P < g; )
        ae[P] = x(P);
      return ae;
    }
    function Me(g) {
      return function(x) {
        return g(x);
      };
    }
    function Ct(g, x) {
      return g == null ? void 0 : g[x];
    }
    function _t(g, x) {
      return function(P) {
        return g(x(P));
      };
    }
    var vt = Array.prototype, st = Function.prototype, rt = Object.prototype, ut = de["__core-js_shared__"], St = st.toString, xt = rt.hasOwnProperty, gt = function() {
      var g = /[^.]+$/.exec(ut && ut.keys && ut.keys.IE_PROTO || "");
      return g ? "Symbol(src)_1." + g : "";
    }(), Ft = rt.toString, cr = St.call(Object), Yt = RegExp(
      "^" + St.call(xt).replace(W, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
    ), Ut = be ? de.Buffer : void 0, Sr = de.Symbol, kt = de.Uint8Array;
    Ut && Ut.allocUnsafe;
    var dr = _t(Object.getPrototypeOf, Object), xr = Object.create, K = rt.propertyIsEnumerable, Z = vt.splice, Pe = Sr ? Sr.toStringTag : void 0, Le = function() {
      try {
        var g = lo(Object, "defineProperty");
        return g({}, "", {}), g;
      } catch {
      }
    }(), He = Ut ? Ut.isBuffer : void 0, $e = Math.max, pt = Date.now, Nt = lo(de, "Map"), nt = lo(Object, "create"), Rt = /* @__PURE__ */ function() {
      function g() {
      }
      return function(x) {
        if (!Br(x))
          return {};
        if (xr)
          return xr(x);
        g.prototype = x;
        var P = new g();
        return g.prototype = void 0, P;
      };
    }();
    function zt(g) {
      var x = -1, P = g == null ? 0 : g.length;
      for (this.clear(); ++x < P; ) {
        var ae = g[x];
        this.set(ae[0], ae[1]);
      }
    }
    function Wt() {
      this.__data__ = nt ? nt(null) : {}, this.size = 0;
    }
    function Pt(g) {
      var x = this.has(g) && delete this.__data__[g];
      return this.size -= x ? 1 : 0, x;
    }
    function Vr(g) {
      var x = this.__data__;
      if (nt) {
        var P = x[g];
        return P === n ? void 0 : P;
      }
      return xt.call(x, g) ? x[g] : void 0;
    }
    function Hr(g) {
      var x = this.__data__;
      return nt ? x[g] !== void 0 : xt.call(x, g);
    }
    function fr(g, x) {
      var P = this.__data__;
      return this.size += this.has(g) ? 0 : 1, P[g] = nt && x === void 0 ? n : x, this;
    }
    zt.prototype.clear = Wt, zt.prototype.delete = Pt, zt.prototype.get = Vr, zt.prototype.has = Hr, zt.prototype.set = fr;
    function At(g) {
      var x = -1, P = g == null ? 0 : g.length;
      for (this.clear(); ++x < P; ) {
        var ae = g[x];
        this.set(ae[0], ae[1]);
      }
    }
    function Jt() {
      this.__data__ = [], this.size = 0;
    }
    function Gr(g) {
      var x = this.__data__, P = Dn(x, g);
      if (P < 0)
        return !1;
      var ae = x.length - 1;
      return P == ae ? x.pop() : Z.call(x, P, 1), --this.size, !0;
    }
    function an(g) {
      var x = this.__data__, P = Dn(x, g);
      return P < 0 ? void 0 : x[P][1];
    }
    function sn(g) {
      return Dn(this.__data__, g) > -1;
    }
    function ln(g, x) {
      var P = this.__data__, ae = Dn(P, g);
      return ae < 0 ? (++this.size, P.push([g, x])) : P[ae][1] = x, this;
    }
    At.prototype.clear = Jt, At.prototype.delete = Gr, At.prototype.get = an, At.prototype.has = sn, At.prototype.set = ln;
    function Zt(g) {
      var x = -1, P = g == null ? 0 : g.length;
      for (this.clear(); ++x < P; ) {
        var ae = g[x];
        this.set(ae[0], ae[1]);
      }
    }
    function ct() {
      this.size = 0, this.__data__ = {
        hash: new zt(),
        map: new (Nt || At)(),
        string: new zt()
      };
    }
    function kn(g) {
      var x = Ln(this, g).delete(g);
      return this.size -= x ? 1 : 0, x;
    }
    function un(g) {
      return Ln(this, g).get(g);
    }
    function Pn(g) {
      return Ln(this, g).has(g);
    }
    function oo(g, x) {
      var P = Ln(this, g), ae = P.size;
      return P.set(g, x), this.size += P.size == ae ? 0 : 1, this;
    }
    Zt.prototype.clear = ct, Zt.prototype.delete = kn, Zt.prototype.get = un, Zt.prototype.has = Pn, Zt.prototype.set = oo;
    function tr(g) {
      var x = this.__data__ = new At(g);
      this.size = x.size;
    }
    function ot() {
      this.__data__ = new At(), this.size = 0;
    }
    function Kr(g) {
      var x = this.__data__, P = x.delete(g);
      return this.size = x.size, P;
    }
    function io(g) {
      return this.__data__.get(g);
    }
    function In(g) {
      return this.__data__.has(g);
    }
    function _i(g, x) {
      var P = this.__data__;
      if (P instanceof At) {
        var ae = P.__data__;
        if (!Nt || ae.length < r - 1)
          return ae.push([g, x]), this.size = ++P.size, this;
        P = this.__data__ = new Zt(ae);
      }
      return P.set(g, x), this.size = P.size, this;
    }
    tr.prototype.clear = ot, tr.prototype.delete = Kr, tr.prototype.get = io, tr.prototype.has = In, tr.prototype.set = _i;
    function Si(g, x) {
      var P = It(g), ae = !P && zn(g), le = !P && !ae && pn(g), Se = !P && !ae && !le && co(g), xe = P || ae || le || Se, Ee = xe ? we(g.length, String) : [], Ae = Ee.length;
      for (var Ke in g)
        xe && // Safari 9 has enumerable `arguments.length` in strict mode.
        (Ke == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
        le && (Ke == "offset" || Ke == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
        Se && (Ke == "buffer" || Ke == "byteLength" || Ke == "byteOffset") || // Skip index properties.
        Fn(Ke, Ae)) || Ee.push(Ke);
      return Ee;
    }
    function Mt(g, x, P) {
      (P !== void 0 && !Nn(g[x], P) || P === void 0 && !(x in g)) && ao(g, x, P);
    }
    function xi(g, x, P) {
      var ae = g[x];
      (!(xt.call(g, x) && Nn(ae, P)) || P === void 0 && !(x in g)) && ao(g, x, P);
    }
    function Dn(g, x) {
      for (var P = g.length; P--; )
        if (Nn(g[P][0], x))
          return P;
      return -1;
    }
    function ao(g, x, P) {
      x == "__proto__" && Le ? Le(g, x, {
        configurable: !0,
        enumerable: !0,
        value: P,
        writable: !0
      }) : g[x] = P;
    }
    var Ai = Bo();
    function Rn(g) {
      return g == null ? g === void 0 ? M : v : Pe && Pe in Object(g) ? ki(g) : Mr(g);
    }
    function cn(g) {
      return Yr(g) && Rn(g) == s;
    }
    function Ro(g) {
      if (!Br(g) || fn(g))
        return !1;
      var x = hn(g) ? Yt : ee;
      return x.test(qi(g));
    }
    function Mn(g) {
      return Yr(g) && mn(g.length) && !!J[Rn(g)];
    }
    function Ar(g) {
      if (!Br(g))
        return Rr(g);
      var x = rr(g), P = [];
      for (var ae in g)
        ae == "constructor" && (x || !xt.call(g, ae)) || P.push(ae);
      return P;
    }
    function Bn(g, x, P, ae, le) {
      g !== x && Ai(x, function(Se, xe) {
        if (le || (le = new tr()), Br(Se))
          Ti(g, x, xe, P, Bn, ae, le);
        else {
          var Ee = ae ? ae(nr(g, xe), Se, xe + "", g, x, le) : void 0;
          Ee === void 0 && (Ee = Se), Mt(g, xe, Ee);
        }
      }, fo);
    }
    function Ti(g, x, P, ae, le, Se, xe) {
      var Ee = nr(g, P), Ae = nr(x, P), Ke = xe.get(Ae);
      if (Ke) {
        Mt(g, P, Ke);
        return;
      }
      var Ye = Se ? Se(Ee, Ae, P + "", g, x, xe) : void 0, it = Ye === void 0;
      if (it) {
        var Tt = It(Ae), yt = !Tt && pn(Ae), qr = !Tt && !yt && co(Ae);
        Ye = Ae, Tt || yt || qr ? It(Ee) ? Ye = Ee : qo(Ee) ? Ye = so(Ee) : yt ? (it = !1, Ye = $i(Ae)) : qr ? (it = !1, Ye = qn(Ae)) : Ye = [] : uo(Ae) || zn(Ae) ? (Ye = Ee, zn(Ee) ? Ye = Tr(Ee) : (!Br(Ee) || hn(Ee)) && (Ye = Pi(Ae))) : it = !1;
      }
      it && (xe.set(Ae, Ye), le(Ye, Ae, ae, Se, xe), xe.delete(Ae)), Mt(g, P, Ye);
    }
    function Ei(g, x) {
      return Mi(Ri(g, x, Lo), g + "");
    }
    var Oi = Le ? function(g, x) {
      return Le(g, "toString", {
        configurable: !0,
        enumerable: !1,
        value: Li(x),
        writable: !0
      });
    } : Lo;
    function $i(g, x) {
      return g.slice();
    }
    function Ci(g) {
      var x = new g.constructor(g.byteLength);
      return new kt(x).set(new kt(g)), x;
    }
    function qn(g, x) {
      var P = Ci(g.buffer);
      return new g.constructor(P, g.byteOffset, g.length);
    }
    function so(g, x) {
      var P = -1, ae = g.length;
      for (x || (x = Array(ae)); ++P < ae; )
        x[P] = g[P];
      return x;
    }
    function dn(g, x, P, ae) {
      var le = !P;
      P || (P = {});
      for (var Se = -1, xe = x.length; ++Se < xe; ) {
        var Ee = x[Se], Ae = void 0;
        Ae === void 0 && (Ae = g[Ee]), le ? ao(P, Ee, Ae) : xi(P, Ee, Ae);
      }
      return P;
    }
    function Mo(g) {
      return Ei(function(x, P) {
        var ae = -1, le = P.length, Se = le > 1 ? P[le - 1] : void 0, xe = le > 2 ? P[2] : void 0;
        for (Se = g.length > 3 && typeof Se == "function" ? (le--, Se) : void 0, xe && Ii(P[0], P[1], xe) && (Se = le < 3 ? void 0 : Se, le = 1), x = Object(x); ++ae < le; ) {
          var Ee = P[ae];
          Ee && g(x, Ee, ae, Se);
        }
        return x;
      });
    }
    function Bo(g) {
      return function(x, P, ae) {
        for (var le = -1, Se = Object(x), xe = ae(x), Ee = xe.length; Ee--; ) {
          var Ae = xe[++le];
          if (P(Se[Ae], Ae, Se) === !1)
            break;
        }
        return x;
      };
    }
    function Ln(g, x) {
      var P = g.__data__;
      return Di(x) ? P[typeof x == "string" ? "string" : "hash"] : P.map;
    }
    function lo(g, x) {
      var P = Ct(g, x);
      return Ro(P) ? P : void 0;
    }
    function ki(g) {
      var x = xt.call(g, Pe), P = g[Pe];
      try {
        g[Pe] = void 0;
        var ae = !0;
      } catch {
      }
      var le = Ft.call(g);
      return ae && (x ? g[Pe] = P : delete g[Pe]), le;
    }
    function Pi(g) {
      return typeof g.constructor == "function" && !rr(g) ? Rt(dr(g)) : {};
    }
    function Fn(g, x) {
      var P = typeof g;
      return x = x ?? i, !!x && (P == "number" || P != "symbol" && oe.test(g)) && g > -1 && g % 1 == 0 && g < x;
    }
    function Ii(g, x, P) {
      if (!Br(P))
        return !1;
      var ae = typeof x;
      return (ae == "number" ? jn(P) && Fn(x, P.length) : ae == "string" && x in P) ? Nn(P[x], g) : !1;
    }
    function Di(g) {
      var x = typeof g;
      return x == "string" || x == "number" || x == "symbol" || x == "boolean" ? g !== "__proto__" : g === null;
    }
    function fn(g) {
      return !!gt && gt in g;
    }
    function rr(g) {
      var x = g && g.constructor, P = typeof x == "function" && x.prototype || rt;
      return g === P;
    }
    function Rr(g) {
      var x = [];
      if (g != null)
        for (var P in Object(g))
          x.push(P);
      return x;
    }
    function Mr(g) {
      return Ft.call(g);
    }
    function Ri(g, x, P) {
      return x = $e(x === void 0 ? g.length - 1 : x, 0), function() {
        for (var ae = arguments, le = -1, Se = $e(ae.length - x, 0), xe = Array(Se); ++le < Se; )
          xe[le] = ae[x + le];
        le = -1;
        for (var Ee = Array(x + 1); ++le < x; )
          Ee[le] = ae[le];
        return Ee[x] = P(xe), Ge(g, this, Ee);
      };
    }
    function nr(g, x) {
      if (!(x === "constructor" && typeof g[x] == "function") && x != "__proto__")
        return g[x];
    }
    var Mi = Bi(Oi);
    function Bi(g) {
      var x = 0, P = 0;
      return function() {
        var ae = pt(), le = a - (ae - P);
        if (P = ae, le > 0) {
          if (++x >= o)
            return arguments[0];
        } else
          x = 0;
        return g.apply(void 0, arguments);
      };
    }
    function qi(g) {
      if (g != null) {
        try {
          return St.call(g);
        } catch {
        }
        try {
          return g + "";
        } catch {
        }
      }
      return "";
    }
    function Nn(g, x) {
      return g === x || g !== g && x !== x;
    }
    var zn = cn(/* @__PURE__ */ function() {
      return arguments;
    }()) ? cn : function(g) {
      return Yr(g) && xt.call(g, "callee") && !K.call(g, "callee");
    }, It = Array.isArray;
    function jn(g) {
      return g != null && mn(g.length) && !hn(g);
    }
    function qo(g) {
      return Yr(g) && jn(g);
    }
    var pn = He || b;
    function hn(g) {
      if (!Br(g))
        return !1;
      var x = Rn(g);
      return x == y || x == m || x == u || x == _;
    }
    function mn(g) {
      return typeof g == "number" && g > -1 && g % 1 == 0 && g <= i;
    }
    function Br(g) {
      var x = typeof g;
      return g != null && (x == "object" || x == "function");
    }
    function Yr(g) {
      return g != null && typeof g == "object";
    }
    function uo(g) {
      if (!Yr(g) || Rn(g) != w)
        return !1;
      var x = dr(g);
      if (x === null)
        return !0;
      var P = xt.call(x, "constructor") && x.constructor;
      return typeof P == "function" && P instanceof P && St.call(P) == cr;
    }
    var co = Oe ? Me(Oe) : Mn;
    function Tr(g) {
      return dn(g, fo(g));
    }
    function fo(g) {
      return jn(g) ? Si(g) : Ar(g);
    }
    var po = Mo(function(g, x, P) {
      Bn(g, x, P);
    });
    function Li(g) {
      return function() {
        return g;
      };
    }
    function Lo(g) {
      return g;
    }
    function b() {
      return !1;
    }
    e.exports = po;
  }(Hi, Hi.exports)), Hi.exports;
}
var Ll, Bh;
function P_() {
  if (Bh) return Ll;
  Bh = 1;
  function e() {
    if (!arguments.length)
      return [];
    var r = arguments[0];
    return t(r) ? r : [r];
  }
  var t = Array.isArray;
  return Ll = e, Ll;
}
var Fl, qh;
function I_() {
  if (qh) return Fl;
  qh = 1;
  const e = U0(), t = (i) => i.toFixed(7).replace(/(\.[0-9]+?)0+$/, "$1").replace(/\.0$/, ""), r = (i) => `${t(i / 16)}rem`, n = (i, s) => `${t(i / s)}em`, o = (i) => {
    i = i.replace("#", ""), i = i.length === 3 ? i.replace(/./g, "$&$&") : i;
    const s = parseInt(i.substring(0, 2), 16), l = parseInt(i.substring(2, 4), 16), u = parseInt(i.substring(4, 6), 16);
    return `${s} ${l} ${u}`;
  };
  let a = {
    sm: {
      css: [
        {
          fontSize: r(14),
          lineHeight: t(24 / 14),
          p: {
            marginTop: n(16, 14),
            marginBottom: n(16, 14)
          },
          '[class~="lead"]': {
            fontSize: n(18, 14),
            lineHeight: t(28 / 18),
            marginTop: n(16, 18),
            marginBottom: n(16, 18)
          },
          blockquote: {
            marginTop: n(24, 18),
            marginBottom: n(24, 18),
            paddingInlineStart: n(20, 18)
          },
          h1: {
            fontSize: n(30, 14),
            marginTop: "0",
            marginBottom: n(24, 30),
            lineHeight: t(36 / 30)
          },
          h2: {
            fontSize: n(20, 14),
            marginTop: n(32, 20),
            marginBottom: n(16, 20),
            lineHeight: t(28 / 20)
          },
          h3: {
            fontSize: n(18, 14),
            marginTop: n(28, 18),
            marginBottom: n(8, 18),
            lineHeight: t(28 / 18)
          },
          h4: {
            marginTop: n(20, 14),
            marginBottom: n(8, 14),
            lineHeight: t(20 / 14)
          },
          img: {
            marginTop: n(24, 14),
            marginBottom: n(24, 14)
          },
          picture: {
            marginTop: n(24, 14),
            marginBottom: n(24, 14)
          },
          "picture > img": {
            marginTop: "0",
            marginBottom: "0"
          },
          video: {
            marginTop: n(24, 14),
            marginBottom: n(24, 14)
          },
          kbd: {
            fontSize: n(12, 14),
            borderRadius: r(5),
            paddingTop: n(2, 14),
            paddingInlineEnd: n(5, 14),
            paddingBottom: n(2, 14),
            paddingInlineStart: n(5, 14)
          },
          code: {
            fontSize: n(12, 14)
          },
          "h2 code": {
            fontSize: n(18, 20)
          },
          "h3 code": {
            fontSize: n(16, 18)
          },
          pre: {
            fontSize: n(12, 14),
            lineHeight: t(20 / 12),
            marginTop: n(20, 12),
            marginBottom: n(20, 12),
            borderRadius: r(4),
            paddingTop: n(8, 12),
            paddingInlineEnd: n(12, 12),
            paddingBottom: n(8, 12),
            paddingInlineStart: n(12, 12)
          },
          ol: {
            marginTop: n(16, 14),
            marginBottom: n(16, 14),
            paddingInlineStart: n(22, 14)
          },
          ul: {
            marginTop: n(16, 14),
            marginBottom: n(16, 14),
            paddingInlineStart: n(22, 14)
          },
          li: {
            marginTop: n(4, 14),
            marginBottom: n(4, 14)
          },
          "ol > li": {
            paddingInlineStart: n(6, 14)
          },
          "ul > li": {
            paddingInlineStart: n(6, 14)
          },
          "> ul > li p": {
            marginTop: n(8, 14),
            marginBottom: n(8, 14)
          },
          "> ul > li > p:first-child": {
            marginTop: n(16, 14)
          },
          "> ul > li > p:last-child": {
            marginBottom: n(16, 14)
          },
          "> ol > li > p:first-child": {
            marginTop: n(16, 14)
          },
          "> ol > li > p:last-child": {
            marginBottom: n(16, 14)
          },
          "ul ul, ul ol, ol ul, ol ol": {
            marginTop: n(8, 14),
            marginBottom: n(8, 14)
          },
          dl: {
            marginTop: n(16, 14),
            marginBottom: n(16, 14)
          },
          dt: {
            marginTop: n(16, 14)
          },
          dd: {
            marginTop: n(4, 14),
            paddingInlineStart: n(22, 14)
          },
          hr: {
            marginTop: n(40, 14),
            marginBottom: n(40, 14)
          },
          "hr + *": {
            marginTop: "0"
          },
          "h2 + *": {
            marginTop: "0"
          },
          "h3 + *": {
            marginTop: "0"
          },
          "h4 + *": {
            marginTop: "0"
          },
          table: {
            fontSize: n(12, 14),
            lineHeight: t(18 / 12)
          },
          "thead th": {
            paddingInlineEnd: n(12, 12),
            paddingBottom: n(8, 12),
            paddingInlineStart: n(12, 12)
          },
          "thead th:first-child": {
            paddingInlineStart: "0"
          },
          "thead th:last-child": {
            paddingInlineEnd: "0"
          },
          "tbody td, tfoot td": {
            paddingTop: n(8, 12),
            paddingInlineEnd: n(12, 12),
            paddingBottom: n(8, 12),
            paddingInlineStart: n(12, 12)
          },
          "tbody td:first-child, tfoot td:first-child": {
            paddingInlineStart: "0"
          },
          "tbody td:last-child, tfoot td:last-child": {
            paddingInlineEnd: "0"
          },
          figure: {
            marginTop: n(24, 14),
            marginBottom: n(24, 14)
          },
          "figure > *": {
            marginTop: "0",
            marginBottom: "0"
          },
          figcaption: {
            fontSize: n(12, 14),
            lineHeight: t(16 / 12),
            marginTop: n(8, 12)
          }
        },
        {
          "> :first-child": {
            marginTop: "0"
          },
          "> :last-child": {
            marginBottom: "0"
          }
        }
      ]
    },
    base: {
      css: [
        {
          fontSize: r(16),
          lineHeight: t(28 / 16),
          p: {
            marginTop: n(20, 16),
            marginBottom: n(20, 16)
          },
          '[class~="lead"]': {
            fontSize: n(20, 16),
            lineHeight: t(32 / 20),
            marginTop: n(24, 20),
            marginBottom: n(24, 20)
          },
          blockquote: {
            marginTop: n(32, 20),
            marginBottom: n(32, 20),
            paddingInlineStart: n(20, 20)
          },
          h1: {
            fontSize: n(36, 16),
            marginTop: "0",
            marginBottom: n(32, 36),
            lineHeight: t(40 / 36)
          },
          h2: {
            fontSize: n(24, 16),
            marginTop: n(48, 24),
            marginBottom: n(24, 24),
            lineHeight: t(32 / 24)
          },
          h3: {
            fontSize: n(20, 16),
            marginTop: n(32, 20),
            marginBottom: n(12, 20),
            lineHeight: t(32 / 20)
          },
          h4: {
            marginTop: n(24, 16),
            marginBottom: n(8, 16),
            lineHeight: t(24 / 16)
          },
          img: {
            marginTop: n(32, 16),
            marginBottom: n(32, 16)
          },
          picture: {
            marginTop: n(32, 16),
            marginBottom: n(32, 16)
          },
          "picture > img": {
            marginTop: "0",
            marginBottom: "0"
          },
          video: {
            marginTop: n(32, 16),
            marginBottom: n(32, 16)
          },
          kbd: {
            fontSize: n(14, 16),
            borderRadius: r(5),
            paddingTop: n(3, 16),
            paddingInlineEnd: n(6, 16),
            paddingBottom: n(3, 16),
            paddingInlineStart: n(6, 16)
          },
          code: {
            fontSize: n(14, 16)
          },
          "h2 code": {
            fontSize: n(21, 24)
          },
          "h3 code": {
            fontSize: n(18, 20)
          },
          pre: {
            fontSize: n(14, 16),
            lineHeight: t(24 / 14),
            marginTop: n(24, 14),
            marginBottom: n(24, 14),
            borderRadius: r(6),
            paddingTop: n(12, 14),
            paddingInlineEnd: n(16, 14),
            paddingBottom: n(12, 14),
            paddingInlineStart: n(16, 14)
          },
          ol: {
            marginTop: n(20, 16),
            marginBottom: n(20, 16),
            paddingInlineStart: n(26, 16)
          },
          ul: {
            marginTop: n(20, 16),
            marginBottom: n(20, 16),
            paddingInlineStart: n(26, 16)
          },
          li: {
            marginTop: n(8, 16),
            marginBottom: n(8, 16)
          },
          "ol > li": {
            paddingInlineStart: n(6, 16)
          },
          "ul > li": {
            paddingInlineStart: n(6, 16)
          },
          "> ul > li p": {
            marginTop: n(12, 16),
            marginBottom: n(12, 16)
          },
          "> ul > li > p:first-child": {
            marginTop: n(20, 16)
          },
          "> ul > li > p:last-child": {
            marginBottom: n(20, 16)
          },
          "> ol > li > p:first-child": {
            marginTop: n(20, 16)
          },
          "> ol > li > p:last-child": {
            marginBottom: n(20, 16)
          },
          "ul ul, ul ol, ol ul, ol ol": {
            marginTop: n(12, 16),
            marginBottom: n(12, 16)
          },
          dl: {
            marginTop: n(20, 16),
            marginBottom: n(20, 16)
          },
          dt: {
            marginTop: n(20, 16)
          },
          dd: {
            marginTop: n(8, 16),
            paddingInlineStart: n(26, 16)
          },
          hr: {
            marginTop: n(48, 16),
            marginBottom: n(48, 16)
          },
          "hr + *": {
            marginTop: "0"
          },
          "h2 + *": {
            marginTop: "0"
          },
          "h3 + *": {
            marginTop: "0"
          },
          "h4 + *": {
            marginTop: "0"
          },
          table: {
            fontSize: n(14, 16),
            lineHeight: t(24 / 14)
          },
          "thead th": {
            paddingInlineEnd: n(8, 14),
            paddingBottom: n(8, 14),
            paddingInlineStart: n(8, 14)
          },
          "thead th:first-child": {
            paddingInlineStart: "0"
          },
          "thead th:last-child": {
            paddingInlineEnd: "0"
          },
          "tbody td, tfoot td": {
            paddingTop: n(8, 14),
            paddingInlineEnd: n(8, 14),
            paddingBottom: n(8, 14),
            paddingInlineStart: n(8, 14)
          },
          "tbody td:first-child, tfoot td:first-child": {
            paddingInlineStart: "0"
          },
          "tbody td:last-child, tfoot td:last-child": {
            paddingInlineEnd: "0"
          },
          figure: {
            marginTop: n(32, 16),
            marginBottom: n(32, 16)
          },
          "figure > *": {
            marginTop: "0",
            marginBottom: "0"
          },
          figcaption: {
            fontSize: n(14, 16),
            lineHeight: t(20 / 14),
            marginTop: n(12, 14)
          }
        },
        {
          "> :first-child": {
            marginTop: "0"
          },
          "> :last-child": {
            marginBottom: "0"
          }
        }
      ]
    },
    lg: {
      css: [
        {
          fontSize: r(18),
          lineHeight: t(32 / 18),
          p: {
            marginTop: n(24, 18),
            marginBottom: n(24, 18)
          },
          '[class~="lead"]': {
            fontSize: n(22, 18),
            lineHeight: t(32 / 22),
            marginTop: n(24, 22),
            marginBottom: n(24, 22)
          },
          blockquote: {
            marginTop: n(40, 24),
            marginBottom: n(40, 24),
            paddingInlineStart: n(24, 24)
          },
          h1: {
            fontSize: n(48, 18),
            marginTop: "0",
            marginBottom: n(40, 48),
            lineHeight: t(48 / 48)
          },
          h2: {
            fontSize: n(30, 18),
            marginTop: n(56, 30),
            marginBottom: n(32, 30),
            lineHeight: t(40 / 30)
          },
          h3: {
            fontSize: n(24, 18),
            marginTop: n(40, 24),
            marginBottom: n(16, 24),
            lineHeight: t(36 / 24)
          },
          h4: {
            marginTop: n(32, 18),
            marginBottom: n(8, 18),
            lineHeight: t(28 / 18)
          },
          img: {
            marginTop: n(32, 18),
            marginBottom: n(32, 18)
          },
          picture: {
            marginTop: n(32, 18),
            marginBottom: n(32, 18)
          },
          "picture > img": {
            marginTop: "0",
            marginBottom: "0"
          },
          video: {
            marginTop: n(32, 18),
            marginBottom: n(32, 18)
          },
          kbd: {
            fontSize: n(16, 18),
            borderRadius: r(5),
            paddingTop: n(4, 18),
            paddingInlineEnd: n(8, 18),
            paddingBottom: n(4, 18),
            paddingInlineStart: n(8, 18)
          },
          code: {
            fontSize: n(16, 18)
          },
          "h2 code": {
            fontSize: n(26, 30)
          },
          "h3 code": {
            fontSize: n(21, 24)
          },
          pre: {
            fontSize: n(16, 18),
            lineHeight: t(28 / 16),
            marginTop: n(32, 16),
            marginBottom: n(32, 16),
            borderRadius: r(6),
            paddingTop: n(16, 16),
            paddingInlineEnd: n(24, 16),
            paddingBottom: n(16, 16),
            paddingInlineStart: n(24, 16)
          },
          ol: {
            marginTop: n(24, 18),
            marginBottom: n(24, 18),
            paddingInlineStart: n(28, 18)
          },
          ul: {
            marginTop: n(24, 18),
            marginBottom: n(24, 18),
            paddingInlineStart: n(28, 18)
          },
          li: {
            marginTop: n(12, 18),
            marginBottom: n(12, 18)
          },
          "ol > li": {
            paddingInlineStart: n(8, 18)
          },
          "ul > li": {
            paddingInlineStart: n(8, 18)
          },
          "> ul > li p": {
            marginTop: n(16, 18),
            marginBottom: n(16, 18)
          },
          "> ul > li > p:first-child": {
            marginTop: n(24, 18)
          },
          "> ul > li > p:last-child": {
            marginBottom: n(24, 18)
          },
          "> ol > li > p:first-child": {
            marginTop: n(24, 18)
          },
          "> ol > li > p:last-child": {
            marginBottom: n(24, 18)
          },
          "ul ul, ul ol, ol ul, ol ol": {
            marginTop: n(16, 18),
            marginBottom: n(16, 18)
          },
          dl: {
            marginTop: n(24, 18),
            marginBottom: n(24, 18)
          },
          dt: {
            marginTop: n(24, 18)
          },
          dd: {
            marginTop: n(12, 18),
            paddingInlineStart: n(28, 18)
          },
          hr: {
            marginTop: n(56, 18),
            marginBottom: n(56, 18)
          },
          "hr + *": {
            marginTop: "0"
          },
          "h2 + *": {
            marginTop: "0"
          },
          "h3 + *": {
            marginTop: "0"
          },
          "h4 + *": {
            marginTop: "0"
          },
          table: {
            fontSize: n(16, 18),
            lineHeight: t(24 / 16)
          },
          "thead th": {
            paddingInlineEnd: n(12, 16),
            paddingBottom: n(12, 16),
            paddingInlineStart: n(12, 16)
          },
          "thead th:first-child": {
            paddingInlineStart: "0"
          },
          "thead th:last-child": {
            paddingInlineEnd: "0"
          },
          "tbody td, tfoot td": {
            paddingTop: n(12, 16),
            paddingInlineEnd: n(12, 16),
            paddingBottom: n(12, 16),
            paddingInlineStart: n(12, 16)
          },
          "tbody td:first-child, tfoot td:first-child": {
            paddingInlineStart: "0"
          },
          "tbody td:last-child, tfoot td:last-child": {
            paddingInlineEnd: "0"
          },
          figure: {
            marginTop: n(32, 18),
            marginBottom: n(32, 18)
          },
          "figure > *": {
            marginTop: "0",
            marginBottom: "0"
          },
          figcaption: {
            fontSize: n(16, 18),
            lineHeight: t(24 / 16),
            marginTop: n(16, 16)
          }
        },
        {
          "> :first-child": {
            marginTop: "0"
          },
          "> :last-child": {
            marginBottom: "0"
          }
        }
      ]
    },
    xl: {
      css: [
        {
          fontSize: r(20),
          lineHeight: t(36 / 20),
          p: {
            marginTop: n(24, 20),
            marginBottom: n(24, 20)
          },
          '[class~="lead"]': {
            fontSize: n(24, 20),
            lineHeight: t(36 / 24),
            marginTop: n(24, 24),
            marginBottom: n(24, 24)
          },
          blockquote: {
            marginTop: n(48, 30),
            marginBottom: n(48, 30),
            paddingInlineStart: n(32, 30)
          },
          h1: {
            fontSize: n(56, 20),
            marginTop: "0",
            marginBottom: n(48, 56),
            lineHeight: t(56 / 56)
          },
          h2: {
            fontSize: n(36, 20),
            marginTop: n(56, 36),
            marginBottom: n(32, 36),
            lineHeight: t(40 / 36)
          },
          h3: {
            fontSize: n(30, 20),
            marginTop: n(48, 30),
            marginBottom: n(20, 30),
            lineHeight: t(40 / 30)
          },
          h4: {
            marginTop: n(36, 20),
            marginBottom: n(12, 20),
            lineHeight: t(32 / 20)
          },
          img: {
            marginTop: n(40, 20),
            marginBottom: n(40, 20)
          },
          picture: {
            marginTop: n(40, 20),
            marginBottom: n(40, 20)
          },
          "picture > img": {
            marginTop: "0",
            marginBottom: "0"
          },
          video: {
            marginTop: n(40, 20),
            marginBottom: n(40, 20)
          },
          kbd: {
            fontSize: n(18, 20),
            borderRadius: r(5),
            paddingTop: n(5, 20),
            paddingInlineEnd: n(8, 20),
            paddingBottom: n(5, 20),
            paddingInlineStart: n(8, 20)
          },
          code: {
            fontSize: n(18, 20)
          },
          "h2 code": {
            fontSize: n(31, 36)
          },
          "h3 code": {
            fontSize: n(27, 30)
          },
          pre: {
            fontSize: n(18, 20),
            lineHeight: t(32 / 18),
            marginTop: n(36, 18),
            marginBottom: n(36, 18),
            borderRadius: r(8),
            paddingTop: n(20, 18),
            paddingInlineEnd: n(24, 18),
            paddingBottom: n(20, 18),
            paddingInlineStart: n(24, 18)
          },
          ol: {
            marginTop: n(24, 20),
            marginBottom: n(24, 20),
            paddingInlineStart: n(32, 20)
          },
          ul: {
            marginTop: n(24, 20),
            marginBottom: n(24, 20),
            paddingInlineStart: n(32, 20)
          },
          li: {
            marginTop: n(12, 20),
            marginBottom: n(12, 20)
          },
          "ol > li": {
            paddingInlineStart: n(8, 20)
          },
          "ul > li": {
            paddingInlineStart: n(8, 20)
          },
          "> ul > li p": {
            marginTop: n(16, 20),
            marginBottom: n(16, 20)
          },
          "> ul > li > p:first-child": {
            marginTop: n(24, 20)
          },
          "> ul > li > p:last-child": {
            marginBottom: n(24, 20)
          },
          "> ol > li > p:first-child": {
            marginTop: n(24, 20)
          },
          "> ol > li > p:last-child": {
            marginBottom: n(24, 20)
          },
          "ul ul, ul ol, ol ul, ol ol": {
            marginTop: n(16, 20),
            marginBottom: n(16, 20)
          },
          dl: {
            marginTop: n(24, 20),
            marginBottom: n(24, 20)
          },
          dt: {
            marginTop: n(24, 20)
          },
          dd: {
            marginTop: n(12, 20),
            paddingInlineStart: n(32, 20)
          },
          hr: {
            marginTop: n(56, 20),
            marginBottom: n(56, 20)
          },
          "hr + *": {
            marginTop: "0"
          },
          "h2 + *": {
            marginTop: "0"
          },
          "h3 + *": {
            marginTop: "0"
          },
          "h4 + *": {
            marginTop: "0"
          },
          table: {
            fontSize: n(18, 20),
            lineHeight: t(28 / 18)
          },
          "thead th": {
            paddingInlineEnd: n(12, 18),
            paddingBottom: n(16, 18),
            paddingInlineStart: n(12, 18)
          },
          "thead th:first-child": {
            paddingInlineStart: "0"
          },
          "thead th:last-child": {
            paddingInlineEnd: "0"
          },
          "tbody td, tfoot td": {
            paddingTop: n(16, 18),
            paddingInlineEnd: n(12, 18),
            paddingBottom: n(16, 18),
            paddingInlineStart: n(12, 18)
          },
          "tbody td:first-child, tfoot td:first-child": {
            paddingInlineStart: "0"
          },
          "tbody td:last-child, tfoot td:last-child": {
            paddingInlineEnd: "0"
          },
          figure: {
            marginTop: n(40, 20),
            marginBottom: n(40, 20)
          },
          "figure > *": {
            marginTop: "0",
            marginBottom: "0"
          },
          figcaption: {
            fontSize: n(18, 20),
            lineHeight: t(28 / 18),
            marginTop: n(18, 18)
          }
        },
        {
          "> :first-child": {
            marginTop: "0"
          },
          "> :last-child": {
            marginBottom: "0"
          }
        }
      ]
    },
    "2xl": {
      css: [
        {
          fontSize: r(24),
          lineHeight: t(40 / 24),
          p: {
            marginTop: n(32, 24),
            marginBottom: n(32, 24)
          },
          '[class~="lead"]': {
            fontSize: n(30, 24),
            lineHeight: t(44 / 30),
            marginTop: n(32, 30),
            marginBottom: n(32, 30)
          },
          blockquote: {
            marginTop: n(64, 36),
            marginBottom: n(64, 36),
            paddingInlineStart: n(40, 36)
          },
          h1: {
            fontSize: n(64, 24),
            marginTop: "0",
            marginBottom: n(56, 64),
            lineHeight: t(64 / 64)
          },
          h2: {
            fontSize: n(48, 24),
            marginTop: n(72, 48),
            marginBottom: n(40, 48),
            lineHeight: t(52 / 48)
          },
          h3: {
            fontSize: n(36, 24),
            marginTop: n(56, 36),
            marginBottom: n(24, 36),
            lineHeight: t(44 / 36)
          },
          h4: {
            marginTop: n(40, 24),
            marginBottom: n(16, 24),
            lineHeight: t(36 / 24)
          },
          img: {
            marginTop: n(48, 24),
            marginBottom: n(48, 24)
          },
          picture: {
            marginTop: n(48, 24),
            marginBottom: n(48, 24)
          },
          "picture > img": {
            marginTop: "0",
            marginBottom: "0"
          },
          video: {
            marginTop: n(48, 24),
            marginBottom: n(48, 24)
          },
          kbd: {
            fontSize: n(20, 24),
            borderRadius: r(6),
            paddingTop: n(6, 24),
            paddingInlineEnd: n(8, 24),
            paddingBottom: n(6, 24),
            paddingInlineStart: n(8, 24)
          },
          code: {
            fontSize: n(20, 24)
          },
          "h2 code": {
            fontSize: n(42, 48)
          },
          "h3 code": {
            fontSize: n(32, 36)
          },
          pre: {
            fontSize: n(20, 24),
            lineHeight: t(36 / 20),
            marginTop: n(40, 20),
            marginBottom: n(40, 20),
            borderRadius: r(8),
            paddingTop: n(24, 20),
            paddingInlineEnd: n(32, 20),
            paddingBottom: n(24, 20),
            paddingInlineStart: n(32, 20)
          },
          ol: {
            marginTop: n(32, 24),
            marginBottom: n(32, 24),
            paddingInlineStart: n(38, 24)
          },
          ul: {
            marginTop: n(32, 24),
            marginBottom: n(32, 24),
            paddingInlineStart: n(38, 24)
          },
          li: {
            marginTop: n(12, 24),
            marginBottom: n(12, 24)
          },
          "ol > li": {
            paddingInlineStart: n(10, 24)
          },
          "ul > li": {
            paddingInlineStart: n(10, 24)
          },
          "> ul > li p": {
            marginTop: n(20, 24),
            marginBottom: n(20, 24)
          },
          "> ul > li > p:first-child": {
            marginTop: n(32, 24)
          },
          "> ul > li > p:last-child": {
            marginBottom: n(32, 24)
          },
          "> ol > li > p:first-child": {
            marginTop: n(32, 24)
          },
          "> ol > li > p:last-child": {
            marginBottom: n(32, 24)
          },
          "ul ul, ul ol, ol ul, ol ol": {
            marginTop: n(16, 24),
            marginBottom: n(16, 24)
          },
          dl: {
            marginTop: n(32, 24),
            marginBottom: n(32, 24)
          },
          dt: {
            marginTop: n(32, 24)
          },
          dd: {
            marginTop: n(12, 24),
            paddingInlineStart: n(38, 24)
          },
          hr: {
            marginTop: n(72, 24),
            marginBottom: n(72, 24)
          },
          "hr + *": {
            marginTop: "0"
          },
          "h2 + *": {
            marginTop: "0"
          },
          "h3 + *": {
            marginTop: "0"
          },
          "h4 + *": {
            marginTop: "0"
          },
          table: {
            fontSize: n(20, 24),
            lineHeight: t(28 / 20)
          },
          "thead th": {
            paddingInlineEnd: n(12, 20),
            paddingBottom: n(16, 20),
            paddingInlineStart: n(12, 20)
          },
          "thead th:first-child": {
            paddingInlineStart: "0"
          },
          "thead th:last-child": {
            paddingInlineEnd: "0"
          },
          "tbody td, tfoot td": {
            paddingTop: n(16, 20),
            paddingInlineEnd: n(12, 20),
            paddingBottom: n(16, 20),
            paddingInlineStart: n(12, 20)
          },
          "tbody td:first-child, tfoot td:first-child": {
            paddingInlineStart: "0"
          },
          "tbody td:last-child, tfoot td:last-child": {
            paddingInlineEnd: "0"
          },
          figure: {
            marginTop: n(48, 24),
            marginBottom: n(48, 24)
          },
          "figure > *": {
            marginTop: "0",
            marginBottom: "0"
          },
          figcaption: {
            fontSize: n(20, 24),
            lineHeight: t(32 / 20),
            marginTop: n(20, 20)
          }
        },
        {
          "> :first-child": {
            marginTop: "0"
          },
          "> :last-child": {
            marginBottom: "0"
          }
        }
      ]
    },
    // Gray color themes
    slate: {
      css: {
        "--tw-prose-body": e.slate[700],
        "--tw-prose-headings": e.slate[900],
        "--tw-prose-lead": e.slate[600],
        "--tw-prose-links": e.slate[900],
        "--tw-prose-bold": e.slate[900],
        "--tw-prose-counters": e.slate[500],
        "--tw-prose-bullets": e.slate[300],
        "--tw-prose-hr": e.slate[200],
        "--tw-prose-quotes": e.slate[900],
        "--tw-prose-quote-borders": e.slate[200],
        "--tw-prose-captions": e.slate[500],
        "--tw-prose-kbd": e.slate[900],
        "--tw-prose-kbd-shadows": o(e.slate[900]),
        "--tw-prose-code": e.slate[900],
        "--tw-prose-pre-code": e.slate[200],
        "--tw-prose-pre-bg": e.slate[800],
        "--tw-prose-th-borders": e.slate[300],
        "--tw-prose-td-borders": e.slate[200],
        "--tw-prose-invert-body": e.slate[300],
        "--tw-prose-invert-headings": e.white,
        "--tw-prose-invert-lead": e.slate[400],
        "--tw-prose-invert-links": e.white,
        "--tw-prose-invert-bold": e.white,
        "--tw-prose-invert-counters": e.slate[400],
        "--tw-prose-invert-bullets": e.slate[600],
        "--tw-prose-invert-hr": e.slate[700],
        "--tw-prose-invert-quotes": e.slate[100],
        "--tw-prose-invert-quote-borders": e.slate[700],
        "--tw-prose-invert-captions": e.slate[400],
        "--tw-prose-invert-kbd": e.white,
        "--tw-prose-invert-kbd-shadows": o(e.white),
        "--tw-prose-invert-code": e.white,
        "--tw-prose-invert-pre-code": e.slate[300],
        "--tw-prose-invert-pre-bg": "rgb(0 0 0 / 50%)",
        "--tw-prose-invert-th-borders": e.slate[600],
        "--tw-prose-invert-td-borders": e.slate[700]
      }
    },
    gray: {
      css: {
        "--tw-prose-body": e.gray[700],
        "--tw-prose-headings": e.gray[900],
        "--tw-prose-lead": e.gray[600],
        "--tw-prose-links": e.gray[900],
        "--tw-prose-bold": e.gray[900],
        "--tw-prose-counters": e.gray[500],
        "--tw-prose-bullets": e.gray[300],
        "--tw-prose-hr": e.gray[200],
        "--tw-prose-quotes": e.gray[900],
        "--tw-prose-quote-borders": e.gray[200],
        "--tw-prose-captions": e.gray[500],
        "--tw-prose-kbd": e.gray[900],
        "--tw-prose-kbd-shadows": o(e.gray[900]),
        "--tw-prose-code": e.gray[900],
        "--tw-prose-pre-code": e.gray[200],
        "--tw-prose-pre-bg": e.gray[800],
        "--tw-prose-th-borders": e.gray[300],
        "--tw-prose-td-borders": e.gray[200],
        "--tw-prose-invert-body": e.gray[300],
        "--tw-prose-invert-headings": e.white,
        "--tw-prose-invert-lead": e.gray[400],
        "--tw-prose-invert-links": e.white,
        "--tw-prose-invert-bold": e.white,
        "--tw-prose-invert-counters": e.gray[400],
        "--tw-prose-invert-bullets": e.gray[600],
        "--tw-prose-invert-hr": e.gray[700],
        "--tw-prose-invert-quotes": e.gray[100],
        "--tw-prose-invert-quote-borders": e.gray[700],
        "--tw-prose-invert-captions": e.gray[400],
        "--tw-prose-invert-kbd": e.white,
        "--tw-prose-invert-kbd-shadows": o(e.white),
        "--tw-prose-invert-code": e.white,
        "--tw-prose-invert-pre-code": e.gray[300],
        "--tw-prose-invert-pre-bg": "rgb(0 0 0 / 50%)",
        "--tw-prose-invert-th-borders": e.gray[600],
        "--tw-prose-invert-td-borders": e.gray[700]
      }
    },
    zinc: {
      css: {
        "--tw-prose-body": e.zinc[700],
        "--tw-prose-headings": e.zinc[900],
        "--tw-prose-lead": e.zinc[600],
        "--tw-prose-links": e.zinc[900],
        "--tw-prose-bold": e.zinc[900],
        "--tw-prose-counters": e.zinc[500],
        "--tw-prose-bullets": e.zinc[300],
        "--tw-prose-hr": e.zinc[200],
        "--tw-prose-quotes": e.zinc[900],
        "--tw-prose-quote-borders": e.zinc[200],
        "--tw-prose-captions": e.zinc[500],
        "--tw-prose-kbd": e.zinc[900],
        "--tw-prose-kbd-shadows": o(e.zinc[900]),
        "--tw-prose-code": e.zinc[900],
        "--tw-prose-pre-code": e.zinc[200],
        "--tw-prose-pre-bg": e.zinc[800],
        "--tw-prose-th-borders": e.zinc[300],
        "--tw-prose-td-borders": e.zinc[200],
        "--tw-prose-invert-body": e.zinc[300],
        "--tw-prose-invert-headings": e.white,
        "--tw-prose-invert-lead": e.zinc[400],
        "--tw-prose-invert-links": e.white,
        "--tw-prose-invert-bold": e.white,
        "--tw-prose-invert-counters": e.zinc[400],
        "--tw-prose-invert-bullets": e.zinc[600],
        "--tw-prose-invert-hr": e.zinc[700],
        "--tw-prose-invert-quotes": e.zinc[100],
        "--tw-prose-invert-quote-borders": e.zinc[700],
        "--tw-prose-invert-captions": e.zinc[400],
        "--tw-prose-invert-kbd": e.white,
        "--tw-prose-invert-kbd-shadows": o(e.white),
        "--tw-prose-invert-code": e.white,
        "--tw-prose-invert-pre-code": e.zinc[300],
        "--tw-prose-invert-pre-bg": "rgb(0 0 0 / 50%)",
        "--tw-prose-invert-th-borders": e.zinc[600],
        "--tw-prose-invert-td-borders": e.zinc[700]
      }
    },
    neutral: {
      css: {
        "--tw-prose-body": e.neutral[700],
        "--tw-prose-headings": e.neutral[900],
        "--tw-prose-lead": e.neutral[600],
        "--tw-prose-links": e.neutral[900],
        "--tw-prose-bold": e.neutral[900],
        "--tw-prose-counters": e.neutral[500],
        "--tw-prose-bullets": e.neutral[300],
        "--tw-prose-hr": e.neutral[200],
        "--tw-prose-quotes": e.neutral[900],
        "--tw-prose-quote-borders": e.neutral[200],
        "--tw-prose-captions": e.neutral[500],
        "--tw-prose-kbd": e.neutral[900],
        "--tw-prose-kbd-shadows": o(e.neutral[900]),
        "--tw-prose-code": e.neutral[900],
        "--tw-prose-pre-code": e.neutral[200],
        "--tw-prose-pre-bg": e.neutral[800],
        "--tw-prose-th-borders": e.neutral[300],
        "--tw-prose-td-borders": e.neutral[200],
        "--tw-prose-invert-body": e.neutral[300],
        "--tw-prose-invert-headings": e.white,
        "--tw-prose-invert-lead": e.neutral[400],
        "--tw-prose-invert-links": e.white,
        "--tw-prose-invert-bold": e.white,
        "--tw-prose-invert-counters": e.neutral[400],
        "--tw-prose-invert-bullets": e.neutral[600],
        "--tw-prose-invert-hr": e.neutral[700],
        "--tw-prose-invert-quotes": e.neutral[100],
        "--tw-prose-invert-quote-borders": e.neutral[700],
        "--tw-prose-invert-captions": e.neutral[400],
        "--tw-prose-invert-kbd": e.white,
        "--tw-prose-invert-kbd-shadows": o(e.white),
        "--tw-prose-invert-code": e.white,
        "--tw-prose-invert-pre-code": e.neutral[300],
        "--tw-prose-invert-pre-bg": "rgb(0 0 0 / 50%)",
        "--tw-prose-invert-th-borders": e.neutral[600],
        "--tw-prose-invert-td-borders": e.neutral[700]
      }
    },
    stone: {
      css: {
        "--tw-prose-body": e.stone[700],
        "--tw-prose-headings": e.stone[900],
        "--tw-prose-lead": e.stone[600],
        "--tw-prose-links": e.stone[900],
        "--tw-prose-bold": e.stone[900],
        "--tw-prose-counters": e.stone[500],
        "--tw-prose-bullets": e.stone[300],
        "--tw-prose-hr": e.stone[200],
        "--tw-prose-quotes": e.stone[900],
        "--tw-prose-quote-borders": e.stone[200],
        "--tw-prose-captions": e.stone[500],
        "--tw-prose-kbd": e.stone[900],
        "--tw-prose-kbd-shadows": o(e.stone[900]),
        "--tw-prose-code": e.stone[900],
        "--tw-prose-pre-code": e.stone[200],
        "--tw-prose-pre-bg": e.stone[800],
        "--tw-prose-th-borders": e.stone[300],
        "--tw-prose-td-borders": e.stone[200],
        "--tw-prose-invert-body": e.stone[300],
        "--tw-prose-invert-headings": e.white,
        "--tw-prose-invert-lead": e.stone[400],
        "--tw-prose-invert-links": e.white,
        "--tw-prose-invert-bold": e.white,
        "--tw-prose-invert-counters": e.stone[400],
        "--tw-prose-invert-bullets": e.stone[600],
        "--tw-prose-invert-hr": e.stone[700],
        "--tw-prose-invert-quotes": e.stone[100],
        "--tw-prose-invert-quote-borders": e.stone[700],
        "--tw-prose-invert-captions": e.stone[400],
        "--tw-prose-invert-kbd": e.white,
        "--tw-prose-invert-kbd-shadows": o(e.white),
        "--tw-prose-invert-code": e.white,
        "--tw-prose-invert-pre-code": e.stone[300],
        "--tw-prose-invert-pre-bg": "rgb(0 0 0 / 50%)",
        "--tw-prose-invert-th-borders": e.stone[600],
        "--tw-prose-invert-td-borders": e.stone[700]
      }
    },
    // Link-only themes (for backward compatibility)
    red: {
      css: {
        "--tw-prose-links": e.red[600],
        "--tw-prose-invert-links": e.red[500]
      }
    },
    orange: {
      css: {
        "--tw-prose-links": e.orange[600],
        "--tw-prose-invert-links": e.orange[500]
      }
    },
    amber: {
      css: {
        "--tw-prose-links": e.amber[600],
        "--tw-prose-invert-links": e.amber[500]
      }
    },
    yellow: {
      css: {
        "--tw-prose-links": e.yellow[600],
        "--tw-prose-invert-links": e.yellow[500]
      }
    },
    lime: {
      css: {
        "--tw-prose-links": e.lime[600],
        "--tw-prose-invert-links": e.lime[500]
      }
    },
    green: {
      css: {
        "--tw-prose-links": e.green[600],
        "--tw-prose-invert-links": e.green[500]
      }
    },
    emerald: {
      css: {
        "--tw-prose-links": e.emerald[600],
        "--tw-prose-invert-links": e.emerald[500]
      }
    },
    teal: {
      css: {
        "--tw-prose-links": e.teal[600],
        "--tw-prose-invert-links": e.teal[500]
      }
    },
    cyan: {
      css: {
        "--tw-prose-links": e.cyan[600],
        "--tw-prose-invert-links": e.cyan[500]
      }
    },
    sky: {
      css: {
        "--tw-prose-links": e.sky[600],
        "--tw-prose-invert-links": e.sky[500]
      }
    },
    blue: {
      css: {
        "--tw-prose-links": e.blue[600],
        "--tw-prose-invert-links": e.blue[500]
      }
    },
    indigo: {
      css: {
        "--tw-prose-links": e.indigo[600],
        "--tw-prose-invert-links": e.indigo[500]
      }
    },
    violet: {
      css: {
        "--tw-prose-links": e.violet[600],
        "--tw-prose-invert-links": e.violet[500]
      }
    },
    purple: {
      css: {
        "--tw-prose-links": e.purple[600],
        "--tw-prose-invert-links": e.purple[500]
      }
    },
    fuchsia: {
      css: {
        "--tw-prose-links": e.fuchsia[600],
        "--tw-prose-invert-links": e.fuchsia[500]
      }
    },
    pink: {
      css: {
        "--tw-prose-links": e.pink[600],
        "--tw-prose-invert-links": e.pink[500]
      }
    },
    rose: {
      css: {
        "--tw-prose-links": e.rose[600],
        "--tw-prose-invert-links": e.rose[500]
      }
    },
    // Invert (for dark mode)
    invert: {
      css: {
        "--tw-prose-body": "var(--tw-prose-invert-body)",
        "--tw-prose-headings": "var(--tw-prose-invert-headings)",
        "--tw-prose-lead": "var(--tw-prose-invert-lead)",
        "--tw-prose-links": "var(--tw-prose-invert-links)",
        "--tw-prose-bold": "var(--tw-prose-invert-bold)",
        "--tw-prose-counters": "var(--tw-prose-invert-counters)",
        "--tw-prose-bullets": "var(--tw-prose-invert-bullets)",
        "--tw-prose-hr": "var(--tw-prose-invert-hr)",
        "--tw-prose-quotes": "var(--tw-prose-invert-quotes)",
        "--tw-prose-quote-borders": "var(--tw-prose-invert-quote-borders)",
        "--tw-prose-captions": "var(--tw-prose-invert-captions)",
        "--tw-prose-kbd": "var(--tw-prose-invert-kbd)",
        "--tw-prose-kbd-shadows": "var(--tw-prose-invert-kbd-shadows)",
        "--tw-prose-code": "var(--tw-prose-invert-code)",
        "--tw-prose-pre-code": "var(--tw-prose-invert-pre-code)",
        "--tw-prose-pre-bg": "var(--tw-prose-invert-pre-bg)",
        "--tw-prose-th-borders": "var(--tw-prose-invert-th-borders)",
        "--tw-prose-td-borders": "var(--tw-prose-invert-td-borders)"
      }
    }
  };
  return Fl = {
    DEFAULT: {
      css: [
        {
          color: "var(--tw-prose-body)",
          maxWidth: "65ch",
          p: {},
          // Required to maintain correct order when merging
          '[class~="lead"]': {
            color: "var(--tw-prose-lead)"
          },
          a: {
            color: "var(--tw-prose-links)",
            textDecoration: "underline",
            fontWeight: "500"
          },
          strong: {
            color: "var(--tw-prose-bold)",
            fontWeight: "600"
          },
          "a strong": {
            color: "inherit"
          },
          "blockquote strong": {
            color: "inherit"
          },
          "thead th strong": {
            color: "inherit"
          },
          ol: {
            listStyleType: "decimal"
          },
          'ol[type="A"]': {
            listStyleType: "upper-alpha"
          },
          'ol[type="a"]': {
            listStyleType: "lower-alpha"
          },
          'ol[type="A" s]': {
            listStyleType: "upper-alpha"
          },
          'ol[type="a" s]': {
            listStyleType: "lower-alpha"
          },
          'ol[type="I"]': {
            listStyleType: "upper-roman"
          },
          'ol[type="i"]': {
            listStyleType: "lower-roman"
          },
          'ol[type="I" s]': {
            listStyleType: "upper-roman"
          },
          'ol[type="i" s]': {
            listStyleType: "lower-roman"
          },
          'ol[type="1"]': {
            listStyleType: "decimal"
          },
          ul: {
            listStyleType: "disc"
          },
          "ol > li::marker": {
            fontWeight: "400",
            color: "var(--tw-prose-counters)"
          },
          "ul > li::marker": {
            color: "var(--tw-prose-bullets)"
          },
          dt: {
            color: "var(--tw-prose-headings)",
            fontWeight: "600"
          },
          hr: {
            borderColor: "var(--tw-prose-hr)",
            borderTopWidth: 1
          },
          blockquote: {
            fontWeight: "500",
            fontStyle: "italic",
            color: "var(--tw-prose-quotes)",
            borderInlineStartWidth: "0.25rem",
            borderInlineStartColor: "var(--tw-prose-quote-borders)",
            quotes: '"\\201C""\\201D""\\2018""\\2019"'
          },
          "blockquote p:first-of-type::before": {
            content: "open-quote"
          },
          "blockquote p:last-of-type::after": {
            content: "close-quote"
          },
          h1: {
            color: "var(--tw-prose-headings)",
            fontWeight: "800"
          },
          "h1 strong": {
            fontWeight: "900",
            color: "inherit"
          },
          h2: {
            color: "var(--tw-prose-headings)",
            fontWeight: "700"
          },
          "h2 strong": {
            fontWeight: "800",
            color: "inherit"
          },
          h3: {
            color: "var(--tw-prose-headings)",
            fontWeight: "600"
          },
          "h3 strong": {
            fontWeight: "700",
            color: "inherit"
          },
          h4: {
            color: "var(--tw-prose-headings)",
            fontWeight: "600"
          },
          "h4 strong": {
            fontWeight: "700",
            color: "inherit"
          },
          img: {},
          // Required to maintain correct order when merging
          picture: {
            display: "block"
          },
          video: {},
          // Required to maintain correct order when merging
          kbd: {
            fontWeight: "500",
            fontFamily: "inherit",
            color: "var(--tw-prose-kbd)",
            boxShadow: "0 0 0 1px rgb(var(--tw-prose-kbd-shadows) / 10%), 0 3px 0 rgb(var(--tw-prose-kbd-shadows) / 10%)"
          },
          code: {
            color: "var(--tw-prose-code)",
            fontWeight: "600"
          },
          "code::before": {
            content: '"`"'
          },
          "code::after": {
            content: '"`"'
          },
          "a code": {
            color: "inherit"
          },
          "h1 code": {
            color: "inherit"
          },
          "h2 code": {
            color: "inherit"
          },
          "h3 code": {
            color: "inherit"
          },
          "h4 code": {
            color: "inherit"
          },
          "blockquote code": {
            color: "inherit"
          },
          "thead th code": {
            color: "inherit"
          },
          pre: {
            color: "var(--tw-prose-pre-code)",
            backgroundColor: "var(--tw-prose-pre-bg)",
            overflowX: "auto",
            fontWeight: "400"
          },
          "pre code": {
            backgroundColor: "transparent",
            borderWidth: "0",
            borderRadius: "0",
            padding: "0",
            fontWeight: "inherit",
            color: "inherit",
            fontSize: "inherit",
            fontFamily: "inherit",
            lineHeight: "inherit"
          },
          "pre code::before": {
            content: "none"
          },
          "pre code::after": {
            content: "none"
          },
          table: {
            width: "100%",
            tableLayout: "auto",
            marginTop: n(32, 16),
            marginBottom: n(32, 16)
          },
          thead: {
            borderBottomWidth: "1px",
            borderBottomColor: "var(--tw-prose-th-borders)"
          },
          "thead th": {
            color: "var(--tw-prose-headings)",
            fontWeight: "600",
            verticalAlign: "bottom"
          },
          "tbody tr": {
            borderBottomWidth: "1px",
            borderBottomColor: "var(--tw-prose-td-borders)"
          },
          "tbody tr:last-child": {
            borderBottomWidth: "0"
          },
          "tbody td": {
            verticalAlign: "baseline"
          },
          tfoot: {
            borderTopWidth: "1px",
            borderTopColor: "var(--tw-prose-th-borders)"
          },
          "tfoot td": {
            verticalAlign: "top"
          },
          "th, td": {
            textAlign: "start"
          },
          "figure > *": {},
          // Required to maintain correct order when merging
          figcaption: {
            color: "var(--tw-prose-captions)"
          }
        },
        a.gray.css,
        ...a.base.css
      ]
    },
    ...a
  }, Fl;
}
var Nl, Lh;
function D_() {
  if (Lh) return Nl;
  Lh = 1;
  var e = "[object Object]";
  function t(h) {
    var y = !1;
    if (h != null && typeof h.toString != "function")
      try {
        y = !!(h + "");
      } catch {
      }
    return y;
  }
  function r(h, y) {
    return function(m) {
      return h(y(m));
    };
  }
  var n = Function.prototype, o = Object.prototype, a = n.toString, i = o.hasOwnProperty, s = a.call(Object), l = o.toString, u = r(Object.getPrototypeOf, Object);
  function c(h) {
    return !!h && typeof h == "object";
  }
  function d(h) {
    if (!c(h) || l.call(h) != e || t(h))
      return !1;
    var y = u(h);
    if (y === null)
      return !0;
    var m = i.call(y, "constructor") && y.constructor;
    return typeof m == "function" && m instanceof m && a.call(m) == s;
  }
  return Nl = d, Nl;
}
var Sa = { exports: {} }, xa = { exports: {} }, Aa = { exports: {} }, Ta = { exports: {} }, Ea = { exports: {} }, Oa = { exports: {} }, Lr = {}, $a = { exports: {} }, Fh;
function W0() {
  return Fh || (Fh = 1, function(e, t) {
    t.__esModule = !0, t.default = o;
    function r(a) {
      for (var i = a.toLowerCase(), s = "", l = !1, u = 0; u < 6 && i[u] !== void 0; u++) {
        var c = i.charCodeAt(u), d = c >= 97 && c <= 102 || c >= 48 && c <= 57;
        if (l = c === 32, !d)
          break;
        s += i[u];
      }
      if (s.length !== 0) {
        var h = parseInt(s, 16), y = h >= 55296 && h <= 57343;
        return y || h === 0 || h > 1114111 ? ["�", s.length + (l ? 1 : 0)] : [String.fromCodePoint(h), s.length + (l ? 1 : 0)];
      }
    }
    var n = /\\/;
    function o(a) {
      var i = n.test(a);
      if (!i)
        return a;
      for (var s = "", l = 0; l < a.length; l++) {
        if (a[l] === "\\") {
          var u = r(a.slice(l + 1, l + 7));
          if (u !== void 0) {
            s += u[0], l += u[1];
            continue;
          }
          if (a[l + 1] === "\\") {
            s += "\\", l++;
            continue;
          }
          a.length === l + 1 && (s += a[l]);
          continue;
        }
        s += a[l];
      }
      return s;
    }
    e.exports = t.default;
  }($a, $a.exports)), $a.exports;
}
var Ca = { exports: {} }, Nh;
function R_() {
  return Nh || (Nh = 1, function(e, t) {
    t.__esModule = !0, t.default = r;
    function r(n) {
      for (var o = arguments.length, a = new Array(o > 1 ? o - 1 : 0), i = 1; i < o; i++)
        a[i - 1] = arguments[i];
      for (; a.length > 0; ) {
        var s = a.shift();
        if (!n[s])
          return;
        n = n[s];
      }
      return n;
    }
    e.exports = t.default;
  }(Ca, Ca.exports)), Ca.exports;
}
var ka = { exports: {} }, zh;
function M_() {
  return zh || (zh = 1, function(e, t) {
    t.__esModule = !0, t.default = r;
    function r(n) {
      for (var o = arguments.length, a = new Array(o > 1 ? o - 1 : 0), i = 1; i < o; i++)
        a[i - 1] = arguments[i];
      for (; a.length > 0; ) {
        var s = a.shift();
        n[s] || (n[s] = {}), n = n[s];
      }
    }
    e.exports = t.default;
  }(ka, ka.exports)), ka.exports;
}
var Pa = { exports: {} }, jh;
function B_() {
  return jh || (jh = 1, function(e, t) {
    t.__esModule = !0, t.default = r;
    function r(n) {
      for (var o = "", a = n.indexOf("/*"), i = 0; a >= 0; ) {
        o = o + n.slice(i, a);
        var s = n.indexOf("*/", a + 2);
        if (s < 0)
          return o;
        i = s + 2, a = n.indexOf("/*", i);
      }
      return o = o + n.slice(i), o;
    }
    e.exports = t.default;
  }(Pa, Pa.exports)), Pa.exports;
}
var Uh;
function Ls() {
  if (Uh) return Lr;
  Uh = 1, Lr.__esModule = !0, Lr.stripComments = Lr.ensureObject = Lr.getProp = Lr.unesc = void 0;
  var e = o(W0());
  Lr.unesc = e.default;
  var t = o(R_());
  Lr.getProp = t.default;
  var r = o(M_());
  Lr.ensureObject = r.default;
  var n = o(B_());
  Lr.stripComments = n.default;
  function o(a) {
    return a && a.__esModule ? a : { default: a };
  }
  return Lr;
}
var Wh;
function to() {
  return Wh || (Wh = 1, function(e, t) {
    t.__esModule = !0, t.default = void 0;
    var r = Ls();
    function n(s, l) {
      for (var u = 0; u < l.length; u++) {
        var c = l[u];
        c.enumerable = c.enumerable || !1, c.configurable = !0, "value" in c && (c.writable = !0), Object.defineProperty(s, c.key, c);
      }
    }
    function o(s, l, u) {
      return l && n(s.prototype, l), s;
    }
    var a = function s(l, u) {
      if (typeof l != "object" || l === null)
        return l;
      var c = new l.constructor();
      for (var d in l)
        if (l.hasOwnProperty(d)) {
          var h = l[d], y = typeof h;
          d === "parent" && y === "object" ? u && (c[d] = u) : h instanceof Array ? c[d] = h.map(function(m) {
            return s(m, c);
          }) : c[d] = s(h, c);
        }
      return c;
    }, i = /* @__PURE__ */ function() {
      function s(u) {
        u === void 0 && (u = {}), Object.assign(this, u), this.spaces = this.spaces || {}, this.spaces.before = this.spaces.before || "", this.spaces.after = this.spaces.after || "";
      }
      var l = s.prototype;
      return l.remove = function() {
        return this.parent && this.parent.removeChild(this), this.parent = void 0, this;
      }, l.replaceWith = function() {
        if (this.parent) {
          for (var c in arguments)
            this.parent.insertBefore(this, arguments[c]);
          this.remove();
        }
        return this;
      }, l.next = function() {
        return this.parent.at(this.parent.index(this) + 1);
      }, l.prev = function() {
        return this.parent.at(this.parent.index(this) - 1);
      }, l.clone = function(c) {
        c === void 0 && (c = {});
        var d = a(this);
        for (var h in c)
          d[h] = c[h];
        return d;
      }, l.appendToPropertyAndEscape = function(c, d, h) {
        this.raws || (this.raws = {});
        var y = this[c], m = this.raws[c];
        this[c] = y + d, m || h !== d ? this.raws[c] = (m || y) + h : delete this.raws[c];
      }, l.setPropertyAndEscape = function(c, d, h) {
        this.raws || (this.raws = {}), this[c] = d, this.raws[c] = h;
      }, l.setPropertyWithoutEscape = function(c, d) {
        this[c] = d, this.raws && delete this.raws[c];
      }, l.isAtPosition = function(c, d) {
        if (this.source && this.source.start && this.source.end)
          return !(this.source.start.line > c || this.source.end.line < c || this.source.start.line === c && this.source.start.column > d || this.source.end.line === c && this.source.end.column < d);
      }, l.stringifyProperty = function(c) {
        return this.raws && this.raws[c] || this[c];
      }, l.valueToString = function() {
        return String(this.stringifyProperty("value"));
      }, l.toString = function() {
        return [this.rawSpaceBefore, this.valueToString(), this.rawSpaceAfter].join("");
      }, o(s, [{
        key: "rawSpaceBefore",
        get: function() {
          var c = this.raws && this.raws.spaces && this.raws.spaces.before;
          return c === void 0 && (c = this.spaces && this.spaces.before), c || "";
        },
        set: function(c) {
          (0, r.ensureObject)(this, "raws", "spaces"), this.raws.spaces.before = c;
        }
      }, {
        key: "rawSpaceAfter",
        get: function() {
          var c = this.raws && this.raws.spaces && this.raws.spaces.after;
          return c === void 0 && (c = this.spaces.after), c || "";
        },
        set: function(c) {
          (0, r.ensureObject)(this, "raws", "spaces"), this.raws.spaces.after = c;
        }
      }]), s;
    }();
    t.default = i, e.exports = t.default;
  }(Oa, Oa.exports)), Oa.exports;
}
var Ze = {}, Vh;
function Kt() {
  if (Vh) return Ze;
  Vh = 1, Ze.__esModule = !0, Ze.UNIVERSAL = Ze.ATTRIBUTE = Ze.CLASS = Ze.COMBINATOR = Ze.COMMENT = Ze.ID = Ze.NESTING = Ze.PSEUDO = Ze.ROOT = Ze.SELECTOR = Ze.STRING = Ze.TAG = void 0;
  var e = "tag";
  Ze.TAG = e;
  var t = "string";
  Ze.STRING = t;
  var r = "selector";
  Ze.SELECTOR = r;
  var n = "root";
  Ze.ROOT = n;
  var o = "pseudo";
  Ze.PSEUDO = o;
  var a = "nesting";
  Ze.NESTING = a;
  var i = "id";
  Ze.ID = i;
  var s = "comment";
  Ze.COMMENT = s;
  var l = "combinator";
  Ze.COMBINATOR = l;
  var u = "class";
  Ze.CLASS = u;
  var c = "attribute";
  Ze.ATTRIBUTE = c;
  var d = "universal";
  return Ze.UNIVERSAL = d, Ze;
}
var Hh;
function pp() {
  return Hh || (Hh = 1, function(e, t) {
    t.__esModule = !0, t.default = void 0;
    var r = i(to()), n = a(Kt());
    function o() {
      if (typeof WeakMap != "function") return null;
      var p = /* @__PURE__ */ new WeakMap();
      return o = function() {
        return p;
      }, p;
    }
    function a(p) {
      if (p && p.__esModule)
        return p;
      if (p === null || typeof p != "object" && typeof p != "function")
        return { default: p };
      var f = o();
      if (f && f.has(p))
        return f.get(p);
      var v = {}, w = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var _ in p)
        if (Object.prototype.hasOwnProperty.call(p, _)) {
          var T = w ? Object.getOwnPropertyDescriptor(p, _) : null;
          T && (T.get || T.set) ? Object.defineProperty(v, _, T) : v[_] = p[_];
        }
      return v.default = p, f && f.set(p, v), v;
    }
    function i(p) {
      return p && p.__esModule ? p : { default: p };
    }
    function s(p, f) {
      var v;
      if (typeof Symbol > "u" || p[Symbol.iterator] == null) {
        if (Array.isArray(p) || (v = l(p)) || f) {
          v && (p = v);
          var w = 0;
          return function() {
            return w >= p.length ? { done: !0 } : { done: !1, value: p[w++] };
          };
        }
        throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
      }
      return v = p[Symbol.iterator](), v.next.bind(v);
    }
    function l(p, f) {
      if (p) {
        if (typeof p == "string") return u(p, f);
        var v = Object.prototype.toString.call(p).slice(8, -1);
        if (v === "Object" && p.constructor && (v = p.constructor.name), v === "Map" || v === "Set") return Array.from(p);
        if (v === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(v)) return u(p, f);
      }
    }
    function u(p, f) {
      (f == null || f > p.length) && (f = p.length);
      for (var v = 0, w = new Array(f); v < f; v++)
        w[v] = p[v];
      return w;
    }
    function c(p, f) {
      for (var v = 0; v < f.length; v++) {
        var w = f[v];
        w.enumerable = w.enumerable || !1, w.configurable = !0, "value" in w && (w.writable = !0), Object.defineProperty(p, w.key, w);
      }
    }
    function d(p, f, v) {
      return f && c(p.prototype, f), p;
    }
    function h(p, f) {
      p.prototype = Object.create(f.prototype), p.prototype.constructor = p, y(p, f);
    }
    function y(p, f) {
      return y = Object.setPrototypeOf || function(w, _) {
        return w.__proto__ = _, w;
      }, y(p, f);
    }
    var m = /* @__PURE__ */ function(p) {
      h(f, p);
      function f(w) {
        var _;
        return _ = p.call(this, w) || this, _.nodes || (_.nodes = []), _;
      }
      var v = f.prototype;
      return v.append = function(_) {
        return _.parent = this, this.nodes.push(_), this;
      }, v.prepend = function(_) {
        return _.parent = this, this.nodes.unshift(_), this;
      }, v.at = function(_) {
        return this.nodes[_];
      }, v.index = function(_) {
        return typeof _ == "number" ? _ : this.nodes.indexOf(_);
      }, v.removeChild = function(_) {
        _ = this.index(_), this.at(_).parent = void 0, this.nodes.splice(_, 1);
        var T;
        for (var A in this.indexes)
          T = this.indexes[A], T >= _ && (this.indexes[A] = T - 1);
        return this;
      }, v.removeAll = function() {
        for (var _ = s(this.nodes), T; !(T = _()).done; ) {
          var A = T.value;
          A.parent = void 0;
        }
        return this.nodes = [], this;
      }, v.empty = function() {
        return this.removeAll();
      }, v.insertAfter = function(_, T) {
        T.parent = this;
        var A = this.index(_);
        this.nodes.splice(A + 1, 0, T), T.parent = this;
        var O;
        for (var M in this.indexes)
          O = this.indexes[M], A <= O && (this.indexes[M] = O + 1);
        return this;
      }, v.insertBefore = function(_, T) {
        T.parent = this;
        var A = this.index(_);
        this.nodes.splice(A, 0, T), T.parent = this;
        var O;
        for (var M in this.indexes)
          O = this.indexes[M], O <= A && (this.indexes[M] = O + 1);
        return this;
      }, v._findChildAtPosition = function(_, T) {
        var A = void 0;
        return this.each(function(O) {
          if (O.atPosition) {
            var M = O.atPosition(_, T);
            if (M)
              return A = M, !1;
          } else if (O.isAtPosition(_, T))
            return A = O, !1;
        }), A;
      }, v.atPosition = function(_, T) {
        if (this.isAtPosition(_, T))
          return this._findChildAtPosition(_, T) || this;
      }, v._inferEndPosition = function() {
        this.last && this.last.source && this.last.source.end && (this.source = this.source || {}, this.source.end = this.source.end || {}, Object.assign(this.source.end, this.last.source.end));
      }, v.each = function(_) {
        this.lastEach || (this.lastEach = 0), this.indexes || (this.indexes = {}), this.lastEach++;
        var T = this.lastEach;
        if (this.indexes[T] = 0, !!this.length) {
          for (var A, O; this.indexes[T] < this.length && (A = this.indexes[T], O = _(this.at(A), A), O !== !1); )
            this.indexes[T] += 1;
          if (delete this.indexes[T], O === !1)
            return !1;
        }
      }, v.walk = function(_) {
        return this.each(function(T, A) {
          var O = _(T, A);
          if (O !== !1 && T.length && (O = T.walk(_)), O === !1)
            return !1;
        });
      }, v.walkAttributes = function(_) {
        var T = this;
        return this.walk(function(A) {
          if (A.type === n.ATTRIBUTE)
            return _.call(T, A);
        });
      }, v.walkClasses = function(_) {
        var T = this;
        return this.walk(function(A) {
          if (A.type === n.CLASS)
            return _.call(T, A);
        });
      }, v.walkCombinators = function(_) {
        var T = this;
        return this.walk(function(A) {
          if (A.type === n.COMBINATOR)
            return _.call(T, A);
        });
      }, v.walkComments = function(_) {
        var T = this;
        return this.walk(function(A) {
          if (A.type === n.COMMENT)
            return _.call(T, A);
        });
      }, v.walkIds = function(_) {
        var T = this;
        return this.walk(function(A) {
          if (A.type === n.ID)
            return _.call(T, A);
        });
      }, v.walkNesting = function(_) {
        var T = this;
        return this.walk(function(A) {
          if (A.type === n.NESTING)
            return _.call(T, A);
        });
      }, v.walkPseudos = function(_) {
        var T = this;
        return this.walk(function(A) {
          if (A.type === n.PSEUDO)
            return _.call(T, A);
        });
      }, v.walkTags = function(_) {
        var T = this;
        return this.walk(function(A) {
          if (A.type === n.TAG)
            return _.call(T, A);
        });
      }, v.walkUniversals = function(_) {
        var T = this;
        return this.walk(function(A) {
          if (A.type === n.UNIVERSAL)
            return _.call(T, A);
        });
      }, v.split = function(_) {
        var T = this, A = [];
        return this.reduce(function(O, M, I) {
          var C = _.call(T, M);
          return A.push(M), C ? (O.push(A), A = []) : I === T.length - 1 && O.push(A), O;
        }, []);
      }, v.map = function(_) {
        return this.nodes.map(_);
      }, v.reduce = function(_, T) {
        return this.nodes.reduce(_, T);
      }, v.every = function(_) {
        return this.nodes.every(_);
      }, v.some = function(_) {
        return this.nodes.some(_);
      }, v.filter = function(_) {
        return this.nodes.filter(_);
      }, v.sort = function(_) {
        return this.nodes.sort(_);
      }, v.toString = function() {
        return this.map(String).join("");
      }, d(f, [{
        key: "first",
        get: function() {
          return this.at(0);
        }
      }, {
        key: "last",
        get: function() {
          return this.at(this.length - 1);
        }
      }, {
        key: "length",
        get: function() {
          return this.nodes.length;
        }
      }]), f;
    }(r.default);
    t.default = m, e.exports = t.default;
  }(Ea, Ea.exports)), Ea.exports;
}
var Gh;
function V0() {
  return Gh || (Gh = 1, function(e, t) {
    t.__esModule = !0, t.default = void 0;
    var r = o(pp()), n = Kt();
    function o(c) {
      return c && c.__esModule ? c : { default: c };
    }
    function a(c, d) {
      for (var h = 0; h < d.length; h++) {
        var y = d[h];
        y.enumerable = y.enumerable || !1, y.configurable = !0, "value" in y && (y.writable = !0), Object.defineProperty(c, y.key, y);
      }
    }
    function i(c, d, h) {
      return d && a(c.prototype, d), c;
    }
    function s(c, d) {
      c.prototype = Object.create(d.prototype), c.prototype.constructor = c, l(c, d);
    }
    function l(c, d) {
      return l = Object.setPrototypeOf || function(y, m) {
        return y.__proto__ = m, y;
      }, l(c, d);
    }
    var u = /* @__PURE__ */ function(c) {
      s(d, c);
      function d(y) {
        var m;
        return m = c.call(this, y) || this, m.type = n.ROOT, m;
      }
      var h = d.prototype;
      return h.toString = function() {
        var m = this.reduce(function(p, f) {
          return p.push(String(f)), p;
        }, []).join(",");
        return this.trailingComma ? m + "," : m;
      }, h.error = function(m, p) {
        return this._error ? this._error(m, p) : new Error(m);
      }, i(d, [{
        key: "errorGenerator",
        set: function(m) {
          this._error = m;
        }
      }]), d;
    }(r.default);
    t.default = u, e.exports = t.default;
  }(Ta, Ta.exports)), Ta.exports;
}
var Ia = { exports: {} }, Kh;
function H0() {
  return Kh || (Kh = 1, function(e, t) {
    t.__esModule = !0, t.default = void 0;
    var r = o(pp()), n = Kt();
    function o(l) {
      return l && l.__esModule ? l : { default: l };
    }
    function a(l, u) {
      l.prototype = Object.create(u.prototype), l.prototype.constructor = l, i(l, u);
    }
    function i(l, u) {
      return i = Object.setPrototypeOf || function(d, h) {
        return d.__proto__ = h, d;
      }, i(l, u);
    }
    var s = /* @__PURE__ */ function(l) {
      a(u, l);
      function u(c) {
        var d;
        return d = l.call(this, c) || this, d.type = n.SELECTOR, d;
      }
      return u;
    }(r.default);
    t.default = s, e.exports = t.default;
  }(Ia, Ia.exports)), Ia.exports;
}
var Da = { exports: {} };
/*! https://mths.be/cssesc v3.0.0 by @mathias */
var zl, Yh;
function hp() {
  if (Yh) return zl;
  Yh = 1;
  var e = {}, t = e.hasOwnProperty, r = function(l, u) {
    if (!l)
      return u;
    var c = {};
    for (var d in u)
      c[d] = t.call(l, d) ? l[d] : u[d];
    return c;
  }, n = /[ -,\.\/:-@\[-\^`\{-~]/, o = /[ -,\.\/:-@\[\]\^`\{-~]/, a = /(^|\\+)?(\\[A-F0-9]{1,6})\x20(?![a-fA-F0-9\x20])/g, i = function s(l, u) {
    u = r(u, s.options), u.quotes != "single" && u.quotes != "double" && (u.quotes = "single");
    for (var c = u.quotes == "double" ? '"' : "'", d = u.isIdentifier, h = l.charAt(0), y = "", m = 0, p = l.length; m < p; ) {
      var f = l.charAt(m++), v = f.charCodeAt(), w = void 0;
      if (v < 32 || v > 126) {
        if (v >= 55296 && v <= 56319 && m < p) {
          var _ = l.charCodeAt(m++);
          (_ & 64512) == 56320 ? v = ((v & 1023) << 10) + (_ & 1023) + 65536 : m--;
        }
        w = "\\" + v.toString(16).toUpperCase() + " ";
      } else
        u.escapeEverything ? n.test(f) ? w = "\\" + f : w = "\\" + v.toString(16).toUpperCase() + " " : /[\t\n\f\r\x0B]/.test(f) ? w = "\\" + v.toString(16).toUpperCase() + " " : f == "\\" || !d && (f == '"' && c == f || f == "'" && c == f) || d && o.test(f) ? w = "\\" + f : w = f;
      y += w;
    }
    return d && (/^-[-\d]/.test(y) ? y = "\\-" + y.slice(1) : /\d/.test(h) && (y = "\\3" + h + " " + y.slice(1))), y = y.replace(a, function(T, A, O) {
      return A && A.length % 2 ? T : (A || "") + O;
    }), !d && u.wrap ? c + y + c : y;
  };
  return i.options = {
    escapeEverything: !1,
    isIdentifier: !1,
    quotes: "single",
    wrap: !1
  }, i.version = "3.0.0", zl = i, zl;
}
var Jh;
function G0() {
  return Jh || (Jh = 1, function(e, t) {
    t.__esModule = !0, t.default = void 0;
    var r = i(hp()), n = Ls(), o = i(to()), a = Kt();
    function i(h) {
      return h && h.__esModule ? h : { default: h };
    }
    function s(h, y) {
      for (var m = 0; m < y.length; m++) {
        var p = y[m];
        p.enumerable = p.enumerable || !1, p.configurable = !0, "value" in p && (p.writable = !0), Object.defineProperty(h, p.key, p);
      }
    }
    function l(h, y, m) {
      return y && s(h.prototype, y), h;
    }
    function u(h, y) {
      h.prototype = Object.create(y.prototype), h.prototype.constructor = h, c(h, y);
    }
    function c(h, y) {
      return c = Object.setPrototypeOf || function(p, f) {
        return p.__proto__ = f, p;
      }, c(h, y);
    }
    var d = /* @__PURE__ */ function(h) {
      u(y, h);
      function y(p) {
        var f;
        return f = h.call(this, p) || this, f.type = a.CLASS, f._constructed = !0, f;
      }
      var m = y.prototype;
      return m.valueToString = function() {
        return "." + h.prototype.valueToString.call(this);
      }, l(y, [{
        key: "value",
        get: function() {
          return this._value;
        },
        set: function(f) {
          if (this._constructed) {
            var v = (0, r.default)(f, {
              isIdentifier: !0
            });
            v !== f ? ((0, n.ensureObject)(this, "raws"), this.raws.value = v) : this.raws && delete this.raws.value;
          }
          this._value = f;
        }
      }]), y;
    }(o.default);
    t.default = d, e.exports = t.default;
  }(Da, Da.exports)), Da.exports;
}
var Ra = { exports: {} }, Zh;
function K0() {
  return Zh || (Zh = 1, function(e, t) {
    t.__esModule = !0, t.default = void 0;
    var r = o(to()), n = Kt();
    function o(l) {
      return l && l.__esModule ? l : { default: l };
    }
    function a(l, u) {
      l.prototype = Object.create(u.prototype), l.prototype.constructor = l, i(l, u);
    }
    function i(l, u) {
      return i = Object.setPrototypeOf || function(d, h) {
        return d.__proto__ = h, d;
      }, i(l, u);
    }
    var s = /* @__PURE__ */ function(l) {
      a(u, l);
      function u(c) {
        var d;
        return d = l.call(this, c) || this, d.type = n.COMMENT, d;
      }
      return u;
    }(r.default);
    t.default = s, e.exports = t.default;
  }(Ra, Ra.exports)), Ra.exports;
}
var Ma = { exports: {} }, Xh;
function Y0() {
  return Xh || (Xh = 1, function(e, t) {
    t.__esModule = !0, t.default = void 0;
    var r = o(to()), n = Kt();
    function o(l) {
      return l && l.__esModule ? l : { default: l };
    }
    function a(l, u) {
      l.prototype = Object.create(u.prototype), l.prototype.constructor = l, i(l, u);
    }
    function i(l, u) {
      return i = Object.setPrototypeOf || function(d, h) {
        return d.__proto__ = h, d;
      }, i(l, u);
    }
    var s = /* @__PURE__ */ function(l) {
      a(u, l);
      function u(d) {
        var h;
        return h = l.call(this, d) || this, h.type = n.ID, h;
      }
      var c = u.prototype;
      return c.valueToString = function() {
        return "#" + l.prototype.valueToString.call(this);
      }, u;
    }(r.default);
    t.default = s, e.exports = t.default;
  }(Ma, Ma.exports)), Ma.exports;
}
var Ba = { exports: {} }, qa = { exports: {} }, Qh;
function mp() {
  return Qh || (Qh = 1, function(e, t) {
    t.__esModule = !0, t.default = void 0;
    var r = a(hp()), n = Ls(), o = a(to());
    function a(d) {
      return d && d.__esModule ? d : { default: d };
    }
    function i(d, h) {
      for (var y = 0; y < h.length; y++) {
        var m = h[y];
        m.enumerable = m.enumerable || !1, m.configurable = !0, "value" in m && (m.writable = !0), Object.defineProperty(d, m.key, m);
      }
    }
    function s(d, h, y) {
      return h && i(d.prototype, h), d;
    }
    function l(d, h) {
      d.prototype = Object.create(h.prototype), d.prototype.constructor = d, u(d, h);
    }
    function u(d, h) {
      return u = Object.setPrototypeOf || function(m, p) {
        return m.__proto__ = p, m;
      }, u(d, h);
    }
    var c = /* @__PURE__ */ function(d) {
      l(h, d);
      function h() {
        return d.apply(this, arguments) || this;
      }
      var y = h.prototype;
      return y.qualifiedName = function(p) {
        return this.namespace ? this.namespaceString + "|" + p : p;
      }, y.valueToString = function() {
        return this.qualifiedName(d.prototype.valueToString.call(this));
      }, s(h, [{
        key: "namespace",
        get: function() {
          return this._namespace;
        },
        set: function(p) {
          if (p === !0 || p === "*" || p === "&") {
            this._namespace = p, this.raws && delete this.raws.namespace;
            return;
          }
          var f = (0, r.default)(p, {
            isIdentifier: !0
          });
          this._namespace = p, f !== p ? ((0, n.ensureObject)(this, "raws"), this.raws.namespace = f) : this.raws && delete this.raws.namespace;
        }
      }, {
        key: "ns",
        get: function() {
          return this._namespace;
        },
        set: function(p) {
          this.namespace = p;
        }
      }, {
        key: "namespaceString",
        get: function() {
          if (this.namespace) {
            var p = this.stringifyProperty("namespace");
            return p === !0 ? "" : p;
          } else
            return "";
        }
      }]), h;
    }(o.default);
    t.default = c, e.exports = t.default;
  }(qa, qa.exports)), qa.exports;
}
var em;
function J0() {
  return em || (em = 1, function(e, t) {
    t.__esModule = !0, t.default = void 0;
    var r = o(mp()), n = Kt();
    function o(l) {
      return l && l.__esModule ? l : { default: l };
    }
    function a(l, u) {
      l.prototype = Object.create(u.prototype), l.prototype.constructor = l, i(l, u);
    }
    function i(l, u) {
      return i = Object.setPrototypeOf || function(d, h) {
        return d.__proto__ = h, d;
      }, i(l, u);
    }
    var s = /* @__PURE__ */ function(l) {
      a(u, l);
      function u(c) {
        var d;
        return d = l.call(this, c) || this, d.type = n.TAG, d;
      }
      return u;
    }(r.default);
    t.default = s, e.exports = t.default;
  }(Ba, Ba.exports)), Ba.exports;
}
var La = { exports: {} }, tm;
function Z0() {
  return tm || (tm = 1, function(e, t) {
    t.__esModule = !0, t.default = void 0;
    var r = o(to()), n = Kt();
    function o(l) {
      return l && l.__esModule ? l : { default: l };
    }
    function a(l, u) {
      l.prototype = Object.create(u.prototype), l.prototype.constructor = l, i(l, u);
    }
    function i(l, u) {
      return i = Object.setPrototypeOf || function(d, h) {
        return d.__proto__ = h, d;
      }, i(l, u);
    }
    var s = /* @__PURE__ */ function(l) {
      a(u, l);
      function u(c) {
        var d;
        return d = l.call(this, c) || this, d.type = n.STRING, d;
      }
      return u;
    }(r.default);
    t.default = s, e.exports = t.default;
  }(La, La.exports)), La.exports;
}
var Fa = { exports: {} }, rm;
function X0() {
  return rm || (rm = 1, function(e, t) {
    t.__esModule = !0, t.default = void 0;
    var r = o(pp()), n = Kt();
    function o(l) {
      return l && l.__esModule ? l : { default: l };
    }
    function a(l, u) {
      l.prototype = Object.create(u.prototype), l.prototype.constructor = l, i(l, u);
    }
    function i(l, u) {
      return i = Object.setPrototypeOf || function(d, h) {
        return d.__proto__ = h, d;
      }, i(l, u);
    }
    var s = /* @__PURE__ */ function(l) {
      a(u, l);
      function u(d) {
        var h;
        return h = l.call(this, d) || this, h.type = n.PSEUDO, h;
      }
      var c = u.prototype;
      return c.toString = function() {
        var h = this.length ? "(" + this.map(String).join(",") + ")" : "";
        return [this.rawSpaceBefore, this.stringifyProperty("value"), h, this.rawSpaceAfter].join("");
      }, u;
    }(r.default);
    t.default = s, e.exports = t.default;
  }(Fa, Fa.exports)), Fa.exports;
}
var jl = {}, Ul, nm;
function q_() {
  if (nm) return Ul;
  nm = 1, Ul = e;
  function e(r, n) {
    if (t("noDeprecation"))
      return r;
    var o = !1;
    function a() {
      if (!o) {
        if (t("throwDeprecation"))
          throw new Error(n);
        t("traceDeprecation") ? console.trace(n) : console.warn(n), o = !0;
      }
      return r.apply(this, arguments);
    }
    return a;
  }
  function t(r) {
    try {
      if (!Ht.localStorage) return !1;
    } catch {
      return !1;
    }
    var n = Ht.localStorage[r];
    return n == null ? !1 : String(n).toLowerCase() === "true";
  }
  return Ul;
}
var om;
function Q0() {
  return om || (om = 1, function(e) {
    e.__esModule = !0, e.unescapeValue = f, e.default = void 0;
    var t = i(hp()), r = i(W0()), n = i(mp()), o = Kt(), a;
    function i(A) {
      return A && A.__esModule ? A : { default: A };
    }
    function s(A, O) {
      for (var M = 0; M < O.length; M++) {
        var I = O[M];
        I.enumerable = I.enumerable || !1, I.configurable = !0, "value" in I && (I.writable = !0), Object.defineProperty(A, I.key, I);
      }
    }
    function l(A, O, M) {
      return O && s(A.prototype, O), A;
    }
    function u(A, O) {
      A.prototype = Object.create(O.prototype), A.prototype.constructor = A, c(A, O);
    }
    function c(A, O) {
      return c = Object.setPrototypeOf || function(I, C) {
        return I.__proto__ = C, I;
      }, c(A, O);
    }
    var d = q_(), h = /^('|")([^]*)\1$/, y = d(function() {
    }, "Assigning an attribute a value containing characters that might need to be escaped is deprecated. Call attribute.setValue() instead."), m = d(function() {
    }, "Assigning attr.quoted is deprecated and has no effect. Assign to attr.quoteMark instead."), p = d(function() {
    }, "Constructing an Attribute selector with a value without specifying quoteMark is deprecated. Note: The value should be unescaped now.");
    function f(A) {
      var O = !1, M = null, I = A, C = I.match(h);
      return C && (M = C[1], I = C[2]), I = (0, r.default)(I), I !== A && (O = !0), {
        deprecatedUsage: O,
        unescaped: I,
        quoteMark: M
      };
    }
    function v(A) {
      if (A.quoteMark !== void 0 || A.value === void 0)
        return A;
      p();
      var O = f(A.value), M = O.quoteMark, I = O.unescaped;
      return A.raws || (A.raws = {}), A.raws.value === void 0 && (A.raws.value = A.value), A.value = I, A.quoteMark = M, A;
    }
    var w = /* @__PURE__ */ function(A) {
      u(O, A);
      function O(I) {
        var C;
        return I === void 0 && (I = {}), C = A.call(this, v(I)) || this, C.type = o.ATTRIBUTE, C.raws = C.raws || {}, Object.defineProperty(C.raws, "unquoted", {
          get: d(function() {
            return C.value;
          }, "attr.raws.unquoted is deprecated. Call attr.value instead."),
          set: d(function() {
            return C.value;
          }, "Setting attr.raws.unquoted is deprecated and has no effect. attr.value is unescaped by default now.")
        }), C._constructed = !0, C;
      }
      var M = O.prototype;
      return M.getQuotedValue = function(C) {
        C === void 0 && (C = {});
        var E = this._determineQuoteMark(C), R = _[E], k = (0, t.default)(this._value, R);
        return k;
      }, M._determineQuoteMark = function(C) {
        return C.smart ? this.smartQuoteMark(C) : this.preferredQuoteMark(C);
      }, M.setValue = function(C, E) {
        E === void 0 && (E = {}), this._value = C, this._quoteMark = this._determineQuoteMark(E), this._syncRawValue();
      }, M.smartQuoteMark = function(C) {
        var E = this.value, R = E.replace(/[^']/g, "").length, k = E.replace(/[^"]/g, "").length;
        if (R + k === 0) {
          var L = (0, t.default)(E, {
            isIdentifier: !0
          });
          if (L === E)
            return O.NO_QUOTE;
          var z = this.preferredQuoteMark(C);
          if (z === O.NO_QUOTE) {
            var F = this.quoteMark || C.quoteMark || O.DOUBLE_QUOTE, q = _[F], j = (0, t.default)(E, q);
            if (j.length < L.length)
              return F;
          }
          return z;
        } else return k === R ? this.preferredQuoteMark(C) : k < R ? O.DOUBLE_QUOTE : O.SINGLE_QUOTE;
      }, M.preferredQuoteMark = function(C) {
        var E = C.preferCurrentQuoteMark ? this.quoteMark : C.quoteMark;
        return E === void 0 && (E = C.preferCurrentQuoteMark ? C.quoteMark : this.quoteMark), E === void 0 && (E = O.DOUBLE_QUOTE), E;
      }, M._syncRawValue = function() {
        var C = (0, t.default)(this._value, _[this.quoteMark]);
        C === this._value ? this.raws && delete this.raws.value : this.raws.value = C;
      }, M._handleEscapes = function(C, E) {
        if (this._constructed) {
          var R = (0, t.default)(E, {
            isIdentifier: !0
          });
          R !== E ? this.raws[C] = R : delete this.raws[C];
        }
      }, M._spacesFor = function(C) {
        var E = {
          before: "",
          after: ""
        }, R = this.spaces[C] || {}, k = this.raws.spaces && this.raws.spaces[C] || {};
        return Object.assign(E, R, k);
      }, M._stringFor = function(C, E, R) {
        E === void 0 && (E = C), R === void 0 && (R = T);
        var k = this._spacesFor(E);
        return R(this.stringifyProperty(C), k);
      }, M.offsetOf = function(C) {
        var E = 1, R = this._spacesFor("attribute");
        if (E += R.before.length, C === "namespace" || C === "ns")
          return this.namespace ? E : -1;
        if (C === "attributeNS" || (E += this.namespaceString.length, this.namespace && (E += 1), C === "attribute"))
          return E;
        E += this.stringifyProperty("attribute").length, E += R.after.length;
        var k = this._spacesFor("operator");
        E += k.before.length;
        var L = this.stringifyProperty("operator");
        if (C === "operator")
          return L ? E : -1;
        E += L.length, E += k.after.length;
        var z = this._spacesFor("value");
        E += z.before.length;
        var F = this.stringifyProperty("value");
        if (C === "value")
          return F ? E : -1;
        E += F.length, E += z.after.length;
        var q = this._spacesFor("insensitive");
        return E += q.before.length, C === "insensitive" && this.insensitive ? E : -1;
      }, M.toString = function() {
        var C = this, E = [this.rawSpaceBefore, "["];
        return E.push(this._stringFor("qualifiedAttribute", "attribute")), this.operator && (this.value || this.value === "") && (E.push(this._stringFor("operator")), E.push(this._stringFor("value")), E.push(this._stringFor("insensitiveFlag", "insensitive", function(R, k) {
          return R.length > 0 && !C.quoted && k.before.length === 0 && !(C.spaces.value && C.spaces.value.after) && (k.before = " "), T(R, k);
        }))), E.push("]"), E.push(this.rawSpaceAfter), E.join("");
      }, l(O, [{
        key: "quoted",
        get: function() {
          var C = this.quoteMark;
          return C === "'" || C === '"';
        },
        set: function(C) {
          m();
        }
        /**
         * returns a single (`'`) or double (`"`) quote character if the value is quoted.
         * returns `null` if the value is not quoted.
         * returns `undefined` if the quotation state is unknown (this can happen when
         * the attribute is constructed without specifying a quote mark.)
         */
      }, {
        key: "quoteMark",
        get: function() {
          return this._quoteMark;
        },
        set: function(C) {
          if (!this._constructed) {
            this._quoteMark = C;
            return;
          }
          this._quoteMark !== C && (this._quoteMark = C, this._syncRawValue());
        }
      }, {
        key: "qualifiedAttribute",
        get: function() {
          return this.qualifiedName(this.raws.attribute || this.attribute);
        }
      }, {
        key: "insensitiveFlag",
        get: function() {
          return this.insensitive ? "i" : "";
        }
      }, {
        key: "value",
        get: function() {
          return this._value;
        },
        set: function(C) {
          if (this._constructed) {
            var E = f(C), R = E.deprecatedUsage, k = E.unescaped, L = E.quoteMark;
            if (R && y(), k === this._value && L === this._quoteMark)
              return;
            this._value = k, this._quoteMark = L, this._syncRawValue();
          } else
            this._value = C;
        }
      }, {
        key: "attribute",
        get: function() {
          return this._attribute;
        },
        set: function(C) {
          this._handleEscapes("attribute", C), this._attribute = C;
        }
      }]), O;
    }(n.default);
    e.default = w, w.NO_QUOTE = null, w.SINGLE_QUOTE = "'", w.DOUBLE_QUOTE = '"';
    var _ = (a = {
      "'": {
        quotes: "single",
        wrap: !0
      },
      '"': {
        quotes: "double",
        wrap: !0
      }
    }, a[null] = {
      isIdentifier: !0
    }, a);
    function T(A, O) {
      return "" + O.before + A + O.after;
    }
  }(jl)), jl;
}
var Na = { exports: {} }, im;
function eb() {
  return im || (im = 1, function(e, t) {
    t.__esModule = !0, t.default = void 0;
    var r = o(mp()), n = Kt();
    function o(l) {
      return l && l.__esModule ? l : { default: l };
    }
    function a(l, u) {
      l.prototype = Object.create(u.prototype), l.prototype.constructor = l, i(l, u);
    }
    function i(l, u) {
      return i = Object.setPrototypeOf || function(d, h) {
        return d.__proto__ = h, d;
      }, i(l, u);
    }
    var s = /* @__PURE__ */ function(l) {
      a(u, l);
      function u(c) {
        var d;
        return d = l.call(this, c) || this, d.type = n.UNIVERSAL, d.value = "*", d;
      }
      return u;
    }(r.default);
    t.default = s, e.exports = t.default;
  }(Na, Na.exports)), Na.exports;
}
var za = { exports: {} }, am;
function tb() {
  return am || (am = 1, function(e, t) {
    t.__esModule = !0, t.default = void 0;
    var r = o(to()), n = Kt();
    function o(l) {
      return l && l.__esModule ? l : { default: l };
    }
    function a(l, u) {
      l.prototype = Object.create(u.prototype), l.prototype.constructor = l, i(l, u);
    }
    function i(l, u) {
      return i = Object.setPrototypeOf || function(d, h) {
        return d.__proto__ = h, d;
      }, i(l, u);
    }
    var s = /* @__PURE__ */ function(l) {
      a(u, l);
      function u(c) {
        var d;
        return d = l.call(this, c) || this, d.type = n.COMBINATOR, d;
      }
      return u;
    }(r.default);
    t.default = s, e.exports = t.default;
  }(za, za.exports)), za.exports;
}
var ja = { exports: {} }, sm;
function rb() {
  return sm || (sm = 1, function(e, t) {
    t.__esModule = !0, t.default = void 0;
    var r = o(to()), n = Kt();
    function o(l) {
      return l && l.__esModule ? l : { default: l };
    }
    function a(l, u) {
      l.prototype = Object.create(u.prototype), l.prototype.constructor = l, i(l, u);
    }
    function i(l, u) {
      return i = Object.setPrototypeOf || function(d, h) {
        return d.__proto__ = h, d;
      }, i(l, u);
    }
    var s = /* @__PURE__ */ function(l) {
      a(u, l);
      function u(c) {
        var d;
        return d = l.call(this, c) || this, d.type = n.NESTING, d.value = "&", d;
      }
      return u;
    }(r.default);
    t.default = s, e.exports = t.default;
  }(ja, ja.exports)), ja.exports;
}
var Ua = { exports: {} }, lm;
function L_() {
  return lm || (lm = 1, function(e, t) {
    t.__esModule = !0, t.default = r;
    function r(n) {
      return n.sort(function(o, a) {
        return o - a;
      });
    }
    e.exports = t.default;
  }(Ua, Ua.exports)), Ua.exports;
}
var Wl = {}, pe = {}, um;
function nb() {
  if (um) return pe;
  um = 1, pe.__esModule = !0, pe.combinator = pe.word = pe.comment = pe.str = pe.tab = pe.newline = pe.feed = pe.cr = pe.backslash = pe.bang = pe.slash = pe.doubleQuote = pe.singleQuote = pe.space = pe.greaterThan = pe.pipe = pe.equals = pe.plus = pe.caret = pe.tilde = pe.dollar = pe.closeSquare = pe.openSquare = pe.closeParenthesis = pe.openParenthesis = pe.semicolon = pe.colon = pe.comma = pe.at = pe.asterisk = pe.ampersand = void 0;
  var e = 38;
  pe.ampersand = e;
  var t = 42;
  pe.asterisk = t;
  var r = 64;
  pe.at = r;
  var n = 44;
  pe.comma = n;
  var o = 58;
  pe.colon = o;
  var a = 59;
  pe.semicolon = a;
  var i = 40;
  pe.openParenthesis = i;
  var s = 41;
  pe.closeParenthesis = s;
  var l = 91;
  pe.openSquare = l;
  var u = 93;
  pe.closeSquare = u;
  var c = 36;
  pe.dollar = c;
  var d = 126;
  pe.tilde = d;
  var h = 94;
  pe.caret = h;
  var y = 43;
  pe.plus = y;
  var m = 61;
  pe.equals = m;
  var p = 124;
  pe.pipe = p;
  var f = 62;
  pe.greaterThan = f;
  var v = 32;
  pe.space = v;
  var w = 39;
  pe.singleQuote = w;
  var _ = 34;
  pe.doubleQuote = _;
  var T = 47;
  pe.slash = T;
  var A = 33;
  pe.bang = A;
  var O = 92;
  pe.backslash = O;
  var M = 13;
  pe.cr = M;
  var I = 12;
  pe.feed = I;
  var C = 10;
  pe.newline = C;
  var E = 9;
  pe.tab = E;
  var R = w;
  pe.str = R;
  var k = -1;
  pe.comment = k;
  var L = -2;
  pe.word = L;
  var z = -3;
  return pe.combinator = z, pe;
}
var cm;
function F_() {
  return cm || (cm = 1, function(e) {
    e.__esModule = !0, e.default = m, e.FIELDS = void 0;
    var t = a(nb()), r, n;
    function o() {
      if (typeof WeakMap != "function") return null;
      var p = /* @__PURE__ */ new WeakMap();
      return o = function() {
        return p;
      }, p;
    }
    function a(p) {
      if (p && p.__esModule)
        return p;
      if (p === null || typeof p != "object" && typeof p != "function")
        return { default: p };
      var f = o();
      if (f && f.has(p))
        return f.get(p);
      var v = {}, w = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var _ in p)
        if (Object.prototype.hasOwnProperty.call(p, _)) {
          var T = w ? Object.getOwnPropertyDescriptor(p, _) : null;
          T && (T.get || T.set) ? Object.defineProperty(v, _, T) : v[_] = p[_];
        }
      return v.default = p, f && f.set(p, v), v;
    }
    for (var i = (r = {}, r[t.tab] = !0, r[t.newline] = !0, r[t.cr] = !0, r[t.feed] = !0, r), s = (n = {}, n[t.space] = !0, n[t.tab] = !0, n[t.newline] = !0, n[t.cr] = !0, n[t.feed] = !0, n[t.ampersand] = !0, n[t.asterisk] = !0, n[t.bang] = !0, n[t.comma] = !0, n[t.colon] = !0, n[t.semicolon] = !0, n[t.openParenthesis] = !0, n[t.closeParenthesis] = !0, n[t.openSquare] = !0, n[t.closeSquare] = !0, n[t.singleQuote] = !0, n[t.doubleQuote] = !0, n[t.plus] = !0, n[t.pipe] = !0, n[t.tilde] = !0, n[t.greaterThan] = !0, n[t.equals] = !0, n[t.dollar] = !0, n[t.caret] = !0, n[t.slash] = !0, n), l = {}, u = "0123456789abcdefABCDEF", c = 0; c < u.length; c++)
      l[u.charCodeAt(c)] = !0;
    function d(p, f) {
      var v = f, w;
      do {
        if (w = p.charCodeAt(v), s[w])
          return v - 1;
        w === t.backslash ? v = h(p, v) + 1 : v++;
      } while (v < p.length);
      return v - 1;
    }
    function h(p, f) {
      var v = f, w = p.charCodeAt(v + 1);
      if (!i[w]) if (l[w]) {
        var _ = 0;
        do
          v++, _++, w = p.charCodeAt(v + 1);
        while (l[w] && _ < 6);
        _ < 6 && w === t.space && v++;
      } else
        v++;
      return v;
    }
    var y = {
      TYPE: 0,
      START_LINE: 1,
      START_COL: 2,
      END_LINE: 3,
      END_COL: 4,
      START_POS: 5,
      END_POS: 6
    };
    e.FIELDS = y;
    function m(p) {
      var f = [], v = p.css.valueOf(), w = v, _ = w.length, T = -1, A = 1, O = 0, M = 0, I, C, E, R, k, L, z, F, q, j, D, H, W;
      function ee(oe, J) {
        if (p.safe)
          v += J, q = v.length - 1;
        else
          throw p.error("Unclosed " + oe, A, O - T, O);
      }
      for (; O < _; ) {
        switch (I = v.charCodeAt(O), I === t.newline && (T = O, A += 1), I) {
          case t.space:
          case t.tab:
          case t.newline:
          case t.cr:
          case t.feed:
            q = O;
            do
              q += 1, I = v.charCodeAt(q), I === t.newline && (T = q, A += 1);
            while (I === t.space || I === t.newline || I === t.tab || I === t.cr || I === t.feed);
            W = t.space, R = A, E = q - T - 1, M = q;
            break;
          case t.plus:
          case t.greaterThan:
          case t.tilde:
          case t.pipe:
            q = O;
            do
              q += 1, I = v.charCodeAt(q);
            while (I === t.plus || I === t.greaterThan || I === t.tilde || I === t.pipe);
            W = t.combinator, R = A, E = O - T, M = q;
            break;
          // Consume these characters as single tokens.
          case t.asterisk:
          case t.ampersand:
          case t.bang:
          case t.comma:
          case t.equals:
          case t.dollar:
          case t.caret:
          case t.openSquare:
          case t.closeSquare:
          case t.colon:
          case t.semicolon:
          case t.openParenthesis:
          case t.closeParenthesis:
            q = O, W = I, R = A, E = O - T, M = q + 1;
            break;
          case t.singleQuote:
          case t.doubleQuote:
            H = I === t.singleQuote ? "'" : '"', q = O;
            do
              for (k = !1, q = v.indexOf(H, q + 1), q === -1 && ee("quote", H), L = q; v.charCodeAt(L - 1) === t.backslash; )
                L -= 1, k = !k;
            while (k);
            W = t.str, R = A, E = O - T, M = q + 1;
            break;
          default:
            I === t.slash && v.charCodeAt(O + 1) === t.asterisk ? (q = v.indexOf("*/", O + 2) + 1, q === 0 && ee("comment", "*/"), C = v.slice(O, q + 1), F = C.split(`
`), z = F.length - 1, z > 0 ? (j = A + z, D = q - F[z].length) : (j = A, D = T), W = t.comment, A = j, R = j, E = q - D) : I === t.slash ? (q = O, W = I, R = A, E = O - T, M = q + 1) : (q = d(v, O), W = t.word, R = A, E = q - T), M = q + 1;
            break;
        }
        f.push([
          W,
          // [0] Token type
          A,
          // [1] Starting line
          O - T,
          // [2] Starting column
          R,
          // [3] Ending line
          E,
          // [4] Ending column
          O,
          // [5] Start position / Source index
          M
          // [6] End position
        ]), D && (T = D, D = null), O = M;
      }
      return f;
    }
  }(Wl)), Wl;
}
var dm;
function N_() {
  return dm || (dm = 1, function(e, t) {
    t.__esModule = !0, t.default = void 0;
    var r = M(V0()), n = M(H0()), o = M(G0()), a = M(K0()), i = M(Y0()), s = M(J0()), l = M(Z0()), u = M(X0()), c = O(Q0()), d = M(eb()), h = M(tb()), y = M(rb()), m = M(L_()), p = O(F_()), f = O(nb()), v = O(Kt()), w = Ls(), _, T;
    function A() {
      if (typeof WeakMap != "function") return null;
      var ee = /* @__PURE__ */ new WeakMap();
      return A = function() {
        return ee;
      }, ee;
    }
    function O(ee) {
      if (ee && ee.__esModule)
        return ee;
      if (ee === null || typeof ee != "object" && typeof ee != "function")
        return { default: ee };
      var oe = A();
      if (oe && oe.has(ee))
        return oe.get(ee);
      var J = {}, N = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var Q in ee)
        if (Object.prototype.hasOwnProperty.call(ee, Q)) {
          var de = N ? Object.getOwnPropertyDescriptor(ee, Q) : null;
          de && (de.get || de.set) ? Object.defineProperty(J, Q, de) : J[Q] = ee[Q];
        }
      return J.default = ee, oe && oe.set(ee, J), J;
    }
    function M(ee) {
      return ee && ee.__esModule ? ee : { default: ee };
    }
    function I(ee, oe) {
      for (var J = 0; J < oe.length; J++) {
        var N = oe[J];
        N.enumerable = N.enumerable || !1, N.configurable = !0, "value" in N && (N.writable = !0), Object.defineProperty(ee, N.key, N);
      }
    }
    function C(ee, oe, J) {
      return oe && I(ee.prototype, oe), ee;
    }
    var E = (_ = {}, _[f.space] = !0, _[f.cr] = !0, _[f.feed] = !0, _[f.newline] = !0, _[f.tab] = !0, _), R = Object.assign({}, E, (T = {}, T[f.comment] = !0, T));
    function k(ee) {
      return {
        line: ee[p.FIELDS.START_LINE],
        column: ee[p.FIELDS.START_COL]
      };
    }
    function L(ee) {
      return {
        line: ee[p.FIELDS.END_LINE],
        column: ee[p.FIELDS.END_COL]
      };
    }
    function z(ee, oe, J, N) {
      return {
        start: {
          line: ee,
          column: oe
        },
        end: {
          line: J,
          column: N
        }
      };
    }
    function F(ee) {
      return z(ee[p.FIELDS.START_LINE], ee[p.FIELDS.START_COL], ee[p.FIELDS.END_LINE], ee[p.FIELDS.END_COL]);
    }
    function q(ee, oe) {
      if (ee)
        return z(ee[p.FIELDS.START_LINE], ee[p.FIELDS.START_COL], oe[p.FIELDS.END_LINE], oe[p.FIELDS.END_COL]);
    }
    function j(ee, oe) {
      var J = ee[oe];
      if (typeof J == "string")
        return J.indexOf("\\") !== -1 && ((0, w.ensureObject)(ee, "raws"), ee[oe] = (0, w.unesc)(J), ee.raws[oe] === void 0 && (ee.raws[oe] = J)), ee;
    }
    function D(ee, oe) {
      for (var J = -1, N = []; (J = ee.indexOf(oe, J + 1)) !== -1; )
        N.push(J);
      return N;
    }
    function H() {
      var ee = Array.prototype.concat.apply([], arguments);
      return ee.filter(function(oe, J) {
        return J === ee.indexOf(oe);
      });
    }
    var W = /* @__PURE__ */ function() {
      function ee(J, N) {
        N === void 0 && (N = {}), this.rule = J, this.options = Object.assign({
          lossy: !1,
          safe: !1
        }, N), this.position = 0, this.css = typeof this.rule == "string" ? this.rule : this.rule.selector, this.tokens = (0, p.default)({
          css: this.css,
          error: this._errorGenerator(),
          safe: this.options.safe
        });
        var Q = q(this.tokens[0], this.tokens[this.tokens.length - 1]);
        this.root = new r.default({
          source: Q
        }), this.root.errorGenerator = this._errorGenerator();
        var de = new n.default({
          source: {
            start: {
              line: 1,
              column: 1
            }
          }
        });
        this.root.append(de), this.current = de, this.loop();
      }
      var oe = ee.prototype;
      return oe._errorGenerator = function() {
        var N = this;
        return function(Q, de) {
          return typeof N.rule == "string" ? new Error(Q) : N.rule.error(Q, de);
        };
      }, oe.attribute = function() {
        var N = [], Q = this.currToken;
        for (this.position++; this.position < this.tokens.length && this.currToken[p.FIELDS.TYPE] !== f.closeSquare; )
          N.push(this.currToken), this.position++;
        if (this.currToken[p.FIELDS.TYPE] !== f.closeSquare)
          return this.expected("closing square bracket", this.currToken[p.FIELDS.START_POS]);
        var de = N.length, G = {
          source: z(Q[1], Q[2], this.currToken[3], this.currToken[4]),
          sourceIndex: Q[p.FIELDS.START_POS]
        };
        if (de === 1 && !~[f.word].indexOf(N[0][p.FIELDS.TYPE]))
          return this.expected("attribute", N[0][p.FIELDS.START_POS]);
        for (var ce = 0, be = "", ve = "", fe = null, Oe = !1; ce < de; ) {
          var Ge = N[ce], we = this.content(Ge), Me = N[ce + 1];
          switch (Ge[p.FIELDS.TYPE]) {
            case f.space:
              if (Oe = !0, this.options.lossy)
                break;
              if (fe) {
                (0, w.ensureObject)(G, "spaces", fe);
                var Ct = G.spaces[fe].after || "";
                G.spaces[fe].after = Ct + we;
                var _t = (0, w.getProp)(G, "raws", "spaces", fe, "after") || null;
                _t && (G.raws.spaces[fe].after = _t + we);
              } else
                be = be + we, ve = ve + we;
              break;
            case f.asterisk:
              if (Me[p.FIELDS.TYPE] === f.equals)
                G.operator = we, fe = "operator";
              else if ((!G.namespace || fe === "namespace" && !Oe) && Me) {
                be && ((0, w.ensureObject)(G, "spaces", "attribute"), G.spaces.attribute.before = be, be = ""), ve && ((0, w.ensureObject)(G, "raws", "spaces", "attribute"), G.raws.spaces.attribute.before = be, ve = ""), G.namespace = (G.namespace || "") + we;
                var vt = (0, w.getProp)(G, "raws", "namespace") || null;
                vt && (G.raws.namespace += we), fe = "namespace";
              }
              Oe = !1;
              break;
            case f.dollar:
              if (fe === "value") {
                var st = (0, w.getProp)(G, "raws", "value");
                G.value += "$", st && (G.raws.value = st + "$");
                break;
              }
            // Falls through
            case f.caret:
              Me[p.FIELDS.TYPE] === f.equals && (G.operator = we, fe = "operator"), Oe = !1;
              break;
            case f.combinator:
              if (we === "~" && Me[p.FIELDS.TYPE] === f.equals && (G.operator = we, fe = "operator"), we !== "|") {
                Oe = !1;
                break;
              }
              Me[p.FIELDS.TYPE] === f.equals ? (G.operator = we, fe = "operator") : !G.namespace && !G.attribute && (G.namespace = !0), Oe = !1;
              break;
            case f.word:
              if (Me && this.content(Me) === "|" && N[ce + 2] && N[ce + 2][p.FIELDS.TYPE] !== f.equals && // this look-ahead probably fails with comment nodes involved.
              !G.operator && !G.namespace)
                G.namespace = we, fe = "namespace";
              else if (!G.attribute || fe === "attribute" && !Oe) {
                be && ((0, w.ensureObject)(G, "spaces", "attribute"), G.spaces.attribute.before = be, be = ""), ve && ((0, w.ensureObject)(G, "raws", "spaces", "attribute"), G.raws.spaces.attribute.before = ve, ve = ""), G.attribute = (G.attribute || "") + we;
                var rt = (0, w.getProp)(G, "raws", "attribute") || null;
                rt && (G.raws.attribute += we), fe = "attribute";
              } else if (!G.value && G.value !== "" || fe === "value" && !Oe) {
                var ut = (0, w.unesc)(we), St = (0, w.getProp)(G, "raws", "value") || "", xt = G.value || "";
                G.value = xt + ut, G.quoteMark = null, (ut !== we || St) && ((0, w.ensureObject)(G, "raws"), G.raws.value = (St || xt) + we), fe = "value";
              } else {
                var gt = we === "i" || we === "I";
                (G.value || G.value === "") && (G.quoteMark || Oe) ? (G.insensitive = gt, (!gt || we === "I") && ((0, w.ensureObject)(G, "raws"), G.raws.insensitiveFlag = we), fe = "insensitive", be && ((0, w.ensureObject)(G, "spaces", "insensitive"), G.spaces.insensitive.before = be, be = ""), ve && ((0, w.ensureObject)(G, "raws", "spaces", "insensitive"), G.raws.spaces.insensitive.before = ve, ve = "")) : (G.value || G.value === "") && (fe = "value", G.value += we, G.raws.value && (G.raws.value += we));
              }
              Oe = !1;
              break;
            case f.str:
              if (!G.attribute || !G.operator)
                return this.error("Expected an attribute followed by an operator preceding the string.", {
                  index: Ge[p.FIELDS.START_POS]
                });
              var Ft = (0, c.unescapeValue)(we), cr = Ft.unescaped, Yt = Ft.quoteMark;
              G.value = cr, G.quoteMark = Yt, fe = "value", (0, w.ensureObject)(G, "raws"), G.raws.value = we, Oe = !1;
              break;
            case f.equals:
              if (!G.attribute)
                return this.expected("attribute", Ge[p.FIELDS.START_POS], we);
              if (G.value)
                return this.error('Unexpected "=" found; an operator was already defined.', {
                  index: Ge[p.FIELDS.START_POS]
                });
              G.operator = G.operator ? G.operator + we : we, fe = "operator", Oe = !1;
              break;
            case f.comment:
              if (fe)
                if (Oe || Me && Me[p.FIELDS.TYPE] === f.space || fe === "insensitive") {
                  var Ut = (0, w.getProp)(G, "spaces", fe, "after") || "", Sr = (0, w.getProp)(G, "raws", "spaces", fe, "after") || Ut;
                  (0, w.ensureObject)(G, "raws", "spaces", fe), G.raws.spaces[fe].after = Sr + we;
                } else {
                  var kt = G[fe] || "", dr = (0, w.getProp)(G, "raws", fe) || kt;
                  (0, w.ensureObject)(G, "raws"), G.raws[fe] = dr + we;
                }
              else
                ve = ve + we;
              break;
            default:
              return this.error('Unexpected "' + we + '" found.', {
                index: Ge[p.FIELDS.START_POS]
              });
          }
          ce++;
        }
        j(G, "attribute"), j(G, "namespace"), this.newNode(new c.default(G)), this.position++;
      }, oe.parseWhitespaceEquivalentTokens = function(N) {
        N < 0 && (N = this.tokens.length);
        var Q = this.position, de = [], G = "", ce = void 0;
        do
          if (E[this.currToken[p.FIELDS.TYPE]])
            this.options.lossy || (G += this.content());
          else if (this.currToken[p.FIELDS.TYPE] === f.comment) {
            var be = {};
            G && (be.before = G, G = ""), ce = new a.default({
              value: this.content(),
              source: F(this.currToken),
              sourceIndex: this.currToken[p.FIELDS.START_POS],
              spaces: be
            }), de.push(ce);
          }
        while (++this.position < N);
        if (G) {
          if (ce)
            ce.spaces.after = G;
          else if (!this.options.lossy) {
            var ve = this.tokens[Q], fe = this.tokens[this.position - 1];
            de.push(new l.default({
              value: "",
              source: z(ve[p.FIELDS.START_LINE], ve[p.FIELDS.START_COL], fe[p.FIELDS.END_LINE], fe[p.FIELDS.END_COL]),
              sourceIndex: ve[p.FIELDS.START_POS],
              spaces: {
                before: G,
                after: ""
              }
            }));
          }
        }
        return de;
      }, oe.convertWhitespaceNodesToSpace = function(N, Q) {
        var de = this;
        Q === void 0 && (Q = !1);
        var G = "", ce = "";
        N.forEach(function(ve) {
          var fe = de.lossySpace(ve.spaces.before, Q), Oe = de.lossySpace(ve.rawSpaceBefore, Q);
          G += fe + de.lossySpace(ve.spaces.after, Q && fe.length === 0), ce += fe + ve.value + de.lossySpace(ve.rawSpaceAfter, Q && Oe.length === 0);
        }), ce === G && (ce = void 0);
        var be = {
          space: G,
          rawSpace: ce
        };
        return be;
      }, oe.isNamedCombinator = function(N) {
        return N === void 0 && (N = this.position), this.tokens[N + 0] && this.tokens[N + 0][p.FIELDS.TYPE] === f.slash && this.tokens[N + 1] && this.tokens[N + 1][p.FIELDS.TYPE] === f.word && this.tokens[N + 2] && this.tokens[N + 2][p.FIELDS.TYPE] === f.slash;
      }, oe.namedCombinator = function() {
        if (this.isNamedCombinator()) {
          var N = this.content(this.tokens[this.position + 1]), Q = (0, w.unesc)(N).toLowerCase(), de = {};
          Q !== N && (de.value = "/" + N + "/");
          var G = new h.default({
            value: "/" + Q + "/",
            source: z(this.currToken[p.FIELDS.START_LINE], this.currToken[p.FIELDS.START_COL], this.tokens[this.position + 2][p.FIELDS.END_LINE], this.tokens[this.position + 2][p.FIELDS.END_COL]),
            sourceIndex: this.currToken[p.FIELDS.START_POS],
            raws: de
          });
          return this.position = this.position + 3, G;
        } else
          this.unexpected();
      }, oe.combinator = function() {
        var N = this;
        if (this.content() === "|")
          return this.namespace();
        var Q = this.locateNextMeaningfulToken(this.position);
        if (Q < 0 || this.tokens[Q][p.FIELDS.TYPE] === f.comma) {
          var de = this.parseWhitespaceEquivalentTokens(Q);
          if (de.length > 0) {
            var G = this.current.last;
            if (G) {
              var ce = this.convertWhitespaceNodesToSpace(de), be = ce.space, ve = ce.rawSpace;
              ve !== void 0 && (G.rawSpaceAfter += ve), G.spaces.after += be;
            } else
              de.forEach(function(St) {
                return N.newNode(St);
              });
          }
          return;
        }
        var fe = this.currToken, Oe = void 0;
        Q > this.position && (Oe = this.parseWhitespaceEquivalentTokens(Q));
        var Ge;
        if (this.isNamedCombinator() ? Ge = this.namedCombinator() : this.currToken[p.FIELDS.TYPE] === f.combinator ? (Ge = new h.default({
          value: this.content(),
          source: F(this.currToken),
          sourceIndex: this.currToken[p.FIELDS.START_POS]
        }), this.position++) : E[this.currToken[p.FIELDS.TYPE]] || Oe || this.unexpected(), Ge) {
          if (Oe) {
            var we = this.convertWhitespaceNodesToSpace(Oe), Me = we.space, Ct = we.rawSpace;
            Ge.spaces.before = Me, Ge.rawSpaceBefore = Ct;
          }
        } else {
          var _t = this.convertWhitespaceNodesToSpace(Oe, !0), vt = _t.space, st = _t.rawSpace;
          st || (st = vt);
          var rt = {}, ut = {
            spaces: {}
          };
          vt.endsWith(" ") && st.endsWith(" ") ? (rt.before = vt.slice(0, vt.length - 1), ut.spaces.before = st.slice(0, st.length - 1)) : vt.startsWith(" ") && st.startsWith(" ") ? (rt.after = vt.slice(1), ut.spaces.after = st.slice(1)) : ut.value = st, Ge = new h.default({
            value: " ",
            source: q(fe, this.tokens[this.position - 1]),
            sourceIndex: fe[p.FIELDS.START_POS],
            spaces: rt,
            raws: ut
          });
        }
        return this.currToken && this.currToken[p.FIELDS.TYPE] === f.space && (Ge.spaces.after = this.optionalSpace(this.content()), this.position++), this.newNode(Ge);
      }, oe.comma = function() {
        if (this.position === this.tokens.length - 1) {
          this.root.trailingComma = !0, this.position++;
          return;
        }
        this.current._inferEndPosition();
        var N = new n.default({
          source: {
            start: k(this.tokens[this.position + 1])
          }
        });
        this.current.parent.append(N), this.current = N, this.position++;
      }, oe.comment = function() {
        var N = this.currToken;
        this.newNode(new a.default({
          value: this.content(),
          source: F(N),
          sourceIndex: N[p.FIELDS.START_POS]
        })), this.position++;
      }, oe.error = function(N, Q) {
        throw this.root.error(N, Q);
      }, oe.missingBackslash = function() {
        return this.error("Expected a backslash preceding the semicolon.", {
          index: this.currToken[p.FIELDS.START_POS]
        });
      }, oe.missingParenthesis = function() {
        return this.expected("opening parenthesis", this.currToken[p.FIELDS.START_POS]);
      }, oe.missingSquareBracket = function() {
        return this.expected("opening square bracket", this.currToken[p.FIELDS.START_POS]);
      }, oe.unexpected = function() {
        return this.error("Unexpected '" + this.content() + "'. Escaping special characters with \\ may help.", this.currToken[p.FIELDS.START_POS]);
      }, oe.namespace = function() {
        var N = this.prevToken && this.content(this.prevToken) || !0;
        if (this.nextToken[p.FIELDS.TYPE] === f.word)
          return this.position++, this.word(N);
        if (this.nextToken[p.FIELDS.TYPE] === f.asterisk)
          return this.position++, this.universal(N);
      }, oe.nesting = function() {
        if (this.nextToken) {
          var N = this.content(this.nextToken);
          if (N === "|") {
            this.position++;
            return;
          }
        }
        var Q = this.currToken;
        this.newNode(new y.default({
          value: this.content(),
          source: F(Q),
          sourceIndex: Q[p.FIELDS.START_POS]
        })), this.position++;
      }, oe.parentheses = function() {
        var N = this.current.last, Q = 1;
        if (this.position++, N && N.type === v.PSEUDO) {
          var de = new n.default({
            source: {
              start: k(this.tokens[this.position - 1])
            }
          }), G = this.current;
          for (N.append(de), this.current = de; this.position < this.tokens.length && Q; )
            this.currToken[p.FIELDS.TYPE] === f.openParenthesis && Q++, this.currToken[p.FIELDS.TYPE] === f.closeParenthesis && Q--, Q ? this.parse() : (this.current.source.end = L(this.currToken), this.current.parent.source.end = L(this.currToken), this.position++);
          this.current = G;
        } else {
          for (var ce = this.currToken, be = "(", ve; this.position < this.tokens.length && Q; )
            this.currToken[p.FIELDS.TYPE] === f.openParenthesis && Q++, this.currToken[p.FIELDS.TYPE] === f.closeParenthesis && Q--, ve = this.currToken, be += this.parseParenthesisToken(this.currToken), this.position++;
          N ? N.appendToPropertyAndEscape("value", be, be) : this.newNode(new l.default({
            value: be,
            source: z(ce[p.FIELDS.START_LINE], ce[p.FIELDS.START_COL], ve[p.FIELDS.END_LINE], ve[p.FIELDS.END_COL]),
            sourceIndex: ce[p.FIELDS.START_POS]
          }));
        }
        if (Q)
          return this.expected("closing parenthesis", this.currToken[p.FIELDS.START_POS]);
      }, oe.pseudo = function() {
        for (var N = this, Q = "", de = this.currToken; this.currToken && this.currToken[p.FIELDS.TYPE] === f.colon; )
          Q += this.content(), this.position++;
        if (!this.currToken)
          return this.expected(["pseudo-class", "pseudo-element"], this.position - 1);
        if (this.currToken[p.FIELDS.TYPE] === f.word)
          this.splitWord(!1, function(G, ce) {
            Q += G, N.newNode(new u.default({
              value: Q,
              source: q(de, N.currToken),
              sourceIndex: de[p.FIELDS.START_POS]
            })), ce > 1 && N.nextToken && N.nextToken[p.FIELDS.TYPE] === f.openParenthesis && N.error("Misplaced parenthesis.", {
              index: N.nextToken[p.FIELDS.START_POS]
            });
          });
        else
          return this.expected(["pseudo-class", "pseudo-element"], this.currToken[p.FIELDS.START_POS]);
      }, oe.space = function() {
        var N = this.content();
        this.position === 0 || this.prevToken[p.FIELDS.TYPE] === f.comma || this.prevToken[p.FIELDS.TYPE] === f.openParenthesis || this.current.nodes.every(function(Q) {
          return Q.type === "comment";
        }) ? (this.spaces = this.optionalSpace(N), this.position++) : this.position === this.tokens.length - 1 || this.nextToken[p.FIELDS.TYPE] === f.comma || this.nextToken[p.FIELDS.TYPE] === f.closeParenthesis ? (this.current.last.spaces.after = this.optionalSpace(N), this.position++) : this.combinator();
      }, oe.string = function() {
        var N = this.currToken;
        this.newNode(new l.default({
          value: this.content(),
          source: F(N),
          sourceIndex: N[p.FIELDS.START_POS]
        })), this.position++;
      }, oe.universal = function(N) {
        var Q = this.nextToken;
        if (Q && this.content(Q) === "|")
          return this.position++, this.namespace();
        var de = this.currToken;
        this.newNode(new d.default({
          value: this.content(),
          source: F(de),
          sourceIndex: de[p.FIELDS.START_POS]
        }), N), this.position++;
      }, oe.splitWord = function(N, Q) {
        for (var de = this, G = this.nextToken, ce = this.content(); G && ~[f.dollar, f.caret, f.equals, f.word].indexOf(G[p.FIELDS.TYPE]); ) {
          this.position++;
          var be = this.content();
          if (ce += be, be.lastIndexOf("\\") === be.length - 1) {
            var ve = this.nextToken;
            ve && ve[p.FIELDS.TYPE] === f.space && (ce += this.requiredSpace(this.content(ve)), this.position++);
          }
          G = this.nextToken;
        }
        var fe = D(ce, ".").filter(function(Me) {
          var Ct = ce[Me - 1] === "\\", _t = /^\d+\.\d+%$/.test(ce);
          return !Ct && !_t;
        }), Oe = D(ce, "#").filter(function(Me) {
          return ce[Me - 1] !== "\\";
        }), Ge = D(ce, "#{");
        Ge.length && (Oe = Oe.filter(function(Me) {
          return !~Ge.indexOf(Me);
        }));
        var we = (0, m.default)(H([0].concat(fe, Oe)));
        we.forEach(function(Me, Ct) {
          var _t = we[Ct + 1] || ce.length, vt = ce.slice(Me, _t);
          if (Ct === 0 && Q)
            return Q.call(de, vt, we.length);
          var st, rt = de.currToken, ut = rt[p.FIELDS.START_POS] + we[Ct], St = z(rt[1], rt[2] + Me, rt[3], rt[2] + (_t - 1));
          if (~fe.indexOf(Me)) {
            var xt = {
              value: vt.slice(1),
              source: St,
              sourceIndex: ut
            };
            st = new o.default(j(xt, "value"));
          } else if (~Oe.indexOf(Me)) {
            var gt = {
              value: vt.slice(1),
              source: St,
              sourceIndex: ut
            };
            st = new i.default(j(gt, "value"));
          } else {
            var Ft = {
              value: vt,
              source: St,
              sourceIndex: ut
            };
            j(Ft, "value"), st = new s.default(Ft);
          }
          de.newNode(st, N), N = null;
        }), this.position++;
      }, oe.word = function(N) {
        var Q = this.nextToken;
        return Q && this.content(Q) === "|" ? (this.position++, this.namespace()) : this.splitWord(N);
      }, oe.loop = function() {
        for (; this.position < this.tokens.length; )
          this.parse(!0);
        return this.current._inferEndPosition(), this.root;
      }, oe.parse = function(N) {
        switch (this.currToken[p.FIELDS.TYPE]) {
          case f.space:
            this.space();
            break;
          case f.comment:
            this.comment();
            break;
          case f.openParenthesis:
            this.parentheses();
            break;
          case f.closeParenthesis:
            N && this.missingParenthesis();
            break;
          case f.openSquare:
            this.attribute();
            break;
          case f.dollar:
          case f.caret:
          case f.equals:
          case f.word:
            this.word();
            break;
          case f.colon:
            this.pseudo();
            break;
          case f.comma:
            this.comma();
            break;
          case f.asterisk:
            this.universal();
            break;
          case f.ampersand:
            this.nesting();
            break;
          case f.slash:
          case f.combinator:
            this.combinator();
            break;
          case f.str:
            this.string();
            break;
          // These cases throw; no break needed.
          case f.closeSquare:
            this.missingSquareBracket();
          case f.semicolon:
            this.missingBackslash();
          default:
            this.unexpected();
        }
      }, oe.expected = function(N, Q, de) {
        if (Array.isArray(N)) {
          var G = N.pop();
          N = N.join(", ") + " or " + G;
        }
        var ce = /^[aeiou]/.test(N[0]) ? "an" : "a";
        return de ? this.error("Expected " + ce + " " + N + ', found "' + de + '" instead.', {
          index: Q
        }) : this.error("Expected " + ce + " " + N + ".", {
          index: Q
        });
      }, oe.requiredSpace = function(N) {
        return this.options.lossy ? " " : N;
      }, oe.optionalSpace = function(N) {
        return this.options.lossy ? "" : N;
      }, oe.lossySpace = function(N, Q) {
        return this.options.lossy ? Q ? " " : "" : N;
      }, oe.parseParenthesisToken = function(N) {
        var Q = this.content(N);
        return N[p.FIELDS.TYPE] === f.space ? this.requiredSpace(Q) : Q;
      }, oe.newNode = function(N, Q) {
        return Q && (/^ +$/.test(Q) && (this.options.lossy || (this.spaces = (this.spaces || "") + Q), Q = !0), N.namespace = Q, j(N, "namespace")), this.spaces && (N.spaces.before = this.spaces, this.spaces = ""), this.current.append(N);
      }, oe.content = function(N) {
        return N === void 0 && (N = this.currToken), this.css.slice(N[p.FIELDS.START_POS], N[p.FIELDS.END_POS]);
      }, oe.locateNextMeaningfulToken = function(N) {
        N === void 0 && (N = this.position + 1);
        for (var Q = N; Q < this.tokens.length; )
          if (R[this.tokens[Q][p.FIELDS.TYPE]]) {
            Q++;
            continue;
          } else
            return Q;
        return -1;
      }, C(ee, [{
        key: "currToken",
        get: function() {
          return this.tokens[this.position];
        }
      }, {
        key: "nextToken",
        get: function() {
          return this.tokens[this.position + 1];
        }
      }, {
        key: "prevToken",
        get: function() {
          return this.tokens[this.position - 1];
        }
      }]), ee;
    }();
    t.default = W, e.exports = t.default;
  }(Aa, Aa.exports)), Aa.exports;
}
var fm;
function z_() {
  return fm || (fm = 1, function(e, t) {
    t.__esModule = !0, t.default = void 0;
    var r = n(N_());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    var o = /* @__PURE__ */ function() {
      function a(s, l) {
        this.func = s || function() {
        }, this.funcRes = null, this.options = l;
      }
      var i = a.prototype;
      return i._shouldUpdateSelector = function(l, u) {
        u === void 0 && (u = {});
        var c = Object.assign({}, this.options, u);
        return c.updateSelector === !1 ? !1 : typeof l != "string";
      }, i._isLossy = function(l) {
        l === void 0 && (l = {});
        var u = Object.assign({}, this.options, l);
        return u.lossless === !1;
      }, i._root = function(l, u) {
        u === void 0 && (u = {});
        var c = new r.default(l, this._parseOptions(u));
        return c.root;
      }, i._parseOptions = function(l) {
        return {
          lossy: this._isLossy(l)
        };
      }, i._run = function(l, u) {
        var c = this;
        return u === void 0 && (u = {}), new Promise(function(d, h) {
          try {
            var y = c._root(l, u);
            Promise.resolve(c.func(y)).then(function(m) {
              var p = void 0;
              return c._shouldUpdateSelector(l, u) && (p = y.toString(), l.selector = p), {
                transform: m,
                root: y,
                string: p
              };
            }).then(d, h);
          } catch (m) {
            h(m);
            return;
          }
        });
      }, i._runSync = function(l, u) {
        u === void 0 && (u = {});
        var c = this._root(l, u), d = this.func(c);
        if (d && typeof d.then == "function")
          throw new Error("Selector processor returned a promise to a synchronous call.");
        var h = void 0;
        return u.updateSelector && typeof l != "string" && (h = c.toString(), l.selector = h), {
          transform: d,
          root: c,
          string: h
        };
      }, i.ast = function(l, u) {
        return this._run(l, u).then(function(c) {
          return c.root;
        });
      }, i.astSync = function(l, u) {
        return this._runSync(l, u).root;
      }, i.transform = function(l, u) {
        return this._run(l, u).then(function(c) {
          return c.transform;
        });
      }, i.transformSync = function(l, u) {
        return this._runSync(l, u).transform;
      }, i.process = function(l, u) {
        return this._run(l, u).then(function(c) {
          return c.string || c.root.toString();
        });
      }, i.processSync = function(l, u) {
        var c = this._runSync(l, u);
        return c.string || c.root.toString();
      }, a;
    }();
    t.default = o, e.exports = t.default;
  }(xa, xa.exports)), xa.exports;
}
var Vl = {}, Xe = {}, pm;
function j_() {
  if (pm) return Xe;
  pm = 1, Xe.__esModule = !0, Xe.universal = Xe.tag = Xe.string = Xe.selector = Xe.root = Xe.pseudo = Xe.nesting = Xe.id = Xe.comment = Xe.combinator = Xe.className = Xe.attribute = void 0;
  var e = h(Q0()), t = h(G0()), r = h(tb()), n = h(K0()), o = h(Y0()), a = h(rb()), i = h(X0()), s = h(V0()), l = h(H0()), u = h(Z0()), c = h(J0()), d = h(eb());
  function h(C) {
    return C && C.__esModule ? C : { default: C };
  }
  var y = function(E) {
    return new e.default(E);
  };
  Xe.attribute = y;
  var m = function(E) {
    return new t.default(E);
  };
  Xe.className = m;
  var p = function(E) {
    return new r.default(E);
  };
  Xe.combinator = p;
  var f = function(E) {
    return new n.default(E);
  };
  Xe.comment = f;
  var v = function(E) {
    return new o.default(E);
  };
  Xe.id = v;
  var w = function(E) {
    return new a.default(E);
  };
  Xe.nesting = w;
  var _ = function(E) {
    return new i.default(E);
  };
  Xe.pseudo = _;
  var T = function(E) {
    return new s.default(E);
  };
  Xe.root = T;
  var A = function(E) {
    return new l.default(E);
  };
  Xe.selector = A;
  var O = function(E) {
    return new u.default(E);
  };
  Xe.string = O;
  var M = function(E) {
    return new c.default(E);
  };
  Xe.tag = M;
  var I = function(E) {
    return new d.default(E);
  };
  return Xe.universal = I, Xe;
}
var Ue = {}, hm;
function U_() {
  if (hm) return Ue;
  hm = 1, Ue.__esModule = !0, Ue.isNode = n, Ue.isPseudoElement = v, Ue.isPseudoClass = w, Ue.isContainer = _, Ue.isNamespace = T, Ue.isUniversal = Ue.isTag = Ue.isString = Ue.isSelector = Ue.isRoot = Ue.isPseudo = Ue.isNesting = Ue.isIdentifier = Ue.isComment = Ue.isCombinator = Ue.isClassName = Ue.isAttribute = void 0;
  var e = Kt(), t, r = (t = {}, t[e.ATTRIBUTE] = !0, t[e.CLASS] = !0, t[e.COMBINATOR] = !0, t[e.COMMENT] = !0, t[e.ID] = !0, t[e.NESTING] = !0, t[e.PSEUDO] = !0, t[e.ROOT] = !0, t[e.SELECTOR] = !0, t[e.STRING] = !0, t[e.TAG] = !0, t[e.UNIVERSAL] = !0, t);
  function n(A) {
    return typeof A == "object" && r[A.type];
  }
  function o(A, O) {
    return n(O) && O.type === A;
  }
  var a = o.bind(null, e.ATTRIBUTE);
  Ue.isAttribute = a;
  var i = o.bind(null, e.CLASS);
  Ue.isClassName = i;
  var s = o.bind(null, e.COMBINATOR);
  Ue.isCombinator = s;
  var l = o.bind(null, e.COMMENT);
  Ue.isComment = l;
  var u = o.bind(null, e.ID);
  Ue.isIdentifier = u;
  var c = o.bind(null, e.NESTING);
  Ue.isNesting = c;
  var d = o.bind(null, e.PSEUDO);
  Ue.isPseudo = d;
  var h = o.bind(null, e.ROOT);
  Ue.isRoot = h;
  var y = o.bind(null, e.SELECTOR);
  Ue.isSelector = y;
  var m = o.bind(null, e.STRING);
  Ue.isString = m;
  var p = o.bind(null, e.TAG);
  Ue.isTag = p;
  var f = o.bind(null, e.UNIVERSAL);
  Ue.isUniversal = f;
  function v(A) {
    return d(A) && A.value && (A.value.startsWith("::") || A.value.toLowerCase() === ":before" || A.value.toLowerCase() === ":after" || A.value.toLowerCase() === ":first-letter" || A.value.toLowerCase() === ":first-line");
  }
  function w(A) {
    return d(A) && !v(A);
  }
  function _(A) {
    return !!(n(A) && A.walk);
  }
  function T(A) {
    return a(A) || p(A);
  }
  return Ue;
}
var mm;
function W_() {
  return mm || (mm = 1, function(e) {
    e.__esModule = !0;
    var t = Kt();
    Object.keys(t).forEach(function(o) {
      o === "default" || o === "__esModule" || o in e && e[o] === t[o] || (e[o] = t[o]);
    });
    var r = j_();
    Object.keys(r).forEach(function(o) {
      o === "default" || o === "__esModule" || o in e && e[o] === r[o] || (e[o] = r[o]);
    });
    var n = U_();
    Object.keys(n).forEach(function(o) {
      o === "default" || o === "__esModule" || o in e && e[o] === n[o] || (e[o] = n[o]);
    });
  }(Vl)), Vl;
}
var vm;
function V_() {
  return vm || (vm = 1, function(e, t) {
    t.__esModule = !0, t.default = void 0;
    var r = i(z_()), n = a(W_());
    function o() {
      if (typeof WeakMap != "function") return null;
      var u = /* @__PURE__ */ new WeakMap();
      return o = function() {
        return u;
      }, u;
    }
    function a(u) {
      if (u && u.__esModule)
        return u;
      if (u === null || typeof u != "object" && typeof u != "function")
        return { default: u };
      var c = o();
      if (c && c.has(u))
        return c.get(u);
      var d = {}, h = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var y in u)
        if (Object.prototype.hasOwnProperty.call(u, y)) {
          var m = h ? Object.getOwnPropertyDescriptor(u, y) : null;
          m && (m.get || m.set) ? Object.defineProperty(d, y, m) : d[y] = u[y];
        }
      return d.default = u, c && c.set(u, d), d;
    }
    function i(u) {
      return u && u.__esModule ? u : { default: u };
    }
    var s = function(c) {
      return new r.default(c);
    };
    Object.assign(s, n), delete s.__esModule;
    var l = s;
    t.default = l, e.exports = t.default;
  }(Sa, Sa.exports)), Sa.exports;
}
var Hl, gm;
function H_() {
  if (gm) return Hl;
  gm = 1;
  const e = D_(), t = V_(), r = t();
  return Hl = {
    isUsableColor(n, o) {
      return e(o) && n !== "gray" && o[600];
    },
    /**
     * @param {string} selector
     */
    commonTrailingPseudos(n) {
      let o = r.astSync(n), a = [];
      for (let [s, l] of o.nodes.entries())
        for (const [u, c] of [...l.nodes].reverse().entries()) {
          if (c.type !== "pseudo" || !c.value.startsWith("::"))
            break;
          a[u] = a[u] || [], a[u][s] = c;
        }
      let i = t.selector();
      for (const s of a) {
        if (!s)
          continue;
        if (new Set(s.map((u) => u.value)).size > 1)
          break;
        s.forEach((u) => u.remove()), i.prepend(s[0]);
      }
      return i.nodes.length ? [i.toString(), o.toString()] : [null, n];
    }
  }, Hl;
}
var Gl, ym;
function G_() {
  if (ym) return Gl;
  ym = 1;
  const e = C_(), t = k_(), r = P_(), n = I_(), { commonTrailingPseudos: o } = H_(), a = {
    // Reserved for future "magic properties", for example:
    // bulletColor: (color) => ({ 'ul > li::before': { backgroundColor: color } }),
  };
  function i(u, { className: c, modifier: d, prefix: h }) {
    let y = h(`.not-${c}`).slice(1), m = u.startsWith(">") ? `${d === "DEFAULT" ? `.${c}` : `.${c}-${d}`} ` : "", [p, f] = o(u);
    return p ? `:where(${m}${f}):not(:where([class~="${y}"],[class~="${y}"] *))${p}` : `:where(${m}${u}):not(:where([class~="${y}"],[class~="${y}"] *))`;
  }
  function s(u) {
    return typeof u == "object" && u !== null;
  }
  function l(u = {}, { target: c, className: d, modifier: h, prefix: y }) {
    function m(p, f) {
      return c === "legacy" ? [p, f] : Array.isArray(f) ? [p, f] : s(f) ? Object.values(f).some(s) ? [
        i(p, { className: d, modifier: h, prefix: y }),
        f,
        Object.fromEntries(Object.entries(f).map(([w, _]) => m(w, _)))
      ] : [i(p, { className: d, modifier: h, prefix: y }), f] : [p, f];
    }
    return Object.fromEntries(
      Object.entries(
        t(
          {},
          ...Object.keys(u).filter((p) => a[p]).map((p) => a[p](u[p])),
          ...r(u.css || {})
        )
      ).map(([p, f]) => m(p, f))
    );
  }
  return Gl = e.withOptions(
    ({ className: u = "prose", target: c = "modern" } = {}) => function({ addVariant: d, addComponents: h, theme: y, prefix: m }) {
      let p = y("typography"), f = { className: u, prefix: m };
      for (let [v, ...w] of [
        ["headings", "h1", "h2", "h3", "h4", "h5", "h6", "th"],
        ["h1"],
        ["h2"],
        ["h3"],
        ["h4"],
        ["h5"],
        ["h6"],
        ["p"],
        ["a"],
        ["blockquote"],
        ["figure"],
        ["figcaption"],
        ["strong"],
        ["em"],
        ["kbd"],
        ["code"],
        ["pre"],
        ["ol"],
        ["ul"],
        ["li"],
        ["table"],
        ["thead"],
        ["tr"],
        ["th"],
        ["td"],
        ["img"],
        ["video"],
        ["hr"],
        ["lead", '[class~="lead"]']
      ]) {
        w = w.length === 0 ? [v] : w;
        let _ = c === "legacy" ? w.map((T) => `& ${T}`) : w.join(", ");
        d(
          `${u}-${v}`,
          c === "legacy" ? _ : `& :is(${i(_, f)})`
        );
      }
      h(
        Object.keys(p).map((v) => ({
          [v === "DEFAULT" ? `.${u}` : `.${u}-${v}`]: l(
            p[v],
            {
              target: c,
              className: u,
              modifier: v,
              prefix: m
            }
          )
        }))
      );
    },
    () => ({
      theme: { typography: n }
    })
  ), Gl;
}
var K_ = G_();
const Y_ = /* @__PURE__ */ ui(K_), bm = S_.slate[300], J_ = {
  darkMode: "selector",
  content: [
    "./index.html",
    "./docs/**/*.vue",
    "./src/**/*.{vue,js,ts,jsx,tsx}",
    "./stories/**/*.{vue,js,ts,jsx,tsx}"
  ],
  theme: {
    extend: {
      keyframes: {
        hide: {
          from: { opacity: "1" },
          to: { opacity: "0" }
        },
        show: {
          from: { opacity: "0" },
          to: { opacity: "1" }
        },
        slideDownAndFade: {
          from: { opacity: "0", transform: "translateY(-6px)" },
          to: { opacity: "1", transform: "translateY(0)" }
        }
      },
      animation: {
        hide: "hide 250ms cubic-bezier(0.16, 1, 0.3, 1)",
        show: "show 250ms cubic-bezier(0.16, 1, 0.3, 1)",
        slideDownAndFade: "slideDownAndFade 250ms cubic-bezier(0.16, 1, 0.3, 1)"
      },
      maxWidth: {
        "8xl": "90rem"
      },
      borderColor: {
        DEFAULT: bm
      },
      fontFamily: {
        sans: ["Inter Var", ...E_.fontFamily.sans]
      },
      colors: {
        border: bm,
        brand: {
          50: "#EAF5FB",
          100: "#D5E7F6",
          200: "#AAC5EE",
          300: "#809BE5",
          400: "#5668DC",
          500: "#2B2BD1",
          600: "#2335A9",
          700: "#1A357F",
          800: "#112C55",
          900: "#091B2A",
          950: "#041015"
        }
      }
    }
  },
  plugins: [
    Y_
  ]
}, Z_ = w_(J_), wm = Z_.theme.colors;
function bt(e, t) {
  if (!wm[e])
    throw new Error(`Color '${e}' does not exist in the Tailwind CSS color palette.`);
  return wm[e][t];
}
function Kl(e, t) {
  return e - t * Math.floor(e / t);
}
const ob = 1721426;
function Wa(e, t, r, n) {
  t = vp(e, t);
  let o = t - 1, a = -2;
  return r <= 2 ? a = 0 : ds(t) && (a = -1), ob - 1 + 365 * o + Math.floor(o / 4) - Math.floor(o / 100) + Math.floor(o / 400) + Math.floor((367 * r - 362) / 12 + a + n);
}
function ds(e) {
  return e % 4 === 0 && (e % 100 !== 0 || e % 400 === 0);
}
function vp(e, t) {
  return e === "BC" ? 1 - t : t;
}
function X_(e) {
  let t = "AD";
  return e <= 0 && (t = "BC", e = 1 - e), [
    t,
    e
  ];
}
const Q_ = {
  standard: [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
  ],
  leapyear: [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
  ]
};
class Xo {
  fromJulianDay(t) {
    let r = t, n = r - ob, o = Math.floor(n / 146097), a = Kl(n, 146097), i = Math.floor(a / 36524), s = Kl(a, 36524), l = Math.floor(s / 1461), u = Kl(s, 1461), c = Math.floor(u / 365), d = o * 400 + i * 100 + l * 4 + c + (i !== 4 && c !== 4 ? 1 : 0), [h, y] = X_(d), m = r - Wa(h, y, 1, 1), p = 2;
    r < Wa(h, y, 3, 1) ? p = 0 : ds(y) && (p = 1);
    let f = Math.floor(((m + p) * 12 + 373) / 367), v = r - Wa(h, y, f, 1) + 1;
    return new ti(h, y, f, v);
  }
  toJulianDay(t) {
    return Wa(t.era, t.year, t.month, t.day);
  }
  getDaysInMonth(t) {
    return Q_[ds(t.year) ? "leapyear" : "standard"][t.month - 1];
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getMonthsInYear(t) {
    return 12;
  }
  getDaysInYear(t) {
    return ds(t.year) ? 366 : 365;
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getYearsInEra(t) {
    return 9999;
  }
  getEras() {
    return [
      "BC",
      "AD"
    ];
  }
  isInverseEra(t) {
    return t.era === "BC";
  }
  balanceDate(t) {
    t.year <= 0 && (t.era = t.era === "BC" ? "AD" : "BC", t.year = 1 - t.year);
  }
  constructor() {
    this.identifier = "gregory";
  }
}
const eS = {
  "001": 1,
  AD: 1,
  AE: 6,
  AF: 6,
  AI: 1,
  AL: 1,
  AM: 1,
  AN: 1,
  AR: 1,
  AT: 1,
  AU: 1,
  AX: 1,
  AZ: 1,
  BA: 1,
  BE: 1,
  BG: 1,
  BH: 6,
  BM: 1,
  BN: 1,
  BY: 1,
  CH: 1,
  CL: 1,
  CM: 1,
  CN: 1,
  CR: 1,
  CY: 1,
  CZ: 1,
  DE: 1,
  DJ: 6,
  DK: 1,
  DZ: 6,
  EC: 1,
  EE: 1,
  EG: 6,
  ES: 1,
  FI: 1,
  FJ: 1,
  FO: 1,
  FR: 1,
  GB: 1,
  GE: 1,
  GF: 1,
  GP: 1,
  GR: 1,
  HR: 1,
  HU: 1,
  IE: 1,
  IQ: 6,
  IR: 6,
  IS: 1,
  IT: 1,
  JO: 6,
  KG: 1,
  KW: 6,
  KZ: 1,
  LB: 1,
  LI: 1,
  LK: 1,
  LT: 1,
  LU: 1,
  LV: 1,
  LY: 6,
  MC: 1,
  MD: 1,
  ME: 1,
  MK: 1,
  MN: 1,
  MQ: 1,
  MV: 5,
  MY: 1,
  NL: 1,
  NO: 1,
  NZ: 1,
  OM: 6,
  PL: 1,
  QA: 6,
  RE: 1,
  RO: 1,
  RS: 1,
  RU: 1,
  SD: 6,
  SE: 1,
  SI: 1,
  SK: 1,
  SM: 1,
  SY: 6,
  TJ: 1,
  TM: 1,
  TR: 1,
  UA: 1,
  UY: 1,
  UZ: 1,
  VA: 1,
  VN: 1,
  XK: 1
};
function ib(e, t, r) {
  let n = e.calendar.toJulianDay(e), o = sS(t), a = Math.ceil(n + 1 - o) % 7;
  return a < 0 && (a += 7), a;
}
function tS(e) {
  return _n(Date.now(), e);
}
function rS(e) {
  return cS(tS(e));
}
function ab(e, t) {
  return e.calendar.toJulianDay(e) - t.calendar.toJulianDay(t);
}
function nS(e, t) {
  return _m(e) - _m(t);
}
function _m(e) {
  return e.hour * 36e5 + e.minute * 6e4 + e.second * 1e3 + e.millisecond;
}
let Yl = null;
function oa() {
  return Yl == null && (Yl = new Intl.DateTimeFormat().resolvedOptions().timeZone), Yl;
}
function oS(e) {
  return e.subtract({
    days: e.day - 1
  });
}
function iS(e, t, r) {
  let n = ib(e, t);
  return e.subtract({
    days: n
  });
}
const Sm = /* @__PURE__ */ new Map();
function aS(e) {
  if (Intl.Locale) {
    let r = Sm.get(e);
    return r || (r = new Intl.Locale(e).maximize().region, r && Sm.set(e, r)), r;
  }
  let t = e.split("-")[1];
  return t === "u" ? void 0 : t;
}
function sS(e) {
  let t = aS(e);
  return t && eS[t] || 0;
}
function Qo(e) {
  e = Jr(e, new Xo());
  let t = vp(e.era, e.year);
  return sb(t, e.month, e.day, e.hour, e.minute, e.second, e.millisecond);
}
function sb(e, t, r, n, o, a, i) {
  let s = /* @__PURE__ */ new Date();
  return s.setUTCHours(n, o, a, i), s.setUTCFullYear(e, t - 1, r), s.getTime();
}
function Ef(e, t) {
  if (t === "UTC") return 0;
  if (e > 0 && t === oa()) return new Date(e).getTimezoneOffset() * -6e4;
  let { year: r, month: n, day: o, hour: a, minute: i, second: s } = lb(e, t);
  return sb(r, n, o, a, i, s, 0) - Math.floor(e / 1e3) * 1e3;
}
const xm = /* @__PURE__ */ new Map();
function lb(e, t) {
  let r = xm.get(t);
  r || (r = new Intl.DateTimeFormat("en-US", {
    timeZone: t,
    hour12: !1,
    era: "short",
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric"
  }), xm.set(t, r));
  let n = r.formatToParts(new Date(e)), o = {};
  for (let a of n) a.type !== "literal" && (o[a.type] = a.value);
  return {
    // Firefox returns B instead of BC... https://bugzilla.mozilla.org/show_bug.cgi?id=1752253
    year: o.era === "BC" || o.era === "B" ? -o.year + 1 : +o.year,
    month: +o.month,
    day: +o.day,
    hour: o.hour === "24" ? 0 : +o.hour,
    minute: +o.minute,
    second: +o.second
  };
}
const Am = 864e5;
function lS(e, t, r, n) {
  return (r === n ? [
    r
  ] : [
    r,
    n
  ]).filter((a) => uS(e, t, a));
}
function uS(e, t, r) {
  let n = lb(r, t);
  return e.year === n.year && e.month === n.month && e.day === n.day && e.hour === n.hour && e.minute === n.minute && e.second === n.second;
}
function wn(e, t, r = "compatible") {
  let n = ei(e);
  if (t === "UTC") return Qo(n);
  if (t === oa() && r === "compatible") {
    n = Jr(n, new Xo());
    let l = /* @__PURE__ */ new Date(), u = vp(n.era, n.year);
    return l.setFullYear(u, n.month - 1, n.day), l.setHours(n.hour, n.minute, n.second, n.millisecond), l.getTime();
  }
  let o = Qo(n), a = Ef(o - Am, t), i = Ef(o + Am, t), s = lS(n, t, o - a, o - i);
  if (s.length === 1) return s[0];
  if (s.length > 1) switch (r) {
    // 'compatible' means 'earlier' for "fall back" transitions
    case "compatible":
    case "earlier":
      return s[0];
    case "later":
      return s[s.length - 1];
    case "reject":
      throw new RangeError("Multiple possible absolute times found");
  }
  switch (r) {
    case "earlier":
      return Math.min(o - a, o - i);
    // 'compatible' means 'later' for "spring forward" transitions
    case "compatible":
    case "later":
      return Math.max(o - a, o - i);
    case "reject":
      throw new RangeError("No such absolute time found");
  }
}
function ub(e, t, r = "compatible") {
  return new Date(wn(e, t, r));
}
function _n(e, t) {
  let r = Ef(e, t), n = new Date(e + r), o = n.getUTCFullYear(), a = n.getUTCMonth() + 1, i = n.getUTCDate(), s = n.getUTCHours(), l = n.getUTCMinutes(), u = n.getUTCSeconds(), c = n.getUTCMilliseconds();
  return new ri(o < 1 ? "BC" : "AD", o < 1 ? -o + 1 : o, a, i, t, r, s, l, u, c);
}
function cS(e) {
  return new ti(e.calendar, e.era, e.year, e.month, e.day);
}
function ei(e, t) {
  let r = 0, n = 0, o = 0, a = 0;
  if ("timeZone" in e) ({ hour: r, minute: n, second: o, millisecond: a } = e);
  else if ("hour" in e && !t) return e;
  return t && ({ hour: r, minute: n, second: o, millisecond: a } = t), new As(e.calendar, e.era, e.year, e.month, e.day, r, n, o, a);
}
function Jr(e, t) {
  if (e.calendar.identifier === t.identifier) return e;
  let r = t.fromJulianDay(e.calendar.toJulianDay(e)), n = e.copy();
  return n.calendar = t, n.era = r.era, n.year = r.year, n.month = r.month, n.day = r.day, Eo(n), n;
}
function dS(e, t, r) {
  if (e instanceof ri)
    return e.timeZone === t ? e : pS(e, t);
  let n = wn(e, t, r);
  return _n(n, t);
}
function fS(e) {
  let t = Qo(e) - e.offset;
  return new Date(t);
}
function pS(e, t) {
  let r = Qo(e) - e.offset;
  return Jr(_n(r, t), e.calendar);
}
const Fi = 36e5;
function Fs(e, t) {
  let r = e.copy(), n = "hour" in r ? gS(r, t) : 0;
  Of(r, t.years || 0), r.calendar.balanceYearMonth && r.calendar.balanceYearMonth(r, e), r.month += t.months || 0, $f(r), cb(r), r.day += (t.weeks || 0) * 7, r.day += t.days || 0, r.day += n, hS(r), r.calendar.balanceDate && r.calendar.balanceDate(r), r.year < 1 && (r.year = 1, r.month = 1, r.day = 1);
  let o = r.calendar.getYearsInEra(r);
  if (r.year > o) {
    var a, i;
    let l = (a = (i = r.calendar).isInverseEra) === null || a === void 0 ? void 0 : a.call(i, r);
    r.year = o, r.month = l ? 1 : r.calendar.getMonthsInYear(r), r.day = l ? 1 : r.calendar.getDaysInMonth(r);
  }
  r.month < 1 && (r.month = 1, r.day = 1);
  let s = r.calendar.getMonthsInYear(r);
  return r.month > s && (r.month = s, r.day = r.calendar.getDaysInMonth(r)), r.day = Math.max(1, Math.min(r.calendar.getDaysInMonth(r), r.day)), r;
}
function Of(e, t) {
  var r, n;
  !((r = (n = e.calendar).isInverseEra) === null || r === void 0) && r.call(n, e) && (t = -t), e.year += t;
}
function $f(e) {
  for (; e.month < 1; )
    Of(e, -1), e.month += e.calendar.getMonthsInYear(e);
  let t = 0;
  for (; e.month > (t = e.calendar.getMonthsInYear(e)); )
    e.month -= t, Of(e, 1);
}
function hS(e) {
  for (; e.day < 1; )
    e.month--, $f(e), e.day += e.calendar.getDaysInMonth(e);
  for (; e.day > e.calendar.getDaysInMonth(e); )
    e.day -= e.calendar.getDaysInMonth(e), e.month++, $f(e);
}
function cb(e) {
  e.month = Math.max(1, Math.min(e.calendar.getMonthsInYear(e), e.month)), e.day = Math.max(1, Math.min(e.calendar.getDaysInMonth(e), e.day));
}
function Eo(e) {
  e.calendar.constrainDate && e.calendar.constrainDate(e), e.year = Math.max(1, Math.min(e.calendar.getYearsInEra(e), e.year)), cb(e);
}
function db(e) {
  let t = {};
  for (let r in e) typeof e[r] == "number" && (t[r] = -e[r]);
  return t;
}
function fb(e, t) {
  return Fs(e, db(t));
}
function gp(e, t) {
  let r = e.copy();
  return t.era != null && (r.era = t.era), t.year != null && (r.year = t.year), t.month != null && (r.month = t.month), t.day != null && (r.day = t.day), Eo(r), r;
}
function xs(e, t) {
  let r = e.copy();
  return t.hour != null && (r.hour = t.hour), t.minute != null && (r.minute = t.minute), t.second != null && (r.second = t.second), t.millisecond != null && (r.millisecond = t.millisecond), vS(r), r;
}
function mS(e) {
  e.second += Math.floor(e.millisecond / 1e3), e.millisecond = Va(e.millisecond, 1e3), e.minute += Math.floor(e.second / 60), e.second = Va(e.second, 60), e.hour += Math.floor(e.minute / 60), e.minute = Va(e.minute, 60);
  let t = Math.floor(e.hour / 24);
  return e.hour = Va(e.hour, 24), t;
}
function vS(e) {
  e.millisecond = Math.max(0, Math.min(e.millisecond, 1e3)), e.second = Math.max(0, Math.min(e.second, 59)), e.minute = Math.max(0, Math.min(e.minute, 59)), e.hour = Math.max(0, Math.min(e.hour, 23));
}
function Va(e, t) {
  let r = e % t;
  return r < 0 && (r += t), r;
}
function gS(e, t) {
  return e.hour += t.hours || 0, e.minute += t.minutes || 0, e.second += t.seconds || 0, e.millisecond += t.milliseconds || 0, mS(e);
}
function yp(e, t, r, n) {
  let o = e.copy();
  switch (t) {
    case "era": {
      let s = e.calendar.getEras(), l = s.indexOf(e.era);
      if (l < 0) throw new Error("Invalid era: " + e.era);
      l = Sn(l, r, 0, s.length - 1, n == null ? void 0 : n.round), o.era = s[l], Eo(o);
      break;
    }
    case "year":
      var a, i;
      !((a = (i = o.calendar).isInverseEra) === null || a === void 0) && a.call(i, o) && (r = -r), o.year = Sn(e.year, r, -1 / 0, 9999, n == null ? void 0 : n.round), o.year === -1 / 0 && (o.year = 1), o.calendar.balanceYearMonth && o.calendar.balanceYearMonth(o, e);
      break;
    case "month":
      o.month = Sn(e.month, r, 1, e.calendar.getMonthsInYear(e), n == null ? void 0 : n.round);
      break;
    case "day":
      o.day = Sn(e.day, r, 1, e.calendar.getDaysInMonth(e), n == null ? void 0 : n.round);
      break;
    default:
      throw new Error("Unsupported field " + t);
  }
  return e.calendar.balanceDate && e.calendar.balanceDate(o), Eo(o), o;
}
function pb(e, t, r, n) {
  let o = e.copy();
  switch (t) {
    case "hour": {
      let a = e.hour, i = 0, s = 23;
      if ((n == null ? void 0 : n.hourCycle) === 12) {
        let l = a >= 12;
        i = l ? 12 : 0, s = l ? 23 : 11;
      }
      o.hour = Sn(a, r, i, s, n == null ? void 0 : n.round);
      break;
    }
    case "minute":
      o.minute = Sn(e.minute, r, 0, 59, n == null ? void 0 : n.round);
      break;
    case "second":
      o.second = Sn(e.second, r, 0, 59, n == null ? void 0 : n.round);
      break;
    case "millisecond":
      o.millisecond = Sn(e.millisecond, r, 0, 999, n == null ? void 0 : n.round);
      break;
    default:
      throw new Error("Unsupported field " + t);
  }
  return o;
}
function Sn(e, t, r, n, o = !1) {
  if (o) {
    e += Math.sign(t), e < r && (e = n);
    let a = Math.abs(t);
    t > 0 ? e = Math.ceil(e / a) * a : e = Math.floor(e / a) * a, e > n && (e = r);
  } else
    e += t, e < r ? e = n - (r - e - 1) : e > n && (e = r + (e - n - 1));
  return e;
}
function hb(e, t) {
  let r;
  if (t.years != null && t.years !== 0 || t.months != null && t.months !== 0 || t.weeks != null && t.weeks !== 0 || t.days != null && t.days !== 0) {
    let o = Fs(ei(e), {
      years: t.years,
      months: t.months,
      weeks: t.weeks,
      days: t.days
    });
    r = wn(o, e.timeZone);
  } else
    r = Qo(e) - e.offset;
  r += t.milliseconds || 0, r += (t.seconds || 0) * 1e3, r += (t.minutes || 0) * 6e4, r += (t.hours || 0) * 36e5;
  let n = _n(r, e.timeZone);
  return Jr(n, e.calendar);
}
function yS(e, t) {
  return hb(e, db(t));
}
function bS(e, t, r, n) {
  switch (t) {
    case "hour": {
      let o = 0, a = 23;
      if ((n == null ? void 0 : n.hourCycle) === 12) {
        let m = e.hour >= 12;
        o = m ? 12 : 0, a = m ? 23 : 11;
      }
      let i = ei(e), s = Jr(xs(i, {
        hour: o
      }), new Xo()), l = [
        wn(s, e.timeZone, "earlier"),
        wn(s, e.timeZone, "later")
      ].filter((m) => _n(m, e.timeZone).day === s.day)[0], u = Jr(xs(i, {
        hour: a
      }), new Xo()), c = [
        wn(u, e.timeZone, "earlier"),
        wn(u, e.timeZone, "later")
      ].filter((m) => _n(m, e.timeZone).day === u.day).pop(), d = Qo(e) - e.offset, h = Math.floor(d / Fi), y = d % Fi;
      return d = Sn(h, r, Math.floor(l / Fi), Math.floor(c / Fi), n == null ? void 0 : n.round) * Fi + y, Jr(_n(d, e.timeZone), e.calendar);
    }
    case "minute":
    case "second":
    case "millisecond":
      return pb(e, t, r, n);
    case "era":
    case "year":
    case "month":
    case "day": {
      let o = yp(ei(e), t, r, n), a = wn(o, e.timeZone);
      return Jr(_n(a, e.timeZone), e.calendar);
    }
    default:
      throw new Error("Unsupported field " + t);
  }
}
function wS(e, t, r) {
  let n = ei(e), o = xs(gp(n, t), t);
  if (o.compare(n) === 0) return e;
  let a = wn(o, e.timeZone, r);
  return Jr(_n(a, e.timeZone), e.calendar);
}
const _S = /^([+-]\d{6}|\d{4})-(\d{2})-(\d{2})$/;
function Jl(e) {
  let t = e.match(_S);
  if (!t) throw new Error("Invalid ISO 8601 date string: " + e);
  let r = new ti(Zl(t[1], 0, 9999), Zl(t[2], 1, 12), 1);
  return r.day = Zl(t[3], 0, r.calendar.getDaysInMonth(r)), r;
}
function Zl(e, t, r) {
  let n = Number(e);
  if (n < t || n > r) throw new RangeError(`Value out of range: ${t} <= ${n} <= ${r}`);
  return n;
}
function SS(e) {
  return `${String(e.hour).padStart(2, "0")}:${String(e.minute).padStart(2, "0")}:${String(e.second).padStart(2, "0")}${e.millisecond ? String(e.millisecond / 1e3).slice(1) : ""}`;
}
function mb(e) {
  let t = Jr(e, new Xo()), r;
  return t.era === "BC" ? r = t.year === 1 ? "0000" : "-" + String(Math.abs(1 - t.year)).padStart(6, "00") : r = String(t.year).padStart(4, "0"), `${r}-${String(t.month).padStart(2, "0")}-${String(t.day).padStart(2, "0")}`;
}
function vb(e) {
  return `${mb(e)}T${SS(e)}`;
}
function xS(e) {
  let t = Math.sign(e) < 0 ? "-" : "+";
  e = Math.abs(e);
  let r = Math.floor(e / 36e5), n = e % 36e5 / 6e4;
  return `${t}${String(r).padStart(2, "0")}:${String(n).padStart(2, "0")}`;
}
function AS(e) {
  return `${vb(e)}${xS(e.offset)}[${e.timeZone}]`;
}
function TS(e, t) {
  if (t.has(e))
    throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function bp(e, t, r) {
  TS(e, t), t.set(e, r);
}
function wp(e) {
  let t = typeof e[0] == "object" ? e.shift() : new Xo(), r;
  if (typeof e[0] == "string") r = e.shift();
  else {
    let i = t.getEras();
    r = i[i.length - 1];
  }
  let n = e.shift(), o = e.shift(), a = e.shift();
  return [
    t,
    r,
    n,
    o,
    a
  ];
}
var ES = /* @__PURE__ */ new WeakMap();
class ti {
  /** Returns a copy of this date. */
  copy() {
    return this.era ? new ti(this.calendar, this.era, this.year, this.month, this.day) : new ti(this.calendar, this.year, this.month, this.day);
  }
  /** Returns a new `CalendarDate` with the given duration added to it. */
  add(t) {
    return Fs(this, t);
  }
  /** Returns a new `CalendarDate` with the given duration subtracted from it. */
  subtract(t) {
    return fb(this, t);
  }
  /** Returns a new `CalendarDate` with the given fields set to the provided values. Other fields will be constrained accordingly. */
  set(t) {
    return gp(this, t);
  }
  /**
  * Returns a new `CalendarDate` with the given field adjusted by a specified amount.
  * When the resulting value reaches the limits of the field, it wraps around.
  */
  cycle(t, r, n) {
    return yp(this, t, r, n);
  }
  /** Converts the date to a native JavaScript Date object, with the time set to midnight in the given time zone. */
  toDate(t) {
    return ub(this, t);
  }
  /** Converts the date to an ISO 8601 formatted string. */
  toString() {
    return mb(this);
  }
  /** Compares this date with another. A negative result indicates that this date is before the given one, and a positive date indicates that it is after. */
  compare(t) {
    return ab(this, t);
  }
  constructor(...t) {
    bp(this, ES, {
      writable: !0,
      value: void 0
    });
    let [r, n, o, a, i] = wp(t);
    this.calendar = r, this.era = n, this.year = o, this.month = a, this.day = i, Eo(this);
  }
}
var OS = /* @__PURE__ */ new WeakMap();
class As {
  /** Returns a copy of this date. */
  copy() {
    return this.era ? new As(this.calendar, this.era, this.year, this.month, this.day, this.hour, this.minute, this.second, this.millisecond) : new As(this.calendar, this.year, this.month, this.day, this.hour, this.minute, this.second, this.millisecond);
  }
  /** Returns a new `CalendarDateTime` with the given duration added to it. */
  add(t) {
    return Fs(this, t);
  }
  /** Returns a new `CalendarDateTime` with the given duration subtracted from it. */
  subtract(t) {
    return fb(this, t);
  }
  /** Returns a new `CalendarDateTime` with the given fields set to the provided values. Other fields will be constrained accordingly. */
  set(t) {
    return gp(xs(this, t), t);
  }
  /**
  * Returns a new `CalendarDateTime` with the given field adjusted by a specified amount.
  * When the resulting value reaches the limits of the field, it wraps around.
  */
  cycle(t, r, n) {
    switch (t) {
      case "era":
      case "year":
      case "month":
      case "day":
        return yp(this, t, r, n);
      default:
        return pb(this, t, r, n);
    }
  }
  /** Converts the date to a native JavaScript Date object in the given time zone. */
  toDate(t, r) {
    return ub(this, t, r);
  }
  /** Converts the date to an ISO 8601 formatted string. */
  toString() {
    return vb(this);
  }
  /** Compares this date with another. A negative result indicates that this date is before the given one, and a positive date indicates that it is after. */
  compare(t) {
    let r = ab(this, t);
    return r === 0 ? nS(this, ei(t)) : r;
  }
  constructor(...t) {
    bp(this, OS, {
      writable: !0,
      value: void 0
    });
    let [r, n, o, a, i] = wp(t);
    this.calendar = r, this.era = n, this.year = o, this.month = a, this.day = i, this.hour = t.shift() || 0, this.minute = t.shift() || 0, this.second = t.shift() || 0, this.millisecond = t.shift() || 0, Eo(this);
  }
}
var $S = /* @__PURE__ */ new WeakMap();
class ri {
  /** Returns a copy of this date. */
  copy() {
    return this.era ? new ri(this.calendar, this.era, this.year, this.month, this.day, this.timeZone, this.offset, this.hour, this.minute, this.second, this.millisecond) : new ri(this.calendar, this.year, this.month, this.day, this.timeZone, this.offset, this.hour, this.minute, this.second, this.millisecond);
  }
  /** Returns a new `ZonedDateTime` with the given duration added to it. */
  add(t) {
    return hb(this, t);
  }
  /** Returns a new `ZonedDateTime` with the given duration subtracted from it. */
  subtract(t) {
    return yS(this, t);
  }
  /** Returns a new `ZonedDateTime` with the given fields set to the provided values. Other fields will be constrained accordingly. */
  set(t, r) {
    return wS(this, t, r);
  }
  /**
  * Returns a new `ZonedDateTime` with the given field adjusted by a specified amount.
  * When the resulting value reaches the limits of the field, it wraps around.
  */
  cycle(t, r, n) {
    return bS(this, t, r, n);
  }
  /** Converts the date to a native JavaScript Date object. */
  toDate() {
    return fS(this);
  }
  /** Converts the date to an ISO 8601 formatted string, including the UTC offset and time zone identifier. */
  toString() {
    return AS(this);
  }
  /** Converts the date to an ISO 8601 formatted string in UTC. */
  toAbsoluteString() {
    return this.toDate().toISOString();
  }
  /** Compares this date with another. A negative result indicates that this date is before the given one, and a positive date indicates that it is after. */
  compare(t) {
    return this.toDate().getTime() - dS(t, this.timeZone).toDate().getTime();
  }
  constructor(...t) {
    bp(this, $S, {
      writable: !0,
      value: void 0
    });
    let [r, n, o, a, i] = wp(t), s = t.shift(), l = t.shift();
    this.calendar = r, this.era = n, this.year = o, this.month = a, this.day = i, this.timeZone = s, this.offset = l, this.hour = t.shift() || 0, this.minute = t.shift() || 0, this.second = t.shift() || 0, this.millisecond = t.shift() || 0, Eo(this);
  }
}
let Xl = /* @__PURE__ */ new Map();
class Ql {
  /** Formats a date as a string according to the locale and format options passed to the constructor. */
  format(t) {
    return this.formatter.format(t);
  }
  /** Formats a date to an array of parts such as separators, numbers, punctuation, and more. */
  formatToParts(t) {
    return this.formatter.formatToParts(t);
  }
  /** Formats a date range as a string. */
  formatRange(t, r) {
    if (typeof this.formatter.formatRange == "function")
      return this.formatter.formatRange(t, r);
    if (r < t) throw new RangeError("End date must be >= start date");
    return `${this.formatter.format(t)} – ${this.formatter.format(r)}`;
  }
  /** Formats a date range as an array of parts. */
  formatRangeToParts(t, r) {
    if (typeof this.formatter.formatRangeToParts == "function")
      return this.formatter.formatRangeToParts(t, r);
    if (r < t) throw new RangeError("End date must be >= start date");
    let n = this.formatter.formatToParts(t), o = this.formatter.formatToParts(r);
    return [
      ...n.map((a) => ({
        ...a,
        source: "startRange"
      })),
      {
        type: "literal",
        value: " – ",
        source: "shared"
      },
      ...o.map((a) => ({
        ...a,
        source: "endRange"
      }))
    ];
  }
  /** Returns the resolved formatting options based on the values passed to the constructor. */
  resolvedOptions() {
    let t = this.formatter.resolvedOptions();
    return PS() && (this.resolvedHourCycle || (this.resolvedHourCycle = IS(t.locale, this.options)), t.hourCycle = this.resolvedHourCycle, t.hour12 = this.resolvedHourCycle === "h11" || this.resolvedHourCycle === "h12"), t.calendar === "ethiopic-amete-alem" && (t.calendar = "ethioaa"), t;
  }
  constructor(t, r = {}) {
    this.formatter = gb(t, r), this.options = r;
  }
}
const CS = {
  true: {
    // Only Japanese uses the h11 style for 12 hour time. All others use h12.
    ja: "h11"
  },
  false: {}
};
function gb(e, t = {}) {
  if (typeof t.hour12 == "boolean" && kS()) {
    t = {
      ...t
    };
    let o = CS[String(t.hour12)][e.split("-")[0]], a = t.hour12 ? "h12" : "h23";
    t.hourCycle = o ?? a, delete t.hour12;
  }
  let r = e + (t ? Object.entries(t).sort((o, a) => o[0] < a[0] ? -1 : 1).join() : "");
  if (Xl.has(r)) return Xl.get(r);
  let n = new Intl.DateTimeFormat(e, t);
  return Xl.set(r, n), n;
}
let eu = null;
function kS() {
  return eu == null && (eu = new Intl.DateTimeFormat("en-US", {
    hour: "numeric",
    hour12: !1
  }).format(new Date(2020, 2, 3, 0)) === "24"), eu;
}
let tu = null;
function PS() {
  return tu == null && (tu = new Intl.DateTimeFormat("fr", {
    hour: "numeric",
    hour12: !1
  }).resolvedOptions().hourCycle === "h12"), tu;
}
function IS(e, t) {
  if (!t.timeStyle && !t.hour) return;
  e = e.replace(/(-u-)?-nu-[a-zA-Z0-9]+/, ""), e += (e.includes("-u-") ? "" : "-u") + "-nu-latn";
  let r = gb(e, {
    ...t,
    timeZone: void 0
    // use local timezone
  }), n = parseInt(r.formatToParts(new Date(2020, 2, 3, 0)).find((a) => a.type === "hour").value, 10), o = parseInt(r.formatToParts(new Date(2020, 2, 3, 23)).find((a) => a.type === "hour").value, 10);
  if (n === 0 && o === 23) return "h23";
  if (n === 24 && o === 23) return "h24";
  if (n === 0 && o === 11) return "h11";
  if (n === 12 && o === 11) return "h12";
  throw new Error("Unexpected hour cycle result");
}
function DS(e) {
  function t(a, i = oa()) {
    return a instanceof ri ? a.toDate() : a.toDate(i);
  }
  function r(a, i = {}) {
    return new Ql(e.value, i).format(t(a)).toString();
  }
  function n(a, i = "narrow") {
    return new Ql(e.value, {
      weekday: i
    }).format(a);
  }
  function o(a, i = {}) {
    return new Ql(e.value, {
      ...i,
      month: "long",
      year: "numeric"
    }).format(t(a));
  }
  return {
    format: r,
    dayOfWeek: n,
    fullMonthAndYear: o
  };
}
function RS(e, t) {
  const r = Jl(t.value), n = 6 * 7, o = DS(e), a = se(0), i = re(() => oS(r.add({ months: a.value }))), s = re(() => {
    const y = [], m = ib(i.value, e.value), p = i.value.subtract({ days: m });
    for (let f = 0; f < n; f++) {
      const v = p.add({ days: f });
      y.push({
        day: v.day,
        selected: v.toString() === Jl(t.value).toString(),
        inCurrentMonth: v.month === i.value.month,
        value: v.toString(),
        isToday: v.toString() === rS(oa()).toString()
      });
    }
    return y;
  }), l = re(() => o.fullMonthAndYear(i.value)), u = re(() => {
    const y = iS(i.value, e.value);
    return Array.from({ length: 7 }).map((m, p) => {
      const f = y.add({ days: p }).toDate(oa());
      return o.dayOfWeek(f, "short");
    });
  }), c = re(() => o.format(Jl(t.value), { dateStyle: "short" }));
  function d() {
    a.value -= 1;
  }
  function h() {
    a.value += 1;
  }
  return {
    displayDate: c,
    grid: s,
    monthName: l,
    next: h,
    previous: d,
    weekDays: u
  };
}
function yb(e) {
  return Bs() ? (up(e), !0) : !1;
}
function Tm() {
  const e = /* @__PURE__ */ new Set(), t = (a) => {
    e.delete(a);
  };
  return {
    on: (a) => {
      e.add(a);
      const i = () => t(a);
      return yb(i), {
        off: i
      };
    },
    off: t,
    trigger: (...a) => Promise.all(Array.from(e).map((i) => i(...a))),
    clear: () => {
      e.clear();
    }
  };
}
const ru = /* @__PURE__ */ new WeakMap(), MS = (...e) => {
  var t;
  const r = e[0], n = (t = rn()) == null ? void 0 : t.proxy;
  if (n == null && !C0())
    throw new Error("injectLocal must be called in setup");
  return n && ru.has(n) && r in ru.get(n) ? ru.get(n)[r] : je(...e);
};
function BS(e) {
  if (!us(e))
    return ws(e);
  const t = new Proxy({}, {
    get(r, n, o) {
      return S(Reflect.get(e.value, n, o));
    },
    set(r, n, o) {
      return us(e.value[n]) && !us(o) ? e.value[n].value = o : e.value[n] = o, !0;
    },
    deleteProperty(r, n) {
      return Reflect.deleteProperty(e.value, n);
    },
    has(r, n) {
      return Reflect.has(e.value, n);
    },
    ownKeys() {
      return Object.keys(e.value);
    },
    getOwnPropertyDescriptor() {
      return {
        enumerable: !0,
        configurable: !0
      };
    }
  });
  return ws(t);
}
function qS(e) {
  return BS(re(e));
}
function _p(e, ...t) {
  const r = t.flat(), n = r[0];
  return qS(() => Object.fromEntries(typeof n == "function" ? Object.entries(Qr(e)).filter(([o, a]) => !n($r(a), o)) : Object.entries(Qr(e)).filter((o) => !r.includes(o[0]))));
}
const Ns = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const LS = Object.prototype.toString, FS = (e) => LS.call(e) === "[object Object]", wo = () => {
}, NS = (e, t) => Object.prototype.hasOwnProperty.call(e, t), zS = /* @__PURE__ */ jS();
function jS() {
  var e, t;
  return Ns && ((e = window == null ? void 0 : window.navigator) == null ? void 0 : e.userAgent) && (/iP(?:ad|hone|od)/.test(window.navigator.userAgent) || ((t = window == null ? void 0 : window.navigator) == null ? void 0 : t.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
function bb(...e) {
  if (e.length !== 1)
    return _s(...e);
  const t = e[0];
  return typeof t == "function" ? qs($0(() => ({ get: t, set: wo }))) : se(t);
}
function US(e, t) {
  function r(...n) {
    return new Promise((o, a) => {
      Promise.resolve(e(() => t.apply(this, n), { fn: t, thisArg: this, args: n })).then(o).catch(a);
    });
  }
  return r;
}
const wb = (e) => e();
function WS(e = wb, t = {}) {
  const {
    initialState: r = "active"
  } = t, n = bb(r === "active");
  function o() {
    n.value = !1;
  }
  function a() {
    n.value = !0;
  }
  const i = (...s) => {
    n.value && e(...s);
  };
  return { isActive: qs(n), pause: o, resume: a, eventFilter: i };
}
function Em(e) {
  return e.endsWith("rem") ? Number.parseFloat(e) * 16 : Number.parseFloat(e);
}
function nu(e) {
  return Array.isArray(e) ? e : [e];
}
function VS(e) {
  return rn();
}
function HS(e, t, r = {}) {
  const {
    eventFilter: n = wb,
    ...o
  } = r;
  return at(
    e,
    US(
      n,
      t
    ),
    o
  );
}
function GS(e, t, r = {}) {
  const {
    eventFilter: n,
    initialState: o = "active",
    ...a
  } = r, { eventFilter: i, pause: s, resume: l, isActive: u } = WS(n, { initialState: o });
  return { stop: HS(
    e,
    t,
    {
      ...a,
      eventFilter: i
    }
  ), pause: s, resume: l, isActive: u };
}
function _b(e, t = !0, r) {
  VS() ? Lt(e, r) : t ? e() : Qe(e);
}
function KS(e, t, r) {
  return at(
    e,
    t,
    {
      ...r,
      immediate: !0
    }
  );
}
const ni = Ns ? window : void 0, YS = Ns ? window.document : void 0;
function Ko(e) {
  var t;
  const r = $r(e);
  return (t = r == null ? void 0 : r.$el) != null ? t : r;
}
function Or(...e) {
  const t = [], r = () => {
    t.forEach((s) => s()), t.length = 0;
  }, n = (s, l, u, c) => (s.addEventListener(l, u, c), () => s.removeEventListener(l, u, c)), o = re(() => {
    const s = nu($r(e[0])).filter((l) => l != null);
    return s.every((l) => typeof l != "string") ? s : void 0;
  }), a = KS(
    () => {
      var s, l;
      return [
        (l = (s = o.value) == null ? void 0 : s.map((u) => Ko(u))) != null ? l : [ni].filter((u) => u != null),
        nu($r(o.value ? e[1] : e[0])),
        nu(S(o.value ? e[2] : e[1])),
        // @ts-expect-error - TypeScript gets the correct types, but somehow still complains
        $r(o.value ? e[3] : e[2])
      ];
    },
    ([s, l, u, c]) => {
      if (r(), !(s != null && s.length) || !(l != null && l.length) || !(u != null && u.length))
        return;
      const d = FS(c) ? { ...c } : c;
      t.push(
        ...s.flatMap(
          (h) => l.flatMap(
            (y) => u.map((m) => n(h, y, m, d))
          )
        )
      );
    },
    { flush: "post" }
  ), i = () => {
    a(), r();
  };
  return yb(r), i;
}
let Om = !1;
function zs(e, t, r = {}) {
  const { window: n = ni, ignore: o = [], capture: a = !0, detectIframe: i = !1, controls: s = !1 } = r;
  if (!n)
    return s ? { stop: wo, cancel: wo, trigger: wo } : wo;
  if (zS && !Om) {
    Om = !0;
    const f = { passive: !0 };
    Array.from(n.document.body.children).forEach((v) => Or(v, "click", wo, f)), Or(n.document.documentElement, "click", wo, f);
  }
  let l = !0;
  const u = (f) => $r(o).some((v) => {
    if (typeof v == "string")
      return Array.from(n.document.querySelectorAll(v)).some((w) => w === f.target || f.composedPath().includes(w));
    {
      const w = Ko(v);
      return w && (f.target === w || f.composedPath().includes(w));
    }
  });
  function c(f) {
    const v = $r(f);
    return v && v.$.subTree.shapeFlag === 16;
  }
  function d(f, v) {
    const w = $r(f), _ = w.$.subTree && w.$.subTree.children;
    return _ == null || !Array.isArray(_) ? !1 : _.some((T) => T.el === v.target || v.composedPath().includes(T.el));
  }
  const h = (f) => {
    const v = Ko(e);
    if (f.target != null && !(!(v instanceof Element) && c(e) && d(e, f)) && !(!v || v === f.target || f.composedPath().includes(v))) {
      if ("detail" in f && f.detail === 0 && (l = !u(f)), !l) {
        l = !0;
        return;
      }
      t(f);
    }
  };
  let y = !1;
  const m = [
    Or(n, "click", (f) => {
      y || (y = !0, setTimeout(() => {
        y = !1;
      }, 0), h(f));
    }, { passive: !0, capture: a }),
    Or(n, "pointerdown", (f) => {
      const v = Ko(e);
      l = !u(f) && !!(v && !f.composedPath().includes(v));
    }, { passive: !0 }),
    i && Or(n, "blur", (f) => {
      setTimeout(() => {
        var v;
        const w = Ko(e);
        ((v = n.document.activeElement) == null ? void 0 : v.tagName) === "IFRAME" && !(w != null && w.contains(n.document.activeElement)) && t(f);
      }, 0);
    }, { passive: !0 })
  ].filter(Boolean), p = () => m.forEach((f) => f());
  return s ? {
    stop: p,
    cancel: () => {
      l = !1;
    },
    trigger: (f) => {
      l = !0, h(f), l = !1;
    }
  } : p;
}
function JS() {
  const e = Zr(!1), t = rn();
  return t && Lt(() => {
    e.value = !0;
  }, t), e;
}
function ZS(e) {
  const t = JS();
  return re(() => (t.value, !!e()));
}
const XS = Symbol("vueuse-ssr-width");
function QS() {
  const e = C0() ? MS(XS, null) : null;
  return typeof e == "number" ? e : void 0;
}
function e2(e, t = {}) {
  const { window: r = ni, ssrWidth: n = QS() } = t, o = ZS(() => r && "matchMedia" in r && typeof r.matchMedia == "function"), a = Zr(typeof n == "number"), i = Zr(), s = Zr(!1), l = (u) => {
    s.value = u.matches;
  };
  return Pr(() => {
    if (a.value) {
      a.value = !o.value;
      const u = $r(e).split(",");
      s.value = u.some((c) => {
        const d = c.includes("not all"), h = c.match(/\(\s*min-width:\s*(-?\d+(?:\.\d*)?[a-z]+\s*)\)/), y = c.match(/\(\s*max-width:\s*(-?\d+(?:\.\d*)?[a-z]+\s*)\)/);
        let m = !!(h || y);
        return h && m && (m = n >= Em(h[1])), y && m && (m = n <= Em(y[1])), d ? !m : m;
      });
      return;
    }
    o.value && (i.value = r.matchMedia($r(e)), s.value = i.value.matches);
  }), Or(i, "change", l, { passive: !0 }), re(() => s.value);
}
const Ha = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, Ga = "__vueuse_ssr_handlers__", t2 = /* @__PURE__ */ r2();
function r2() {
  return Ga in Ha || (Ha[Ga] = Ha[Ga] || {}), Ha[Ga];
}
function Sb(e, t) {
  return t2[e] || t;
}
function n2(e) {
  return e2("(prefers-color-scheme: dark)", e);
}
function o2(e) {
  return e == null ? "any" : e instanceof Set ? "set" : e instanceof Map ? "map" : e instanceof Date ? "date" : typeof e == "boolean" ? "boolean" : typeof e == "string" ? "string" : typeof e == "object" ? "object" : Number.isNaN(e) ? "any" : "number";
}
const i2 = {
  boolean: {
    read: (e) => e === "true",
    write: (e) => String(e)
  },
  object: {
    read: (e) => JSON.parse(e),
    write: (e) => JSON.stringify(e)
  },
  number: {
    read: (e) => Number.parseFloat(e),
    write: (e) => String(e)
  },
  any: {
    read: (e) => e,
    write: (e) => String(e)
  },
  string: {
    read: (e) => e,
    write: (e) => String(e)
  },
  map: {
    read: (e) => new Map(JSON.parse(e)),
    write: (e) => JSON.stringify(Array.from(e.entries()))
  },
  set: {
    read: (e) => new Set(JSON.parse(e)),
    write: (e) => JSON.stringify(Array.from(e))
  },
  date: {
    read: (e) => new Date(e),
    write: (e) => e.toISOString()
  }
}, $m = "vueuse-storage";
function a2(e, t, r, n = {}) {
  var o;
  const {
    flush: a = "pre",
    deep: i = !0,
    listenToStorageChanges: s = !0,
    writeDefaults: l = !0,
    mergeDefaults: u = !1,
    shallow: c,
    window: d = ni,
    eventFilter: h,
    onError: y = (R) => {
      console.error(R);
    },
    initOnMounted: m
  } = n, p = (c ? Zr : se)(typeof t == "function" ? t() : t), f = re(() => $r(e));
  if (!r)
    try {
      r = Sb("getDefaultStorage", () => {
        var R;
        return (R = ni) == null ? void 0 : R.localStorage;
      })();
    } catch (R) {
      y(R);
    }
  if (!r)
    return p;
  const v = $r(t), w = o2(v), _ = (o = n.serializer) != null ? o : i2[w], { pause: T, resume: A } = GS(
    p,
    () => M(p.value),
    { flush: a, deep: i, eventFilter: h }
  );
  at(f, () => C(), { flush: a }), d && s && _b(() => {
    r instanceof Storage ? Or(d, "storage", C, { passive: !0 }) : Or(d, $m, E), m && C();
  }), m || C();
  function O(R, k) {
    if (d) {
      const L = {
        key: f.value,
        oldValue: R,
        newValue: k,
        storageArea: r
      };
      d.dispatchEvent(r instanceof Storage ? new StorageEvent("storage", L) : new CustomEvent($m, {
        detail: L
      }));
    }
  }
  function M(R) {
    try {
      const k = r.getItem(f.value);
      if (R == null)
        O(k, null), r.removeItem(f.value);
      else {
        const L = _.write(R);
        k !== L && (r.setItem(f.value, L), O(k, L));
      }
    } catch (k) {
      y(k);
    }
  }
  function I(R) {
    const k = R ? R.newValue : r.getItem(f.value);
    if (k == null)
      return l && v != null && r.setItem(f.value, _.write(v)), v;
    if (!R && u) {
      const L = _.read(k);
      return typeof u == "function" ? u(L, v) : w === "object" && !Array.isArray(L) ? { ...v, ...L } : L;
    } else return typeof k != "string" ? k : _.read(k);
  }
  function C(R) {
    if (!(R && R.storageArea !== r)) {
      if (R && R.key == null) {
        p.value = v;
        return;
      }
      if (!(R && R.key !== f.value)) {
        T();
        try {
          (R == null ? void 0 : R.newValue) !== _.write(p.value) && (p.value = I(R));
        } catch (k) {
          y(k);
        } finally {
          R ? Qe(A) : A();
        }
      }
    }
  }
  function E(R) {
    C(R.detail);
  }
  return p;
}
const s2 = "*,*::before,*::after{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}";
function l2(e = {}) {
  const {
    selector: t = "html",
    attribute: r = "class",
    initialValue: n = "auto",
    window: o = ni,
    storage: a,
    storageKey: i = "vueuse-color-scheme",
    listenToStorageChanges: s = !0,
    storageRef: l,
    emitAuto: u,
    disableTransition: c = !0
  } = e, d = {
    auto: "",
    light: "light",
    dark: "dark",
    ...e.modes || {}
  }, h = n2({ window: o }), y = re(() => h.value ? "dark" : "light"), m = l || (i == null ? bb(n) : a2(i, n, a, { window: o, listenToStorageChanges: s })), p = re(() => m.value === "auto" ? y.value : m.value), f = Sb(
    "updateHTMLAttrs",
    (T, A, O) => {
      const M = typeof T == "string" ? o == null ? void 0 : o.document.querySelector(T) : Ko(T);
      if (!M)
        return;
      const I = /* @__PURE__ */ new Set(), C = /* @__PURE__ */ new Set();
      let E = null;
      if (A === "class") {
        const k = O.split(/\s/g);
        Object.values(d).flatMap((L) => (L || "").split(/\s/g)).filter(Boolean).forEach((L) => {
          k.includes(L) ? I.add(L) : C.add(L);
        });
      } else
        E = { key: A, value: O };
      if (I.size === 0 && C.size === 0 && E === null)
        return;
      let R;
      c && (R = o.document.createElement("style"), R.appendChild(document.createTextNode(s2)), o.document.head.appendChild(R));
      for (const k of I)
        M.classList.add(k);
      for (const k of C)
        M.classList.remove(k);
      E && M.setAttribute(E.key, E.value), c && (o.getComputedStyle(R).opacity, document.head.removeChild(R));
    }
  );
  function v(T) {
    var A;
    f(t, r, (A = d[T]) != null ? A : T);
  }
  function w(T) {
    e.onChanged ? e.onChanged(T, v) : v(T);
  }
  at(p, w, { flush: "post", immediate: !0 }), _b(() => w(p.value));
  const _ = re({
    get() {
      return u ? m.value : p.value;
    },
    set(T) {
      m.value = T;
    }
  });
  return Object.assign(_, { store: m, system: y, state: p });
}
function u2(e = {}) {
  const {
    valueDark: t = "dark",
    valueLight: r = ""
  } = e, n = l2({
    ...e,
    onChanged: (i, s) => {
      var l;
      e.onChanged ? (l = e.onChanged) == null || l.call(e, i === "dark", s, i) : s(i);
    },
    modes: {
      dark: t,
      light: r
    }
  }), o = re(() => n.system.value);
  return re({
    get() {
      return n.value === "dark";
    },
    set(i) {
      const s = i ? "dark" : "light";
      o.value === s ? n.value = "auto" : n.value = s;
    }
  });
}
function c2(e, t = {}) {
  var r, n;
  const o = Zr(!1), a = Zr(null);
  let i = 0, s = !0;
  if (Ns) {
    const l = typeof t == "function" ? { onDrop: t } : t, u = (r = l.multiple) != null ? r : !0, c = (n = l.preventDefaultForUnhandled) != null ? n : !1, d = (f) => {
      var v, w;
      const _ = Array.from((w = (v = f.dataTransfer) == null ? void 0 : v.files) != null ? w : []);
      return _.length === 0 ? null : u ? _ : [_[0]];
    }, h = (f) => {
      const v = S(l.dataTypes);
      return typeof v == "function" ? v(f) : v != null && v.length ? f.length === 0 ? !1 : f.every(
        (w) => v.some((_) => w.includes(_))
      ) : !0;
    }, y = (f) => {
      const v = Array.from(f ?? []).map((T) => T.type), w = h(v), _ = u || f.length <= 1;
      return w && _;
    }, m = () => /^(?:(?!chrome|android).)*safari/i.test(navigator.userAgent) && !("chrome" in window), p = (f, v) => {
      var w, _, T, A, O, M;
      const I = (w = f.dataTransfer) == null ? void 0 : w.items;
      if (s = (_ = I && y(I)) != null ? _ : !1, c && f.preventDefault(), !m() && !s) {
        f.dataTransfer && (f.dataTransfer.dropEffect = "none");
        return;
      }
      f.preventDefault(), f.dataTransfer && (f.dataTransfer.dropEffect = "copy");
      const C = d(f);
      switch (v) {
        case "enter":
          i += 1, o.value = !0, (T = l.onEnter) == null || T.call(l, null, f);
          break;
        case "over":
          (A = l.onOver) == null || A.call(l, null, f);
          break;
        case "leave":
          i -= 1, i === 0 && (o.value = !1), (O = l.onLeave) == null || O.call(l, null, f);
          break;
        case "drop":
          i = 0, o.value = !1, s && (a.value = C, (M = l.onDrop) == null || M.call(l, C, f));
          break;
      }
    };
    Or(e, "dragenter", (f) => p(f, "enter")), Or(e, "dragover", (f) => p(f, "over")), Or(e, "dragleave", (f) => p(f, "leave")), Or(e, "drop", (f) => p(f, "drop"));
  }
  return {
    files: a,
    isOverDropZone: o
  };
}
const Ni = /* @__PURE__ */ new Map();
function d2(e) {
  const t = Bs();
  function r(s) {
    var l;
    const u = Ni.get(e) || /* @__PURE__ */ new Set();
    u.add(s), Ni.set(e, u);
    const c = () => o(s);
    return (l = t == null ? void 0 : t.cleanups) == null || l.push(c), c;
  }
  function n(s) {
    function l(...u) {
      o(l), s(...u);
    }
    return r(l);
  }
  function o(s) {
    const l = Ni.get(e);
    l && (l.delete(s), l.size || a());
  }
  function a() {
    Ni.delete(e);
  }
  function i(s, l) {
    var u;
    (u = Ni.get(e)) == null || u.forEach((c) => c(s, l));
  }
  return { on: r, once: n, off: o, emit: i, reset: a };
}
const f2 = {
  multiple: !0,
  accept: "*",
  reset: !1,
  directory: !1
};
function p2(e) {
  if (!e)
    return null;
  if (e instanceof FileList)
    return e;
  const t = new DataTransfer();
  for (const r of e)
    t.items.add(r);
  return t.files;
}
function xb(e = {}) {
  const {
    document: t = YS
  } = e, r = se(p2(e.initialFiles)), { on: n, trigger: o } = Tm(), { on: a, trigger: i } = Tm();
  let s;
  t && (s = t.createElement("input"), s.type = "file", s.onchange = (c) => {
    const d = c.target;
    r.value = d.files, o(r.value);
  }, s.oncancel = () => {
    i();
  });
  const l = () => {
    r.value = null, s && s.value && (s.value = "", o(null));
  }, u = (c) => {
    if (!s)
      return;
    const d = {
      ...f2,
      ...e,
      ...c
    };
    s.multiple = d.multiple, s.accept = d.accept, s.webkitdirectory = d.directory, NS(d, "capture") && (s.capture = d.capture), d.reset && l(), s.click();
  };
  return {
    files: qs(r),
    open: u,
    reset: l,
    onCancel: a,
    onChange: n
  };
}
function js() {
  return globalThis.FOCUSUI_DARKMODE_SUPPORTED === !1 ? re(() => !1) : u2({
    selector: "html",
    valueDark: "dark",
    valueLight: "light"
  });
}
const h2 = {
  focus: {
    default: [
      "focus:ring-brand-100",
      "focus:ring-2",
      "focus:outline",
      "focus:outline-1",
      "focus:outline-offset-0",
      "focus:outline-brand-500/50"
    ],
    destructive: [
      "focus:ring-red-100",
      "focus:ring-2",
      "focus:outline",
      "focus:outline-1",
      "focus:outline-offset-0",
      "focus:outline-red-500/50"
    ]
  },
  focusWithin: {
    default: [
      "focus-within:border-brand-500",
      "focus-within:ring-brand-100",
      "focus-within:ring-2"
    ],
    destructive: [
      "focus-within:border-red-500",
      "focus-within:ring-red-100",
      "focus-within:ring-2"
    ]
  }
};
function Qt(e, t = "default") {
  return Array.isArray(e) ? e.map((r) => Qt(r, t)).join(" ") : h2[e][t];
}
function Je(e = "id") {
  return Math.random().toString(36).replace("0.", `${e}-` || "");
}
function y6() {
  const e = se([]), t = d2("toastNotifications");
  function r() {
    t.on(function(i) {
      e.value.push(i);
    });
  }
  function n(i) {
    e.value = e.value.filter((s) => s.id !== i.id);
  }
  function o(i) {
    i.id = Je("toast-notification"), t.emit(i);
  }
  function a(i) {
    i.forEach((s) => {
      s.id = Je("toast"), o(s);
    });
  }
  return {
    toastNotifications: e,
    initializeNotificationHandlers: r,
    closeToastNotification: n,
    emitToastNotificationEvent: o,
    emitToastNotificationEvents: a
  };
}
const m2 = { class: "border-b dark:border-zinc-700" }, b6 = /* @__PURE__ */ U({
  __name: "AccordionItem",
  setup(e) {
    const t = Je("accordionItem"), r = je("activeAccordionItem"), n = re(() => r.value === t);
    return tt("accordionItemId", t), tt("accordionItemActive", n), (o, a) => ($(), B("div", m2, [
      V(o.$slots, "default")
    ]));
  }
});
function v2(e, t) {
  return $(), B("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    X("path", {
      "fill-rule": "evenodd",
      d: "M14 8a.75.75 0 0 1-.75.75H4.56l3.22 3.22a.75.75 0 1 1-1.06 1.06l-4.5-4.5a.75.75 0 0 1 0-1.06l4.5-4.5a.75.75 0 0 1 1.06 1.06L4.56 7.25h8.69A.75.75 0 0 1 14 8Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function g2(e, t) {
  return $(), B("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    X("path", {
      "fill-rule": "evenodd",
      d: "M2 3.75A.75.75 0 0 1 2.75 3h10.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 3.75ZM2 8a.75.75 0 0 1 .75-.75h10.5a.75.75 0 0 1 0 1.5H2.75A.75.75 0 0 1 2 8Zm0 4.25a.75.75 0 0 1 .75-.75h10.5a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1-.75-.75Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function y2(e, t) {
  return $(), B("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    X("path", {
      "fill-rule": "evenodd",
      d: "M4 1.75a.75.75 0 0 1 1.5 0V3h5V1.75a.75.75 0 0 1 1.5 0V3a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2V1.75ZM4.5 6a1 1 0 0 0-1 1v4.5a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-7Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function b2(e, t) {
  return $(), B("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    X("path", {
      "fill-rule": "evenodd",
      d: "M12.416 3.376a.75.75 0 0 1 .208 1.04l-5 7.5a.75.75 0 0 1-1.154.114l-3-3a.75.75 0 0 1 1.06-1.06l2.353 2.353 4.493-6.74a.75.75 0 0 1 1.04-.207Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Ab(e, t) {
  return $(), B("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    X("path", {
      "fill-rule": "evenodd",
      d: "M4.22 6.22a.75.75 0 0 1 1.06 0L8 8.94l2.72-2.72a.75.75 0 1 1 1.06 1.06l-3.25 3.25a.75.75 0 0 1-1.06 0L4.22 7.28a.75.75 0 0 1 0-1.06Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Tb(e, t) {
  return $(), B("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    X("path", {
      "fill-rule": "evenodd",
      d: "M9.78 4.22a.75.75 0 0 1 0 1.06L7.06 8l2.72 2.72a.75.75 0 1 1-1.06 1.06L5.47 8.53a.75.75 0 0 1 0-1.06l3.25-3.25a.75.75 0 0 1 1.06 0Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Sp(e, t) {
  return $(), B("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    X("path", {
      "fill-rule": "evenodd",
      d: "M6.22 4.22a.75.75 0 0 1 1.06 0l3.25 3.25a.75.75 0 0 1 0 1.06l-3.25 3.25a.75.75 0 0 1-1.06-1.06L8.94 8 6.22 5.28a.75.75 0 0 1 0-1.06Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function w2(e, t) {
  return $(), B("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    X("path", {
      "fill-rule": "evenodd",
      d: "M5.22 10.22a.75.75 0 0 1 1.06 0L8 11.94l1.72-1.72a.75.75 0 1 1 1.06 1.06l-2.25 2.25a.75.75 0 0 1-1.06 0l-2.25-2.25a.75.75 0 0 1 0-1.06ZM10.78 5.78a.75.75 0 0 1-1.06 0L8 4.06 6.28 5.78a.75.75 0 0 1-1.06-1.06l2.25-2.25a.75.75 0 0 1 1.06 0l2.25 2.25a.75.75 0 0 1 0 1.06Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function _2(e, t) {
  return $(), B("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    X("path", {
      "fill-rule": "evenodd",
      d: "M11.78 9.78a.75.75 0 0 1-1.06 0L8 7.06 5.28 9.78a.75.75 0 0 1-1.06-1.06l3.25-3.25a.75.75 0 0 1 1.06 0l3.25 3.25a.75.75 0 0 1 0 1.06Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function S2(e, t) {
  return $(), B("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    X("path", { d: "M2 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0ZM6.5 8a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0ZM12.5 6.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z" })
  ]);
}
function x2(e, t) {
  return $(), B("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    X("path", {
      "fill-rule": "evenodd",
      d: "M3.28 2.22a.75.75 0 0 0-1.06 1.06l10.5 10.5a.75.75 0 1 0 1.06-1.06l-1.322-1.323a7.012 7.012 0 0 0 2.16-3.11.87.87 0 0 0 0-.567A7.003 7.003 0 0 0 4.82 3.76l-1.54-1.54Zm3.196 3.195 1.135 1.136A1.502 1.502 0 0 1 9.45 8.389l1.136 1.135a3 3 0 0 0-4.109-4.109Z",
      "clip-rule": "evenodd"
    }),
    X("path", { d: "m7.812 10.994 1.816 1.816A7.003 7.003 0 0 1 1.38 8.28a.87.87 0 0 1 0-.566 6.985 6.985 0 0 1 1.113-2.039l2.513 2.513a3 3 0 0 0 2.806 2.806Z" })
  ]);
}
function A2(e, t) {
  return $(), B("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    X("path", { d: "M8 9.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z" }),
    X("path", {
      "fill-rule": "evenodd",
      d: "M1.38 8.28a.87.87 0 0 1 0-.566 7.003 7.003 0 0 1 13.238.006.87.87 0 0 1 0 .566A7.003 7.003 0 0 1 1.379 8.28ZM11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Eb(e, t) {
  return $(), B("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    X("path", {
      "fill-rule": "evenodd",
      d: "M15 8A7 7 0 1 1 1 8a7 7 0 0 1 14 0ZM9 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM6.75 8a.75.75 0 0 0 0 1.5h.75v1.75a.75.75 0 0 0 1.5 0v-2.5A.75.75 0 0 0 8.25 8h-1.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function T2(e, t) {
  return $(), B("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    X("path", {
      "fill-rule": "evenodd",
      d: "M9.965 11.026a5 5 0 1 1 1.06-1.06l2.755 2.754a.75.75 0 1 1-1.06 1.06l-2.755-2.754ZM10.5 7a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function E2(e, t) {
  return $(), B("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    X("path", { d: "M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM12.735 14c.618 0 1.093-.561.872-1.139a6.002 6.002 0 0 0-11.215 0c-.22.578.254 1.139.872 1.139h9.47Z" })
  ]);
}
function ua(e, t) {
  return $(), B("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    X("path", { d: "M5.28 4.22a.75.75 0 0 0-1.06 1.06L6.94 8l-2.72 2.72a.75.75 0 1 0 1.06 1.06L8 9.06l2.72 2.72a.75.75 0 1 0 1.06-1.06L9.06 8l2.72-2.72a.75.75 0 0 0-1.06-1.06L8 6.94 5.28 4.22Z" })
  ]);
}
const Ve = /* @__PURE__ */ U({
  __name: "TextStyle",
  props: {
    subdued: { type: Boolean, default: !1 },
    strong: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, r = re(() => [
      { "text-slate-500 dark:text-zinc-500": t.subdued },
      { "font-medium": t.strong }
    ]);
    return (n, o) => ($(), B("span", {
      class: Te([r.value, "inline-block"])
    }, [
      V(n.$slots, "default")
    ], 2));
  }
}), O2 = ["aria-controls", "aria-expanded"], $2 = { class: "py-3 group-hover:underline" }, w6 = /* @__PURE__ */ U({
  __name: "AccordionTrigger",
  setup(e) {
    const t = je("activeAccordionItem"), r = je("accordionItemId"), n = je("accordionItemActive");
    function o() {
      t.value = t.value !== r ? r : null;
    }
    return (a, i) => ($(), B("button", {
      "aria-controls": S(r),
      "aria-expanded": S(n),
      class: "w-full flex flex-1 items-center justify-between group",
      onClick: o
    }, [
      X("span", $2, [
        ie(S(Ve), { strong: "" }, {
          default: Y(() => [
            V(a.$slots, "default")
          ]),
          _: 3
        })
      ]),
      S(n) ? _e("", !0) : ($(), ne(S(Ab), {
        key: 0,
        class: "size-4"
      })),
      S(n) ? ($(), ne(S(_2), {
        key: 1,
        class: "size-4"
      })) : _e("", !0)
    ], 8, O2));
  }
}), C2 = ["top", "right", "bottom", "left"], Zn = Math.min, vr = Math.max, Ts = Math.round, Ka = Math.floor, Xn = (e) => ({
  x: e,
  y: e
}), k2 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, P2 = {
  start: "end",
  end: "start"
};
function Cf(e, t, r) {
  return vr(e, Zn(t, r));
}
function An(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Tn(e) {
  return e.split("-")[0];
}
function ci(e) {
  return e.split("-")[1];
}
function xp(e) {
  return e === "x" ? "y" : "x";
}
function Ap(e) {
  return e === "y" ? "height" : "width";
}
function Qn(e) {
  return ["top", "bottom"].includes(Tn(e)) ? "y" : "x";
}
function Tp(e) {
  return xp(Qn(e));
}
function I2(e, t, r) {
  r === void 0 && (r = !1);
  const n = ci(e), o = Tp(e), a = Ap(o);
  let i = o === "x" ? n === (r ? "end" : "start") ? "right" : "left" : n === "start" ? "bottom" : "top";
  return t.reference[a] > t.floating[a] && (i = Es(i)), [i, Es(i)];
}
function D2(e) {
  const t = Es(e);
  return [kf(e), t, kf(t)];
}
function kf(e) {
  return e.replace(/start|end/g, (t) => P2[t]);
}
function R2(e, t, r) {
  const n = ["left", "right"], o = ["right", "left"], a = ["top", "bottom"], i = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return r ? t ? o : n : t ? n : o;
    case "left":
    case "right":
      return t ? a : i;
    default:
      return [];
  }
}
function M2(e, t, r, n) {
  const o = ci(e);
  let a = R2(Tn(e), r === "start", n);
  return o && (a = a.map((i) => i + "-" + o), t && (a = a.concat(a.map(kf)))), a;
}
function Es(e) {
  return e.replace(/left|right|bottom|top/g, (t) => k2[t]);
}
function B2(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function Ob(e) {
  return typeof e != "number" ? B2(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Os(e) {
  const {
    x: t,
    y: r,
    width: n,
    height: o
  } = e;
  return {
    width: n,
    height: o,
    top: r,
    left: t,
    right: t + n,
    bottom: r + o,
    x: t,
    y: r
  };
}
function Cm(e, t, r) {
  let {
    reference: n,
    floating: o
  } = e;
  const a = Qn(t), i = Tp(t), s = Ap(i), l = Tn(t), u = a === "y", c = n.x + n.width / 2 - o.width / 2, d = n.y + n.height / 2 - o.height / 2, h = n[s] / 2 - o[s] / 2;
  let y;
  switch (l) {
    case "top":
      y = {
        x: c,
        y: n.y - o.height
      };
      break;
    case "bottom":
      y = {
        x: c,
        y: n.y + n.height
      };
      break;
    case "right":
      y = {
        x: n.x + n.width,
        y: d
      };
      break;
    case "left":
      y = {
        x: n.x - o.width,
        y: d
      };
      break;
    default:
      y = {
        x: n.x,
        y: n.y
      };
  }
  switch (ci(t)) {
    case "start":
      y[i] -= h * (r && u ? -1 : 1);
      break;
    case "end":
      y[i] += h * (r && u ? -1 : 1);
      break;
  }
  return y;
}
const q2 = async (e, t, r) => {
  const {
    placement: n = "bottom",
    strategy: o = "absolute",
    middleware: a = [],
    platform: i
  } = r, s = a.filter(Boolean), l = await (i.isRTL == null ? void 0 : i.isRTL(t));
  let u = await i.getElementRects({
    reference: e,
    floating: t,
    strategy: o
  }), {
    x: c,
    y: d
  } = Cm(u, n, l), h = n, y = {}, m = 0;
  for (let p = 0; p < s.length; p++) {
    const {
      name: f,
      fn: v
    } = s[p], {
      x: w,
      y: _,
      data: T,
      reset: A
    } = await v({
      x: c,
      y: d,
      initialPlacement: n,
      placement: h,
      strategy: o,
      middlewareData: y,
      rects: u,
      platform: i,
      elements: {
        reference: e,
        floating: t
      }
    });
    c = w ?? c, d = _ ?? d, y = {
      ...y,
      [f]: {
        ...y[f],
        ...T
      }
    }, A && m <= 50 && (m++, typeof A == "object" && (A.placement && (h = A.placement), A.rects && (u = A.rects === !0 ? await i.getElementRects({
      reference: e,
      floating: t,
      strategy: o
    }) : A.rects), {
      x: c,
      y: d
    } = Cm(u, h, l)), p = -1);
  }
  return {
    x: c,
    y: d,
    placement: h,
    strategy: o,
    middlewareData: y
  };
};
async function ia(e, t) {
  var r;
  t === void 0 && (t = {});
  const {
    x: n,
    y: o,
    platform: a,
    rects: i,
    elements: s,
    strategy: l
  } = e, {
    boundary: u = "clippingAncestors",
    rootBoundary: c = "viewport",
    elementContext: d = "floating",
    altBoundary: h = !1,
    padding: y = 0
  } = An(t, e), m = Ob(y), f = s[h ? d === "floating" ? "reference" : "floating" : d], v = Os(await a.getClippingRect({
    element: (r = await (a.isElement == null ? void 0 : a.isElement(f))) == null || r ? f : f.contextElement || await (a.getDocumentElement == null ? void 0 : a.getDocumentElement(s.floating)),
    boundary: u,
    rootBoundary: c,
    strategy: l
  })), w = d === "floating" ? {
    x: n,
    y: o,
    width: i.floating.width,
    height: i.floating.height
  } : i.reference, _ = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(s.floating)), T = await (a.isElement == null ? void 0 : a.isElement(_)) ? await (a.getScale == null ? void 0 : a.getScale(_)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, A = Os(a.convertOffsetParentRelativeRectToViewportRelativeRect ? await a.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: s,
    rect: w,
    offsetParent: _,
    strategy: l
  }) : w);
  return {
    top: (v.top - A.top + m.top) / T.y,
    bottom: (A.bottom - v.bottom + m.bottom) / T.y,
    left: (v.left - A.left + m.left) / T.x,
    right: (A.right - v.right + m.right) / T.x
  };
}
const L2 = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: r,
      y: n,
      placement: o,
      rects: a,
      platform: i,
      elements: s,
      middlewareData: l
    } = t, {
      element: u,
      padding: c = 0
    } = An(e, t) || {};
    if (u == null)
      return {};
    const d = Ob(c), h = {
      x: r,
      y: n
    }, y = Tp(o), m = Ap(y), p = await i.getDimensions(u), f = y === "y", v = f ? "top" : "left", w = f ? "bottom" : "right", _ = f ? "clientHeight" : "clientWidth", T = a.reference[m] + a.reference[y] - h[y] - a.floating[m], A = h[y] - a.reference[y], O = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(u));
    let M = O ? O[_] : 0;
    (!M || !await (i.isElement == null ? void 0 : i.isElement(O))) && (M = s.floating[_] || a.floating[m]);
    const I = T / 2 - A / 2, C = M / 2 - p[m] / 2 - 1, E = Zn(d[v], C), R = Zn(d[w], C), k = E, L = M - p[m] - R, z = M / 2 - p[m] / 2 + I, F = Cf(k, z, L), q = !l.arrow && ci(o) != null && z !== F && a.reference[m] / 2 - (z < k ? E : R) - p[m] / 2 < 0, j = q ? z < k ? z - k : z - L : 0;
    return {
      [y]: h[y] + j,
      data: {
        [y]: F,
        centerOffset: z - F - j,
        ...q && {
          alignmentOffset: j
        }
      },
      reset: q
    };
  }
}), F2 = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var r, n;
      const {
        placement: o,
        middlewareData: a,
        rects: i,
        initialPlacement: s,
        platform: l,
        elements: u
      } = t, {
        mainAxis: c = !0,
        crossAxis: d = !0,
        fallbackPlacements: h,
        fallbackStrategy: y = "bestFit",
        fallbackAxisSideDirection: m = "none",
        flipAlignment: p = !0,
        ...f
      } = An(e, t);
      if ((r = a.arrow) != null && r.alignmentOffset)
        return {};
      const v = Tn(o), w = Qn(s), _ = Tn(s) === s, T = await (l.isRTL == null ? void 0 : l.isRTL(u.floating)), A = h || (_ || !p ? [Es(s)] : D2(s)), O = m !== "none";
      !h && O && A.push(...M2(s, p, m, T));
      const M = [s, ...A], I = await ia(t, f), C = [];
      let E = ((n = a.flip) == null ? void 0 : n.overflows) || [];
      if (c && C.push(I[v]), d) {
        const z = I2(o, i, T);
        C.push(I[z[0]], I[z[1]]);
      }
      if (E = [...E, {
        placement: o,
        overflows: C
      }], !C.every((z) => z <= 0)) {
        var R, k;
        const z = (((R = a.flip) == null ? void 0 : R.index) || 0) + 1, F = M[z];
        if (F)
          return {
            data: {
              index: z,
              overflows: E
            },
            reset: {
              placement: F
            }
          };
        let q = (k = E.filter((j) => j.overflows[0] <= 0).sort((j, D) => j.overflows[1] - D.overflows[1])[0]) == null ? void 0 : k.placement;
        if (!q)
          switch (y) {
            case "bestFit": {
              var L;
              const j = (L = E.filter((D) => {
                if (O) {
                  const H = Qn(D.placement);
                  return H === w || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  H === "y";
                }
                return !0;
              }).map((D) => [D.placement, D.overflows.filter((H) => H > 0).reduce((H, W) => H + W, 0)]).sort((D, H) => D[1] - H[1])[0]) == null ? void 0 : L[0];
              j && (q = j);
              break;
            }
            case "initialPlacement":
              q = s;
              break;
          }
        if (o !== q)
          return {
            reset: {
              placement: q
            }
          };
      }
      return {};
    }
  };
};
function km(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function Pm(e) {
  return C2.some((t) => e[t] >= 0);
}
const N2 = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: r
      } = t, {
        strategy: n = "referenceHidden",
        ...o
      } = An(e, t);
      switch (n) {
        case "referenceHidden": {
          const a = await ia(t, {
            ...o,
            elementContext: "reference"
          }), i = km(a, r.reference);
          return {
            data: {
              referenceHiddenOffsets: i,
              referenceHidden: Pm(i)
            }
          };
        }
        case "escaped": {
          const a = await ia(t, {
            ...o,
            altBoundary: !0
          }), i = km(a, r.floating);
          return {
            data: {
              escapedOffsets: i,
              escaped: Pm(i)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function z2(e, t) {
  const {
    placement: r,
    platform: n,
    elements: o
  } = e, a = await (n.isRTL == null ? void 0 : n.isRTL(o.floating)), i = Tn(r), s = ci(r), l = Qn(r) === "y", u = ["left", "top"].includes(i) ? -1 : 1, c = a && l ? -1 : 1, d = An(t, e);
  let {
    mainAxis: h,
    crossAxis: y,
    alignmentAxis: m
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: d.mainAxis || 0,
    crossAxis: d.crossAxis || 0,
    alignmentAxis: d.alignmentAxis
  };
  return s && typeof m == "number" && (y = s === "end" ? m * -1 : m), l ? {
    x: y * c,
    y: h * u
  } : {
    x: h * u,
    y: y * c
  };
}
const j2 = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var r, n;
      const {
        x: o,
        y: a,
        placement: i,
        middlewareData: s
      } = t, l = await z2(t, e);
      return i === ((r = s.offset) == null ? void 0 : r.placement) && (n = s.arrow) != null && n.alignmentOffset ? {} : {
        x: o + l.x,
        y: a + l.y,
        data: {
          ...l,
          placement: i
        }
      };
    }
  };
}, U2 = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: r,
        y: n,
        placement: o
      } = t, {
        mainAxis: a = !0,
        crossAxis: i = !1,
        limiter: s = {
          fn: (f) => {
            let {
              x: v,
              y: w
            } = f;
            return {
              x: v,
              y: w
            };
          }
        },
        ...l
      } = An(e, t), u = {
        x: r,
        y: n
      }, c = await ia(t, l), d = Qn(Tn(o)), h = xp(d);
      let y = u[h], m = u[d];
      if (a) {
        const f = h === "y" ? "top" : "left", v = h === "y" ? "bottom" : "right", w = y + c[f], _ = y - c[v];
        y = Cf(w, y, _);
      }
      if (i) {
        const f = d === "y" ? "top" : "left", v = d === "y" ? "bottom" : "right", w = m + c[f], _ = m - c[v];
        m = Cf(w, m, _);
      }
      const p = s.fn({
        ...t,
        [h]: y,
        [d]: m
      });
      return {
        ...p,
        data: {
          x: p.x - r,
          y: p.y - n,
          enabled: {
            [h]: a,
            [d]: i
          }
        }
      };
    }
  };
}, W2 = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: r,
        y: n,
        placement: o,
        rects: a,
        middlewareData: i
      } = t, {
        offset: s = 0,
        mainAxis: l = !0,
        crossAxis: u = !0
      } = An(e, t), c = {
        x: r,
        y: n
      }, d = Qn(o), h = xp(d);
      let y = c[h], m = c[d];
      const p = An(s, t), f = typeof p == "number" ? {
        mainAxis: p,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...p
      };
      if (l) {
        const _ = h === "y" ? "height" : "width", T = a.reference[h] - a.floating[_] + f.mainAxis, A = a.reference[h] + a.reference[_] - f.mainAxis;
        y < T ? y = T : y > A && (y = A);
      }
      if (u) {
        var v, w;
        const _ = h === "y" ? "width" : "height", T = ["top", "left"].includes(Tn(o)), A = a.reference[d] - a.floating[_] + (T && ((v = i.offset) == null ? void 0 : v[d]) || 0) + (T ? 0 : f.crossAxis), O = a.reference[d] + a.reference[_] + (T ? 0 : ((w = i.offset) == null ? void 0 : w[d]) || 0) - (T ? f.crossAxis : 0);
        m < A ? m = A : m > O && (m = O);
      }
      return {
        [h]: y,
        [d]: m
      };
    }
  };
}, V2 = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var r, n;
      const {
        placement: o,
        rects: a,
        platform: i,
        elements: s
      } = t, {
        apply: l = () => {
        },
        ...u
      } = An(e, t), c = await ia(t, u), d = Tn(o), h = ci(o), y = Qn(o) === "y", {
        width: m,
        height: p
      } = a.floating;
      let f, v;
      d === "top" || d === "bottom" ? (f = d, v = h === (await (i.isRTL == null ? void 0 : i.isRTL(s.floating)) ? "start" : "end") ? "left" : "right") : (v = d, f = h === "end" ? "top" : "bottom");
      const w = p - c.top - c.bottom, _ = m - c.left - c.right, T = Zn(p - c[f], w), A = Zn(m - c[v], _), O = !t.middlewareData.shift;
      let M = T, I = A;
      if ((r = t.middlewareData.shift) != null && r.enabled.x && (I = _), (n = t.middlewareData.shift) != null && n.enabled.y && (M = w), O && !h) {
        const E = vr(c.left, 0), R = vr(c.right, 0), k = vr(c.top, 0), L = vr(c.bottom, 0);
        y ? I = m - 2 * (E !== 0 || R !== 0 ? E + R : vr(c.left, c.right)) : M = p - 2 * (k !== 0 || L !== 0 ? k + L : vr(c.top, c.bottom));
      }
      await l({
        ...t,
        availableWidth: I,
        availableHeight: M
      });
      const C = await i.getDimensions(s.floating);
      return m !== C.width || p !== C.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function Us() {
  return typeof window < "u";
}
function Po(e) {
  return Ep(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function gr(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function nn(e) {
  var t;
  return (t = (Ep(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function Ep(e) {
  return Us() ? e instanceof Node || e instanceof gr(e).Node : !1;
}
function jr(e) {
  return Us() ? e instanceof Element || e instanceof gr(e).Element : !1;
}
function en(e) {
  return Us() ? e instanceof HTMLElement || e instanceof gr(e).HTMLElement : !1;
}
function Im(e) {
  return !Us() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof gr(e).ShadowRoot;
}
function ca(e) {
  const {
    overflow: t,
    overflowX: r,
    overflowY: n,
    display: o
  } = Ur(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + n + r) && !["inline", "contents"].includes(o);
}
function H2(e) {
  return ["table", "td", "th"].includes(Po(e));
}
function Ws(e) {
  return [":popover-open", ":modal"].some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function Op(e) {
  const t = $p(), r = jr(e) ? Ur(e) : e;
  return r.transform !== "none" || r.perspective !== "none" || (r.containerType ? r.containerType !== "normal" : !1) || !t && (r.backdropFilter ? r.backdropFilter !== "none" : !1) || !t && (r.filter ? r.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((n) => (r.willChange || "").includes(n)) || ["paint", "layout", "strict", "content"].some((n) => (r.contain || "").includes(n));
}
function G2(e) {
  let t = eo(e);
  for (; en(t) && !oi(t); ) {
    if (Op(t))
      return t;
    if (Ws(t))
      return null;
    t = eo(t);
  }
  return null;
}
function $p() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function oi(e) {
  return ["html", "body", "#document"].includes(Po(e));
}
function Ur(e) {
  return gr(e).getComputedStyle(e);
}
function Vs(e) {
  return jr(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function eo(e) {
  if (Po(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Im(e) && e.host || // Fallback.
    nn(e)
  );
  return Im(t) ? t.host : t;
}
function $b(e) {
  const t = eo(e);
  return oi(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : en(t) && ca(t) ? t : $b(t);
}
function aa(e, t, r) {
  var n;
  t === void 0 && (t = []), r === void 0 && (r = !0);
  const o = $b(e), a = o === ((n = e.ownerDocument) == null ? void 0 : n.body), i = gr(o);
  if (a) {
    const s = Pf(i);
    return t.concat(i, i.visualViewport || [], ca(o) ? o : [], s && r ? aa(s) : []);
  }
  return t.concat(o, aa(o, [], r));
}
function Pf(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function Cb(e) {
  const t = Ur(e);
  let r = parseFloat(t.width) || 0, n = parseFloat(t.height) || 0;
  const o = en(e), a = o ? e.offsetWidth : r, i = o ? e.offsetHeight : n, s = Ts(r) !== a || Ts(n) !== i;
  return s && (r = a, n = i), {
    width: r,
    height: n,
    $: s
  };
}
function Cp(e) {
  return jr(e) ? e : e.contextElement;
}
function Jo(e) {
  const t = Cp(e);
  if (!en(t))
    return Xn(1);
  const r = t.getBoundingClientRect(), {
    width: n,
    height: o,
    $: a
  } = Cb(t);
  let i = (a ? Ts(r.width) : r.width) / n, s = (a ? Ts(r.height) : r.height) / o;
  return (!i || !Number.isFinite(i)) && (i = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: i,
    y: s
  };
}
const K2 = /* @__PURE__ */ Xn(0);
function kb(e) {
  const t = gr(e);
  return !$p() || !t.visualViewport ? K2 : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function Y2(e, t, r) {
  return t === void 0 && (t = !1), !r || t && r !== gr(e) ? !1 : t;
}
function Oo(e, t, r, n) {
  t === void 0 && (t = !1), r === void 0 && (r = !1);
  const o = e.getBoundingClientRect(), a = Cp(e);
  let i = Xn(1);
  t && (n ? jr(n) && (i = Jo(n)) : i = Jo(e));
  const s = Y2(a, r, n) ? kb(a) : Xn(0);
  let l = (o.left + s.x) / i.x, u = (o.top + s.y) / i.y, c = o.width / i.x, d = o.height / i.y;
  if (a) {
    const h = gr(a), y = n && jr(n) ? gr(n) : n;
    let m = h, p = Pf(m);
    for (; p && n && y !== m; ) {
      const f = Jo(p), v = p.getBoundingClientRect(), w = Ur(p), _ = v.left + (p.clientLeft + parseFloat(w.paddingLeft)) * f.x, T = v.top + (p.clientTop + parseFloat(w.paddingTop)) * f.y;
      l *= f.x, u *= f.y, c *= f.x, d *= f.y, l += _, u += T, m = gr(p), p = Pf(m);
    }
  }
  return Os({
    width: c,
    height: d,
    x: l,
    y: u
  });
}
function J2(e) {
  let {
    elements: t,
    rect: r,
    offsetParent: n,
    strategy: o
  } = e;
  const a = o === "fixed", i = nn(n), s = t ? Ws(t.floating) : !1;
  if (n === i || s && a)
    return r;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = Xn(1);
  const c = Xn(0), d = en(n);
  if ((d || !d && !a) && ((Po(n) !== "body" || ca(i)) && (l = Vs(n)), en(n))) {
    const h = Oo(n);
    u = Jo(n), c.x = h.x + n.clientLeft, c.y = h.y + n.clientTop;
  }
  return {
    width: r.width * u.x,
    height: r.height * u.y,
    x: r.x * u.x - l.scrollLeft * u.x + c.x,
    y: r.y * u.y - l.scrollTop * u.y + c.y
  };
}
function Z2(e) {
  return Array.from(e.getClientRects());
}
function If(e, t) {
  const r = Vs(e).scrollLeft;
  return t ? t.left + r : Oo(nn(e)).left + r;
}
function X2(e) {
  const t = nn(e), r = Vs(e), n = e.ownerDocument.body, o = vr(t.scrollWidth, t.clientWidth, n.scrollWidth, n.clientWidth), a = vr(t.scrollHeight, t.clientHeight, n.scrollHeight, n.clientHeight);
  let i = -r.scrollLeft + If(e);
  const s = -r.scrollTop;
  return Ur(n).direction === "rtl" && (i += vr(t.clientWidth, n.clientWidth) - o), {
    width: o,
    height: a,
    x: i,
    y: s
  };
}
function Q2(e, t) {
  const r = gr(e), n = nn(e), o = r.visualViewport;
  let a = n.clientWidth, i = n.clientHeight, s = 0, l = 0;
  if (o) {
    a = o.width, i = o.height;
    const u = $p();
    (!u || u && t === "fixed") && (s = o.offsetLeft, l = o.offsetTop);
  }
  return {
    width: a,
    height: i,
    x: s,
    y: l
  };
}
function ex(e, t) {
  const r = Oo(e, !0, t === "fixed"), n = r.top + e.clientTop, o = r.left + e.clientLeft, a = en(e) ? Jo(e) : Xn(1), i = e.clientWidth * a.x, s = e.clientHeight * a.y, l = o * a.x, u = n * a.y;
  return {
    width: i,
    height: s,
    x: l,
    y: u
  };
}
function Dm(e, t, r) {
  let n;
  if (t === "viewport")
    n = Q2(e, r);
  else if (t === "document")
    n = X2(nn(e));
  else if (jr(t))
    n = ex(t, r);
  else {
    const o = kb(e);
    n = {
      ...t,
      x: t.x - o.x,
      y: t.y - o.y
    };
  }
  return Os(n);
}
function Pb(e, t) {
  const r = eo(e);
  return r === t || !jr(r) || oi(r) ? !1 : Ur(r).position === "fixed" || Pb(r, t);
}
function tx(e, t) {
  const r = t.get(e);
  if (r)
    return r;
  let n = aa(e, [], !1).filter((s) => jr(s) && Po(s) !== "body"), o = null;
  const a = Ur(e).position === "fixed";
  let i = a ? eo(e) : e;
  for (; jr(i) && !oi(i); ) {
    const s = Ur(i), l = Op(i);
    !l && s.position === "fixed" && (o = null), (a ? !l && !o : !l && s.position === "static" && !!o && ["absolute", "fixed"].includes(o.position) || ca(i) && !l && Pb(e, i)) ? n = n.filter((c) => c !== i) : o = s, i = eo(i);
  }
  return t.set(e, n), n;
}
function rx(e) {
  let {
    element: t,
    boundary: r,
    rootBoundary: n,
    strategy: o
  } = e;
  const i = [...r === "clippingAncestors" ? Ws(t) ? [] : tx(t, this._c) : [].concat(r), n], s = i[0], l = i.reduce((u, c) => {
    const d = Dm(t, c, o);
    return u.top = vr(d.top, u.top), u.right = Zn(d.right, u.right), u.bottom = Zn(d.bottom, u.bottom), u.left = vr(d.left, u.left), u;
  }, Dm(t, s, o));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function nx(e) {
  const {
    width: t,
    height: r
  } = Cb(e);
  return {
    width: t,
    height: r
  };
}
function ox(e, t, r) {
  const n = en(t), o = nn(t), a = r === "fixed", i = Oo(e, !0, a, t);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = Xn(0);
  if (n || !n && !a)
    if ((Po(t) !== "body" || ca(o)) && (s = Vs(t)), n) {
      const y = Oo(t, !0, a, t);
      l.x = y.x + t.clientLeft, l.y = y.y + t.clientTop;
    } else o && (l.x = If(o));
  let u = 0, c = 0;
  if (o && !n && !a) {
    const y = o.getBoundingClientRect();
    c = y.top + s.scrollTop, u = y.left + s.scrollLeft - // RTL <body> scrollbar.
    If(o, y);
  }
  const d = i.left + s.scrollLeft - l.x - u, h = i.top + s.scrollTop - l.y - c;
  return {
    x: d,
    y: h,
    width: i.width,
    height: i.height
  };
}
function ou(e) {
  return Ur(e).position === "static";
}
function Rm(e, t) {
  if (!en(e) || Ur(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let r = e.offsetParent;
  return nn(e) === r && (r = r.ownerDocument.body), r;
}
function Ib(e, t) {
  const r = gr(e);
  if (Ws(e))
    return r;
  if (!en(e)) {
    let o = eo(e);
    for (; o && !oi(o); ) {
      if (jr(o) && !ou(o))
        return o;
      o = eo(o);
    }
    return r;
  }
  let n = Rm(e, t);
  for (; n && H2(n) && ou(n); )
    n = Rm(n, t);
  return n && oi(n) && ou(n) && !Op(n) ? r : n || G2(e) || r;
}
const ix = async function(e) {
  const t = this.getOffsetParent || Ib, r = this.getDimensions, n = await r(e.floating);
  return {
    reference: ox(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: n.width,
      height: n.height
    }
  };
};
function ax(e) {
  return Ur(e).direction === "rtl";
}
const sx = {
  convertOffsetParentRelativeRectToViewportRelativeRect: J2,
  getDocumentElement: nn,
  getClippingRect: rx,
  getOffsetParent: Ib,
  getElementRects: ix,
  getClientRects: Z2,
  getDimensions: nx,
  getScale: Jo,
  isElement: jr,
  isRTL: ax
};
function lx(e, t) {
  let r = null, n;
  const o = nn(e);
  function a() {
    var s;
    clearTimeout(n), (s = r) == null || s.disconnect(), r = null;
  }
  function i(s, l) {
    s === void 0 && (s = !1), l === void 0 && (l = 1), a();
    const {
      left: u,
      top: c,
      width: d,
      height: h
    } = e.getBoundingClientRect();
    if (s || t(), !d || !h)
      return;
    const y = Ka(c), m = Ka(o.clientWidth - (u + d)), p = Ka(o.clientHeight - (c + h)), f = Ka(u), w = {
      rootMargin: -y + "px " + -m + "px " + -p + "px " + -f + "px",
      threshold: vr(0, Zn(1, l)) || 1
    };
    let _ = !0;
    function T(A) {
      const O = A[0].intersectionRatio;
      if (O !== l) {
        if (!_)
          return i();
        O ? i(!1, O) : n = setTimeout(() => {
          i(!1, 1e-7);
        }, 1e3);
      }
      _ = !1;
    }
    try {
      r = new IntersectionObserver(T, {
        ...w,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      r = new IntersectionObserver(T, w);
    }
    r.observe(e);
  }
  return i(!0), a;
}
function Db(e, t, r, n) {
  n === void 0 && (n = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: a = !0,
    elementResize: i = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = n, u = Cp(e), c = o || a ? [...u ? aa(u) : [], ...aa(t)] : [];
  c.forEach((v) => {
    o && v.addEventListener("scroll", r, {
      passive: !0
    }), a && v.addEventListener("resize", r);
  });
  const d = u && s ? lx(u, r) : null;
  let h = -1, y = null;
  i && (y = new ResizeObserver((v) => {
    let [w] = v;
    w && w.target === u && y && (y.unobserve(t), cancelAnimationFrame(h), h = requestAnimationFrame(() => {
      var _;
      (_ = y) == null || _.observe(t);
    })), r();
  }), u && !l && y.observe(u), y.observe(t));
  let m, p = l ? Oo(e) : null;
  l && f();
  function f() {
    const v = Oo(e);
    p && (v.x !== p.x || v.y !== p.y || v.width !== p.width || v.height !== p.height) && r(), p = v, m = requestAnimationFrame(f);
  }
  return r(), () => {
    var v;
    c.forEach((w) => {
      o && w.removeEventListener("scroll", r), a && w.removeEventListener("resize", r);
    }), d == null || d(), (v = y) == null || v.disconnect(), y = null, l && cancelAnimationFrame(m);
  };
}
const Rb = j2, Mb = U2, Df = F2, ux = V2, cx = N2, dx = L2, fx = W2, Bb = (e, t, r) => {
  const n = /* @__PURE__ */ new Map(), o = {
    platform: sx,
    ...r
  }, a = {
    ...o.platform,
    _c: n
  };
  return q2(e, t, {
    ...o,
    platform: a
  });
};
function px(e) {
  return e != null && typeof e == "object" && "$el" in e;
}
function Rf(e) {
  if (px(e)) {
    const t = e.$el;
    return Ep(t) && Po(t) === "#comment" ? null : t;
  }
  return e;
}
function Ho(e) {
  return typeof e == "function" ? e() : S(e);
}
function qb(e) {
  return {
    name: "arrow",
    options: e,
    fn(t) {
      const r = Rf(Ho(e.element));
      return r == null ? {} : dx({
        element: r,
        padding: e.padding
      }).fn(t);
    }
  };
}
function Lb(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Mm(e, t) {
  const r = Lb(e);
  return Math.round(t * r) / r;
}
function hx(e, t, r) {
  r === void 0 && (r = {});
  const n = r.whileElementsMounted, o = re(() => {
    var M;
    return (M = Ho(r.open)) != null ? M : !0;
  }), a = re(() => Ho(r.middleware)), i = re(() => {
    var M;
    return (M = Ho(r.placement)) != null ? M : "bottom";
  }), s = re(() => {
    var M;
    return (M = Ho(r.strategy)) != null ? M : "absolute";
  }), l = re(() => {
    var M;
    return (M = Ho(r.transform)) != null ? M : !0;
  }), u = re(() => Rf(e.value)), c = re(() => Rf(t.value)), d = se(0), h = se(0), y = se(s.value), m = se(i.value), p = Zr({}), f = se(!1), v = re(() => {
    const M = {
      position: y.value,
      left: "0",
      top: "0"
    };
    if (!c.value)
      return M;
    const I = Mm(c.value, d.value), C = Mm(c.value, h.value);
    return l.value ? {
      ...M,
      transform: "translate(" + I + "px, " + C + "px)",
      ...Lb(c.value) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: y.value,
      left: I + "px",
      top: C + "px"
    };
  });
  let w;
  function _() {
    if (u.value == null || c.value == null)
      return;
    const M = o.value;
    Bb(u.value, c.value, {
      middleware: a.value,
      placement: i.value,
      strategy: s.value
    }).then((I) => {
      d.value = I.x, h.value = I.y, y.value = I.strategy, m.value = I.placement, p.value = I.middlewareData, f.value = M !== !1;
    });
  }
  function T() {
    typeof w == "function" && (w(), w = void 0);
  }
  function A() {
    if (T(), n === void 0) {
      _();
      return;
    }
    if (u.value != null && c.value != null) {
      w = n(u.value, c.value, _);
      return;
    }
  }
  function O() {
    o.value || (f.value = !1);
  }
  return at([a, i, s, o], _, {
    flush: "sync"
  }), at([u, c], A, {
    flush: "sync"
  }), at(o, O, {
    flush: "sync"
  }), Bs() && up(T), {
    x: Fo(d),
    y: Fo(h),
    strategy: Fo(y),
    placement: Fo(m),
    middlewareData: Fo(p),
    isPositioned: Fo(f),
    floatingStyles: v,
    update: _
  };
}
const Fb = /* @__PURE__ */ U({
  __name: "Popper",
  props: {
    trigger: { default: "manual" },
    placement: {},
    timeout: { default: 0 },
    open: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, r = Je("popperBody"), n = Je("popperTrigger"), o = Je("popperArrow"), a = se(!1), i = se(), s = se(), l = se(), u = se();
    let c = null;
    tt("popperBodyId", r), tt("popperTriggerId", n), tt("popperBodyVisible", a), tt("popperArrowId", o), Lt(() => {
      at(() => t.open, () => {
        t.trigger === "manual" && (t.open ? h() : y());
      }, { immediate: !0 });
    });
    function d() {
      Bb(s.value, l.value, {
        placement: t.placement,
        middleware: [
          qb({
            element: u
          }),
          Rb(6),
          Df(),
          Mb({
            padding: 5
          })
        ]
      }).then(({ x: f, y: v, placement: w, middlewareData: _ }) => {
        if (u.value !== null) {
          const { x: T, y: A } = _.arrow, O = {
            top: "bottom",
            right: "left",
            bottom: "top",
            left: "right"
          }[w.split("-")[0]];
          Object.assign(u.value.style, {
            left: T != null ? `${T}px` : "",
            top: A != null ? `${A}px` : "",
            right: "",
            bottom: "",
            [O]: "-4px"
          });
        }
        Object.assign(l.value.style, {
          left: `${f}px`,
          top: `${v}px`
        });
      });
    }
    function h() {
      a.value = !0, s.value && l.value && (c = Db(
        s.value,
        l.value,
        d
      ));
    }
    function y() {
      setTimeout(() => {
        a.value = !1, c && c();
      }, t.timeout);
    }
    function m() {
      s.value.addEventListener("mouseenter", h), s.value.addEventListener("mouseleave", y);
    }
    function p() {
      s.value.addEventListener("click", () => {
        a.value ? y() : h();
      });
    }
    return Lt(() => {
      s.value = document.getElementById(n), l.value = document.getElementById(r), u.value = document.getElementById(o), t.trigger !== "manual" && zs(i, () => {
        y();
      }), t.trigger === "hover" && m(), t.trigger === "click" && p();
    }), Co(() => {
      c && c();
    }), (f, v) => ($(), B("span", {
      ref_key: "$popperWrapper",
      ref: i
    }, [
      V(f.$slots, "default")
    ], 512));
  }
}), mx = ["id"], vx = /* @__PURE__ */ U({
  __name: "PopperArrow",
  setup(e) {
    const t = je("popperArrowId");
    return (r, n) => ($(), B("div", {
      id: S(t),
      class: "w-2 h-2 rotate-45 bg-black",
      style: {
        position: "absolute"
      }
    }, null, 8, mx));
  }
}), gx = ["id", "data-state"], Nb = /* @__PURE__ */ U({
  __name: "PopperBody",
  setup(e) {
    const t = je("popperBodyId"), r = je("popperBodyVisible");
    return (n, o) => ($(), B("div", {
      id: S(t),
      class: Te(["absolute z-10 will-change-[transform,opacity] data-[state=closed]:animate-hide data-[state=open]:animate-slideDownAndFade", {
        hidden: !S(r),
        block: S(r)
      }]),
      "data-state": S(r) ? "open" : "closed"
    }, [
      V(n.$slots, "default")
    ], 10, gx));
  }
}), yx = ["id"], zb = /* @__PURE__ */ U({
  __name: "PopperTrigger",
  setup(e) {
    const t = je("popperTriggerId");
    return (r, n) => ($(), B("span", {
      id: S(t),
      class: "inline-block"
    }, [
      V(r.$slots, "default")
    ], 8, yx));
  }
}), jb = /* @__PURE__ */ U({
  __name: "Popover",
  props: {
    alignment: {}
  },
  setup(e) {
    return (t, r) => ($(), ne(S(Fb), {
      trigger: "click",
      placement: `bottom-${t.alignment}`
    }, {
      default: Y(() => [
        V(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["placement"]));
  }
}), bx = { class: "overflow-hidden rounded-md border bg-white shadow-lg dark:bg-zinc-900 dark:border-zinc-700" }, Ub = /* @__PURE__ */ U({
  __name: "PopoverBody",
  setup(e) {
    return (t, r) => ($(), ne(S(Nb), null, {
      default: Y(() => [
        X("div", bx, [
          V(t.$slots, "default")
        ])
      ]),
      _: 3
    }));
  }
}), Wb = /* @__PURE__ */ U({
  __name: "PopoverTrigger",
  setup(e) {
    return (t, r) => ($(), ne(S(zb), null, {
      default: Y(() => [
        V(t.$slots, "default")
      ]),
      _: 3
    }));
  }
}), _6 = /* @__PURE__ */ U({
  __name: "ActionList",
  props: {
    alignment: { default: "start" }
  },
  setup(e) {
    return (t, r) => ($(), ne(S(jb), { alignment: t.alignment }, {
      default: Y(() => [
        V(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["alignment"]));
  }
}), wx = { class: "min-w-[200px]" }, S6 = /* @__PURE__ */ U({
  __name: "ActionListBody",
  setup(e) {
    return (t, r) => ($(), ne(S(Ub), null, {
      default: Y(() => [
        X("div", wx, [
          V(t.$slots, "default")
        ])
      ]),
      _: 3
    }));
  }
}), Hs = /* @__PURE__ */ U({
  __name: "InertiaLink",
  props: {
    as: {},
    data: {},
    href: {},
    method: {},
    headers: {},
    onClick: { type: Function },
    preserveScroll: { type: [Boolean, Function] },
    preserveState: { type: [Boolean, Function, null] },
    replace: { type: Boolean },
    only: {},
    except: {},
    onCancelToken: { type: Function },
    onBefore: { type: Function },
    onStart: { type: Function },
    onProgress: { type: Function },
    onFinish: { type: Function },
    onCancel: { type: Function },
    onSuccess: { type: Function },
    queryStringArrayFormat: {}
  },
  setup(e) {
    return (t, r) => {
      const n = Nw("InertiaLink", !0);
      return $(), ne(n, zr(ko(t.$props)), {
        default: Y(() => [
          V(t.$slots, "default")
        ]),
        _: 3
      }, 16);
    };
  }
});
function Vb(e) {
  var t, r, n = "";
  if (typeof e == "string" || typeof e == "number") n += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var o = e.length;
    for (t = 0; t < o; t++) e[t] && (r = Vb(e[t])) && (n && (n += " "), n += r);
  } else for (r in e) e[r] && (n && (n += " "), n += r);
  return n;
}
function _x() {
  for (var e, t, r = 0, n = "", o = arguments.length; r < o; r++) (e = arguments[r]) && (t = Vb(e)) && (n && (n += " "), n += t);
  return n;
}
const kp = "-", Sx = (e) => {
  const t = Ax(e), {
    conflictingClassGroups: r,
    conflictingClassGroupModifiers: n
  } = e;
  return {
    getClassGroupId: (i) => {
      const s = i.split(kp);
      return s[0] === "" && s.length !== 1 && s.shift(), Hb(s, t) || xx(i);
    },
    getConflictingClassGroupIds: (i, s) => {
      const l = r[i] || [];
      return s && n[i] ? [...l, ...n[i]] : l;
    }
  };
}, Hb = (e, t) => {
  var i;
  if (e.length === 0)
    return t.classGroupId;
  const r = e[0], n = t.nextPart.get(r), o = n ? Hb(e.slice(1), n) : void 0;
  if (o)
    return o;
  if (t.validators.length === 0)
    return;
  const a = e.join(kp);
  return (i = t.validators.find(({
    validator: s
  }) => s(a))) == null ? void 0 : i.classGroupId;
}, Bm = /^\[(.+)\]$/, xx = (e) => {
  if (Bm.test(e)) {
    const t = Bm.exec(e)[1], r = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (r)
      return "arbitrary.." + r;
  }
}, Ax = (e) => {
  const {
    theme: t,
    classGroups: r
  } = e, n = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  for (const o in r)
    Mf(r[o], n, o, t);
  return n;
}, Mf = (e, t, r, n) => {
  e.forEach((o) => {
    if (typeof o == "string") {
      const a = o === "" ? t : qm(t, o);
      a.classGroupId = r;
      return;
    }
    if (typeof o == "function") {
      if (Tx(o)) {
        Mf(o(n), t, r, n);
        return;
      }
      t.validators.push({
        validator: o,
        classGroupId: r
      });
      return;
    }
    Object.entries(o).forEach(([a, i]) => {
      Mf(i, qm(t, a), r, n);
    });
  });
}, qm = (e, t) => {
  let r = e;
  return t.split(kp).forEach((n) => {
    r.nextPart.has(n) || r.nextPart.set(n, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), r = r.nextPart.get(n);
  }), r;
}, Tx = (e) => e.isThemeGetter, Ex = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, r = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map();
  const o = (a, i) => {
    r.set(a, i), t++, t > e && (t = 0, n = r, r = /* @__PURE__ */ new Map());
  };
  return {
    get(a) {
      let i = r.get(a);
      if (i !== void 0)
        return i;
      if ((i = n.get(a)) !== void 0)
        return o(a, i), i;
    },
    set(a, i) {
      r.has(a) ? r.set(a, i) : o(a, i);
    }
  };
}, Bf = "!", qf = ":", Ox = qf.length, $x = (e) => {
  const {
    prefix: t,
    experimentalParseClassName: r
  } = e;
  let n = (o) => {
    const a = [];
    let i = 0, s = 0, l = 0, u;
    for (let m = 0; m < o.length; m++) {
      let p = o[m];
      if (i === 0 && s === 0) {
        if (p === qf) {
          a.push(o.slice(l, m)), l = m + Ox;
          continue;
        }
        if (p === "/") {
          u = m;
          continue;
        }
      }
      p === "[" ? i++ : p === "]" ? i-- : p === "(" ? s++ : p === ")" && s--;
    }
    const c = a.length === 0 ? o : o.substring(l), d = Cx(c), h = d !== c, y = u && u > l ? u - l : void 0;
    return {
      modifiers: a,
      hasImportantModifier: h,
      baseClassName: d,
      maybePostfixModifierPosition: y
    };
  };
  if (t) {
    const o = t + qf, a = n;
    n = (i) => i.startsWith(o) ? a(i.substring(o.length)) : {
      isExternal: !0,
      modifiers: [],
      hasImportantModifier: !1,
      baseClassName: i,
      maybePostfixModifierPosition: void 0
    };
  }
  if (r) {
    const o = n;
    n = (a) => r({
      className: a,
      parseClassName: o
    });
  }
  return n;
}, Cx = (e) => e.endsWith(Bf) ? e.substring(0, e.length - 1) : e.startsWith(Bf) ? e.substring(1) : e, kx = (e) => {
  const t = Object.fromEntries(e.orderSensitiveModifiers.map((n) => [n, !0]));
  return (n) => {
    if (n.length <= 1)
      return n;
    const o = [];
    let a = [];
    return n.forEach((i) => {
      i[0] === "[" || t[i] ? (o.push(...a.sort(), i), a = []) : a.push(i);
    }), o.push(...a.sort()), o;
  };
}, Px = (e) => ({
  cache: Ex(e.cacheSize),
  parseClassName: $x(e),
  sortModifiers: kx(e),
  ...Sx(e)
}), Ix = /\s+/, Dx = (e, t) => {
  const {
    parseClassName: r,
    getClassGroupId: n,
    getConflictingClassGroupIds: o,
    sortModifiers: a
  } = t, i = [], s = e.trim().split(Ix);
  let l = "";
  for (let u = s.length - 1; u >= 0; u -= 1) {
    const c = s[u], {
      isExternal: d,
      modifiers: h,
      hasImportantModifier: y,
      baseClassName: m,
      maybePostfixModifierPosition: p
    } = r(c);
    if (d) {
      l = c + (l.length > 0 ? " " + l : l);
      continue;
    }
    let f = !!p, v = n(f ? m.substring(0, p) : m);
    if (!v) {
      if (!f) {
        l = c + (l.length > 0 ? " " + l : l);
        continue;
      }
      if (v = n(m), !v) {
        l = c + (l.length > 0 ? " " + l : l);
        continue;
      }
      f = !1;
    }
    const w = a(h).join(":"), _ = y ? w + Bf : w, T = _ + v;
    if (i.includes(T))
      continue;
    i.push(T);
    const A = o(v, f);
    for (let O = 0; O < A.length; ++O) {
      const M = A[O];
      i.push(_ + M);
    }
    l = c + (l.length > 0 ? " " + l : l);
  }
  return l;
};
function Rx() {
  let e = 0, t, r, n = "";
  for (; e < arguments.length; )
    (t = arguments[e++]) && (r = Gb(t)) && (n && (n += " "), n += r);
  return n;
}
const Gb = (e) => {
  if (typeof e == "string")
    return e;
  let t, r = "";
  for (let n = 0; n < e.length; n++)
    e[n] && (t = Gb(e[n])) && (r && (r += " "), r += t);
  return r;
};
function Mx(e, ...t) {
  let r, n, o, a = i;
  function i(l) {
    const u = t.reduce((c, d) => d(c), e());
    return r = Px(u), n = r.cache.get, o = r.cache.set, a = s, s(l);
  }
  function s(l) {
    const u = n(l);
    if (u)
      return u;
    const c = Dx(l, r);
    return o(l, c), c;
  }
  return function() {
    return a(Rx.apply(null, arguments));
  };
}
const Dt = (e) => {
  const t = (r) => r[e] || [];
  return t.isThemeGetter = !0, t;
}, Kb = /^\[(?:(\w[\w-]*):)?(.+)\]$/i, Yb = /^\((?:(\w[\w-]*):)?(.+)\)$/i, Bx = /^\d+\/\d+$/, qx = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, Lx = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, Fx = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, Nx = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, zx = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, No = (e) => Bx.test(e), qe = (e) => !!e && !Number.isNaN(Number(e)), Un = (e) => !!e && Number.isInteger(Number(e)), iu = (e) => e.endsWith("%") && qe(e.slice(0, -1)), gn = (e) => qx.test(e), jx = () => !0, Ux = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  Lx.test(e) && !Fx.test(e)
), Jb = () => !1, Wx = (e) => Nx.test(e), Vx = (e) => zx.test(e), Hx = (e) => !he(e) && !me(e), Gx = (e) => di(e, Qb, Jb), he = (e) => Kb.test(e), mo = (e) => di(e, e1, Ux), au = (e) => di(e, Xx, qe), Lm = (e) => di(e, Zb, Jb), Kx = (e) => di(e, Xb, Vx), Ya = (e) => di(e, t1, Wx), me = (e) => Yb.test(e), zi = (e) => fi(e, e1), Yx = (e) => fi(e, Qx), Fm = (e) => fi(e, Zb), Jx = (e) => fi(e, Qb), Zx = (e) => fi(e, Xb), Ja = (e) => fi(e, t1, !0), di = (e, t, r) => {
  const n = Kb.exec(e);
  return n ? n[1] ? t(n[1]) : r(n[2]) : !1;
}, fi = (e, t, r = !1) => {
  const n = Yb.exec(e);
  return n ? n[1] ? t(n[1]) : r : !1;
}, Zb = (e) => e === "position" || e === "percentage", Xb = (e) => e === "image" || e === "url", Qb = (e) => e === "length" || e === "size" || e === "bg-size", e1 = (e) => e === "length", Xx = (e) => e === "number", Qx = (e) => e === "family-name", t1 = (e) => e === "shadow", eA = () => {
  const e = Dt("color"), t = Dt("font"), r = Dt("text"), n = Dt("font-weight"), o = Dt("tracking"), a = Dt("leading"), i = Dt("breakpoint"), s = Dt("container"), l = Dt("spacing"), u = Dt("radius"), c = Dt("shadow"), d = Dt("inset-shadow"), h = Dt("text-shadow"), y = Dt("drop-shadow"), m = Dt("blur"), p = Dt("perspective"), f = Dt("aspect"), v = Dt("ease"), w = Dt("animate"), _ = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], T = () => [
    "center",
    "top",
    "bottom",
    "left",
    "right",
    "top-left",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "left-top",
    "top-right",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "right-top",
    "bottom-right",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "right-bottom",
    "bottom-left",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "left-bottom"
  ], A = () => [...T(), me, he], O = () => ["auto", "hidden", "clip", "visible", "scroll"], M = () => ["auto", "contain", "none"], I = () => [me, he, l], C = () => [No, "full", "auto", ...I()], E = () => [Un, "none", "subgrid", me, he], R = () => ["auto", {
    span: ["full", Un, me, he]
  }, Un, me, he], k = () => [Un, "auto", me, he], L = () => ["auto", "min", "max", "fr", me, he], z = () => ["start", "end", "center", "between", "around", "evenly", "stretch", "baseline", "center-safe", "end-safe"], F = () => ["start", "end", "center", "stretch", "center-safe", "end-safe"], q = () => ["auto", ...I()], j = () => [No, "auto", "full", "dvw", "dvh", "lvw", "lvh", "svw", "svh", "min", "max", "fit", ...I()], D = () => [e, me, he], H = () => [...T(), Fm, Lm, {
    position: [me, he]
  }], W = () => ["no-repeat", {
    repeat: ["", "x", "y", "space", "round"]
  }], ee = () => ["auto", "cover", "contain", Jx, Gx, {
    size: [me, he]
  }], oe = () => [iu, zi, mo], J = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    "full",
    u,
    me,
    he
  ], N = () => ["", qe, zi, mo], Q = () => ["solid", "dashed", "dotted", "double"], de = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], G = () => [qe, iu, Fm, Lm], ce = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    m,
    me,
    he
  ], be = () => ["none", qe, me, he], ve = () => ["none", qe, me, he], fe = () => [qe, me, he], Oe = () => [No, "full", ...I()];
  return {
    cacheSize: 500,
    theme: {
      animate: ["spin", "ping", "pulse", "bounce"],
      aspect: ["video"],
      blur: [gn],
      breakpoint: [gn],
      color: [jx],
      container: [gn],
      "drop-shadow": [gn],
      ease: ["in", "out", "in-out"],
      font: [Hx],
      "font-weight": ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black"],
      "inset-shadow": [gn],
      leading: ["none", "tight", "snug", "normal", "relaxed", "loose"],
      perspective: ["dramatic", "near", "normal", "midrange", "distant", "none"],
      radius: [gn],
      shadow: [gn],
      spacing: ["px", qe],
      text: [gn],
      "text-shadow": [gn],
      tracking: ["tighter", "tight", "normal", "wide", "wider", "widest"]
    },
    classGroups: {
      // --------------
      // --- Layout ---
      // --------------
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", No, he, me, f]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       * @deprecated since Tailwind CSS v4.0.0
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [qe, he, me, s]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": _()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": _()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Screen Reader Only
       * @see https://tailwindcss.com/docs/display#screen-reader-only
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: A()
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: O()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": O()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": O()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: M()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": M()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": M()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: C()
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": C()
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": C()
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: C()
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: C()
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: C()
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: C()
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: C()
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: C()
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: [Un, "auto", me, he]
      }],
      // ------------------------
      // --- Flexbox and Grid ---
      // ------------------------
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: [No, "full", "auto", s, ...I()]
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["nowrap", "wrap", "wrap-reverse"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: [qe, No, "auto", "initial", "none", he]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: ["", qe, me, he]
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: ["", qe, me, he]
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: [Un, "first", "last", "none", me, he]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": E()
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: R()
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": k()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": k()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": E()
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: R()
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": k()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": k()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": L()
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": L()
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: I()
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": I()
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": I()
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: [...z(), "normal"]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": [...F(), "normal"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", ...F()]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...z()]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: [...F(), {
          baseline: ["", "last"]
        }]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", ...F(), {
          baseline: ["", "last"]
        }]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": z()
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": [...F(), "baseline"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", ...F()]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: I()
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: I()
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: I()
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: I()
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: I()
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: I()
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: I()
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: I()
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: I()
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: q()
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: q()
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: q()
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: q()
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: q()
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: q()
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: q()
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: q()
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: q()
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x": [{
        "space-x": I()
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y": [{
        "space-y": I()
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y-reverse": ["space-y-reverse"],
      // --------------
      // --- Sizing ---
      // --------------
      /**
       * Size
       * @see https://tailwindcss.com/docs/width#setting-both-width-and-height
       */
      size: [{
        size: j()
      }],
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: [s, "screen", ...j()]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [
          s,
          "screen",
          /** Deprecated. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "none",
          ...j()
        ]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [
          s,
          "screen",
          "none",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "prose",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          {
            screen: [i]
          },
          ...j()
        ]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: ["screen", ...j()]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["screen", "none", ...j()]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": ["screen", ...j()]
      }],
      // ------------------
      // --- Typography ---
      // ------------------
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", r, zi, mo]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: [n, me, au]
      }],
      /**
       * Font Stretch
       * @see https://tailwindcss.com/docs/font-stretch
       */
      "font-stretch": [{
        "font-stretch": ["ultra-condensed", "extra-condensed", "condensed", "semi-condensed", "normal", "semi-expanded", "expanded", "extra-expanded", "ultra-expanded", iu, he]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [Yx, he, t]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: [o, me, he]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": [qe, "none", me, au]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: [
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          a,
          ...I()
        ]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", me, he]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["disc", "decimal", "none", me, he]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://v3.tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: D()
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: D()
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...Q(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: [qe, "from-font", "auto", me, mo]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: D()
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": [qe, "auto", me, he]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: I()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", me, he]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Overflow Wrap
       * @see https://tailwindcss.com/docs/overflow-wrap
       */
      wrap: [{
        wrap: ["break-word", "anywhere", "normal"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", me, he]
      }],
      // -------------------
      // --- Backgrounds ---
      // -------------------
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: H()
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: W()
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ee()
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          linear: [{
            to: ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
          }, Un, me, he],
          radial: ["", me, he],
          conic: [Un, me, he]
        }, Zx, Kx]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: D()
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: oe()
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: oe()
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: oe()
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: D()
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: D()
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: D()
      }],
      // ---------------
      // --- Borders ---
      // ---------------
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: J()
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": J()
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": J()
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": J()
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": J()
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": J()
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": J()
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": J()
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": J()
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": J()
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": J()
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": J()
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": J()
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": J()
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": J()
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: N()
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": N()
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": N()
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": N()
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": N()
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": N()
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": N()
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": N()
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": N()
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x": [{
        "divide-x": N()
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y": [{
        "divide-y": N()
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...Q(), "hidden", "none"]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/border-style#setting-the-divider-style
       */
      "divide-style": [{
        divide: [...Q(), "hidden", "none"]
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: D()
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": D()
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": D()
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": D()
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": D()
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": D()
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": D()
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": D()
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": D()
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: D()
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [...Q(), "none", "hidden"]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [qe, me, he]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: ["", qe, zi, mo]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: D()
      }],
      // ---------------
      // --- Effects ---
      // ---------------
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          "none",
          c,
          Ja,
          Ya
        ]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-shadow-color
       */
      "shadow-color": [{
        shadow: D()
      }],
      /**
       * Inset Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-shadow
       */
      "inset-shadow": [{
        "inset-shadow": ["none", d, Ja, Ya]
      }],
      /**
       * Inset Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-shadow-color
       */
      "inset-shadow-color": [{
        "inset-shadow": D()
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-a-ring
       */
      "ring-w": [{
        ring: N()
      }],
      /**
       * Ring Width Inset
       * @see https://v3.tailwindcss.com/docs/ring-width#inset-rings
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-ring-color
       */
      "ring-color": [{
        ring: D()
      }],
      /**
       * Ring Offset Width
       * @see https://v3.tailwindcss.com/docs/ring-offset-width
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-w": [{
        "ring-offset": [qe, mo]
      }],
      /**
       * Ring Offset Color
       * @see https://v3.tailwindcss.com/docs/ring-offset-color
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-color": [{
        "ring-offset": D()
      }],
      /**
       * Inset Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-ring
       */
      "inset-ring-w": [{
        "inset-ring": N()
      }],
      /**
       * Inset Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-ring-color
       */
      "inset-ring-color": [{
        "inset-ring": D()
      }],
      /**
       * Text Shadow
       * @see https://tailwindcss.com/docs/text-shadow
       */
      "text-shadow": [{
        "text-shadow": ["none", h, Ja, Ya]
      }],
      /**
       * Text Shadow Color
       * @see https://tailwindcss.com/docs/text-shadow#setting-the-shadow-color
       */
      "text-shadow-color": [{
        "text-shadow": D()
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [qe, me, he]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...de(), "plus-darker", "plus-lighter"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": de()
      }],
      /**
       * Mask Clip
       * @see https://tailwindcss.com/docs/mask-clip
       */
      "mask-clip": [{
        "mask-clip": ["border", "padding", "content", "fill", "stroke", "view"]
      }, "mask-no-clip"],
      /**
       * Mask Composite
       * @see https://tailwindcss.com/docs/mask-composite
       */
      "mask-composite": [{
        mask: ["add", "subtract", "intersect", "exclude"]
      }],
      /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */
      "mask-image-linear-pos": [{
        "mask-linear": [qe]
      }],
      "mask-image-linear-from-pos": [{
        "mask-linear-from": G()
      }],
      "mask-image-linear-to-pos": [{
        "mask-linear-to": G()
      }],
      "mask-image-linear-from-color": [{
        "mask-linear-from": D()
      }],
      "mask-image-linear-to-color": [{
        "mask-linear-to": D()
      }],
      "mask-image-t-from-pos": [{
        "mask-t-from": G()
      }],
      "mask-image-t-to-pos": [{
        "mask-t-to": G()
      }],
      "mask-image-t-from-color": [{
        "mask-t-from": D()
      }],
      "mask-image-t-to-color": [{
        "mask-t-to": D()
      }],
      "mask-image-r-from-pos": [{
        "mask-r-from": G()
      }],
      "mask-image-r-to-pos": [{
        "mask-r-to": G()
      }],
      "mask-image-r-from-color": [{
        "mask-r-from": D()
      }],
      "mask-image-r-to-color": [{
        "mask-r-to": D()
      }],
      "mask-image-b-from-pos": [{
        "mask-b-from": G()
      }],
      "mask-image-b-to-pos": [{
        "mask-b-to": G()
      }],
      "mask-image-b-from-color": [{
        "mask-b-from": D()
      }],
      "mask-image-b-to-color": [{
        "mask-b-to": D()
      }],
      "mask-image-l-from-pos": [{
        "mask-l-from": G()
      }],
      "mask-image-l-to-pos": [{
        "mask-l-to": G()
      }],
      "mask-image-l-from-color": [{
        "mask-l-from": D()
      }],
      "mask-image-l-to-color": [{
        "mask-l-to": D()
      }],
      "mask-image-x-from-pos": [{
        "mask-x-from": G()
      }],
      "mask-image-x-to-pos": [{
        "mask-x-to": G()
      }],
      "mask-image-x-from-color": [{
        "mask-x-from": D()
      }],
      "mask-image-x-to-color": [{
        "mask-x-to": D()
      }],
      "mask-image-y-from-pos": [{
        "mask-y-from": G()
      }],
      "mask-image-y-to-pos": [{
        "mask-y-to": G()
      }],
      "mask-image-y-from-color": [{
        "mask-y-from": D()
      }],
      "mask-image-y-to-color": [{
        "mask-y-to": D()
      }],
      "mask-image-radial": [{
        "mask-radial": [me, he]
      }],
      "mask-image-radial-from-pos": [{
        "mask-radial-from": G()
      }],
      "mask-image-radial-to-pos": [{
        "mask-radial-to": G()
      }],
      "mask-image-radial-from-color": [{
        "mask-radial-from": D()
      }],
      "mask-image-radial-to-color": [{
        "mask-radial-to": D()
      }],
      "mask-image-radial-shape": [{
        "mask-radial": ["circle", "ellipse"]
      }],
      "mask-image-radial-size": [{
        "mask-radial": [{
          closest: ["side", "corner"],
          farthest: ["side", "corner"]
        }]
      }],
      "mask-image-radial-pos": [{
        "mask-radial-at": T()
      }],
      "mask-image-conic-pos": [{
        "mask-conic": [qe]
      }],
      "mask-image-conic-from-pos": [{
        "mask-conic-from": G()
      }],
      "mask-image-conic-to-pos": [{
        "mask-conic-to": G()
      }],
      "mask-image-conic-from-color": [{
        "mask-conic-from": D()
      }],
      "mask-image-conic-to-color": [{
        "mask-conic-to": D()
      }],
      /**
       * Mask Mode
       * @see https://tailwindcss.com/docs/mask-mode
       */
      "mask-mode": [{
        mask: ["alpha", "luminance", "match"]
      }],
      /**
       * Mask Origin
       * @see https://tailwindcss.com/docs/mask-origin
       */
      "mask-origin": [{
        "mask-origin": ["border", "padding", "content", "fill", "stroke", "view"]
      }],
      /**
       * Mask Position
       * @see https://tailwindcss.com/docs/mask-position
       */
      "mask-position": [{
        mask: H()
      }],
      /**
       * Mask Repeat
       * @see https://tailwindcss.com/docs/mask-repeat
       */
      "mask-repeat": [{
        mask: W()
      }],
      /**
       * Mask Size
       * @see https://tailwindcss.com/docs/mask-size
       */
      "mask-size": [{
        mask: ee()
      }],
      /**
       * Mask Type
       * @see https://tailwindcss.com/docs/mask-type
       */
      "mask-type": [{
        "mask-type": ["alpha", "luminance"]
      }],
      /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */
      "mask-image": [{
        mask: ["none", me, he]
      }],
      // ---------------
      // --- Filters ---
      // ---------------
      /**
       * Filter
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          me,
          he
        ]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: ce()
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [qe, me, he]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [qe, me, he]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          "none",
          y,
          Ja,
          Ya
        ]
      }],
      /**
       * Drop Shadow Color
       * @see https://tailwindcss.com/docs/filter-drop-shadow#setting-the-shadow-color
       */
      "drop-shadow-color": [{
        "drop-shadow": D()
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: ["", qe, me, he]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [qe, me, he]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: ["", qe, me, he]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [qe, me, he]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: ["", qe, me, he]
      }],
      /**
       * Backdrop Filter
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          me,
          he
        ]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": ce()
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [qe, me, he]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [qe, me, he]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": ["", qe, me, he]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [qe, me, he]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": ["", qe, me, he]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [qe, me, he]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [qe, me, he]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": ["", qe, me, he]
      }],
      // --------------
      // --- Tables ---
      // --------------
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": I()
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": I()
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": I()
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // ---------------------------------
      // --- Transitions and Animation ---
      // ---------------------------------
      /**
       * Transition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["", "all", "colors", "opacity", "shadow", "transform", "none", me, he]
      }],
      /**
       * Transition Behavior
       * @see https://tailwindcss.com/docs/transition-behavior
       */
      "transition-behavior": [{
        transition: ["normal", "discrete"]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: [qe, "initial", me, he]
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "initial", v, me, he]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: [qe, me, he]
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", w, me, he]
      }],
      // ------------------
      // --- Transforms ---
      // ------------------
      /**
       * Backface Visibility
       * @see https://tailwindcss.com/docs/backface-visibility
       */
      backface: [{
        backface: ["hidden", "visible"]
      }],
      /**
       * Perspective
       * @see https://tailwindcss.com/docs/perspective
       */
      perspective: [{
        perspective: [p, me, he]
      }],
      /**
       * Perspective Origin
       * @see https://tailwindcss.com/docs/perspective-origin
       */
      "perspective-origin": [{
        "perspective-origin": A()
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: be()
      }],
      /**
       * Rotate X
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-x": [{
        "rotate-x": be()
      }],
      /**
       * Rotate Y
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-y": [{
        "rotate-y": be()
      }],
      /**
       * Rotate Z
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-z": [{
        "rotate-z": be()
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: ve()
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": ve()
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": ve()
      }],
      /**
       * Scale Z
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-z": [{
        "scale-z": ve()
      }],
      /**
       * Scale 3D
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-3d": ["scale-3d"],
      /**
       * Skew
       * @see https://tailwindcss.com/docs/skew
       */
      skew: [{
        skew: fe()
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": fe()
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": fe()
      }],
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: [me, he, "", "none", "gpu", "cpu"]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: A()
      }],
      /**
       * Transform Style
       * @see https://tailwindcss.com/docs/transform-style
       */
      "transform-style": [{
        transform: ["3d", "flat"]
      }],
      /**
       * Translate
       * @see https://tailwindcss.com/docs/translate
       */
      translate: [{
        translate: Oe()
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": Oe()
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": Oe()
      }],
      /**
       * Translate Z
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-z": [{
        "translate-z": Oe()
      }],
      /**
       * Translate None
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-none": ["translate-none"],
      // ---------------------
      // --- Interactivity ---
      // ---------------------
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: D()
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: D()
      }],
      /**
       * Color Scheme
       * @see https://tailwindcss.com/docs/color-scheme
       */
      "color-scheme": [{
        scheme: ["normal", "dark", "light", "light-dark", "only-dark", "only-light"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", me, he]
      }],
      /**
       * Field Sizing
       * @see https://tailwindcss.com/docs/field-sizing
       */
      "field-sizing": [{
        "field-sizing": ["fixed", "content"]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["auto", "none"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "", "y", "x"]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": I()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": I()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": I()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": I()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": I()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": I()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": I()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": I()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": I()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": I()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": I()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": I()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": I()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": I()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": I()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": I()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": I()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": I()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", me, he]
      }],
      // -----------
      // --- SVG ---
      // -----------
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: ["none", ...D()]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [qe, zi, mo, au]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: ["none", ...D()]
      }],
      // ---------------------
      // --- Accessibility ---
      // ---------------------
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-x", "border-w-y", "border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-x", "border-color-y", "border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      translate: ["translate-x", "translate-y", "translate-none"],
      "translate-none": ["translate", "translate-x", "translate-y", "translate-z"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    },
    orderSensitiveModifiers: ["*", "**", "after", "backdrop", "before", "details-content", "file", "first-letter", "first-line", "marker", "placeholder", "selection"]
  };
}, tA = /* @__PURE__ */ Mx(eA);
function da(...e) {
  return tA(_x(e));
}
const rA = ["id"], nA = {
  key: 0,
  class: "ml-2"
}, Ir = /* @__PURE__ */ U({
  inheritAttrs: !1,
  __name: "Button",
  props: {
    align: { default: "center" },
    class: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    disclosure: { type: Boolean, default: !1 },
    external: { type: Boolean, default: !1 },
    fullWidth: { type: Boolean, default: !1 },
    href: { default: null },
    iconOnly: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    native: { type: Boolean, default: !1 },
    size: { default: "normal" },
    type: { default: "button" },
    variant: { default: "primary" }
  },
  setup(e) {
    const t = e, r = Je("buttonLabel"), n = re(() => [
      { "bg-brand-500 hover:bg-brand-600 text-white": t.variant === "primary" },
      { "bg-slate-200 hover:bg-slate-300 dark:bg-zinc-800 dark:hover:bg-zinc-700": t.variant === "secondary" },
      { "bg-red-500/20 hover:bg-red-500/30 text-red-600 dark:text-white dark:bg-red-700": t.variant === "destructive" },
      { "hover:bg-slate-200 dark:hover:bg-zinc-700": t.variant === "ghost" },
      { "hover:bg-transparent/20 ring-1 ring-slate-200 ring-inset dark:ring-zinc-700 dark:hover:bg-zinc-700": t.variant === "outline" },
      { "px-4 py-3": t.size === "normal" && !t.iconOnly },
      { "px-3 py-2": t.size === "small" && !t.iconOnly },
      { "p-3": t.size === "normal" && t.iconOnly },
      { "p-2": t.size === "small" && t.iconOnly },
      { "opacity-50 cursor-not-allowed": t.disabled },
      { "pointer-events-none opacity-75 justify-center": t.loading },
      { "w-full": t.fullWidth },
      ...Qt("focus", t.variant === "destructive" ? "destructive" : "default")
    ]), o = re(() => t.href ? t.native ? "a" : Hs : "button");
    return (a, i) => ($(), ne(er(o.value), We({
      "aria-busy": a.loading,
      "aria-disabled": a.disabled || a.loading,
      "aria-labelledby": S(r),
      class: S(da)("inline-flex shrink-0 items-center rounded text-sm font-medium leading-none active:opacity-80 active:shadow-inner", n.value, t.class),
      disabled: a.disabled || a.loading,
      href: a.href,
      type: a.type,
      role: "button"
    }, a.$attrs), {
      default: Y(() => [
        X("span", {
          id: S(r),
          class: Te([{
            invisible: a.loading,
            "mx-auto": t.align === "center",
            "mr-auto": t.align === "left",
            "ml-auto": t.align === "right"
          }, "inline-flex items-center justify-center space-x-2"])
        }, [
          V(a.$slots, "default"),
          a.disclosure ? ($(), B("span", nA, [
            ie(S(Ab), { class: "size-4" })
          ])) : _e("", !0)
        ], 10, rA),
        a.loading ? ($(), ne(S(L4), {
          key: 0,
          class: "absolute",
          variant: t.variant === "primary" ? "light" : "dark"
        }, null, 8, ["variant"])) : _e("", !0)
      ]),
      _: 3
    }, 16, ["aria-busy", "aria-disabled", "aria-labelledby", "class", "disabled", "href", "type"]));
  }
}), oA = "_visuallyHidden_o6qmb_6", iA = {
  visuallyHidden: oA
}, De = (e, t) => {
  const r = e.__vccOpts || e;
  for (const [n, o] of t)
    r[n] = o;
  return r;
}, aA = {};
function sA(e, t) {
  return $(), B("span", {
    class: Te(e.$style.visuallyHidden)
  }, [
    V(e.$slots, "default")
  ], 2);
}
const lA = {
  $style: iA
}, pi = /* @__PURE__ */ De(aA, [["render", sA], ["__cssModules", lA]]), uA = { class: "flex items-center space-x-2" }, x6 = /* @__PURE__ */ U({
  __name: "ButtonBadge",
  props: {
    accessibilityLabel: { default: null },
    color: {}
  },
  setup(e) {
    const t = e, r = re(() => ({
      backgroundColor: bt(t.color, "400")
    }));
    return (n, o) => ($(), B("span", {
      class: "-my-2 inline-flex rounded bg-slate-200 px-2 py-1 text-xs text-white",
      style: $t(r.value)
    }, [
      ie(S(Ve), { strong: "" }, {
        default: Y(() => [
          X("div", uA, [
            V(n.$slots, "default")
          ])
        ]),
        _: 3
      }),
      n.accessibilityLabel ? ($(), ne(S(pi), { key: 0 }, {
        default: Y(() => [
          et(Ie(n.accessibilityLabel), 1)
        ]),
        _: 1
      })) : _e("", !0)
    ], 4));
  }
}), cA = {}, dA = { class: "text-sm leading-none" };
function fA(e, t) {
  return $(), B("span", dA, [
    V(e.$slots, "default")
  ]);
}
const pA = /* @__PURE__ */ De(cA, [["render", fA]]), hA = ["alt", "crossorigin", "src"], hi = /* @__PURE__ */ U({
  __name: "Image",
  props: {
    alt: {},
    source: {},
    crossOrigin: { default: void 0 },
    rounded: { type: Boolean, default: !1 }
  },
  emits: ["load", "error"],
  setup(e, { emit: t }) {
    const r = e, n = t;
    return Lt(() => {
      r.source || n("error");
    }), (o, a) => ($(), B("img", We({
      alt: o.alt,
      class: { rounded: o.rounded },
      crossorigin: o.crossOrigin,
      src: o.source ?? void 0
    }, o.$attrs, {
      onError: a[0] || (a[0] = (i) => o.$emit("error")),
      onLoad: a[1] || (a[1] = (i) => o.$emit("load"))
    }), null, 16, hA));
  }
}), mA = { class: "flex-shrink-0 size-4 -mt-0.5 -mb-0.5" }, ii = /* @__PURE__ */ U({
  __name: "ButtonIcon",
  props: {
    alt: { default: void 0 },
    icon: { type: [Function, Object, null], default: null },
    source: { default: null }
  },
  setup(e) {
    return (t, r) => ($(), B("div", mA, [
      t.icon ? ($(), ne(er(t.icon), {
        key: 0,
        class: "size-4"
      })) : _e("", !0),
      t.source ? ($(), ne(S(hi), {
        key: 1,
        alt: t.alt,
        source: t.source
      }, null, 8, ["alt", "source"])) : _e("", !0)
    ]));
  }
}), vA = { class: "block" }, A6 = /* @__PURE__ */ U({
  __name: "ActionListItem",
  props: {
    active: { type: Boolean, default: !1 },
    icon: { type: [Function, Object, null], default: null },
    variant: { default: "ghost" }
  },
  setup(e) {
    return (t, r) => ($(), B("li", vA, [
      ie(S(Ir), We({
        active: t.active,
        variant: t.variant,
        align: "left",
        "full-width": "",
        role: "menuitem",
        size: "small"
      }, t.$attrs), {
        default: Y(() => [
          t.icon ? ($(), ne(er(t.icon), {
            key: 0,
            class: "size-4"
          })) : _e("", !0),
          ie(S(pA), null, {
            default: Y(() => [
              V(t.$slots, "default")
            ]),
            _: 3
          })
        ]),
        _: 3
      }, 16, ["active", "variant"])
    ]));
  }
}), gA = {}, yA = { class: "[&:not(:last-child)]:border-b dark:[&:not(:last-child)]:border-zinc-700 p-1.5 space-y-0.5" };
function bA(e, t) {
  return $(), B("ul", yA, [
    V(e.$slots, "default")
  ]);
}
const T6 = /* @__PURE__ */ De(gA, [["render", bA]]), E6 = /* @__PURE__ */ U({
  __name: "ActionListTrigger",
  setup(e) {
    return (t, r) => ($(), ne(S(Wb), null, {
      default: Y(() => [
        V(t.$slots, "default")
      ]),
      _: 3
    }));
  }
}), wA = /* @__PURE__ */ U({
  __name: "DismissableAlertButton",
  props: {
    variant: { default: "default" }
  },
  emits: ["dismiss"],
  setup(e) {
    const t = e, r = re(() => ({
      "hover:bg-red-900/20": t.variant === "destructive",
      "hover:bg-yellow-900/20": t.variant === "warning",
      "hover:bg-slate-200": t.variant === "default"
    }));
    return (n, o) => ($(), B("button", {
      class: Te([r.value, "absolute right-2 top-2 !mt-0 flex size-5 items-center justify-center rounded"]),
      "aria-label": "Dismiss notification",
      type: "button",
      onClick: o[0] || (o[0] = (a) => n.$emit("dismiss"))
    }, [
      ie(S(ua), { class: "size-4" })
    ], 2));
  }
}), _A = ["role", "aria-live"], O6 = /* @__PURE__ */ U({
  __name: "Alert",
  props: {
    flush: { type: Boolean, default: !1 },
    dismissible: { type: Boolean, default: !1 },
    variant: { default: "default" }
  },
  emits: ["dismiss"],
  setup(e, { emit: t }) {
    const r = e, n = t;
    tt("alertVariant", r.variant);
    const o = se(!1), a = re(() => [
      { "bg-white dark:text-white dark:bg-zinc-900 dark:border-zinc-700": r.variant === "default" },
      { "bg-blue-50 border-blue-500/40 text-blue-800 dark:bg-blue-600 dark:text-white dark:border-blue-500": r.variant === "informative" },
      { "bg-red-50 border-red-500/40 text-red-800 dark:bg-red-600 dark:text-white dark:border-red-500": r.variant === "destructive" },
      { "bg-yellow-50 border-yellow-500/40 text-yellow-800 dark:bg-yellow-600 dark:text-white dark:border-yellow-500": r.variant === "warning" },
      { "border rounded px-4 py-3": !r.flush },
      { "border-y px-6 py-3 mt-6": r.flush }
    ]), i = re(() => r.variant === "destructive" ? "alert" : "status"), s = re(() => r.variant === "destructive" ? "assertive" : "polite");
    function l() {
      n("dismiss"), o.value = !0;
    }
    return (u, c) => o.value ? _e("", !0) : ($(), B("div", {
      key: 0,
      class: Te([a.value, "relative space-y-3 shadow-sm [&_[data-component=link]]:font-medium [&_[data-component=link]]:text-inherit"]),
      role: i.value,
      "aria-live": s.value,
      tabindex: "0"
    }, [
      V(u.$slots, "default"),
      u.dismissible ? ($(), ne(wA, {
        key: 0,
        variant: u.variant,
        onDismiss: l
      }, null, 8, ["variant"])) : _e("", !0)
    ], 10, _A));
  }
}), $6 = /* @__PURE__ */ U({
  __name: "AlertDescription",
  setup(e) {
    const t = je("alertVariant"), r = re(() => ({
      "text-red-900/80 dark:text-red-300": t === "destructive",
      "text-yellow-900/80 dark:text-yellow-300": t === "warning",
      "text-gray-900/80 dark:text-zinc-300": t === "default"
    }));
    return (n, o) => ($(), B("div", {
      class: Te([r.value, "flex [&>[data-component=button-group]]:ml-auto"])
    }, [
      V(n.$slots, "default")
    ], 2));
  }
}), SA = { class: "leading-none" }, C6 = /* @__PURE__ */ U({
  __name: "AlertTitle",
  setup(e) {
    return (t, r) => ($(), B("h5", SA, [
      ie(S(Ve), { strong: "" }, {
        default: Y(() => [
          V(t.$slots, "default")
        ]),
        _: 3
      })
    ]));
  }
}), xA = ["aria-describedby", "aria-labelledby"], AA = { class: "flex min-h-full items-center justify-center" }, k6 = /* @__PURE__ */ U({
  __name: "AlertDialog",
  props: {
    open: { type: Boolean, default: !1 }
  },
  emits: ["cancel"],
  setup(e, { emit: t }) {
    const r = t;
    function n() {
      r("cancel");
    }
    const o = Je("alertDialogLabel"), a = Je("alertDialogDescription");
    return tt("cancelAlertDialog", n), tt("alertDialogLabelledBy", o), tt("alertDialogDescribedBy", a), (i, s) => i.open ? ($(), B("div", {
      key: 0,
      "aria-describedby": S(a),
      "aria-labelledby": S(o),
      class: "fixed top-0 left-0 z-10 h-screen w-screen bg-slate-500/50 dark:bg-zinc-900/50 px-2 text-sm",
      role: "alertdialog"
    }, [
      X("div", AA, [
        V(i.$slots, "default")
      ])
    ], 8, xA)) : _e("", !0);
  }
}), P6 = /* @__PURE__ */ U({
  __name: "AlertDialogActionButton",
  props: {
    variant: { default: "primary" }
  },
  setup(e) {
    return (t, r) => ($(), ne(S(Ir), { variant: t.variant }, {
      default: Y(() => [
        V(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["variant"]));
  }
}), I6 = /* @__PURE__ */ U({
  __name: "AlertDialogCancelButton",
  setup(e) {
    const t = je("cancelAlertDialog");
    return (r, n) => ($(), ne(S(Ir), {
      variant: "secondary",
      onClick: S(t)
    }, {
      default: Y(() => [
        V(r.$slots, "default")
      ]),
      _: 3
    }, 8, ["onClick"]));
  }
}), D6 = /* @__PURE__ */ U({
  __name: "AlertDialogContent",
  setup(e) {
    const t = se(!1), r = se(null);
    zs(r, o);
    function n(a) {
      a.key === "Escape" && o();
    }
    function o() {
      t.value = !0, setTimeout(() => {
        t.value = !1;
      }, 250);
    }
    return Lt(() => {
      document.addEventListener("keydown", n);
    }), Co(() => {
      document.removeEventListener("keydown", n);
    }), (a, i) => ($(), B("div", {
      ref_key: "clickOutsideTarget",
      ref: r,
      class: Te([{ shake: t.value }, "w-full max-w-lg select-text overflow-hidden rounded-lg bg-white dark:bg-zinc-950 dark:border dark:border-zinc-700 shadow-2xl"])
    }, [
      V(a.$slots, "default")
    ], 2));
  }
}), R6 = /* @__PURE__ */ U({
  __name: "AlertDialogDescription",
  setup(e) {
    const t = je("alertDialogLabelledBy");
    return (r, n) => ($(), B("p", null, [
      ie(S(Ve), {
        id: S(t),
        subdued: ""
      }, {
        default: Y(() => [
          V(r.$slots, "default")
        ]),
        _: 3
      }, 8, ["id"])
    ]));
  }
}), TA = {}, EA = {
  class: "flex items-center space-x-2",
  "data-component": "button-group"
};
function OA(e, t) {
  return $(), B("div", EA, [
    V(e.$slots, "default")
  ]);
}
const Pp = /* @__PURE__ */ De(TA, [["render", OA]]), $A = { class: "bg-slate-100 dark:bg-zinc-900 px-4 py-3 flex items-center justify-end" }, M6 = /* @__PURE__ */ U({
  __name: "AlertDialogFooter",
  setup(e) {
    return (t, r) => ($(), B("div", $A, [
      ie(S(Pp), null, {
        default: Y(() => [
          V(t.$slots, "default")
        ]),
        _: 3
      })
    ]));
  }
}), CA = {}, kA = { class: "flex flex-col space-y-4 p-6" };
function PA(e, t) {
  return $(), B("div", kA, [
    V(e.$slots, "default")
  ]);
}
const B6 = /* @__PURE__ */ De(CA, [["render", PA]]);
var Nm = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, ir = (e) => !e || typeof e != "object" || Object.keys(e).length === 0, IA = (e, t) => JSON.stringify(e) === JSON.stringify(t);
function r1(e, t) {
  e.forEach(function(r) {
    Array.isArray(r) ? r1(r, t) : t.push(r);
  });
}
function n1(e) {
  let t = [];
  return r1(e, t), t;
}
var o1 = (...e) => n1(e).filter(Boolean), i1 = (e, t) => {
  let r = {}, n = Object.keys(e), o = Object.keys(t);
  for (let a of n) if (o.includes(a)) {
    let i = e[a], s = t[a];
    Array.isArray(i) || Array.isArray(s) ? r[a] = o1(s, i) : typeof i == "object" && typeof s == "object" ? r[a] = i1(i, s) : r[a] = s + " " + i;
  } else r[a] = e[a];
  for (let a of o) n.includes(a) || (r[a] = t[a]);
  return r;
}, zm = (e) => !e || typeof e != "string" ? e : e.replace(/\s+/g, " ").trim();
const Ip = "-", DA = (e) => {
  const t = MA(e), {
    conflictingClassGroups: r,
    conflictingClassGroupModifiers: n
  } = e;
  return {
    getClassGroupId: (i) => {
      const s = i.split(Ip);
      return s[0] === "" && s.length !== 1 && s.shift(), a1(s, t) || RA(i);
    },
    getConflictingClassGroupIds: (i, s) => {
      const l = r[i] || [];
      return s && n[i] ? [...l, ...n[i]] : l;
    }
  };
}, a1 = (e, t) => {
  var i;
  if (e.length === 0)
    return t.classGroupId;
  const r = e[0], n = t.nextPart.get(r), o = n ? a1(e.slice(1), n) : void 0;
  if (o)
    return o;
  if (t.validators.length === 0)
    return;
  const a = e.join(Ip);
  return (i = t.validators.find(({
    validator: s
  }) => s(a))) == null ? void 0 : i.classGroupId;
}, jm = /^\[(.+)\]$/, RA = (e) => {
  if (jm.test(e)) {
    const t = jm.exec(e)[1], r = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (r)
      return "arbitrary.." + r;
  }
}, MA = (e) => {
  const {
    theme: t,
    classGroups: r
  } = e, n = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  for (const o in r)
    Lf(r[o], n, o, t);
  return n;
}, Lf = (e, t, r, n) => {
  e.forEach((o) => {
    if (typeof o == "string") {
      const a = o === "" ? t : Um(t, o);
      a.classGroupId = r;
      return;
    }
    if (typeof o == "function") {
      if (BA(o)) {
        Lf(o(n), t, r, n);
        return;
      }
      t.validators.push({
        validator: o,
        classGroupId: r
      });
      return;
    }
    Object.entries(o).forEach(([a, i]) => {
      Lf(i, Um(t, a), r, n);
    });
  });
}, Um = (e, t) => {
  let r = e;
  return t.split(Ip).forEach((n) => {
    r.nextPart.has(n) || r.nextPart.set(n, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), r = r.nextPart.get(n);
  }), r;
}, BA = (e) => e.isThemeGetter, qA = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, r = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map();
  const o = (a, i) => {
    r.set(a, i), t++, t > e && (t = 0, n = r, r = /* @__PURE__ */ new Map());
  };
  return {
    get(a) {
      let i = r.get(a);
      if (i !== void 0)
        return i;
      if ((i = n.get(a)) !== void 0)
        return o(a, i), i;
    },
    set(a, i) {
      r.has(a) ? r.set(a, i) : o(a, i);
    }
  };
}, Ff = "!", Nf = ":", LA = Nf.length, FA = (e) => {
  const {
    prefix: t,
    experimentalParseClassName: r
  } = e;
  let n = (o) => {
    const a = [];
    let i = 0, s = 0, l = 0, u;
    for (let m = 0; m < o.length; m++) {
      let p = o[m];
      if (i === 0 && s === 0) {
        if (p === Nf) {
          a.push(o.slice(l, m)), l = m + LA;
          continue;
        }
        if (p === "/") {
          u = m;
          continue;
        }
      }
      p === "[" ? i++ : p === "]" ? i-- : p === "(" ? s++ : p === ")" && s--;
    }
    const c = a.length === 0 ? o : o.substring(l), d = NA(c), h = d !== c, y = u && u > l ? u - l : void 0;
    return {
      modifiers: a,
      hasImportantModifier: h,
      baseClassName: d,
      maybePostfixModifierPosition: y
    };
  };
  if (t) {
    const o = t + Nf, a = n;
    n = (i) => i.startsWith(o) ? a(i.substring(o.length)) : {
      isExternal: !0,
      modifiers: [],
      hasImportantModifier: !1,
      baseClassName: i,
      maybePostfixModifierPosition: void 0
    };
  }
  if (r) {
    const o = n;
    n = (a) => r({
      className: a,
      parseClassName: o
    });
  }
  return n;
}, NA = (e) => e.endsWith(Ff) ? e.substring(0, e.length - 1) : e.startsWith(Ff) ? e.substring(1) : e, zA = (e) => {
  const t = Object.fromEntries(e.orderSensitiveModifiers.map((n) => [n, !0]));
  return (n) => {
    if (n.length <= 1)
      return n;
    const o = [];
    let a = [];
    return n.forEach((i) => {
      i[0] === "[" || t[i] ? (o.push(...a.sort(), i), a = []) : a.push(i);
    }), o.push(...a.sort()), o;
  };
}, jA = (e) => ({
  cache: qA(e.cacheSize),
  parseClassName: FA(e),
  sortModifiers: zA(e),
  ...DA(e)
}), UA = /\s+/, WA = (e, t) => {
  const {
    parseClassName: r,
    getClassGroupId: n,
    getConflictingClassGroupIds: o,
    sortModifiers: a
  } = t, i = [], s = e.trim().split(UA);
  let l = "";
  for (let u = s.length - 1; u >= 0; u -= 1) {
    const c = s[u], {
      isExternal: d,
      modifiers: h,
      hasImportantModifier: y,
      baseClassName: m,
      maybePostfixModifierPosition: p
    } = r(c);
    if (d) {
      l = c + (l.length > 0 ? " " + l : l);
      continue;
    }
    let f = !!p, v = n(f ? m.substring(0, p) : m);
    if (!v) {
      if (!f) {
        l = c + (l.length > 0 ? " " + l : l);
        continue;
      }
      if (v = n(m), !v) {
        l = c + (l.length > 0 ? " " + l : l);
        continue;
      }
      f = !1;
    }
    const w = a(h).join(":"), _ = y ? w + Ff : w, T = _ + v;
    if (i.includes(T))
      continue;
    i.push(T);
    const A = o(v, f);
    for (let O = 0; O < A.length; ++O) {
      const M = A[O];
      i.push(_ + M);
    }
    l = c + (l.length > 0 ? " " + l : l);
  }
  return l;
};
function VA() {
  let e = 0, t, r, n = "";
  for (; e < arguments.length; )
    (t = arguments[e++]) && (r = s1(t)) && (n && (n += " "), n += r);
  return n;
}
const s1 = (e) => {
  if (typeof e == "string")
    return e;
  let t, r = "";
  for (let n = 0; n < e.length; n++)
    e[n] && (t = s1(e[n])) && (r && (r += " "), r += t);
  return r;
};
function zf(e, ...t) {
  let r, n, o, a = i;
  function i(l) {
    const u = t.reduce((c, d) => d(c), e());
    return r = jA(u), n = r.cache.get, o = r.cache.set, a = s, s(l);
  }
  function s(l) {
    const u = n(l);
    if (u)
      return u;
    const c = WA(l, r);
    return o(l, c), c;
  }
  return function() {
    return a(VA.apply(null, arguments));
  };
}
const Bt = (e) => {
  const t = (r) => r[e] || [];
  return t.isThemeGetter = !0, t;
}, l1 = /^\[(?:(\w[\w-]*):)?(.+)\]$/i, u1 = /^\((?:(\w[\w-]*):)?(.+)\)$/i, HA = /^\d+\/\d+$/, GA = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, KA = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, YA = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, JA = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, ZA = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, zo = (e) => HA.test(e), Fe = (e) => !!e && !Number.isNaN(Number(e)), vo = (e) => !!e && Number.isInteger(Number(e)), Wm = (e) => e.endsWith("%") && Fe(e.slice(0, -1)), Wn = (e) => GA.test(e), XA = () => !0, QA = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  KA.test(e) && !YA.test(e)
), Dp = () => !1, eT = (e) => JA.test(e), tT = (e) => ZA.test(e), rT = (e) => !ge(e) && !ye(e), nT = (e) => mi(e, f1, Dp), ge = (e) => l1.test(e), go = (e) => mi(e, p1, QA), su = (e) => mi(e, hT, Fe), oT = (e) => mi(e, c1, Dp), iT = (e) => mi(e, d1, tT), aT = (e) => mi(e, Dp, eT), ye = (e) => u1.test(e), Za = (e) => vi(e, p1), sT = (e) => vi(e, mT), lT = (e) => vi(e, c1), uT = (e) => vi(e, f1), cT = (e) => vi(e, d1), dT = (e) => vi(e, vT, !0), mi = (e, t, r) => {
  const n = l1.exec(e);
  return n ? n[1] ? t(n[1]) : r(n[2]) : !1;
}, vi = (e, t, r = !1) => {
  const n = u1.exec(e);
  return n ? n[1] ? t(n[1]) : r : !1;
}, c1 = (e) => e === "position", fT = /* @__PURE__ */ new Set(["image", "url"]), d1 = (e) => fT.has(e), pT = /* @__PURE__ */ new Set(["length", "size", "percentage"]), f1 = (e) => pT.has(e), p1 = (e) => e === "length", hT = (e) => e === "number", mT = (e) => e === "family-name", vT = (e) => e === "shadow", jf = () => {
  const e = Bt("color"), t = Bt("font"), r = Bt("text"), n = Bt("font-weight"), o = Bt("tracking"), a = Bt("leading"), i = Bt("breakpoint"), s = Bt("container"), l = Bt("spacing"), u = Bt("radius"), c = Bt("shadow"), d = Bt("inset-shadow"), h = Bt("drop-shadow"), y = Bt("blur"), m = Bt("perspective"), p = Bt("aspect"), f = Bt("ease"), v = Bt("animate"), w = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], _ = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], T = () => ["auto", "hidden", "clip", "visible", "scroll"], A = () => ["auto", "contain", "none"], O = () => [ye, ge, l], M = () => [zo, "full", "auto", ...O()], I = () => [vo, "none", "subgrid", ye, ge], C = () => ["auto", {
    span: ["full", vo, ye, ge]
  }, ye, ge], E = () => [vo, "auto", ye, ge], R = () => ["auto", "min", "max", "fr", ye, ge], k = () => ["start", "end", "center", "between", "around", "evenly", "stretch", "baseline"], L = () => ["start", "end", "center", "stretch"], z = () => ["auto", ...O()], F = () => [zo, "auto", "full", "dvw", "dvh", "lvw", "lvh", "svw", "svh", "min", "max", "fit", ...O()], q = () => [e, ye, ge], j = () => [Wm, go], D = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    "full",
    u,
    ye,
    ge
  ], H = () => ["", Fe, Za, go], W = () => ["solid", "dashed", "dotted", "double"], ee = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], oe = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    y,
    ye,
    ge
  ], J = () => ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", ye, ge], N = () => ["none", Fe, ye, ge], Q = () => ["none", Fe, ye, ge], de = () => [Fe, ye, ge], G = () => [zo, "full", ...O()];
  return {
    cacheSize: 500,
    theme: {
      animate: ["spin", "ping", "pulse", "bounce"],
      aspect: ["video"],
      blur: [Wn],
      breakpoint: [Wn],
      color: [XA],
      container: [Wn],
      "drop-shadow": [Wn],
      ease: ["in", "out", "in-out"],
      font: [rT],
      "font-weight": ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black"],
      "inset-shadow": [Wn],
      leading: ["none", "tight", "snug", "normal", "relaxed", "loose"],
      perspective: ["dramatic", "near", "normal", "midrange", "distant", "none"],
      radius: [Wn],
      shadow: [Wn],
      spacing: ["px", Fe],
      text: [Wn],
      tracking: ["tighter", "tight", "normal", "wide", "wider", "widest"]
    },
    classGroups: {
      // --------------
      // --- Layout ---
      // --------------
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", zo, ge, ye, p]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       * @deprecated since Tailwind CSS v4.0.0
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [Fe, ge, ye, s]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": w()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": w()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Screen Reader Only
       * @see https://tailwindcss.com/docs/display#screen-reader-only
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [..._(), ge, ye]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: T()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": T()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": T()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: A()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": A()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": A()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: M()
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": M()
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": M()
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: M()
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: M()
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: M()
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: M()
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: M()
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: M()
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: [vo, "auto", ye, ge]
      }],
      // ------------------------
      // --- Flexbox and Grid ---
      // ------------------------
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: [zo, "full", "auto", s, ...O()]
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["nowrap", "wrap", "wrap-reverse"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: [Fe, zo, "auto", "initial", "none", ge]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: ["", Fe, ye, ge]
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: ["", Fe, ye, ge]
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: [vo, "first", "last", "none", ye, ge]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": I()
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: C()
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": E()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": E()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": I()
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: C()
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": E()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": E()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": R()
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": R()
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: O()
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": O()
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": O()
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: [...k(), "normal"]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": [...L(), "normal"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", ...L()]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...k()]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: [...L(), "baseline"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", ...L(), "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": k()
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": [...L(), "baseline"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", ...L()]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: O()
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: O()
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: O()
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: O()
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: O()
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: O()
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: O()
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: O()
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: O()
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: z()
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: z()
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: z()
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: z()
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: z()
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: z()
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: z()
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: z()
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: z()
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x": [{
        "space-x": O()
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y": [{
        "space-y": O()
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y-reverse": ["space-y-reverse"],
      // --------------
      // --- Sizing ---
      // --------------
      /**
       * Size
       * @see https://tailwindcss.com/docs/width#setting-both-width-and-height
       */
      size: [{
        size: F()
      }],
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: [s, "screen", ...F()]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [
          s,
          "screen",
          /** Deprecated. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "none",
          ...F()
        ]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [
          s,
          "screen",
          "none",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "prose",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          {
            screen: [i]
          },
          ...F()
        ]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: ["screen", ...F()]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["screen", "none", ...F()]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": ["screen", ...F()]
      }],
      // ------------------
      // --- Typography ---
      // ------------------
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", r, Za, go]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: [n, ye, su]
      }],
      /**
       * Font Stretch
       * @see https://tailwindcss.com/docs/font-stretch
       */
      "font-stretch": [{
        "font-stretch": ["ultra-condensed", "extra-condensed", "condensed", "semi-condensed", "normal", "semi-expanded", "expanded", "extra-expanded", "ultra-expanded", Wm, ge]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [sT, ge, t]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: [o, ye, ge]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": [Fe, "none", ye, su]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: [
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          a,
          ...O()
        ]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", ye, ge]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["disc", "decimal", "none", ye, ge]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://v3.tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: q()
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: q()
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...W(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: [Fe, "from-font", "auto", ye, go]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: q()
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": [Fe, "auto", ye, ge]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: O()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", ye, ge]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", ye, ge]
      }],
      // -------------------
      // --- Backgrounds ---
      // -------------------
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [..._(), lT, oT]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "space", "round"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", uT, nT]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          linear: [{
            to: ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
          }, vo, ye, ge],
          radial: ["", ye, ge],
          conic: [vo, ye, ge]
        }, cT, iT]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: q()
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: j()
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: j()
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: j()
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: q()
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: q()
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: q()
      }],
      // ---------------
      // --- Borders ---
      // ---------------
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: D()
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": D()
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": D()
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": D()
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": D()
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": D()
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": D()
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": D()
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": D()
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": D()
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": D()
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": D()
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": D()
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": D()
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": D()
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: H()
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": H()
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": H()
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": H()
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": H()
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": H()
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": H()
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": H()
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": H()
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x": [{
        "divide-x": H()
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y": [{
        "divide-y": H()
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...W(), "hidden", "none"]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/border-style#setting-the-divider-style
       */
      "divide-style": [{
        divide: [...W(), "hidden", "none"]
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: q()
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": q()
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": q()
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": q()
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": q()
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": q()
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": q()
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": q()
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": q()
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: q()
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [...W(), "none", "hidden"]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [Fe, ye, ge]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: ["", Fe, Za, go]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      // ---------------
      // --- Effects ---
      // ---------------
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          "none",
          c,
          dT,
          aT
        ]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-shadow-color
       */
      "shadow-color": [{
        shadow: q()
      }],
      /**
       * Inset Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-shadow
       */
      "inset-shadow": [{
        "inset-shadow": ["none", ye, ge, d]
      }],
      /**
       * Inset Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-shadow-color
       */
      "inset-shadow-color": [{
        "inset-shadow": q()
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-a-ring
       */
      "ring-w": [{
        ring: H()
      }],
      /**
       * Ring Width Inset
       * @see https://v3.tailwindcss.com/docs/ring-width#inset-rings
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-ring-color
       */
      "ring-color": [{
        ring: q()
      }],
      /**
       * Ring Offset Width
       * @see https://v3.tailwindcss.com/docs/ring-offset-width
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-w": [{
        "ring-offset": [Fe, go]
      }],
      /**
       * Ring Offset Color
       * @see https://v3.tailwindcss.com/docs/ring-offset-color
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-color": [{
        "ring-offset": q()
      }],
      /**
       * Inset Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-ring
       */
      "inset-ring-w": [{
        "inset-ring": H()
      }],
      /**
       * Inset Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-ring-color
       */
      "inset-ring-color": [{
        "inset-ring": q()
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [Fe, ye, ge]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...ee(), "plus-darker", "plus-lighter"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": ee()
      }],
      // ---------------
      // --- Filters ---
      // ---------------
      /**
       * Filter
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          ye,
          ge
        ]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: oe()
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [Fe, ye, ge]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [Fe, ye, ge]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          "none",
          h,
          ye,
          ge
        ]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: ["", Fe, ye, ge]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [Fe, ye, ge]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: ["", Fe, ye, ge]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [Fe, ye, ge]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: ["", Fe, ye, ge]
      }],
      /**
       * Backdrop Filter
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          ye,
          ge
        ]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": oe()
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [Fe, ye, ge]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [Fe, ye, ge]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": ["", Fe, ye, ge]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [Fe, ye, ge]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": ["", Fe, ye, ge]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [Fe, ye, ge]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [Fe, ye, ge]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": ["", Fe, ye, ge]
      }],
      // --------------
      // --- Tables ---
      // --------------
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": O()
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": O()
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": O()
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // ---------------------------------
      // --- Transitions and Animation ---
      // ---------------------------------
      /**
       * Transition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["", "all", "colors", "opacity", "shadow", "transform", "none", ye, ge]
      }],
      /**
       * Transition Behavior
       * @see https://tailwindcss.com/docs/transition-behavior
       */
      "transition-behavior": [{
        transition: ["normal", "discrete"]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: [Fe, "initial", ye, ge]
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "initial", f, ye, ge]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: [Fe, ye, ge]
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", v, ye, ge]
      }],
      // ------------------
      // --- Transforms ---
      // ------------------
      /**
       * Backface Visibility
       * @see https://tailwindcss.com/docs/backface-visibility
       */
      backface: [{
        backface: ["hidden", "visible"]
      }],
      /**
       * Perspective
       * @see https://tailwindcss.com/docs/perspective
       */
      perspective: [{
        perspective: [m, ye, ge]
      }],
      /**
       * Perspective Origin
       * @see https://tailwindcss.com/docs/perspective-origin
       */
      "perspective-origin": [{
        "perspective-origin": J()
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: N()
      }],
      /**
       * Rotate X
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-x": [{
        "rotate-x": N()
      }],
      /**
       * Rotate Y
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-y": [{
        "rotate-y": N()
      }],
      /**
       * Rotate Z
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-z": [{
        "rotate-z": N()
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: Q()
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": Q()
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": Q()
      }],
      /**
       * Scale Z
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-z": [{
        "scale-z": Q()
      }],
      /**
       * Scale 3D
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-3d": ["scale-3d"],
      /**
       * Skew
       * @see https://tailwindcss.com/docs/skew
       */
      skew: [{
        skew: de()
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": de()
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": de()
      }],
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: [ye, ge, "", "none", "gpu", "cpu"]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: J()
      }],
      /**
       * Transform Style
       * @see https://tailwindcss.com/docs/transform-style
       */
      "transform-style": [{
        transform: ["3d", "flat"]
      }],
      /**
       * Translate
       * @see https://tailwindcss.com/docs/translate
       */
      translate: [{
        translate: G()
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": G()
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": G()
      }],
      /**
       * Translate Z
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-z": [{
        "translate-z": G()
      }],
      /**
       * Translate None
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-none": ["translate-none"],
      // ---------------------
      // --- Interactivity ---
      // ---------------------
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: q()
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: q()
      }],
      /**
       * Color Scheme
       * @see https://tailwindcss.com/docs/color-scheme
       */
      "color-scheme": [{
        scheme: ["normal", "dark", "light", "light-dark", "only-dark", "only-light"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", ye, ge]
      }],
      /**
       * Field Sizing
       * @see https://tailwindcss.com/docs/field-sizing
       */
      "field-sizing": [{
        "field-sizing": ["fixed", "content"]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["auto", "none"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "", "y", "x"]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": O()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": O()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": O()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": O()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": O()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": O()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": O()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": O()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": O()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": O()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": O()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": O()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": O()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": O()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": O()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": O()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": O()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": O()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", ye, ge]
      }],
      // -----------
      // --- SVG ---
      // -----------
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: ["none", ...q()]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [Fe, Za, go, su]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: ["none", ...q()]
      }],
      // ---------------------
      // --- Accessibility ---
      // ---------------------
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      translate: ["translate-x", "translate-y", "translate-none"],
      "translate-none": ["translate", "translate-x", "translate-y", "translate-z"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    },
    orderSensitiveModifiers: ["before", "after", "placeholder", "file", "marker", "selection", "first-line", "first-letter", "backdrop", "*", "**"]
  };
}, gT = (e, {
  cacheSize: t,
  prefix: r,
  experimentalParseClassName: n,
  extend: o = {},
  override: a = {}
}) => (Gi(e, "cacheSize", t), Gi(e, "prefix", r), Gi(e, "experimentalParseClassName", n), Xa(e.theme, a.theme), Xa(e.classGroups, a.classGroups), Xa(e.conflictingClassGroups, a.conflictingClassGroups), Xa(e.conflictingClassGroupModifiers, a.conflictingClassGroupModifiers), Gi(e, "orderSensitiveModifiers", a.orderSensitiveModifiers), Qa(e.theme, o.theme), Qa(e.classGroups, o.classGroups), Qa(e.conflictingClassGroups, o.conflictingClassGroups), Qa(e.conflictingClassGroupModifiers, o.conflictingClassGroupModifiers), h1(e, o, "orderSensitiveModifiers"), e), Gi = (e, t, r) => {
  r !== void 0 && (e[t] = r);
}, Xa = (e, t) => {
  if (t)
    for (const r in t)
      Gi(e, r, t[r]);
}, Qa = (e, t) => {
  if (t)
    for (const r in t)
      h1(e, t, r);
}, h1 = (e, t, r) => {
  const n = t[r];
  n !== void 0 && (e[r] = e[r] ? e[r].concat(n) : n);
}, yT = (e, ...t) => typeof e == "function" ? zf(jf, e, ...t) : zf(() => gT(jf(), e), ...t), bT = /* @__PURE__ */ zf(jf);
var wT = { twMerge: !0, twMergeConfig: {}, responsiveVariants: !1 }, m1 = (e) => e || void 0, sa = (...e) => m1(n1(e).filter(Boolean).join(" ")), lu = null, bn = {}, Uf = !1, ji = (...e) => (t) => t.twMerge ? ((!lu || Uf) && (Uf = !1, lu = ir(bn) ? bT : yT({ ...bn, extend: { theme: bn.theme, classGroups: bn.classGroups, conflictingClassGroupModifiers: bn.conflictingClassGroupModifiers, conflictingClassGroups: bn.conflictingClassGroups, ...bn.extend } })), m1(lu(sa(e)))) : sa(e), Vm = (e, t) => {
  for (let r in t) e.hasOwnProperty(r) ? e[r] = sa(e[r], t[r]) : e[r] = t[r];
  return e;
}, v1 = (e, t) => {
  let { extend: r = null, slots: n = {}, variants: o = {}, compoundVariants: a = [], compoundSlots: i = [], defaultVariants: s = {} } = e, l = { ...wT, ...t }, u = r != null && r.base ? sa(r.base, e == null ? void 0 : e.base) : e == null ? void 0 : e.base, c = r != null && r.variants && !ir(r.variants) ? i1(o, r.variants) : o, d = r != null && r.defaultVariants && !ir(r.defaultVariants) ? { ...r.defaultVariants, ...s } : s;
  !ir(l.twMergeConfig) && !IA(l.twMergeConfig, bn) && (Uf = !0, bn = l.twMergeConfig);
  let h = ir(r == null ? void 0 : r.slots), y = ir(n) ? {} : { base: sa(e == null ? void 0 : e.base, h && (r == null ? void 0 : r.base)), ...n }, m = h ? y : Vm({ ...r == null ? void 0 : r.slots }, ir(y) ? { base: e == null ? void 0 : e.base } : y), p = ir(r == null ? void 0 : r.compoundVariants) ? a : o1(r == null ? void 0 : r.compoundVariants, a), f = (w) => {
    if (ir(c) && ir(n) && h) return ji(u, w == null ? void 0 : w.class, w == null ? void 0 : w.className)(l);
    if (p && !Array.isArray(p)) throw new TypeError(`The "compoundVariants" prop must be an array. Received: ${typeof p}`);
    if (i && !Array.isArray(i)) throw new TypeError(`The "compoundSlots" prop must be an array. Received: ${typeof i}`);
    let _ = (k, L, z = [], F) => {
      let q = z;
      if (typeof L == "string") q = q.concat(zm(L).split(" ").map((j) => `${k}:${j}`));
      else if (Array.isArray(L)) q = q.concat(L.reduce((j, D) => j.concat(`${k}:${D}`), []));
      else if (typeof L == "object" && typeof F == "string") {
        for (let j in L) if (L.hasOwnProperty(j) && j === F) {
          let D = L[j];
          if (D && typeof D == "string") {
            let H = zm(D);
            q[F] ? q[F] = q[F].concat(H.split(" ").map((W) => `${k}:${W}`)) : q[F] = H.split(" ").map((W) => `${k}:${W}`);
          } else Array.isArray(D) && D.length > 0 && (q[F] = D.reduce((H, W) => H.concat(`${k}:${W}`), []));
        }
      }
      return q;
    }, T = (k, L = c, z = null, F = null) => {
      var q;
      let j = L[k];
      if (!j || ir(j)) return null;
      let D = (q = F == null ? void 0 : F[k]) != null ? q : w == null ? void 0 : w[k];
      if (D === null) return null;
      let H = Nm(D), W = Array.isArray(l.responsiveVariants) && l.responsiveVariants.length > 0 || l.responsiveVariants === !0, ee = d == null ? void 0 : d[k], oe = [];
      if (typeof H == "object" && W) for (let [Q, de] of Object.entries(H)) {
        let G = j[de];
        if (Q === "initial") {
          ee = de;
          continue;
        }
        Array.isArray(l.responsiveVariants) && !l.responsiveVariants.includes(Q) || (oe = _(Q, G, oe, z));
      }
      let J = H != null && typeof H != "object" ? H : Nm(ee), N = j[J || "false"];
      return typeof oe == "object" && typeof z == "string" && oe[z] ? Vm(oe, N) : oe.length > 0 ? (oe.push(N), z === "base" ? oe.join(" ") : oe) : N;
    }, A = () => c ? Object.keys(c).map((k) => T(k, c)) : null, O = (k, L) => {
      if (!c || typeof c != "object") return null;
      let z = new Array();
      for (let F in c) {
        let q = T(F, c, k, L), j = k === "base" && typeof q == "string" ? q : q && q[k];
        j && (z[z.length] = j);
      }
      return z;
    }, M = {};
    for (let k in w) w[k] !== void 0 && (M[k] = w[k]);
    let I = (k, L) => {
      var z;
      let F = typeof (w == null ? void 0 : w[k]) == "object" ? { [k]: (z = w[k]) == null ? void 0 : z.initial } : {};
      return { ...d, ...M, ...F, ...L };
    }, C = (k = [], L) => {
      let z = [];
      for (let { class: F, className: q, ...j } of k) {
        let D = !0;
        for (let [H, W] of Object.entries(j)) {
          let ee = I(H, L)[H];
          if (Array.isArray(W)) {
            if (!W.includes(ee)) {
              D = !1;
              break;
            }
          } else {
            let oe = (J) => J == null || J === !1;
            if (oe(W) && oe(ee)) continue;
            if (ee !== W) {
              D = !1;
              break;
            }
          }
        }
        D && (F && z.push(F), q && z.push(q));
      }
      return z;
    }, E = (k) => {
      let L = C(p, k);
      if (!Array.isArray(L)) return L;
      let z = {};
      for (let F of L) if (typeof F == "string" && (z.base = ji(z.base, F)(l)), typeof F == "object") for (let [q, j] of Object.entries(F)) z[q] = ji(z[q], j)(l);
      return z;
    }, R = (k) => {
      if (i.length < 1) return null;
      let L = {};
      for (let { slots: z = [], class: F, className: q, ...j } of i) {
        if (!ir(j)) {
          let D = !0;
          for (let H of Object.keys(j)) {
            let W = I(H, k)[H];
            if (W === void 0 || (Array.isArray(j[H]) ? !j[H].includes(W) : j[H] !== W)) {
              D = !1;
              break;
            }
          }
          if (!D) continue;
        }
        for (let D of z) L[D] = L[D] || [], L[D].push([F, q]);
      }
      return L;
    };
    if (!ir(n) || !h) {
      let k = {};
      if (typeof m == "object" && !ir(m)) for (let L of Object.keys(m)) k[L] = (z) => {
        var F, q;
        return ji(m[L], O(L, z), ((F = E(z)) != null ? F : [])[L], ((q = R(z)) != null ? q : [])[L], z == null ? void 0 : z.class, z == null ? void 0 : z.className)(l);
      };
      return k;
    }
    return ji(u, A(), C(p), w == null ? void 0 : w.class, w == null ? void 0 : w.className)(l);
  }, v = () => {
    if (!(!c || typeof c != "object")) return Object.keys(c);
  };
  return f.variantKeys = v(), f.extend = r, f.base = u, f.slots = m, f.variants = c, f.defaultVariants = d, f.compoundSlots = i, f.compoundVariants = p, f;
};
const _T = v1({
  base: "font-semibold leading-tight",
  variants: {
    size: {
      base: "text-base",
      lg: "text-lg",
      xl: "text-xl",
      "2xl": "text-2xl",
      "3xl": "text-3xl"
    }
  }
}), gi = /* @__PURE__ */ U({
  __name: "Heading",
  props: {
    level: { default: "h2" },
    size: { default: "xl" },
    class: { default: void 0 }
  },
  setup(e) {
    const t = e;
    return (r, n) => ($(), ne(er(r.level), {
      class: Te(S(da)(S(_T)({ size: r.size }), t.class))
    }, {
      default: Y(() => [
        V(r.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), q6 = /* @__PURE__ */ U({
  __name: "AlertDialogTitle",
  setup(e) {
    const t = je("alertDialogLabelledBy");
    return (r, n) => ($(), ne(S(gi), {
      id: S(t),
      level: "h2"
    }, {
      default: Y(() => [
        V(r.$slots, "default")
      ]),
      _: 3
    }, 8, ["id"]));
  }
}), fa = /* @__PURE__ */ U({
  __name: "AspectRatio",
  props: {
    fit: { default: "cover" },
    ratio: { default: 1 }
  },
  setup(e) {
    return (t, r) => ($(), B("div", {
      style: $t({ paddingBottom: `${100 / t.ratio}%` }),
      class: "relative w-full"
    }, [
      X("div", {
        class: Te(["absolute inset-0 [&>*]:size-full", {
          "[&>*]:object-cover": t.fit === "cover",
          "[&>*]:object-contain": t.fit === "contain"
        }])
      }, [
        V(t.$slots, "default")
      ], 2)
    ], 4));
  }
});
function _r(e, t) {
  const r = typeof e == "string" && !t ? `${e}Context` : t, n = Symbol(r);
  return [(o) => {
    const a = je(n, o);
    if (a || a === null)
      return a;
    throw new Error(
      `Injection \`${n.toString()}\` not found. Component must be used within ${Array.isArray(e) ? `one of the following components: ${e.join(
        ", "
      )}` : `\`${e}\``}`
    );
  }, (o) => (tt(n, o), o)];
}
function Rp(e, t, r) {
  const n = r.originalEvent.target, o = new CustomEvent(e, {
    bubbles: !1,
    cancelable: !0,
    detail: r
  });
  t && n.addEventListener(e, t, { once: !0 }), n.dispatchEvent(o);
}
function ST(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var xT = function e(t, r) {
  if (t === r) return !0;
  if (t && r && typeof t == "object" && typeof r == "object") {
    if (t.constructor !== r.constructor) return !1;
    var n, o, a;
    if (Array.isArray(t)) {
      if (n = t.length, n != r.length) return !1;
      for (o = n; o-- !== 0; )
        if (!e(t[o], r[o])) return !1;
      return !0;
    }
    if (t.constructor === RegExp) return t.source === r.source && t.flags === r.flags;
    if (t.valueOf !== Object.prototype.valueOf) return t.valueOf() === r.valueOf();
    if (t.toString !== Object.prototype.toString) return t.toString() === r.toString();
    if (a = Object.keys(t), n = a.length, n !== Object.keys(r).length) return !1;
    for (o = n; o-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(r, a[o])) return !1;
    for (o = n; o-- !== 0; ) {
      var i = a[o];
      if (!e(t[i], r[i])) return !1;
    }
    return !0;
  }
  return t !== t && r !== r;
};
const So = /* @__PURE__ */ ST(xT);
function AT(e, t) {
  var r;
  const n = Zr();
  return Pr(() => {
    n.value = e();
  }, {
    ...t,
    flush: (r = void 0) != null ? r : "sync"
  }), qs(n);
}
function Gs(e) {
  return Bs() ? (up(e), !0) : !1;
}
function TT(e) {
  let t = !1, r;
  const n = I0(!0);
  return (...o) => (t || (r = n.run(() => e(...o)), t = !0), r);
}
function g1(e) {
  let t = 0, r, n;
  const o = () => {
    t -= 1, n && t <= 0 && (n.stop(), r = void 0, n = void 0);
  };
  return (...a) => (t += 1, r || (n = I0(!0), r = n.run(() => e(...a))), Gs(o), r);
}
function Jn(e) {
  return typeof e == "function" ? e() : S(e);
}
const ro = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const ET = (e) => typeof e < "u", OT = (e) => e != null, $T = Object.prototype.toString, CT = (e) => $T.call(e) === "[object Object]", kT = () => {
}, Hm = /* @__PURE__ */ PT();
function PT() {
  var e, t;
  return ro && ((e = window == null ? void 0 : window.navigator) == null ? void 0 : e.userAgent) && (/iP(?:ad|hone|od)/.test(window.navigator.userAgent) || ((t = window == null ? void 0 : window.navigator) == null ? void 0 : t.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
function IT(e) {
  return rn();
}
function DT(e, t = 1e4) {
  return $0((r, n) => {
    let o = Jn(e), a;
    const i = () => setTimeout(() => {
      o = Jn(e), n();
    }, Jn(t));
    return Gs(() => {
      clearTimeout(a);
    }), {
      get() {
        return r(), o;
      },
      set(s) {
        o = s, n(), clearTimeout(a), a = i();
      }
    };
  });
}
function RT(e, t) {
  IT() && Gw(e, t);
}
function On(e) {
  var t;
  const r = Jn(e);
  return (t = r == null ? void 0 : r.$el) != null ? t : r;
}
const Ks = ro ? window : void 0;
function $s(...e) {
  let t, r, n, o;
  if (typeof e[0] == "string" || Array.isArray(e[0]) ? ([r, n, o] = e, t = Ks) : [t, r, n, o] = e, !t)
    return kT;
  Array.isArray(r) || (r = [r]), Array.isArray(n) || (n = [n]);
  const a = [], i = () => {
    a.forEach((c) => c()), a.length = 0;
  }, s = (c, d, h, y) => (c.addEventListener(d, h, y), () => c.removeEventListener(d, h, y)), l = at(
    () => [On(t), Jn(o)],
    ([c, d]) => {
      if (i(), !c)
        return;
      const h = CT(d) ? { ...d } : d;
      a.push(
        ...r.flatMap((y) => n.map((m) => s(c, y, m, h)))
      );
    },
    { immediate: !0, flush: "post" }
  ), u = () => {
    l(), i();
  };
  return Gs(u), u;
}
function MT(e) {
  return typeof e == "function" ? e : typeof e == "string" ? (t) => t.key === e : Array.isArray(e) ? (t) => e.includes(t.key) : () => !0;
}
function BT(...e) {
  let t, r, n = {};
  e.length === 3 ? (t = e[0], r = e[1], n = e[2]) : e.length === 2 ? typeof e[1] == "object" ? (t = !0, r = e[0], n = e[1]) : (t = e[0], r = e[1]) : (t = !0, r = e[0]);
  const {
    target: o = Ks,
    eventName: a = "keydown",
    passive: i = !1,
    dedupe: s = !1
  } = n, l = MT(t);
  return $s(o, a, (u) => {
    u.repeat && Jn(s) || l(u) && r(u);
  }, i);
}
function y1() {
  const e = se(!1), t = rn();
  return t && Lt(() => {
    e.value = !0;
  }, t), e;
}
function qT(e) {
  const t = y1();
  return re(() => (t.value, !!e()));
}
function LT(e, t, r = {}) {
  const { window: n = Ks, ...o } = r;
  let a;
  const i = qT(() => n && "MutationObserver" in n), s = () => {
    a && (a.disconnect(), a = void 0);
  }, l = re(() => {
    const h = Jn(e), y = (Array.isArray(h) ? h : [h]).map(On).filter(OT);
    return new Set(y);
  }), u = at(
    () => l.value,
    (h) => {
      s(), i.value && h.size && (a = new MutationObserver(t), h.forEach((y) => a.observe(y, o)));
    },
    { immediate: !0, flush: "post" }
  ), c = () => a == null ? void 0 : a.takeRecords(), d = () => {
    s(), u();
  };
  return Gs(d), {
    isSupported: i,
    stop: d,
    takeRecords: c
  };
}
function FT(e) {
  return JSON.parse(JSON.stringify(e));
}
function xo(e, t, r, n = {}) {
  var o, a, i;
  const {
    clone: s = !1,
    passive: l = !1,
    eventName: u,
    deep: c = !1,
    defaultValue: d,
    shouldEmit: h
  } = n, y = rn(), m = r || (y == null ? void 0 : y.emit) || ((o = y == null ? void 0 : y.$emit) == null ? void 0 : o.bind(y)) || ((i = (a = y == null ? void 0 : y.proxy) == null ? void 0 : a.$emit) == null ? void 0 : i.bind(y == null ? void 0 : y.proxy));
  let p = u;
  t || (t = "modelValue"), p = p || `update:${t.toString()}`;
  const f = (_) => s ? typeof s == "function" ? s(_) : FT(_) : _, v = () => ET(e[t]) ? f(e[t]) : d, w = (_) => {
    h ? h(_) && m(p, _) : m(p, _);
  };
  if (l) {
    const _ = v(), T = se(_);
    let A = !1;
    return at(
      () => e[t],
      (O) => {
        A || (A = !0, T.value = f(O), Qe(() => A = !1));
      }
    ), at(
      T,
      (O) => {
        !A && (O !== e[t] || c) && w(O);
      },
      { deep: c }
    ), T;
  } else
    return re({
      get() {
        return v();
      },
      set(_) {
        w(_);
      }
    });
}
function Mp(e) {
  return e ? e.flatMap((t) => t.type === qt ? Mp(t.children) : [t]) : [];
}
function kr() {
  let e = document.activeElement;
  if (e == null)
    return null;
  for (; e != null && e.shadowRoot != null && e.shadowRoot.activeElement != null; )
    e = e.shadowRoot.activeElement;
  return e;
}
const NT = ["INPUT", "TEXTAREA"];
function zT(e, t, r, n = {}) {
  if (!t || n.enableIgnoredElement && NT.includes(t.nodeName))
    return null;
  const {
    arrowKeyOptions: o = "both",
    attributeName: a = "[data-radix-vue-collection-item]",
    itemsArray: i = [],
    loop: s = !0,
    dir: l = "ltr",
    preventScroll: u = !0,
    focus: c = !1
  } = n, [d, h, y, m, p, f] = [
    e.key === "ArrowRight",
    e.key === "ArrowLeft",
    e.key === "ArrowUp",
    e.key === "ArrowDown",
    e.key === "Home",
    e.key === "End"
  ], v = y || m, w = d || h;
  if (!p && !f && (!v && !w || o === "vertical" && w || o === "horizontal" && v))
    return null;
  const _ = r ? Array.from(r.querySelectorAll(a)) : i;
  if (!_.length)
    return null;
  u && e.preventDefault();
  let T = null;
  return w || v ? T = b1(_, t, {
    goForward: v ? m : l === "ltr" ? d : h,
    loop: s
  }) : p ? T = _.at(0) || null : f && (T = _.at(-1) || null), c && (T == null || T.focus()), T;
}
function b1(e, t, r, n = e.length) {
  if (--n === 0)
    return null;
  const o = e.indexOf(t), a = r.goForward ? o + 1 : o - 1;
  if (!r.loop && (a < 0 || a >= e.length))
    return null;
  const i = (a + e.length) % e.length, s = e[i];
  return s ? s.hasAttribute("disabled") && s.getAttribute("disabled") !== "false" ? b1(
    e,
    s,
    r,
    n
  ) : s : null;
}
function uu(e) {
  if (e === null || typeof e != "object")
    return !1;
  const t = Object.getPrototypeOf(e);
  return t !== null && t !== Object.prototype && Object.getPrototypeOf(t) !== null || Symbol.iterator in e ? !1 : Symbol.toStringTag in e ? Object.prototype.toString.call(e) === "[object Module]" : !0;
}
function Wf(e, t, r = ".", n) {
  if (!uu(t))
    return Wf(e, {}, r);
  const o = Object.assign({}, t);
  for (const a in e) {
    if (a === "__proto__" || a === "constructor")
      continue;
    const i = e[a];
    i != null && (Array.isArray(i) && Array.isArray(o[a]) ? o[a] = [...i, ...o[a]] : uu(i) && uu(o[a]) ? o[a] = Wf(
      i,
      o[a],
      (r ? `${r}.` : "") + a.toString()
    ) : o[a] = i);
  }
  return o;
}
function jT(e) {
  return (...t) => (
    // eslint-disable-next-line unicorn/no-array-reduce
    t.reduce((r, n) => Wf(r, n, ""), {})
  );
}
const UT = jT(), [Bp, L6] = _r("ConfigProvider");
let WT = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict", VT = (e = 21) => {
  let t = "", r = e;
  for (; r--; )
    t += WT[Math.random() * 64 | 0];
  return t;
};
const HT = g1(() => {
  const e = se(/* @__PURE__ */ new Map()), t = se(), r = re(() => {
    for (const i of e.value.values())
      if (i)
        return !0;
    return !1;
  }), n = Bp({
    scrollBody: se(!0)
  });
  let o = null;
  const a = () => {
    document.body.style.paddingRight = "", document.body.style.marginRight = "", document.body.style.pointerEvents = "", document.body.style.removeProperty("--scrollbar-width"), document.body.style.overflow = t.value ?? "", Hm && (o == null || o()), t.value = void 0;
  };
  return at(r, (i, s) => {
    var l;
    if (!ro)
      return;
    if (!i) {
      s && a();
      return;
    }
    t.value === void 0 && (t.value = document.body.style.overflow);
    const u = window.innerWidth - document.documentElement.clientWidth, c = { padding: u, margin: 0 }, d = (l = n.scrollBody) != null && l.value ? typeof n.scrollBody.value == "object" ? UT({
      padding: n.scrollBody.value.padding === !0 ? u : n.scrollBody.value.padding,
      margin: n.scrollBody.value.margin === !0 ? u : n.scrollBody.value.margin
    }, c) : c : { padding: 0, margin: 0 };
    u > 0 && (document.body.style.paddingRight = typeof d.padding == "number" ? `${d.padding}px` : String(d.padding), document.body.style.marginRight = typeof d.margin == "number" ? `${d.margin}px` : String(d.margin), document.body.style.setProperty("--scrollbar-width", `${u}px`), document.body.style.overflow = "hidden"), Hm && (o = $s(
      document,
      "touchmove",
      (h) => GT(h),
      { passive: !1 }
    )), Qe(() => {
      document.body.style.pointerEvents = "none", document.body.style.overflow = "hidden";
    });
  }, { immediate: !0, flush: "sync" }), e;
});
function w1(e) {
  const t = VT(6), r = HT();
  r.value.set(t, e ?? !1);
  const n = re({
    get: () => r.value.get(t) ?? !1,
    set: (o) => r.value.set(t, o)
  });
  return RT(() => {
    r.value.delete(t);
  }), n;
}
function _1(e) {
  const t = window.getComputedStyle(e);
  if (t.overflowX === "scroll" || t.overflowY === "scroll" || t.overflowX === "auto" && e.clientWidth < e.scrollWidth || t.overflowY === "auto" && e.clientHeight < e.scrollHeight)
    return !0;
  {
    const r = e.parentNode;
    return !(r instanceof Element) || r.tagName === "BODY" ? !1 : _1(r);
  }
}
function GT(e) {
  const t = e || window.event, r = t.target;
  return r instanceof Element && _1(r) ? !1 : t.touches.length > 1 ? !0 : (t.preventDefault && t.cancelable && t.preventDefault(), !1);
}
const KT = "data-radix-vue-collection-item";
function YT(e, t = KT) {
  const r = Symbol();
  return { createCollection: (n) => {
    const o = se([]);
    function a() {
      const i = On(n);
      return i ? o.value = Array.from(
        i.querySelectorAll(`[${t}]:not([data-disabled])`)
      ) : o.value = [];
    }
    return Kw(() => {
      o.value = [];
    }), Lt(a), Yw(a), at(() => n == null ? void 0 : n.value, a, { immediate: !0 }), tt(r, o), o;
  }, injectCollection: () => je(r, se([])) };
}
function Ys(e) {
  const t = Bp({
    dir: se("ltr")
  });
  return re(() => {
    var r;
    return (e == null ? void 0 : e.value) || ((r = t.dir) == null ? void 0 : r.value) || "ltr";
  });
}
function S1(e) {
  const t = rn(), r = t == null ? void 0 : t.type.emits, n = {};
  return r != null && r.length || console.warn(
    `No emitted event found. Please check component: ${t == null ? void 0 : t.type.__name}`
  ), r == null || r.forEach((o) => {
    n[jw(k0(o))] = (...a) => e(o, ...a);
  }), n;
}
let cu = 0;
function JT() {
  Pr((e) => {
    if (!ro)
      return;
    const t = document.querySelectorAll("[data-radix-focus-guard]");
    document.body.insertAdjacentElement(
      "afterbegin",
      t[0] ?? Gm()
    ), document.body.insertAdjacentElement(
      "beforeend",
      t[1] ?? Gm()
    ), cu++, e(() => {
      cu === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((r) => r.remove()), cu--;
    });
  });
}
function Gm() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
function ZT(e) {
  return re(() => {
    var t;
    return Jn(e) ? !!((t = On(e)) != null && t.closest("form")) : !0;
  });
}
function Js(e) {
  const t = rn(), r = Object.keys((t == null ? void 0 : t.type.props) ?? {}).reduce((o, a) => {
    const i = (t == null ? void 0 : t.type.props[a]).default;
    return i !== void 0 && (o[a] = i), o;
  }, {}), n = _s(e);
  return re(() => {
    const o = {}, a = (t == null ? void 0 : t.vnode.props) ?? {};
    return Object.keys(a).forEach((i) => {
      o[k0(i)] = a[i];
    }), Object.keys({ ...r, ...o }).reduce((i, s) => (n.value[s] !== void 0 && (i[s] = n.value[s]), i), {});
  });
}
function Io(e, t) {
  const r = Js(e), n = t ? S1(t) : {};
  return re(() => ({
    ...r.value,
    ...n
  }));
}
function wt() {
  const e = rn(), t = se(), r = re(() => {
    var i, s;
    return ["#text", "#comment"].includes((i = t.value) == null ? void 0 : i.$el.nodeName) ? (s = t.value) == null ? void 0 : s.$el.nextElementSibling : On(t);
  }), n = Object.assign({}, e.exposed), o = {};
  for (const i in e.props)
    Object.defineProperty(o, i, {
      enumerable: !0,
      configurable: !0,
      get: () => e.props[i]
    });
  if (Object.keys(n).length > 0)
    for (const i in n)
      Object.defineProperty(o, i, {
        enumerable: !0,
        configurable: !0,
        get: () => n[i]
      });
  Object.defineProperty(o, "$el", {
    enumerable: !0,
    configurable: !0,
    get: () => e.vnode.el
  }), e.exposed = o;
  function a(i) {
    t.value = i, i && (Object.defineProperty(o, "$el", {
      enumerable: !0,
      configurable: !0,
      get: () => i instanceof Element ? i : i.$el
    }), e.exposed = o);
  }
  return { forwardRef: a, currentRef: t, currentElement: r };
}
var XT = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, jo = /* @__PURE__ */ new WeakMap(), es = /* @__PURE__ */ new WeakMap(), ts = {}, du = 0, x1 = function(e) {
  return e && (e.host || x1(e.parentNode));
}, QT = function(e, t) {
  return t.map(function(r) {
    if (e.contains(r))
      return r;
    var n = x1(r);
    return n && e.contains(n) ? n : (console.error("aria-hidden", r, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(r) {
    return !!r;
  });
}, eE = function(e, t, r, n) {
  var o = QT(t, Array.isArray(e) ? e : [e]);
  ts[r] || (ts[r] = /* @__PURE__ */ new WeakMap());
  var a = ts[r], i = [], s = /* @__PURE__ */ new Set(), l = new Set(o), u = function(d) {
    !d || s.has(d) || (s.add(d), u(d.parentNode));
  };
  o.forEach(u);
  var c = function(d) {
    !d || l.has(d) || Array.prototype.forEach.call(d.children, function(h) {
      if (s.has(h))
        c(h);
      else
        try {
          var y = h.getAttribute(n), m = y !== null && y !== "false", p = (jo.get(h) || 0) + 1, f = (a.get(h) || 0) + 1;
          jo.set(h, p), a.set(h, f), i.push(h), p === 1 && m && es.set(h, !0), f === 1 && h.setAttribute(r, "true"), m || h.setAttribute(n, "true");
        } catch (v) {
          console.error("aria-hidden: cannot operate on ", h, v);
        }
    });
  };
  return c(t), s.clear(), du++, function() {
    i.forEach(function(d) {
      var h = jo.get(d) - 1, y = a.get(d) - 1;
      jo.set(d, h), a.set(d, y), h || (es.has(d) || d.removeAttribute(n), es.delete(d)), y || d.removeAttribute(r);
    }), du--, du || (jo = /* @__PURE__ */ new WeakMap(), jo = /* @__PURE__ */ new WeakMap(), es = /* @__PURE__ */ new WeakMap(), ts = {});
  };
}, tE = function(e, t, r) {
  r === void 0 && (r = "data-aria-hidden");
  var n = Array.from(Array.isArray(e) ? e : [e]), o = XT(e);
  return o ? (n.push.apply(n, Array.from(o.querySelectorAll("[aria-live]"))), eE(n, o, r, "aria-hidden")) : function() {
    return null;
  };
};
function A1(e) {
  let t;
  at(() => On(e), (r) => {
    r ? t = tE(r) : t && t();
  }), Co(() => {
    t && t();
  });
}
let rE = 0;
function ai(e, t = "radix") {
  const r = Bp({ useId: void 0 });
  return th.useId ? `${t}-${th.useId()}` : r.useId ? `${t}-${r.useId()}` : `${t}-${++rE}`;
}
function nE(e) {
  const t = se(), r = re(() => {
    var o;
    return ((o = t.value) == null ? void 0 : o.width) ?? 0;
  }), n = re(() => {
    var o;
    return ((o = t.value) == null ? void 0 : o.height) ?? 0;
  });
  return Lt(() => {
    const o = On(e);
    if (o) {
      t.value = { width: o.offsetWidth, height: o.offsetHeight };
      const a = new ResizeObserver((i) => {
        if (!Array.isArray(i) || !i.length)
          return;
        const s = i[0];
        let l, u;
        if ("borderBoxSize" in s) {
          const c = s.borderBoxSize, d = Array.isArray(c) ? c[0] : c;
          l = d.inlineSize, u = d.blockSize;
        } else
          l = o.offsetWidth, u = o.offsetHeight;
        t.value = { width: l, height: u };
      });
      return a.observe(o, { box: "border-box" }), () => a.unobserve(o);
    } else
      t.value = void 0;
  }), {
    width: r,
    height: n
  };
}
function oE(e, t) {
  const r = se(e);
  function n(o) {
    return t[r.value][o] ?? r.value;
  }
  return {
    state: r,
    dispatch: (o) => {
      r.value = n(o);
    }
  };
}
const iE = "data-item-text";
function aE(e) {
  const t = DT("", 1e3);
  return {
    search: t,
    handleTypeaheadSearch: (r, n) => {
      if (!(e != null && e.value) && !n)
        return;
      t.value = t.value + r;
      const o = (e == null ? void 0 : e.value) ?? n, a = kr(), i = o.map((d) => {
        var h;
        return {
          ref: d,
          textValue: ((h = (d.querySelector(`[${iE}]`) ?? d).textContent) == null ? void 0 : h.trim()) ?? ""
        };
      }), s = i.find((d) => d.ref === a), l = i.map((d) => d.textValue), u = lE(l, t.value, s == null ? void 0 : s.textValue), c = i.find((d) => d.textValue === u);
      return c && c.ref.focus(), c == null ? void 0 : c.ref;
    },
    resetTypeahead: () => {
      t.value = "";
    }
  };
}
function sE(e, t) {
  return e.map((r, n) => e[(t + n) % e.length]);
}
function lE(e, t, r) {
  const n = t.length > 1 && Array.from(t).every((s) => s === t[0]) ? t[0] : t, o = r ? e.indexOf(r) : -1;
  let a = sE(e, Math.max(o, 0));
  n.length === 1 && (a = a.filter((s) => s !== r));
  const i = a.find(
    (s) => s.toLowerCase().startsWith(n.toLowerCase())
  );
  return i !== r ? i : void 0;
}
const qp = U({
  name: "PrimitiveSlot",
  inheritAttrs: !1,
  setup(e, { attrs: t, slots: r }) {
    return () => {
      var n, o;
      if (!r.default)
        return null;
      const a = Mp(r.default()), i = a.findIndex((c) => c.type !== Uw);
      if (i === -1)
        return a;
      const s = a[i];
      (n = s.props) == null || delete n.ref;
      const l = s.props ? We(t, s.props) : t;
      t.class && (o = s.props) != null && o.class && delete s.props.class;
      const u = Ww(s, l);
      for (const c in l)
        c.startsWith("on") && (u.props || (u.props = {}), u.props[c] = l[c]);
      return a.length === 1 ? u : (a[i] = u, a);
    };
  }
}), Gt = U({
  name: "Primitive",
  inheritAttrs: !1,
  props: {
    asChild: {
      type: Boolean,
      default: !1
    },
    as: {
      type: [String, Object],
      default: "div"
    }
  },
  setup(e, { attrs: t, slots: r }) {
    const n = e.asChild ? "template" : e.as;
    return typeof n == "string" && ["area", "img", "input"].includes(n) ? () => Cr(n, t) : n !== "template" ? () => Cr(e.as, t, { default: r.default }) : () => Cr(qp, t, { default: r.default });
  }
});
function T1() {
  const e = se(), t = re(() => {
    var r, n;
    return ["#text", "#comment"].includes((r = e.value) == null ? void 0 : r.$el.nodeName) ? (n = e.value) == null ? void 0 : n.$el.nextElementSibling : On(e);
  });
  return {
    primitiveElement: e,
    currentElement: t
  };
}
function uE(e, t) {
  var r;
  const n = se({}), o = se("none"), a = se(e), i = e.value ? "mounted" : "unmounted";
  let s;
  const l = ((r = t.value) == null ? void 0 : r.ownerDocument.defaultView) ?? Ks, { state: u, dispatch: c } = oE(i, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  }), d = (f) => {
    var v;
    if (ro) {
      const w = new CustomEvent(f, { bubbles: !1, cancelable: !1 });
      (v = t.value) == null || v.dispatchEvent(w);
    }
  };
  at(
    e,
    async (f, v) => {
      var w;
      const _ = v !== f;
      if (await Qe(), _) {
        const T = o.value, A = rs(t.value);
        f ? (c("MOUNT"), d("enter"), A === "none" && d("after-enter")) : A === "none" || ((w = n.value) == null ? void 0 : w.display) === "none" ? (c("UNMOUNT"), d("leave"), d("after-leave")) : v && T !== A ? (c("ANIMATION_OUT"), d("leave")) : (c("UNMOUNT"), d("after-leave"));
      }
    },
    { immediate: !0 }
  );
  const h = (f) => {
    const v = rs(t.value), w = v.includes(
      f.animationName
    ), _ = u.value === "mounted" ? "enter" : "leave";
    if (f.target === t.value && w && (d(`after-${_}`), c("ANIMATION_END"), !a.value)) {
      const T = t.value.style.animationFillMode;
      t.value.style.animationFillMode = "forwards", s = l == null ? void 0 : l.setTimeout(() => {
        var A;
        ((A = t.value) == null ? void 0 : A.style.animationFillMode) === "forwards" && (t.value.style.animationFillMode = T);
      });
    }
    f.target === t.value && v === "none" && c("ANIMATION_END");
  }, y = (f) => {
    f.target === t.value && (o.value = rs(t.value));
  }, m = at(
    t,
    (f, v) => {
      f ? (n.value = getComputedStyle(f), f.addEventListener("animationstart", y), f.addEventListener("animationcancel", h), f.addEventListener("animationend", h)) : (c("ANIMATION_END"), s !== void 0 && (l == null || l.clearTimeout(s)), v == null || v.removeEventListener("animationstart", y), v == null || v.removeEventListener("animationcancel", h), v == null || v.removeEventListener("animationend", h));
    },
    { immediate: !0 }
  ), p = at(u, () => {
    const f = rs(t.value);
    o.value = u.value === "mounted" ? f : "none";
  });
  return Co(() => {
    m(), p();
  }), {
    isPresent: re(
      () => ["mounted", "unmountSuspended"].includes(u.value)
    )
  };
}
function rs(e) {
  return e && getComputedStyle(e).animationName || "none";
}
const E1 = U({
  name: "Presence",
  props: {
    present: {
      type: Boolean,
      required: !0
    },
    forceMount: {
      type: Boolean
    }
  },
  slots: {},
  setup(e, { slots: t, expose: r }) {
    var n;
    const { present: o, forceMount: a } = Qr(e), i = se(), { isPresent: s } = uE(o, i);
    r({ present: s });
    let l = t.default({ present: s });
    l = Mp(l || []);
    const u = rn();
    if (l && (l == null ? void 0 : l.length) > 1) {
      const c = (n = u == null ? void 0 : u.parent) != null && n.type.name ? `<${u.parent.type.name} />` : "component";
      throw new Error(
        [
          `Detected an invalid children for \`${c}\` for  \`Presence\` component.`,
          "",
          "Note: Presence works similarly to `v-if` directly, but it waits for animation/transition to finished before unmounting. So it expect only one direct child of valid VNode type.",
          "You can apply a few solutions:",
          [
            "Provide a single child element so that `presence` directive attach correctly.",
            "Ensure the first child is an actual element instead of a raw text node or comment node."
          ].map((d) => `  - ${d}`).join(`
`)
        ].join(`
`)
      );
    }
    return () => a.value || o.value || s.value ? Cr(t.default({ present: s })[0], {
      ref: (c) => {
        const d = On(c);
        return typeof (d == null ? void 0 : d.hasAttribute) > "u" || (d != null && d.hasAttribute("data-radix-popper-content-wrapper") ? i.value = d.firstElementChild : i.value = d), d;
      }
    }) : null;
  }
}), cE = /* @__PURE__ */ U({
  __name: "Teleport",
  props: {
    to: { default: "body" },
    disabled: { type: Boolean },
    forceMount: { type: Boolean }
  },
  setup(e) {
    const t = y1();
    return (r, n) => S(t) || r.forceMount ? ($(), ne(Hw, {
      key: 0,
      to: r.to,
      disabled: r.disabled
    }, [
      V(r.$slots, "default")
    ], 8, ["to", "disabled"])) : _e("", !0);
  }
}), dE = "dismissableLayer.pointerDownOutside", fE = "dismissableLayer.focusOutside";
function O1(e, t) {
  const r = t.closest(
    "[data-dismissable-layer]"
  ), n = e.dataset.dismissableLayer === "" ? e : e.querySelector(
    "[data-dismissable-layer]"
  ), o = Array.from(
    e.ownerDocument.querySelectorAll("[data-dismissable-layer]")
  );
  return !!(r && n === r || o.indexOf(n) < o.indexOf(r));
}
function pE(e, t) {
  var r;
  const n = ((r = t == null ? void 0 : t.value) == null ? void 0 : r.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), o = se(!1), a = se(() => {
  });
  return Pr((i) => {
    if (!ro)
      return;
    const s = async (u) => {
      const c = u.target;
      if (t != null && t.value) {
        if (O1(t.value, c)) {
          o.value = !1;
          return;
        }
        if (u.target && !o.value) {
          let d = function() {
            Rp(
              dE,
              e,
              h
            );
          };
          const h = { originalEvent: u };
          u.pointerType === "touch" ? (n.removeEventListener("click", a.value), a.value = d, n.addEventListener("click", a.value, {
            once: !0
          })) : d();
        } else
          n.removeEventListener("click", a.value);
        o.value = !1;
      }
    }, l = window.setTimeout(() => {
      n.addEventListener("pointerdown", s);
    }, 0);
    i(() => {
      window.clearTimeout(l), n.removeEventListener("pointerdown", s), n.removeEventListener("click", a.value);
    });
  }), {
    onPointerDownCapture: () => o.value = !0
  };
}
function hE(e, t) {
  var r;
  const n = ((r = t == null ? void 0 : t.value) == null ? void 0 : r.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), o = se(!1);
  return Pr((a) => {
    if (!ro)
      return;
    const i = async (s) => {
      t != null && t.value && (await Qe(), !(!t.value || O1(t.value, s.target)) && s.target && !o.value && Rp(
        fE,
        e,
        { originalEvent: s }
      ));
    };
    n.addEventListener("focusin", i), a(() => n.removeEventListener("focusin", i));
  }), {
    onFocusCapture: () => o.value = !0,
    onBlurCapture: () => o.value = !1
  };
}
const yn = ws({
  layersRoot: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), $1 = /* @__PURE__ */ U({
  __name: "DismissableLayer",
  props: {
    disableOutsidePointerEvents: { type: Boolean, default: !1 },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "dismiss"],
  setup(e, { emit: t }) {
    const r = e, n = t, { forwardRef: o, currentElement: a } = wt(), i = re(
      () => {
        var m;
        return ((m = a.value) == null ? void 0 : m.ownerDocument) ?? globalThis.document;
      }
    ), s = re(() => yn.layersRoot), l = re(() => a.value ? Array.from(s.value).indexOf(a.value) : -1), u = re(() => yn.layersWithOutsidePointerEventsDisabled.size > 0), c = re(() => {
      const m = Array.from(s.value), [p] = [...yn.layersWithOutsidePointerEventsDisabled].slice(-1), f = m.indexOf(p);
      return l.value >= f;
    }), d = pE(async (m) => {
      const p = [...yn.branches].some(
        (f) => f == null ? void 0 : f.contains(m.target)
      );
      !c.value || p || (n("pointerDownOutside", m), n("interactOutside", m), await Qe(), m.defaultPrevented || n("dismiss"));
    }, a), h = hE((m) => {
      [...yn.branches].some(
        (p) => p == null ? void 0 : p.contains(m.target)
      ) || (n("focusOutside", m), n("interactOutside", m), m.defaultPrevented || n("dismiss"));
    }, a);
    BT("Escape", (m) => {
      l.value === s.value.size - 1 && (n("escapeKeyDown", m), m.defaultPrevented || n("dismiss"));
    });
    let y;
    return Pr((m) => {
      a.value && (r.disableOutsidePointerEvents && (yn.layersWithOutsidePointerEventsDisabled.size === 0 && (y = i.value.body.style.pointerEvents, i.value.body.style.pointerEvents = "none"), yn.layersWithOutsidePointerEventsDisabled.add(a.value)), s.value.add(a.value), m(() => {
        r.disableOutsidePointerEvents && yn.layersWithOutsidePointerEventsDisabled.size === 1 && (i.value.body.style.pointerEvents = y);
      }));
    }), Pr((m) => {
      m(() => {
        a.value && (s.value.delete(a.value), yn.layersWithOutsidePointerEventsDisabled.delete(a.value));
      });
    }), (m, p) => ($(), ne(S(Gt), {
      ref: S(o),
      "as-child": m.asChild,
      as: m.as,
      "data-dismissable-layer": "",
      style: $t({
        pointerEvents: u.value ? c.value ? "auto" : "none" : void 0
      }),
      onFocusCapture: S(h).onFocusCapture,
      onBlurCapture: S(h).onBlurCapture,
      onPointerdownCapture: S(d).onPointerDownCapture
    }, {
      default: Y(() => [
        V(m.$slots, "default")
      ]),
      _: 3
    }, 8, ["as-child", "as", "style", "onFocusCapture", "onBlurCapture", "onPointerdownCapture"]));
  }
}), fu = "focusScope.autoFocusOnMount", pu = "focusScope.autoFocusOnUnmount", Km = { bubbles: !1, cancelable: !0 };
function mE(e, { select: t = !1 } = {}) {
  const r = kr();
  for (const n of e)
    if (Hn(n, { select: t }), kr() !== r)
      return !0;
}
function vE(e) {
  const t = C1(e), r = Ym(t, e), n = Ym(t.reverse(), e);
  return [r, n];
}
function C1(e) {
  const t = [], r = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (n) => {
      const o = n.tagName === "INPUT" && n.type === "hidden";
      return n.disabled || n.hidden || o ? NodeFilter.FILTER_SKIP : n.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; r.nextNode(); ) t.push(r.currentNode);
  return t;
}
function Ym(e, t) {
  for (const r of e)
    if (!gE(r, { upTo: t }))
      return r;
}
function gE(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden")
    return !0;
  for (; e; ) {
    if (t !== void 0 && e === t)
      return !1;
    if (getComputedStyle(e).display === "none")
      return !0;
    e = e.parentElement;
  }
  return !1;
}
function yE(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Hn(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const r = kr();
    e.focus({ preventScroll: !0 }), e !== r && yE(e) && t && e.select();
  }
}
const bE = TT(() => se([]));
function wE() {
  const e = bE();
  return {
    add(t) {
      const r = e.value[0];
      t !== r && (r == null || r.pause()), e.value = Jm(e.value, t), e.value.unshift(t);
    },
    remove(t) {
      var r;
      e.value = Jm(e.value, t), (r = e.value[0]) == null || r.resume();
    }
  };
}
function Jm(e, t) {
  const r = [...e], n = r.indexOf(t);
  return n !== -1 && r.splice(n, 1), r;
}
function _E(e) {
  return e.filter((t) => t.tagName !== "A");
}
const SE = /* @__PURE__ */ U({
  __name: "FocusScope",
  props: {
    loop: { type: Boolean, default: !1 },
    trapped: { type: Boolean, default: !1 },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["mountAutoFocus", "unmountAutoFocus"],
  setup(e, { emit: t }) {
    const r = e, n = t, { currentRef: o, currentElement: a } = wt(), i = se(null), s = wE(), l = ws({
      paused: !1,
      pause() {
        this.paused = !0;
      },
      resume() {
        this.paused = !1;
      }
    });
    Pr((c) => {
      if (!ro)
        return;
      const d = a.value;
      if (!r.trapped)
        return;
      function h(f) {
        if (l.paused || !d)
          return;
        const v = f.target;
        d.contains(v) ? i.value = v : Hn(i.value, { select: !0 });
      }
      function y(f) {
        if (l.paused || !d)
          return;
        const v = f.relatedTarget;
        v !== null && (d.contains(v) || Hn(i.value, { select: !0 }));
      }
      function m(f) {
        d.contains(i.value) || Hn(d);
      }
      document.addEventListener("focusin", h), document.addEventListener("focusout", y);
      const p = new MutationObserver(m);
      d && p.observe(d, { childList: !0, subtree: !0 }), c(() => {
        document.removeEventListener("focusin", h), document.removeEventListener("focusout", y), p.disconnect();
      });
    }), Pr(async (c) => {
      const d = a.value;
      if (await Qe(), !d)
        return;
      s.add(l);
      const h = kr();
      if (!d.contains(h)) {
        const y = new CustomEvent(fu, Km);
        d.addEventListener(fu, (m) => n("mountAutoFocus", m)), d.dispatchEvent(y), y.defaultPrevented || (mE(_E(C1(d)), {
          select: !0
        }), kr() === h && Hn(d));
      }
      c(() => {
        d.removeEventListener(fu, (p) => n("mountAutoFocus", p));
        const y = new CustomEvent(pu, Km), m = (p) => {
          n("unmountAutoFocus", p);
        };
        d.addEventListener(pu, m), d.dispatchEvent(y), setTimeout(() => {
          y.defaultPrevented || Hn(h ?? document.body, { select: !0 }), d.removeEventListener(pu, m), s.remove(l);
        }, 0);
      });
    });
    function u(c) {
      if (!r.loop && !r.trapped || l.paused)
        return;
      const d = c.key === "Tab" && !c.altKey && !c.ctrlKey && !c.metaKey, h = kr();
      if (d && h) {
        const y = c.currentTarget, [m, p] = vE(y);
        m && p ? !c.shiftKey && h === p ? (c.preventDefault(), r.loop && Hn(m, { select: !0 })) : c.shiftKey && h === m && (c.preventDefault(), r.loop && Hn(p, { select: !0 })) : h === y && c.preventDefault();
      }
    }
    return (c, d) => ($(), ne(S(Gt), {
      ref_key: "currentRef",
      ref: o,
      tabindex: "-1",
      "as-child": c.asChild,
      as: c.as,
      onKeydown: u
    }, {
      default: Y(() => [
        V(c.$slots, "default")
      ]),
      _: 3
    }, 8, ["as-child", "as"]));
  }
}), xE = "menu.itemSelect", Vf = ["Enter", " "], AE = ["ArrowDown", "PageUp", "Home"], k1 = ["ArrowUp", "PageDown", "End"], TE = [...AE, ...k1];
[...Vf], [...Vf];
function EE(e) {
  return e ? "open" : "closed";
}
function OE(e) {
  const t = kr();
  for (const r of e)
    if (r === t || (r.focus(), kr() !== t))
      return;
}
function $E(e, t) {
  const { x: r, y: n } = e;
  let o = !1;
  for (let a = 0, i = t.length - 1; a < t.length; i = a++) {
    const s = t[a].x, l = t[a].y, u = t[i].x, c = t[i].y;
    l > n != c > n && r < (u - s) * (n - l) / (c - l) + s && (o = !o);
  }
  return o;
}
function CE(e, t) {
  if (!t)
    return !1;
  const r = { x: e.clientX, y: e.clientY };
  return $E(r, t);
}
function Hf(e) {
  return e.pointerType === "mouse";
}
const [P1, kE] = _r("PopperRoot"), I1 = /* @__PURE__ */ U({
  inheritAttrs: !1,
  __name: "PopperRoot",
  setup(e) {
    const t = se();
    return kE({
      anchor: t,
      onAnchorChange: (r) => t.value = r
    }), (r, n) => V(r.$slots, "default");
  }
}), PE = /* @__PURE__ */ U({
  __name: "PopperAnchor",
  props: {
    element: {},
    asChild: { type: Boolean },
    as: {}
  },
  setup(e) {
    const t = e, { forwardRef: r, currentElement: n } = wt(), o = P1();
    return Pr(() => {
      o.onAnchorChange(t.element ?? n.value);
    }), (a, i) => ($(), ne(S(Gt), {
      ref: S(r),
      as: a.as,
      "as-child": a.asChild
    }, {
      default: Y(() => [
        V(a.$slots, "default")
      ]),
      _: 3
    }, 8, ["as", "as-child"]));
  }
});
function IE(e) {
  return e !== null;
}
function DE(e) {
  return {
    name: "transformOrigin",
    options: e,
    fn(t) {
      var r, n, o;
      const { placement: a, rects: i, middlewareData: s } = t, l = ((r = s.arrow) == null ? void 0 : r.centerOffset) !== 0, u = l ? 0 : e.arrowWidth, c = l ? 0 : e.arrowHeight, [d, h] = Gf(a), y = { start: "0%", center: "50%", end: "100%" }[h], m = (((n = s.arrow) == null ? void 0 : n.x) ?? 0) + u / 2, p = (((o = s.arrow) == null ? void 0 : o.y) ?? 0) + c / 2;
      let f = "", v = "";
      return d === "bottom" ? (f = l ? y : `${m}px`, v = `${-c}px`) : d === "top" ? (f = l ? y : `${m}px`, v = `${i.floating.height + c}px`) : d === "right" ? (f = `${-c}px`, v = l ? y : `${p}px`) : d === "left" && (f = `${i.floating.width + c}px`, v = l ? y : `${p}px`), { data: { x: f, y: v } };
    }
  };
}
function Gf(e) {
  const [t, r = "center"] = e.split("-");
  return [t, r];
}
const D1 = {
  side: "bottom",
  sideOffset: 0,
  align: "center",
  alignOffset: 0,
  arrowPadding: 0,
  avoidCollisions: !0,
  collisionBoundary: () => [],
  collisionPadding: 0,
  sticky: "partial",
  hideWhenDetached: !1,
  updatePositionStrategy: "optimized",
  prioritizePosition: !1
}, [F6, RE] = _r("PopperContent"), Kf = /* @__PURE__ */ U({
  inheritAttrs: !1,
  __name: "PopperContent",
  props: /* @__PURE__ */ P0({
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  }, {
    ...D1
  }),
  emits: ["placed"],
  setup(e, { emit: t }) {
    const r = e, n = t, o = P1(), { forwardRef: a, currentElement: i } = wt(), s = se(), l = se(), { width: u, height: c } = nE(l), d = re(
      () => r.side + (r.align !== "center" ? `-${r.align}` : "")
    ), h = re(() => typeof r.collisionPadding == "number" ? r.collisionPadding : { top: 0, right: 0, bottom: 0, left: 0, ...r.collisionPadding }), y = re(() => Array.isArray(r.collisionBoundary) ? r.collisionBoundary : [r.collisionBoundary]), m = re(() => ({
      padding: h.value,
      boundary: y.value.filter(IE),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: y.value.length > 0
    })), p = AT(() => [
      Rb({
        mainAxis: r.sideOffset + c.value,
        alignmentAxis: r.alignOffset
      }),
      r.prioritizePosition && r.avoidCollisions && Df({
        ...m.value
      }),
      r.avoidCollisions && Mb({
        mainAxis: !0,
        crossAxis: !!r.prioritizePosition,
        limiter: r.sticky === "partial" ? fx() : void 0,
        ...m.value
      }),
      !r.prioritizePosition && r.avoidCollisions && Df({
        ...m.value
      }),
      ux({
        ...m.value,
        apply: ({ elements: E, rects: R, availableWidth: k, availableHeight: L }) => {
          const { width: z, height: F } = R.reference, q = E.floating.style;
          q.setProperty(
            "--radix-popper-available-width",
            `${k}px`
          ), q.setProperty(
            "--radix-popper-available-height",
            `${L}px`
          ), q.setProperty(
            "--radix-popper-anchor-width",
            `${z}px`
          ), q.setProperty(
            "--radix-popper-anchor-height",
            `${F}px`
          );
        }
      }),
      l.value && qb({ element: l.value, padding: r.arrowPadding }),
      DE({
        arrowWidth: u.value,
        arrowHeight: c.value
      }),
      r.hideWhenDetached && cx({ strategy: "referenceHidden", ...m.value })
    ]), { floatingStyles: f, placement: v, isPositioned: w, middlewareData: _ } = hx(
      o.anchor,
      s,
      {
        strategy: "fixed",
        placement: d,
        whileElementsMounted: (...E) => Db(...E, {
          animationFrame: r.updatePositionStrategy === "always"
        }),
        middleware: p
      }
    ), T = re(
      () => Gf(v.value)[0]
    ), A = re(
      () => Gf(v.value)[1]
    );
    Vw(() => {
      w.value && n("placed");
    });
    const O = re(
      () => {
        var E;
        return ((E = _.value.arrow) == null ? void 0 : E.centerOffset) !== 0;
      }
    ), M = se("");
    Pr(() => {
      i.value && (M.value = window.getComputedStyle(i.value).zIndex);
    });
    const I = re(() => {
      var E;
      return ((E = _.value.arrow) == null ? void 0 : E.x) ?? 0;
    }), C = re(() => {
      var E;
      return ((E = _.value.arrow) == null ? void 0 : E.y) ?? 0;
    });
    return RE({
      placedSide: T,
      onArrowChange: (E) => l.value = E,
      arrowX: I,
      arrowY: C,
      shouldHideArrow: O
    }), (E, R) => {
      var k, L, z;
      return $(), B("div", {
        ref_key: "floatingRef",
        ref: s,
        "data-radix-popper-content-wrapper": "",
        style: $t({
          ...S(f),
          transform: S(w) ? S(f).transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: M.value,
          "--radix-popper-transform-origin": [
            (k = S(_).transformOrigin) == null ? void 0 : k.x,
            (L = S(_).transformOrigin) == null ? void 0 : L.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((z = S(_).hide) == null ? void 0 : z.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        })
      }, [
        ie(S(Gt), We({ ref: S(a) }, E.$attrs, {
          "as-child": r.asChild,
          as: E.as,
          "data-side": T.value,
          "data-align": A.value,
          style: {
            // if the PopperContent hasn't been placed yet (not all measurements done)
            // we prevent animations so that users's animation don't kick in too early referring wrong sides
            animation: S(w) ? void 0 : "none"
          }
        }), {
          default: Y(() => [
            V(E.$slots, "default")
          ]),
          _: 3
        }, 16, ["as-child", "as", "data-side", "data-align", "style"])
      ], 4);
    };
  }
}), ME = /* @__PURE__ */ U({
  __name: "VisuallyHidden",
  props: {
    asChild: { type: Boolean },
    as: { default: "span" }
  },
  setup(e) {
    return wt(), (t, r) => ($(), ne(S(Gt), {
      as: t.as,
      "as-child": t.asChild,
      style: {
        // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
        position: "absolute",
        border: 0,
        width: "1px",
        display: "inline-block",
        height: "1px",
        padding: 0,
        margin: "-1px",
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        wordWrap: "normal"
      }
    }, {
      default: Y(() => [
        V(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["as", "as-child"]));
  }
}), BE = /* @__PURE__ */ U({
  __name: "VisuallyHiddenInput",
  props: {
    name: {},
    value: {},
    required: { type: Boolean },
    disabled: { type: Boolean }
  },
  setup(e) {
    const t = e, r = re(() => typeof t.value == "string" || typeof t.value == "number" || typeof t.value == "boolean" ? [{ name: t.name, value: t.value }] : typeof t.value == "object" && Array.isArray(t.value) ? t.value.flatMap((n, o) => typeof n == "object" ? Object.entries(n).map(([a, i]) => ({ name: `[${o}][${t.name}][${a}]`, value: i })) : { name: `[${t.name}][${o}]`, value: n }) : t.value !== null && typeof t.value == "object" && !Array.isArray(t.value) ? Object.entries(t.value).map(([n, o]) => ({ name: `[${t.name}][${n}]`, value: o })) : []);
    return (n, o) => ($(!0), B(qt, null, sr(r.value, (a) => ($(), ne(ME, {
      key: a.name,
      as: "input",
      type: "hidden",
      hidden: "",
      readonly: "",
      name: a.name,
      value: a.value,
      required: n.required,
      disabled: n.disabled
    }, null, 8, ["name", "value", "required", "disabled"]))), 128));
  }
}), qE = "data-radix-vue-collection-item", [Lp, LE] = _r("CollectionProvider");
function R1(e = qE) {
  const t = se(/* @__PURE__ */ new Map()), r = se(), n = LE({
    collectionRef: r,
    itemMap: t,
    attrName: e
  }), { getItems: o } = FE(n), a = re(() => Array.from(n.itemMap.value.values())), i = re(() => n.itemMap.value.size);
  return { getItems: o, reactiveItems: a, itemMapSize: i };
}
const M1 = U({
  name: "CollectionSlot",
  setup(e, { slots: t }) {
    const r = Lp(), { primitiveElement: n, currentElement: o } = T1();
    return at(o, () => {
      r.collectionRef.value = o.value;
    }), () => Cr(qp, { ref: n }, t);
  }
}), B1 = U({
  name: "CollectionItem",
  inheritAttrs: !1,
  props: {
    value: {
      // It accepts any value
      validator: () => !0
    }
  },
  setup(e, { slots: t, attrs: r }) {
    const n = Lp(), { primitiveElement: o, currentElement: a } = T1();
    return Pr((i) => {
      if (a.value) {
        const s = Tf(a.value);
        n.itemMap.value.set(s, { ref: a.value, value: e.value }), i(() => n.itemMap.value.delete(s));
      }
    }), () => Cr(qp, { ...r, [n.attrName]: "", ref: o }, t);
  }
});
function FE(e) {
  const t = e ?? Lp();
  return { getItems: () => {
    const r = t.collectionRef.value;
    if (!r)
      return [];
    const n = Array.from(r.querySelectorAll(`[${t.attrName}]`));
    return Array.from(t.itemMap.value.values()).sort(
      (o, a) => n.indexOf(o.ref) - n.indexOf(a.ref)
    );
  } };
}
const [pa, NE] = _r("ComboboxRoot"), zE = /* @__PURE__ */ U({
  __name: "ComboboxRoot",
  props: {
    modelValue: {},
    defaultValue: {},
    open: { type: Boolean, default: void 0 },
    defaultOpen: { type: Boolean },
    searchTerm: {},
    selectedValue: {},
    multiple: { type: Boolean },
    disabled: { type: Boolean },
    name: {},
    dir: {},
    filterFunction: {},
    displayValue: {},
    resetSearchTermOnBlur: { type: Boolean, default: !0 },
    resetSearchTermOnSelect: { type: Boolean, default: !0 },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["update:modelValue", "update:open", "update:searchTerm", "update:selectedValue"],
  setup(e, { emit: t }) {
    const r = e, n = t, { multiple: o, disabled: a, dir: i } = Qr(r), s = Ys(i), l = xo(r, "searchTerm", n, {
      // @ts-expect-error ignore the type error here
      defaultValue: "",
      passive: r.searchTerm === void 0
    }), u = xo(r, "modelValue", n, {
      // @ts-expect-error ignore the type error here
      defaultValue: r.defaultValue ?? o.value ? [] : void 0,
      passive: r.modelValue === void 0,
      deep: !0
    }), c = xo(r, "open", n, {
      defaultValue: r.defaultOpen,
      passive: r.open === void 0
    }), d = xo(r, "selectedValue", n, {
      defaultValue: void 0,
      passive: r.selectedValue === void 0
    });
    async function h(H) {
      var W, ee;
      c.value = H, await Qe(), H ? (u.value && (Array.isArray(u.value) && o.value ? d.value = (W = _().find((oe) => {
        var J, N;
        return ((N = (J = oe.ref) == null ? void 0 : J.dataset) == null ? void 0 : N.state) === "checked";
      })) == null ? void 0 : W.value : d.value = u.value), await Qe(), (ee = p.value) == null || ee.focus(), L()) : (m.value = !1, r.resetSearchTermOnBlur && I("blur"));
    }
    function y(H) {
      if (Array.isArray(u.value) && o.value) {
        const W = u.value.findIndex((oe) => So(oe, H)), ee = [...u.value];
        W === -1 ? ee.push(H) : ee.splice(W, 1), u.value = ee;
      } else
        u.value = H, h(!1);
    }
    const m = se(!1), p = se(), f = se(), { forwardRef: v, currentElement: w } = wt(), { getItems: _, reactiveItems: T, itemMapSize: A } = R1("data-radix-vue-combobox-item"), O = se([]);
    at(() => A.value, () => {
      O.value = _().map((H) => H.value);
    }, {
      immediate: !0,
      flush: "post"
    });
    const M = re(() => {
      if (m.value) {
        if (r.filterFunction)
          return r.filterFunction(O.value, l.value);
        const H = O.value.filter((W) => typeof W == "string");
        if (H.length)
          return H.filter((W) => {
            var ee;
            return W.toLowerCase().includes((ee = l.value) == null ? void 0 : ee.toLowerCase());
          });
      }
      return O.value;
    });
    function I(H) {
      const W = H === "blur" || H === "select" && r.resetSearchTermOnSelect;
      !o.value && u.value && !Array.isArray(u.value) ? r.displayValue ? l.value = r.displayValue(u.value) : typeof u.value != "object" ? l.value = u.value.toString() : W && (l.value = "") : W && (l.value = "");
    }
    const C = re(() => M.value.findIndex((H) => So(H, d.value))), E = re(() => {
      var H;
      return (H = T.value.find((W) => So(W.value, d.value))) == null ? void 0 : H.ref;
    }), R = re(() => JSON.stringify(u.value));
    at(R, async () => {
      await Qe(), await Qe(), I("select");
    }, {
      // If searchTerm is provided with value during initialization, we don't reset it immediately
      immediate: !r.searchTerm
    }), at(() => [M.value.length, l.value.length], async ([H, W], [ee, oe]) => {
      await Qe(), await Qe(), H && (oe > W || C.value === -1) && (d.value = M.value[0]);
    });
    const k = ZT(w);
    function L() {
      var H;
      E.value instanceof Element && ((H = E.value) == null || H.scrollIntoView({ block: "nearest" }));
    }
    function z() {
      E.value instanceof Element && E.value.focus && E.value.focus();
    }
    const F = se(!1);
    function q() {
      F.value = !0;
    }
    function j() {
      requestAnimationFrame(() => {
        F.value = !1;
      });
    }
    async function D(H) {
      var W;
      M.value.length && d.value && E.value instanceof Element && (H.preventDefault(), H.stopPropagation(), F.value || (W = E.value) == null || W.click());
    }
    return NE({
      searchTerm: l,
      modelValue: u,
      // @ts-expect-error ignoring
      onValueChange: y,
      isUserInputted: m,
      multiple: o,
      disabled: a,
      open: c,
      onOpenChange: h,
      filteredOptions: M,
      contentId: "",
      inputElement: p,
      selectedElement: E,
      onInputElementChange: (H) => p.value = H,
      onInputNavigation: async (H) => {
        const W = C.value;
        W === 0 && H === "up" || W === M.value.length - 1 && H === "down" || (W === -1 && M.value.length || H === "home" ? d.value = M.value[0] : H === "end" ? d.value = M.value[M.value.length - 1] : d.value = M.value[H === "up" ? W - 1 : W + 1], await Qe(), L(), z(), Qe(() => {
          var ee;
          return (ee = p.value) == null ? void 0 : ee.focus({ preventScroll: !0 });
        }));
      },
      onInputEnter: D,
      onCompositionEnd: j,
      onCompositionStart: q,
      selectedValue: d,
      onSelectedValueChange: (H) => d.value = H,
      parentElement: w,
      contentElement: f,
      onContentElementChange: (H) => f.value = H
    }), (H, W) => ($(), ne(S(I1), null, {
      default: Y(() => [
        ie(S(Gt), We({
          ref: S(v),
          style: {
            pointerEvents: S(c) ? "auto" : void 0
          },
          as: H.as,
          "as-child": H.asChild,
          dir: S(s)
        }, H.$attrs), {
          default: Y(() => [
            V(H.$slots, "default", {
              open: S(c),
              modelValue: S(u)
            }),
            S(k) && r.name ? ($(), ne(S(BE), {
              key: 0,
              name: r.name,
              value: S(u)
            }, null, 8, ["name", "value"])) : _e("", !0)
          ]),
          _: 3
        }, 16, ["style", "as", "as-child", "dir"])
      ]),
      _: 3
    }));
  }
}), jE = /* @__PURE__ */ U({
  __name: "ComboboxInput",
  props: {
    type: { default: "text" },
    disabled: { type: Boolean },
    autoFocus: { type: Boolean },
    asChild: { type: Boolean },
    as: { default: "input" }
  },
  setup(e) {
    const t = e, r = pa(), { forwardRef: n, currentElement: o } = wt();
    Lt(() => {
      const c = o.value.nodeName === "INPUT" ? o.value : o.value.querySelector("input");
      c && (r.onInputElementChange(c), setTimeout(() => {
        t.autoFocus && (c == null || c.focus());
      }, 1));
    });
    const a = re(() => t.disabled || r.disabled.value || !1), i = se();
    zw(() => {
      var c;
      return i.value = (c = r.selectedElement.value) == null ? void 0 : c.id;
    });
    function s(c) {
      r.open.value ? r.onInputNavigation(c.key === "ArrowUp" ? "up" : "down") : r.onOpenChange(!0);
    }
    function l(c) {
      r.open.value && r.onInputNavigation(c.key === "Home" ? "home" : "end");
    }
    function u(c) {
      var d;
      r.searchTerm.value = (d = c.target) == null ? void 0 : d.value, r.open.value || r.onOpenChange(!0), r.isUserInputted.value = !0;
    }
    return (c, d) => ($(), ne(S(Gt), {
      ref: S(n),
      as: c.as,
      "as-child": c.asChild,
      type: c.type,
      disabled: a.value,
      value: S(r).searchTerm.value,
      "aria-expanded": S(r).open.value,
      "aria-controls": S(r).contentId,
      "aria-disabled": a.value ?? void 0,
      "aria-activedescendant": i.value,
      "aria-autocomplete": "list",
      role: "combobox",
      autocomplete: "false",
      onInput: u,
      onKeydown: [
        cs(Ss(s, ["prevent"]), ["down", "up"]),
        cs(S(r).onInputEnter, ["enter"]),
        cs(Ss(l, ["prevent"]), ["home", "end"])
      ],
      onCompositionstart: S(r).onCompositionStart,
      onCompositionend: S(r).onCompositionEnd
    }, {
      default: Y(() => [
        V(c.$slots, "default")
      ]),
      _: 3
    }, 8, ["as", "as-child", "type", "disabled", "value", "aria-expanded", "aria-controls", "aria-disabled", "aria-activedescendant", "onKeydown", "onCompositionstart", "onCompositionend"]));
  }
}), [q1, UE] = _r("ComboboxGroup"), WE = /* @__PURE__ */ U({
  __name: "ComboboxGroup",
  props: {
    asChild: { type: Boolean },
    as: {}
  },
  setup(e) {
    const t = e, { currentRef: r, currentElement: n } = wt(), o = ai(void 0, "radix-vue-combobox-group"), a = pa(), i = se(!1);
    function s() {
      if (!n.value)
        return;
      const l = n.value.querySelectorAll("[data-radix-vue-combobox-item]:not([data-hidden])");
      i.value = !!l.length;
    }
    return LT(n, () => {
      Qe(() => {
        s();
      });
    }, { childList: !0 }), at(() => a.searchTerm.value, () => {
      Qe(() => {
        s();
      });
    }, { immediate: !0 }), UE({
      id: o
    }), (l, u) => Dr(($(), ne(S(Gt), We(t, {
      ref_key: "currentRef",
      ref: r,
      role: "group",
      "aria-labelledby": S(o)
    }), {
      default: Y(() => [
        V(l.$slots, "default")
      ]),
      _: 3
    }, 16, ["aria-labelledby"])), [
      [li, i.value]
    ]);
  }
}), VE = /* @__PURE__ */ U({
  __name: "ComboboxLabel",
  props: {
    for: {},
    asChild: { type: Boolean },
    as: { default: "div" }
  },
  setup(e) {
    const t = e;
    wt();
    const r = q1({ id: "" });
    return (n, o) => ($(), ne(S(Gt), We(t, {
      id: S(r).id
    }), {
      default: Y(() => [
        V(n.$slots, "default")
      ]),
      _: 3
    }, 16, ["id"]));
  }
}), [N6, HE] = _r("ComboboxContent"), GE = /* @__PURE__ */ U({
  __name: "ComboboxContentImpl",
  props: {
    position: { default: "inline" },
    bodyLock: { type: Boolean },
    dismissable: { type: Boolean, default: !0 },
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: {},
    disableOutsidePointerEvents: { type: Boolean }
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside"],
  setup(e, { emit: t }) {
    const r = e, n = t, { position: o } = Qr(r), a = pa();
    w1(r.bodyLock);
    const { forwardRef: i, currentElement: s } = wt();
    A1(a.parentElement);
    const l = re(() => r.position === "popper" ? r : {}), u = Js(l.value);
    function c(h) {
      a.onSelectedValueChange("");
    }
    Lt(() => {
      a.onContentElementChange(s.value);
    });
    const d = {
      // Ensure border-box for floating-ui calculations
      boxSizing: "border-box",
      "--radix-combobox-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-combobox-content-available-width": "var(--radix-popper-available-width)",
      "--radix-combobox-content-available-height": "var(--radix-popper-available-height)",
      "--radix-combobox-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-combobox-trigger-height": "var(--radix-popper-anchor-height)"
    };
    return HE({ position: o }), (h, y) => ($(), ne(S(M1), null, {
      default: Y(() => [
        h.dismissable ? ($(), ne(S($1), {
          key: 0,
          "as-child": "",
          "disable-outside-pointer-events": h.disableOutsidePointerEvents,
          onDismiss: y[0] || (y[0] = (m) => S(a).onOpenChange(!1)),
          onFocusOutside: y[1] || (y[1] = (m) => {
            var p;
            (p = S(a).parentElement.value) != null && p.contains(m.target) && m.preventDefault(), n("focusOutside", m);
          }),
          onInteractOutside: y[2] || (y[2] = (m) => n("interactOutside", m)),
          onEscapeKeyDown: y[3] || (y[3] = (m) => n("escapeKeyDown", m)),
          onPointerDownOutside: y[4] || (y[4] = (m) => {
            var p;
            (p = S(a).parentElement.value) != null && p.contains(m.target) && m.preventDefault(), n("pointerDownOutside", m);
          })
        }, {
          default: Y(() => [
            ($(), ne(er(S(o) === "popper" ? S(Kf) : S(Gt)), We({ ...h.$attrs, ...S(u) }, {
              id: S(a).contentId,
              ref: S(i),
              role: "listbox",
              "data-state": S(a).open.value ? "open" : "closed",
              style: {
                // flex layout so we can place the scroll buttons properly
                display: "flex",
                flexDirection: "column",
                // reset the outline by default as the content MAY get focused
                outline: "none",
                ...S(o) === "popper" ? d : {}
              },
              onPointerleave: c
            }), {
              default: Y(() => [
                V(h.$slots, "default")
              ]),
              _: 3
            }, 16, ["id", "data-state", "style"]))
          ]),
          _: 3
        }, 8, ["disable-outside-pointer-events"])) : ($(), ne(er(S(o) === "popper" ? S(Kf) : S(Gt)), We({ key: 1 }, { ...h.$attrs, ...l.value }, {
          id: S(a).contentId,
          ref: S(i),
          role: "listbox",
          "data-state": S(a).open.value ? "open" : "closed",
          style: {
            // flex layout so we can place the scroll buttons properly
            display: "flex",
            flexDirection: "column",
            // reset the outline by default as the content MAY get focused
            outline: "none",
            ...S(o) === "popper" ? d : {}
          },
          onPointerleave: c
        }), {
          default: Y(() => [
            V(h.$slots, "default")
          ]),
          _: 3
        }, 16, ["id", "data-state", "style"]))
      ]),
      _: 3
    }));
  }
}), KE = /* @__PURE__ */ U({
  __name: "ComboboxContent",
  props: {
    forceMount: { type: Boolean },
    position: {},
    bodyLock: { type: Boolean },
    dismissable: { type: Boolean },
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: {},
    disableOutsidePointerEvents: { type: Boolean }
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside"],
  setup(e, { emit: t }) {
    const r = Io(e, t), { forwardRef: n } = wt(), o = pa();
    return o.contentId || (o.contentId = ai(void 0, "radix-vue-combobox-content")), (a, i) => ($(), ne(S(E1), {
      present: a.forceMount || S(o).open.value
    }, {
      default: Y(() => [
        ie(GE, We({ ...S(r), ...a.$attrs }, { ref: S(n) }), {
          default: Y(() => [
            V(a.$slots, "default")
          ]),
          _: 3
        }, 16)
      ]),
      _: 3
    }, 8, ["present"]));
  }
}), [z6, YE] = _r("ComboboxItem"), JE = "combobox.select", ZE = /* @__PURE__ */ U({
  __name: "ComboboxItem",
  props: {
    value: {},
    disabled: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["select"],
  setup(e, { emit: t }) {
    const r = e, n = t, { disabled: o } = Qr(r), a = pa();
    q1({ id: "", options: se([]) });
    const { forwardRef: i } = wt(), s = re(
      () => {
        var p, f;
        return a.multiple.value && Array.isArray(a.modelValue.value) ? (p = a.modelValue.value) == null ? void 0 : p.some((v) => So(v, r.value)) : So((f = a.modelValue) == null ? void 0 : f.value, r.value);
      }
    ), l = re(() => So(a.selectedValue.value, r.value)), u = ai(void 0, "radix-vue-combobox-item"), c = ai(void 0, "radix-vue-combobox-option"), d = re(() => a.isUserInputted.value ? a.searchTerm.value === "" || !!a.filteredOptions.value.find((p) => So(p, r.value)) : !0);
    async function h(p) {
      n("select", p), !(p != null && p.defaultPrevented) && !o.value && p && a.onValueChange(r.value);
    }
    function y(p) {
      if (!p)
        return;
      const f = { originalEvent: p, value: r.value };
      Rp(JE, h, f);
    }
    async function m(p) {
      await Qe(), !p.defaultPrevented && a.onSelectedValueChange(r.value);
    }
    if (r.value === "")
      throw new Error(
        "A <ComboboxItem /> must have a value prop that is not an empty string. This is because the Combobox value can be set to an empty string to clear the selection and show the placeholder."
      );
    return YE({
      isSelected: s
    }), (p, f) => ($(), ne(S(B1), { value: p.value }, {
      default: Y(() => [
        Dr(ie(S(Gt), {
          id: S(c),
          ref: S(i),
          role: "option",
          tabindex: "-1",
          "aria-labelledby": S(u),
          "data-highlighted": l.value ? "" : void 0,
          "aria-selected": s.value,
          "data-state": s.value ? "checked" : "unchecked",
          "aria-disabled": S(o) || void 0,
          "data-disabled": S(o) ? "" : void 0,
          as: p.as,
          "as-child": p.asChild,
          "data-hidden": d.value ? void 0 : !0,
          onClick: y,
          onPointermove: m
        }, {
          default: Y(() => [
            V(p.$slots, "default", {}, () => [
              et(Ie(p.value), 1)
            ])
          ]),
          _: 3
        }, 8, ["id", "aria-labelledby", "data-highlighted", "aria-selected", "data-state", "aria-disabled", "data-disabled", "as", "as-child", "data-hidden"]), [
          [li, d.value]
        ])
      ]),
      _: 3
    }, 8, ["value"]));
  }
}), XE = /* @__PURE__ */ U({
  __name: "MenuAnchor",
  props: {
    element: {},
    asChild: { type: Boolean },
    as: {}
  },
  setup(e) {
    const t = e;
    return (r, n) => ($(), ne(S(PE), zr(ko(t)), {
      default: Y(() => [
        V(r.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
});
function QE() {
  const e = se(!1);
  return Lt(() => {
    $s("keydown", () => {
      e.value = !0;
    }, { capture: !0, passive: !0 }), $s(["pointerdown", "pointermove"], () => {
      e.value = !1;
    }, { capture: !0, passive: !0 });
  }), e;
}
const eO = g1(QE), [Zs, tO] = _r(["MenuRoot", "MenuSub"], "MenuContext"), [Fp, rO] = _r("MenuRoot"), nO = /* @__PURE__ */ U({
  __name: "MenuRoot",
  props: {
    open: { type: Boolean, default: !1 },
    dir: {},
    modal: { type: Boolean, default: !0 }
  },
  emits: ["update:open"],
  setup(e, { emit: t }) {
    const r = e, n = t, { modal: o, dir: a } = Qr(r), i = Ys(a), s = xo(r, "open", n), l = se(), u = eO();
    return tO({
      open: s,
      onOpenChange: (c) => {
        s.value = c;
      },
      content: l,
      onContentChange: (c) => {
        l.value = c;
      }
    }), rO({
      onClose: () => {
        s.value = !1;
      },
      isUsingKeyboardRef: u,
      dir: i,
      modal: o
    }), (c, d) => ($(), ne(S(I1), null, {
      default: Y(() => [
        V(c.$slots, "default")
      ]),
      _: 3
    }));
  }
}), oO = "rovingFocusGroup.onEntryFocus", iO = { bubbles: !1, cancelable: !0 };
function aO(e, t = !1) {
  const r = kr();
  for (const n of e)
    if (n === r || (n.focus({ preventScroll: t }), kr() !== r))
      return;
}
const [j6, sO] = _r("RovingFocusGroup"), lO = /* @__PURE__ */ U({
  __name: "RovingFocusGroup",
  props: {
    orientation: { default: void 0 },
    dir: {},
    loop: { type: Boolean, default: !1 },
    currentTabStopId: {},
    defaultCurrentTabStopId: {},
    preventScrollOnEntryFocus: { type: Boolean, default: !1 },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["entryFocus", "update:currentTabStopId"],
  setup(e, { expose: t, emit: r }) {
    const n = e, o = r, { loop: a, orientation: i, dir: s } = Qr(n), l = Ys(s), u = xo(n, "currentTabStopId", o, {
      defaultValue: n.defaultCurrentTabStopId,
      passive: n.currentTabStopId === void 0
    }), c = se(!1), d = se(!1), h = se(0), { getItems: y } = R1();
    function m(f) {
      const v = !d.value;
      if (f.currentTarget && f.target === f.currentTarget && v && !c.value) {
        const w = new CustomEvent(oO, iO);
        if (f.currentTarget.dispatchEvent(w), o("entryFocus", w), !w.defaultPrevented) {
          const _ = y().map((M) => M.ref).filter((M) => M.dataset.disabled !== ""), T = _.find((M) => M.getAttribute("data-active") === "true"), A = _.find(
            (M) => M.id === u.value
          ), O = [T, A, ..._].filter(
            Boolean
          );
          aO(O, n.preventScrollOnEntryFocus);
        }
      }
      d.value = !1;
    }
    function p() {
      setTimeout(() => {
        d.value = !1;
      }, 1);
    }
    return t({
      getItems: y
    }), sO({
      loop: a,
      dir: l,
      orientation: i,
      currentTabStopId: u,
      onItemFocus: (f) => {
        u.value = f;
      },
      onItemShiftTab: () => {
        c.value = !0;
      },
      onFocusableItemAdd: () => {
        h.value++;
      },
      onFocusableItemRemove: () => {
        h.value--;
      }
    }), (f, v) => ($(), ne(S(M1), null, {
      default: Y(() => [
        ie(S(Gt), {
          tabindex: c.value || h.value === 0 ? -1 : 0,
          "data-orientation": S(i),
          as: f.as,
          "as-child": f.asChild,
          dir: S(l),
          style: { outline: "none" },
          onMousedown: v[0] || (v[0] = (w) => d.value = !0),
          onMouseup: p,
          onFocus: m,
          onBlur: v[1] || (v[1] = (w) => c.value = !1)
        }, {
          default: Y(() => [
            V(f.$slots, "default")
          ]),
          _: 3
        }, 8, ["tabindex", "data-orientation", "as", "as-child", "dir"])
      ]),
      _: 3
    }));
  }
}), [L1, uO] = _r("MenuContent"), F1 = /* @__PURE__ */ U({
  __name: "MenuContentImpl",
  props: /* @__PURE__ */ P0({
    loop: { type: Boolean },
    disableOutsidePointerEvents: { type: Boolean },
    disableOutsideScroll: { type: Boolean },
    trapFocus: { type: Boolean },
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  }, {
    ...D1
  }),
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "entryFocus", "openAutoFocus", "closeAutoFocus", "dismiss"],
  setup(e, { emit: t }) {
    const r = e, n = t, o = Zs(), a = Fp(), { trapFocus: i, disableOutsidePointerEvents: s, loop: l } = Qr(r);
    JT(), w1(s.value);
    const u = se(""), c = se(0), d = se(0), h = se(null), y = se("right"), m = se(0), p = se(null), { createCollection: f } = YT(), { forwardRef: v, currentElement: w } = wt(), _ = f(w);
    at(w, (E) => {
      o.onContentChange(E);
    });
    const { handleTypeaheadSearch: T } = aE(_);
    Co(() => {
      window.clearTimeout(c.value);
    });
    function A(E) {
      var R, k;
      return y.value === ((R = h.value) == null ? void 0 : R.side) && CE(E, (k = h.value) == null ? void 0 : k.area);
    }
    async function O(E) {
      var R;
      n("openAutoFocus", E), !E.defaultPrevented && (E.preventDefault(), (R = w.value) == null || R.focus({
        preventScroll: !0
      }));
    }
    function M(E) {
      if (E.defaultPrevented)
        return;
      const R = E.target.closest("[data-radix-menu-content]") === E.currentTarget, k = E.ctrlKey || E.altKey || E.metaKey, L = E.key.length === 1, z = zT(
        E,
        kr(),
        w.value,
        {
          loop: l.value,
          arrowKeyOptions: "vertical",
          dir: a == null ? void 0 : a.dir.value,
          focus: !0,
          attributeName: "[data-radix-vue-collection-item]:not([data-disabled])"
        }
      );
      if (z)
        return z == null ? void 0 : z.focus();
      if (E.code === "Space" || (R && (E.key === "Tab" && E.preventDefault(), !k && L && T(E.key)), E.target !== w.value) || !TE.includes(E.key))
        return;
      E.preventDefault();
      const F = _.value;
      k1.includes(E.key) && F.reverse(), OE(F);
    }
    function I(E) {
      var R, k;
      (k = (R = E == null ? void 0 : E.currentTarget) == null ? void 0 : R.contains) != null && k.call(R, E.target) || (window.clearTimeout(c.value), u.value = "");
    }
    function C(E) {
      var R;
      if (!Hf(E))
        return;
      const k = E.target, L = m.value !== E.clientX;
      if ((R = E == null ? void 0 : E.currentTarget) != null && R.contains(k) && L) {
        const z = E.clientX > m.value ? "right" : "left";
        y.value = z, m.value = E.clientX;
      }
    }
    return uO({
      onItemEnter: (E) => !!A(E),
      onItemLeave: (E) => {
        var R;
        A(E) || ((R = w.value) == null || R.focus(), p.value = null);
      },
      onTriggerLeave: (E) => !!A(E),
      searchRef: u,
      pointerGraceTimerRef: d,
      onPointerGraceIntentChange: (E) => {
        h.value = E;
      }
    }), (E, R) => ($(), ne(S(SE), {
      "as-child": "",
      trapped: S(i),
      onMountAutoFocus: O,
      onUnmountAutoFocus: R[7] || (R[7] = (k) => n("closeAutoFocus", k))
    }, {
      default: Y(() => [
        ie(S($1), {
          "as-child": "",
          "disable-outside-pointer-events": S(s),
          onEscapeKeyDown: R[2] || (R[2] = (k) => n("escapeKeyDown", k)),
          onPointerDownOutside: R[3] || (R[3] = (k) => n("pointerDownOutside", k)),
          onFocusOutside: R[4] || (R[4] = (k) => n("focusOutside", k)),
          onInteractOutside: R[5] || (R[5] = (k) => n("interactOutside", k)),
          onDismiss: R[6] || (R[6] = (k) => n("dismiss"))
        }, {
          default: Y(() => [
            ie(S(lO), {
              "current-tab-stop-id": p.value,
              "onUpdate:currentTabStopId": R[0] || (R[0] = (k) => p.value = k),
              "as-child": "",
              orientation: "vertical",
              dir: S(a).dir.value,
              loop: S(l),
              onEntryFocus: R[1] || (R[1] = (k) => {
                n("entryFocus", k), S(a).isUsingKeyboardRef.value || k.preventDefault();
              })
            }, {
              default: Y(() => [
                ie(S(Kf), {
                  ref: S(v),
                  role: "menu",
                  as: E.as,
                  "as-child": E.asChild,
                  "aria-orientation": "vertical",
                  "data-radix-menu-content": "",
                  "data-state": S(EE)(S(o).open.value),
                  dir: S(a).dir.value,
                  side: E.side,
                  "side-offset": E.sideOffset,
                  align: E.align,
                  "align-offset": E.alignOffset,
                  "avoid-collisions": E.avoidCollisions,
                  "collision-boundary": E.collisionBoundary,
                  "collision-padding": E.collisionPadding,
                  "arrow-padding": E.arrowPadding,
                  "prioritize-position": E.prioritizePosition,
                  sticky: E.sticky,
                  "hide-when-detached": E.hideWhenDetached,
                  onKeydown: M,
                  onBlur: I,
                  onPointermove: C
                }, {
                  default: Y(() => [
                    V(E.$slots, "default")
                  ]),
                  _: 3
                }, 8, ["as", "as-child", "data-state", "dir", "side", "side-offset", "align", "align-offset", "avoid-collisions", "collision-boundary", "collision-padding", "arrow-padding", "prioritize-position", "sticky", "hide-when-detached"])
              ]),
              _: 3
            }, 8, ["current-tab-stop-id", "dir", "loop"])
          ]),
          _: 3
        }, 8, ["disable-outside-pointer-events"])
      ]),
      _: 3
    }, 8, ["trapped"]));
  }
}), cO = /* @__PURE__ */ U({
  inheritAttrs: !1,
  __name: "MenuItemImpl",
  props: {
    disabled: { type: Boolean },
    textValue: {},
    asChild: { type: Boolean },
    as: {}
  },
  setup(e) {
    const t = e, r = L1(), { forwardRef: n } = wt(), o = se(!1);
    async function a(s) {
      if (!s.defaultPrevented && Hf(s)) {
        if (t.disabled)
          r.onItemLeave(s);
        else if (!r.onItemEnter(s)) {
          const l = s.currentTarget;
          l == null || l.focus({ preventScroll: !0 });
        }
      }
    }
    async function i(s) {
      await Qe(), !s.defaultPrevented && Hf(s) && r.onItemLeave(s);
    }
    return (s, l) => ($(), ne(S(B1), {
      value: { textValue: s.textValue }
    }, {
      default: Y(() => [
        ie(S(Gt), We({
          ref: S(n),
          role: "menuitem",
          tabindex: "-1"
        }, s.$attrs, {
          as: s.as,
          "as-child": s.asChild,
          "data-radix-vue-collection-item": "",
          "aria-disabled": s.disabled || void 0,
          "data-disabled": s.disabled ? "" : void 0,
          "data-highlighted": o.value ? "" : void 0,
          onPointermove: a,
          onPointerleave: i,
          onFocus: l[0] || (l[0] = async (u) => {
            await Qe(), !(u.defaultPrevented || s.disabled) && (o.value = !0);
          }),
          onBlur: l[1] || (l[1] = async (u) => {
            await Qe(), !u.defaultPrevented && (o.value = !1);
          })
        }), {
          default: Y(() => [
            V(s.$slots, "default")
          ]),
          _: 3
        }, 16, ["as", "as-child", "aria-disabled", "data-disabled", "data-highlighted"])
      ]),
      _: 3
    }, 8, ["value"]));
  }
}), dO = /* @__PURE__ */ U({
  __name: "MenuItem",
  props: {
    disabled: { type: Boolean },
    textValue: {},
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["select"],
  setup(e, { emit: t }) {
    const r = e, n = t, { forwardRef: o, currentElement: a } = wt(), i = Fp(), s = L1(), l = se(!1);
    async function u() {
      const c = a.value;
      if (!r.disabled && c) {
        const d = new CustomEvent(xE, {
          bubbles: !0,
          cancelable: !0
        });
        n("select", d), await Qe(), d.defaultPrevented ? l.value = !1 : i.onClose();
      }
    }
    return (c, d) => ($(), ne(cO, We(r, {
      ref: S(o),
      onClick: u,
      onPointerdown: d[0] || (d[0] = () => {
        l.value = !0;
      }),
      onPointerup: d[1] || (d[1] = async (h) => {
        var y;
        await Qe(), !h.defaultPrevented && (l.value || (y = h.currentTarget) == null || y.click());
      }),
      onKeydown: d[2] || (d[2] = async (h) => {
        const y = S(s).searchRef.value !== "";
        c.disabled || y && h.key === " " || S(Vf).includes(h.key) && (h.currentTarget.click(), h.preventDefault());
      })
    }), {
      default: Y(() => [
        V(c.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), fO = /* @__PURE__ */ U({
  __name: "MenuRootContentModal",
  props: {
    loop: { type: Boolean },
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "entryFocus", "openAutoFocus", "closeAutoFocus"],
  setup(e, { emit: t }) {
    const r = e, n = t, o = Io(r, n), a = Zs(), { forwardRef: i, currentElement: s } = wt();
    return A1(s), (l, u) => ($(), ne(F1, We(S(o), {
      ref: S(i),
      "trap-focus": S(a).open.value,
      "disable-outside-pointer-events": S(a).open.value,
      "disable-outside-scroll": !0,
      onDismiss: u[0] || (u[0] = (c) => S(a).onOpenChange(!1)),
      onFocusOutside: u[1] || (u[1] = Ss((c) => n("focusOutside", c), ["prevent"]))
    }), {
      default: Y(() => [
        V(l.$slots, "default")
      ]),
      _: 3
    }, 16, ["trap-focus", "disable-outside-pointer-events"]));
  }
}), pO = /* @__PURE__ */ U({
  __name: "MenuRootContentNonModal",
  props: {
    loop: { type: Boolean },
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "entryFocus", "openAutoFocus", "closeAutoFocus"],
  setup(e, { emit: t }) {
    const r = Io(e, t), n = Zs();
    return (o, a) => ($(), ne(F1, We(S(r), {
      "trap-focus": !1,
      "disable-outside-pointer-events": !1,
      "disable-outside-scroll": !1,
      onDismiss: a[0] || (a[0] = (i) => S(n).onOpenChange(!1))
    }), {
      default: Y(() => [
        V(o.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), hO = /* @__PURE__ */ U({
  __name: "MenuContent",
  props: {
    forceMount: { type: Boolean },
    loop: { type: Boolean },
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "entryFocus", "openAutoFocus", "closeAutoFocus"],
  setup(e, { emit: t }) {
    const r = Io(e, t), n = Zs(), o = Fp();
    return (a, i) => ($(), ne(S(E1), {
      present: a.forceMount || S(n).open.value
    }, {
      default: Y(() => [
        S(o).modal.value ? ($(), ne(fO, zr(We({ key: 0 }, { ...a.$attrs, ...S(r) })), {
          default: Y(() => [
            V(a.$slots, "default")
          ]),
          _: 3
        }, 16)) : ($(), ne(pO, zr(We({ key: 1 }, { ...a.$attrs, ...S(r) })), {
          default: Y(() => [
            V(a.$slots, "default")
          ]),
          _: 3
        }, 16))
      ]),
      _: 3
    }, 8, ["present"]));
  }
}), mO = /* @__PURE__ */ U({
  __name: "MenuPortal",
  props: {
    to: {},
    disabled: { type: Boolean },
    forceMount: { type: Boolean }
  },
  setup(e) {
    const t = e;
    return (r, n) => ($(), ne(S(cE), zr(ko(t)), {
      default: Y(() => [
        V(r.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), vO = /* @__PURE__ */ U({
  __name: "MenuSeparator",
  props: {
    asChild: { type: Boolean },
    as: {}
  },
  setup(e) {
    const t = e;
    return (r, n) => ($(), ne(S(Gt), We(t, {
      role: "separator",
      "aria-orientation": "horizontal"
    }), {
      default: Y(() => [
        V(r.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), [N1, gO] = _r("DropdownMenuRoot"), yO = /* @__PURE__ */ U({
  __name: "DropdownMenuRoot",
  props: {
    defaultOpen: { type: Boolean },
    open: { type: Boolean, default: void 0 },
    dir: {},
    modal: { type: Boolean, default: !0 }
  },
  emits: ["update:open"],
  setup(e, { emit: t }) {
    const r = e, n = t;
    wt();
    const o = xo(r, "open", n, {
      defaultValue: r.defaultOpen,
      passive: r.open === void 0
    }), a = se(), { modal: i, dir: s } = Qr(r), l = Ys(s);
    return gO({
      open: o,
      onOpenChange: (u) => {
        o.value = u;
      },
      onOpenToggle: () => {
        o.value = !o.value;
      },
      triggerId: "",
      triggerElement: a,
      contentId: "",
      modal: i,
      dir: l
    }), (u, c) => ($(), ne(S(nO), {
      open: S(o),
      "onUpdate:open": c[0] || (c[0] = (d) => us(o) ? o.value = d : null),
      dir: S(l),
      modal: S(i)
    }, {
      default: Y(() => [
        V(u.$slots, "default", { open: S(o) })
      ]),
      _: 3
    }, 8, ["open", "dir", "modal"]));
  }
}), bO = /* @__PURE__ */ U({
  __name: "DropdownMenuTrigger",
  props: {
    disabled: { type: Boolean },
    asChild: { type: Boolean },
    as: { default: "button" }
  },
  setup(e) {
    const t = e, r = N1(), { forwardRef: n, currentElement: o } = wt();
    return Lt(() => {
      r.triggerElement = o;
    }), r.triggerId || (r.triggerId = ai(void 0, "radix-vue-dropdown-menu-trigger")), (a, i) => ($(), ne(S(XE), { "as-child": "" }, {
      default: Y(() => [
        ie(S(Gt), {
          id: S(r).triggerId,
          ref: S(n),
          type: a.as === "button" ? "button" : void 0,
          "as-child": t.asChild,
          as: a.as,
          "aria-haspopup": "menu",
          "aria-expanded": S(r).open.value,
          "aria-controls": S(r).open.value ? S(r).contentId : void 0,
          "data-disabled": a.disabled ? "" : void 0,
          disabled: a.disabled,
          "data-state": S(r).open.value ? "open" : "closed",
          onClick: i[0] || (i[0] = async (s) => {
            var l;
            !a.disabled && s.button === 0 && s.ctrlKey === !1 && ((l = S(r)) == null || l.onOpenToggle(), await Qe(), S(r).open.value && s.preventDefault());
          }),
          onKeydown: i[1] || (i[1] = cs(
            (s) => {
              a.disabled || (["Enter", " "].includes(s.key) && S(r).onOpenToggle(), s.key === "ArrowDown" && S(r).onOpenChange(!0), ["Enter", " ", "ArrowDown"].includes(s.key) && s.preventDefault());
            },
            ["enter", "space", "arrow-down"]
          ))
        }, {
          default: Y(() => [
            V(a.$slots, "default")
          ]),
          _: 3
        }, 8, ["id", "type", "as-child", "as", "aria-expanded", "aria-controls", "data-disabled", "disabled", "data-state"])
      ]),
      _: 3
    }));
  }
}), wO = /* @__PURE__ */ U({
  __name: "DropdownMenuPortal",
  props: {
    to: {},
    disabled: { type: Boolean },
    forceMount: { type: Boolean }
  },
  setup(e) {
    const t = e;
    return (r, n) => ($(), ne(S(mO), zr(ko(t)), {
      default: Y(() => [
        V(r.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), _O = /* @__PURE__ */ U({
  __name: "DropdownMenuContent",
  props: {
    forceMount: { type: Boolean },
    loop: { type: Boolean },
    side: {},
    sideOffset: {},
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "closeAutoFocus"],
  setup(e, { emit: t }) {
    const r = Io(e, t);
    wt();
    const n = N1(), o = se(!1);
    function a(i) {
      i.defaultPrevented || (o.value || setTimeout(() => {
        var s;
        (s = n.triggerElement.value) == null || s.focus();
      }, 0), o.value = !1, i.preventDefault());
    }
    return n.contentId || (n.contentId = ai(void 0, "radix-vue-dropdown-menu-content")), (i, s) => {
      var l;
      return $(), ne(S(hO), We(S(r), {
        id: S(n).contentId,
        "aria-labelledby": (l = S(n)) == null ? void 0 : l.triggerId,
        style: {
          "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
          "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
          "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        },
        onCloseAutoFocus: a,
        onInteractOutside: s[0] || (s[0] = (u) => {
          var c;
          if (u.defaultPrevented) return;
          const d = u.detail.originalEvent, h = d.button === 0 && d.ctrlKey === !0, y = d.button === 2 || h;
          (!S(n).modal.value || y) && (o.value = !0), (c = S(n).triggerElement.value) != null && c.contains(u.target) && u.preventDefault();
        })
      }), {
        default: Y(() => [
          V(i.$slots, "default")
        ]),
        _: 3
      }, 16, ["id", "aria-labelledby"]);
    };
  }
}), SO = /* @__PURE__ */ U({
  __name: "DropdownMenuItem",
  props: {
    disabled: { type: Boolean },
    textValue: {},
    asChild: { type: Boolean },
    as: {}
  },
  emits: ["select"],
  setup(e, { emit: t }) {
    const r = e, n = S1(t);
    return wt(), (o, a) => ($(), ne(S(dO), zr(ko({ ...r, ...S(n) })), {
      default: Y(() => [
        V(o.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), xO = /* @__PURE__ */ U({
  __name: "DropdownMenuSeparator",
  props: {
    asChild: { type: Boolean },
    as: {}
  },
  setup(e) {
    const t = e;
    return wt(), (r, n) => ($(), ne(S(vO), zr(ko(t)), {
      default: Y(() => [
        V(r.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
});
function AO() {
  if (typeof matchMedia == "function")
    return matchMedia("(pointer:coarse)").matches ? "coarse" : "fine";
}
AO();
const TO = { class: "flex w-full flex-col" }, U6 = /* @__PURE__ */ U({
  __name: "Autocomplete",
  props: /* @__PURE__ */ br({
    label: {},
    labelHidden: { type: Boolean, default: !1 },
    placeholder: { default: null }
  }, {
    modelValue: { default: "" },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = Je("autoComplete"), r = wr(e, "modelValue");
    return (n, o) => ($(), B("div", TO, [
      ie(S(zE), {
        "search-term": "",
        class: "relative",
        "reset-search-term-on-blur": !1
      }, {
        default: Y(() => [
          ie(S(Qp), {
            id: S(t),
            modelValue: r.value,
            "onUpdate:modelValue": o[0] || (o[0] = (a) => r.value = a),
            as: S(jE),
            label: n.label,
            "label-hidden": n.labelHidden,
            placeholder: n.placeholder,
            "auto-complete": "off",
            name: "search",
            type: "search"
          }, null, 8, ["id", "modelValue", "as", "label", "label-hidden", "placeholder"]),
          ie(S(KE), { class: "absolute z-50 mt-2 overflow-hidden rounded-md border bg-white shadow-lg data-[state=closed]:animate-hide data-[state=open]:animate-slideDownAndFade dark:border-zinc-700 dark:bg-zinc-900" }, {
            default: Y(() => [
              V(n.$slots, "default")
            ]),
            _: 3
          })
        ]),
        _: 3
      })
    ]));
  }
}), W6 = /* @__PURE__ */ U({
  __name: "AutocompleteGroup",
  props: {
    label: {}
  },
  setup(e) {
    return (t, r) => ($(), ne(S(WE), null, {
      default: Y(() => [
        ie(S(VE), { class: "border-b bg-slate-50 px-3 py-2 text-xs font-medium leading-none text-slate-500 shadow-sm" }, {
          default: Y(() => [
            et(Ie(t.label), 1)
          ]),
          _: 1
        }),
        V(t.$slots, "default")
      ]),
      _: 3
    }));
  }
}), V6 = /* @__PURE__ */ U({
  __name: "AutocompleteItem",
  props: {
    asChild: { type: Boolean },
    as: {}
  },
  setup(e) {
    const t = Je("ComboboxItem");
    return (r, n) => ($(), ne(S(ZE), We({
      value: S(t),
      class: "block cursor-pointer px-3 py-2 hover:bg-slate-100 data-[highlighted]:bg-slate-50 data-[state=checked]:bg-slate-100"
    }, r.$props), {
      default: Y(() => [
        X("span", null, [
          V(r.$slots, "default")
        ])
      ]),
      _: 3
    }, 16, ["value"]));
  }
}), EO = {
  key: 1,
  class: "absolute h-full w-full"
}, OO = ["aria-label"], H6 = /* @__PURE__ */ U({
  __name: "Avatar",
  props: {
    size: { default: "md" },
    name: { default: void 0 },
    initials: { default: null },
    source: { default: void 0 },
    accessibilityLabel: { default: null }
  },
  setup(e) {
    const t = e, r = se(
      "PENDING"
      /* Pending */
    ), n = re(() => [
      { "size-4": t.size === "xs" },
      { "size-6": t.size === "sm" },
      { "size-8": t.size === "md" },
      { "size-10": t.size === "lg" },
      { "size-12": t.size === "xl" },
      {
        "bg-slate-200 dark:bg-zinc-700": r.value !== "LOADED"
        /* Loaded */
      }
    ]), o = re(() => [
      { "w-3 h-3": t.size === "xs" }
    ]), a = re(() => [
      { "text-xs": t.size === "xs" },
      { "text-xs": t.size === "sm" },
      { "text-md": t.size === "md" },
      { "text-lg": t.size === "lg" },
      { "text-lg": t.size === "xl" }
    ]);
    function i(c) {
      return t.size === "xs" ? c == null ? void 0 : c.slice(0, 1) : c;
    }
    function s() {
      r.value = "ERRORED";
    }
    function l() {
      r.value = "LOADED";
    }
    const u = re(() => {
      const c = t.accessibilityLabel || t.name;
      return c || void 0;
    });
    return (c, d) => ($(), B("span", {
      class: Te([n.value, "relative flex items-center justify-center overflow-hidden rounded"])
    }, [
      c.initials ? _e("", !0) : ($(), ne(S(E2), {
        key: 0,
        class: Te(o.value),
        role: "img"
      }, null, 8, ["class"])),
      c.source ? ($(), B("span", EO, [
        ie(S(fa), null, {
          default: Y(() => [
            ie(S(hi), {
              alt: c.name,
              class: Te({
                hidden: r.value !== "LOADED"
                /* Loaded */
              }),
              source: c.source,
              onError: s,
              onLoad: l
            }, null, 8, ["alt", "class", "source"])
          ]),
          _: 1
        })
      ])) : _e("", !0),
      c.initials && r.value !== "LOADED" ? ($(), B("span", {
        key: 2,
        "aria-label": u.value,
        class: Te([a.value, "font-semibold"])
      }, Ie(i(c.initials)), 11, OO)) : _e("", !0)
    ], 2));
  }
}), $O = { class: "flex items-center space-x-2" }, G6 = /* @__PURE__ */ U({
  __name: "Badge",
  props: {
    accessibilityLabel: { default: null },
    color: {},
    size: { default: "sm" }
  },
  setup(e) {
    const t = e, r = re(() => js().value ? {
      backgroundColor: bt(t.color, "500"),
      color: "white"
    } : {
      backgroundColor: bt(t.color, "100"),
      color: bt(t.color, "900")
    }), n = re(() => [
      { "text-xs px-2 py-1": t.size === "sm" },
      { "text-sm px-3 py-1.5": t.size === "md" },
      { "text-md px-4 py-2": t.size === "lg" }
    ]);
    return (o, a) => ($(), B("span", {
      class: Te(["inline-flex rounded bg-slate-200", n.value]),
      style: $t(r.value)
    }, [
      ie(S(Ve), { strong: "" }, {
        default: Y(() => [
          X("div", $O, [
            V(o.$slots, "default")
          ])
        ]),
        _: 3
      }),
      o.accessibilityLabel ? ($(), ne(S(pi), { key: 0 }, {
        default: Y(() => [
          et(Ie(o.accessibilityLabel), 1)
        ]),
        _: 1
      })) : _e("", !0)
    ], 6));
  }
}), K6 = /* @__PURE__ */ U({
  __name: "BadgeContent",
  setup(e) {
    return (t, r) => ($(), ne(S(Ve), { strong: "" }, {
      default: Y(() => [
        V(t.$slots, "default")
      ]),
      _: 3
    }));
  }
}), CO = {}, kO = { class: "size-4" };
function PO(e, t) {
  return $(), B("div", kO, [
    V(e.$slots, "default")
  ]);
}
const Y6 = /* @__PURE__ */ De(CO, [["render", PO]]);
var hu = { exports: {} }, mu, Zm;
function IO() {
  return Zm || (Zm = 1, mu = function() {
    var t = this, r = -1;
    return {
      next: function() {
        return r += 1, {
          value: t.items[r],
          done: r >= t.items.length
        };
      }
    };
  }), mu;
}
var vu, Xm;
function DO() {
  return Xm || (Xm = 1, vu = function() {
    return this.items;
  }), vu;
}
var gu, Qm;
function ft() {
  if (Qm) return gu;
  Qm = 1;
  function e(t) {
    "@babel/helpers - typeof";
    return e = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
      return typeof r;
    } : function(r) {
      return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
    }, e(t);
  }
  return gu = {
    /**
     * @returns {boolean}
     */
    isArray: function(r) {
      return Array.isArray(r);
    },
    /**
     * @returns {boolean}
     */
    isObject: function(r) {
      return e(r) === "object" && Array.isArray(r) === !1 && r !== null;
    },
    /**
     * @returns {boolean}
     */
    isFunction: function(r) {
      return typeof r == "function";
    }
  }, gu;
}
var yu, ev;
function z1() {
  if (ev) return yu;
  ev = 1;
  var e = ft(), t = e.isFunction;
  return yu = function(n) {
    return n === void 0 ? this.sum() / this.items.length : t(n) ? new this.constructor(this.items).sum(n) / this.items.length : new this.constructor(this.items).pluck(n).sum() / this.items.length;
  }, yu;
}
var bu, tv;
function RO() {
  if (tv) return bu;
  tv = 1;
  var e = z1();
  return bu = e, bu;
}
var wu, rv;
function MO() {
  if (rv) return wu;
  rv = 1;
  function e(t) {
    "@babel/helpers - typeof";
    return e = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
      return typeof r;
    } : function(r) {
      return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
    }, e(t);
  }
  return wu = function(r) {
    var n = this, o = [], a = 0;
    if (Array.isArray(this.items))
      do {
        var i = this.items.slice(a, a + r), s = new this.constructor(i);
        o.push(s), a += r;
      } while (a < this.items.length);
    else if (e(this.items) === "object") {
      var l = Object.keys(this.items), u = function() {
        var d = l.slice(a, a + r), h = new n.constructor({});
        d.forEach(function(y) {
          return h.put(y, n.items[y]);
        }), o.push(h), a += r;
      };
      do
        u();
      while (a < l.length);
    } else
      o.push(new this.constructor([this.items]));
    return new this.constructor(o);
  }, wu;
}
var _u, nv;
function BO() {
  if (nv) return _u;
  nv = 1;
  function e(i) {
    return o(i) || n(i) || r(i) || t();
  }
  function t() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function r(i, s) {
    if (i) {
      if (typeof i == "string") return a(i, s);
      var l = Object.prototype.toString.call(i).slice(8, -1);
      if (l === "Object" && i.constructor && (l = i.constructor.name), l === "Map" || l === "Set") return Array.from(i);
      if (l === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(l)) return a(i, s);
    }
  }
  function n(i) {
    if (typeof Symbol < "u" && i[Symbol.iterator] != null || i["@@iterator"] != null) return Array.from(i);
  }
  function o(i) {
    if (Array.isArray(i)) return a(i);
  }
  function a(i, s) {
    (s == null || s > i.length) && (s = i.length);
    for (var l = 0, u = new Array(s); l < s; l++)
      u[l] = i[l];
    return u;
  }
  return _u = function() {
    var s;
    return new this.constructor((s = []).concat.apply(s, e(this.items)));
  }, _u;
}
var Su, ov;
function qO() {
  if (ov) return Su;
  ov = 1;
  function e(s, l) {
    return a(s) || o(s, l) || r(s, l) || t();
  }
  function t() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function r(s, l) {
    if (s) {
      if (typeof s == "string") return n(s, l);
      var u = Object.prototype.toString.call(s).slice(8, -1);
      if (u === "Object" && s.constructor && (u = s.constructor.name), u === "Map" || u === "Set") return Array.from(s);
      if (u === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(u)) return n(s, l);
    }
  }
  function n(s, l) {
    (l == null || l > s.length) && (l = s.length);
    for (var u = 0, c = new Array(l); u < l; u++)
      c[u] = s[u];
    return c;
  }
  function o(s, l) {
    var u = s == null ? null : typeof Symbol < "u" && s[Symbol.iterator] || s["@@iterator"];
    if (u != null) {
      var c = [], d = !0, h = !1, y, m;
      try {
        for (u = u.call(s); !(d = (y = u.next()).done) && (c.push(y.value), !(l && c.length === l)); d = !0)
          ;
      } catch (p) {
        h = !0, m = p;
      } finally {
        try {
          !d && u.return != null && u.return();
        } finally {
          if (h) throw m;
        }
      }
      return c;
    }
  }
  function a(s) {
    if (Array.isArray(s)) return s;
  }
  function i(s) {
    "@babel/helpers - typeof";
    return i = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(l) {
      return typeof l;
    } : function(l) {
      return l && typeof Symbol == "function" && l.constructor === Symbol && l !== Symbol.prototype ? "symbol" : typeof l;
    }, i(s);
  }
  return Su = function(l) {
    var u = this, c = l;
    c instanceof this.constructor && (c = l.all());
    var d = {};
    if (Array.isArray(this.items) && Array.isArray(c))
      this.items.forEach(function(m, p) {
        d[m] = c[p];
      });
    else if (i(this.items) === "object" && i(c) === "object")
      Object.keys(this.items).forEach(function(m, p) {
        d[u.items[m]] = c[Object.keys(c)[p]];
      });
    else if (Array.isArray(this.items))
      d[this.items[0]] = c;
    else if (typeof this.items == "string" && Array.isArray(c)) {
      var h = c, y = e(h, 1);
      d[this.items] = y[0];
    } else typeof this.items == "string" && (d[this.items] = c);
    return new this.constructor(d);
  }, Su;
}
var xu, iv;
function j1() {
  if (iv) return xu;
  iv = 1;
  function e(i) {
    return o(i) || n(i) || r(i) || t();
  }
  function t() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function r(i, s) {
    if (i) {
      if (typeof i == "string") return a(i, s);
      var l = Object.prototype.toString.call(i).slice(8, -1);
      if (l === "Object" && i.constructor && (l = i.constructor.name), l === "Map" || l === "Set") return Array.from(i);
      if (l === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(l)) return a(i, s);
    }
  }
  function n(i) {
    if (typeof Symbol < "u" && i[Symbol.iterator] != null || i["@@iterator"] != null) return Array.from(i);
  }
  function o(i) {
    if (Array.isArray(i)) return a(i);
  }
  function a(i, s) {
    (s == null || s > i.length) && (s = i.length);
    for (var l = 0, u = new Array(s); l < s; l++)
      u[l] = i[l];
    return u;
  }
  return xu = function(s) {
    var l;
    if (Array.isArray(s)) {
      var u;
      l = [], (u = l).push.apply(u, e(s));
    } else
      l = {}, Object.keys(s).forEach(function(c) {
        l[c] = s[c];
      });
    return l;
  }, xu;
}
var Au, av;
function LO() {
  if (av) return Au;
  av = 1;
  function e(r) {
    "@babel/helpers - typeof";
    return e = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
      return typeof n;
    } : function(n) {
      return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
    }, e(r);
  }
  var t = j1();
  return Au = function(n) {
    var o = n;
    n instanceof this.constructor ? o = n.all() : e(n) === "object" && (o = [], Object.keys(n).forEach(function(i) {
      o.push(n[i]);
    }));
    var a = t(this.items);
    return o.forEach(function(i) {
      e(i) === "object" ? Object.keys(i).forEach(function(s) {
        return a.push(i[s]);
      }) : a.push(i);
    }), new this.constructor(a);
  }, Au;
}
var Tu, sv;
function on() {
  if (sv) return Tu;
  sv = 1;
  function e(i) {
    return o(i) || n(i) || r(i) || t();
  }
  function t() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function r(i, s) {
    if (i) {
      if (typeof i == "string") return a(i, s);
      var l = Object.prototype.toString.call(i).slice(8, -1);
      if (l === "Object" && i.constructor && (l = i.constructor.name), l === "Map" || l === "Set") return Array.from(i);
      if (l === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(l)) return a(i, s);
    }
  }
  function n(i) {
    if (typeof Symbol < "u" && i[Symbol.iterator] != null || i["@@iterator"] != null) return Array.from(i);
  }
  function o(i) {
    if (Array.isArray(i)) return a(i);
  }
  function a(i, s) {
    (s == null || s > i.length) && (s = i.length);
    for (var l = 0, u = new Array(s); l < s; l++)
      u[l] = i[l];
    return u;
  }
  return Tu = function(s) {
    var l = [];
    return Array.isArray(s) ? l.push.apply(l, e(s)) : s.constructor.name === "Collection" ? l.push.apply(l, e(s.all())) : Object.keys(s).forEach(function(u) {
      return l.push(s[u]);
    }), l;
  }, Tu;
}
var Eu, lv;
function U1() {
  if (lv) return Eu;
  lv = 1;
  function e(u) {
    return o(u) || n(u) || r(u) || t();
  }
  function t() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function r(u, c) {
    if (u) {
      if (typeof u == "string") return a(u, c);
      var d = Object.prototype.toString.call(u).slice(8, -1);
      if (d === "Object" && u.constructor && (d = u.constructor.name), d === "Map" || d === "Set") return Array.from(u);
      if (d === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(d)) return a(u, c);
    }
  }
  function n(u) {
    if (typeof Symbol < "u" && u[Symbol.iterator] != null || u["@@iterator"] != null) return Array.from(u);
  }
  function o(u) {
    if (Array.isArray(u)) return a(u);
  }
  function a(u, c) {
    (c == null || c > u.length) && (c = u.length);
    for (var d = 0, h = new Array(c); d < c; d++)
      h[d] = u[d];
    return h;
  }
  var i = on(), s = ft(), l = s.isFunction;
  return Eu = function(c, d) {
    if (d !== void 0)
      return Array.isArray(this.items) ? this.items.filter(function(y) {
        return y[c] !== void 0 && y[c] === d;
      }).length > 0 : this.items[c] !== void 0 && this.items[c] === d;
    if (l(c))
      return this.items.filter(function(y, m) {
        return c(y, m);
      }).length > 0;
    if (Array.isArray(this.items))
      return this.items.indexOf(c) !== -1;
    var h = i(this.items);
    return h.push.apply(h, e(Object.keys(this.items))), h.indexOf(c) !== -1;
  }, Eu;
}
var Ou, uv;
function FO() {
  return uv || (uv = 1, Ou = function() {
    return this.count() === 1;
  }), Ou;
}
var $u, cv;
function NO() {
  return cv || (cv = 1, $u = function() {
    var t = 0;
    return Array.isArray(this.items) && (t = this.items.length), Math.max(Object.keys(this.items).length, t);
  }), $u;
}
var Cu, dv;
function zO() {
  return dv || (dv = 1, Cu = function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function(r) {
      return r;
    };
    return new this.constructor(this.items).groupBy(t).map(function(r) {
      return r.count();
    });
  }), Cu;
}
var ku, fv;
function jO() {
  return fv || (fv = 1, ku = function() {
    function t(a, i, s) {
      var l = s[0];
      l instanceof i && (l = l.all());
      for (var u = s.slice(1), c = !u.length, d = [], h = 0; h < l.length; h += 1) {
        var y = a.slice();
        y.push(l[h]), c ? d.push(y) : d = d.concat(t(y, i, u));
      }
      return d;
    }
    for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++)
      n[o] = arguments[o];
    return new this.constructor(t([], this.constructor, [].concat([this.items], n)));
  }), ku;
}
var Pu, pv;
function UO() {
  return pv || (pv = 1, Pu = function() {
    this.dump(), typeof process < "u" && process.exit(1);
  }), Pu;
}
var Iu, hv;
function WO() {
  return hv || (hv = 1, Iu = function(t) {
    var r;
    t instanceof this.constructor ? r = t.all() : r = t;
    var n = this.items.filter(function(o) {
      return r.indexOf(o) === -1;
    });
    return new this.constructor(n);
  }), Iu;
}
var Du, mv;
function VO() {
  return mv || (mv = 1, Du = function(t) {
    var r = this, n = t;
    t instanceof this.constructor && (n = t.all());
    var o = {};
    return Object.keys(this.items).forEach(function(a) {
      (n[a] === void 0 || n[a] !== r.items[a]) && (o[a] = r.items[a]);
    }), new this.constructor(o);
  }), Du;
}
var Ru, vv;
function HO() {
  return vv || (vv = 1, Ru = function(t) {
    var r;
    t instanceof this.constructor ? r = t.all() : r = t;
    var n = Object.keys(r), o = Object.keys(this.items).filter(function(a) {
      return n.indexOf(a) === -1;
    });
    return new this.constructor(this.items).only(o);
  }), Ru;
}
var Mu, gv;
function GO() {
  return gv || (gv = 1, Mu = function(t, r) {
    var n = this.items.filter(function(o) {
      return !(t && t.some(function(a) {
        return r(o, a) === 0;
      }));
    });
    return new this.constructor(n);
  }), Mu;
}
var Bu, yv;
function KO() {
  return yv || (yv = 1, Bu = function(t, r) {
    return !this.contains(t, r);
  }), Bu;
}
var qu, bv;
function YO() {
  return bv || (bv = 1, qu = function() {
    return console.log(this), this;
  }), qu;
}
var Lu, wv;
function JO() {
  if (wv) return Lu;
  wv = 1;
  function e(t) {
    "@babel/helpers - typeof";
    return e = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
      return typeof r;
    } : function(r) {
      return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
    }, e(t);
  }
  return Lu = function() {
    var r = this, n = [], o = {}, a = function(s) {
      return Array.isArray(s) || e(s) === "object" ? JSON.stringify(s) : s;
    };
    return Array.isArray(this.items) ? this.items.forEach(function(i, s) {
      var l = a(i);
      n.indexOf(l) === -1 ? n.push(l) : o[s] = i;
    }) : e(this.items) === "object" && Object.keys(this.items).forEach(function(i) {
      var s = a(r.items[i]);
      n.indexOf(s) === -1 ? n.push(s) : o[i] = r.items[i];
    }), new this.constructor(o);
  }, Lu;
}
var Fu, _v;
function ZO() {
  return _v || (_v = 1, Fu = function(t) {
    var r = !1;
    if (Array.isArray(this.items))
      for (var n = this.items.length, o = 0; o < n && !r; o += 1)
        r = t(this.items[o], o, this.items) === !1;
    else
      for (var a = Object.keys(this.items), i = a.length, s = 0; s < i && !r; s += 1) {
        var l = a[s];
        r = t(this.items[l], l, this.items) === !1;
      }
    return this;
  }), Fu;
}
var Nu, Sv;
function XO() {
  if (Sv) return Nu;
  Sv = 1;
  function e(i) {
    return o(i) || n(i) || r(i) || t();
  }
  function t() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function r(i, s) {
    if (i) {
      if (typeof i == "string") return a(i, s);
      var l = Object.prototype.toString.call(i).slice(8, -1);
      if (l === "Object" && i.constructor && (l = i.constructor.name), l === "Map" || l === "Set") return Array.from(i);
      if (l === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(l)) return a(i, s);
    }
  }
  function n(i) {
    if (typeof Symbol < "u" && i[Symbol.iterator] != null || i["@@iterator"] != null) return Array.from(i);
  }
  function o(i) {
    if (Array.isArray(i)) return a(i);
  }
  function a(i, s) {
    (s == null || s > i.length) && (s = i.length);
    for (var l = 0, u = new Array(s); l < s; l++)
      u[l] = i[l];
    return u;
  }
  return Nu = function(s) {
    return this.each(function(l, u) {
      s.apply(void 0, e(l).concat([u]));
    }), this;
  }, Nu;
}
var zu, xv;
function QO() {
  if (xv) return zu;
  xv = 1;
  var e = on();
  return zu = function(r) {
    var n = e(this.items);
    return n.every(r);
  }, zu;
}
var ju, Av;
function Xs() {
  return Av || (Av = 1, ju = function(t) {
    return Array.isArray(t[0]) ? t[0] : t;
  }), ju;
}
var Uu, Tv;
function e$() {
  if (Tv) return Uu;
  Tv = 1;
  var e = Xs();
  return Uu = function() {
    for (var r = this, n = arguments.length, o = new Array(n), a = 0; a < n; a++)
      o[a] = arguments[a];
    var i = e(o);
    if (Array.isArray(this.items)) {
      var s = this.items.filter(function(u) {
        return i.indexOf(u) === -1;
      });
      return new this.constructor(s);
    }
    var l = {};
    return Object.keys(this.items).forEach(function(u) {
      i.indexOf(u) === -1 && (l[u] = r.items[u]);
    }), new this.constructor(l);
  }, Uu;
}
var Wu, Ev;
function t$() {
  if (Ev) return Wu;
  Ev = 1;
  function e(o) {
    "@babel/helpers - typeof";
    return e = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(a) {
      return typeof a;
    } : function(a) {
      return a && typeof Symbol == "function" && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a;
    }, e(o);
  }
  function t(o) {
    if (Array.isArray(o)) {
      if (o.length)
        return !1;
    } else if (o != null && e(o) === "object") {
      if (Object.keys(o).length)
        return !1;
    } else if (o)
      return !1;
    return !0;
  }
  function r(o, a) {
    var i = {};
    return Object.keys(a).forEach(function(s) {
      o ? o(a[s], s) && (i[s] = a[s]) : t(a[s]) || (i[s] = a[s]);
    }), i;
  }
  function n(o, a) {
    if (o)
      return a.filter(o);
    for (var i = [], s = 0; s < a.length; s += 1) {
      var l = a[s];
      t(l) || i.push(l);
    }
    return i;
  }
  return Wu = function(a) {
    var i = a || !1, s = null;
    return Array.isArray(this.items) ? s = n(i, this.items) : s = r(i, this.items), new this.constructor(s);
  }, Wu;
}
var Vu, Ov;
function r$() {
  if (Ov) return Vu;
  Ov = 1;
  var e = ft(), t = e.isFunction;
  return Vu = function(n, o) {
    if (t(n)) {
      for (var a = Object.keys(this.items), i = 0; i < a.length; i += 1) {
        var s = a[i], l = this.items[s];
        if (n(l, s))
          return l;
      }
      return t(o) ? o() : o;
    }
    if (Array.isArray(this.items) && this.items.length || Object.keys(this.items).length) {
      if (Array.isArray(this.items))
        return this.items[0];
      var u = Object.keys(this.items)[0];
      return this.items[u];
    }
    return t(o) ? o() : o;
  }, Vu;
}
var Hu, $v;
function n$() {
  if ($v) return Hu;
  $v = 1;
  var e = ft(), t = e.isFunction;
  return Hu = function(n, o, a) {
    if (t(n))
      return this.first(n, function() {
        throw new Error("Item not found.");
      });
    var i = this.where(n, o, a);
    if (i.isEmpty())
      throw new Error("Item not found.");
    return i.first();
  }, Hu;
}
var Gu, Cv;
function o$() {
  return Cv || (Cv = 1, Gu = function(t, r, n) {
    return this.where(t, r, n).first() || null;
  }), Gu;
}
var Ku, kv;
function i$() {
  return kv || (kv = 1, Ku = function(t) {
    return this.map(t).collapse();
  }), Ku;
}
var Yu, Pv;
function a$() {
  if (Pv) return Yu;
  Pv = 1;
  var e = ft(), t = e.isArray, r = e.isObject;
  return Yu = function(o) {
    var a = o || 1 / 0, i = !1, s = [], l = function(c) {
      s = [], t(c) ? c.forEach(function(d) {
        t(d) ? s = s.concat(d) : r(d) ? Object.keys(d).forEach(function(h) {
          s = s.concat(d[h]);
        }) : s.push(d);
      }) : Object.keys(c).forEach(function(d) {
        t(c[d]) ? s = s.concat(c[d]) : r(c[d]) ? Object.keys(c[d]).forEach(function(h) {
          s = s.concat(c[d][h]);
        }) : s.push(c[d]);
      }), i = s.filter(function(d) {
        return r(d);
      }), i = i.length === 0, a -= 1;
    };
    for (l(this.items); !i && a > 0; )
      l(s);
    return new this.constructor(s);
  }, Yu;
}
var Ju, Iv;
function s$() {
  return Iv || (Iv = 1, Ju = function() {
    var t = this, r = {};
    return Array.isArray(this.items) ? Object.keys(this.items).forEach(function(n) {
      r[t.items[n]] = Number(n);
    }) : Object.keys(this.items).forEach(function(n) {
      r[t.items[n]] = n;
    }), new this.constructor(r);
  }), Ju;
}
var Zu, Dv;
function l$() {
  return Dv || (Dv = 1, Zu = function(t, r) {
    var n = this, o = {};
    return Array.isArray(this.items) ? o = this.items.slice(t * r - r, t * r) : Object.keys(this.items).slice(t * r - r, t * r).forEach(function(a) {
      o[a] = n.items[a];
    }), new this.constructor(o);
  }), Zu;
}
var Xu, Rv;
function u$() {
  return Rv || (Rv = 1, Xu = function(t) {
    return Array.isArray(this.items) ? this.items.splice(t, 1) : delete this.items[t], this;
  }), Xu;
}
var Qu, Mv;
function c$() {
  if (Mv) return Qu;
  Mv = 1;
  var e = ft(), t = e.isFunction;
  return Qu = function(n) {
    var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    return this.items[n] !== void 0 ? this.items[n] : t(o) ? o() : o !== null ? o : null;
  }, Qu;
}
var ec, Bv;
function no() {
  return Bv || (Bv = 1, ec = function(t, r) {
    try {
      return r.split(".").reduce(function(n, o) {
        return n[o];
      }, t);
    } catch {
      return t;
    }
  }), ec;
}
var tc, qv;
function d$() {
  if (qv) return tc;
  qv = 1;
  var e = no(), t = ft(), r = t.isFunction;
  return tc = function(o) {
    var a = this, i = {};
    return this.items.forEach(function(s, l) {
      var u;
      r(o) ? u = o(s, l) : e(s, o) || e(s, o) === 0 ? u = e(s, o) : u = "", i[u] === void 0 && (i[u] = new a.constructor([])), i[u].push(s);
    }), new this.constructor(i);
  }, tc;
}
var rc, Lv;
function f$() {
  if (Lv) return rc;
  Lv = 1;
  var e = Xs();
  return rc = function() {
    for (var r = this, n = arguments.length, o = new Array(n), a = 0; a < n; a++)
      o[a] = arguments[a];
    var i = e(o);
    return i.filter(function(s) {
      return Object.hasOwnProperty.call(r.items, s);
    }).length === i.length;
  }, rc;
}
var nc, Fv;
function p$() {
  return Fv || (Fv = 1, nc = function(t, r) {
    return r === void 0 ? this.items.join(t) : new this.constructor(this.items).pluck(t).all().join(r);
  }), nc;
}
var oc, Nv;
function h$() {
  return Nv || (Nv = 1, oc = function(t) {
    var r = t;
    t instanceof this.constructor && (r = t.all());
    var n = this.items.filter(function(o) {
      return r.indexOf(o) !== -1;
    });
    return new this.constructor(n);
  }), oc;
}
var ic, zv;
function m$() {
  return zv || (zv = 1, ic = function(t) {
    var r = this, n = Object.keys(t);
    t instanceof this.constructor && (n = Object.keys(t.all()));
    var o = {};
    return Object.keys(this.items).forEach(function(a) {
      n.indexOf(a) !== -1 && (o[a] = r.items[a]);
    }), new this.constructor(o);
  }), ic;
}
var ac, jv;
function v$() {
  return jv || (jv = 1, ac = function() {
    return Array.isArray(this.items) ? !this.items.length : !Object.keys(this.items).length;
  }), ac;
}
var sc, Uv;
function g$() {
  return Uv || (Uv = 1, sc = function() {
    return !this.isEmpty();
  }), sc;
}
var lc, Wv;
function y$() {
  return Wv || (Wv = 1, lc = function(t, r) {
    var n = this.values();
    if (r === void 0)
      return n.implode(t);
    var o = n.count();
    if (o === 0)
      return "";
    if (o === 1)
      return n.last();
    var a = n.pop();
    return n.implode(t) + r + a;
  }), lc;
}
var uc, Vv;
function b$() {
  if (Vv) return uc;
  Vv = 1;
  var e = no(), t = ft(), r = t.isFunction;
  return uc = function(o) {
    var a = {};
    return r(o) ? this.items.forEach(function(i) {
      a[o(i)] = i;
    }) : this.items.forEach(function(i) {
      var s = e(i, o);
      a[s || ""] = i;
    }), new this.constructor(a);
  }, uc;
}
var cc, Hv;
function w$() {
  return Hv || (Hv = 1, cc = function() {
    var t = Object.keys(this.items);
    return Array.isArray(this.items) && (t = t.map(Number)), new this.constructor(t);
  }), cc;
}
var dc, Gv;
function _$() {
  if (Gv) return dc;
  Gv = 1;
  var e = ft(), t = e.isFunction;
  return dc = function(n, o) {
    var a = this.items;
    if (t(n) && (a = this.filter(n).all()), Array.isArray(a) && !a.length || !Object.keys(a).length)
      return t(o) ? o() : o;
    if (Array.isArray(a))
      return a[a.length - 1];
    var i = Object.keys(a);
    return a[i[i.length - 1]];
  }, dc;
}
var fc, Kv;
function S$() {
  return Kv || (Kv = 1, fc = function(t, r) {
    this.constructor.prototype[t] = r;
  }), fc;
}
var pc, Yv;
function x$() {
  return Yv || (Yv = 1, pc = function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new this.constructor(t);
  }), pc;
}
var hc, Jv;
function A$() {
  return Jv || (Jv = 1, hc = function(t) {
    var r = this;
    if (Array.isArray(this.items))
      return new this.constructor(this.items.map(t));
    var n = {};
    return Object.keys(this.items).forEach(function(o) {
      n[o] = t(r.items[o], o);
    }), new this.constructor(n);
  }), hc;
}
var mc, Zv;
function T$() {
  if (Zv) return mc;
  Zv = 1;
  function e(i) {
    return o(i) || n(i) || r(i) || t();
  }
  function t() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function r(i, s) {
    if (i) {
      if (typeof i == "string") return a(i, s);
      var l = Object.prototype.toString.call(i).slice(8, -1);
      if (l === "Object" && i.constructor && (l = i.constructor.name), l === "Map" || l === "Set") return Array.from(i);
      if (l === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(l)) return a(i, s);
    }
  }
  function n(i) {
    if (typeof Symbol < "u" && i[Symbol.iterator] != null || i["@@iterator"] != null) return Array.from(i);
  }
  function o(i) {
    if (Array.isArray(i)) return a(i);
  }
  function a(i, s) {
    (s == null || s > i.length) && (s = i.length);
    for (var l = 0, u = new Array(s); l < s; l++)
      u[l] = i[l];
    return u;
  }
  return mc = function(s) {
    return this.map(function(l, u) {
      return s.apply(void 0, e(l).concat([u]));
    });
  }, mc;
}
var vc, Xv;
function E$() {
  if (Xv) return vc;
  Xv = 1;
  function e(i, s) {
    return a(i) || o(i, s) || r(i, s) || t();
  }
  function t() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function r(i, s) {
    if (i) {
      if (typeof i == "string") return n(i, s);
      var l = Object.prototype.toString.call(i).slice(8, -1);
      if (l === "Object" && i.constructor && (l = i.constructor.name), l === "Map" || l === "Set") return Array.from(i);
      if (l === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(l)) return n(i, s);
    }
  }
  function n(i, s) {
    (s == null || s > i.length) && (s = i.length);
    for (var l = 0, u = new Array(s); l < s; l++)
      u[l] = i[l];
    return u;
  }
  function o(i, s) {
    var l = i == null ? null : typeof Symbol < "u" && i[Symbol.iterator] || i["@@iterator"];
    if (l != null) {
      var u = [], c = !0, d = !1, h, y;
      try {
        for (l = l.call(i); !(c = (h = l.next()).done) && (u.push(h.value), !(s && u.length === s)); c = !0)
          ;
      } catch (m) {
        d = !0, y = m;
      } finally {
        try {
          !c && l.return != null && l.return();
        } finally {
          if (d) throw y;
        }
      }
      return u;
    }
  }
  function a(i) {
    if (Array.isArray(i)) return i;
  }
  return vc = function(s) {
    var l = {};
    return this.items.forEach(function(u, c) {
      var d = s(u, c), h = e(d, 2), y = h[0], m = h[1];
      l[y] === void 0 ? l[y] = [m] : l[y].push(m);
    }), new this.constructor(l);
  }, vc;
}
var gc, Qv;
function O$() {
  return Qv || (Qv = 1, gc = function(t) {
    return this.map(function(r, n) {
      return new t(r, n);
    });
  }), gc;
}
var yc, eg;
function $$() {
  if (eg) return yc;
  eg = 1;
  function e(i, s) {
    return a(i) || o(i, s) || r(i, s) || t();
  }
  function t() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function r(i, s) {
    if (i) {
      if (typeof i == "string") return n(i, s);
      var l = Object.prototype.toString.call(i).slice(8, -1);
      if (l === "Object" && i.constructor && (l = i.constructor.name), l === "Map" || l === "Set") return Array.from(i);
      if (l === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(l)) return n(i, s);
    }
  }
  function n(i, s) {
    (s == null || s > i.length) && (s = i.length);
    for (var l = 0, u = new Array(s); l < s; l++)
      u[l] = i[l];
    return u;
  }
  function o(i, s) {
    var l = i == null ? null : typeof Symbol < "u" && i[Symbol.iterator] || i["@@iterator"];
    if (l != null) {
      var u = [], c = !0, d = !1, h, y;
      try {
        for (l = l.call(i); !(c = (h = l.next()).done) && (u.push(h.value), !(s && u.length === s)); c = !0)
          ;
      } catch (m) {
        d = !0, y = m;
      } finally {
        try {
          !c && l.return != null && l.return();
        } finally {
          if (d) throw y;
        }
      }
      return u;
    }
  }
  function a(i) {
    if (Array.isArray(i)) return i;
  }
  return yc = function(s) {
    var l = {};
    return this.items.forEach(function(u, c) {
      var d = s(u, c), h = e(d, 2), y = h[0], m = h[1];
      l[y] === void 0 ? l[y] = [m] : l[y].push(m);
    }), new this.constructor(l);
  }, yc;
}
var bc, tg;
function C$() {
  if (tg) return bc;
  tg = 1;
  function e(i, s) {
    return a(i) || o(i, s) || r(i, s) || t();
  }
  function t() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function r(i, s) {
    if (i) {
      if (typeof i == "string") return n(i, s);
      var l = Object.prototype.toString.call(i).slice(8, -1);
      if (l === "Object" && i.constructor && (l = i.constructor.name), l === "Map" || l === "Set") return Array.from(i);
      if (l === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(l)) return n(i, s);
    }
  }
  function n(i, s) {
    (s == null || s > i.length) && (s = i.length);
    for (var l = 0, u = new Array(s); l < s; l++)
      u[l] = i[l];
    return u;
  }
  function o(i, s) {
    var l = i == null ? null : typeof Symbol < "u" && i[Symbol.iterator] || i["@@iterator"];
    if (l != null) {
      var u = [], c = !0, d = !1, h, y;
      try {
        for (l = l.call(i); !(c = (h = l.next()).done) && (u.push(h.value), !(s && u.length === s)); c = !0)
          ;
      } catch (m) {
        d = !0, y = m;
      } finally {
        try {
          !c && l.return != null && l.return();
        } finally {
          if (d) throw y;
        }
      }
      return u;
    }
  }
  function a(i) {
    if (Array.isArray(i)) return i;
  }
  return bc = function(s) {
    var l = this, u = {};
    return Array.isArray(this.items) ? this.items.forEach(function(c, d) {
      var h = s(c, d), y = e(h, 2), m = y[0], p = y[1];
      u[m] = p;
    }) : Object.keys(this.items).forEach(function(c) {
      var d = s(l.items[c], c), h = e(d, 2), y = h[0], m = h[1];
      u[y] = m;
    }), new this.constructor(u);
  }, bc;
}
var wc, rg;
function k$() {
  if (rg) return wc;
  rg = 1;
  function e(i) {
    return o(i) || n(i) || r(i) || t();
  }
  function t() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function r(i, s) {
    if (i) {
      if (typeof i == "string") return a(i, s);
      var l = Object.prototype.toString.call(i).slice(8, -1);
      if (l === "Object" && i.constructor && (l = i.constructor.name), l === "Map" || l === "Set") return Array.from(i);
      if (l === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(l)) return a(i, s);
    }
  }
  function n(i) {
    if (typeof Symbol < "u" && i[Symbol.iterator] != null || i["@@iterator"] != null) return Array.from(i);
  }
  function o(i) {
    if (Array.isArray(i)) return a(i);
  }
  function a(i, s) {
    (s == null || s > i.length) && (s = i.length);
    for (var l = 0, u = new Array(s); l < s; l++)
      u[l] = i[l];
    return u;
  }
  return wc = function(s) {
    if (typeof s == "string") {
      var l = this.items.filter(function(u) {
        return u[s] !== void 0;
      });
      return Math.max.apply(Math, e(l.map(function(u) {
        return u[s];
      })));
    }
    return Math.max.apply(Math, e(this.items));
  }, wc;
}
var _c, ng;
function P$() {
  return ng || (ng = 1, _c = function(t) {
    var r = this.items.length;
    return t === void 0 ? r % 2 === 0 ? (this.items[r / 2 - 1] + this.items[r / 2]) / 2 : this.items[Math.floor(r / 2)] : r % 2 === 0 ? (this.items[r / 2 - 1][t] + this.items[r / 2][t]) / 2 : this.items[Math.floor(r / 2)][t];
  }), _c;
}
var Sc, og;
function I$() {
  return og || (og = 1, Sc = function(t) {
    var r = t;
    if (typeof r == "string" && (r = [r]), Array.isArray(this.items) && Array.isArray(r))
      return new this.constructor(this.items.concat(r));
    var n = JSON.parse(JSON.stringify(this.items));
    return Object.keys(r).forEach(function(o) {
      n[o] = r[o];
    }), new this.constructor(n);
  }), Sc;
}
var xc, ig;
function D$() {
  if (ig) return xc;
  ig = 1;
  function e(o) {
    "@babel/helpers - typeof";
    return e = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(a) {
      return typeof a;
    } : function(a) {
      return a && typeof Symbol == "function" && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a;
    }, e(o);
  }
  function t(o, a) {
    var i = Object.keys(o);
    if (Object.getOwnPropertySymbols) {
      var s = Object.getOwnPropertySymbols(o);
      a && (s = s.filter(function(l) {
        return Object.getOwnPropertyDescriptor(o, l).enumerable;
      })), i.push.apply(i, s);
    }
    return i;
  }
  function r(o) {
    for (var a = 1; a < arguments.length; a++) {
      var i = arguments[a] != null ? arguments[a] : {};
      a % 2 ? t(Object(i), !0).forEach(function(s) {
        n(o, s, i[s]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(i)) : t(Object(i)).forEach(function(s) {
        Object.defineProperty(o, s, Object.getOwnPropertyDescriptor(i, s));
      });
    }
    return o;
  }
  function n(o, a, i) {
    return a in o ? Object.defineProperty(o, a, { value: i, enumerable: !0, configurable: !0, writable: !0 }) : o[a] = i, o;
  }
  return xc = function(a) {
    var i = function s(l, u) {
      var c = {}, d = Object.keys(r(r({}, l), u));
      return d.forEach(function(h) {
        l[h] === void 0 && u[h] !== void 0 ? c[h] = u[h] : l[h] !== void 0 && u[h] === void 0 ? c[h] = l[h] : l[h] !== void 0 && u[h] !== void 0 && (l[h] === u[h] ? c[h] = l[h] : !Array.isArray(l[h]) && e(l[h]) === "object" && !Array.isArray(u[h]) && e(u[h]) === "object" ? c[h] = s(l[h], u[h]) : c[h] = [].concat(l[h], u[h]));
      }), c;
    };
    return a ? a.constructor.name === "Collection" ? new this.constructor(i(this.items, a.all())) : new this.constructor(i(this.items, a)) : this;
  }, xc;
}
var Ac, ag;
function R$() {
  if (ag) return Ac;
  ag = 1;
  function e(i) {
    return o(i) || n(i) || r(i) || t();
  }
  function t() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function r(i, s) {
    if (i) {
      if (typeof i == "string") return a(i, s);
      var l = Object.prototype.toString.call(i).slice(8, -1);
      if (l === "Object" && i.constructor && (l = i.constructor.name), l === "Map" || l === "Set") return Array.from(i);
      if (l === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(l)) return a(i, s);
    }
  }
  function n(i) {
    if (typeof Symbol < "u" && i[Symbol.iterator] != null || i["@@iterator"] != null) return Array.from(i);
  }
  function o(i) {
    if (Array.isArray(i)) return a(i);
  }
  function a(i, s) {
    (s == null || s > i.length) && (s = i.length);
    for (var l = 0, u = new Array(s); l < s; l++)
      u[l] = i[l];
    return u;
  }
  return Ac = function(s) {
    if (s !== void 0) {
      var l = this.items.filter(function(u) {
        return u[s] !== void 0;
      });
      return Math.min.apply(Math, e(l.map(function(u) {
        return u[s];
      })));
    }
    return Math.min.apply(Math, e(this.items));
  }, Ac;
}
var Tc, sg;
function M$() {
  return sg || (sg = 1, Tc = function(t) {
    var r = [], n = 1;
    return this.items.length ? (this.items.forEach(function(o) {
      var a = r.filter(function(s) {
        return t !== void 0 ? s.key === o[t] : s.key === o;
      });
      if (!a.length)
        t !== void 0 ? r.push({
          key: o[t],
          count: 1
        }) : r.push({
          key: o,
          count: 1
        });
      else {
        a[0].count += 1;
        var i = a[0].count;
        i > n && (n = i);
      }
    }), r.filter(function(o) {
      return o.count === n;
    }).map(function(o) {
      return o.key;
    })) : null;
  }), Tc;
}
var Ec, lg;
function B$() {
  if (lg) return Ec;
  lg = 1;
  var e = on();
  return Ec = function(r) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, o = e(this.items), a = o.slice(n).filter(function(i, s) {
      return s % r === 0;
    });
    return new this.constructor(a);
  }, Ec;
}
var Oc, ug;
function q$() {
  if (ug) return Oc;
  ug = 1;
  var e = Xs();
  return Oc = function() {
    for (var r = this, n = arguments.length, o = new Array(n), a = 0; a < n; a++)
      o[a] = arguments[a];
    var i = e(o);
    if (Array.isArray(this.items)) {
      var s = this.items.filter(function(u) {
        return i.indexOf(u) !== -1;
      });
      return new this.constructor(s);
    }
    var l = {};
    return Object.keys(this.items).forEach(function(u) {
      i.indexOf(u) !== -1 && (l[u] = r.items[u]);
    }), new this.constructor(l);
  }, Oc;
}
var $c, cg;
function L$() {
  if (cg) return $c;
  cg = 1;
  var e = j1();
  return $c = function(r, n) {
    var o = Math.abs(r), a = this.count();
    if (o <= a)
      return this;
    for (var i = o - a, s = e(this.items), l = Array.isArray(this.items), u = r < 0, c = 0; c < i; )
      l ? u ? s.unshift(n) : s.push(n) : s[c] !== void 0 ? i += 1 : s[c] = n, c += 1;
    return new this.constructor(s);
  }, $c;
}
var Cc, dg;
function F$() {
  return dg || (dg = 1, Cc = function(t) {
    var r = this, n;
    return Array.isArray(this.items) ? (n = [new this.constructor([]), new this.constructor([])], this.items.forEach(function(o) {
      t(o) === !0 ? n[0].push(o) : n[1].push(o);
    })) : (n = [new this.constructor({}), new this.constructor({})], Object.keys(this.items).forEach(function(o) {
      var a = r.items[o];
      t(a) === !0 ? n[0].put(o, a) : n[1].put(o, a);
    })), new this.constructor(n);
  }), Cc;
}
var kc, fg;
function N$() {
  return fg || (fg = 1, kc = function(t) {
    return t(this);
  }), kc;
}
var Pc, pg;
function z$() {
  if (pg) return Pc;
  pg = 1;
  var e = ft(), t = e.isArray, r = e.isObject, n = no(), o = function(i) {
    var s = {};
    return i.forEach(function(l, u) {
      function c(d, h) {
        r(d) ? Object.keys(d).forEach(function(y) {
          c(d[y], "".concat(h, ".").concat(y));
        }) : t(d) && d.forEach(function(y, m) {
          c(y, "".concat(h, ".").concat(m));
        }), s[h] = d;
      }
      c(l, u);
    }), s;
  };
  return Pc = function(i, s) {
    if (i.indexOf("*") !== -1) {
      var l = o(this.items), u = [];
      if (s !== void 0) {
        var c = new RegExp("0.".concat(s), "g"), d = "0.".concat(s).split(".").length;
        Object.keys(l).forEach(function(v) {
          var w = v.match(c);
          if (w) {
            var _ = w[0];
            _.split(".").length === d && u.push(l[_]);
          }
        });
      }
      var h = [], y = new RegExp("0.".concat(i), "g"), m = "0.".concat(i).split(".").length;
      if (Object.keys(l).forEach(function(v) {
        var w = v.match(y);
        if (w) {
          var _ = w[0];
          _.split(".").length === m && h.push(l[_]);
        }
      }), s !== void 0) {
        var p = {};
        return this.items.forEach(function(v, w) {
          p[u[w] || ""] = h;
        }), new this.constructor(p);
      }
      return new this.constructor([h]);
    }
    if (s !== void 0) {
      var f = {};
      return this.items.forEach(function(v) {
        n(v, i) !== void 0 ? f[v[s] || ""] = n(v, i) : f[v[s] || ""] = null;
      }), new this.constructor(f);
    }
    return this.map(function(v) {
      return n(v, i) !== void 0 ? n(v, i) : null;
    });
  }, Pc;
}
var Ic, hg;
function W1() {
  if (hg) return Ic;
  hg = 1;
  var e = Xs();
  return Ic = function(r) {
    for (var n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), a = 1; a < n; a++)
      o[a - 1] = arguments[a];
    e(o).forEach(function(i) {
      delete r[i];
    });
  }, Ic;
}
var Dc, mg;
function j$() {
  if (mg) return Dc;
  mg = 1;
  var e = ft(), t = e.isArray, r = e.isObject, n = W1();
  return Dc = function() {
    var a = this, i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
    if (this.isEmpty())
      return null;
    if (t(this.items))
      return i === 1 ? this.items.pop() : new this.constructor(this.items.splice(-i));
    if (r(this.items)) {
      var s = Object.keys(this.items);
      if (i === 1) {
        var l = s[s.length - 1], u = this.items[l];
        return n(this.items, l), u;
      }
      var c = s.slice(-i), d = c.reduce(function(h, y) {
        return h[y] = a.items[y], h;
      }, {});
      return n(this.items, c), new this.constructor(d);
    }
    return null;
  }, Dc;
}
var Rc, vg;
function U$() {
  return vg || (vg = 1, Rc = function(t, r) {
    return r !== void 0 ? this.put(r, t) : (this.items.unshift(t), this);
  }), Rc;
}
var Mc, gg;
function W$() {
  if (gg) return Mc;
  gg = 1;
  var e = ft(), t = e.isFunction;
  return Mc = function(n, o) {
    var a = this.items[n] || null;
    return !a && o !== void 0 && (t(o) ? a = o() : a = o), delete this.items[n], a;
  }, Mc;
}
var Bc, yg;
function V$() {
  return yg || (yg = 1, Bc = function() {
    var t;
    return (t = this.items).push.apply(t, arguments), this;
  }), Bc;
}
var qc, bg;
function H$() {
  return bg || (bg = 1, qc = function(t, r) {
    return this.items[t] = r, this;
  }), qc;
}
var Lc, wg;
function G$() {
  if (wg) return Lc;
  wg = 1;
  var e = on();
  return Lc = function() {
    var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, n = e(this.items), o = new this.constructor(n).shuffle();
    return r !== parseInt(r, 10) ? o.first() : o.take(r);
  }, Lc;
}
var Fc, _g;
function K$() {
  return _g || (_g = 1, Fc = function(t, r) {
    var n = this, o = null;
    return r !== void 0 && (o = r), Array.isArray(this.items) ? this.items.forEach(function(a) {
      o = t(o, a);
    }) : Object.keys(this.items).forEach(function(a) {
      o = t(o, n.items[a], a);
    }), o;
  }), Fc;
}
var Nc, Sg;
function Y$() {
  return Sg || (Sg = 1, Nc = function(t) {
    return new this.constructor(this.items).filter(function(r) {
      return !t(r);
    });
  }), Nc;
}
var zc, xg;
function J$() {
  if (xg) return zc;
  xg = 1;
  function e(n, o) {
    var a = Object.keys(n);
    if (Object.getOwnPropertySymbols) {
      var i = Object.getOwnPropertySymbols(n);
      o && (i = i.filter(function(s) {
        return Object.getOwnPropertyDescriptor(n, s).enumerable;
      })), a.push.apply(a, i);
    }
    return a;
  }
  function t(n) {
    for (var o = 1; o < arguments.length; o++) {
      var a = arguments[o] != null ? arguments[o] : {};
      o % 2 ? e(Object(a), !0).forEach(function(i) {
        r(n, i, a[i]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(a)) : e(Object(a)).forEach(function(i) {
        Object.defineProperty(n, i, Object.getOwnPropertyDescriptor(a, i));
      });
    }
    return n;
  }
  function r(n, o, a) {
    return o in n ? Object.defineProperty(n, o, { value: a, enumerable: !0, configurable: !0, writable: !0 }) : n[o] = a, n;
  }
  return zc = function(o) {
    if (!o)
      return this;
    if (Array.isArray(o)) {
      var a = this.items.map(function(l, u) {
        return o[u] || l;
      });
      return new this.constructor(a);
    }
    if (o.constructor.name === "Collection") {
      var i = t(t({}, this.items), o.all());
      return new this.constructor(i);
    }
    var s = t(t({}, this.items), o);
    return new this.constructor(s);
  }, zc;
}
var jc, Ag;
function Z$() {
  if (Ag) return jc;
  Ag = 1;
  function e(o) {
    "@babel/helpers - typeof";
    return e = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(a) {
      return typeof a;
    } : function(a) {
      return a && typeof Symbol == "function" && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a;
    }, e(o);
  }
  function t(o, a) {
    var i = Object.keys(o);
    if (Object.getOwnPropertySymbols) {
      var s = Object.getOwnPropertySymbols(o);
      a && (s = s.filter(function(l) {
        return Object.getOwnPropertyDescriptor(o, l).enumerable;
      })), i.push.apply(i, s);
    }
    return i;
  }
  function r(o) {
    for (var a = 1; a < arguments.length; a++) {
      var i = arguments[a] != null ? arguments[a] : {};
      a % 2 ? t(Object(i), !0).forEach(function(s) {
        n(o, s, i[s]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(i)) : t(Object(i)).forEach(function(s) {
        Object.defineProperty(o, s, Object.getOwnPropertyDescriptor(i, s));
      });
    }
    return o;
  }
  function n(o, a, i) {
    return a in o ? Object.defineProperty(o, a, { value: i, enumerable: !0, configurable: !0, writable: !0 }) : o[a] = i, o;
  }
  return jc = function(a) {
    var i = function s(l, u) {
      var c = r({}, l), d = Object.keys(r(r({}, l), u));
      return d.forEach(function(h) {
        !Array.isArray(u[h]) && e(u[h]) === "object" ? c[h] = s(l[h], u[h]) : l[h] === void 0 && u[h] !== void 0 ? e(l[h]) === "object" ? c[h] = r({}, u[h]) : c[h] = u[h] : l[h] !== void 0 && u[h] === void 0 ? e(l[h]) === "object" ? c[h] = r({}, l[h]) : c[h] = l[h] : l[h] !== void 0 && u[h] !== void 0 && (e(u[h]) === "object" ? c[h] = r({}, u[h]) : c[h] = u[h]);
      }), c;
    };
    return a ? !Array.isArray(a) && e(a) !== "object" ? new this.constructor(i(this.items, [a])) : a.constructor.name === "Collection" ? new this.constructor(i(this.items, a.all())) : new this.constructor(i(this.items, a)) : this;
  }, jc;
}
var Uc, Tg;
function X$() {
  return Tg || (Tg = 1, Uc = function() {
    var t = [].concat(this.items).reverse();
    return new this.constructor(t);
  }), Uc;
}
var Wc, Eg;
function Q$() {
  if (Eg) return Wc;
  Eg = 1;
  var e = ft(), t = e.isArray, r = e.isObject, n = e.isFunction;
  return Wc = function(a, i) {
    var s = this, l, u = function(d, h) {
      return n(a) ? a(s.items[h], h) : i ? s.items[h] === a : s.items[h] == a;
    };
    return t(this.items) ? l = this.items.findIndex(u) : r(this.items) && (l = Object.keys(this.items).find(function(c) {
      return u(s.items[c], c);
    })), l === void 0 || l < 0 ? !1 : l;
  }, Wc;
}
var Vc, Og;
function e5() {
  if (Og) return Vc;
  Og = 1;
  var e = ft(), t = e.isArray, r = e.isObject, n = W1();
  return Vc = function() {
    var a = this, i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
    if (this.isEmpty())
      return null;
    if (t(this.items))
      return i === 1 ? this.items.shift() : new this.constructor(this.items.splice(0, i));
    if (r(this.items)) {
      if (i === 1) {
        var s = Object.keys(this.items)[0], l = this.items[s];
        return delete this.items[s], l;
      }
      var u = Object.keys(this.items), c = u.slice(0, i), d = c.reduce(function(h, y) {
        return h[y] = a.items[y], h;
      }, {});
      return n(this.items, c), new this.constructor(d);
    }
    return null;
  }, Vc;
}
var Hc, $g;
function t5() {
  if ($g) return Hc;
  $g = 1;
  var e = on();
  return Hc = function() {
    var r = e(this.items), n, o, a;
    for (a = r.length; a; a -= 1)
      n = Math.floor(Math.random() * a), o = r[a - 1], r[a - 1] = r[n], r[n] = o;
    return this.items = r, this;
  }, Hc;
}
var Gc, Cg;
function r5() {
  if (Cg) return Gc;
  Cg = 1;
  var e = ft(), t = e.isObject;
  return Gc = function(n) {
    var o = this;
    return t(this.items) ? new this.constructor(Object.keys(this.items).reduce(function(a, i, s) {
      return s + 1 > n && (a[i] = o.items[i]), a;
    }, {})) : new this.constructor(this.items.slice(n));
  }, Gc;
}
var Kc, kg;
function n5() {
  if (kg) return Kc;
  kg = 1;
  var e = ft(), t = e.isArray, r = e.isObject, n = e.isFunction;
  return Kc = function(a) {
    var i = this, s = null, l, u = function(d) {
      return d === a;
    };
    return n(a) && (u = a), t(this.items) && (l = this.items.filter(function(c) {
      return s !== !0 && (s = u(c)), s;
    })), r(this.items) && (l = Object.keys(this.items).reduce(function(c, d) {
      return s !== !0 && (s = u(i.items[d])), s !== !1 && (c[d] = i.items[d]), c;
    }, {})), new this.constructor(l);
  }, Kc;
}
var Yc, Pg;
function o5() {
  if (Pg) return Yc;
  Pg = 1;
  var e = ft(), t = e.isArray, r = e.isObject, n = e.isFunction;
  return Yc = function(a) {
    var i = this, s = null, l, u = function(d) {
      return d === a;
    };
    return n(a) && (u = a), t(this.items) && (l = this.items.filter(function(c) {
      return s !== !0 && (s = !u(c)), s;
    })), r(this.items) && (l = Object.keys(this.items).reduce(function(c, d) {
      return s !== !0 && (s = !u(i.items[d])), s !== !1 && (c[d] = i.items[d]), c;
    }, {})), new this.constructor(l);
  }, Yc;
}
var Jc, Ig;
function i5() {
  return Ig || (Ig = 1, Jc = function(t, r) {
    var n = this.items.slice(t);
    return r !== void 0 && (n = n.slice(0, r)), new this.constructor(n);
  }), Jc;
}
var Zc, Dg;
function a5() {
  if (Dg) return Zc;
  Dg = 1;
  var e = ft(), t = e.isFunction;
  return Zc = function(n, o, a) {
    var i;
    if (t(n) ? i = this.filter(n) : i = this.where(n, o, a), i.isEmpty())
      throw new Error("Item not found.");
    if (i.count() > 1)
      throw new Error("Multiple items found.");
    return i.first();
  }, Zc;
}
var Xc, Rg;
function s5() {
  if (Rg) return Xc;
  Rg = 1;
  var e = U1();
  return Xc = e, Xc;
}
var Qc, Mg;
function l5() {
  return Mg || (Mg = 1, Qc = function(t) {
    var r = [].concat(this.items);
    return t === void 0 ? this.every(function(n) {
      return typeof n == "number";
    }) ? r.sort(function(n, o) {
      return n - o;
    }) : r.sort() : r.sort(t), new this.constructor(r);
  }), Qc;
}
var ed, Bg;
function u5() {
  return Bg || (Bg = 1, ed = function() {
    return this.sort().reverse();
  }), ed;
}
var td, qg;
function c5() {
  if (qg) return td;
  qg = 1;
  var e = no(), t = ft(), r = t.isFunction;
  return td = function(o) {
    var a = [].concat(this.items), i = function(l) {
      return r(o) ? o(l) : e(l, o);
    };
    return a.sort(function(s, l) {
      var u = i(s), c = i(l);
      return u == null ? 1 : c == null || u < c ? -1 : u > c ? 1 : 0;
    }), new this.constructor(a);
  }, td;
}
var rd, Lg;
function d5() {
  return Lg || (Lg = 1, rd = function(t) {
    return this.sortBy(t).reverse();
  }), rd;
}
var nd, Fg;
function f5() {
  return Fg || (Fg = 1, nd = function() {
    var t = this, r = {};
    return Object.keys(this.items).sort().forEach(function(n) {
      r[n] = t.items[n];
    }), new this.constructor(r);
  }), nd;
}
var od, Ng;
function p5() {
  return Ng || (Ng = 1, od = function() {
    var t = this, r = {};
    return Object.keys(this.items).sort().reverse().forEach(function(n) {
      r[n] = t.items[n];
    }), new this.constructor(r);
  }), od;
}
var id, zg;
function h5() {
  return zg || (zg = 1, id = function(t, r, n) {
    var o = this.slice(t, r);
    if (this.items = this.diff(o.all()).all(), Array.isArray(n))
      for (var a = 0, i = n.length; a < i; a += 1)
        this.items.splice(t + a, 0, n[a]);
    return o;
  }), id;
}
var ad, jg;
function m5() {
  return jg || (jg = 1, ad = function(t) {
    for (var r = Math.round(this.items.length / t), n = JSON.parse(JSON.stringify(this.items)), o = [], a = 0; a < t; a += 1)
      o.push(new this.constructor(n.splice(0, r)));
    return new this.constructor(o);
  }), ad;
}
var sd, Ug;
function v5() {
  if (Ug) return sd;
  Ug = 1;
  var e = on(), t = ft(), r = t.isFunction;
  return sd = function(o) {
    var a = e(this.items), i = 0;
    if (o === void 0)
      for (var s = 0, l = a.length; s < l; s += 1)
        i += parseFloat(a[s]);
    else if (r(o))
      for (var u = 0, c = a.length; u < c; u += 1)
        i += parseFloat(o(a[u]));
    else
      for (var d = 0, h = a.length; d < h; d += 1)
        i += parseFloat(a[d][o]);
    return parseFloat(i.toPrecision(12));
  }, sd;
}
var ld, Wg;
function g5() {
  if (Wg) return ld;
  Wg = 1;
  function e(t) {
    "@babel/helpers - typeof";
    return e = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
      return typeof r;
    } : function(r) {
      return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
    }, e(t);
  }
  return ld = function(r) {
    var n = this;
    if (!Array.isArray(this.items) && e(this.items) === "object") {
      var o = Object.keys(this.items), a;
      r < 0 ? a = o.slice(r) : a = o.slice(0, r);
      var i = {};
      return o.forEach(function(s) {
        a.indexOf(s) !== -1 && (i[s] = n.items[s]);
      }), new this.constructor(i);
    }
    return r < 0 ? new this.constructor(this.items.slice(r)) : new this.constructor(this.items.slice(0, r));
  }, ld;
}
var ud, Vg;
function y5() {
  if (Vg) return ud;
  Vg = 1;
  var e = ft(), t = e.isArray, r = e.isObject, n = e.isFunction;
  return ud = function(a) {
    var i = this, s = null, l, u = function(d) {
      return d === a;
    };
    return n(a) && (u = a), t(this.items) && (l = this.items.filter(function(c) {
      return s !== !1 && (s = !u(c)), s;
    })), r(this.items) && (l = Object.keys(this.items).reduce(function(c, d) {
      return s !== !1 && (s = !u(i.items[d])), s !== !1 && (c[d] = i.items[d]), c;
    }, {})), new this.constructor(l);
  }, ud;
}
var cd, Hg;
function b5() {
  if (Hg) return cd;
  Hg = 1;
  var e = ft(), t = e.isArray, r = e.isObject, n = e.isFunction;
  return cd = function(a) {
    var i = this, s = null, l, u = function(d) {
      return d === a;
    };
    return n(a) && (u = a), t(this.items) && (l = this.items.filter(function(c) {
      return s !== !1 && (s = u(c)), s;
    })), r(this.items) && (l = Object.keys(this.items).reduce(function(c, d) {
      return s !== !1 && (s = u(i.items[d])), s !== !1 && (c[d] = i.items[d]), c;
    }, {})), new this.constructor(l);
  }, cd;
}
var dd, Gg;
function w5() {
  return Gg || (Gg = 1, dd = function(t) {
    return t(this), this;
  }), dd;
}
var fd, Kg;
function _5() {
  return Kg || (Kg = 1, fd = function(t, r) {
    for (var n = 1; n <= t; n += 1)
      this.items.push(r(n));
    return this;
  }), fd;
}
var pd, Yg;
function S5() {
  return Yg || (Yg = 1, pd = function() {
    var t = this.constructor;
    function r(o, a) {
      var i = [];
      o instanceof t ? (o.items.forEach(function(s) {
        return r(s, i);
      }), a.push(i)) : Array.isArray(o) ? (o.forEach(function(s) {
        return r(s, i);
      }), a.push(i)) : a.push(o);
    }
    if (Array.isArray(this.items)) {
      var n = [];
      return this.items.forEach(function(o) {
        r(o, n);
      }), n;
    }
    return this.values().all();
  }), pd;
}
var hd, Jg;
function x5() {
  if (Jg) return hd;
  Jg = 1;
  function e(t) {
    "@babel/helpers - typeof";
    return e = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
      return typeof r;
    } : function(r) {
      return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
    }, e(t);
  }
  return hd = function() {
    return e(this.items) === "object" && !Array.isArray(this.items) ? JSON.stringify(this.all()) : JSON.stringify(this.toArray());
  }, hd;
}
var md, Zg;
function A5() {
  return Zg || (Zg = 1, md = function(t) {
    var r = this;
    if (Array.isArray(this.items))
      this.items = this.items.map(t);
    else {
      var n = {};
      Object.keys(this.items).forEach(function(o) {
        n[o] = t(r.items[o], o);
      }), this.items = n;
    }
    return this;
  }), md;
}
var vd, Xg;
function T5() {
  if (Xg) return vd;
  Xg = 1;
  function e(n, o) {
    var a = Object.keys(n);
    if (Object.getOwnPropertySymbols) {
      var i = Object.getOwnPropertySymbols(n);
      o && (i = i.filter(function(s) {
        return Object.getOwnPropertyDescriptor(n, s).enumerable;
      })), a.push.apply(a, i);
    }
    return a;
  }
  function t(n) {
    for (var o = 1; o < arguments.length; o++) {
      var a = arguments[o] != null ? arguments[o] : {};
      o % 2 ? e(Object(a), !0).forEach(function(i) {
        r(n, i, a[i]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(a)) : e(Object(a)).forEach(function(i) {
        Object.defineProperty(n, i, Object.getOwnPropertyDescriptor(a, i));
      });
    }
    return n;
  }
  function r(n, o, a) {
    return o in n ? Object.defineProperty(n, o, { value: a, enumerable: !0, configurable: !0, writable: !0 }) : n[o] = a, n;
  }
  return vd = function() {
    var o = this;
    if (Array.isArray(this.items))
      return this;
    var a = {};
    return Object.keys(this.items).forEach(function(i) {
      if (i.indexOf(".") !== -1) {
        var s = a;
        i.split(".").reduce(function(l, u, c, d) {
          return l[u] || (l[u] = {}), c === d.length - 1 && (l[u] = o.items[i]), l[u];
        }, s), a = t(t({}, a), s);
      } else
        a[i] = o.items[i];
    }), new this.constructor(a);
  }, vd;
}
var gd, Qg;
function E5() {
  return Qg || (Qg = 1, gd = function(t, r, n) {
    t ? n(this) : r(this);
  }), gd;
}
var yd, ey;
function ty() {
  return ey || (ey = 1, yd = function(t, r) {
    if (Array.isArray(this.items) && this.items.length)
      return t(this);
    if (Object.keys(this.items).length)
      return t(this);
    if (r !== void 0) {
      if (Array.isArray(this.items) && !this.items.length)
        return r(this);
      if (!Object.keys(this.items).length)
        return r(this);
    }
    return this;
  }), yd;
}
var bd, ry;
function ny() {
  return ry || (ry = 1, bd = function(t, r) {
    if (Array.isArray(this.items) && !this.items.length)
      return t(this);
    if (!Object.keys(this.items).length)
      return t(this);
    if (r !== void 0) {
      if (Array.isArray(this.items) && this.items.length)
        return r(this);
      if (Object.keys(this.items).length)
        return r(this);
    }
    return this;
  }), bd;
}
var wd, oy;
function O5() {
  return oy || (oy = 1, wd = function(t) {
    var r = this, n = JSON.parse(JSON.stringify(this.items));
    return Object.keys(t).forEach(function(o) {
      r.items[o] === void 0 && (n[o] = t[o]);
    }), new this.constructor(n);
  }), wd;
}
var _d, iy;
function $5() {
  if (iy) return _d;
  iy = 1;
  var e = ft(), t = e.isFunction;
  return _d = function(n) {
    var o;
    if (n === void 0)
      o = this.items.filter(function(u, c, d) {
        return d.indexOf(u) === c;
      });
    else {
      o = [];
      for (var a = [], i = 0, s = this.items.length; i < s; i += 1) {
        var l = void 0;
        t(n) ? l = n(this.items[i]) : l = this.items[i][n], a.indexOf(l) === -1 && (o.push(this.items[i]), a.push(l));
      }
    }
    return new this.constructor(o);
  }, _d;
}
var Sd, ay;
function C5() {
  return ay || (ay = 1, Sd = function(t) {
    return t instanceof this.constructor ? t.all() : t;
  }), Sd;
}
var xd, sy;
function k5() {
  if (sy) return xd;
  sy = 1;
  var e = on();
  return xd = function() {
    return new this.constructor(e(this.items));
  }, xd;
}
var Ad, ly;
function P5() {
  return ly || (ly = 1, Ad = function(t, r, n) {
    return t ? r(this, t) : n ? n(this, t) : this;
  }), Ad;
}
var Td, uy;
function I5() {
  if (uy) return Td;
  uy = 1;
  var e = on(), t = no();
  return Td = function(n, o, a) {
    var i = o, s = a, l = e(this.items);
    if (o === void 0 || o === !0)
      return new this.constructor(l.filter(function(c) {
        return t(c, n);
      }));
    if (o === !1)
      return new this.constructor(l.filter(function(c) {
        return !t(c, n);
      }));
    a === void 0 && (s = o, i = "===");
    var u = l.filter(function(c) {
      switch (i) {
        case "==":
          return t(c, n) === Number(s) || t(c, n) === s.toString();
        default:
        case "===":
          return t(c, n) === s;
        case "!=":
        case "<>":
          return t(c, n) !== Number(s) && t(c, n) !== s.toString();
        case "!==":
          return t(c, n) !== s;
        case "<":
          return t(c, n) < s;
        case "<=":
          return t(c, n) <= s;
        case ">":
          return t(c, n) > s;
        case ">=":
          return t(c, n) >= s;
      }
    });
    return new this.constructor(u);
  }, Td;
}
var Ed, cy;
function D5() {
  return cy || (cy = 1, Ed = function(t, r) {
    return this.where(t, ">=", r[0]).where(t, "<=", r[r.length - 1]);
  }), Ed;
}
var Od, dy;
function R5() {
  if (dy) return Od;
  dy = 1;
  var e = on(), t = no();
  return Od = function(n, o) {
    var a = e(o), i = this.items.filter(function(s) {
      return a.indexOf(t(s, n)) !== -1;
    });
    return new this.constructor(i);
  }, Od;
}
var $d, fy;
function M5() {
  return fy || (fy = 1, $d = function(t) {
    return this.filter(function(r) {
      return r instanceof t;
    });
  }), $d;
}
var Cd, py;
function B5() {
  if (py) return Cd;
  py = 1;
  var e = no();
  return Cd = function(r, n) {
    return this.filter(function(o) {
      return e(o, r) < n[0] || e(o, r) > n[n.length - 1];
    });
  }, Cd;
}
var kd, hy;
function q5() {
  if (hy) return kd;
  hy = 1;
  var e = on(), t = no();
  return kd = function(n, o) {
    var a = e(o), i = this.items.filter(function(s) {
      return a.indexOf(t(s, n)) === -1;
    });
    return new this.constructor(i);
  }, kd;
}
var Pd, my;
function L5() {
  return my || (my = 1, Pd = function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    return this.where(t, "===", null);
  }), Pd;
}
var Id, vy;
function F5() {
  return vy || (vy = 1, Id = function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    return this.where(t, "!==", null);
  }), Id;
}
var Dd, gy;
function N5() {
  if (gy) return Dd;
  gy = 1;
  function e(t) {
    "@babel/helpers - typeof";
    return e = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
      return typeof r;
    } : function(r) {
      return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
    }, e(t);
  }
  return Dd = function(r) {
    return r instanceof this.constructor ? r : e(r) === "object" ? new this.constructor(r) : new this.constructor([r]);
  }, Dd;
}
var Rd, yy;
function z5() {
  return yy || (yy = 1, Rd = function(t) {
    var r = this, n = t;
    n instanceof this.constructor && (n = n.all());
    var o = this.items.map(function(a, i) {
      return new r.constructor([a, n[i]]);
    });
    return new this.constructor(o);
  }), Rd;
}
var by;
function j5() {
  return by || (by = 1, function(e) {
    function t(a) {
      "@babel/helpers - typeof";
      return t = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(i) {
        return typeof i;
      } : function(i) {
        return i && typeof Symbol == "function" && i.constructor === Symbol && i !== Symbol.prototype ? "symbol" : typeof i;
      }, t(a);
    }
    function r(a) {
      a !== void 0 && !Array.isArray(a) && t(a) !== "object" ? this.items = [a] : a instanceof this.constructor ? this.items = a.all() : this.items = a || [];
    }
    var n = IO();
    typeof Symbol < "u" && (r.prototype[Symbol.iterator] = n), r.prototype.toJSON = function() {
      return this.items;
    }, r.prototype.all = DO(), r.prototype.average = z1(), r.prototype.avg = RO(), r.prototype.chunk = MO(), r.prototype.collapse = BO(), r.prototype.combine = qO(), r.prototype.concat = LO(), r.prototype.contains = U1(), r.prototype.containsOneItem = FO(), r.prototype.count = NO(), r.prototype.countBy = zO(), r.prototype.crossJoin = jO(), r.prototype.dd = UO(), r.prototype.diff = WO(), r.prototype.diffAssoc = VO(), r.prototype.diffKeys = HO(), r.prototype.diffUsing = GO(), r.prototype.doesntContain = KO(), r.prototype.dump = YO(), r.prototype.duplicates = JO(), r.prototype.each = ZO(), r.prototype.eachSpread = XO(), r.prototype.every = QO(), r.prototype.except = e$(), r.prototype.filter = t$(), r.prototype.first = r$(), r.prototype.firstOrFail = n$(), r.prototype.firstWhere = o$(), r.prototype.flatMap = i$(), r.prototype.flatten = a$(), r.prototype.flip = s$(), r.prototype.forPage = l$(), r.prototype.forget = u$(), r.prototype.get = c$(), r.prototype.groupBy = d$(), r.prototype.has = f$(), r.prototype.implode = p$(), r.prototype.intersect = h$(), r.prototype.intersectByKeys = m$(), r.prototype.isEmpty = v$(), r.prototype.isNotEmpty = g$(), r.prototype.join = y$(), r.prototype.keyBy = b$(), r.prototype.keys = w$(), r.prototype.last = _$(), r.prototype.macro = S$(), r.prototype.make = x$(), r.prototype.map = A$(), r.prototype.mapSpread = T$(), r.prototype.mapToDictionary = E$(), r.prototype.mapInto = O$(), r.prototype.mapToGroups = $$(), r.prototype.mapWithKeys = C$(), r.prototype.max = k$(), r.prototype.median = P$(), r.prototype.merge = I$(), r.prototype.mergeRecursive = D$(), r.prototype.min = R$(), r.prototype.mode = M$(), r.prototype.nth = B$(), r.prototype.only = q$(), r.prototype.pad = L$(), r.prototype.partition = F$(), r.prototype.pipe = N$(), r.prototype.pluck = z$(), r.prototype.pop = j$(), r.prototype.prepend = U$(), r.prototype.pull = W$(), r.prototype.push = V$(), r.prototype.put = H$(), r.prototype.random = G$(), r.prototype.reduce = K$(), r.prototype.reject = Y$(), r.prototype.replace = J$(), r.prototype.replaceRecursive = Z$(), r.prototype.reverse = X$(), r.prototype.search = Q$(), r.prototype.shift = e5(), r.prototype.shuffle = t5(), r.prototype.skip = r5(), r.prototype.skipUntil = n5(), r.prototype.skipWhile = o5(), r.prototype.slice = i5(), r.prototype.sole = a5(), r.prototype.some = s5(), r.prototype.sort = l5(), r.prototype.sortDesc = u5(), r.prototype.sortBy = c5(), r.prototype.sortByDesc = d5(), r.prototype.sortKeys = f5(), r.prototype.sortKeysDesc = p5(), r.prototype.splice = h5(), r.prototype.split = m5(), r.prototype.sum = v5(), r.prototype.take = g5(), r.prototype.takeUntil = y5(), r.prototype.takeWhile = b5(), r.prototype.tap = w5(), r.prototype.times = _5(), r.prototype.toArray = S5(), r.prototype.toJson = x5(), r.prototype.transform = A5(), r.prototype.undot = T5(), r.prototype.unless = E5(), r.prototype.unlessEmpty = ty(), r.prototype.unlessNotEmpty = ny(), r.prototype.union = O5(), r.prototype.unique = $5(), r.prototype.unwrap = C5(), r.prototype.values = k5(), r.prototype.when = P5(), r.prototype.whenEmpty = ny(), r.prototype.whenNotEmpty = ty(), r.prototype.where = I5(), r.prototype.whereBetween = D5(), r.prototype.whereIn = R5(), r.prototype.whereInstanceOf = M5(), r.prototype.whereNotBetween = B5(), r.prototype.whereNotIn = q5(), r.prototype.whereNull = L5(), r.prototype.whereNotNull = F5(), r.prototype.wrap = N5(), r.prototype.zip = z5();
    var o = function(i) {
      return new r(i);
    };
    e.exports = o, e.exports.collect = o, e.exports.default = o, e.exports.Collection = r;
  }(hu)), hu.exports;
}
var U5 = j5();
const wy = /* @__PURE__ */ ui(U5), W5 = {}, V5 = { class: "flex items-center space-x-2" };
function H5(e, t) {
  return $(), B("ul", V5, [
    V(e.$slots, "default")
  ]);
}
const G5 = /* @__PURE__ */ De(W5, [["render", H5]]), K5 = ["aria-labelledby"], Y5 = /* @__PURE__ */ U({
  __name: "LegendItem",
  props: {
    color: {}
  },
  setup(e) {
    const t = e, r = Je("legendItem"), n = bt(t.color, "500");
    return (o, a) => ($(), B("li", { "aria-labelledby": S(r) }, [
      X("button", {
        class: Te([S(Qt)("focus"), "flex items-center rounded border border-transparent px-2 space-x-2 py-0.5 hover:bg-slate-100"]),
        role: "button"
      }, [
        X("span", {
          class: "h-2 w-2 rounded-full flex-shrink-0",
          style: $t({ backgroundColor: S(n) })
        }, null, 4),
        ie(S(Ve), {
          id: S(r),
          class: "whitespace-nowrap",
          strong: ""
        }, {
          default: Y(() => [
            V(o.$slots, "default")
          ]),
          _: 3
        }, 8, ["id"])
      ], 2)
    ], 8, K5));
  }
}), J5 = { class: "flex justify-end" }, Z5 = /* @__PURE__ */ U({
  __name: "BarChartLegend",
  setup(e) {
    const t = je("barChartCategories"), r = je("barChartHiddenCategories");
    function n(o) {
      const a = o.accessorKey;
      t.length !== 1 && (r.value = r.value.includes(a) ? r.value.filter((i) => i !== a) : [...r.value, a]);
    }
    return (o, a) => ($(), B("div", J5, [
      ie(S(G5), null, {
        default: Y(() => [
          ($(!0), B(qt, null, sr(S(t), (i) => ($(), ne(S(Y5), {
            key: i.accessorKey,
            color: i.color,
            class: Te({
              "opacity-50": S(r).includes(i.accessorKey)
            }),
            onClick: (s) => n(i)
          }, {
            default: Y(() => [
              et(Ie(i.label), 1)
            ]),
            _: 2
          }, 1032, ["color", "class", "onClick"]))), 128))
        ]),
        _: 1
      })
    ]));
  }
}), X5 = { class: "px-4 pt-3" }, Q5 = { class: "px-4 py-3" }, eC = { class: "flex items-center space-x-2" }, tC = /* @__PURE__ */ U({
  __name: "BarChartTooltip",
  setup(e, { expose: t }) {
    const r = je("barChartHighlightedRecord"), n = je("barChartLabelAccessorKey"), o = je("barChartCategories"), a = se();
    t({
      $tooltip: a
    });
    const i = re(() => r.value[n]);
    return (s, l) => Dr(($(), B("div", {
      ref_key: "$tooltip",
      ref: a,
      class: "absolute transition-all duration-75 m-1 rounded border bg-white shadow-lg min-w-[200px] pointer-events-none"
    }, [
      S(r) ? ($(), B(qt, { key: 0 }, [
        X("div", X5, [
          ie(S(Ve), { strong: "" }, {
            default: Y(() => [
              et(Ie(i.value), 1)
            ]),
            _: 1
          })
        ]),
        X("ul", Q5, [
          ($(!0), B(qt, null, sr(S(o), (u) => ($(), B("li", {
            key: u.accessorKey,
            class: "flex items-center justify-between space-x-2"
          }, [
            X("div", eC, [
              X("div", {
                class: "rounded-full size-2",
                style: $t({ backgroundColor: S(bt)(u.color, "500") })
              }, null, 4),
              X("div", null, Ie(u.label), 1)
            ]),
            X("div", null, Ie(S(r)[u.accessorKey]), 1)
          ]))), 128))
        ])
      ], 64)) : _e("", !0)
    ], 512)), [
      [li, S(r)]
    ]);
  }
}), rC = ["onMouseenter"], nC = {
  key: 1,
  class: "flex items-center justify-between mt-2 px-3"
}, J6 = /* @__PURE__ */ U({
  __name: "BarChart",
  props: {
    categories: {},
    data: {},
    labelAccessorKey: {},
    stacked: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, r = se(null), n = se([]), o = se(), a = se(), i = re(() => wy(t.categories).filter((m) => !n.value.includes(m.accessorKey))), s = re(() => {
      const m = wy(t.data), p = i.value;
      return t.stacked ? m.map((f) => p.sum((v) => f[v.accessorKey])).max() : p.map((f) => m.max(f.accessorKey)).max();
    }), l = re(() => [
      { "flex-col-reverse": t.stacked },
      { "space-x-1": !t.stacked }
    ]), u = re(() => [
      { "first:rounded-b-sm last:rounded-t-sm": t.stacked },
      { "rounded-sm": !t.stacked }
    ]), c = re(() => t.data.length === 0 ? null : [
      t.data[0][t.labelAccessorKey],
      t.data[t.data.length - 1][t.labelAccessorKey]
    ]);
    function d(m, p) {
      return (m[p.accessorKey] / s.value * 100).toFixed(2);
    }
    function h(m, p) {
      const f = a.value.$tooltip;
      r.value = p, Qe(() => {
        const v = m.target, w = v.offsetLeft + v.offsetWidth;
        f.style.left = f.offsetWidth + w > o.value.offsetWidth ? `${v.offsetLeft - f.offsetWidth - 8}px` : `${w}px`;
      });
    }
    function y() {
      r.value = null;
    }
    return tt("barChartCategories", t.categories), tt("barChartHiddenCategories", n), tt("barChartHighlightedRecord", r), tt("barChartLabelAccessorKey", t.labelAccessorKey), (m, p) => ($(), B(qt, null, [
      m.categories.length > 1 ? ($(), ne(Z5, { key: 0 })) : _e("", !0),
      X("div", {
        ref_key: "$container",
        ref: o,
        class: "relative flex w-full mt-4",
        style: { "aspect-ratio": "16 / 5", "max-height": "250px" }
      }, [
        ie(tC, {
          ref_key: "$tooltip",
          ref: a
        }, null, 512),
        ($(!0), B(qt, null, sr(m.data, (f, v) => ($(), B("div", {
          key: v,
          style: $t({
            width: `${100 / m.data.length}%`
          }),
          class: "px-0.5",
          onMouseenter: (w) => h(w, f),
          onMouseleave: y
        }, [
          X("div", {
            class: Te(["flex h-full w-full items-end overflow-hidden rounded-sm bg-slate-100 p-1.5 hover:bg-slate-200", l.value])
          }, [
            ($(!0), B(qt, null, sr(i.value, (w) => ($(), B("div", {
              key: w.accessorKey,
              class: Te(["w-full", u.value]),
              style: $t({
                height: `${d(f, w)}%`,
                backgroundColor: S(bt)(w.color, "500")
              })
            }, null, 6))), 128))
          ], 2)
        ], 44, rC))), 128))
      ], 512),
      c.value ? ($(), B("div", nC, [
        X("div", null, Ie(c.value[0]), 1),
        X("div", null, Ie(c.value[1]), 1)
      ])) : _e("", !0)
    ], 64));
  }
}), oC = {}, iC = { "aria-label": "breadcrumb" };
function aC(e, t) {
  return $(), B("nav", iC, [
    V(e.$slots, "default")
  ]);
}
const Z6 = /* @__PURE__ */ De(oC, [["render", aC]]), sC = {
  role: "presentation",
  "aria-hidden": "true"
}, X6 = /* @__PURE__ */ U({
  __name: "BreadcrumbEllipsis",
  setup(e) {
    return (t, r) => ($(), B("span", sC, [
      ie(S(S2), { class: "size-4" })
    ]));
  }
}), lC = {}, uC = { class: "inline-flex items-center text-slate-500" };
function cC(e, t) {
  return $(), B("li", uC, [
    V(e.$slots, "default")
  ]);
}
const Q6 = /* @__PURE__ */ De(lC, [["render", cC]]), eR = /* @__PURE__ */ U({
  __name: "BreadcrumbLink",
  setup(e) {
    return (t, r) => ($(), ne(S(Hs), {
      class: "hover:underline hover:text-black",
      href: "/",
      role: "link"
    }, {
      default: Y(() => [
        V(t.$slots, "default")
      ]),
      _: 3
    }));
  }
}), dC = {}, fC = { class: "flex flex-wrap items-center gap-2 break-words" };
function pC(e, t) {
  return $(), B("ol", fC, [
    V(e.$slots, "default")
  ]);
}
const tR = /* @__PURE__ */ De(dC, [["render", pC]]), hC = {}, mC = {
  "aria-current": "page",
  "aria-disabled": "true",
  class: "text-black",
  role: "link"
};
function vC(e, t) {
  return $(), B("span", mC, [
    V(e.$slots, "default")
  ]);
}
const rR = /* @__PURE__ */ De(hC, [["render", vC]]), gC = {
  "aria-hidden": "true",
  role: "presentation"
}, nR = /* @__PURE__ */ U({
  __name: "BreadcrumbSeparator",
  setup(e) {
    return (t, r) => ($(), B("li", gC, [
      ie(S(Sp), { class: "size-4" })
    ]));
  }
}), yC = {}, bC = { class: "flex flex-col overflow-auto rounded-lg border bg-white dark:bg-zinc-950 dark:border-zinc-700 shadow-sm" };
function wC(e, t) {
  return $(), B("div", bC, [
    V(e.$slots, "default")
  ]);
}
const Np = /* @__PURE__ */ De(yC, [["render", wC]]), oR = /* @__PURE__ */ U({
  __name: "CardDescription",
  setup(e) {
    return (t, r) => ($(), B("p", null, [
      ie(S(Ve), { subdued: "" }, {
        default: Y(() => [
          V(t.$slots, "default")
        ]),
        _: 3
      })
    ]));
  }
}), _C = {}, SC = { class: "flex items-center justify-end bg-slate-100 px-6 py-3 dark:bg-zinc-900" };
function xC(e, t) {
  return $(), B("div", SC, [
    V(e.$slots, "default")
  ]);
}
const iR = /* @__PURE__ */ De(_C, [["render", xC]]), AC = {}, TC = { class: "relative flex flex-col space-y-1.5 p-6 pb-0" };
function EC(e, t) {
  return $(), B("div", TC, [
    V(e.$slots, "default")
  ]);
}
const aR = /* @__PURE__ */ De(AC, [["render", EC]]);
function V1(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: OC } = Object.prototype, { getPrototypeOf: zp } = Object, Qs = /* @__PURE__ */ ((e) => (t) => {
  const r = OC.call(t);
  return e[r] || (e[r] = r.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), Wr = (e) => (e = e.toLowerCase(), (t) => Qs(t) === e), el = (e) => (t) => typeof t === e, { isArray: yi } = Array, la = el("undefined");
function $C(e) {
  return e !== null && !la(e) && e.constructor !== null && !la(e.constructor) && yr(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const H1 = Wr("ArrayBuffer");
function CC(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && H1(e.buffer), t;
}
const kC = el("string"), yr = el("function"), G1 = el("number"), tl = (e) => e !== null && typeof e == "object", PC = (e) => e === !0 || e === !1, fs = (e) => {
  if (Qs(e) !== "object")
    return !1;
  const t = zp(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, IC = Wr("Date"), DC = Wr("File"), RC = Wr("Blob"), MC = Wr("FileList"), BC = (e) => tl(e) && yr(e.pipe), qC = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || yr(e.append) && ((t = Qs(e)) === "formdata" || // detect form-data instance
  t === "object" && yr(e.toString) && e.toString() === "[object FormData]"));
}, LC = Wr("URLSearchParams"), [FC, NC, zC, jC] = ["ReadableStream", "Request", "Response", "Headers"].map(Wr), UC = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function ha(e, t, { allOwnKeys: r = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let n, o;
  if (typeof e != "object" && (e = [e]), yi(e))
    for (n = 0, o = e.length; n < o; n++)
      t.call(null, e[n], n, e);
  else {
    const a = r ? Object.getOwnPropertyNames(e) : Object.keys(e), i = a.length;
    let s;
    for (n = 0; n < i; n++)
      s = a[n], t.call(null, e[s], s, e);
  }
}
function K1(e, t) {
  t = t.toLowerCase();
  const r = Object.keys(e);
  let n = r.length, o;
  for (; n-- > 0; )
    if (o = r[n], t === o.toLowerCase())
      return o;
  return null;
}
const Ao = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, Y1 = (e) => !la(e) && e !== Ao;
function Yf() {
  const { caseless: e } = Y1(this) && this || {}, t = {}, r = (n, o) => {
    const a = e && K1(t, o) || o;
    fs(t[a]) && fs(n) ? t[a] = Yf(t[a], n) : fs(n) ? t[a] = Yf({}, n) : yi(n) ? t[a] = n.slice() : t[a] = n;
  };
  for (let n = 0, o = arguments.length; n < o; n++)
    arguments[n] && ha(arguments[n], r);
  return t;
}
const WC = (e, t, r, { allOwnKeys: n } = {}) => (ha(t, (o, a) => {
  r && yr(o) ? e[a] = V1(o, r) : e[a] = o;
}, { allOwnKeys: n }), e), VC = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), HC = (e, t, r, n) => {
  e.prototype = Object.create(t.prototype, n), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), r && Object.assign(e.prototype, r);
}, GC = (e, t, r, n) => {
  let o, a, i;
  const s = {};
  if (t = t || {}, e == null) return t;
  do {
    for (o = Object.getOwnPropertyNames(e), a = o.length; a-- > 0; )
      i = o[a], (!n || n(i, e, t)) && !s[i] && (t[i] = e[i], s[i] = !0);
    e = r !== !1 && zp(e);
  } while (e && (!r || r(e, t)) && e !== Object.prototype);
  return t;
}, KC = (e, t, r) => {
  e = String(e), (r === void 0 || r > e.length) && (r = e.length), r -= t.length;
  const n = e.indexOf(t, r);
  return n !== -1 && n === r;
}, YC = (e) => {
  if (!e) return null;
  if (yi(e)) return e;
  let t = e.length;
  if (!G1(t)) return null;
  const r = new Array(t);
  for (; t-- > 0; )
    r[t] = e[t];
  return r;
}, JC = /* @__PURE__ */ ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && zp(Uint8Array)), ZC = (e, t) => {
  const n = (e && e[Symbol.iterator]).call(e);
  let o;
  for (; (o = n.next()) && !o.done; ) {
    const a = o.value;
    t.call(e, a[0], a[1]);
  }
}, XC = (e, t) => {
  let r;
  const n = [];
  for (; (r = e.exec(t)) !== null; )
    n.push(r);
  return n;
}, QC = Wr("HTMLFormElement"), ek = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(r, n, o) {
    return n.toUpperCase() + o;
  }
), _y = (({ hasOwnProperty: e }) => (t, r) => e.call(t, r))(Object.prototype), tk = Wr("RegExp"), J1 = (e, t) => {
  const r = Object.getOwnPropertyDescriptors(e), n = {};
  ha(r, (o, a) => {
    let i;
    (i = t(o, a, e)) !== !1 && (n[a] = i || o);
  }), Object.defineProperties(e, n);
}, rk = (e) => {
  J1(e, (t, r) => {
    if (yr(e) && ["arguments", "caller", "callee"].indexOf(r) !== -1)
      return !1;
    const n = e[r];
    if (yr(n)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + r + "'");
      });
    }
  });
}, nk = (e, t) => {
  const r = {}, n = (o) => {
    o.forEach((a) => {
      r[a] = !0;
    });
  };
  return yi(e) ? n(e) : n(String(e).split(t)), r;
}, ok = () => {
}, ik = (e, t) => e != null && Number.isFinite(e = +e) ? e : t, Md = "abcdefghijklmnopqrstuvwxyz", Sy = "0123456789", Z1 = {
  DIGIT: Sy,
  ALPHA: Md,
  ALPHA_DIGIT: Md + Md.toUpperCase() + Sy
}, ak = (e = 16, t = Z1.ALPHA_DIGIT) => {
  let r = "";
  const { length: n } = t;
  for (; e--; )
    r += t[Math.random() * n | 0];
  return r;
};
function sk(e) {
  return !!(e && yr(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
const lk = (e) => {
  const t = new Array(10), r = (n, o) => {
    if (tl(n)) {
      if (t.indexOf(n) >= 0)
        return;
      if (!("toJSON" in n)) {
        t[o] = n;
        const a = yi(n) ? [] : {};
        return ha(n, (i, s) => {
          const l = r(i, o + 1);
          !la(l) && (a[s] = l);
        }), t[o] = void 0, a;
      }
    }
    return n;
  };
  return r(e, 0);
}, uk = Wr("AsyncFunction"), ck = (e) => e && (tl(e) || yr(e)) && yr(e.then) && yr(e.catch), X1 = ((e, t) => e ? setImmediate : t ? ((r, n) => (Ao.addEventListener("message", ({ source: o, data: a }) => {
  o === Ao && a === r && n.length && n.shift()();
}, !1), (o) => {
  n.push(o), Ao.postMessage(r, "*");
}))(`axios@${Math.random()}`, []) : (r) => setTimeout(r))(
  typeof setImmediate == "function",
  yr(Ao.postMessage)
), dk = typeof queueMicrotask < "u" ? queueMicrotask.bind(Ao) : typeof process < "u" && process.nextTick || X1, te = {
  isArray: yi,
  isArrayBuffer: H1,
  isBuffer: $C,
  isFormData: qC,
  isArrayBufferView: CC,
  isString: kC,
  isNumber: G1,
  isBoolean: PC,
  isObject: tl,
  isPlainObject: fs,
  isReadableStream: FC,
  isRequest: NC,
  isResponse: zC,
  isHeaders: jC,
  isUndefined: la,
  isDate: IC,
  isFile: DC,
  isBlob: RC,
  isRegExp: tk,
  isFunction: yr,
  isStream: BC,
  isURLSearchParams: LC,
  isTypedArray: JC,
  isFileList: MC,
  forEach: ha,
  merge: Yf,
  extend: WC,
  trim: UC,
  stripBOM: VC,
  inherits: HC,
  toFlatObject: GC,
  kindOf: Qs,
  kindOfTest: Wr,
  endsWith: KC,
  toArray: YC,
  forEachEntry: ZC,
  matchAll: XC,
  isHTMLForm: QC,
  hasOwnProperty: _y,
  hasOwnProp: _y,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: J1,
  freezeMethods: rk,
  toObjectSet: nk,
  toCamelCase: ek,
  noop: ok,
  toFiniteNumber: ik,
  findKey: K1,
  global: Ao,
  isContextDefined: Y1,
  ALPHABET: Z1,
  generateString: ak,
  isSpecCompliantForm: sk,
  toJSONObject: lk,
  isAsyncFn: uk,
  isThenable: ck,
  setImmediate: X1,
  asap: dk
};
function Be(e, t, r, n, o) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), r && (this.config = r), n && (this.request = n), o && (this.response = o, this.status = o.status ? o.status : null);
}
te.inherits(Be, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: te.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const Q1 = Be.prototype, ew = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  ew[e] = { value: e };
});
Object.defineProperties(Be, ew);
Object.defineProperty(Q1, "isAxiosError", { value: !0 });
Be.from = (e, t, r, n, o, a) => {
  const i = Object.create(Q1);
  return te.toFlatObject(e, i, function(l) {
    return l !== Error.prototype;
  }, (s) => s !== "isAxiosError"), Be.call(i, e.message, t, r, n, o), i.cause = e, i.name = e.name, a && Object.assign(i, a), i;
};
const fk = null;
function Jf(e) {
  return te.isPlainObject(e) || te.isArray(e);
}
function tw(e) {
  return te.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function xy(e, t, r) {
  return e ? e.concat(t).map(function(o, a) {
    return o = tw(o), !r && a ? "[" + o + "]" : o;
  }).join(r ? "." : "") : t;
}
function pk(e) {
  return te.isArray(e) && !e.some(Jf);
}
const hk = te.toFlatObject(te, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function rl(e, t, r) {
  if (!te.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), r = te.toFlatObject(r, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(p, f) {
    return !te.isUndefined(f[p]);
  });
  const n = r.metaTokens, o = r.visitor || c, a = r.dots, i = r.indexes, l = (r.Blob || typeof Blob < "u" && Blob) && te.isSpecCompliantForm(t);
  if (!te.isFunction(o))
    throw new TypeError("visitor must be a function");
  function u(m) {
    if (m === null) return "";
    if (te.isDate(m))
      return m.toISOString();
    if (!l && te.isBlob(m))
      throw new Be("Blob is not supported. Use a Buffer instead.");
    return te.isArrayBuffer(m) || te.isTypedArray(m) ? l && typeof Blob == "function" ? new Blob([m]) : Buffer.from(m) : m;
  }
  function c(m, p, f) {
    let v = m;
    if (m && !f && typeof m == "object") {
      if (te.endsWith(p, "{}"))
        p = n ? p : p.slice(0, -2), m = JSON.stringify(m);
      else if (te.isArray(m) && pk(m) || (te.isFileList(m) || te.endsWith(p, "[]")) && (v = te.toArray(m)))
        return p = tw(p), v.forEach(function(_, T) {
          !(te.isUndefined(_) || _ === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            i === !0 ? xy([p], T, a) : i === null ? p : p + "[]",
            u(_)
          );
        }), !1;
    }
    return Jf(m) ? !0 : (t.append(xy(f, p, a), u(m)), !1);
  }
  const d = [], h = Object.assign(hk, {
    defaultVisitor: c,
    convertValue: u,
    isVisitable: Jf
  });
  function y(m, p) {
    if (!te.isUndefined(m)) {
      if (d.indexOf(m) !== -1)
        throw Error("Circular reference detected in " + p.join("."));
      d.push(m), te.forEach(m, function(v, w) {
        (!(te.isUndefined(v) || v === null) && o.call(
          t,
          v,
          te.isString(w) ? w.trim() : w,
          p,
          h
        )) === !0 && y(v, p ? p.concat(w) : [w]);
      }), d.pop();
    }
  }
  if (!te.isObject(e))
    throw new TypeError("data must be an object");
  return y(e), t;
}
function Ay(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(n) {
    return t[n];
  });
}
function jp(e, t) {
  this._pairs = [], e && rl(e, this, t);
}
const rw = jp.prototype;
rw.append = function(t, r) {
  this._pairs.push([t, r]);
};
rw.toString = function(t) {
  const r = t ? function(n) {
    return t.call(this, n, Ay);
  } : Ay;
  return this._pairs.map(function(o) {
    return r(o[0]) + "=" + r(o[1]);
  }, "").join("&");
};
function mk(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function nw(e, t, r) {
  if (!t)
    return e;
  const n = r && r.encode || mk, o = r && r.serialize;
  let a;
  if (o ? a = o(t, r) : a = te.isURLSearchParams(t) ? t.toString() : new jp(t, r).toString(n), a) {
    const i = e.indexOf("#");
    i !== -1 && (e = e.slice(0, i)), e += (e.indexOf("?") === -1 ? "?" : "&") + a;
  }
  return e;
}
class Ty {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, r, n) {
    return this.handlers.push({
      fulfilled: t,
      rejected: r,
      synchronous: n ? n.synchronous : !1,
      runWhen: n ? n.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    te.forEach(this.handlers, function(n) {
      n !== null && t(n);
    });
  }
}
const ow = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, vk = typeof URLSearchParams < "u" ? URLSearchParams : jp, gk = typeof FormData < "u" ? FormData : null, yk = typeof Blob < "u" ? Blob : null, bk = {
  isBrowser: !0,
  classes: {
    URLSearchParams: vk,
    FormData: gk,
    Blob: yk
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, Up = typeof window < "u" && typeof document < "u", Zf = typeof navigator == "object" && navigator || void 0, wk = Up && (!Zf || ["ReactNative", "NativeScript", "NS"].indexOf(Zf.product) < 0), _k = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", Sk = Up && window.location.href || "http://localhost", xk = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: Up,
  hasStandardBrowserEnv: wk,
  hasStandardBrowserWebWorkerEnv: _k,
  navigator: Zf,
  origin: Sk
}, Symbol.toStringTag, { value: "Module" })), lr = {
  ...xk,
  ...bk
};
function Ak(e, t) {
  return rl(e, new lr.classes.URLSearchParams(), Object.assign({
    visitor: function(r, n, o, a) {
      return lr.isNode && te.isBuffer(r) ? (this.append(n, r.toString("base64")), !1) : a.defaultVisitor.apply(this, arguments);
    }
  }, t));
}
function Tk(e) {
  return te.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function Ek(e) {
  const t = {}, r = Object.keys(e);
  let n;
  const o = r.length;
  let a;
  for (n = 0; n < o; n++)
    a = r[n], t[a] = e[a];
  return t;
}
function iw(e) {
  function t(r, n, o, a) {
    let i = r[a++];
    if (i === "__proto__") return !0;
    const s = Number.isFinite(+i), l = a >= r.length;
    return i = !i && te.isArray(o) ? o.length : i, l ? (te.hasOwnProp(o, i) ? o[i] = [o[i], n] : o[i] = n, !s) : ((!o[i] || !te.isObject(o[i])) && (o[i] = []), t(r, n, o[i], a) && te.isArray(o[i]) && (o[i] = Ek(o[i])), !s);
  }
  if (te.isFormData(e) && te.isFunction(e.entries)) {
    const r = {};
    return te.forEachEntry(e, (n, o) => {
      t(Tk(n), o, r, 0);
    }), r;
  }
  return null;
}
function Ok(e, t, r) {
  if (te.isString(e))
    try {
      return (t || JSON.parse)(e), te.trim(e);
    } catch (n) {
      if (n.name !== "SyntaxError")
        throw n;
    }
  return (r || JSON.stringify)(e);
}
const ma = {
  transitional: ow,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(t, r) {
    const n = r.getContentType() || "", o = n.indexOf("application/json") > -1, a = te.isObject(t);
    if (a && te.isHTMLForm(t) && (t = new FormData(t)), te.isFormData(t))
      return o ? JSON.stringify(iw(t)) : t;
    if (te.isArrayBuffer(t) || te.isBuffer(t) || te.isStream(t) || te.isFile(t) || te.isBlob(t) || te.isReadableStream(t))
      return t;
    if (te.isArrayBufferView(t))
      return t.buffer;
    if (te.isURLSearchParams(t))
      return r.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
    let s;
    if (a) {
      if (n.indexOf("application/x-www-form-urlencoded") > -1)
        return Ak(t, this.formSerializer).toString();
      if ((s = te.isFileList(t)) || n.indexOf("multipart/form-data") > -1) {
        const l = this.env && this.env.FormData;
        return rl(
          s ? { "files[]": t } : t,
          l && new l(),
          this.formSerializer
        );
      }
    }
    return a || o ? (r.setContentType("application/json", !1), Ok(t)) : t;
  }],
  transformResponse: [function(t) {
    const r = this.transitional || ma.transitional, n = r && r.forcedJSONParsing, o = this.responseType === "json";
    if (te.isResponse(t) || te.isReadableStream(t))
      return t;
    if (t && te.isString(t) && (n && !this.responseType || o)) {
      const i = !(r && r.silentJSONParsing) && o;
      try {
        return JSON.parse(t);
      } catch (s) {
        if (i)
          throw s.name === "SyntaxError" ? Be.from(s, Be.ERR_BAD_RESPONSE, this, null, this.response) : s;
      }
    }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: lr.classes.FormData,
    Blob: lr.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
te.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  ma.headers[e] = {};
});
const $k = te.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), Ck = (e) => {
  const t = {};
  let r, n, o;
  return e && e.split(`
`).forEach(function(i) {
    o = i.indexOf(":"), r = i.substring(0, o).trim().toLowerCase(), n = i.substring(o + 1).trim(), !(!r || t[r] && $k[r]) && (r === "set-cookie" ? t[r] ? t[r].push(n) : t[r] = [n] : t[r] = t[r] ? t[r] + ", " + n : n);
  }), t;
}, Ey = Symbol("internals");
function Ui(e) {
  return e && String(e).trim().toLowerCase();
}
function ps(e) {
  return e === !1 || e == null ? e : te.isArray(e) ? e.map(ps) : String(e);
}
function kk(e) {
  const t = /* @__PURE__ */ Object.create(null), r = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let n;
  for (; n = r.exec(e); )
    t[n[1]] = n[2];
  return t;
}
const Pk = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function Bd(e, t, r, n, o) {
  if (te.isFunction(n))
    return n.call(this, t, r);
  if (o && (t = r), !!te.isString(t)) {
    if (te.isString(n))
      return t.indexOf(n) !== -1;
    if (te.isRegExp(n))
      return n.test(t);
  }
}
function Ik(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, r, n) => r.toUpperCase() + n);
}
function Dk(e, t) {
  const r = te.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((n) => {
    Object.defineProperty(e, n + r, {
      value: function(o, a, i) {
        return this[n].call(this, t, o, a, i);
      },
      configurable: !0
    });
  });
}
let ur = class {
  constructor(t) {
    t && this.set(t);
  }
  set(t, r, n) {
    const o = this;
    function a(s, l, u) {
      const c = Ui(l);
      if (!c)
        throw new Error("header name must be a non-empty string");
      const d = te.findKey(o, c);
      (!d || o[d] === void 0 || u === !0 || u === void 0 && o[d] !== !1) && (o[d || l] = ps(s));
    }
    const i = (s, l) => te.forEach(s, (u, c) => a(u, c, l));
    if (te.isPlainObject(t) || t instanceof this.constructor)
      i(t, r);
    else if (te.isString(t) && (t = t.trim()) && !Pk(t))
      i(Ck(t), r);
    else if (te.isHeaders(t))
      for (const [s, l] of t.entries())
        a(l, s, n);
    else
      t != null && a(r, t, n);
    return this;
  }
  get(t, r) {
    if (t = Ui(t), t) {
      const n = te.findKey(this, t);
      if (n) {
        const o = this[n];
        if (!r)
          return o;
        if (r === !0)
          return kk(o);
        if (te.isFunction(r))
          return r.call(this, o, n);
        if (te.isRegExp(r))
          return r.exec(o);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, r) {
    if (t = Ui(t), t) {
      const n = te.findKey(this, t);
      return !!(n && this[n] !== void 0 && (!r || Bd(this, this[n], n, r)));
    }
    return !1;
  }
  delete(t, r) {
    const n = this;
    let o = !1;
    function a(i) {
      if (i = Ui(i), i) {
        const s = te.findKey(n, i);
        s && (!r || Bd(n, n[s], s, r)) && (delete n[s], o = !0);
      }
    }
    return te.isArray(t) ? t.forEach(a) : a(t), o;
  }
  clear(t) {
    const r = Object.keys(this);
    let n = r.length, o = !1;
    for (; n--; ) {
      const a = r[n];
      (!t || Bd(this, this[a], a, t, !0)) && (delete this[a], o = !0);
    }
    return o;
  }
  normalize(t) {
    const r = this, n = {};
    return te.forEach(this, (o, a) => {
      const i = te.findKey(n, a);
      if (i) {
        r[i] = ps(o), delete r[a];
        return;
      }
      const s = t ? Ik(a) : String(a).trim();
      s !== a && delete r[a], r[s] = ps(o), n[s] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const r = /* @__PURE__ */ Object.create(null);
    return te.forEach(this, (n, o) => {
      n != null && n !== !1 && (r[o] = t && te.isArray(n) ? n.join(", ") : n);
    }), r;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, r]) => t + ": " + r).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...r) {
    const n = new this(t);
    return r.forEach((o) => n.set(o)), n;
  }
  static accessor(t) {
    const n = (this[Ey] = this[Ey] = {
      accessors: {}
    }).accessors, o = this.prototype;
    function a(i) {
      const s = Ui(i);
      n[s] || (Dk(o, i), n[s] = !0);
    }
    return te.isArray(t) ? t.forEach(a) : a(t), this;
  }
};
ur.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
te.reduceDescriptors(ur.prototype, ({ value: e }, t) => {
  let r = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(n) {
      this[r] = n;
    }
  };
});
te.freezeMethods(ur);
function qd(e, t) {
  const r = this || ma, n = t || r, o = ur.from(n.headers);
  let a = n.data;
  return te.forEach(e, function(s) {
    a = s.call(r, a, o.normalize(), t ? t.status : void 0);
  }), o.normalize(), a;
}
function aw(e) {
  return !!(e && e.__CANCEL__);
}
function bi(e, t, r) {
  Be.call(this, e ?? "canceled", Be.ERR_CANCELED, t, r), this.name = "CanceledError";
}
te.inherits(bi, Be, {
  __CANCEL__: !0
});
function sw(e, t, r) {
  const n = r.config.validateStatus;
  !r.status || !n || n(r.status) ? e(r) : t(new Be(
    "Request failed with status code " + r.status,
    [Be.ERR_BAD_REQUEST, Be.ERR_BAD_RESPONSE][Math.floor(r.status / 100) - 4],
    r.config,
    r.request,
    r
  ));
}
function Rk(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function Mk(e, t) {
  e = e || 10;
  const r = new Array(e), n = new Array(e);
  let o = 0, a = 0, i;
  return t = t !== void 0 ? t : 1e3, function(l) {
    const u = Date.now(), c = n[a];
    i || (i = u), r[o] = l, n[o] = u;
    let d = a, h = 0;
    for (; d !== o; )
      h += r[d++], d = d % e;
    if (o = (o + 1) % e, o === a && (a = (a + 1) % e), u - i < t)
      return;
    const y = c && u - c;
    return y ? Math.round(h * 1e3 / y) : void 0;
  };
}
function Bk(e, t) {
  let r = 0, n = 1e3 / t, o, a;
  const i = (u, c = Date.now()) => {
    r = c, o = null, a && (clearTimeout(a), a = null), e.apply(null, u);
  };
  return [(...u) => {
    const c = Date.now(), d = c - r;
    d >= n ? i(u, c) : (o = u, a || (a = setTimeout(() => {
      a = null, i(o);
    }, n - d)));
  }, () => o && i(o)];
}
const Cs = (e, t, r = 3) => {
  let n = 0;
  const o = Mk(50, 250);
  return Bk((a) => {
    const i = a.loaded, s = a.lengthComputable ? a.total : void 0, l = i - n, u = o(l), c = i <= s;
    n = i;
    const d = {
      loaded: i,
      total: s,
      progress: s ? i / s : void 0,
      bytes: l,
      rate: u || void 0,
      estimated: u && s && c ? (s - i) / u : void 0,
      event: a,
      lengthComputable: s != null,
      [t ? "download" : "upload"]: !0
    };
    e(d);
  }, r);
}, Oy = (e, t) => {
  const r = e != null;
  return [(n) => t[0]({
    lengthComputable: r,
    total: e,
    loaded: n
  }), t[1]];
}, $y = (e) => (...t) => te.asap(() => e(...t)), qk = lr.hasStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function() {
    const t = lr.navigator && /(msie|trident)/i.test(lr.navigator.userAgent), r = document.createElement("a");
    let n;
    function o(a) {
      let i = a;
      return t && (r.setAttribute("href", i), i = r.href), r.setAttribute("href", i), {
        href: r.href,
        protocol: r.protocol ? r.protocol.replace(/:$/, "") : "",
        host: r.host,
        search: r.search ? r.search.replace(/^\?/, "") : "",
        hash: r.hash ? r.hash.replace(/^#/, "") : "",
        hostname: r.hostname,
        port: r.port,
        pathname: r.pathname.charAt(0) === "/" ? r.pathname : "/" + r.pathname
      };
    }
    return n = o(window.location.href), function(i) {
      const s = te.isString(i) ? o(i) : i;
      return s.protocol === n.protocol && s.host === n.host;
    };
  }()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  /* @__PURE__ */ function() {
    return function() {
      return !0;
    };
  }()
), Lk = lr.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, r, n, o, a) {
      const i = [e + "=" + encodeURIComponent(t)];
      te.isNumber(r) && i.push("expires=" + new Date(r).toGMTString()), te.isString(n) && i.push("path=" + n), te.isString(o) && i.push("domain=" + o), a === !0 && i.push("secure"), document.cookie = i.join("; ");
    },
    read(e) {
      const t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return t ? decodeURIComponent(t[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function Fk(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function Nk(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function lw(e, t) {
  return e && !Fk(t) ? Nk(e, t) : t;
}
const Cy = (e) => e instanceof ur ? { ...e } : e;
function $o(e, t) {
  t = t || {};
  const r = {};
  function n(u, c, d) {
    return te.isPlainObject(u) && te.isPlainObject(c) ? te.merge.call({ caseless: d }, u, c) : te.isPlainObject(c) ? te.merge({}, c) : te.isArray(c) ? c.slice() : c;
  }
  function o(u, c, d) {
    if (te.isUndefined(c)) {
      if (!te.isUndefined(u))
        return n(void 0, u, d);
    } else return n(u, c, d);
  }
  function a(u, c) {
    if (!te.isUndefined(c))
      return n(void 0, c);
  }
  function i(u, c) {
    if (te.isUndefined(c)) {
      if (!te.isUndefined(u))
        return n(void 0, u);
    } else return n(void 0, c);
  }
  function s(u, c, d) {
    if (d in t)
      return n(u, c);
    if (d in e)
      return n(void 0, u);
  }
  const l = {
    url: a,
    method: a,
    data: a,
    baseURL: i,
    transformRequest: i,
    transformResponse: i,
    paramsSerializer: i,
    timeout: i,
    timeoutMessage: i,
    withCredentials: i,
    withXSRFToken: i,
    adapter: i,
    responseType: i,
    xsrfCookieName: i,
    xsrfHeaderName: i,
    onUploadProgress: i,
    onDownloadProgress: i,
    decompress: i,
    maxContentLength: i,
    maxBodyLength: i,
    beforeRedirect: i,
    transport: i,
    httpAgent: i,
    httpsAgent: i,
    cancelToken: i,
    socketPath: i,
    responseEncoding: i,
    validateStatus: s,
    headers: (u, c) => o(Cy(u), Cy(c), !0)
  };
  return te.forEach(Object.keys(Object.assign({}, e, t)), function(c) {
    const d = l[c] || o, h = d(e[c], t[c], c);
    te.isUndefined(h) && d !== s || (r[c] = h);
  }), r;
}
const uw = (e) => {
  const t = $o({}, e);
  let { data: r, withXSRFToken: n, xsrfHeaderName: o, xsrfCookieName: a, headers: i, auth: s } = t;
  t.headers = i = ur.from(i), t.url = nw(lw(t.baseURL, t.url), e.params, e.paramsSerializer), s && i.set(
    "Authorization",
    "Basic " + btoa((s.username || "") + ":" + (s.password ? unescape(encodeURIComponent(s.password)) : ""))
  );
  let l;
  if (te.isFormData(r)) {
    if (lr.hasStandardBrowserEnv || lr.hasStandardBrowserWebWorkerEnv)
      i.setContentType(void 0);
    else if ((l = i.getContentType()) !== !1) {
      const [u, ...c] = l ? l.split(";").map((d) => d.trim()).filter(Boolean) : [];
      i.setContentType([u || "multipart/form-data", ...c].join("; "));
    }
  }
  if (lr.hasStandardBrowserEnv && (n && te.isFunction(n) && (n = n(t)), n || n !== !1 && qk(t.url))) {
    const u = o && a && Lk.read(a);
    u && i.set(o, u);
  }
  return t;
}, zk = typeof XMLHttpRequest < "u", jk = zk && function(e) {
  return new Promise(function(r, n) {
    const o = uw(e);
    let a = o.data;
    const i = ur.from(o.headers).normalize();
    let { responseType: s, onUploadProgress: l, onDownloadProgress: u } = o, c, d, h, y, m;
    function p() {
      y && y(), m && m(), o.cancelToken && o.cancelToken.unsubscribe(c), o.signal && o.signal.removeEventListener("abort", c);
    }
    let f = new XMLHttpRequest();
    f.open(o.method.toUpperCase(), o.url, !0), f.timeout = o.timeout;
    function v() {
      if (!f)
        return;
      const _ = ur.from(
        "getAllResponseHeaders" in f && f.getAllResponseHeaders()
      ), A = {
        data: !s || s === "text" || s === "json" ? f.responseText : f.response,
        status: f.status,
        statusText: f.statusText,
        headers: _,
        config: e,
        request: f
      };
      sw(function(M) {
        r(M), p();
      }, function(M) {
        n(M), p();
      }, A), f = null;
    }
    "onloadend" in f ? f.onloadend = v : f.onreadystatechange = function() {
      !f || f.readyState !== 4 || f.status === 0 && !(f.responseURL && f.responseURL.indexOf("file:") === 0) || setTimeout(v);
    }, f.onabort = function() {
      f && (n(new Be("Request aborted", Be.ECONNABORTED, e, f)), f = null);
    }, f.onerror = function() {
      n(new Be("Network Error", Be.ERR_NETWORK, e, f)), f = null;
    }, f.ontimeout = function() {
      let T = o.timeout ? "timeout of " + o.timeout + "ms exceeded" : "timeout exceeded";
      const A = o.transitional || ow;
      o.timeoutErrorMessage && (T = o.timeoutErrorMessage), n(new Be(
        T,
        A.clarifyTimeoutError ? Be.ETIMEDOUT : Be.ECONNABORTED,
        e,
        f
      )), f = null;
    }, a === void 0 && i.setContentType(null), "setRequestHeader" in f && te.forEach(i.toJSON(), function(T, A) {
      f.setRequestHeader(A, T);
    }), te.isUndefined(o.withCredentials) || (f.withCredentials = !!o.withCredentials), s && s !== "json" && (f.responseType = o.responseType), u && ([h, m] = Cs(u, !0), f.addEventListener("progress", h)), l && f.upload && ([d, y] = Cs(l), f.upload.addEventListener("progress", d), f.upload.addEventListener("loadend", y)), (o.cancelToken || o.signal) && (c = (_) => {
      f && (n(!_ || _.type ? new bi(null, e, f) : _), f.abort(), f = null);
    }, o.cancelToken && o.cancelToken.subscribe(c), o.signal && (o.signal.aborted ? c() : o.signal.addEventListener("abort", c)));
    const w = Rk(o.url);
    if (w && lr.protocols.indexOf(w) === -1) {
      n(new Be("Unsupported protocol " + w + ":", Be.ERR_BAD_REQUEST, e));
      return;
    }
    f.send(a || null);
  });
}, Uk = (e, t) => {
  const { length: r } = e = e ? e.filter(Boolean) : [];
  if (t || r) {
    let n = new AbortController(), o;
    const a = function(u) {
      if (!o) {
        o = !0, s();
        const c = u instanceof Error ? u : this.reason;
        n.abort(c instanceof Be ? c : new bi(c instanceof Error ? c.message : c));
      }
    };
    let i = t && setTimeout(() => {
      i = null, a(new Be(`timeout ${t} of ms exceeded`, Be.ETIMEDOUT));
    }, t);
    const s = () => {
      e && (i && clearTimeout(i), i = null, e.forEach((u) => {
        u.unsubscribe ? u.unsubscribe(a) : u.removeEventListener("abort", a);
      }), e = null);
    };
    e.forEach((u) => u.addEventListener("abort", a));
    const { signal: l } = n;
    return l.unsubscribe = () => te.asap(s), l;
  }
}, Wk = function* (e, t) {
  let r = e.byteLength;
  if (r < t) {
    yield e;
    return;
  }
  let n = 0, o;
  for (; n < r; )
    o = n + t, yield e.slice(n, o), n = o;
}, Vk = async function* (e, t) {
  for await (const r of Hk(e))
    yield* Wk(r, t);
}, Hk = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const t = e.getReader();
  try {
    for (; ; ) {
      const { done: r, value: n } = await t.read();
      if (r)
        break;
      yield n;
    }
  } finally {
    await t.cancel();
  }
}, ky = (e, t, r, n) => {
  const o = Vk(e, t);
  let a = 0, i, s = (l) => {
    i || (i = !0, n && n(l));
  };
  return new ReadableStream({
    async pull(l) {
      try {
        const { done: u, value: c } = await o.next();
        if (u) {
          s(), l.close();
          return;
        }
        let d = c.byteLength;
        if (r) {
          let h = a += d;
          r(h);
        }
        l.enqueue(new Uint8Array(c));
      } catch (u) {
        throw s(u), u;
      }
    },
    cancel(l) {
      return s(l), o.return();
    }
  }, {
    highWaterMark: 2
  });
}, nl = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", cw = nl && typeof ReadableStream == "function", Gk = nl && (typeof TextEncoder == "function" ? /* @__PURE__ */ ((e) => (t) => e.encode(t))(new TextEncoder()) : async (e) => new Uint8Array(await new Response(e).arrayBuffer())), dw = (e, ...t) => {
  try {
    return !!e(...t);
  } catch {
    return !1;
  }
}, Kk = cw && dw(() => {
  let e = !1;
  const t = new Request(lr.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      return e = !0, "half";
    }
  }).headers.has("Content-Type");
  return e && !t;
}), Py = 64 * 1024, Xf = cw && dw(() => te.isReadableStream(new Response("").body)), ks = {
  stream: Xf && ((e) => e.body)
};
nl && ((e) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((t) => {
    !ks[t] && (ks[t] = te.isFunction(e[t]) ? (r) => r[t]() : (r, n) => {
      throw new Be(`Response type '${t}' is not supported`, Be.ERR_NOT_SUPPORT, n);
    });
  });
})(new Response());
const Yk = async (e) => {
  if (e == null)
    return 0;
  if (te.isBlob(e))
    return e.size;
  if (te.isSpecCompliantForm(e))
    return (await new Request(lr.origin, {
      method: "POST",
      body: e
    }).arrayBuffer()).byteLength;
  if (te.isArrayBufferView(e) || te.isArrayBuffer(e))
    return e.byteLength;
  if (te.isURLSearchParams(e) && (e = e + ""), te.isString(e))
    return (await Gk(e)).byteLength;
}, Jk = async (e, t) => {
  const r = te.toFiniteNumber(e.getContentLength());
  return r ?? Yk(t);
}, Zk = nl && (async (e) => {
  let {
    url: t,
    method: r,
    data: n,
    signal: o,
    cancelToken: a,
    timeout: i,
    onDownloadProgress: s,
    onUploadProgress: l,
    responseType: u,
    headers: c,
    withCredentials: d = "same-origin",
    fetchOptions: h
  } = uw(e);
  u = u ? (u + "").toLowerCase() : "text";
  let y = Uk([o, a && a.toAbortSignal()], i), m;
  const p = y && y.unsubscribe && (() => {
    y.unsubscribe();
  });
  let f;
  try {
    if (l && Kk && r !== "get" && r !== "head" && (f = await Jk(c, n)) !== 0) {
      let A = new Request(t, {
        method: "POST",
        body: n,
        duplex: "half"
      }), O;
      if (te.isFormData(n) && (O = A.headers.get("content-type")) && c.setContentType(O), A.body) {
        const [M, I] = Oy(
          f,
          Cs($y(l))
        );
        n = ky(A.body, Py, M, I);
      }
    }
    te.isString(d) || (d = d ? "include" : "omit");
    const v = "credentials" in Request.prototype;
    m = new Request(t, {
      ...h,
      signal: y,
      method: r.toUpperCase(),
      headers: c.normalize().toJSON(),
      body: n,
      duplex: "half",
      credentials: v ? d : void 0
    });
    let w = await fetch(m);
    const _ = Xf && (u === "stream" || u === "response");
    if (Xf && (s || _ && p)) {
      const A = {};
      ["status", "statusText", "headers"].forEach((C) => {
        A[C] = w[C];
      });
      const O = te.toFiniteNumber(w.headers.get("content-length")), [M, I] = s && Oy(
        O,
        Cs($y(s), !0)
      ) || [];
      w = new Response(
        ky(w.body, Py, M, () => {
          I && I(), p && p();
        }),
        A
      );
    }
    u = u || "text";
    let T = await ks[te.findKey(ks, u) || "text"](w, e);
    return !_ && p && p(), await new Promise((A, O) => {
      sw(A, O, {
        data: T,
        headers: ur.from(w.headers),
        status: w.status,
        statusText: w.statusText,
        config: e,
        request: m
      });
    });
  } catch (v) {
    throw p && p(), v && v.name === "TypeError" && /fetch/i.test(v.message) ? Object.assign(
      new Be("Network Error", Be.ERR_NETWORK, e, m),
      {
        cause: v.cause || v
      }
    ) : Be.from(v, v && v.code, e, m);
  }
}), Qf = {
  http: fk,
  xhr: jk,
  fetch: Zk
};
te.forEach(Qf, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const Iy = (e) => `- ${e}`, Xk = (e) => te.isFunction(e) || e === null || e === !1, fw = {
  getAdapter: (e) => {
    e = te.isArray(e) ? e : [e];
    const { length: t } = e;
    let r, n;
    const o = {};
    for (let a = 0; a < t; a++) {
      r = e[a];
      let i;
      if (n = r, !Xk(r) && (n = Qf[(i = String(r)).toLowerCase()], n === void 0))
        throw new Be(`Unknown adapter '${i}'`);
      if (n)
        break;
      o[i || "#" + a] = n;
    }
    if (!n) {
      const a = Object.entries(o).map(
        ([s, l]) => `adapter ${s} ` + (l === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let i = t ? a.length > 1 ? `since :
` + a.map(Iy).join(`
`) : " " + Iy(a[0]) : "as no adapter specified";
      throw new Be(
        "There is no suitable adapter to dispatch the request " + i,
        "ERR_NOT_SUPPORT"
      );
    }
    return n;
  },
  adapters: Qf
};
function Ld(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new bi(null, e);
}
function Dy(e) {
  return Ld(e), e.headers = ur.from(e.headers), e.data = qd.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), fw.getAdapter(e.adapter || ma.adapter)(e).then(function(n) {
    return Ld(e), n.data = qd.call(
      e,
      e.transformResponse,
      n
    ), n.headers = ur.from(n.headers), n;
  }, function(n) {
    return aw(n) || (Ld(e), n && n.response && (n.response.data = qd.call(
      e,
      e.transformResponse,
      n.response
    ), n.response.headers = ur.from(n.response.headers))), Promise.reject(n);
  });
}
const pw = "1.7.7", Wp = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  Wp[e] = function(n) {
    return typeof n === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const Ry = {};
Wp.transitional = function(t, r, n) {
  function o(a, i) {
    return "[Axios v" + pw + "] Transitional option '" + a + "'" + i + (n ? ". " + n : "");
  }
  return (a, i, s) => {
    if (t === !1)
      throw new Be(
        o(i, " has been removed" + (r ? " in " + r : "")),
        Be.ERR_DEPRECATED
      );
    return r && !Ry[i] && (Ry[i] = !0, console.warn(
      o(
        i,
        " has been deprecated since v" + r + " and will be removed in the near future"
      )
    )), t ? t(a, i, s) : !0;
  };
};
function Qk(e, t, r) {
  if (typeof e != "object")
    throw new Be("options must be an object", Be.ERR_BAD_OPTION_VALUE);
  const n = Object.keys(e);
  let o = n.length;
  for (; o-- > 0; ) {
    const a = n[o], i = t[a];
    if (i) {
      const s = e[a], l = s === void 0 || i(s, a, e);
      if (l !== !0)
        throw new Be("option " + a + " must be " + l, Be.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (r !== !0)
      throw new Be("Unknown option " + a, Be.ERR_BAD_OPTION);
  }
}
const ep = {
  assertOptions: Qk,
  validators: Wp
}, Vn = ep.validators;
let To = class {
  constructor(t) {
    this.defaults = t, this.interceptors = {
      request: new Ty(),
      response: new Ty()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(t, r) {
    try {
      return await this._request(t, r);
    } catch (n) {
      if (n instanceof Error) {
        let o;
        Error.captureStackTrace ? Error.captureStackTrace(o = {}) : o = new Error();
        const a = o.stack ? o.stack.replace(/^.+\n/, "") : "";
        try {
          n.stack ? a && !String(n.stack).endsWith(a.replace(/^.+\n.+\n/, "")) && (n.stack += `
` + a) : n.stack = a;
        } catch {
        }
      }
      throw n;
    }
  }
  _request(t, r) {
    typeof t == "string" ? (r = r || {}, r.url = t) : r = t || {}, r = $o(this.defaults, r);
    const { transitional: n, paramsSerializer: o, headers: a } = r;
    n !== void 0 && ep.assertOptions(n, {
      silentJSONParsing: Vn.transitional(Vn.boolean),
      forcedJSONParsing: Vn.transitional(Vn.boolean),
      clarifyTimeoutError: Vn.transitional(Vn.boolean)
    }, !1), o != null && (te.isFunction(o) ? r.paramsSerializer = {
      serialize: o
    } : ep.assertOptions(o, {
      encode: Vn.function,
      serialize: Vn.function
    }, !0)), r.method = (r.method || this.defaults.method || "get").toLowerCase();
    let i = a && te.merge(
      a.common,
      a[r.method]
    );
    a && te.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (m) => {
        delete a[m];
      }
    ), r.headers = ur.concat(i, a);
    const s = [];
    let l = !0;
    this.interceptors.request.forEach(function(p) {
      typeof p.runWhen == "function" && p.runWhen(r) === !1 || (l = l && p.synchronous, s.unshift(p.fulfilled, p.rejected));
    });
    const u = [];
    this.interceptors.response.forEach(function(p) {
      u.push(p.fulfilled, p.rejected);
    });
    let c, d = 0, h;
    if (!l) {
      const m = [Dy.bind(this), void 0];
      for (m.unshift.apply(m, s), m.push.apply(m, u), h = m.length, c = Promise.resolve(r); d < h; )
        c = c.then(m[d++], m[d++]);
      return c;
    }
    h = s.length;
    let y = r;
    for (d = 0; d < h; ) {
      const m = s[d++], p = s[d++];
      try {
        y = m(y);
      } catch (f) {
        p.call(this, f);
        break;
      }
    }
    try {
      c = Dy.call(this, y);
    } catch (m) {
      return Promise.reject(m);
    }
    for (d = 0, h = u.length; d < h; )
      c = c.then(u[d++], u[d++]);
    return c;
  }
  getUri(t) {
    t = $o(this.defaults, t);
    const r = lw(t.baseURL, t.url);
    return nw(r, t.params, t.paramsSerializer);
  }
};
te.forEach(["delete", "get", "head", "options"], function(t) {
  To.prototype[t] = function(r, n) {
    return this.request($o(n || {}, {
      method: t,
      url: r,
      data: (n || {}).data
    }));
  };
});
te.forEach(["post", "put", "patch"], function(t) {
  function r(n) {
    return function(a, i, s) {
      return this.request($o(s || {}, {
        method: t,
        headers: n ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: a,
        data: i
      }));
    };
  }
  To.prototype[t] = r(), To.prototype[t + "Form"] = r(!0);
});
let e3 = class hw {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let r;
    this.promise = new Promise(function(a) {
      r = a;
    });
    const n = this;
    this.promise.then((o) => {
      if (!n._listeners) return;
      let a = n._listeners.length;
      for (; a-- > 0; )
        n._listeners[a](o);
      n._listeners = null;
    }), this.promise.then = (o) => {
      let a;
      const i = new Promise((s) => {
        n.subscribe(s), a = s;
      }).then(o);
      return i.cancel = function() {
        n.unsubscribe(a);
      }, i;
    }, t(function(a, i, s) {
      n.reason || (n.reason = new bi(a, i, s), r(n.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const r = this._listeners.indexOf(t);
    r !== -1 && this._listeners.splice(r, 1);
  }
  toAbortSignal() {
    const t = new AbortController(), r = (n) => {
      t.abort(n);
    };
    return this.subscribe(r), t.signal.unsubscribe = () => this.unsubscribe(r), t.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new hw(function(o) {
        t = o;
      }),
      cancel: t
    };
  }
};
function t3(e) {
  return function(r) {
    return e.apply(null, r);
  };
}
function r3(e) {
  return te.isObject(e) && e.isAxiosError === !0;
}
const tp = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(tp).forEach(([e, t]) => {
  tp[t] = e;
});
function mw(e) {
  const t = new To(e), r = V1(To.prototype.request, t);
  return te.extend(r, To.prototype, t, { allOwnKeys: !0 }), te.extend(r, t, null, { allOwnKeys: !0 }), r.create = function(o) {
    return mw($o(e, o));
  }, r;
}
const mt = mw(ma);
mt.Axios = To;
mt.CanceledError = bi;
mt.CancelToken = e3;
mt.isCancel = aw;
mt.VERSION = pw;
mt.toFormData = rl;
mt.AxiosError = Be;
mt.Cancel = mt.CanceledError;
mt.all = function(t) {
  return Promise.all(t);
};
mt.spread = t3;
mt.isAxiosError = r3;
mt.mergeConfig = $o;
mt.AxiosHeaders = ur;
mt.formToJSON = (e) => iw(te.isHTMLForm(e) ? new FormData(e) : e);
mt.getAdapter = fw.getAdapter;
mt.HttpStatusCode = tp;
mt.default = mt;
const {
  Axios: uR,
  AxiosError: cR,
  CanceledError: dR,
  isCancel: fR,
  CancelToken: pR,
  VERSION: hR,
  all: mR,
  Cancel: vR,
  isAxiosError: gR,
  spread: yR,
  toFormData: bR,
  AxiosHeaders: wR,
  HttpStatusCode: _R,
  formToJSON: SR,
  getAdapter: xR,
  mergeConfig: AR
} = mt;
var Fd, My;
function n3() {
  if (My) return Fd;
  My = 1;
  var e = function(w) {
    return t(w) && !r(w);
  };
  function t(v) {
    return !!v && typeof v == "object";
  }
  function r(v) {
    var w = Object.prototype.toString.call(v);
    return w === "[object RegExp]" || w === "[object Date]" || a(v);
  }
  var n = typeof Symbol == "function" && Symbol.for, o = n ? Symbol.for("react.element") : 60103;
  function a(v) {
    return v.$$typeof === o;
  }
  function i(v) {
    return Array.isArray(v) ? [] : {};
  }
  function s(v, w) {
    return w.clone !== !1 && w.isMergeableObject(v) ? p(i(v), v, w) : v;
  }
  function l(v, w, _) {
    return v.concat(w).map(function(T) {
      return s(T, _);
    });
  }
  function u(v, w) {
    if (!w.customMerge)
      return p;
    var _ = w.customMerge(v);
    return typeof _ == "function" ? _ : p;
  }
  function c(v) {
    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(v).filter(function(w) {
      return Object.propertyIsEnumerable.call(v, w);
    }) : [];
  }
  function d(v) {
    return Object.keys(v).concat(c(v));
  }
  function h(v, w) {
    try {
      return w in v;
    } catch {
      return !1;
    }
  }
  function y(v, w) {
    return h(v, w) && !(Object.hasOwnProperty.call(v, w) && Object.propertyIsEnumerable.call(v, w));
  }
  function m(v, w, _) {
    var T = {};
    return _.isMergeableObject(v) && d(v).forEach(function(A) {
      T[A] = s(v[A], _);
    }), d(w).forEach(function(A) {
      y(v, A) || (h(v, A) && _.isMergeableObject(w[A]) ? T[A] = u(A, _)(v[A], w[A], _) : T[A] = s(w[A], _));
    }), T;
  }
  function p(v, w, _) {
    _ = _ || {}, _.arrayMerge = _.arrayMerge || l, _.isMergeableObject = _.isMergeableObject || e, _.cloneUnlessOtherwiseSpecified = s;
    var T = Array.isArray(w), A = Array.isArray(v), O = T === A;
    return O ? T ? _.arrayMerge(v, w, _) : m(v, w, _) : s(w, _);
  }
  p.all = function(w, _) {
    if (!Array.isArray(w))
      throw new Error("first argument should be an array");
    return w.reduce(function(T, A) {
      return p(T, A, _);
    }, {});
  };
  var f = p;
  return Fd = f, Fd;
}
var o3 = n3();
const i3 = /* @__PURE__ */ ui(o3);
var Nd, By;
function a3() {
  return By || (By = 1, Nd = Error), Nd;
}
var zd, qy;
function s3() {
  return qy || (qy = 1, zd = EvalError), zd;
}
var jd, Ly;
function l3() {
  return Ly || (Ly = 1, jd = RangeError), jd;
}
var Ud, Fy;
function u3() {
  return Fy || (Fy = 1, Ud = ReferenceError), Ud;
}
var Wd, Ny;
function vw() {
  return Ny || (Ny = 1, Wd = SyntaxError), Wd;
}
var Vd, zy;
function va() {
  return zy || (zy = 1, Vd = TypeError), Vd;
}
var Hd, jy;
function c3() {
  return jy || (jy = 1, Hd = URIError), Hd;
}
var Gd, Uy;
function d3() {
  return Uy || (Uy = 1, Gd = function() {
    if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
      return !1;
    if (typeof Symbol.iterator == "symbol")
      return !0;
    var t = {}, r = Symbol("test"), n = Object(r);
    if (typeof r == "string" || Object.prototype.toString.call(r) !== "[object Symbol]" || Object.prototype.toString.call(n) !== "[object Symbol]")
      return !1;
    var o = 42;
    t[r] = o;
    for (r in t)
      return !1;
    if (typeof Object.keys == "function" && Object.keys(t).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(t).length !== 0)
      return !1;
    var a = Object.getOwnPropertySymbols(t);
    if (a.length !== 1 || a[0] !== r || !Object.prototype.propertyIsEnumerable.call(t, r))
      return !1;
    if (typeof Object.getOwnPropertyDescriptor == "function") {
      var i = Object.getOwnPropertyDescriptor(t, r);
      if (i.value !== o || i.enumerable !== !0)
        return !1;
    }
    return !0;
  }), Gd;
}
var Kd, Wy;
function f3() {
  if (Wy) return Kd;
  Wy = 1;
  var e = typeof Symbol < "u" && Symbol, t = d3();
  return Kd = function() {
    return typeof e != "function" || typeof Symbol != "function" || typeof e("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : t();
  }, Kd;
}
var Yd, Vy;
function p3() {
  if (Vy) return Yd;
  Vy = 1;
  var e = {
    __proto__: null,
    foo: {}
  }, t = Object;
  return Yd = function() {
    return { __proto__: e }.foo === e.foo && !(e instanceof t);
  }, Yd;
}
var Jd, Hy;
function h3() {
  if (Hy) return Jd;
  Hy = 1;
  var e = "Function.prototype.bind called on incompatible ", t = Object.prototype.toString, r = Math.max, n = "[object Function]", o = function(l, u) {
    for (var c = [], d = 0; d < l.length; d += 1)
      c[d] = l[d];
    for (var h = 0; h < u.length; h += 1)
      c[h + l.length] = u[h];
    return c;
  }, a = function(l, u) {
    for (var c = [], d = u, h = 0; d < l.length; d += 1, h += 1)
      c[h] = l[d];
    return c;
  }, i = function(s, l) {
    for (var u = "", c = 0; c < s.length; c += 1)
      u += s[c], c + 1 < s.length && (u += l);
    return u;
  };
  return Jd = function(l) {
    var u = this;
    if (typeof u != "function" || t.apply(u) !== n)
      throw new TypeError(e + u);
    for (var c = a(arguments, 1), d, h = function() {
      if (this instanceof d) {
        var v = u.apply(
          this,
          o(c, arguments)
        );
        return Object(v) === v ? v : this;
      }
      return u.apply(
        l,
        o(c, arguments)
      );
    }, y = r(0, u.length - c.length), m = [], p = 0; p < y; p++)
      m[p] = "$" + p;
    if (d = Function("binder", "return function (" + i(m, ",") + "){ return binder.apply(this,arguments); }")(h), u.prototype) {
      var f = function() {
      };
      f.prototype = u.prototype, d.prototype = new f(), f.prototype = null;
    }
    return d;
  }, Jd;
}
var Zd, Gy;
function Vp() {
  if (Gy) return Zd;
  Gy = 1;
  var e = h3();
  return Zd = Function.prototype.bind || e, Zd;
}
var Xd, Ky;
function m3() {
  if (Ky) return Xd;
  Ky = 1;
  var e = Function.prototype.call, t = Object.prototype.hasOwnProperty, r = Vp();
  return Xd = r.call(e, t), Xd;
}
var Qd, Yy;
function wi() {
  if (Yy) return Qd;
  Yy = 1;
  var e, t = /* @__PURE__ */ a3(), r = /* @__PURE__ */ s3(), n = /* @__PURE__ */ l3(), o = /* @__PURE__ */ u3(), a = /* @__PURE__ */ vw(), i = /* @__PURE__ */ va(), s = /* @__PURE__ */ c3(), l = Function, u = function(j) {
    try {
      return l('"use strict"; return (' + j + ").constructor;")();
    } catch {
    }
  }, c = Object.getOwnPropertyDescriptor;
  if (c)
    try {
      c({}, "");
    } catch {
      c = null;
    }
  var d = function() {
    throw new i();
  }, h = c ? function() {
    try {
      return arguments.callee, d;
    } catch {
      try {
        return c(arguments, "callee").get;
      } catch {
        return d;
      }
    }
  }() : d, y = f3()(), m = /* @__PURE__ */ p3()(), p = Object.getPrototypeOf || (m ? function(j) {
    return j.__proto__;
  } : null), f = {}, v = typeof Uint8Array > "u" || !p ? e : p(Uint8Array), w = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError > "u" ? e : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer > "u" ? e : ArrayBuffer,
    "%ArrayIteratorPrototype%": y && p ? p([][Symbol.iterator]()) : e,
    "%AsyncFromSyncIteratorPrototype%": e,
    "%AsyncFunction%": f,
    "%AsyncGenerator%": f,
    "%AsyncGeneratorFunction%": f,
    "%AsyncIteratorPrototype%": f,
    "%Atomics%": typeof Atomics > "u" ? e : Atomics,
    "%BigInt%": typeof BigInt > "u" ? e : BigInt,
    "%BigInt64Array%": typeof BigInt64Array > "u" ? e : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array > "u" ? e : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView > "u" ? e : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": t,
    "%eval%": eval,
    // eslint-disable-line no-eval
    "%EvalError%": r,
    "%Float32Array%": typeof Float32Array > "u" ? e : Float32Array,
    "%Float64Array%": typeof Float64Array > "u" ? e : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? e : FinalizationRegistry,
    "%Function%": l,
    "%GeneratorFunction%": f,
    "%Int8Array%": typeof Int8Array > "u" ? e : Int8Array,
    "%Int16Array%": typeof Int16Array > "u" ? e : Int16Array,
    "%Int32Array%": typeof Int32Array > "u" ? e : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": y && p ? p(p([][Symbol.iterator]())) : e,
    "%JSON%": typeof JSON == "object" ? JSON : e,
    "%Map%": typeof Map > "u" ? e : Map,
    "%MapIteratorPrototype%": typeof Map > "u" || !y || !p ? e : p((/* @__PURE__ */ new Map())[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise > "u" ? e : Promise,
    "%Proxy%": typeof Proxy > "u" ? e : Proxy,
    "%RangeError%": n,
    "%ReferenceError%": o,
    "%Reflect%": typeof Reflect > "u" ? e : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set > "u" ? e : Set,
    "%SetIteratorPrototype%": typeof Set > "u" || !y || !p ? e : p((/* @__PURE__ */ new Set())[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? e : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": y && p ? p(""[Symbol.iterator]()) : e,
    "%Symbol%": y ? Symbol : e,
    "%SyntaxError%": a,
    "%ThrowTypeError%": h,
    "%TypedArray%": v,
    "%TypeError%": i,
    "%Uint8Array%": typeof Uint8Array > "u" ? e : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? e : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array > "u" ? e : Uint16Array,
    "%Uint32Array%": typeof Uint32Array > "u" ? e : Uint32Array,
    "%URIError%": s,
    "%WeakMap%": typeof WeakMap > "u" ? e : WeakMap,
    "%WeakRef%": typeof WeakRef > "u" ? e : WeakRef,
    "%WeakSet%": typeof WeakSet > "u" ? e : WeakSet
  };
  if (p)
    try {
      null.error;
    } catch (j) {
      var _ = p(p(j));
      w["%Error.prototype%"] = _;
    }
  var T = function j(D) {
    var H;
    if (D === "%AsyncFunction%")
      H = u("async function () {}");
    else if (D === "%GeneratorFunction%")
      H = u("function* () {}");
    else if (D === "%AsyncGeneratorFunction%")
      H = u("async function* () {}");
    else if (D === "%AsyncGenerator%") {
      var W = j("%AsyncGeneratorFunction%");
      W && (H = W.prototype);
    } else if (D === "%AsyncIteratorPrototype%") {
      var ee = j("%AsyncGenerator%");
      ee && p && (H = p(ee.prototype));
    }
    return w[D] = H, H;
  }, A = {
    __proto__: null,
    "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
    "%ArrayPrototype%": ["Array", "prototype"],
    "%ArrayProto_entries%": ["Array", "prototype", "entries"],
    "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
    "%ArrayProto_keys%": ["Array", "prototype", "keys"],
    "%ArrayProto_values%": ["Array", "prototype", "values"],
    "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
    "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
    "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
    "%BooleanPrototype%": ["Boolean", "prototype"],
    "%DataViewPrototype%": ["DataView", "prototype"],
    "%DatePrototype%": ["Date", "prototype"],
    "%ErrorPrototype%": ["Error", "prototype"],
    "%EvalErrorPrototype%": ["EvalError", "prototype"],
    "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
    "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
    "%FunctionPrototype%": ["Function", "prototype"],
    "%Generator%": ["GeneratorFunction", "prototype"],
    "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
    "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
    "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
    "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
    "%JSONParse%": ["JSON", "parse"],
    "%JSONStringify%": ["JSON", "stringify"],
    "%MapPrototype%": ["Map", "prototype"],
    "%NumberPrototype%": ["Number", "prototype"],
    "%ObjectPrototype%": ["Object", "prototype"],
    "%ObjProto_toString%": ["Object", "prototype", "toString"],
    "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
    "%PromisePrototype%": ["Promise", "prototype"],
    "%PromiseProto_then%": ["Promise", "prototype", "then"],
    "%Promise_all%": ["Promise", "all"],
    "%Promise_reject%": ["Promise", "reject"],
    "%Promise_resolve%": ["Promise", "resolve"],
    "%RangeErrorPrototype%": ["RangeError", "prototype"],
    "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
    "%RegExpPrototype%": ["RegExp", "prototype"],
    "%SetPrototype%": ["Set", "prototype"],
    "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
    "%StringPrototype%": ["String", "prototype"],
    "%SymbolPrototype%": ["Symbol", "prototype"],
    "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
    "%TypedArrayPrototype%": ["TypedArray", "prototype"],
    "%TypeErrorPrototype%": ["TypeError", "prototype"],
    "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
    "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
    "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
    "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
    "%URIErrorPrototype%": ["URIError", "prototype"],
    "%WeakMapPrototype%": ["WeakMap", "prototype"],
    "%WeakSetPrototype%": ["WeakSet", "prototype"]
  }, O = Vp(), M = /* @__PURE__ */ m3(), I = O.call(Function.call, Array.prototype.concat), C = O.call(Function.apply, Array.prototype.splice), E = O.call(Function.call, String.prototype.replace), R = O.call(Function.call, String.prototype.slice), k = O.call(Function.call, RegExp.prototype.exec), L = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, z = /\\(\\)?/g, F = function(D) {
    var H = R(D, 0, 1), W = R(D, -1);
    if (H === "%" && W !== "%")
      throw new a("invalid intrinsic syntax, expected closing `%`");
    if (W === "%" && H !== "%")
      throw new a("invalid intrinsic syntax, expected opening `%`");
    var ee = [];
    return E(D, L, function(oe, J, N, Q) {
      ee[ee.length] = N ? E(Q, z, "$1") : J || oe;
    }), ee;
  }, q = function(D, H) {
    var W = D, ee;
    if (M(A, W) && (ee = A[W], W = "%" + ee[0] + "%"), M(w, W)) {
      var oe = w[W];
      if (oe === f && (oe = T(W)), typeof oe > "u" && !H)
        throw new i("intrinsic " + D + " exists, but is not available. Please file an issue!");
      return {
        alias: ee,
        name: W,
        value: oe
      };
    }
    throw new a("intrinsic " + D + " does not exist!");
  };
  return Qd = function(D, H) {
    if (typeof D != "string" || D.length === 0)
      throw new i("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof H != "boolean")
      throw new i('"allowMissing" argument must be a boolean');
    if (k(/^%?[^%]*%?$/, D) === null)
      throw new a("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var W = F(D), ee = W.length > 0 ? W[0] : "", oe = q("%" + ee + "%", H), J = oe.name, N = oe.value, Q = !1, de = oe.alias;
    de && (ee = de[0], C(W, I([0, 1], de)));
    for (var G = 1, ce = !0; G < W.length; G += 1) {
      var be = W[G], ve = R(be, 0, 1), fe = R(be, -1);
      if ((ve === '"' || ve === "'" || ve === "`" || fe === '"' || fe === "'" || fe === "`") && ve !== fe)
        throw new a("property names with quotes must have matching quotes");
      if ((be === "constructor" || !ce) && (Q = !0), ee += "." + be, J = "%" + ee + "%", M(w, J))
        N = w[J];
      else if (N != null) {
        if (!(be in N)) {
          if (!H)
            throw new i("base intrinsic for " + D + " exists, but the property is not available.");
          return;
        }
        if (c && G + 1 >= W.length) {
          var Oe = c(N, be);
          ce = !!Oe, ce && "get" in Oe && !("originalValue" in Oe.get) ? N = Oe.get : N = N[be];
        } else
          ce = M(N, be), N = N[be];
        ce && !Q && (w[J] = N);
      }
    }
    return N;
  }, Qd;
}
var ef = { exports: {} }, tf, Jy;
function Hp() {
  if (Jy) return tf;
  Jy = 1;
  var e = /* @__PURE__ */ wi(), t = e("%Object.defineProperty%", !0) || !1;
  if (t)
    try {
      t({}, "a", { value: 1 });
    } catch {
      t = !1;
    }
  return tf = t, tf;
}
var rf, Zy;
function gw() {
  if (Zy) return rf;
  Zy = 1;
  var e = /* @__PURE__ */ wi(), t = e("%Object.getOwnPropertyDescriptor%", !0);
  if (t)
    try {
      t([], "length");
    } catch {
      t = null;
    }
  return rf = t, rf;
}
var nf, Xy;
function v3() {
  if (Xy) return nf;
  Xy = 1;
  var e = /* @__PURE__ */ Hp(), t = /* @__PURE__ */ vw(), r = /* @__PURE__ */ va(), n = /* @__PURE__ */ gw();
  return nf = function(a, i, s) {
    if (!a || typeof a != "object" && typeof a != "function")
      throw new r("`obj` must be an object or a function`");
    if (typeof i != "string" && typeof i != "symbol")
      throw new r("`property` must be a string or a symbol`");
    if (arguments.length > 3 && typeof arguments[3] != "boolean" && arguments[3] !== null)
      throw new r("`nonEnumerable`, if provided, must be a boolean or null");
    if (arguments.length > 4 && typeof arguments[4] != "boolean" && arguments[4] !== null)
      throw new r("`nonWritable`, if provided, must be a boolean or null");
    if (arguments.length > 5 && typeof arguments[5] != "boolean" && arguments[5] !== null)
      throw new r("`nonConfigurable`, if provided, must be a boolean or null");
    if (arguments.length > 6 && typeof arguments[6] != "boolean")
      throw new r("`loose`, if provided, must be a boolean");
    var l = arguments.length > 3 ? arguments[3] : null, u = arguments.length > 4 ? arguments[4] : null, c = arguments.length > 5 ? arguments[5] : null, d = arguments.length > 6 ? arguments[6] : !1, h = !!n && n(a, i);
    if (e)
      e(a, i, {
        configurable: c === null && h ? h.configurable : !c,
        enumerable: l === null && h ? h.enumerable : !l,
        value: s,
        writable: u === null && h ? h.writable : !u
      });
    else if (d || !l && !u && !c)
      a[i] = s;
    else
      throw new t("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
  }, nf;
}
var of, Qy;
function g3() {
  if (Qy) return of;
  Qy = 1;
  var e = /* @__PURE__ */ Hp(), t = function() {
    return !!e;
  };
  return t.hasArrayLengthDefineBug = function() {
    if (!e)
      return null;
    try {
      return e([], "length", { value: 1 }).length !== 1;
    } catch {
      return !0;
    }
  }, of = t, of;
}
var af, e0;
function y3() {
  if (e0) return af;
  e0 = 1;
  var e = /* @__PURE__ */ wi(), t = /* @__PURE__ */ v3(), r = /* @__PURE__ */ g3()(), n = /* @__PURE__ */ gw(), o = /* @__PURE__ */ va(), a = e("%Math.floor%");
  return af = function(s, l) {
    if (typeof s != "function")
      throw new o("`fn` is not a function");
    if (typeof l != "number" || l < 0 || l > 4294967295 || a(l) !== l)
      throw new o("`length` must be a positive 32-bit integer");
    var u = arguments.length > 2 && !!arguments[2], c = !0, d = !0;
    if ("length" in s && n) {
      var h = n(s, "length");
      h && !h.configurable && (c = !1), h && !h.writable && (d = !1);
    }
    return (c || d || !u) && (r ? t(
      /** @type {Parameters<define>[0]} */
      s,
      "length",
      l,
      !0,
      !0
    ) : t(
      /** @type {Parameters<define>[0]} */
      s,
      "length",
      l
    )), s;
  }, af;
}
var t0;
function b3() {
  return t0 || (t0 = 1, function(e) {
    var t = Vp(), r = /* @__PURE__ */ wi(), n = /* @__PURE__ */ y3(), o = /* @__PURE__ */ va(), a = r("%Function.prototype.apply%"), i = r("%Function.prototype.call%"), s = r("%Reflect.apply%", !0) || t.call(i, a), l = /* @__PURE__ */ Hp(), u = r("%Math.max%");
    e.exports = function(h) {
      if (typeof h != "function")
        throw new o("a function is required");
      var y = s(t, i, arguments);
      return n(
        y,
        1 + u(0, h.length - (arguments.length - 1)),
        !0
      );
    };
    var c = function() {
      return s(t, a, arguments);
    };
    l ? l(e.exports, "apply", { value: c }) : e.exports.apply = c;
  }(ef)), ef.exports;
}
var sf, r0;
function w3() {
  if (r0) return sf;
  r0 = 1;
  var e = /* @__PURE__ */ wi(), t = b3(), r = t(e("String.prototype.indexOf"));
  return sf = function(o, a) {
    var i = e(o, !!a);
    return typeof i == "function" && r(o, ".prototype.") > -1 ? t(i) : i;
  }, sf;
}
const _3 = {}, S3 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _3
}, Symbol.toStringTag, { value: "Module" })), x3 = /* @__PURE__ */ r_(S3);
var lf, n0;
function A3() {
  if (n0) return lf;
  n0 = 1;
  var e = typeof Map == "function" && Map.prototype, t = Object.getOwnPropertyDescriptor && e ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null, r = e && t && typeof t.get == "function" ? t.get : null, n = e && Map.prototype.forEach, o = typeof Set == "function" && Set.prototype, a = Object.getOwnPropertyDescriptor && o ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null, i = o && a && typeof a.get == "function" ? a.get : null, s = o && Set.prototype.forEach, l = typeof WeakMap == "function" && WeakMap.prototype, u = l ? WeakMap.prototype.has : null, c = typeof WeakSet == "function" && WeakSet.prototype, d = c ? WeakSet.prototype.has : null, h = typeof WeakRef == "function" && WeakRef.prototype, y = h ? WeakRef.prototype.deref : null, m = Boolean.prototype.valueOf, p = Object.prototype.toString, f = Function.prototype.toString, v = String.prototype.match, w = String.prototype.slice, _ = String.prototype.replace, T = String.prototype.toUpperCase, A = String.prototype.toLowerCase, O = RegExp.prototype.test, M = Array.prototype.concat, I = Array.prototype.join, C = Array.prototype.slice, E = Math.floor, R = typeof BigInt == "function" ? BigInt.prototype.valueOf : null, k = Object.getOwnPropertySymbols, L = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Symbol.prototype.toString : null, z = typeof Symbol == "function" && typeof Symbol.iterator == "object", F = typeof Symbol == "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === z || !0) ? Symbol.toStringTag : null, q = Object.prototype.propertyIsEnumerable, j = (typeof Reflect == "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(K) {
    return K.__proto__;
  } : null);
  function D(K, Z) {
    if (K === 1 / 0 || K === -1 / 0 || K !== K || K && K > -1e3 && K < 1e3 || O.call(/e/, Z))
      return Z;
    var Pe = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof K == "number") {
      var Le = K < 0 ? -E(-K) : E(K);
      if (Le !== K) {
        var He = String(Le), $e = w.call(Z, He.length + 1);
        return _.call(He, Pe, "$&_") + "." + _.call(_.call($e, /([0-9]{3})/g, "$&_"), /_$/, "");
      }
    }
    return _.call(Z, Pe, "$&_");
  }
  var H = x3, W = H.custom, ee = fe(W) ? W : null;
  lf = function K(Z, Pe, Le, He) {
    var $e = Pe || {};
    if (we($e, "quoteStyle") && $e.quoteStyle !== "single" && $e.quoteStyle !== "double")
      throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if (we($e, "maxStringLength") && (typeof $e.maxStringLength == "number" ? $e.maxStringLength < 0 && $e.maxStringLength !== 1 / 0 : $e.maxStringLength !== null))
      throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var pt = we($e, "customInspect") ? $e.customInspect : !0;
    if (typeof pt != "boolean" && pt !== "symbol")
      throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
    if (we($e, "indent") && $e.indent !== null && $e.indent !== "	" && !(parseInt($e.indent, 10) === $e.indent && $e.indent > 0))
      throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if (we($e, "numericSeparator") && typeof $e.numericSeparator != "boolean")
      throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var Nt = $e.numericSeparator;
    if (typeof Z > "u")
      return "undefined";
    if (Z === null)
      return "null";
    if (typeof Z == "boolean")
      return Z ? "true" : "false";
    if (typeof Z == "string")
      return gt(Z, $e);
    if (typeof Z == "number") {
      if (Z === 0)
        return 1 / 0 / Z > 0 ? "0" : "-0";
      var nt = String(Z);
      return Nt ? D(Z, nt) : nt;
    }
    if (typeof Z == "bigint") {
      var Rt = String(Z) + "n";
      return Nt ? D(Z, Rt) : Rt;
    }
    var zt = typeof $e.depth > "u" ? 5 : $e.depth;
    if (typeof Le > "u" && (Le = 0), Le >= zt && zt > 0 && typeof Z == "object")
      return N(Z) ? "[Array]" : "[Object]";
    var Wt = kt($e, Le);
    if (typeof He > "u")
      He = [];
    else if (_t(He, Z) >= 0)
      return "[Circular]";
    function Pt(ot, Kr, io) {
      if (Kr && (He = C.call(He), He.push(Kr)), io) {
        var In = {
          depth: $e.depth
        };
        return we($e, "quoteStyle") && (In.quoteStyle = $e.quoteStyle), K(ot, In, Le + 1, He);
      }
      return K(ot, $e, Le + 1, He);
    }
    if (typeof Z == "function" && !de(Z)) {
      var Vr = Ct(Z), Hr = xr(Z, Pt);
      return "[Function" + (Vr ? ": " + Vr : " (anonymous)") + "]" + (Hr.length > 0 ? " { " + I.call(Hr, ", ") + " }" : "");
    }
    if (fe(Z)) {
      var fr = z ? _.call(String(Z), /^(Symbol\(.*\))_[^)]*$/, "$1") : L.call(Z);
      return typeof Z == "object" && !z ? cr(fr) : fr;
    }
    if (xt(Z)) {
      for (var At = "<" + A.call(String(Z.nodeName)), Jt = Z.attributes || [], Gr = 0; Gr < Jt.length; Gr++)
        At += " " + Jt[Gr].name + "=" + oe(J(Jt[Gr].value), "double", $e);
      return At += ">", Z.childNodes && Z.childNodes.length && (At += "..."), At += "</" + A.call(String(Z.nodeName)) + ">", At;
    }
    if (N(Z)) {
      if (Z.length === 0)
        return "[]";
      var an = xr(Z, Pt);
      return Wt && !Sr(an) ? "[" + dr(an, Wt) + "]" : "[ " + I.call(an, ", ") + " ]";
    }
    if (G(Z)) {
      var sn = xr(Z, Pt);
      return !("cause" in Error.prototype) && "cause" in Z && !q.call(Z, "cause") ? "{ [" + String(Z) + "] " + I.call(M.call("[cause]: " + Pt(Z.cause), sn), ", ") + " }" : sn.length === 0 ? "[" + String(Z) + "]" : "{ [" + String(Z) + "] " + I.call(sn, ", ") + " }";
    }
    if (typeof Z == "object" && pt) {
      if (ee && typeof Z[ee] == "function" && H)
        return H(Z, { depth: zt - Le });
      if (pt !== "symbol" && typeof Z.inspect == "function")
        return Z.inspect();
    }
    if (vt(Z)) {
      var ln = [];
      return n && n.call(Z, function(ot, Kr) {
        ln.push(Pt(Kr, Z, !0) + " => " + Pt(ot, Z));
      }), Ut("Map", r.call(Z), ln, Wt);
    }
    if (ut(Z)) {
      var Zt = [];
      return s && s.call(Z, function(ot) {
        Zt.push(Pt(ot, Z));
      }), Ut("Set", i.call(Z), Zt, Wt);
    }
    if (st(Z))
      return Yt("WeakMap");
    if (St(Z))
      return Yt("WeakSet");
    if (rt(Z))
      return Yt("WeakRef");
    if (be(Z))
      return cr(Pt(Number(Z)));
    if (Oe(Z))
      return cr(Pt(R.call(Z)));
    if (ve(Z))
      return cr(m.call(Z));
    if (ce(Z))
      return cr(Pt(String(Z)));
    if (typeof window < "u" && Z === window)
      return "{ [object Window] }";
    if (typeof globalThis < "u" && Z === globalThis || typeof Ht < "u" && Z === Ht)
      return "{ [object globalThis] }";
    if (!Q(Z) && !de(Z)) {
      var ct = xr(Z, Pt), kn = j ? j(Z) === Object.prototype : Z instanceof Object || Z.constructor === Object, un = Z instanceof Object ? "" : "null prototype", Pn = !kn && F && Object(Z) === Z && F in Z ? w.call(Me(Z), 8, -1) : un ? "Object" : "", oo = kn || typeof Z.constructor != "function" ? "" : Z.constructor.name ? Z.constructor.name + " " : "", tr = oo + (Pn || un ? "[" + I.call(M.call([], Pn || [], un || []), ": ") + "] " : "");
      return ct.length === 0 ? tr + "{}" : Wt ? tr + "{" + dr(ct, Wt) + "}" : tr + "{ " + I.call(ct, ", ") + " }";
    }
    return String(Z);
  };
  function oe(K, Z, Pe) {
    var Le = (Pe.quoteStyle || Z) === "double" ? '"' : "'";
    return Le + K + Le;
  }
  function J(K) {
    return _.call(String(K), /"/g, "&quot;");
  }
  function N(K) {
    return Me(K) === "[object Array]" && (!F || !(typeof K == "object" && F in K));
  }
  function Q(K) {
    return Me(K) === "[object Date]" && (!F || !(typeof K == "object" && F in K));
  }
  function de(K) {
    return Me(K) === "[object RegExp]" && (!F || !(typeof K == "object" && F in K));
  }
  function G(K) {
    return Me(K) === "[object Error]" && (!F || !(typeof K == "object" && F in K));
  }
  function ce(K) {
    return Me(K) === "[object String]" && (!F || !(typeof K == "object" && F in K));
  }
  function be(K) {
    return Me(K) === "[object Number]" && (!F || !(typeof K == "object" && F in K));
  }
  function ve(K) {
    return Me(K) === "[object Boolean]" && (!F || !(typeof K == "object" && F in K));
  }
  function fe(K) {
    if (z)
      return K && typeof K == "object" && K instanceof Symbol;
    if (typeof K == "symbol")
      return !0;
    if (!K || typeof K != "object" || !L)
      return !1;
    try {
      return L.call(K), !0;
    } catch {
    }
    return !1;
  }
  function Oe(K) {
    if (!K || typeof K != "object" || !R)
      return !1;
    try {
      return R.call(K), !0;
    } catch {
    }
    return !1;
  }
  var Ge = Object.prototype.hasOwnProperty || function(K) {
    return K in this;
  };
  function we(K, Z) {
    return Ge.call(K, Z);
  }
  function Me(K) {
    return p.call(K);
  }
  function Ct(K) {
    if (K.name)
      return K.name;
    var Z = v.call(f.call(K), /^function\s*([\w$]+)/);
    return Z ? Z[1] : null;
  }
  function _t(K, Z) {
    if (K.indexOf)
      return K.indexOf(Z);
    for (var Pe = 0, Le = K.length; Pe < Le; Pe++)
      if (K[Pe] === Z)
        return Pe;
    return -1;
  }
  function vt(K) {
    if (!r || !K || typeof K != "object")
      return !1;
    try {
      r.call(K);
      try {
        i.call(K);
      } catch {
        return !0;
      }
      return K instanceof Map;
    } catch {
    }
    return !1;
  }
  function st(K) {
    if (!u || !K || typeof K != "object")
      return !1;
    try {
      u.call(K, u);
      try {
        d.call(K, d);
      } catch {
        return !0;
      }
      return K instanceof WeakMap;
    } catch {
    }
    return !1;
  }
  function rt(K) {
    if (!y || !K || typeof K != "object")
      return !1;
    try {
      return y.call(K), !0;
    } catch {
    }
    return !1;
  }
  function ut(K) {
    if (!i || !K || typeof K != "object")
      return !1;
    try {
      i.call(K);
      try {
        r.call(K);
      } catch {
        return !0;
      }
      return K instanceof Set;
    } catch {
    }
    return !1;
  }
  function St(K) {
    if (!d || !K || typeof K != "object")
      return !1;
    try {
      d.call(K, d);
      try {
        u.call(K, u);
      } catch {
        return !0;
      }
      return K instanceof WeakSet;
    } catch {
    }
    return !1;
  }
  function xt(K) {
    return !K || typeof K != "object" ? !1 : typeof HTMLElement < "u" && K instanceof HTMLElement ? !0 : typeof K.nodeName == "string" && typeof K.getAttribute == "function";
  }
  function gt(K, Z) {
    if (K.length > Z.maxStringLength) {
      var Pe = K.length - Z.maxStringLength, Le = "... " + Pe + " more character" + (Pe > 1 ? "s" : "");
      return gt(w.call(K, 0, Z.maxStringLength), Z) + Le;
    }
    var He = _.call(_.call(K, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, Ft);
    return oe(He, "single", Z);
  }
  function Ft(K) {
    var Z = K.charCodeAt(0), Pe = {
      8: "b",
      9: "t",
      10: "n",
      12: "f",
      13: "r"
    }[Z];
    return Pe ? "\\" + Pe : "\\x" + (Z < 16 ? "0" : "") + T.call(Z.toString(16));
  }
  function cr(K) {
    return "Object(" + K + ")";
  }
  function Yt(K) {
    return K + " { ? }";
  }
  function Ut(K, Z, Pe, Le) {
    var He = Le ? dr(Pe, Le) : I.call(Pe, ", ");
    return K + " (" + Z + ") {" + He + "}";
  }
  function Sr(K) {
    for (var Z = 0; Z < K.length; Z++)
      if (_t(K[Z], `
`) >= 0)
        return !1;
    return !0;
  }
  function kt(K, Z) {
    var Pe;
    if (K.indent === "	")
      Pe = "	";
    else if (typeof K.indent == "number" && K.indent > 0)
      Pe = I.call(Array(K.indent + 1), " ");
    else
      return null;
    return {
      base: Pe,
      prev: I.call(Array(Z + 1), Pe)
    };
  }
  function dr(K, Z) {
    if (K.length === 0)
      return "";
    var Pe = `
` + Z.prev + Z.base;
    return Pe + I.call(K, "," + Pe) + `
` + Z.prev;
  }
  function xr(K, Z) {
    var Pe = N(K), Le = [];
    if (Pe) {
      Le.length = K.length;
      for (var He = 0; He < K.length; He++)
        Le[He] = we(K, He) ? Z(K[He], K) : "";
    }
    var $e = typeof k == "function" ? k(K) : [], pt;
    if (z) {
      pt = {};
      for (var Nt = 0; Nt < $e.length; Nt++)
        pt["$" + $e[Nt]] = $e[Nt];
    }
    for (var nt in K)
      we(K, nt) && (Pe && String(Number(nt)) === nt && nt < K.length || z && pt["$" + nt] instanceof Symbol || (O.call(/[^\w$]/, nt) ? Le.push(Z(nt, K) + ": " + Z(K[nt], K)) : Le.push(nt + ": " + Z(K[nt], K))));
    if (typeof k == "function")
      for (var Rt = 0; Rt < $e.length; Rt++)
        q.call(K, $e[Rt]) && Le.push("[" + Z($e[Rt]) + "]: " + Z(K[$e[Rt]], K));
    return Le;
  }
  return lf;
}
var uf, o0;
function T3() {
  if (o0) return uf;
  o0 = 1;
  var e = /* @__PURE__ */ wi(), t = w3(), r = /* @__PURE__ */ A3(), n = /* @__PURE__ */ va(), o = e("%WeakMap%", !0), a = e("%Map%", !0), i = t("WeakMap.prototype.get", !0), s = t("WeakMap.prototype.set", !0), l = t("WeakMap.prototype.has", !0), u = t("Map.prototype.get", !0), c = t("Map.prototype.set", !0), d = t("Map.prototype.has", !0), h = function(f, v) {
    for (var w = f, _; (_ = w.next) !== null; w = _)
      if (_.key === v)
        return w.next = _.next, _.next = /** @type {NonNullable<typeof list.next>} */
        f.next, f.next = _, _;
  }, y = function(f, v) {
    var w = h(f, v);
    return w && w.value;
  }, m = function(f, v, w) {
    var _ = h(f, v);
    _ ? _.value = w : f.next = /** @type {import('.').ListNode<typeof value>} */
    {
      // eslint-disable-line no-param-reassign, no-extra-parens
      key: v,
      next: f.next,
      value: w
    };
  }, p = function(f, v) {
    return !!h(f, v);
  };
  return uf = function() {
    var v, w, _, T = {
      assert: function(A) {
        if (!T.has(A))
          throw new n("Side channel does not contain " + r(A));
      },
      get: function(A) {
        if (o && A && (typeof A == "object" || typeof A == "function")) {
          if (v)
            return i(v, A);
        } else if (a) {
          if (w)
            return u(w, A);
        } else if (_)
          return y(_, A);
      },
      has: function(A) {
        if (o && A && (typeof A == "object" || typeof A == "function")) {
          if (v)
            return l(v, A);
        } else if (a) {
          if (w)
            return d(w, A);
        } else if (_)
          return p(_, A);
        return !1;
      },
      set: function(A, O) {
        o && A && (typeof A == "object" || typeof A == "function") ? (v || (v = new o()), s(v, A, O)) : a ? (w || (w = new a()), c(w, A, O)) : (_ || (_ = { key: {}, next: null }), m(_, A, O));
      }
    };
    return T;
  }, uf;
}
var cf, i0;
function Gp() {
  if (i0) return cf;
  i0 = 1;
  var e = String.prototype.replace, t = /%20/g, r = {
    RFC1738: "RFC1738",
    RFC3986: "RFC3986"
  };
  return cf = {
    default: r.RFC3986,
    formatters: {
      RFC1738: function(n) {
        return e.call(n, t, "+");
      },
      RFC3986: function(n) {
        return String(n);
      }
    },
    RFC1738: r.RFC1738,
    RFC3986: r.RFC3986
  }, cf;
}
var df, a0;
function yw() {
  if (a0) return df;
  a0 = 1;
  var e = /* @__PURE__ */ Gp(), t = Object.prototype.hasOwnProperty, r = Array.isArray, n = function() {
    for (var f = [], v = 0; v < 256; ++v)
      f.push("%" + ((v < 16 ? "0" : "") + v.toString(16)).toUpperCase());
    return f;
  }(), o = function(v) {
    for (; v.length > 1; ) {
      var w = v.pop(), _ = w.obj[w.prop];
      if (r(_)) {
        for (var T = [], A = 0; A < _.length; ++A)
          typeof _[A] < "u" && T.push(_[A]);
        w.obj[w.prop] = T;
      }
    }
  }, a = function(v, w) {
    for (var _ = w && w.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, T = 0; T < v.length; ++T)
      typeof v[T] < "u" && (_[T] = v[T]);
    return _;
  }, i = function f(v, w, _) {
    if (!w)
      return v;
    if (typeof w != "object") {
      if (r(v))
        v.push(w);
      else if (v && typeof v == "object")
        (_ && (_.plainObjects || _.allowPrototypes) || !t.call(Object.prototype, w)) && (v[w] = !0);
      else
        return [v, w];
      return v;
    }
    if (!v || typeof v != "object")
      return [v].concat(w);
    var T = v;
    return r(v) && !r(w) && (T = a(v, _)), r(v) && r(w) ? (w.forEach(function(A, O) {
      if (t.call(v, O)) {
        var M = v[O];
        M && typeof M == "object" && A && typeof A == "object" ? v[O] = f(M, A, _) : v.push(A);
      } else
        v[O] = A;
    }), v) : Object.keys(w).reduce(function(A, O) {
      var M = w[O];
      return t.call(A, O) ? A[O] = f(A[O], M, _) : A[O] = M, A;
    }, T);
  }, s = function(v, w) {
    return Object.keys(w).reduce(function(_, T) {
      return _[T] = w[T], _;
    }, v);
  }, l = function(f, v, w) {
    var _ = f.replace(/\+/g, " ");
    if (w === "iso-8859-1")
      return _.replace(/%[0-9a-f]{2}/gi, unescape);
    try {
      return decodeURIComponent(_);
    } catch {
      return _;
    }
  }, u = 1024, c = function(v, w, _, T, A) {
    if (v.length === 0)
      return v;
    var O = v;
    if (typeof v == "symbol" ? O = Symbol.prototype.toString.call(v) : typeof v != "string" && (O = String(v)), _ === "iso-8859-1")
      return escape(O).replace(/%u[0-9a-f]{4}/gi, function(L) {
        return "%26%23" + parseInt(L.slice(2), 16) + "%3B";
      });
    for (var M = "", I = 0; I < O.length; I += u) {
      for (var C = O.length >= u ? O.slice(I, I + u) : O, E = [], R = 0; R < C.length; ++R) {
        var k = C.charCodeAt(R);
        if (k === 45 || k === 46 || k === 95 || k === 126 || k >= 48 && k <= 57 || k >= 65 && k <= 90 || k >= 97 && k <= 122 || A === e.RFC1738 && (k === 40 || k === 41)) {
          E[E.length] = C.charAt(R);
          continue;
        }
        if (k < 128) {
          E[E.length] = n[k];
          continue;
        }
        if (k < 2048) {
          E[E.length] = n[192 | k >> 6] + n[128 | k & 63];
          continue;
        }
        if (k < 55296 || k >= 57344) {
          E[E.length] = n[224 | k >> 12] + n[128 | k >> 6 & 63] + n[128 | k & 63];
          continue;
        }
        R += 1, k = 65536 + ((k & 1023) << 10 | C.charCodeAt(R) & 1023), E[E.length] = n[240 | k >> 18] + n[128 | k >> 12 & 63] + n[128 | k >> 6 & 63] + n[128 | k & 63];
      }
      M += E.join("");
    }
    return M;
  }, d = function(v) {
    for (var w = [{ obj: { o: v }, prop: "o" }], _ = [], T = 0; T < w.length; ++T)
      for (var A = w[T], O = A.obj[A.prop], M = Object.keys(O), I = 0; I < M.length; ++I) {
        var C = M[I], E = O[C];
        typeof E == "object" && E !== null && _.indexOf(E) === -1 && (w.push({ obj: O, prop: C }), _.push(E));
      }
    return o(w), v;
  }, h = function(v) {
    return Object.prototype.toString.call(v) === "[object RegExp]";
  }, y = function(v) {
    return !v || typeof v != "object" ? !1 : !!(v.constructor && v.constructor.isBuffer && v.constructor.isBuffer(v));
  }, m = function(v, w) {
    return [].concat(v, w);
  }, p = function(v, w) {
    if (r(v)) {
      for (var _ = [], T = 0; T < v.length; T += 1)
        _.push(w(v[T]));
      return _;
    }
    return w(v);
  };
  return df = {
    arrayToObject: a,
    assign: s,
    combine: m,
    compact: d,
    decode: l,
    encode: c,
    isBuffer: y,
    isRegExp: h,
    maybeMap: p,
    merge: i
  }, df;
}
var ff, s0;
function E3() {
  if (s0) return ff;
  s0 = 1;
  var e = T3(), t = /* @__PURE__ */ yw(), r = /* @__PURE__ */ Gp(), n = Object.prototype.hasOwnProperty, o = {
    brackets: function(f) {
      return f + "[]";
    },
    comma: "comma",
    indices: function(f, v) {
      return f + "[" + v + "]";
    },
    repeat: function(f) {
      return f;
    }
  }, a = Array.isArray, i = Array.prototype.push, s = function(p, f) {
    i.apply(p, a(f) ? f : [f]);
  }, l = Date.prototype.toISOString, u = r.default, c = {
    addQueryPrefix: !1,
    allowDots: !1,
    allowEmptyArrays: !1,
    arrayFormat: "indices",
    charset: "utf-8",
    charsetSentinel: !1,
    delimiter: "&",
    encode: !0,
    encodeDotInKeys: !1,
    encoder: t.encode,
    encodeValuesOnly: !1,
    format: u,
    formatter: r.formatters[u],
    // deprecated
    indices: !1,
    serializeDate: function(f) {
      return l.call(f);
    },
    skipNulls: !1,
    strictNullHandling: !1
  }, d = function(f) {
    return typeof f == "string" || typeof f == "number" || typeof f == "boolean" || typeof f == "symbol" || typeof f == "bigint";
  }, h = {}, y = function p(f, v, w, _, T, A, O, M, I, C, E, R, k, L, z, F, q, j) {
    for (var D = f, H = j, W = 0, ee = !1; (H = H.get(h)) !== void 0 && !ee; ) {
      var oe = H.get(f);
      if (W += 1, typeof oe < "u") {
        if (oe === W)
          throw new RangeError("Cyclic object value");
        ee = !0;
      }
      typeof H.get(h) > "u" && (W = 0);
    }
    if (typeof C == "function" ? D = C(v, D) : D instanceof Date ? D = k(D) : w === "comma" && a(D) && (D = t.maybeMap(D, function(Me) {
      return Me instanceof Date ? k(Me) : Me;
    })), D === null) {
      if (A)
        return I && !F ? I(v, c.encoder, q, "key", L) : v;
      D = "";
    }
    if (d(D) || t.isBuffer(D)) {
      if (I) {
        var J = F ? v : I(v, c.encoder, q, "key", L);
        return [z(J) + "=" + z(I(D, c.encoder, q, "value", L))];
      }
      return [z(v) + "=" + z(String(D))];
    }
    var N = [];
    if (typeof D > "u")
      return N;
    var Q;
    if (w === "comma" && a(D))
      F && I && (D = t.maybeMap(D, I)), Q = [{ value: D.length > 0 ? D.join(",") || null : void 0 }];
    else if (a(C))
      Q = C;
    else {
      var de = Object.keys(D);
      Q = E ? de.sort(E) : de;
    }
    var G = M ? v.replace(/\./g, "%2E") : v, ce = _ && a(D) && D.length === 1 ? G + "[]" : G;
    if (T && a(D) && D.length === 0)
      return ce + "[]";
    for (var be = 0; be < Q.length; ++be) {
      var ve = Q[be], fe = typeof ve == "object" && typeof ve.value < "u" ? ve.value : D[ve];
      if (!(O && fe === null)) {
        var Oe = R && M ? ve.replace(/\./g, "%2E") : ve, Ge = a(D) ? typeof w == "function" ? w(ce, Oe) : ce : ce + (R ? "." + Oe : "[" + Oe + "]");
        j.set(f, W);
        var we = e();
        we.set(h, j), s(N, p(
          fe,
          Ge,
          w,
          _,
          T,
          A,
          O,
          M,
          w === "comma" && F && a(D) ? null : I,
          C,
          E,
          R,
          k,
          L,
          z,
          F,
          q,
          we
        ));
      }
    }
    return N;
  }, m = function(f) {
    if (!f)
      return c;
    if (typeof f.allowEmptyArrays < "u" && typeof f.allowEmptyArrays != "boolean")
      throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof f.encodeDotInKeys < "u" && typeof f.encodeDotInKeys != "boolean")
      throw new TypeError("`encodeDotInKeys` option can only be `true` or `false`, when provided");
    if (f.encoder !== null && typeof f.encoder < "u" && typeof f.encoder != "function")
      throw new TypeError("Encoder has to be a function.");
    var v = f.charset || c.charset;
    if (typeof f.charset < "u" && f.charset !== "utf-8" && f.charset !== "iso-8859-1")
      throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var w = r.default;
    if (typeof f.format < "u") {
      if (!n.call(r.formatters, f.format))
        throw new TypeError("Unknown format option provided.");
      w = f.format;
    }
    var _ = r.formatters[w], T = c.filter;
    (typeof f.filter == "function" || a(f.filter)) && (T = f.filter);
    var A;
    if (f.arrayFormat in o ? A = f.arrayFormat : "indices" in f ? A = f.indices ? "indices" : "repeat" : A = c.arrayFormat, "commaRoundTrip" in f && typeof f.commaRoundTrip != "boolean")
      throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
    var O = typeof f.allowDots > "u" ? f.encodeDotInKeys === !0 ? !0 : c.allowDots : !!f.allowDots;
    return {
      addQueryPrefix: typeof f.addQueryPrefix == "boolean" ? f.addQueryPrefix : c.addQueryPrefix,
      allowDots: O,
      allowEmptyArrays: typeof f.allowEmptyArrays == "boolean" ? !!f.allowEmptyArrays : c.allowEmptyArrays,
      arrayFormat: A,
      charset: v,
      charsetSentinel: typeof f.charsetSentinel == "boolean" ? f.charsetSentinel : c.charsetSentinel,
      commaRoundTrip: f.commaRoundTrip,
      delimiter: typeof f.delimiter > "u" ? c.delimiter : f.delimiter,
      encode: typeof f.encode == "boolean" ? f.encode : c.encode,
      encodeDotInKeys: typeof f.encodeDotInKeys == "boolean" ? f.encodeDotInKeys : c.encodeDotInKeys,
      encoder: typeof f.encoder == "function" ? f.encoder : c.encoder,
      encodeValuesOnly: typeof f.encodeValuesOnly == "boolean" ? f.encodeValuesOnly : c.encodeValuesOnly,
      filter: T,
      format: w,
      formatter: _,
      serializeDate: typeof f.serializeDate == "function" ? f.serializeDate : c.serializeDate,
      skipNulls: typeof f.skipNulls == "boolean" ? f.skipNulls : c.skipNulls,
      sort: typeof f.sort == "function" ? f.sort : null,
      strictNullHandling: typeof f.strictNullHandling == "boolean" ? f.strictNullHandling : c.strictNullHandling
    };
  };
  return ff = function(p, f) {
    var v = p, w = m(f), _, T;
    typeof w.filter == "function" ? (T = w.filter, v = T("", v)) : a(w.filter) && (T = w.filter, _ = T);
    var A = [];
    if (typeof v != "object" || v === null)
      return "";
    var O = o[w.arrayFormat], M = O === "comma" && w.commaRoundTrip;
    _ || (_ = Object.keys(v)), w.sort && _.sort(w.sort);
    for (var I = e(), C = 0; C < _.length; ++C) {
      var E = _[C];
      w.skipNulls && v[E] === null || s(A, y(
        v[E],
        E,
        O,
        M,
        w.allowEmptyArrays,
        w.strictNullHandling,
        w.skipNulls,
        w.encodeDotInKeys,
        w.encode ? w.encoder : null,
        w.filter,
        w.sort,
        w.allowDots,
        w.serializeDate,
        w.format,
        w.formatter,
        w.encodeValuesOnly,
        w.charset,
        I
      ));
    }
    var R = A.join(w.delimiter), k = w.addQueryPrefix === !0 ? "?" : "";
    return w.charsetSentinel && (w.charset === "iso-8859-1" ? k += "utf8=%26%2310003%3B&" : k += "utf8=%E2%9C%93&"), R.length > 0 ? k + R : "";
  }, ff;
}
var pf, l0;
function O3() {
  if (l0) return pf;
  l0 = 1;
  var e = /* @__PURE__ */ yw(), t = Object.prototype.hasOwnProperty, r = Array.isArray, n = {
    allowDots: !1,
    allowEmptyArrays: !1,
    allowPrototypes: !1,
    allowSparse: !1,
    arrayLimit: 20,
    charset: "utf-8",
    charsetSentinel: !1,
    comma: !1,
    decodeDotInKeys: !1,
    decoder: e.decode,
    delimiter: "&",
    depth: 5,
    duplicates: "combine",
    ignoreQueryPrefix: !1,
    interpretNumericEntities: !1,
    parameterLimit: 1e3,
    parseArrays: !0,
    plainObjects: !1,
    strictDepth: !1,
    strictNullHandling: !1
  }, o = function(h) {
    return h.replace(/&#(\d+);/g, function(y, m) {
      return String.fromCharCode(parseInt(m, 10));
    });
  }, a = function(h, y) {
    return h && typeof h == "string" && y.comma && h.indexOf(",") > -1 ? h.split(",") : h;
  }, i = "utf8=%26%2310003%3B", s = "utf8=%E2%9C%93", l = function(y, m) {
    var p = { __proto__: null }, f = m.ignoreQueryPrefix ? y.replace(/^\?/, "") : y;
    f = f.replace(/%5B/gi, "[").replace(/%5D/gi, "]");
    var v = m.parameterLimit === 1 / 0 ? void 0 : m.parameterLimit, w = f.split(m.delimiter, v), _ = -1, T, A = m.charset;
    if (m.charsetSentinel)
      for (T = 0; T < w.length; ++T)
        w[T].indexOf("utf8=") === 0 && (w[T] === s ? A = "utf-8" : w[T] === i && (A = "iso-8859-1"), _ = T, T = w.length);
    for (T = 0; T < w.length; ++T)
      if (T !== _) {
        var O = w[T], M = O.indexOf("]="), I = M === -1 ? O.indexOf("=") : M + 1, C, E;
        I === -1 ? (C = m.decoder(O, n.decoder, A, "key"), E = m.strictNullHandling ? null : "") : (C = m.decoder(O.slice(0, I), n.decoder, A, "key"), E = e.maybeMap(
          a(O.slice(I + 1), m),
          function(k) {
            return m.decoder(k, n.decoder, A, "value");
          }
        )), E && m.interpretNumericEntities && A === "iso-8859-1" && (E = o(E)), O.indexOf("[]=") > -1 && (E = r(E) ? [E] : E);
        var R = t.call(p, C);
        R && m.duplicates === "combine" ? p[C] = e.combine(p[C], E) : (!R || m.duplicates === "last") && (p[C] = E);
      }
    return p;
  }, u = function(h, y, m, p) {
    for (var f = p ? y : a(y, m), v = h.length - 1; v >= 0; --v) {
      var w, _ = h[v];
      if (_ === "[]" && m.parseArrays)
        w = m.allowEmptyArrays && (f === "" || m.strictNullHandling && f === null) ? [] : [].concat(f);
      else {
        w = m.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
        var T = _.charAt(0) === "[" && _.charAt(_.length - 1) === "]" ? _.slice(1, -1) : _, A = m.decodeDotInKeys ? T.replace(/%2E/g, ".") : T, O = parseInt(A, 10);
        !m.parseArrays && A === "" ? w = { 0: f } : !isNaN(O) && _ !== A && String(O) === A && O >= 0 && m.parseArrays && O <= m.arrayLimit ? (w = [], w[O] = f) : A !== "__proto__" && (w[A] = f);
      }
      f = w;
    }
    return f;
  }, c = function(y, m, p, f) {
    if (y) {
      var v = p.allowDots ? y.replace(/\.([^.[]+)/g, "[$1]") : y, w = /(\[[^[\]]*])/, _ = /(\[[^[\]]*])/g, T = p.depth > 0 && w.exec(v), A = T ? v.slice(0, T.index) : v, O = [];
      if (A) {
        if (!p.plainObjects && t.call(Object.prototype, A) && !p.allowPrototypes)
          return;
        O.push(A);
      }
      for (var M = 0; p.depth > 0 && (T = _.exec(v)) !== null && M < p.depth; ) {
        if (M += 1, !p.plainObjects && t.call(Object.prototype, T[1].slice(1, -1)) && !p.allowPrototypes)
          return;
        O.push(T[1]);
      }
      if (T) {
        if (p.strictDepth === !0)
          throw new RangeError("Input depth exceeded depth option of " + p.depth + " and strictDepth is true");
        O.push("[" + v.slice(T.index) + "]");
      }
      return u(O, m, p, f);
    }
  }, d = function(y) {
    if (!y)
      return n;
    if (typeof y.allowEmptyArrays < "u" && typeof y.allowEmptyArrays != "boolean")
      throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof y.decodeDotInKeys < "u" && typeof y.decodeDotInKeys != "boolean")
      throw new TypeError("`decodeDotInKeys` option can only be `true` or `false`, when provided");
    if (y.decoder !== null && typeof y.decoder < "u" && typeof y.decoder != "function")
      throw new TypeError("Decoder has to be a function.");
    if (typeof y.charset < "u" && y.charset !== "utf-8" && y.charset !== "iso-8859-1")
      throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var m = typeof y.charset > "u" ? n.charset : y.charset, p = typeof y.duplicates > "u" ? n.duplicates : y.duplicates;
    if (p !== "combine" && p !== "first" && p !== "last")
      throw new TypeError("The duplicates option must be either combine, first, or last");
    var f = typeof y.allowDots > "u" ? y.decodeDotInKeys === !0 ? !0 : n.allowDots : !!y.allowDots;
    return {
      allowDots: f,
      allowEmptyArrays: typeof y.allowEmptyArrays == "boolean" ? !!y.allowEmptyArrays : n.allowEmptyArrays,
      allowPrototypes: typeof y.allowPrototypes == "boolean" ? y.allowPrototypes : n.allowPrototypes,
      allowSparse: typeof y.allowSparse == "boolean" ? y.allowSparse : n.allowSparse,
      arrayLimit: typeof y.arrayLimit == "number" ? y.arrayLimit : n.arrayLimit,
      charset: m,
      charsetSentinel: typeof y.charsetSentinel == "boolean" ? y.charsetSentinel : n.charsetSentinel,
      comma: typeof y.comma == "boolean" ? y.comma : n.comma,
      decodeDotInKeys: typeof y.decodeDotInKeys == "boolean" ? y.decodeDotInKeys : n.decodeDotInKeys,
      decoder: typeof y.decoder == "function" ? y.decoder : n.decoder,
      delimiter: typeof y.delimiter == "string" || e.isRegExp(y.delimiter) ? y.delimiter : n.delimiter,
      // eslint-disable-next-line no-implicit-coercion, no-extra-parens
      depth: typeof y.depth == "number" || y.depth === !1 ? +y.depth : n.depth,
      duplicates: p,
      ignoreQueryPrefix: y.ignoreQueryPrefix === !0,
      interpretNumericEntities: typeof y.interpretNumericEntities == "boolean" ? y.interpretNumericEntities : n.interpretNumericEntities,
      parameterLimit: typeof y.parameterLimit == "number" ? y.parameterLimit : n.parameterLimit,
      parseArrays: y.parseArrays !== !1,
      plainObjects: typeof y.plainObjects == "boolean" ? y.plainObjects : n.plainObjects,
      strictDepth: typeof y.strictDepth == "boolean" ? !!y.strictDepth : n.strictDepth,
      strictNullHandling: typeof y.strictNullHandling == "boolean" ? y.strictNullHandling : n.strictNullHandling
    };
  };
  return pf = function(h, y) {
    var m = d(y);
    if (h === "" || h === null || typeof h > "u")
      return m.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
    for (var p = typeof h == "string" ? l(h, m) : h, f = m.plainObjects ? /* @__PURE__ */ Object.create(null) : {}, v = Object.keys(p), w = 0; w < v.length; ++w) {
      var _ = v[w], T = c(_, p[_], m, typeof h == "string");
      f = e.merge(f, T, m);
    }
    return m.allowSparse === !0 ? f : e.compact(f);
  }, pf;
}
var hf, u0;
function $3() {
  if (u0) return hf;
  u0 = 1;
  var e = /* @__PURE__ */ E3(), t = /* @__PURE__ */ O3(), r = /* @__PURE__ */ Gp();
  return hf = {
    formats: r,
    parse: t,
    stringify: e
  }, hf;
}
var c0 = /* @__PURE__ */ $3(), hs = { exports: {} };
/* NProgress, (c) 2013, 2014 Rico Sta. Cruz - http://ricostacruz.com/nprogress
 * @license MIT */
var C3 = hs.exports, d0;
function k3() {
  return d0 || (d0 = 1, function(e, t) {
    (function(r, n) {
      e.exports = n();
    })(C3, function() {
      var r = {};
      r.version = "0.2.0";
      var n = r.settings = {
        minimum: 0.08,
        easing: "ease",
        positionUsing: "",
        speed: 200,
        trickle: !0,
        trickleRate: 0.02,
        trickleSpeed: 800,
        showSpinner: !0,
        barSelector: '[role="bar"]',
        spinnerSelector: '[role="spinner"]',
        parent: "body",
        template: '<div class="bar" role="bar"><div class="peg"></div></div><div class="spinner" role="spinner"><div class="spinner-icon"></div></div>'
      };
      r.configure = function(m) {
        var p, f;
        for (p in m)
          f = m[p], f !== void 0 && m.hasOwnProperty(p) && (n[p] = f);
        return this;
      }, r.status = null, r.set = function(m) {
        var p = r.isStarted();
        m = o(m, n.minimum, 1), r.status = m === 1 ? null : m;
        var f = r.render(!p), v = f.querySelector(n.barSelector), w = n.speed, _ = n.easing;
        return f.offsetWidth, s(function(T) {
          n.positionUsing === "" && (n.positionUsing = r.getPositioningCSS()), l(v, i(m, w, _)), m === 1 ? (l(f, {
            transition: "none",
            opacity: 1
          }), f.offsetWidth, setTimeout(function() {
            l(f, {
              transition: "all " + w + "ms linear",
              opacity: 0
            }), setTimeout(function() {
              r.remove(), T();
            }, w);
          }, w)) : setTimeout(T, w);
        }), this;
      }, r.isStarted = function() {
        return typeof r.status == "number";
      }, r.start = function() {
        r.status || r.set(0);
        var m = function() {
          setTimeout(function() {
            r.status && (r.trickle(), m());
          }, n.trickleSpeed);
        };
        return n.trickle && m(), this;
      }, r.done = function(m) {
        return !m && !r.status ? this : r.inc(0.3 + 0.5 * Math.random()).set(1);
      }, r.inc = function(m) {
        var p = r.status;
        return p ? (typeof m != "number" && (m = (1 - p) * o(Math.random() * p, 0.1, 0.95)), p = o(p + m, 0, 0.994), r.set(p)) : r.start();
      }, r.trickle = function() {
        return r.inc(Math.random() * n.trickleRate);
      }, function() {
        var m = 0, p = 0;
        r.promise = function(f) {
          return !f || f.state() === "resolved" ? this : (p === 0 && r.start(), m++, p++, f.always(function() {
            p--, p === 0 ? (m = 0, r.done()) : r.set((m - p) / m);
          }), this);
        };
      }(), r.render = function(m) {
        if (r.isRendered()) return document.getElementById("nprogress");
        c(document.documentElement, "nprogress-busy");
        var p = document.createElement("div");
        p.id = "nprogress", p.innerHTML = n.template;
        var f = p.querySelector(n.barSelector), v = m ? "-100" : a(r.status || 0), w = document.querySelector(n.parent), _;
        return l(f, {
          transition: "all 0 linear",
          transform: "translate3d(" + v + "%,0,0)"
        }), n.showSpinner || (_ = p.querySelector(n.spinnerSelector), _ && y(_)), w != document.body && c(w, "nprogress-custom-parent"), w.appendChild(p), p;
      }, r.remove = function() {
        d(document.documentElement, "nprogress-busy"), d(document.querySelector(n.parent), "nprogress-custom-parent");
        var m = document.getElementById("nprogress");
        m && y(m);
      }, r.isRendered = function() {
        return !!document.getElementById("nprogress");
      }, r.getPositioningCSS = function() {
        var m = document.body.style, p = "WebkitTransform" in m ? "Webkit" : "MozTransform" in m ? "Moz" : "msTransform" in m ? "ms" : "OTransform" in m ? "O" : "";
        return p + "Perspective" in m ? "translate3d" : p + "Transform" in m ? "translate" : "margin";
      };
      function o(m, p, f) {
        return m < p ? p : m > f ? f : m;
      }
      function a(m) {
        return (-1 + m) * 100;
      }
      function i(m, p, f) {
        var v;
        return n.positionUsing === "translate3d" ? v = { transform: "translate3d(" + a(m) + "%,0,0)" } : n.positionUsing === "translate" ? v = { transform: "translate(" + a(m) + "%,0)" } : v = { "margin-left": a(m) + "%" }, v.transition = "all " + p + "ms " + f, v;
      }
      var s = /* @__PURE__ */ function() {
        var m = [];
        function p() {
          var f = m.shift();
          f && f(p);
        }
        return function(f) {
          m.push(f), m.length == 1 && p();
        };
      }(), l = /* @__PURE__ */ function() {
        var m = ["Webkit", "O", "Moz", "ms"], p = {};
        function f(T) {
          return T.replace(/^-ms-/, "ms-").replace(/-([\da-z])/gi, function(A, O) {
            return O.toUpperCase();
          });
        }
        function v(T) {
          var A = document.body.style;
          if (T in A) return T;
          for (var O = m.length, M = T.charAt(0).toUpperCase() + T.slice(1), I; O--; )
            if (I = m[O] + M, I in A) return I;
          return T;
        }
        function w(T) {
          return T = f(T), p[T] || (p[T] = v(T));
        }
        function _(T, A, O) {
          A = w(A), T.style[A] = O;
        }
        return function(T, A) {
          var O = arguments, M, I;
          if (O.length == 2)
            for (M in A)
              I = A[M], I !== void 0 && A.hasOwnProperty(M) && _(T, M, I);
          else
            _(T, O[1], O[2]);
        };
      }();
      function u(m, p) {
        var f = typeof m == "string" ? m : h(m);
        return f.indexOf(" " + p + " ") >= 0;
      }
      function c(m, p) {
        var f = h(m), v = f + p;
        u(f, p) || (m.className = v.substring(1));
      }
      function d(m, p) {
        var f = h(m), v;
        u(m, p) && (v = f.replace(" " + p + " ", " "), m.className = v.substring(1, v.length - 1));
      }
      function h(m) {
        return (" " + (m.className || "") + " ").replace(/\s+/gi, " ");
      }
      function y(m) {
        m && m.parentNode && m.parentNode.removeChild(m);
      }
      return r;
    });
  }(hs)), hs.exports;
}
k3();
function bw(e, t) {
  let r;
  return function(...n) {
    clearTimeout(r), r = setTimeout(() => e.apply(this, n), t);
  };
}
function $n(e, t) {
  return document.dispatchEvent(new CustomEvent(`inertia:${e}`, t));
}
var P3 = (e) => $n("before", { cancelable: !0, detail: { visit: e } }), I3 = (e) => $n("error", { detail: { errors: e } }), D3 = (e) => $n("exception", { cancelable: !0, detail: { exception: e } }), f0 = (e) => $n("finish", { detail: { visit: e } }), R3 = (e) => $n("invalid", { cancelable: !0, detail: { response: e } }), Wi = (e) => $n("navigate", { detail: { page: e } }), M3 = (e) => $n("progress", { detail: { progress: e } }), B3 = (e) => $n("start", { detail: { visit: e } }), q3 = (e) => $n("success", { detail: { page: e } });
function rp(e) {
  return e instanceof File || e instanceof Blob || e instanceof FileList && e.length > 0 || e instanceof FormData && Array.from(e.values()).some((t) => rp(t)) || typeof e == "object" && e !== null && Object.values(e).some((t) => rp(t));
}
function ww(e, t = new FormData(), r = null) {
  e = e || {};
  for (let n in e) Object.prototype.hasOwnProperty.call(e, n) && Sw(t, _w(r, n), e[n]);
  return t;
}
function _w(e, t) {
  return e ? e + "[" + t + "]" : t;
}
function Sw(e, t, r) {
  if (Array.isArray(r)) return Array.from(r.keys()).forEach((n) => Sw(e, _w(t, n.toString()), r[n]));
  if (r instanceof Date) return e.append(t, r.toISOString());
  if (r instanceof File) return e.append(t, r, r.name);
  if (r instanceof Blob) return e.append(t, r);
  if (typeof r == "boolean") return e.append(t, r ? "1" : "0");
  if (typeof r == "string") return e.append(t, r);
  if (typeof r == "number") return e.append(t, `${r}`);
  if (r == null) return e.append(t, "");
  ww(r, e, t);
}
var L3 = { modal: null, listener: null, show(e) {
  typeof e == "object" && (e = `All Inertia requests must receive a valid Inertia response, however a plain JSON response was received.<hr>${JSON.stringify(e)}`);
  let t = document.createElement("html");
  t.innerHTML = e, t.querySelectorAll("a").forEach((n) => n.setAttribute("target", "_top")), this.modal = document.createElement("div"), this.modal.style.position = "fixed", this.modal.style.width = "100vw", this.modal.style.height = "100vh", this.modal.style.padding = "50px", this.modal.style.boxSizing = "border-box", this.modal.style.backgroundColor = "rgba(0, 0, 0, .6)", this.modal.style.zIndex = 2e5, this.modal.addEventListener("click", () => this.hide());
  let r = document.createElement("iframe");
  if (r.style.backgroundColor = "white", r.style.borderRadius = "5px", r.style.width = "100%", r.style.height = "100%", this.modal.appendChild(r), document.body.prepend(this.modal), document.body.style.overflow = "hidden", !r.contentWindow) throw new Error("iframe not yet ready.");
  r.contentWindow.document.open(), r.contentWindow.document.write(t.outerHTML), r.contentWindow.document.close(), this.listener = this.hideOnEscape.bind(this), document.addEventListener("keydown", this.listener);
}, hide() {
  this.modal.outerHTML = "", this.modal = null, document.body.style.overflow = "visible", document.removeEventListener("keydown", this.listener);
}, hideOnEscape(e) {
  e.keyCode === 27 && this.hide();
} };
function Uo(e) {
  return new URL(e.toString(), window.location.toString());
}
function xw(e, t, r, n = "brackets") {
  let o = /^https?:\/\//.test(t.toString()), a = o || t.toString().startsWith("/"), i = !a && !t.toString().startsWith("#") && !t.toString().startsWith("?"), s = t.toString().includes("?") || e === "get" && Object.keys(r).length, l = t.toString().includes("#"), u = new URL(t.toString(), "http://localhost");
  return e === "get" && Object.keys(r).length && (u.search = c0.stringify(i3(c0.parse(u.search, { ignoreQueryPrefix: !0 }), r), { encodeValuesOnly: !0, arrayFormat: n }), r = {}), [[o ? `${u.protocol}//${u.host}` : "", a ? u.pathname : "", i ? u.pathname.substring(1) : "", s ? u.search : "", l ? u.hash : ""].join(""), r];
}
function Vi(e) {
  return e = new URL(e.href), e.hash = "", e;
}
var p0 = typeof window > "u", F3 = class {
  constructor() {
    this.visitId = null;
  }
  init({ initialPage: e, resolveComponent: t, swapComponent: r }) {
    this.page = e, this.resolveComponent = t, this.swapComponent = r, this.setNavigationType(), this.clearRememberedStateOnReload(), this.isBackForwardVisit() ? this.handleBackForwardVisit(this.page) : this.isLocationVisit() ? this.handleLocationVisit(this.page) : this.handleInitialPageVisit(this.page), this.setupEventListeners();
  }
  setNavigationType() {
    this.navigationType = window.performance && window.performance.getEntriesByType("navigation").length > 0 ? window.performance.getEntriesByType("navigation")[0].type : "navigate";
  }
  clearRememberedStateOnReload() {
    var e;
    this.navigationType === "reload" && ((e = window.history.state) != null && e.rememberedState) && delete window.history.state.rememberedState;
  }
  handleInitialPageVisit(e) {
    this.page.url += window.location.hash, this.setPage(e, { preserveState: !0 }).then(() => Wi(e));
  }
  setupEventListeners() {
    window.addEventListener("popstate", this.handlePopstateEvent.bind(this)), document.addEventListener("scroll", bw(this.handleScrollEvent.bind(this), 100), !0);
  }
  scrollRegions() {
    return document.querySelectorAll("[scroll-region]");
  }
  handleScrollEvent(e) {
    typeof e.target.hasAttribute == "function" && e.target.hasAttribute("scroll-region") && this.saveScrollPositions();
  }
  saveScrollPositions() {
    this.replaceState({ ...this.page, scrollRegions: Array.from(this.scrollRegions()).map((e) => ({ top: e.scrollTop, left: e.scrollLeft })) });
  }
  resetScrollPositions() {
    window.scrollTo(0, 0), this.scrollRegions().forEach((e) => {
      typeof e.scrollTo == "function" ? e.scrollTo(0, 0) : (e.scrollTop = 0, e.scrollLeft = 0);
    }), this.saveScrollPositions(), window.location.hash && setTimeout(() => {
      var e;
      return (e = document.getElementById(window.location.hash.slice(1))) == null ? void 0 : e.scrollIntoView();
    });
  }
  restoreScrollPositions() {
    this.page.scrollRegions && this.scrollRegions().forEach((e, t) => {
      let r = this.page.scrollRegions[t];
      if (r) typeof e.scrollTo == "function" ? e.scrollTo(r.left, r.top) : (e.scrollTop = r.top, e.scrollLeft = r.left);
      else return;
    });
  }
  isBackForwardVisit() {
    return window.history.state && this.navigationType === "back_forward";
  }
  handleBackForwardVisit(e) {
    window.history.state.version = e.version, this.setPage(window.history.state, { preserveScroll: !0, preserveState: !0 }).then(() => {
      this.restoreScrollPositions(), Wi(e);
    });
  }
  locationVisit(e, t) {
    try {
      let r = { preserveScroll: t };
      window.sessionStorage.setItem("inertiaLocationVisit", JSON.stringify(r)), window.location.href = e.href, Vi(window.location).href === Vi(e).href && window.location.reload();
    } catch {
      return !1;
    }
  }
  isLocationVisit() {
    try {
      return window.sessionStorage.getItem("inertiaLocationVisit") !== null;
    } catch {
      return !1;
    }
  }
  handleLocationVisit(e) {
    var r, n;
    let t = JSON.parse(window.sessionStorage.getItem("inertiaLocationVisit") || "");
    window.sessionStorage.removeItem("inertiaLocationVisit"), e.url += window.location.hash, e.rememberedState = ((r = window.history.state) == null ? void 0 : r.rememberedState) ?? {}, e.scrollRegions = ((n = window.history.state) == null ? void 0 : n.scrollRegions) ?? [], this.setPage(e, { preserveScroll: t.preserveScroll, preserveState: !0 }).then(() => {
      t.preserveScroll && this.restoreScrollPositions(), Wi(e);
    });
  }
  isLocationVisitResponse(e) {
    return !!(e && e.status === 409 && e.headers["x-inertia-location"]);
  }
  isInertiaResponse(e) {
    return !!(e != null && e.headers["x-inertia"]);
  }
  createVisitId() {
    return this.visitId = {}, this.visitId;
  }
  cancelVisit(e, { cancelled: t = !1, interrupted: r = !1 }) {
    e && !e.completed && !e.cancelled && !e.interrupted && (e.cancelToken.abort(), e.onCancel(), e.completed = !1, e.cancelled = t, e.interrupted = r, f0(e), e.onFinish(e));
  }
  finishVisit(e) {
    !e.cancelled && !e.interrupted && (e.completed = !0, e.cancelled = !1, e.interrupted = !1, f0(e), e.onFinish(e));
  }
  resolvePreserveOption(e, t) {
    return typeof e == "function" ? e(t) : e === "errors" ? Object.keys(t.props.errors || {}).length > 0 : e;
  }
  cancel() {
    this.activeVisit && this.cancelVisit(this.activeVisit, { cancelled: !0 });
  }
  visit(e, { method: t = "get", data: r = {}, replace: n = !1, preserveScroll: o = !1, preserveState: a = !1, only: i = [], except: s = [], headers: l = {}, errorBag: u = "", forceFormData: c = !1, onCancelToken: d = () => {
  }, onBefore: h = () => {
  }, onStart: y = () => {
  }, onProgress: m = () => {
  }, onFinish: p = () => {
  }, onCancel: f = () => {
  }, onSuccess: v = () => {
  }, onError: w = () => {
  }, queryStringArrayFormat: _ = "brackets" } = {}) {
    let T = typeof e == "string" ? Uo(e) : e;
    if ((rp(r) || c) && !(r instanceof FormData) && (r = ww(r)), !(r instanceof FormData)) {
      let [I, C] = xw(t, T, r, _);
      T = Uo(I), r = C;
    }
    let A = { url: T, method: t, data: r, replace: n, preserveScroll: o, preserveState: a, only: i, except: s, headers: l, errorBag: u, forceFormData: c, queryStringArrayFormat: _, cancelled: !1, completed: !1, interrupted: !1 };
    if (h(A) === !1 || !P3(A)) return;
    this.activeVisit && this.cancelVisit(this.activeVisit, { interrupted: !0 }), this.saveScrollPositions();
    let O = this.createVisitId();
    this.activeVisit = { ...A, onCancelToken: d, onBefore: h, onStart: y, onProgress: m, onFinish: p, onCancel: f, onSuccess: v, onError: w, queryStringArrayFormat: _, cancelToken: new AbortController() }, d({ cancel: () => {
      this.activeVisit && this.cancelVisit(this.activeVisit, { cancelled: !0 });
    } }), B3(A), y(A);
    let M = !!(i.length || s.length);
    mt({ method: t, url: Vi(T).href, data: t === "get" ? {} : r, params: t === "get" ? r : {}, signal: this.activeVisit.cancelToken.signal, headers: { ...l, Accept: "text/html, application/xhtml+xml", "X-Requested-With": "XMLHttpRequest", "X-Inertia": !0, ...M ? { "X-Inertia-Partial-Component": this.page.component } : {}, ...i.length ? { "X-Inertia-Partial-Data": i.join(",") } : {}, ...s.length ? { "X-Inertia-Partial-Except": s.join(",") } : {}, ...u && u.length ? { "X-Inertia-Error-Bag": u } : {}, ...this.page.version ? { "X-Inertia-Version": this.page.version } : {} }, onUploadProgress: (I) => {
      r instanceof FormData && (I.percentage = I.progress ? Math.round(I.progress * 100) : 0, M3(I), m(I));
    } }).then((I) => {
      var k;
      if (!this.isInertiaResponse(I)) return Promise.reject({ response: I });
      let C = I.data;
      M && C.component === this.page.component && (C.props = { ...this.page.props, ...C.props }), o = this.resolvePreserveOption(o, C), a = this.resolvePreserveOption(a, C), a && ((k = window.history.state) != null && k.rememberedState) && C.component === this.page.component && (C.rememberedState = window.history.state.rememberedState);
      let E = T, R = Uo(C.url);
      return E.hash && !R.hash && Vi(E).href === R.href && (R.hash = E.hash, C.url = R.href), this.setPage(C, { visitId: O, replace: n, preserveScroll: o, preserveState: a });
    }).then(() => {
      let I = this.page.props.errors || {};
      if (Object.keys(I).length > 0) {
        let C = u ? I[u] ? I[u] : {} : I;
        return I3(C), w(C);
      }
      return q3(this.page), v(this.page);
    }).catch((I) => {
      if (this.isInertiaResponse(I.response)) return this.setPage(I.response.data, { visitId: O });
      if (this.isLocationVisitResponse(I.response)) {
        let C = Uo(I.response.headers["x-inertia-location"]), E = T;
        E.hash && !C.hash && Vi(E).href === C.href && (C.hash = E.hash), this.locationVisit(C, o === !0);
      } else if (I.response) R3(I.response) && L3.show(I.response.data);
      else return Promise.reject(I);
    }).then(() => {
      this.activeVisit && this.finishVisit(this.activeVisit);
    }).catch((I) => {
      if (!mt.isCancel(I)) {
        let C = D3(I);
        if (this.activeVisit && this.finishVisit(this.activeVisit), C) return Promise.reject(I);
      }
    });
  }
  setPage(e, { visitId: t = this.createVisitId(), replace: r = !1, preserveScroll: n = !1, preserveState: o = !1 } = {}) {
    return Promise.resolve(this.resolveComponent(e.component)).then((a) => {
      t === this.visitId && (e.scrollRegions = e.scrollRegions || [], e.rememberedState = e.rememberedState || {}, r = r || Uo(e.url).href === window.location.href, r ? this.replaceState(e) : this.pushState(e), this.swapComponent({ component: a, page: e, preserveState: o }).then(() => {
        n || this.resetScrollPositions(), r || Wi(e);
      }));
    });
  }
  pushState(e) {
    this.page = e, window.history.pushState(e, "", e.url);
  }
  replaceState(e) {
    this.page = e, window.history.replaceState(e, "", e.url);
  }
  handlePopstateEvent(e) {
    if (e.state !== null) {
      let t = e.state, r = this.createVisitId();
      Promise.resolve(this.resolveComponent(t.component)).then((n) => {
        r === this.visitId && (this.page = t, this.swapComponent({ component: n, page: t, preserveState: !1 }).then(() => {
          this.restoreScrollPositions(), Wi(t);
        }));
      });
    } else {
      let t = Uo(this.page.url);
      t.hash = window.location.hash, this.replaceState({ ...this.page, url: t.href }), this.resetScrollPositions();
    }
  }
  get(e, t = {}, r = {}) {
    return this.visit(e, { ...r, method: "get", data: t });
  }
  reload(e = {}) {
    return this.visit(window.location.href, { ...e, preserveScroll: !0, preserveState: !0 });
  }
  replace(e, t = {}) {
    return console.warn(`Inertia.replace() has been deprecated and will be removed in a future release. Please use Inertia.${t.method ?? "get"}() instead.`), this.visit(e, { preserveState: !0, ...t, replace: !0 });
  }
  post(e, t = {}, r = {}) {
    return this.visit(e, { preserveState: !0, ...r, method: "post", data: t });
  }
  put(e, t = {}, r = {}) {
    return this.visit(e, { preserveState: !0, ...r, method: "put", data: t });
  }
  patch(e, t = {}, r = {}) {
    return this.visit(e, { preserveState: !0, ...r, method: "patch", data: t });
  }
  delete(e, t = {}) {
    return this.visit(e, { preserveState: !0, ...t, method: "delete" });
  }
  remember(e, t = "default") {
    var r;
    p0 || this.replaceState({ ...this.page, rememberedState: { ...(r = this.page) == null ? void 0 : r.rememberedState, [t]: e } });
  }
  restore(e = "default") {
    var t, r;
    if (!p0) return (r = (t = window.history.state) == null ? void 0 : t.rememberedState) == null ? void 0 : r[e];
  }
  on(e, t) {
    let r = (n) => {
      let o = t(n);
      n.cancelable && !n.defaultPrevented && o === !1 && n.preventDefault();
    };
    return document.addEventListener(`inertia:${e}`, r), () => document.removeEventListener(`inertia:${e}`, r);
  }
}, N3 = { buildDOMElement(e) {
  let t = document.createElement("template");
  t.innerHTML = e;
  let r = t.content.firstChild;
  if (!e.startsWith("<script ")) return r;
  let n = document.createElement("script");
  return n.innerHTML = r.innerHTML, r.getAttributeNames().forEach((o) => {
    n.setAttribute(o, r.getAttribute(o) || "");
  }), n;
}, isInertiaManagedElement(e) {
  return e.nodeType === Node.ELEMENT_NODE && e.getAttribute("inertia") !== null;
}, findMatchingElementIndex(e, t) {
  let r = e.getAttribute("inertia");
  return r !== null ? t.findIndex((n) => n.getAttribute("inertia") === r) : -1;
}, update: bw(function(e) {
  let t = e.map((r) => this.buildDOMElement(r));
  Array.from(document.head.childNodes).filter((r) => this.isInertiaManagedElement(r)).forEach((r) => {
    var a, i;
    let n = this.findMatchingElementIndex(r, t);
    if (n === -1) {
      (a = r == null ? void 0 : r.parentNode) == null || a.removeChild(r);
      return;
    }
    let o = t.splice(n, 1)[0];
    o && !r.isEqualNode(o) && ((i = r == null ? void 0 : r.parentNode) == null || i.replaceChild(o, r));
  }), t.forEach((r) => document.head.appendChild(r));
}, 1) };
function z3(e, t, r) {
  let n = {}, o = 0;
  function a() {
    let c = o += 1;
    return n[c] = [], c.toString();
  }
  function i(c) {
    c === null || Object.keys(n).indexOf(c) === -1 || (delete n[c], u());
  }
  function s(c, d = []) {
    c !== null && Object.keys(n).indexOf(c) > -1 && (n[c] = d), u();
  }
  function l() {
    let c = t(""), d = { ...c ? { title: `<title inertia="">${c}</title>` } : {} }, h = Object.values(n).reduce((y, m) => y.concat(m), []).reduce((y, m) => {
      if (m.indexOf("<") === -1) return y;
      if (m.indexOf("<title ") === 0) {
        let f = m.match(/(<title [^>]+>)(.*?)(<\/title>)/);
        return y.title = f ? `${f[1]}${t(f[2])}${f[3]}` : m, y;
      }
      let p = m.match(/ inertia="[^"]+"/);
      return p ? y[p[0]] = m : y[Object.keys(y).length] = m, y;
    }, d);
    return Object.values(h);
  }
  function u() {
    e ? r(l()) : N3.update(l());
  }
  return u(), { forceUpdate: u, createProvider: function() {
    let c = a();
    return { update: (d) => s(c, d), disconnect: () => i(c) };
  } };
}
function j3(e) {
  let t = e.currentTarget.tagName.toLowerCase() === "a";
  return !(e.target && (e == null ? void 0 : e.target).isContentEditable || e.defaultPrevented || t && e.which > 1 || t && e.altKey || t && e.ctrlKey || t && e.metaKey || t && e.shiftKey);
}
var np = new F3(), Ki = { exports: {} };
Ki.exports;
var h0;
function U3() {
  return h0 || (h0 = 1, function(e, t) {
    var r = 200, n = "__lodash_hash_undefined__", o = 9007199254740991, a = "[object Arguments]", i = "[object Array]", s = "[object Boolean]", l = "[object Date]", u = "[object Error]", c = "[object Function]", d = "[object GeneratorFunction]", h = "[object Map]", y = "[object Number]", m = "[object Object]", p = "[object Promise]", f = "[object RegExp]", v = "[object Set]", w = "[object String]", _ = "[object Symbol]", T = "[object WeakMap]", A = "[object ArrayBuffer]", O = "[object DataView]", M = "[object Float32Array]", I = "[object Float64Array]", C = "[object Int8Array]", E = "[object Int16Array]", R = "[object Int32Array]", k = "[object Uint8Array]", L = "[object Uint8ClampedArray]", z = "[object Uint16Array]", F = "[object Uint32Array]", q = /[\\^$.*+?()[\]{}|]/g, j = /\w*$/, D = /^\[object .+?Constructor\]$/, H = /^(?:0|[1-9]\d*)$/, W = {};
    W[a] = W[i] = W[A] = W[O] = W[s] = W[l] = W[M] = W[I] = W[C] = W[E] = W[R] = W[h] = W[y] = W[m] = W[f] = W[v] = W[w] = W[_] = W[k] = W[L] = W[z] = W[F] = !0, W[u] = W[c] = W[T] = !1;
    var ee = typeof Ht == "object" && Ht && Ht.Object === Object && Ht, oe = typeof self == "object" && self && self.Object === Object && self, J = ee || oe || Function("return this")(), N = t && !t.nodeType && t, Q = N && !0 && e && !e.nodeType && e, de = Q && Q.exports === N;
    function G(b, g) {
      return b.set(g[0], g[1]), b;
    }
    function ce(b, g) {
      return b.add(g), b;
    }
    function be(b, g) {
      for (var x = -1, P = b ? b.length : 0; ++x < P && g(b[x], x, b) !== !1; )
        ;
      return b;
    }
    function ve(b, g) {
      for (var x = -1, P = g.length, ae = b.length; ++x < P; )
        b[ae + x] = g[x];
      return b;
    }
    function fe(b, g, x, P) {
      for (var ae = -1, le = b ? b.length : 0; ++ae < le; )
        x = g(x, b[ae], ae, b);
      return x;
    }
    function Oe(b, g) {
      for (var x = -1, P = Array(b); ++x < b; )
        P[x] = g(x);
      return P;
    }
    function Ge(b, g) {
      return b == null ? void 0 : b[g];
    }
    function we(b) {
      var g = !1;
      if (b != null && typeof b.toString != "function")
        try {
          g = !!(b + "");
        } catch {
        }
      return g;
    }
    function Me(b) {
      var g = -1, x = Array(b.size);
      return b.forEach(function(P, ae) {
        x[++g] = [ae, P];
      }), x;
    }
    function Ct(b, g) {
      return function(x) {
        return b(g(x));
      };
    }
    function _t(b) {
      var g = -1, x = Array(b.size);
      return b.forEach(function(P) {
        x[++g] = P;
      }), x;
    }
    var vt = Array.prototype, st = Function.prototype, rt = Object.prototype, ut = J["__core-js_shared__"], St = function() {
      var b = /[^.]+$/.exec(ut && ut.keys && ut.keys.IE_PROTO || "");
      return b ? "Symbol(src)_1." + b : "";
    }(), xt = st.toString, gt = rt.hasOwnProperty, Ft = rt.toString, cr = RegExp(
      "^" + xt.call(gt).replace(q, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
    ), Yt = de ? J.Buffer : void 0, Ut = J.Symbol, Sr = J.Uint8Array, kt = Ct(Object.getPrototypeOf, Object), dr = Object.create, xr = rt.propertyIsEnumerable, K = vt.splice, Z = Object.getOwnPropertySymbols, Pe = Yt ? Yt.isBuffer : void 0, Le = Ct(Object.keys, Object), He = rr(J, "DataView"), $e = rr(J, "Map"), pt = rr(J, "Promise"), Nt = rr(J, "Set"), nt = rr(J, "WeakMap"), Rt = rr(Object, "create"), zt = It(He), Wt = It($e), Pt = It(pt), Vr = It(Nt), Hr = It(nt), fr = Ut ? Ut.prototype : void 0, At = fr ? fr.valueOf : void 0;
    function Jt(b) {
      var g = -1, x = b ? b.length : 0;
      for (this.clear(); ++g < x; ) {
        var P = b[g];
        this.set(P[0], P[1]);
      }
    }
    function Gr() {
      this.__data__ = Rt ? Rt(null) : {};
    }
    function an(b) {
      return this.has(b) && delete this.__data__[b];
    }
    function sn(b) {
      var g = this.__data__;
      if (Rt) {
        var x = g[b];
        return x === n ? void 0 : x;
      }
      return gt.call(g, b) ? g[b] : void 0;
    }
    function ln(b) {
      var g = this.__data__;
      return Rt ? g[b] !== void 0 : gt.call(g, b);
    }
    function Zt(b, g) {
      var x = this.__data__;
      return x[b] = Rt && g === void 0 ? n : g, this;
    }
    Jt.prototype.clear = Gr, Jt.prototype.delete = an, Jt.prototype.get = sn, Jt.prototype.has = ln, Jt.prototype.set = Zt;
    function ct(b) {
      var g = -1, x = b ? b.length : 0;
      for (this.clear(); ++g < x; ) {
        var P = b[g];
        this.set(P[0], P[1]);
      }
    }
    function kn() {
      this.__data__ = [];
    }
    function un(b) {
      var g = this.__data__, x = Mn(g, b);
      if (x < 0)
        return !1;
      var P = g.length - 1;
      return x == P ? g.pop() : K.call(g, x, 1), !0;
    }
    function Pn(b) {
      var g = this.__data__, x = Mn(g, b);
      return x < 0 ? void 0 : g[x][1];
    }
    function oo(b) {
      return Mn(this.__data__, b) > -1;
    }
    function tr(b, g) {
      var x = this.__data__, P = Mn(x, b);
      return P < 0 ? x.push([b, g]) : x[P][1] = g, this;
    }
    ct.prototype.clear = kn, ct.prototype.delete = un, ct.prototype.get = Pn, ct.prototype.has = oo, ct.prototype.set = tr;
    function ot(b) {
      var g = -1, x = b ? b.length : 0;
      for (this.clear(); ++g < x; ) {
        var P = b[g];
        this.set(P[0], P[1]);
      }
    }
    function Kr() {
      this.__data__ = {
        hash: new Jt(),
        map: new ($e || ct)(),
        string: new Jt()
      };
    }
    function io(b) {
      return fn(this, b).delete(b);
    }
    function In(b) {
      return fn(this, b).get(b);
    }
    function _i(b) {
      return fn(this, b).has(b);
    }
    function Si(b, g) {
      return fn(this, b).set(b, g), this;
    }
    ot.prototype.clear = Kr, ot.prototype.delete = io, ot.prototype.get = In, ot.prototype.has = _i, ot.prototype.set = Si;
    function Mt(b) {
      this.__data__ = new ct(b);
    }
    function xi() {
      this.__data__ = new ct();
    }
    function Dn(b) {
      return this.__data__.delete(b);
    }
    function ao(b) {
      return this.__data__.get(b);
    }
    function Ai(b) {
      return this.__data__.has(b);
    }
    function Rn(b, g) {
      var x = this.__data__;
      if (x instanceof ct) {
        var P = x.__data__;
        if (!$e || P.length < r - 1)
          return P.push([b, g]), this;
        x = this.__data__ = new ot(P);
      }
      return x.set(b, g), this;
    }
    Mt.prototype.clear = xi, Mt.prototype.delete = Dn, Mt.prototype.get = ao, Mt.prototype.has = Ai, Mt.prototype.set = Rn;
    function cn(b, g) {
      var x = hn(b) || pn(b) ? Oe(b.length, String) : [], P = x.length, ae = !!P;
      for (var le in b)
        gt.call(b, le) && !(ae && (le == "length" || Bi(le, P))) && x.push(le);
      return x;
    }
    function Ro(b, g, x) {
      var P = b[g];
      (!(gt.call(b, g) && qo(P, x)) || x === void 0 && !(g in b)) && (b[g] = x);
    }
    function Mn(b, g) {
      for (var x = b.length; x--; )
        if (qo(b[x][0], g))
          return x;
      return -1;
    }
    function Ar(b, g) {
      return b && Fn(g, po(g), b);
    }
    function Bn(b, g, x, P, ae, le, Se) {
      var xe;
      if (P && (xe = le ? P(b, ae, le, Se) : P(b)), xe !== void 0)
        return xe;
      if (!Tr(b))
        return b;
      var Ee = hn(b);
      if (Ee) {
        if (xe = Ri(b), !g)
          return Pi(b, xe);
      } else {
        var Ae = Mr(b), Ke = Ae == c || Ae == d;
        if (Yr(b))
          return qn(b, g);
        if (Ae == m || Ae == a || Ke && !le) {
          if (we(b))
            return le ? b : {};
          if (xe = nr(Ke ? {} : b), !g)
            return Ii(b, Ar(xe, b));
        } else {
          if (!W[Ae])
            return le ? b : {};
          xe = Mi(b, Ae, Bn, g);
        }
      }
      Se || (Se = new Mt());
      var Ye = Se.get(b);
      if (Ye)
        return Ye;
      if (Se.set(b, xe), !Ee)
        var it = x ? Di(b) : po(b);
      return be(it || b, function(Tt, yt) {
        it && (yt = Tt, Tt = b[yt]), Ro(xe, yt, Bn(Tt, g, x, P, yt, b, Se));
      }), xe;
    }
    function Ti(b) {
      return Tr(b) ? dr(b) : {};
    }
    function Ei(b, g, x) {
      var P = g(b);
      return hn(b) ? P : ve(P, x(b));
    }
    function Oi(b) {
      return Ft.call(b);
    }
    function $i(b) {
      if (!Tr(b) || Nn(b))
        return !1;
      var g = uo(b) || we(b) ? cr : D;
      return g.test(It(b));
    }
    function Ci(b) {
      if (!zn(b))
        return Le(b);
      var g = [];
      for (var x in Object(b))
        gt.call(b, x) && x != "constructor" && g.push(x);
      return g;
    }
    function qn(b, g) {
      if (g)
        return b.slice();
      var x = new b.constructor(b.length);
      return b.copy(x), x;
    }
    function so(b) {
      var g = new b.constructor(b.byteLength);
      return new Sr(g).set(new Sr(b)), g;
    }
    function dn(b, g) {
      var x = g ? so(b.buffer) : b.buffer;
      return new b.constructor(x, b.byteOffset, b.byteLength);
    }
    function Mo(b, g, x) {
      var P = g ? x(Me(b), !0) : Me(b);
      return fe(P, G, new b.constructor());
    }
    function Bo(b) {
      var g = new b.constructor(b.source, j.exec(b));
      return g.lastIndex = b.lastIndex, g;
    }
    function Ln(b, g, x) {
      var P = g ? x(_t(b), !0) : _t(b);
      return fe(P, ce, new b.constructor());
    }
    function lo(b) {
      return At ? Object(At.call(b)) : {};
    }
    function ki(b, g) {
      var x = g ? so(b.buffer) : b.buffer;
      return new b.constructor(x, b.byteOffset, b.length);
    }
    function Pi(b, g) {
      var x = -1, P = b.length;
      for (g || (g = Array(P)); ++x < P; )
        g[x] = b[x];
      return g;
    }
    function Fn(b, g, x, P) {
      x || (x = {});
      for (var ae = -1, le = g.length; ++ae < le; ) {
        var Se = g[ae], xe = void 0;
        Ro(x, Se, xe === void 0 ? b[Se] : xe);
      }
      return x;
    }
    function Ii(b, g) {
      return Fn(b, Rr(b), g);
    }
    function Di(b) {
      return Ei(b, po, Rr);
    }
    function fn(b, g) {
      var x = b.__data__;
      return qi(g) ? x[typeof g == "string" ? "string" : "hash"] : x.map;
    }
    function rr(b, g) {
      var x = Ge(b, g);
      return $i(x) ? x : void 0;
    }
    var Rr = Z ? Ct(Z, Object) : Li, Mr = Oi;
    (He && Mr(new He(new ArrayBuffer(1))) != O || $e && Mr(new $e()) != h || pt && Mr(pt.resolve()) != p || Nt && Mr(new Nt()) != v || nt && Mr(new nt()) != T) && (Mr = function(b) {
      var g = Ft.call(b), x = g == m ? b.constructor : void 0, P = x ? It(x) : void 0;
      if (P)
        switch (P) {
          case zt:
            return O;
          case Wt:
            return h;
          case Pt:
            return p;
          case Vr:
            return v;
          case Hr:
            return T;
        }
      return g;
    });
    function Ri(b) {
      var g = b.length, x = b.constructor(g);
      return g && typeof b[0] == "string" && gt.call(b, "index") && (x.index = b.index, x.input = b.input), x;
    }
    function nr(b) {
      return typeof b.constructor == "function" && !zn(b) ? Ti(kt(b)) : {};
    }
    function Mi(b, g, x, P) {
      var ae = b.constructor;
      switch (g) {
        case A:
          return so(b);
        case s:
        case l:
          return new ae(+b);
        case O:
          return dn(b, P);
        case M:
        case I:
        case C:
        case E:
        case R:
        case k:
        case L:
        case z:
        case F:
          return ki(b, P);
        case h:
          return Mo(b, P, x);
        case y:
        case w:
          return new ae(b);
        case f:
          return Bo(b);
        case v:
          return Ln(b, P, x);
        case _:
          return lo(b);
      }
    }
    function Bi(b, g) {
      return g = g ?? o, !!g && (typeof b == "number" || H.test(b)) && b > -1 && b % 1 == 0 && b < g;
    }
    function qi(b) {
      var g = typeof b;
      return g == "string" || g == "number" || g == "symbol" || g == "boolean" ? b !== "__proto__" : b === null;
    }
    function Nn(b) {
      return !!St && St in b;
    }
    function zn(b) {
      var g = b && b.constructor, x = typeof g == "function" && g.prototype || rt;
      return b === x;
    }
    function It(b) {
      if (b != null) {
        try {
          return xt.call(b);
        } catch {
        }
        try {
          return b + "";
        } catch {
        }
      }
      return "";
    }
    function jn(b) {
      return Bn(b, !0, !0);
    }
    function qo(b, g) {
      return b === g || b !== b && g !== g;
    }
    function pn(b) {
      return Br(b) && gt.call(b, "callee") && (!xr.call(b, "callee") || Ft.call(b) == a);
    }
    var hn = Array.isArray;
    function mn(b) {
      return b != null && co(b.length) && !uo(b);
    }
    function Br(b) {
      return fo(b) && mn(b);
    }
    var Yr = Pe || Lo;
    function uo(b) {
      var g = Tr(b) ? Ft.call(b) : "";
      return g == c || g == d;
    }
    function co(b) {
      return typeof b == "number" && b > -1 && b % 1 == 0 && b <= o;
    }
    function Tr(b) {
      var g = typeof b;
      return !!b && (g == "object" || g == "function");
    }
    function fo(b) {
      return !!b && typeof b == "object";
    }
    function po(b) {
      return mn(b) ? cn(b) : Ci(b);
    }
    function Li() {
      return [];
    }
    function Lo() {
      return !1;
    }
    e.exports = jn;
  }(Ki, Ki.exports)), Ki.exports;
}
U3();
var Yi = { exports: {} };
Yi.exports;
var m0;
function W3() {
  return m0 || (m0 = 1, function(e, t) {
    var r = 200, n = "__lodash_hash_undefined__", o = 1, a = 2, i = 9007199254740991, s = "[object Arguments]", l = "[object Array]", u = "[object AsyncFunction]", c = "[object Boolean]", d = "[object Date]", h = "[object Error]", y = "[object Function]", m = "[object GeneratorFunction]", p = "[object Map]", f = "[object Number]", v = "[object Null]", w = "[object Object]", _ = "[object Promise]", T = "[object Proxy]", A = "[object RegExp]", O = "[object Set]", M = "[object String]", I = "[object Symbol]", C = "[object Undefined]", E = "[object WeakMap]", R = "[object ArrayBuffer]", k = "[object DataView]", L = "[object Float32Array]", z = "[object Float64Array]", F = "[object Int8Array]", q = "[object Int16Array]", j = "[object Int32Array]", D = "[object Uint8Array]", H = "[object Uint8ClampedArray]", W = "[object Uint16Array]", ee = "[object Uint32Array]", oe = /[\\^$.*+?()[\]{}|]/g, J = /^\[object .+?Constructor\]$/, N = /^(?:0|[1-9]\d*)$/, Q = {};
    Q[L] = Q[z] = Q[F] = Q[q] = Q[j] = Q[D] = Q[H] = Q[W] = Q[ee] = !0, Q[s] = Q[l] = Q[R] = Q[c] = Q[k] = Q[d] = Q[h] = Q[y] = Q[p] = Q[f] = Q[w] = Q[A] = Q[O] = Q[M] = Q[E] = !1;
    var de = typeof Ht == "object" && Ht && Ht.Object === Object && Ht, G = typeof self == "object" && self && self.Object === Object && self, ce = de || G || Function("return this")(), be = t && !t.nodeType && t, ve = be && !0 && e && !e.nodeType && e, fe = ve && ve.exports === be, Oe = fe && de.process, Ge = function() {
      try {
        return Oe && Oe.binding && Oe.binding("util");
      } catch {
      }
    }(), we = Ge && Ge.isTypedArray;
    function Me(b, g) {
      for (var x = -1, P = b == null ? 0 : b.length, ae = 0, le = []; ++x < P; ) {
        var Se = b[x];
        g(Se, x, b) && (le[ae++] = Se);
      }
      return le;
    }
    function Ct(b, g) {
      for (var x = -1, P = g.length, ae = b.length; ++x < P; )
        b[ae + x] = g[x];
      return b;
    }
    function _t(b, g) {
      for (var x = -1, P = b == null ? 0 : b.length; ++x < P; )
        if (g(b[x], x, b))
          return !0;
      return !1;
    }
    function vt(b, g) {
      for (var x = -1, P = Array(b); ++x < b; )
        P[x] = g(x);
      return P;
    }
    function st(b) {
      return function(g) {
        return b(g);
      };
    }
    function rt(b, g) {
      return b.has(g);
    }
    function ut(b, g) {
      return b == null ? void 0 : b[g];
    }
    function St(b) {
      var g = -1, x = Array(b.size);
      return b.forEach(function(P, ae) {
        x[++g] = [ae, P];
      }), x;
    }
    function xt(b, g) {
      return function(x) {
        return b(g(x));
      };
    }
    function gt(b) {
      var g = -1, x = Array(b.size);
      return b.forEach(function(P) {
        x[++g] = P;
      }), x;
    }
    var Ft = Array.prototype, cr = Function.prototype, Yt = Object.prototype, Ut = ce["__core-js_shared__"], Sr = cr.toString, kt = Yt.hasOwnProperty, dr = function() {
      var b = /[^.]+$/.exec(Ut && Ut.keys && Ut.keys.IE_PROTO || "");
      return b ? "Symbol(src)_1." + b : "";
    }(), xr = Yt.toString, K = RegExp(
      "^" + Sr.call(kt).replace(oe, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
    ), Z = fe ? ce.Buffer : void 0, Pe = ce.Symbol, Le = ce.Uint8Array, He = Yt.propertyIsEnumerable, $e = Ft.splice, pt = Pe ? Pe.toStringTag : void 0, Nt = Object.getOwnPropertySymbols, nt = Z ? Z.isBuffer : void 0, Rt = xt(Object.keys, Object), zt = Rr(ce, "DataView"), Wt = Rr(ce, "Map"), Pt = Rr(ce, "Promise"), Vr = Rr(ce, "Set"), Hr = Rr(ce, "WeakMap"), fr = Rr(Object, "create"), At = It(zt), Jt = It(Wt), Gr = It(Pt), an = It(Vr), sn = It(Hr), ln = Pe ? Pe.prototype : void 0, Zt = ln ? ln.valueOf : void 0;
    function ct(b) {
      var g = -1, x = b == null ? 0 : b.length;
      for (this.clear(); ++g < x; ) {
        var P = b[g];
        this.set(P[0], P[1]);
      }
    }
    function kn() {
      this.__data__ = fr ? fr(null) : {}, this.size = 0;
    }
    function un(b) {
      var g = this.has(b) && delete this.__data__[b];
      return this.size -= g ? 1 : 0, g;
    }
    function Pn(b) {
      var g = this.__data__;
      if (fr) {
        var x = g[b];
        return x === n ? void 0 : x;
      }
      return kt.call(g, b) ? g[b] : void 0;
    }
    function oo(b) {
      var g = this.__data__;
      return fr ? g[b] !== void 0 : kt.call(g, b);
    }
    function tr(b, g) {
      var x = this.__data__;
      return this.size += this.has(b) ? 0 : 1, x[b] = fr && g === void 0 ? n : g, this;
    }
    ct.prototype.clear = kn, ct.prototype.delete = un, ct.prototype.get = Pn, ct.prototype.has = oo, ct.prototype.set = tr;
    function ot(b) {
      var g = -1, x = b == null ? 0 : b.length;
      for (this.clear(); ++g < x; ) {
        var P = b[g];
        this.set(P[0], P[1]);
      }
    }
    function Kr() {
      this.__data__ = [], this.size = 0;
    }
    function io(b) {
      var g = this.__data__, x = qn(g, b);
      if (x < 0)
        return !1;
      var P = g.length - 1;
      return x == P ? g.pop() : $e.call(g, x, 1), --this.size, !0;
    }
    function In(b) {
      var g = this.__data__, x = qn(g, b);
      return x < 0 ? void 0 : g[x][1];
    }
    function _i(b) {
      return qn(this.__data__, b) > -1;
    }
    function Si(b, g) {
      var x = this.__data__, P = qn(x, b);
      return P < 0 ? (++this.size, x.push([b, g])) : x[P][1] = g, this;
    }
    ot.prototype.clear = Kr, ot.prototype.delete = io, ot.prototype.get = In, ot.prototype.has = _i, ot.prototype.set = Si;
    function Mt(b) {
      var g = -1, x = b == null ? 0 : b.length;
      for (this.clear(); ++g < x; ) {
        var P = b[g];
        this.set(P[0], P[1]);
      }
    }
    function xi() {
      this.size = 0, this.__data__ = {
        hash: new ct(),
        map: new (Wt || ot)(),
        string: new ct()
      };
    }
    function Dn(b) {
      var g = rr(this, b).delete(b);
      return this.size -= g ? 1 : 0, g;
    }
    function ao(b) {
      return rr(this, b).get(b);
    }
    function Ai(b) {
      return rr(this, b).has(b);
    }
    function Rn(b, g) {
      var x = rr(this, b), P = x.size;
      return x.set(b, g), this.size += x.size == P ? 0 : 1, this;
    }
    Mt.prototype.clear = xi, Mt.prototype.delete = Dn, Mt.prototype.get = ao, Mt.prototype.has = Ai, Mt.prototype.set = Rn;
    function cn(b) {
      var g = -1, x = b == null ? 0 : b.length;
      for (this.__data__ = new Mt(); ++g < x; )
        this.add(b[g]);
    }
    function Ro(b) {
      return this.__data__.set(b, n), this;
    }
    function Mn(b) {
      return this.__data__.has(b);
    }
    cn.prototype.add = cn.prototype.push = Ro, cn.prototype.has = Mn;
    function Ar(b) {
      var g = this.__data__ = new ot(b);
      this.size = g.size;
    }
    function Bn() {
      this.__data__ = new ot(), this.size = 0;
    }
    function Ti(b) {
      var g = this.__data__, x = g.delete(b);
      return this.size = g.size, x;
    }
    function Ei(b) {
      return this.__data__.get(b);
    }
    function Oi(b) {
      return this.__data__.has(b);
    }
    function $i(b, g) {
      var x = this.__data__;
      if (x instanceof ot) {
        var P = x.__data__;
        if (!Wt || P.length < r - 1)
          return P.push([b, g]), this.size = ++x.size, this;
        x = this.__data__ = new Mt(P);
      }
      return x.set(b, g), this.size = x.size, this;
    }
    Ar.prototype.clear = Bn, Ar.prototype.delete = Ti, Ar.prototype.get = Ei, Ar.prototype.has = Oi, Ar.prototype.set = $i;
    function Ci(b, g) {
      var x = pn(b), P = !x && qo(b), ae = !x && !P && mn(b), le = !x && !P && !ae && fo(b), Se = x || P || ae || le, xe = Se ? vt(b.length, String) : [], Ee = xe.length;
      for (var Ae in b)
        kt.call(b, Ae) && !(Se && // Safari 9 has enumerable `arguments.length` in strict mode.
        (Ae == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
        ae && (Ae == "offset" || Ae == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
        le && (Ae == "buffer" || Ae == "byteLength" || Ae == "byteOffset") || // Skip index properties.
        Mi(Ae, Ee))) && xe.push(Ae);
      return xe;
    }
    function qn(b, g) {
      for (var x = b.length; x--; )
        if (jn(b[x][0], g))
          return x;
      return -1;
    }
    function so(b, g, x) {
      var P = g(b);
      return pn(b) ? P : Ct(P, x(b));
    }
    function dn(b) {
      return b == null ? b === void 0 ? C : v : pt && pt in Object(b) ? Mr(b) : zn(b);
    }
    function Mo(b) {
      return Tr(b) && dn(b) == s;
    }
    function Bo(b, g, x, P, ae) {
      return b === g ? !0 : b == null || g == null || !Tr(b) && !Tr(g) ? b !== b && g !== g : Ln(b, g, x, P, Bo, ae);
    }
    function Ln(b, g, x, P, ae, le) {
      var Se = pn(b), xe = pn(g), Ee = Se ? l : nr(b), Ae = xe ? l : nr(g);
      Ee = Ee == s ? w : Ee, Ae = Ae == s ? w : Ae;
      var Ke = Ee == w, Ye = Ae == w, it = Ee == Ae;
      if (it && mn(b)) {
        if (!mn(g))
          return !1;
        Se = !0, Ke = !1;
      }
      if (it && !Ke)
        return le || (le = new Ar()), Se || fo(b) ? Fn(b, g, x, P, ae, le) : Ii(b, g, Ee, x, P, ae, le);
      if (!(x & o)) {
        var Tt = Ke && kt.call(b, "__wrapped__"), yt = Ye && kt.call(g, "__wrapped__");
        if (Tt || yt) {
          var qr = Tt ? b.value() : b, vn = yt ? g.value() : g;
          return le || (le = new Ar()), ae(qr, vn, x, P, le);
        }
      }
      return it ? (le || (le = new Ar()), Di(b, g, x, P, ae, le)) : !1;
    }
    function lo(b) {
      if (!co(b) || qi(b))
        return !1;
      var g = Yr(b) ? K : J;
      return g.test(It(b));
    }
    function ki(b) {
      return Tr(b) && uo(b.length) && !!Q[dn(b)];
    }
    function Pi(b) {
      if (!Nn(b))
        return Rt(b);
      var g = [];
      for (var x in Object(b))
        kt.call(b, x) && x != "constructor" && g.push(x);
      return g;
    }
    function Fn(b, g, x, P, ae, le) {
      var Se = x & o, xe = b.length, Ee = g.length;
      if (xe != Ee && !(Se && Ee > xe))
        return !1;
      var Ae = le.get(b);
      if (Ae && le.get(g))
        return Ae == g;
      var Ke = -1, Ye = !0, it = x & a ? new cn() : void 0;
      for (le.set(b, g), le.set(g, b); ++Ke < xe; ) {
        var Tt = b[Ke], yt = g[Ke];
        if (P)
          var qr = Se ? P(yt, Tt, Ke, g, b, le) : P(Tt, yt, Ke, b, g, le);
        if (qr !== void 0) {
          if (qr)
            continue;
          Ye = !1;
          break;
        }
        if (it) {
          if (!_t(g, function(vn, ho) {
            if (!rt(it, ho) && (Tt === vn || ae(Tt, vn, x, P, le)))
              return it.push(ho);
          })) {
            Ye = !1;
            break;
          }
        } else if (!(Tt === yt || ae(Tt, yt, x, P, le))) {
          Ye = !1;
          break;
        }
      }
      return le.delete(b), le.delete(g), Ye;
    }
    function Ii(b, g, x, P, ae, le, Se) {
      switch (x) {
        case k:
          if (b.byteLength != g.byteLength || b.byteOffset != g.byteOffset)
            return !1;
          b = b.buffer, g = g.buffer;
        case R:
          return !(b.byteLength != g.byteLength || !le(new Le(b), new Le(g)));
        case c:
        case d:
        case f:
          return jn(+b, +g);
        case h:
          return b.name == g.name && b.message == g.message;
        case A:
        case M:
          return b == g + "";
        case p:
          var xe = St;
        case O:
          var Ee = P & o;
          if (xe || (xe = gt), b.size != g.size && !Ee)
            return !1;
          var Ae = Se.get(b);
          if (Ae)
            return Ae == g;
          P |= a, Se.set(b, g);
          var Ke = Fn(xe(b), xe(g), P, ae, le, Se);
          return Se.delete(b), Ke;
        case I:
          if (Zt)
            return Zt.call(b) == Zt.call(g);
      }
      return !1;
    }
    function Di(b, g, x, P, ae, le) {
      var Se = x & o, xe = fn(b), Ee = xe.length, Ae = fn(g), Ke = Ae.length;
      if (Ee != Ke && !Se)
        return !1;
      for (var Ye = Ee; Ye--; ) {
        var it = xe[Ye];
        if (!(Se ? it in g : kt.call(g, it)))
          return !1;
      }
      var Tt = le.get(b);
      if (Tt && le.get(g))
        return Tt == g;
      var yt = !0;
      le.set(b, g), le.set(g, b);
      for (var qr = Se; ++Ye < Ee; ) {
        it = xe[Ye];
        var vn = b[it], ho = g[it];
        if (P)
          var eh = Se ? P(ho, vn, it, g, b, le) : P(vn, ho, it, b, g, le);
        if (!(eh === void 0 ? vn === ho || ae(vn, ho, x, P, le) : eh)) {
          yt = !1;
          break;
        }
        qr || (qr = it == "constructor");
      }
      if (yt && !qr) {
        var ba = b.constructor, wa = g.constructor;
        ba != wa && "constructor" in b && "constructor" in g && !(typeof ba == "function" && ba instanceof ba && typeof wa == "function" && wa instanceof wa) && (yt = !1);
      }
      return le.delete(b), le.delete(g), yt;
    }
    function fn(b) {
      return so(b, po, Ri);
    }
    function rr(b, g) {
      var x = b.__data__;
      return Bi(g) ? x[typeof g == "string" ? "string" : "hash"] : x.map;
    }
    function Rr(b, g) {
      var x = ut(b, g);
      return lo(x) ? x : void 0;
    }
    function Mr(b) {
      var g = kt.call(b, pt), x = b[pt];
      try {
        b[pt] = void 0;
        var P = !0;
      } catch {
      }
      var ae = xr.call(b);
      return P && (g ? b[pt] = x : delete b[pt]), ae;
    }
    var Ri = Nt ? function(b) {
      return b == null ? [] : (b = Object(b), Me(Nt(b), function(g) {
        return He.call(b, g);
      }));
    } : Li, nr = dn;
    (zt && nr(new zt(new ArrayBuffer(1))) != k || Wt && nr(new Wt()) != p || Pt && nr(Pt.resolve()) != _ || Vr && nr(new Vr()) != O || Hr && nr(new Hr()) != E) && (nr = function(b) {
      var g = dn(b), x = g == w ? b.constructor : void 0, P = x ? It(x) : "";
      if (P)
        switch (P) {
          case At:
            return k;
          case Jt:
            return p;
          case Gr:
            return _;
          case an:
            return O;
          case sn:
            return E;
        }
      return g;
    });
    function Mi(b, g) {
      return g = g ?? i, !!g && (typeof b == "number" || N.test(b)) && b > -1 && b % 1 == 0 && b < g;
    }
    function Bi(b) {
      var g = typeof b;
      return g == "string" || g == "number" || g == "symbol" || g == "boolean" ? b !== "__proto__" : b === null;
    }
    function qi(b) {
      return !!dr && dr in b;
    }
    function Nn(b) {
      var g = b && b.constructor, x = typeof g == "function" && g.prototype || Yt;
      return b === x;
    }
    function zn(b) {
      return xr.call(b);
    }
    function It(b) {
      if (b != null) {
        try {
          return Sr.call(b);
        } catch {
        }
        try {
          return b + "";
        } catch {
        }
      }
      return "";
    }
    function jn(b, g) {
      return b === g || b !== b && g !== g;
    }
    var qo = Mo(/* @__PURE__ */ function() {
      return arguments;
    }()) ? Mo : function(b) {
      return Tr(b) && kt.call(b, "callee") && !He.call(b, "callee");
    }, pn = Array.isArray;
    function hn(b) {
      return b != null && uo(b.length) && !Yr(b);
    }
    var mn = nt || Lo;
    function Br(b, g) {
      return Bo(b, g);
    }
    function Yr(b) {
      if (!co(b))
        return !1;
      var g = dn(b);
      return g == y || g == m || g == u || g == T;
    }
    function uo(b) {
      return typeof b == "number" && b > -1 && b % 1 == 0 && b <= i;
    }
    function co(b) {
      var g = typeof b;
      return b != null && (g == "object" || g == "function");
    }
    function Tr(b) {
      return b != null && typeof b == "object";
    }
    var fo = we ? st(we) : ki;
    function po(b) {
      return hn(b) ? Ci(b) : Pi(b);
    }
    function Li() {
      return [];
    }
    function Lo() {
      return !1;
    }
    e.exports = Br;
  }(Yi, Yi.exports)), Yi.exports;
}
W3();
var pr = se(null), ns = se(null), mf = Zr(null), os = se(null), v0 = null;
U({ name: "Inertia", props: { initialPage: { type: Object, required: !0 }, initialComponent: { type: Object, required: !1 }, resolveComponent: { type: Function, required: !1 }, titleCallback: { type: Function, required: !1, default: (e) => e }, onHeadUpdate: { type: Function, required: !1, default: () => () => {
} } }, setup({ initialPage: e, initialComponent: t, resolveComponent: r, titleCallback: n, onHeadUpdate: o }) {
  pr.value = t ? Tf(t) : null, ns.value = e, os.value = null;
  let a = typeof window > "u";
  return v0 = z3(a, n, o), a || (np.init({ initialPage: e, resolveComponent: r, swapComponent: async (i) => {
    pr.value = Tf(i.component), ns.value = i.page, os.value = i.preserveState ? os.value : Date.now();
  } }), np.on("navigate", () => v0.forceUpdate())), () => {
    if (pr.value) {
      pr.value.inheritAttrs = !!pr.value.inheritAttrs;
      let i = Cr(pr.value, { ...ns.value.props, key: os.value });
      return mf.value && (pr.value.layout = mf.value, mf.value = null), pr.value.layout ? typeof pr.value.layout == "function" ? pr.value.layout(Cr, i) : (Array.isArray(pr.value.layout) ? pr.value.layout : [pr.value.layout]).concat(i).reverse().reduce((s, l) => (l.inheritAttrs = !!l.inheritAttrs, Cr(l, { ...ns.value.props }, () => s))) : i;
    }
  };
} });
U({ props: { title: { type: String, required: !1 } }, data() {
  return { provider: this.$headManager.createProvider() };
}, beforeUnmount() {
  this.provider.disconnect();
}, methods: { isUnaryTag(e) {
  return ["area", "base", "br", "col", "embed", "hr", "img", "input", "keygen", "link", "meta", "param", "source", "track", "wbr"].indexOf(e.type) > -1;
}, renderTagStart(e) {
  e.props = e.props || {}, e.props.inertia = e.props["head-key"] !== void 0 ? e.props["head-key"] : "";
  let t = Object.keys(e.props).reduce((r, n) => {
    let o = e.props[n];
    return ["key", "head-key"].includes(n) ? r : o === "" ? r + ` ${n}` : r + ` ${n}="${o}"`;
  }, "");
  return `<${e.type}${t}>`;
}, renderTagChildren(e) {
  return typeof e.children == "string" ? e.children : e.children.reduce((t, r) => t + this.renderTag(r), "");
}, isFunctionNode(e) {
  return typeof e.type == "function";
}, isComponentNode(e) {
  return typeof e.type == "object";
}, isCommentNode(e) {
  return /(comment|cmt)/i.test(e.type.toString());
}, isFragmentNode(e) {
  return /(fragment|fgt|symbol\(\))/i.test(e.type.toString());
}, isTextNode(e) {
  return /(text|txt)/i.test(e.type.toString());
}, renderTag(e) {
  if (this.isTextNode(e)) return e.children;
  if (this.isFragmentNode(e) || this.isCommentNode(e)) return "";
  let t = this.renderTagStart(e);
  return e.children && (t += this.renderTagChildren(e)), this.isUnaryTag(e) || (t += `</${e.type}>`), t;
}, addTitleElement(e) {
  return this.title && !e.find((t) => t.startsWith("<title")) && e.push(`<title inertia>${this.title}</title>`), e;
}, renderNodes(e) {
  return this.addTitleElement(e.flatMap((t) => this.resolveNode(t)).map((t) => this.renderTag(t)).filter((t) => t));
}, resolveNode(e) {
  return this.isFunctionNode(e) ? this.resolveNode(e.type()) : this.isComponentNode(e) ? (console.warn("Using components in the <Head> component is not supported."), []) : this.isTextNode(e) && e.children ? e : this.isFragmentNode(e) && e.children ? e.children.flatMap((t) => this.resolveNode(t)) : this.isCommentNode(e) ? [] : e;
} }, render() {
  this.provider.update(this.renderNodes(this.$slots.default ? this.$slots.default() : []));
} });
var V3 = U({ name: "Link", props: { as: { type: String, default: "a" }, data: { type: Object, default: () => ({}) }, href: { type: String, required: !0 }, method: { type: String, default: "get" }, replace: { type: Boolean, default: !1 }, preserveScroll: { type: Boolean, default: !1 }, preserveState: { type: Boolean, default: null }, only: { type: Array, default: () => [] }, except: { type: Array, default: () => [] }, headers: { type: Object, default: () => ({}) }, queryStringArrayFormat: { type: String, default: "brackets" } }, setup(e, { slots: t, attrs: r }) {
  return () => {
    let n = e.as.toLowerCase(), o = e.method.toLowerCase(), [a, i] = xw(o, e.href || "", e.data, e.queryStringArrayFormat);
    return n === "a" && o !== "get" && console.warn(`Creating POST/PUT/PATCH/DELETE <a> links is discouraged as it causes "Open Link in New Tab/Window" accessibility issues.

Please specify a more appropriate element using the "as" attribute. For example:

<Link href="${a}" method="${o}" as="button">...</Link>`), Cr(e.as, { ...r, ...n === "a" ? { href: a } : {}, onClick: (s) => {
      j3(s) && (s.preventDefault(), np.visit(a, { data: i, method: o, replace: e.replace, preserveScroll: e.preserveScroll, preserveState: e.preserveState ?? o !== "get", only: e.only, except: e.except, headers: e.headers, onCancelToken: r.onCancelToken || (() => ({})), onBefore: r.onBefore || (() => ({})), onStart: r.onStart || (() => ({})), onProgress: r.onProgress || (() => ({})), onFinish: r.onFinish || (() => ({})), onCancel: r.onCancel || (() => ({})), onSuccess: r.onSuccess || (() => ({})), onError: r.onError || (() => ({})) }));
    } }, t);
  };
} }), Aw = V3;
const H3 = { class: "ml-1 w-0 overflow-hidden whitespace-nowrap text-black transition-[width] ease-out group-hover:w-[calc-size(auto,size)]" }, G3 = /* @__PURE__ */ U({
  __name: "CardHelp",
  props: {
    label: {},
    href: { default: void 0 },
    onClick: { type: Function, default: void 0 }
  },
  setup(e) {
    const t = e;
    return (r, n) => ($(), ne(er(t.href ? S(Aw) : "button"), We({
      href: r.href,
      target: r.href ? "_blank" : void 0,
      type: t.href ? void 0 : "button"
    }, r.$attrs, {
      class: "group ml-2 flex shrink-0 items-center rounded-full border border-transparent p-1 pr-2 text-xs font-normal leading-none text-slate-500 hover:border-slate-300 hover:bg-slate-100 dark:text-zinc-400",
      onClick: r.onClick
    }), {
      default: Y(() => [
        ie(S(Eb), { class: "size-4 transition-colors group-hover:text-brand-500" }),
        X("span", H3, Ie(r.label), 1)
      ]),
      _: 1
    }, 16, ["href", "target", "type", "onClick"]));
  }
}), K3 = { class: "mb-4 size-14 overflow-hidden rounded-md border bg-white bg-gradient-to-tl from-slate-100 to-50% p-1 shadow" }, TR = /* @__PURE__ */ U({
  __name: "CardIcon",
  props: {
    alt: {},
    source: {}
  },
  setup(e) {
    return (t, r) => ($(), B("div", K3, [
      ie(S(fa), { fit: "contain" }, {
        default: Y(() => [
          ie(S(hi), {
            source: t.source,
            alt: t.alt,
            class: "rounded"
          }, null, 8, ["source", "alt"])
        ]),
        _: 1
      })
    ]));
  }
}), ER = /* @__PURE__ */ U({
  __name: "CardLayout",
  props: {
    columns: { default: 1 }
  },
  setup(e) {
    const t = e, r = re(() => [
      { "grid-cols-1": t.columns === 1 },
      { "grid-cols-2": t.columns === 2 },
      { "grid-cols-3": t.columns === 3 }
    ]);
    return (n, o) => ($(), B("div", {
      class: Te(["grid gap-[var(--grid-gap)]", r.value])
    }, [
      V(n.$slots, "default")
    ], 2));
  }
}), Kp = /* @__PURE__ */ U({
  __name: "CardSection",
  props: {
    flush: { type: Boolean, default: !1 },
    alignment: { default: "start" }
  },
  setup(e) {
    const t = e, r = re(() => [
      { "py-6": t.flush },
      { "p-6": !t.flush },
      { "justify-start": t.alignment === "start" },
      { "justify-end": t.alignment === "end" }
    ]);
    return (n, o) => ($(), B("div", {
      class: Te([r.value, "inline-flex h-full flex-col"])
    }, [
      V(n.$slots, "default")
    ], 2));
  }
}), Y3 = { class: "relative bg-slate-200" }, J3 = {
  key: 0,
  class: "absolute inset-0"
}, OR = /* @__PURE__ */ U({
  __name: "CardMedia",
  props: {
    alt: {},
    ratio: { default: 16 / 9 },
    source: {},
    subdued: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = se(!1);
    function r() {
      t.value = !0;
    }
    return (n, o) => ($(), B("div", Y3, [
      ie(S(fa), { ratio: n.ratio }, {
        default: Y(() => [
          Dr(ie(S(hi), {
            alt: n.alt,
            source: n.source,
            class: Te({
              "opacity-30 grayscale": n.subdued
            }),
            onError: r
          }, null, 8, ["alt", "source", "class"]), [
            [li, !t.value]
          ])
        ]),
        _: 1
      }, 8, ["ratio"]),
      n.$slots.default ? ($(), B("div", J3, [
        ie(Kp, null, {
          default: Y(() => [
            V(n.$slots, "default")
          ]),
          _: 3
        })
      ])) : _e("", !0)
    ]));
  }
}), Z3 = {}, X3 = { class: "relative flex h-0 items-center" };
function Q3(e, t) {
  return $(), B("div", X3, t[0] || (t[0] = [
    X("div", { class: "h-px w-full shrink-0 bg-slate-300 dark:bg-zinc-700" }, null, -1)
  ]));
}
const $R = /* @__PURE__ */ De(Z3, [["render", Q3]]), eP = { class: "flex items-center" }, tP = { class: "truncate" }, CR = /* @__PURE__ */ U({
  __name: "CardTitle",
  props: {
    cardHelp: { default: null }
  },
  setup(e) {
    return (t, r) => ($(), ne(S(gi), { level: "h2" }, {
      default: Y(() => [
        X("span", eP, [
          X("span", tP, [
            V(t.$slots, "default")
          ]),
          t.cardHelp ? ($(), ne(S(G3), zr(We({ key: 0 }, t.cardHelp)), null, 16)) : _e("", !0)
        ])
      ]),
      _: 3
    }));
  }
}), rP = { class: "h-4 rounded flex [&>*]:flex-shrink-0 overflow-hidden mb-4" }, nP = ["onMouseenter"], oP = ["onMouseenter"], iP = { class: "space-x-1" }, kR = /* @__PURE__ */ U({
  __name: "CategoryBar",
  props: {
    categories: {}
  },
  setup(e) {
    const t = e, r = se(null), n = re(() => t.categories.reduce((a, i) => a + i.value, 0)), o = re(() => t.categories.map((a) => ({
      ...a,
      percentage: (a.value / n.value * 100).toFixed(1),
      color: bt(a.color, "500")
    })));
    return (a, i) => ($(), B(qt, null, [
      X("div", rP, [
        ($(!0), B(qt, null, sr(o.value, (s, l) => ($(), B("div", {
          key: l,
          class: Te([{ "opacity-50": r.value !== null && r.value !== l }, "h-full w-10 bg-red-500 transition-opacity duration-100"]),
          style: $t({
            width: `${s.percentage}%`,
            backgroundColor: s.color
          }),
          onMouseenter: (u) => r.value = l,
          onMouseleave: i[0] || (i[0] = (u) => r.value = null)
        }, null, 46, nP))), 128))
      ]),
      X("ul", null, [
        ($(!0), B(qt, null, sr(o.value, (s, l) => ($(), B("li", {
          key: l,
          class: Te(["flex pb-2 transition-opacity duration-100 space-x-2", { "opacity-50": r.value !== null && r.value !== l }]),
          onMouseenter: (u) => r.value = l,
          onMouseleave: i[1] || (i[1] = (u) => r.value = null)
        }, [
          X("div", {
            class: "rounded-full size-2 mt-1.5",
            style: $t({ backgroundColor: s.color })
          }, null, 4),
          X("div", null, [
            ie(S(Ve), {
              subdued: "",
              strong: ""
            }, {
              default: Y(() => [
                et(Ie(s.label), 1)
              ]),
              _: 2
            }, 1024),
            X("div", iP, [
              ie(S(Ve), { strong: "" }, {
                default: Y(() => [
                  et(Ie(s.value), 1)
                ]),
                _: 2
              }, 1024),
              ie(S(Ve), { subdued: "" }, {
                default: Y(() => [
                  et(" (" + Ie(s.percentage) + "%) ", 1)
                ]),
                _: 2
              }, 1024)
            ])
          ])
        ], 42, oP))), 128)),
        X("li", null, [
          i[2] || (i[2] = et(" Total ")),
          ie(S(Ve), { strong: "" }, {
            default: Y(() => [
              et(Ie(n.value), 1)
            ]),
            _: 1
          })
        ])
      ])
    ], 64));
  }
}), Do = /* @__PURE__ */ U({
  __name: "InputLabel",
  props: {
    label: {},
    labelFor: {},
    labelHidden: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, r = re(() => t.labelHidden ? pi : "label");
    return (n, o) => ($(), ne(er(r.value), {
      for: n.labelFor,
      class: "block w-fit cursor-pointer truncate align-baseline text-sm font-medium"
    }, {
      default: Y(() => [
        et(Ie(n.label), 1)
      ]),
      _: 1
    }, 8, ["for"]));
  }
}), aP = ["aria-checked", "aria-labelledby"], sP = { class: "relative" }, lP = ["id", "value"], uP = { class: "pointer-events-none invisible absolute inset-0 z-10 flex size-4 items-center justify-center rounded bg-brand-500 text-white peer-checked:visible" }, cP = {
  key: 0,
  "aria-hidden": "true",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, dP = {
  key: 1,
  "aria-hidden": "true",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, fP = {
  key: 0,
  class: "-mt-[2px] space-y-1"
}, PR = /* @__PURE__ */ U({
  __name: "Checkbox",
  props: /* @__PURE__ */ br({
    helpText: { default: null },
    id: { default: null },
    indeterminate: { type: Boolean },
    label: {},
    labelHidden: { type: Boolean, default: !1 },
    value: { type: [String, Number, Boolean] }
  }, {
    modelValue: { type: [Boolean, Array] },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = e, r = se(null), n = wr(e, "modelValue"), o = t.id || Je("checkbox"), a = re(() => Array.isArray(n.value) ? n.value.includes(t.value) : n.value);
    return (i, s) => ($(), B("div", {
      "aria-checked": a.value,
      "aria-labelledby": S(o),
      class: "flex items-start space-x-2",
      role: "checkbox"
    }, [
      X("div", sP, [
        Dr(X("input", {
          id: S(o),
          ref_key: "$checkboxElement",
          ref: r,
          "onUpdate:modelValue": s[0] || (s[0] = (l) => n.value = l),
          class: Te([S(Qt)("focus"), "peer block size-4 shrink-0 appearance-none rounded border border-slate-400 bg-white text-brand-500 shadow-sm dark:border-zinc-700 dark:bg-zinc-800 dark:text-blue-500"]),
          value: i.value,
          type: "checkbox"
        }, null, 10, lP), [
          [D0, n.value]
        ]),
        X("div", uP, [
          i.indeterminate ? _e("", !0) : ($(), B("svg", cP, s[1] || (s[1] = [
            X("path", {
              d: "M11.2 5.59998L6.79999 9.99998L4.79999 7.99998",
              stroke: "currentColor",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2"
            }, null, -1)
          ]))),
          i.indeterminate ? ($(), B("svg", dP, s[2] || (s[2] = [
            X("line", {
              stroke: "currentColor",
              "stroke-linecap": "round",
              "stroke-width": "2",
              x1: "4",
              x2: "12",
              y1: "8",
              y2: "8"
            }, null, -1)
          ]))) : _e("", !0)
        ])
      ]),
      i.labelHidden ? _e("", !0) : ($(), B("div", fP, [
        ie(S(Do), {
          label: i.label,
          "label-for": S(o)
        }, null, 8, ["label", "label-for"]),
        i.helpText ? ($(), ne(S(Ve), {
          key: 0,
          subdued: ""
        }, {
          default: Y(() => [
            et(Ie(i.helpText), 1)
          ]),
          _: 1
        })) : _e("", !0)
      ]))
    ], 8, aP));
  }
}), pP = { class: "space-y-2" }, hP = { key: 0 }, IR = /* @__PURE__ */ U({
  __name: "CheckboxGroup",
  props: {
    label: { default: null }
  },
  setup(e) {
    return (t, r) => ($(), B("div", pP, [
      t.label ? ($(), B("p", hP, [
        ie(S(Ve), {
          subdued: "",
          strong: ""
        }, {
          default: Y(() => [
            et(Ie(t.label), 1)
          ]),
          _: 1
        })
      ])) : _e("", !0),
      V(t.$slots, "default")
    ]));
  }
}), mP = ["id"], DR = /* @__PURE__ */ U({
  __name: "Collapsible",
  props: {
    id: {},
    open: { type: Boolean, default: !1 }
  },
  setup(e) {
    function t(a) {
      a.style.height = "0";
    }
    function r(a) {
      a.style.height = a.scrollHeight + "px";
    }
    function n(a) {
      a.style.height = a.scrollHeight + "px";
    }
    function o(a) {
      a.style.height = "0";
    }
    return (a, i) => ($(), ne(lp, {
      onEnter: r,
      onLeave: o,
      onBeforeEnter: t,
      onBeforeLeave: n
    }, {
      default: Y(() => [
        Dr(X("div", {
          id: a.id,
          class: "transition-all duration-200 ease-in-out overflow-hidden",
          role: "region"
        }, [
          V(a.$slots, "default")
        ], 8, mP), [
          [li, a.open]
        ])
      ]),
      _: 3
    }));
  }
}), vP = ["id"], gP = { class: "break-words" }, ol = /* @__PURE__ */ U({
  __name: "InlineError",
  props: {
    id: {},
    message: {}
  },
  setup(e) {
    return (t, r) => ($(), B("div", {
      id: t.id,
      class: "flex items-start space-x-2 text-red-600"
    }, [
      r[0] || (r[0] = X("svg", {
        viewBox: "0 0 20 20",
        class: "fill-current size-5 flex-shrink-0",
        focusable: "false",
        "aria-hidden": "true"
      }, [
        X("path", { d: "M10 6a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5a.75.75 0 0 1 .75-.75Z" }),
        X("path", { d: "M11 13a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z" }),
        X("path", {
          "fill-rule": "evenodd",
          d: "M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Zm-1.5 0a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Z"
        })
      ], -1)),
      X("span", gP, Ie(t.message), 1)
    ], 8, vP));
  }
}), yP = { class: "w-full" }, bP = { class: "block cursor-pointer px-2 py-1.5" }, wP = { class: "font-mono" }, _P = ["id", "name"], SP = { class: "text-sm text-slate-500" }, RR = /* @__PURE__ */ U({
  __name: "ColorInput",
  props: /* @__PURE__ */ br({
    disabled: { type: Boolean, default: !1 },
    error: { default: null },
    helpText: { default: null },
    id: { default: null },
    label: {},
    labelHidden: { type: Boolean, default: !1 },
    name: {}
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = e, r = wr(e, "modelValue"), n = t.id || Je("colorInput"), o = re(() => t.error ? Je("colorInputError") : void 0), a = re(() => [
      { "mt-1": !t.labelHidden },
      { "pointer-events-none bg-slate-50 cursor-not-allowed": t.disabled },
      { "bg-white cursor-pointer": !t.disabled },
      ...Qt("focusWithin")
    ]);
    return (i, s) => ($(), B("div", yP, [
      ie(S(Do), {
        id: `${S(n)}-label`,
        label: i.label,
        "label-for": S(n),
        "label-hidden": i.labelHidden,
        "aria-disabled": i.disabled
      }, null, 8, ["id", "label", "label-for", "label-hidden", "aria-disabled"]),
      X("label", {
        class: Te(["relative flex w-full items-center rounded border shadow-sm", a.value])
      }, [
        X("span", bP, [
          X("span", {
            class: "block rounded size-6",
            style: $t({ backgroundColor: r.value })
          }, null, 4)
        ]),
        X("span", wP, Ie(r.value), 1),
        ie(S(pi), null, {
          default: Y(() => [
            Dr(X("input", {
              id: S(n),
              "onUpdate:modelValue": s[0] || (s[0] = (l) => r.value = l),
              name: i.name,
              type: "color"
            }, null, 8, _P), [
              [Jw, r.value]
            ])
          ]),
          _: 1
        })
      ], 2),
      i.error && o.value ? ($(), ne(S(ol), {
        key: 0,
        id: o.value,
        message: i.error
      }, null, 8, ["id", "message"])) : _e("", !0),
      X("p", SP, Ie(i.helpText), 1)
    ]));
  }
}), xP = ["value"], AP = /* @__PURE__ */ U({
  __name: "ColorPalette",
  props: /* @__PURE__ */ br({
    colors: {},
    rows: { default: 2 }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = e, r = wr(e, "modelValue"), n = re(() => ({
      gridTemplateColumns: `repeat(${Math.round(t.colors.length / t.rows)}, minmax(0, 1fr))`
    }));
    function o(a) {
      return bt(a, "500");
    }
    return (a, i) => ($(), B("ul", {
      class: "grid gap-x-4 gap-y-2",
      style: $t(n.value)
    }, [
      ($(!0), B(qt, null, sr(a.colors, (s) => ($(), B("li", { key: s }, [
        Dr(X("input", {
          "onUpdate:modelValue": i[0] || (i[0] = (l) => r.value = l),
          value: s,
          class: "flex size-6 cursor-pointer appearance-none items-center justify-center rounded-full bg-gradient-to-tr from-white/20 shadow-inner transition-opacity duration-100 hover:opacity-50",
          type: "radio",
          style: $t({
            backgroundColor: o(s)
          })
        }, null, 12, xP), [
          [R0, r.value]
        ])
      ]))), 128))
    ], 4));
  }
}), MR = /* @__PURE__ */ De(AP, [["__scopeId", "data-v-55656b4c"]]);
/**!
 * Sortable 1.15.6
 * @author	RubaXa   <trash@rubaxa.org>
 * @author	owenm    <owen23355@gmail.com>
 * @license MIT
 */
function g0(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function tn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? g0(Object(r), !0).forEach(function(n) {
      TP(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : g0(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function ms(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? ms = function(t) {
    return typeof t;
  } : ms = function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, ms(e);
}
function TP(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function En() {
  return En = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, En.apply(this, arguments);
}
function EP(e, t) {
  if (e == null) return {};
  var r = {}, n = Object.keys(e), o, a;
  for (a = 0; a < n.length; a++)
    o = n[a], !(t.indexOf(o) >= 0) && (r[o] = e[o]);
  return r;
}
function OP(e, t) {
  if (e == null) return {};
  var r = EP(e, t), n, o;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (o = 0; o < a.length; o++)
      n = a[o], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
var $P = "1.15.6";
function xn(e) {
  if (typeof window < "u" && window.navigator)
    return !!/* @__PURE__ */ navigator.userAgent.match(e);
}
var Cn = xn(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i), ga = xn(/Edge/i), y0 = xn(/firefox/i), Qi = xn(/safari/i) && !xn(/chrome/i) && !xn(/android/i), Yp = xn(/iP(ad|od|hone)/i), Tw = xn(/chrome/i) && xn(/android/i), Ew = {
  capture: !1,
  passive: !1
};
function ze(e, t, r) {
  e.addEventListener(t, r, !Cn && Ew);
}
function Ne(e, t, r) {
  e.removeEventListener(t, r, !Cn && Ew);
}
function Ps(e, t) {
  if (t) {
    if (t[0] === ">" && (t = t.substring(1)), e)
      try {
        if (e.matches)
          return e.matches(t);
        if (e.msMatchesSelector)
          return e.msMatchesSelector(t);
        if (e.webkitMatchesSelector)
          return e.webkitMatchesSelector(t);
      } catch {
        return !1;
      }
    return !1;
  }
}
function Ow(e) {
  return e.host && e !== document && e.host.nodeType ? e.host : e.parentNode;
}
function Nr(e, t, r, n) {
  if (e) {
    r = r || document;
    do {
      if (t != null && (t[0] === ">" ? e.parentNode === r && Ps(e, t) : Ps(e, t)) || n && e === r)
        return e;
      if (e === r) break;
    } while (e = Ow(e));
  }
  return null;
}
var b0 = /\s+/g;
function hr(e, t, r) {
  if (e && t)
    if (e.classList)
      e.classList[r ? "add" : "remove"](t);
    else {
      var n = (" " + e.className + " ").replace(b0, " ").replace(" " + t + " ", " ");
      e.className = (n + (r ? " " + t : "")).replace(b0, " ");
    }
}
function Ce(e, t, r) {
  var n = e && e.style;
  if (n) {
    if (r === void 0)
      return document.defaultView && document.defaultView.getComputedStyle ? r = document.defaultView.getComputedStyle(e, "") : e.currentStyle && (r = e.currentStyle), t === void 0 ? r : r[t];
    !(t in n) && t.indexOf("webkit") === -1 && (t = "-webkit-" + t), n[t] = r + (typeof r == "string" ? "" : "px");
  }
}
function Zo(e, t) {
  var r = "";
  if (typeof e == "string")
    r = e;
  else
    do {
      var n = Ce(e, "transform");
      n && n !== "none" && (r = n + " " + r);
    } while (!t && (e = e.parentNode));
  var o = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
  return o && new o(r);
}
function $w(e, t, r) {
  if (e) {
    var n = e.getElementsByTagName(t), o = 0, a = n.length;
    if (r)
      for (; o < a; o++)
        r(n[o], o);
    return n;
  }
  return [];
}
function Xr() {
  var e = document.scrollingElement;
  return e || document.documentElement;
}
function Ot(e, t, r, n, o) {
  if (!(!e.getBoundingClientRect && e !== window)) {
    var a, i, s, l, u, c, d;
    if (e !== window && e.parentNode && e !== Xr() ? (a = e.getBoundingClientRect(), i = a.top, s = a.left, l = a.bottom, u = a.right, c = a.height, d = a.width) : (i = 0, s = 0, l = window.innerHeight, u = window.innerWidth, c = window.innerHeight, d = window.innerWidth), (t || r) && e !== window && (o = o || e.parentNode, !Cn))
      do
        if (o && o.getBoundingClientRect && (Ce(o, "transform") !== "none" || r && Ce(o, "position") !== "static")) {
          var h = o.getBoundingClientRect();
          i -= h.top + parseInt(Ce(o, "border-top-width")), s -= h.left + parseInt(Ce(o, "border-left-width")), l = i + a.height, u = s + a.width;
          break;
        }
      while (o = o.parentNode);
    if (n && e !== window) {
      var y = Zo(o || e), m = y && y.a, p = y && y.d;
      y && (i /= p, s /= m, d /= m, c /= p, l = i + c, u = s + d);
    }
    return {
      top: i,
      left: s,
      bottom: l,
      right: u,
      width: d,
      height: c
    };
  }
}
function w0(e, t, r) {
  for (var n = Yn(e, !0), o = Ot(e)[t]; n; ) {
    var a = Ot(n)[r], i = void 0;
    if (i = o >= a, !i) return n;
    if (n === Xr()) break;
    n = Yn(n, !1);
  }
  return !1;
}
function si(e, t, r, n) {
  for (var o = 0, a = 0, i = e.children; a < i.length; ) {
    if (i[a].style.display !== "none" && i[a] !== ke.ghost && (n || i[a] !== ke.dragged) && Nr(i[a], r.draggable, e, !1)) {
      if (o === t)
        return i[a];
      o++;
    }
    a++;
  }
  return null;
}
function Jp(e, t) {
  for (var r = e.lastElementChild; r && (r === ke.ghost || Ce(r, "display") === "none" || t && !Ps(r, t)); )
    r = r.previousElementSibling;
  return r || null;
}
function Er(e, t) {
  var r = 0;
  if (!e || !e.parentNode)
    return -1;
  for (; e = e.previousElementSibling; )
    e.nodeName.toUpperCase() !== "TEMPLATE" && e !== ke.clone && (!t || Ps(e, t)) && r++;
  return r;
}
function _0(e) {
  var t = 0, r = 0, n = Xr();
  if (e)
    do {
      var o = Zo(e), a = o.a, i = o.d;
      t += e.scrollLeft * a, r += e.scrollTop * i;
    } while (e !== n && (e = e.parentNode));
  return [t, r];
}
function CP(e, t) {
  for (var r in e)
    if (e.hasOwnProperty(r)) {
      for (var n in t)
        if (t.hasOwnProperty(n) && t[n] === e[r][n]) return Number(r);
    }
  return -1;
}
function Yn(e, t) {
  if (!e || !e.getBoundingClientRect) return Xr();
  var r = e, n = !1;
  do
    if (r.clientWidth < r.scrollWidth || r.clientHeight < r.scrollHeight) {
      var o = Ce(r);
      if (r.clientWidth < r.scrollWidth && (o.overflowX == "auto" || o.overflowX == "scroll") || r.clientHeight < r.scrollHeight && (o.overflowY == "auto" || o.overflowY == "scroll")) {
        if (!r.getBoundingClientRect || r === document.body) return Xr();
        if (n || t) return r;
        n = !0;
      }
    }
  while (r = r.parentNode);
  return Xr();
}
function kP(e, t) {
  if (e && t)
    for (var r in t)
      t.hasOwnProperty(r) && (e[r] = t[r]);
  return e;
}
function vf(e, t) {
  return Math.round(e.top) === Math.round(t.top) && Math.round(e.left) === Math.round(t.left) && Math.round(e.height) === Math.round(t.height) && Math.round(e.width) === Math.round(t.width);
}
var ea;
function Cw(e, t) {
  return function() {
    if (!ea) {
      var r = arguments, n = this;
      r.length === 1 ? e.call(n, r[0]) : e.apply(n, r), ea = setTimeout(function() {
        ea = void 0;
      }, t);
    }
  };
}
function PP() {
  clearTimeout(ea), ea = void 0;
}
function kw(e, t, r) {
  e.scrollLeft += t, e.scrollTop += r;
}
function Pw(e) {
  var t = window.Polymer, r = window.jQuery || window.Zepto;
  return t && t.dom ? t.dom(e).cloneNode(!0) : r ? r(e).clone(!0)[0] : e.cloneNode(!0);
}
function Iw(e, t, r) {
  var n = {};
  return Array.from(e.children).forEach(function(o) {
    var a, i, s, l;
    if (!(!Nr(o, t.draggable, e, !1) || o.animated || o === r)) {
      var u = Ot(o);
      n.left = Math.min((a = n.left) !== null && a !== void 0 ? a : 1 / 0, u.left), n.top = Math.min((i = n.top) !== null && i !== void 0 ? i : 1 / 0, u.top), n.right = Math.max((s = n.right) !== null && s !== void 0 ? s : -1 / 0, u.right), n.bottom = Math.max((l = n.bottom) !== null && l !== void 0 ? l : -1 / 0, u.bottom);
    }
  }), n.width = n.right - n.left, n.height = n.bottom - n.top, n.x = n.left, n.y = n.top, n;
}
var ar = "Sortable" + (/* @__PURE__ */ new Date()).getTime();
function IP() {
  var e = [], t;
  return {
    captureAnimationState: function() {
      if (e = [], !!this.options.animation) {
        var n = [].slice.call(this.el.children);
        n.forEach(function(o) {
          if (!(Ce(o, "display") === "none" || o === ke.ghost)) {
            e.push({
              target: o,
              rect: Ot(o)
            });
            var a = tn({}, e[e.length - 1].rect);
            if (o.thisAnimationDuration) {
              var i = Zo(o, !0);
              i && (a.top -= i.f, a.left -= i.e);
            }
            o.fromRect = a;
          }
        });
      }
    },
    addAnimationState: function(n) {
      e.push(n);
    },
    removeAnimationState: function(n) {
      e.splice(CP(e, {
        target: n
      }), 1);
    },
    animateAll: function(n) {
      var o = this;
      if (!this.options.animation) {
        clearTimeout(t), typeof n == "function" && n();
        return;
      }
      var a = !1, i = 0;
      e.forEach(function(s) {
        var l = 0, u = s.target, c = u.fromRect, d = Ot(u), h = u.prevFromRect, y = u.prevToRect, m = s.rect, p = Zo(u, !0);
        p && (d.top -= p.f, d.left -= p.e), u.toRect = d, u.thisAnimationDuration && vf(h, d) && !vf(c, d) && // Make sure animatingRect is on line between toRect & fromRect
        (m.top - d.top) / (m.left - d.left) === (c.top - d.top) / (c.left - d.left) && (l = RP(m, h, y, o.options)), vf(d, c) || (u.prevFromRect = c, u.prevToRect = d, l || (l = o.options.animation), o.animate(u, m, d, l)), l && (a = !0, i = Math.max(i, l), clearTimeout(u.animationResetTimer), u.animationResetTimer = setTimeout(function() {
          u.animationTime = 0, u.prevFromRect = null, u.fromRect = null, u.prevToRect = null, u.thisAnimationDuration = null;
        }, l), u.thisAnimationDuration = l);
      }), clearTimeout(t), a ? t = setTimeout(function() {
        typeof n == "function" && n();
      }, i) : typeof n == "function" && n(), e = [];
    },
    animate: function(n, o, a, i) {
      if (i) {
        Ce(n, "transition", ""), Ce(n, "transform", "");
        var s = Zo(this.el), l = s && s.a, u = s && s.d, c = (o.left - a.left) / (l || 1), d = (o.top - a.top) / (u || 1);
        n.animatingX = !!c, n.animatingY = !!d, Ce(n, "transform", "translate3d(" + c + "px," + d + "px,0)"), this.forRepaintDummy = DP(n), Ce(n, "transition", "transform " + i + "ms" + (this.options.easing ? " " + this.options.easing : "")), Ce(n, "transform", "translate3d(0,0,0)"), typeof n.animated == "number" && clearTimeout(n.animated), n.animated = setTimeout(function() {
          Ce(n, "transition", ""), Ce(n, "transform", ""), n.animated = !1, n.animatingX = !1, n.animatingY = !1;
        }, i);
      }
    }
  };
}
function DP(e) {
  return e.offsetWidth;
}
function RP(e, t, r, n) {
  return Math.sqrt(Math.pow(t.top - e.top, 2) + Math.pow(t.left - e.left, 2)) / Math.sqrt(Math.pow(t.top - r.top, 2) + Math.pow(t.left - r.left, 2)) * n.animation;
}
var Wo = [], gf = {
  initializeByDefault: !0
}, ya = {
  mount: function(t) {
    for (var r in gf)
      gf.hasOwnProperty(r) && !(r in t) && (t[r] = gf[r]);
    Wo.forEach(function(n) {
      if (n.pluginName === t.pluginName)
        throw "Sortable: Cannot mount plugin ".concat(t.pluginName, " more than once");
    }), Wo.push(t);
  },
  pluginEvent: function(t, r, n) {
    var o = this;
    this.eventCanceled = !1, n.cancel = function() {
      o.eventCanceled = !0;
    };
    var a = t + "Global";
    Wo.forEach(function(i) {
      r[i.pluginName] && (r[i.pluginName][a] && r[i.pluginName][a](tn({
        sortable: r
      }, n)), r.options[i.pluginName] && r[i.pluginName][t] && r[i.pluginName][t](tn({
        sortable: r
      }, n)));
    });
  },
  initializePlugins: function(t, r, n, o) {
    Wo.forEach(function(s) {
      var l = s.pluginName;
      if (!(!t.options[l] && !s.initializeByDefault)) {
        var u = new s(t, r, t.options);
        u.sortable = t, u.options = t.options, t[l] = u, En(n, u.defaults);
      }
    });
    for (var a in t.options)
      if (t.options.hasOwnProperty(a)) {
        var i = this.modifyOption(t, a, t.options[a]);
        typeof i < "u" && (t.options[a] = i);
      }
  },
  getEventProperties: function(t, r) {
    var n = {};
    return Wo.forEach(function(o) {
      typeof o.eventProperties == "function" && En(n, o.eventProperties.call(r[o.pluginName], t));
    }), n;
  },
  modifyOption: function(t, r, n) {
    var o;
    return Wo.forEach(function(a) {
      t[a.pluginName] && a.optionListeners && typeof a.optionListeners[r] == "function" && (o = a.optionListeners[r].call(t[a.pluginName], n));
    }), o;
  }
};
function MP(e) {
  var t = e.sortable, r = e.rootEl, n = e.name, o = e.targetEl, a = e.cloneEl, i = e.toEl, s = e.fromEl, l = e.oldIndex, u = e.newIndex, c = e.oldDraggableIndex, d = e.newDraggableIndex, h = e.originalEvent, y = e.putSortable, m = e.extraEventProperties;
  if (t = t || r && r[ar], !!t) {
    var p, f = t.options, v = "on" + n.charAt(0).toUpperCase() + n.substr(1);
    window.CustomEvent && !Cn && !ga ? p = new CustomEvent(n, {
      bubbles: !0,
      cancelable: !0
    }) : (p = document.createEvent("Event"), p.initEvent(n, !0, !0)), p.to = i || r, p.from = s || r, p.item = o || r, p.clone = a, p.oldIndex = l, p.newIndex = u, p.oldDraggableIndex = c, p.newDraggableIndex = d, p.originalEvent = h, p.pullMode = y ? y.lastPutMode : void 0;
    var w = tn(tn({}, m), ya.getEventProperties(n, t));
    for (var _ in w)
      p[_] = w[_];
    r && r.dispatchEvent(p), f[v] && f[v].call(t, p);
  }
}
var BP = ["evt"], or = function(t, r) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, o = n.evt, a = OP(n, BP);
  ya.pluginEvent.bind(ke)(t, r, tn({
    dragEl: ue,
    parentEl: ht,
    ghostEl: Re,
    rootEl: lt,
    nextEl: _o,
    lastDownEl: vs,
    cloneEl: dt,
    cloneHidden: Kn,
    dragStarted: Ji,
    putSortable: jt,
    activeSortable: ke.active,
    originalEvent: o,
    oldIndex: Yo,
    oldDraggableIndex: ta,
    newIndex: mr,
    newDraggableIndex: Gn,
    hideGhostForTarget: Bw,
    unhideGhostForTarget: qw,
    cloneNowHidden: function() {
      Kn = !0;
    },
    cloneNowShown: function() {
      Kn = !1;
    },
    dispatchSortableEvent: function(s) {
      Xt({
        sortable: r,
        name: s,
        originalEvent: o
      });
    }
  }, a));
};
function Xt(e) {
  MP(tn({
    putSortable: jt,
    cloneEl: dt,
    targetEl: ue,
    rootEl: lt,
    oldIndex: Yo,
    oldDraggableIndex: ta,
    newIndex: mr,
    newDraggableIndex: Gn
  }, e));
}
var ue, ht, Re, lt, _o, vs, dt, Kn, Yo, mr, ta, Gn, is, jt, Go = !1, Is = !1, Ds = [], yo, Fr, yf, bf, S0, x0, Ji, Vo, ra, na = !1, as = !1, gs, Vt, wf = [], op = !1, Rs = [], il = typeof document < "u", ss = Yp, A0 = ga || Cn ? "cssFloat" : "float", qP = il && !Tw && !Yp && "draggable" in document.createElement("div"), Dw = function() {
  if (il) {
    if (Cn)
      return !1;
    var e = document.createElement("x");
    return e.style.cssText = "pointer-events:auto", e.style.pointerEvents === "auto";
  }
}(), Rw = function(t, r) {
  var n = Ce(t), o = parseInt(n.width) - parseInt(n.paddingLeft) - parseInt(n.paddingRight) - parseInt(n.borderLeftWidth) - parseInt(n.borderRightWidth), a = si(t, 0, r), i = si(t, 1, r), s = a && Ce(a), l = i && Ce(i), u = s && parseInt(s.marginLeft) + parseInt(s.marginRight) + Ot(a).width, c = l && parseInt(l.marginLeft) + parseInt(l.marginRight) + Ot(i).width;
  if (n.display === "flex")
    return n.flexDirection === "column" || n.flexDirection === "column-reverse" ? "vertical" : "horizontal";
  if (n.display === "grid")
    return n.gridTemplateColumns.split(" ").length <= 1 ? "vertical" : "horizontal";
  if (a && s.float && s.float !== "none") {
    var d = s.float === "left" ? "left" : "right";
    return i && (l.clear === "both" || l.clear === d) ? "vertical" : "horizontal";
  }
  return a && (s.display === "block" || s.display === "flex" || s.display === "table" || s.display === "grid" || u >= o && n[A0] === "none" || i && n[A0] === "none" && u + c > o) ? "vertical" : "horizontal";
}, LP = function(t, r, n) {
  var o = n ? t.left : t.top, a = n ? t.right : t.bottom, i = n ? t.width : t.height, s = n ? r.left : r.top, l = n ? r.right : r.bottom, u = n ? r.width : r.height;
  return o === s || a === l || o + i / 2 === s + u / 2;
}, FP = function(t, r) {
  var n;
  return Ds.some(function(o) {
    var a = o[ar].options.emptyInsertThreshold;
    if (!(!a || Jp(o))) {
      var i = Ot(o), s = t >= i.left - a && t <= i.right + a, l = r >= i.top - a && r <= i.bottom + a;
      if (s && l)
        return n = o;
    }
  }), n;
}, Mw = function(t) {
  function r(a, i) {
    return function(s, l, u, c) {
      var d = s.options.group.name && l.options.group.name && s.options.group.name === l.options.group.name;
      if (a == null && (i || d))
        return !0;
      if (a == null || a === !1)
        return !1;
      if (i && a === "clone")
        return a;
      if (typeof a == "function")
        return r(a(s, l, u, c), i)(s, l, u, c);
      var h = (i ? s : l).options.group.name;
      return a === !0 || typeof a == "string" && a === h || a.join && a.indexOf(h) > -1;
    };
  }
  var n = {}, o = t.group;
  (!o || ms(o) != "object") && (o = {
    name: o
  }), n.name = o.name, n.checkPull = r(o.pull, !0), n.checkPut = r(o.put), n.revertClone = o.revertClone, t.group = n;
}, Bw = function() {
  !Dw && Re && Ce(Re, "display", "none");
}, qw = function() {
  !Dw && Re && Ce(Re, "display", "");
};
il && !Tw && document.addEventListener("click", function(e) {
  if (Is)
    return e.preventDefault(), e.stopPropagation && e.stopPropagation(), e.stopImmediatePropagation && e.stopImmediatePropagation(), Is = !1, !1;
}, !0);
var bo = function(t) {
  if (ue) {
    t = t.touches ? t.touches[0] : t;
    var r = FP(t.clientX, t.clientY);
    if (r) {
      var n = {};
      for (var o in t)
        t.hasOwnProperty(o) && (n[o] = t[o]);
      n.target = n.rootEl = r, n.preventDefault = void 0, n.stopPropagation = void 0, r[ar]._onDragOver(n);
    }
  }
}, NP = function(t) {
  ue && ue.parentNode[ar]._isOutsideThisEl(t.target);
};
function ke(e, t) {
  if (!(e && e.nodeType && e.nodeType === 1))
    throw "Sortable: `el` must be an HTMLElement, not ".concat({}.toString.call(e));
  this.el = e, this.options = t = En({}, t), e[ar] = this;
  var r = {
    group: null,
    sort: !0,
    disabled: !1,
    store: null,
    handle: null,
    draggable: /^[uo]l$/i.test(e.nodeName) ? ">li" : ">*",
    swapThreshold: 1,
    // percentage; 0 <= x <= 1
    invertSwap: !1,
    // invert always
    invertedSwapThreshold: null,
    // will be set to same as swapThreshold if default
    removeCloneOnHide: !0,
    direction: function() {
      return Rw(e, this.options);
    },
    ghostClass: "sortable-ghost",
    chosenClass: "sortable-chosen",
    dragClass: "sortable-drag",
    ignore: "a, img",
    filter: null,
    preventOnFilter: !0,
    animation: 0,
    easing: null,
    setData: function(i, s) {
      i.setData("Text", s.textContent);
    },
    dropBubble: !1,
    dragoverBubble: !1,
    dataIdAttr: "data-id",
    delay: 0,
    delayOnTouchOnly: !1,
    touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
    forceFallback: !1,
    fallbackClass: "sortable-fallback",
    fallbackOnBody: !1,
    fallbackTolerance: 0,
    fallbackOffset: {
      x: 0,
      y: 0
    },
    // Disabled on Safari: #1571; Enabled on Safari IOS: #2244
    supportPointer: ke.supportPointer !== !1 && "PointerEvent" in window && (!Qi || Yp),
    emptyInsertThreshold: 5
  };
  ya.initializePlugins(this, e, r);
  for (var n in r)
    !(n in t) && (t[n] = r[n]);
  Mw(t);
  for (var o in this)
    o.charAt(0) === "_" && typeof this[o] == "function" && (this[o] = this[o].bind(this));
  this.nativeDraggable = t.forceFallback ? !1 : qP, this.nativeDraggable && (this.options.touchStartThreshold = 1), t.supportPointer ? ze(e, "pointerdown", this._onTapStart) : (ze(e, "mousedown", this._onTapStart), ze(e, "touchstart", this._onTapStart)), this.nativeDraggable && (ze(e, "dragover", this), ze(e, "dragenter", this)), Ds.push(this.el), t.store && t.store.get && this.sort(t.store.get(this) || []), En(this, IP());
}
ke.prototype = /** @lends Sortable.prototype */
{
  constructor: ke,
  _isOutsideThisEl: function(t) {
    !this.el.contains(t) && t !== this.el && (Vo = null);
  },
  _getDirection: function(t, r) {
    return typeof this.options.direction == "function" ? this.options.direction.call(this, t, r, ue) : this.options.direction;
  },
  _onTapStart: function(t) {
    if (t.cancelable) {
      var r = this, n = this.el, o = this.options, a = o.preventOnFilter, i = t.type, s = t.touches && t.touches[0] || t.pointerType && t.pointerType === "touch" && t, l = (s || t).target, u = t.target.shadowRoot && (t.path && t.path[0] || t.composedPath && t.composedPath()[0]) || l, c = o.filter;
      if (KP(n), !ue && !(/mousedown|pointerdown/.test(i) && t.button !== 0 || o.disabled) && !u.isContentEditable && !(!this.nativeDraggable && Qi && l && l.tagName.toUpperCase() === "SELECT") && (l = Nr(l, o.draggable, n, !1), !(l && l.animated) && vs !== l)) {
        if (Yo = Er(l), ta = Er(l, o.draggable), typeof c == "function") {
          if (c.call(this, t, l, this)) {
            Xt({
              sortable: r,
              rootEl: u,
              name: "filter",
              targetEl: l,
              toEl: n,
              fromEl: n
            }), or("filter", r, {
              evt: t
            }), a && t.preventDefault();
            return;
          }
        } else if (c && (c = c.split(",").some(function(d) {
          if (d = Nr(u, d.trim(), n, !1), d)
            return Xt({
              sortable: r,
              rootEl: d,
              name: "filter",
              targetEl: l,
              fromEl: n,
              toEl: n
            }), or("filter", r, {
              evt: t
            }), !0;
        }), c)) {
          a && t.preventDefault();
          return;
        }
        o.handle && !Nr(u, o.handle, n, !1) || this._prepareDragStart(t, s, l);
      }
    }
  },
  _prepareDragStart: function(t, r, n) {
    var o = this, a = o.el, i = o.options, s = a.ownerDocument, l;
    if (n && !ue && n.parentNode === a) {
      var u = Ot(n);
      if (lt = a, ue = n, ht = ue.parentNode, _o = ue.nextSibling, vs = n, is = i.group, ke.dragged = ue, yo = {
        target: ue,
        clientX: (r || t).clientX,
        clientY: (r || t).clientY
      }, S0 = yo.clientX - u.left, x0 = yo.clientY - u.top, this._lastX = (r || t).clientX, this._lastY = (r || t).clientY, ue.style["will-change"] = "all", l = function() {
        if (or("delayEnded", o, {
          evt: t
        }), ke.eventCanceled) {
          o._onDrop();
          return;
        }
        o._disableDelayedDragEvents(), !y0 && o.nativeDraggable && (ue.draggable = !0), o._triggerDragStart(t, r), Xt({
          sortable: o,
          name: "choose",
          originalEvent: t
        }), hr(ue, i.chosenClass, !0);
      }, i.ignore.split(",").forEach(function(c) {
        $w(ue, c.trim(), _f);
      }), ze(s, "dragover", bo), ze(s, "mousemove", bo), ze(s, "touchmove", bo), i.supportPointer ? (ze(s, "pointerup", o._onDrop), !this.nativeDraggable && ze(s, "pointercancel", o._onDrop)) : (ze(s, "mouseup", o._onDrop), ze(s, "touchend", o._onDrop), ze(s, "touchcancel", o._onDrop)), y0 && this.nativeDraggable && (this.options.touchStartThreshold = 4, ue.draggable = !0), or("delayStart", this, {
        evt: t
      }), i.delay && (!i.delayOnTouchOnly || r) && (!this.nativeDraggable || !(ga || Cn))) {
        if (ke.eventCanceled) {
          this._onDrop();
          return;
        }
        i.supportPointer ? (ze(s, "pointerup", o._disableDelayedDrag), ze(s, "pointercancel", o._disableDelayedDrag)) : (ze(s, "mouseup", o._disableDelayedDrag), ze(s, "touchend", o._disableDelayedDrag), ze(s, "touchcancel", o._disableDelayedDrag)), ze(s, "mousemove", o._delayedDragTouchMoveHandler), ze(s, "touchmove", o._delayedDragTouchMoveHandler), i.supportPointer && ze(s, "pointermove", o._delayedDragTouchMoveHandler), o._dragStartTimer = setTimeout(l, i.delay);
      } else
        l();
    }
  },
  _delayedDragTouchMoveHandler: function(t) {
    var r = t.touches ? t.touches[0] : t;
    Math.max(Math.abs(r.clientX - this._lastX), Math.abs(r.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1)) && this._disableDelayedDrag();
  },
  _disableDelayedDrag: function() {
    ue && _f(ue), clearTimeout(this._dragStartTimer), this._disableDelayedDragEvents();
  },
  _disableDelayedDragEvents: function() {
    var t = this.el.ownerDocument;
    Ne(t, "mouseup", this._disableDelayedDrag), Ne(t, "touchend", this._disableDelayedDrag), Ne(t, "touchcancel", this._disableDelayedDrag), Ne(t, "pointerup", this._disableDelayedDrag), Ne(t, "pointercancel", this._disableDelayedDrag), Ne(t, "mousemove", this._delayedDragTouchMoveHandler), Ne(t, "touchmove", this._delayedDragTouchMoveHandler), Ne(t, "pointermove", this._delayedDragTouchMoveHandler);
  },
  _triggerDragStart: function(t, r) {
    r = r || t.pointerType == "touch" && t, !this.nativeDraggable || r ? this.options.supportPointer ? ze(document, "pointermove", this._onTouchMove) : r ? ze(document, "touchmove", this._onTouchMove) : ze(document, "mousemove", this._onTouchMove) : (ze(ue, "dragend", this), ze(lt, "dragstart", this._onDragStart));
    try {
      document.selection ? ys(function() {
        document.selection.empty();
      }) : window.getSelection().removeAllRanges();
    } catch {
    }
  },
  _dragStarted: function(t, r) {
    if (Go = !1, lt && ue) {
      or("dragStarted", this, {
        evt: r
      }), this.nativeDraggable && ze(document, "dragover", NP);
      var n = this.options;
      !t && hr(ue, n.dragClass, !1), hr(ue, n.ghostClass, !0), ke.active = this, t && this._appendGhost(), Xt({
        sortable: this,
        name: "start",
        originalEvent: r
      });
    } else
      this._nulling();
  },
  _emulateDragOver: function() {
    if (Fr) {
      this._lastX = Fr.clientX, this._lastY = Fr.clientY, Bw();
      for (var t = document.elementFromPoint(Fr.clientX, Fr.clientY), r = t; t && t.shadowRoot && (t = t.shadowRoot.elementFromPoint(Fr.clientX, Fr.clientY), t !== r); )
        r = t;
      if (ue.parentNode[ar]._isOutsideThisEl(t), r)
        do {
          if (r[ar]) {
            var n = void 0;
            if (n = r[ar]._onDragOver({
              clientX: Fr.clientX,
              clientY: Fr.clientY,
              target: t,
              rootEl: r
            }), n && !this.options.dragoverBubble)
              break;
          }
          t = r;
        } while (r = Ow(r));
      qw();
    }
  },
  _onTouchMove: function(t) {
    if (yo) {
      var r = this.options, n = r.fallbackTolerance, o = r.fallbackOffset, a = t.touches ? t.touches[0] : t, i = Re && Zo(Re, !0), s = Re && i && i.a, l = Re && i && i.d, u = ss && Vt && _0(Vt), c = (a.clientX - yo.clientX + o.x) / (s || 1) + (u ? u[0] - wf[0] : 0) / (s || 1), d = (a.clientY - yo.clientY + o.y) / (l || 1) + (u ? u[1] - wf[1] : 0) / (l || 1);
      if (!ke.active && !Go) {
        if (n && Math.max(Math.abs(a.clientX - this._lastX), Math.abs(a.clientY - this._lastY)) < n)
          return;
        this._onDragStart(t, !0);
      }
      if (Re) {
        i ? (i.e += c - (yf || 0), i.f += d - (bf || 0)) : i = {
          a: 1,
          b: 0,
          c: 0,
          d: 1,
          e: c,
          f: d
        };
        var h = "matrix(".concat(i.a, ",").concat(i.b, ",").concat(i.c, ",").concat(i.d, ",").concat(i.e, ",").concat(i.f, ")");
        Ce(Re, "webkitTransform", h), Ce(Re, "mozTransform", h), Ce(Re, "msTransform", h), Ce(Re, "transform", h), yf = c, bf = d, Fr = a;
      }
      t.cancelable && t.preventDefault();
    }
  },
  _appendGhost: function() {
    if (!Re) {
      var t = this.options.fallbackOnBody ? document.body : lt, r = Ot(ue, !0, ss, !0, t), n = this.options;
      if (ss) {
        for (Vt = t; Ce(Vt, "position") === "static" && Ce(Vt, "transform") === "none" && Vt !== document; )
          Vt = Vt.parentNode;
        Vt !== document.body && Vt !== document.documentElement ? (Vt === document && (Vt = Xr()), r.top += Vt.scrollTop, r.left += Vt.scrollLeft) : Vt = Xr(), wf = _0(Vt);
      }
      Re = ue.cloneNode(!0), hr(Re, n.ghostClass, !1), hr(Re, n.fallbackClass, !0), hr(Re, n.dragClass, !0), Ce(Re, "transition", ""), Ce(Re, "transform", ""), Ce(Re, "box-sizing", "border-box"), Ce(Re, "margin", 0), Ce(Re, "top", r.top), Ce(Re, "left", r.left), Ce(Re, "width", r.width), Ce(Re, "height", r.height), Ce(Re, "opacity", "0.8"), Ce(Re, "position", ss ? "absolute" : "fixed"), Ce(Re, "zIndex", "100000"), Ce(Re, "pointerEvents", "none"), ke.ghost = Re, t.appendChild(Re), Ce(Re, "transform-origin", S0 / parseInt(Re.style.width) * 100 + "% " + x0 / parseInt(Re.style.height) * 100 + "%");
    }
  },
  _onDragStart: function(t, r) {
    var n = this, o = t.dataTransfer, a = n.options;
    if (or("dragStart", this, {
      evt: t
    }), ke.eventCanceled) {
      this._onDrop();
      return;
    }
    or("setupClone", this), ke.eventCanceled || (dt = Pw(ue), dt.removeAttribute("id"), dt.draggable = !1, dt.style["will-change"] = "", this._hideClone(), hr(dt, this.options.chosenClass, !1), ke.clone = dt), n.cloneId = ys(function() {
      or("clone", n), !ke.eventCanceled && (n.options.removeCloneOnHide || lt.insertBefore(dt, ue), n._hideClone(), Xt({
        sortable: n,
        name: "clone"
      }));
    }), !r && hr(ue, a.dragClass, !0), r ? (Is = !0, n._loopId = setInterval(n._emulateDragOver, 50)) : (Ne(document, "mouseup", n._onDrop), Ne(document, "touchend", n._onDrop), Ne(document, "touchcancel", n._onDrop), o && (o.effectAllowed = "move", a.setData && a.setData.call(n, o, ue)), ze(document, "drop", n), Ce(ue, "transform", "translateZ(0)")), Go = !0, n._dragStartId = ys(n._dragStarted.bind(n, r, t)), ze(document, "selectstart", n), Ji = !0, window.getSelection().removeAllRanges(), Qi && Ce(document.body, "user-select", "none");
  },
  // Returns true - if no further action is needed (either inserted or another condition)
  _onDragOver: function(t) {
    var r = this.el, n = t.target, o, a, i, s = this.options, l = s.group, u = ke.active, c = is === l, d = s.sort, h = jt || u, y, m = this, p = !1;
    if (op) return;
    function f(D, H) {
      or(D, m, tn({
        evt: t,
        isOwner: c,
        axis: y ? "vertical" : "horizontal",
        revert: i,
        dragRect: o,
        targetRect: a,
        canSort: d,
        fromSortable: h,
        target: n,
        completed: w,
        onMove: function(ee, oe) {
          return ls(lt, r, ue, o, ee, Ot(ee), t, oe);
        },
        changed: _
      }, H));
    }
    function v() {
      f("dragOverAnimationCapture"), m.captureAnimationState(), m !== h && h.captureAnimationState();
    }
    function w(D) {
      return f("dragOverCompleted", {
        insertion: D
      }), D && (c ? u._hideClone() : u._showClone(m), m !== h && (hr(ue, jt ? jt.options.ghostClass : u.options.ghostClass, !1), hr(ue, s.ghostClass, !0)), jt !== m && m !== ke.active ? jt = m : m === ke.active && jt && (jt = null), h === m && (m._ignoreWhileAnimating = n), m.animateAll(function() {
        f("dragOverAnimationComplete"), m._ignoreWhileAnimating = null;
      }), m !== h && (h.animateAll(), h._ignoreWhileAnimating = null)), (n === ue && !ue.animated || n === r && !n.animated) && (Vo = null), !s.dragoverBubble && !t.rootEl && n !== document && (ue.parentNode[ar]._isOutsideThisEl(t.target), !D && bo(t)), !s.dragoverBubble && t.stopPropagation && t.stopPropagation(), p = !0;
    }
    function _() {
      mr = Er(ue), Gn = Er(ue, s.draggable), Xt({
        sortable: m,
        name: "change",
        toEl: r,
        newIndex: mr,
        newDraggableIndex: Gn,
        originalEvent: t
      });
    }
    if (t.preventDefault !== void 0 && t.cancelable && t.preventDefault(), n = Nr(n, s.draggable, r, !0), f("dragOver"), ke.eventCanceled) return p;
    if (ue.contains(t.target) || n.animated && n.animatingX && n.animatingY || m._ignoreWhileAnimating === n)
      return w(!1);
    if (Is = !1, u && !s.disabled && (c ? d || (i = ht !== lt) : jt === this || (this.lastPutMode = is.checkPull(this, u, ue, t)) && l.checkPut(this, u, ue, t))) {
      if (y = this._getDirection(t, n) === "vertical", o = Ot(ue), f("dragOverValid"), ke.eventCanceled) return p;
      if (i)
        return ht = lt, v(), this._hideClone(), f("revert"), ke.eventCanceled || (_o ? lt.insertBefore(ue, _o) : lt.appendChild(ue)), w(!0);
      var T = Jp(r, s.draggable);
      if (!T || WP(t, y, this) && !T.animated) {
        if (T === ue)
          return w(!1);
        if (T && r === t.target && (n = T), n && (a = Ot(n)), ls(lt, r, ue, o, n, a, t, !!n) !== !1)
          return v(), T && T.nextSibling ? r.insertBefore(ue, T.nextSibling) : r.appendChild(ue), ht = r, _(), w(!0);
      } else if (T && UP(t, y, this)) {
        var A = si(r, 0, s, !0);
        if (A === ue)
          return w(!1);
        if (n = A, a = Ot(n), ls(lt, r, ue, o, n, a, t, !1) !== !1)
          return v(), r.insertBefore(ue, A), ht = r, _(), w(!0);
      } else if (n.parentNode === r) {
        a = Ot(n);
        var O = 0, M, I = ue.parentNode !== r, C = !LP(ue.animated && ue.toRect || o, n.animated && n.toRect || a, y), E = y ? "top" : "left", R = w0(n, "top", "top") || w0(ue, "top", "top"), k = R ? R.scrollTop : void 0;
        Vo !== n && (M = a[E], na = !1, as = !C && s.invertSwap || I), O = VP(t, n, a, y, C ? 1 : s.swapThreshold, s.invertedSwapThreshold == null ? s.swapThreshold : s.invertedSwapThreshold, as, Vo === n);
        var L;
        if (O !== 0) {
          var z = Er(ue);
          do
            z -= O, L = ht.children[z];
          while (L && (Ce(L, "display") === "none" || L === Re));
        }
        if (O === 0 || L === n)
          return w(!1);
        Vo = n, ra = O;
        var F = n.nextElementSibling, q = !1;
        q = O === 1;
        var j = ls(lt, r, ue, o, n, a, t, q);
        if (j !== !1)
          return (j === 1 || j === -1) && (q = j === 1), op = !0, setTimeout(jP, 30), v(), q && !F ? r.appendChild(ue) : n.parentNode.insertBefore(ue, q ? F : n), R && kw(R, 0, k - R.scrollTop), ht = ue.parentNode, M !== void 0 && !as && (gs = Math.abs(M - Ot(n)[E])), _(), w(!0);
      }
      if (r.contains(ue))
        return w(!1);
    }
    return !1;
  },
  _ignoreWhileAnimating: null,
  _offMoveEvents: function() {
    Ne(document, "mousemove", this._onTouchMove), Ne(document, "touchmove", this._onTouchMove), Ne(document, "pointermove", this._onTouchMove), Ne(document, "dragover", bo), Ne(document, "mousemove", bo), Ne(document, "touchmove", bo);
  },
  _offUpEvents: function() {
    var t = this.el.ownerDocument;
    Ne(t, "mouseup", this._onDrop), Ne(t, "touchend", this._onDrop), Ne(t, "pointerup", this._onDrop), Ne(t, "pointercancel", this._onDrop), Ne(t, "touchcancel", this._onDrop), Ne(document, "selectstart", this);
  },
  _onDrop: function(t) {
    var r = this.el, n = this.options;
    if (mr = Er(ue), Gn = Er(ue, n.draggable), or("drop", this, {
      evt: t
    }), ht = ue && ue.parentNode, mr = Er(ue), Gn = Er(ue, n.draggable), ke.eventCanceled) {
      this._nulling();
      return;
    }
    Go = !1, as = !1, na = !1, clearInterval(this._loopId), clearTimeout(this._dragStartTimer), ip(this.cloneId), ip(this._dragStartId), this.nativeDraggable && (Ne(document, "drop", this), Ne(r, "dragstart", this._onDragStart)), this._offMoveEvents(), this._offUpEvents(), Qi && Ce(document.body, "user-select", ""), Ce(ue, "transform", ""), t && (Ji && (t.cancelable && t.preventDefault(), !n.dropBubble && t.stopPropagation()), Re && Re.parentNode && Re.parentNode.removeChild(Re), (lt === ht || jt && jt.lastPutMode !== "clone") && dt && dt.parentNode && dt.parentNode.removeChild(dt), ue && (this.nativeDraggable && Ne(ue, "dragend", this), _f(ue), ue.style["will-change"] = "", Ji && !Go && hr(ue, jt ? jt.options.ghostClass : this.options.ghostClass, !1), hr(ue, this.options.chosenClass, !1), Xt({
      sortable: this,
      name: "unchoose",
      toEl: ht,
      newIndex: null,
      newDraggableIndex: null,
      originalEvent: t
    }), lt !== ht ? (mr >= 0 && (Xt({
      rootEl: ht,
      name: "add",
      toEl: ht,
      fromEl: lt,
      originalEvent: t
    }), Xt({
      sortable: this,
      name: "remove",
      toEl: ht,
      originalEvent: t
    }), Xt({
      rootEl: ht,
      name: "sort",
      toEl: ht,
      fromEl: lt,
      originalEvent: t
    }), Xt({
      sortable: this,
      name: "sort",
      toEl: ht,
      originalEvent: t
    })), jt && jt.save()) : mr !== Yo && mr >= 0 && (Xt({
      sortable: this,
      name: "update",
      toEl: ht,
      originalEvent: t
    }), Xt({
      sortable: this,
      name: "sort",
      toEl: ht,
      originalEvent: t
    })), ke.active && ((mr == null || mr === -1) && (mr = Yo, Gn = ta), Xt({
      sortable: this,
      name: "end",
      toEl: ht,
      originalEvent: t
    }), this.save()))), this._nulling();
  },
  _nulling: function() {
    or("nulling", this), lt = ue = ht = Re = _o = dt = vs = Kn = yo = Fr = Ji = mr = Gn = Yo = ta = Vo = ra = jt = is = ke.dragged = ke.ghost = ke.clone = ke.active = null, Rs.forEach(function(t) {
      t.checked = !0;
    }), Rs.length = yf = bf = 0;
  },
  handleEvent: function(t) {
    switch (t.type) {
      case "drop":
      case "dragend":
        this._onDrop(t);
        break;
      case "dragenter":
      case "dragover":
        ue && (this._onDragOver(t), zP(t));
        break;
      case "selectstart":
        t.preventDefault();
        break;
    }
  },
  /**
   * Serializes the item into an array of string.
   * @returns {String[]}
   */
  toArray: function() {
    for (var t = [], r, n = this.el.children, o = 0, a = n.length, i = this.options; o < a; o++)
      r = n[o], Nr(r, i.draggable, this.el, !1) && t.push(r.getAttribute(i.dataIdAttr) || GP(r));
    return t;
  },
  /**
   * Sorts the elements according to the array.
   * @param  {String[]}  order  order of the items
   */
  sort: function(t, r) {
    var n = {}, o = this.el;
    this.toArray().forEach(function(a, i) {
      var s = o.children[i];
      Nr(s, this.options.draggable, o, !1) && (n[a] = s);
    }, this), r && this.captureAnimationState(), t.forEach(function(a) {
      n[a] && (o.removeChild(n[a]), o.appendChild(n[a]));
    }), r && this.animateAll();
  },
  /**
   * Save the current sorting
   */
  save: function() {
    var t = this.options.store;
    t && t.set && t.set(this);
  },
  /**
   * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
   * @param   {HTMLElement}  el
   * @param   {String}       [selector]  default: `options.draggable`
   * @returns {HTMLElement|null}
   */
  closest: function(t, r) {
    return Nr(t, r || this.options.draggable, this.el, !1);
  },
  /**
   * Set/get option
   * @param   {string} name
   * @param   {*}      [value]
   * @returns {*}
   */
  option: function(t, r) {
    var n = this.options;
    if (r === void 0)
      return n[t];
    var o = ya.modifyOption(this, t, r);
    typeof o < "u" ? n[t] = o : n[t] = r, t === "group" && Mw(n);
  },
  /**
   * Destroy
   */
  destroy: function() {
    or("destroy", this);
    var t = this.el;
    t[ar] = null, Ne(t, "mousedown", this._onTapStart), Ne(t, "touchstart", this._onTapStart), Ne(t, "pointerdown", this._onTapStart), this.nativeDraggable && (Ne(t, "dragover", this), Ne(t, "dragenter", this)), Array.prototype.forEach.call(t.querySelectorAll("[draggable]"), function(r) {
      r.removeAttribute("draggable");
    }), this._onDrop(), this._disableDelayedDragEvents(), Ds.splice(Ds.indexOf(this.el), 1), this.el = t = null;
  },
  _hideClone: function() {
    if (!Kn) {
      if (or("hideClone", this), ke.eventCanceled) return;
      Ce(dt, "display", "none"), this.options.removeCloneOnHide && dt.parentNode && dt.parentNode.removeChild(dt), Kn = !0;
    }
  },
  _showClone: function(t) {
    if (t.lastPutMode !== "clone") {
      this._hideClone();
      return;
    }
    if (Kn) {
      if (or("showClone", this), ke.eventCanceled) return;
      ue.parentNode == lt && !this.options.group.revertClone ? lt.insertBefore(dt, ue) : _o ? lt.insertBefore(dt, _o) : lt.appendChild(dt), this.options.group.revertClone && this.animate(ue, dt), Ce(dt, "display", ""), Kn = !1;
    }
  }
};
function zP(e) {
  e.dataTransfer && (e.dataTransfer.dropEffect = "move"), e.cancelable && e.preventDefault();
}
function ls(e, t, r, n, o, a, i, s) {
  var l, u = e[ar], c = u.options.onMove, d;
  return window.CustomEvent && !Cn && !ga ? l = new CustomEvent("move", {
    bubbles: !0,
    cancelable: !0
  }) : (l = document.createEvent("Event"), l.initEvent("move", !0, !0)), l.to = t, l.from = e, l.dragged = r, l.draggedRect = n, l.related = o || t, l.relatedRect = a || Ot(t), l.willInsertAfter = s, l.originalEvent = i, e.dispatchEvent(l), c && (d = c.call(u, l, i)), d;
}
function _f(e) {
  e.draggable = !1;
}
function jP() {
  op = !1;
}
function UP(e, t, r) {
  var n = Ot(si(r.el, 0, r.options, !0)), o = Iw(r.el, r.options, Re), a = 10;
  return t ? e.clientX < o.left - a || e.clientY < n.top && e.clientX < n.right : e.clientY < o.top - a || e.clientY < n.bottom && e.clientX < n.left;
}
function WP(e, t, r) {
  var n = Ot(Jp(r.el, r.options.draggable)), o = Iw(r.el, r.options, Re), a = 10;
  return t ? e.clientX > o.right + a || e.clientY > n.bottom && e.clientX > n.left : e.clientY > o.bottom + a || e.clientX > n.right && e.clientY > n.top;
}
function VP(e, t, r, n, o, a, i, s) {
  var l = n ? e.clientY : e.clientX, u = n ? r.height : r.width, c = n ? r.top : r.left, d = n ? r.bottom : r.right, h = !1;
  if (!i) {
    if (s && gs < u * o) {
      if (!na && (ra === 1 ? l > c + u * a / 2 : l < d - u * a / 2) && (na = !0), na)
        h = !0;
      else if (ra === 1 ? l < c + gs : l > d - gs)
        return -ra;
    } else if (l > c + u * (1 - o) / 2 && l < d - u * (1 - o) / 2)
      return HP(t);
  }
  return h = h || i, h && (l < c + u * a / 2 || l > d - u * a / 2) ? l > c + u / 2 ? 1 : -1 : 0;
}
function HP(e) {
  return Er(ue) < Er(e) ? 1 : -1;
}
function GP(e) {
  for (var t = e.tagName + e.className + e.src + e.href + e.textContent, r = t.length, n = 0; r--; )
    n += t.charCodeAt(r);
  return n.toString(36);
}
function KP(e) {
  Rs.length = 0;
  for (var t = e.getElementsByTagName("input"), r = t.length; r--; ) {
    var n = t[r];
    n.checked && Rs.push(n);
  }
}
function ys(e) {
  return setTimeout(e, 0);
}
function ip(e) {
  return clearTimeout(e);
}
il && ze(document, "touchmove", function(e) {
  (ke.active || Go) && e.cancelable && e.preventDefault();
});
ke.utils = {
  on: ze,
  off: Ne,
  css: Ce,
  find: $w,
  is: function(t, r) {
    return !!Nr(t, r, t, !1);
  },
  extend: kP,
  throttle: Cw,
  closest: Nr,
  toggleClass: hr,
  clone: Pw,
  index: Er,
  nextTick: ys,
  cancelNextTick: ip,
  detectDirection: Rw,
  getChild: si,
  expando: ar
};
ke.get = function(e) {
  return e[ar];
};
ke.mount = function() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  t[0].constructor === Array && (t = t[0]), t.forEach(function(n) {
    if (!n.prototype || !n.prototype.constructor)
      throw "Sortable: Mounted plugin must be a constructor function, not ".concat({}.toString.call(n));
    n.utils && (ke.utils = tn(tn({}, ke.utils), n.utils)), ya.mount(n);
  });
};
ke.create = function(e, t) {
  return new ke(e, t);
};
ke.version = $P;
var Et = [], Zi, ap, sp = !1, Sf, xf, Ms, Xi;
function YP() {
  function e() {
    this.defaults = {
      scroll: !0,
      forceAutoScrollFallback: !1,
      scrollSensitivity: 30,
      scrollSpeed: 10,
      bubbleScroll: !0
    };
    for (var t in this)
      t.charAt(0) === "_" && typeof this[t] == "function" && (this[t] = this[t].bind(this));
  }
  return e.prototype = {
    dragStarted: function(r) {
      var n = r.originalEvent;
      this.sortable.nativeDraggable ? ze(document, "dragover", this._handleAutoScroll) : this.options.supportPointer ? ze(document, "pointermove", this._handleFallbackAutoScroll) : n.touches ? ze(document, "touchmove", this._handleFallbackAutoScroll) : ze(document, "mousemove", this._handleFallbackAutoScroll);
    },
    dragOverCompleted: function(r) {
      var n = r.originalEvent;
      !this.options.dragOverBubble && !n.rootEl && this._handleAutoScroll(n);
    },
    drop: function() {
      this.sortable.nativeDraggable ? Ne(document, "dragover", this._handleAutoScroll) : (Ne(document, "pointermove", this._handleFallbackAutoScroll), Ne(document, "touchmove", this._handleFallbackAutoScroll), Ne(document, "mousemove", this._handleFallbackAutoScroll)), T0(), bs(), PP();
    },
    nulling: function() {
      Ms = ap = Zi = sp = Xi = Sf = xf = null, Et.length = 0;
    },
    _handleFallbackAutoScroll: function(r) {
      this._handleAutoScroll(r, !0);
    },
    _handleAutoScroll: function(r, n) {
      var o = this, a = (r.touches ? r.touches[0] : r).clientX, i = (r.touches ? r.touches[0] : r).clientY, s = document.elementFromPoint(a, i);
      if (Ms = r, n || this.options.forceAutoScrollFallback || ga || Cn || Qi) {
        Af(r, this.options, s, n);
        var l = Yn(s, !0);
        sp && (!Xi || a !== Sf || i !== xf) && (Xi && T0(), Xi = setInterval(function() {
          var u = Yn(document.elementFromPoint(a, i), !0);
          u !== l && (l = u, bs()), Af(r, o.options, u, n);
        }, 10), Sf = a, xf = i);
      } else {
        if (!this.options.bubbleScroll || Yn(s, !0) === Xr()) {
          bs();
          return;
        }
        Af(r, this.options, Yn(s, !1), !1);
      }
    }
  }, En(e, {
    pluginName: "scroll",
    initializeByDefault: !0
  });
}
function bs() {
  Et.forEach(function(e) {
    clearInterval(e.pid);
  }), Et = [];
}
function T0() {
  clearInterval(Xi);
}
var Af = Cw(function(e, t, r, n) {
  if (t.scroll) {
    var o = (e.touches ? e.touches[0] : e).clientX, a = (e.touches ? e.touches[0] : e).clientY, i = t.scrollSensitivity, s = t.scrollSpeed, l = Xr(), u = !1, c;
    ap !== r && (ap = r, bs(), Zi = t.scroll, c = t.scrollFn, Zi === !0 && (Zi = Yn(r, !0)));
    var d = 0, h = Zi;
    do {
      var y = h, m = Ot(y), p = m.top, f = m.bottom, v = m.left, w = m.right, _ = m.width, T = m.height, A = void 0, O = void 0, M = y.scrollWidth, I = y.scrollHeight, C = Ce(y), E = y.scrollLeft, R = y.scrollTop;
      y === l ? (A = _ < M && (C.overflowX === "auto" || C.overflowX === "scroll" || C.overflowX === "visible"), O = T < I && (C.overflowY === "auto" || C.overflowY === "scroll" || C.overflowY === "visible")) : (A = _ < M && (C.overflowX === "auto" || C.overflowX === "scroll"), O = T < I && (C.overflowY === "auto" || C.overflowY === "scroll"));
      var k = A && (Math.abs(w - o) <= i && E + _ < M) - (Math.abs(v - o) <= i && !!E), L = O && (Math.abs(f - a) <= i && R + T < I) - (Math.abs(p - a) <= i && !!R);
      if (!Et[d])
        for (var z = 0; z <= d; z++)
          Et[z] || (Et[z] = {});
      (Et[d].vx != k || Et[d].vy != L || Et[d].el !== y) && (Et[d].el = y, Et[d].vx = k, Et[d].vy = L, clearInterval(Et[d].pid), (k != 0 || L != 0) && (u = !0, Et[d].pid = setInterval((function() {
        n && this.layer === 0 && ke.active._onTouchMove(Ms);
        var F = Et[this.layer].vy ? Et[this.layer].vy * s : 0, q = Et[this.layer].vx ? Et[this.layer].vx * s : 0;
        typeof c == "function" && c.call(ke.dragged.parentNode[ar], q, F, e, Ms, Et[this.layer].el) !== "continue" || kw(Et[this.layer].el, q, F);
      }).bind({
        layer: d
      }), 24))), d++;
    } while (t.bubbleScroll && h !== l && (h = Yn(h, !1)));
    sp = u;
  }
}, 30), Lw = function(t) {
  var r = t.originalEvent, n = t.putSortable, o = t.dragEl, a = t.activeSortable, i = t.dispatchSortableEvent, s = t.hideGhostForTarget, l = t.unhideGhostForTarget;
  if (r) {
    var u = n || a;
    s();
    var c = r.changedTouches && r.changedTouches.length ? r.changedTouches[0] : r, d = document.elementFromPoint(c.clientX, c.clientY);
    l(), u && !u.el.contains(d) && (i("spill"), this.onSpill({
      dragEl: o,
      putSortable: n
    }));
  }
};
function Zp() {
}
Zp.prototype = {
  startIndex: null,
  dragStart: function(t) {
    var r = t.oldDraggableIndex;
    this.startIndex = r;
  },
  onSpill: function(t) {
    var r = t.dragEl, n = t.putSortable;
    this.sortable.captureAnimationState(), n && n.captureAnimationState();
    var o = si(this.sortable.el, this.startIndex, this.options);
    o ? this.sortable.el.insertBefore(r, o) : this.sortable.el.appendChild(r), this.sortable.animateAll(), n && n.animateAll();
  },
  drop: Lw
};
En(Zp, {
  pluginName: "revertOnSpill"
});
function Xp() {
}
Xp.prototype = {
  onSpill: function(t) {
    var r = t.dragEl, n = t.putSortable, o = n || this.sortable;
    o.captureAnimationState(), r.parentNode && r.parentNode.removeChild(r), o.animateAll();
  },
  drop: Lw
};
En(Xp, {
  pluginName: "removeOnSpill"
});
ke.mount(new YP());
ke.mount(Xp, Zp);
const BR = /* @__PURE__ */ U({
  __name: "DataList",
  props: {
    sortable: { type: Boolean, default: !1 }
  },
  emits: ["sort"],
  setup(e, { emit: t }) {
    const r = e, n = se(), o = t;
    function a() {
      const i = [];
      n.value.querySelectorAll("[data-sortable-id]").forEach((s) => {
        i.push(s.getAttribute("data-sortable-id"));
      }), o("sort", i);
    }
    return Lt(() => {
      r.sortable && ke.create(n.value, {
        animation: 100,
        handle: ".drag-handle",
        ghostClass: "ghost",
        chosenClass: "chosen",
        forceFallback: !0,
        onSort: a
      });
    }), tt("sortable", r.sortable), (i, s) => ($(), B("ul", {
      ref_key: "$list",
      ref: n,
      class: "bg-white dark:bg-zinc-950 dark:border-zinc-700 border rounded divide-y dark:divide-zinc-700 overflow-hidden"
    }, [
      V(i.$slots, "default")
    ], 512));
  }
}), JP = {}, ZP = { class: "flex-1 space-y-1.5" };
function XP(e, t) {
  return $(), B("div", ZP, [
    V(e.$slots, "default")
  ]);
}
const qR = /* @__PURE__ */ De(JP, [["render", XP]]), QP = ["data-sortable-id"], eI = /* @__PURE__ */ U({
  __name: "DataListItem",
  props: {
    id: {}
  },
  setup(e) {
    const t = je("sortable");
    return (r, n) => ($(), B("li", {
      class: "flex items-center justify-between bg-white dark:bg-zinc-950 px-4 py-3 space-x-4",
      "data-sortable-id": r.id
    }, [
      S(t) ? ($(), ne(S(g2), {
        key: 0,
        class: "cursor-grab select-none text-slate-400 dark:text-zinc-500 drag-handle size-4"
      })) : _e("", !0),
      V(r.$slots, "default", {}, void 0, !0)
    ], 8, QP));
  }
}), LR = /* @__PURE__ */ De(eI, [["__scopeId", "data-v-af1d3709"]]), tI = {};
function rI(e, t) {
  return $(), B("div", null, [
    V(e.$slots, "default")
  ]);
}
const FR = /* @__PURE__ */ De(tI, [["render", rI]]), E0 = /* @__PURE__ */ U({
  __name: "DataTableCell",
  props: {
    as: { default: "td" },
    column: {}
  },
  setup(e) {
    const t = e, r = re(() => t.column.columnType === "numeric" ? "right" : "left"), n = re(() => [
      { "text-left": r.value === "left" },
      { "text-right": r.value === "right" }
    ]);
    return (o, a) => ($(), ne(er(o.as), {
      class: Te(["px-3 py-2 align-middle [&:has([role=checkbox])]:pr-0", n.value])
    }, {
      default: Y(() => [
        V(o.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), nI = {}, oI = { class: "border-b hover:bg-slate-50" };
function iI(e, t) {
  return $(), B("tr", oI, [
    V(e.$slots, "default")
  ]);
}
const O0 = /* @__PURE__ */ De(nI, [["render", iI]]), aI = { class: "w-full" }, sI = { class: "[&_tr]:bg-slate-50 shadow relative" }, lI = { class: "[&_tr:last-child]:border-0" }, NR = /* @__PURE__ */ U({
  __name: "DataTable",
  setup(e) {
    const t = je("dataTableColumns"), r = je("dataTableRows");
    return (n, o) => ($(), ne(S(Np), null, {
      default: Y(() => [
        X("table", aI, [
          X("thead", sI, [
            ie(O0, null, {
              default: Y(() => [
                ($(!0), B(qt, null, sr(S(t), (a) => ($(), ne(E0, {
                  key: a.accessorKey,
                  column: a,
                  as: "th"
                }, {
                  default: Y(() => [
                    et(Ie(a.header), 1)
                  ]),
                  _: 2
                }, 1032, ["column"]))), 128))
              ]),
              _: 1
            })
          ]),
          X("tbody", lI, [
            ($(!0), B(qt, null, sr(S(r), (a) => ($(), ne(O0, {
              key: a.id
            }, {
              default: Y(() => [
                ($(!0), B(qt, null, sr(S(t), (i) => ($(), ne(E0, {
                  key: i.accessorKey,
                  column: i
                }, {
                  default: Y(() => [
                    V(n.$slots, i.accessorKey, { row: a }, () => [
                      et(Ie(a[i.accessorKey]), 1)
                    ])
                  ]),
                  _: 2
                }, 1032, ["column"]))), 128))
              ]),
              _: 2
            }, 1024))), 128))
          ])
        ])
      ]),
      _: 3
    }));
  }
}), zR = /* @__PURE__ */ U({
  __name: "DataTableRoot",
  props: {
    columns: {},
    rows: {}
  },
  setup(e) {
    const t = e;
    return tt("dataTableColumns", _s(t, "columns")), tt("dataTableRows", _s(t, "rows")), (r, n) => V(r.$slots, "default");
  }
});
function uI(e, t) {
  return $(), B("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    X("path", {
      "fill-rule": "evenodd",
      d: "M15.97 2.47a.75.75 0 0 1 1.06 0l4.5 4.5a.75.75 0 0 1 0 1.06l-4.5 4.5a.75.75 0 1 1-1.06-1.06l3.22-3.22H7.5a.75.75 0 0 1 0-1.5h11.69l-3.22-3.22a.75.75 0 0 1 0-1.06Zm-7.94 9a.75.75 0 0 1 0 1.06l-3.22 3.22H16.5a.75.75 0 0 1 0 1.5H4.81l3.22 3.22a.75.75 0 1 1-1.06 1.06l-4.5-4.5a.75.75 0 0 1 0-1.06l4.5-4.5a.75.75 0 0 1 1.06 0Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function cI(e, t) {
  return $(), B("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    X("path", {
      "fill-rule": "evenodd",
      d: "M7.72 12.53a.75.75 0 0 1 0-1.06l7.5-7.5a.75.75 0 1 1 1.06 1.06L9.31 12l6.97 6.97a.75.75 0 1 1-1.06 1.06l-7.5-7.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function dI(e, t) {
  return $(), B("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    X("path", {
      "fill-rule": "evenodd",
      d: "M16.28 11.47a.75.75 0 0 1 0 1.06l-7.5 7.5a.75.75 0 0 1-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 0 1 1.06-1.06l7.5 7.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
const fI = {}, pI = { class: "text-sm text-slate-500" };
function hI(e, t) {
  return $(), B("p", pI, [
    V(e.$slots, "default")
  ]);
}
const Fw = /* @__PURE__ */ De(fI, [["render", hI]]), mI = {
  key: 0,
  class: "size-4 absolute left-3 text-slate-500 leading-4"
}, vI = { key: 1 }, gI = /* @__PURE__ */ U({
  __name: "TextFieldIcon",
  props: {
    icon: { type: [Function, Object, String] }
  },
  setup(e) {
    return (t, r) => t.icon ? ($(), B("span", mI, [
      t.icon && typeof t.icon == "function" ? ($(), ne(er(t.icon), {
        key: 0,
        class: ""
      })) : _e("", !0),
      t.icon && typeof t.icon == "string" ? ($(), B("span", vI, Ie(t.icon), 1)) : _e("", !0)
    ])) : _e("", !0);
  }
}), yI = /* @__PURE__ */ U({
  __name: "TextFieldPasswordIcon",
  setup(e) {
    const t = je("internalInputType");
    function r() {
      t.value = t.value === "password" ? "text" : "password";
    }
    return (n, o) => ($(), B("div", {
      class: "cursor-pointer rounded bg-slate-200 p-1 text-xs font-medium leading-none mr-1.5 hover:opacity-80",
      onClick: r
    }, [
      S(t) !== "password" ? ($(), ne(S(x2), {
        key: 0,
        class: "h-4 w-4"
      })) : _e("", !0),
      S(t) === "password" ? ($(), ne(S(A2), {
        key: 1,
        class: "h-4 w-4"
      })) : _e("", !0)
    ]));
  }
}), bI = { class: "size-4 absolute left-3" }, wI = /* @__PURE__ */ U({
  __name: "TextFieldSearchIcon",
  setup(e) {
    return (t, r) => ($(), B("div", bI, [
      ie(S(T2))
    ]));
  }
}), _I = { class: "w-full" }, SI = { class: "flex items-center justify-between" }, xI = {
  key: 1,
  class: "float-right text-sm text-slate-500"
}, Qp = /* @__PURE__ */ U({
  __name: "TextField",
  props: /* @__PURE__ */ br({
    as: { default: null },
    autoComplete: { default: null },
    disabled: { type: Boolean, default: !1 },
    error: { default: null },
    helpText: { default: null },
    icon: { type: [Function, Object, String], default: void 0 },
    id: { default: null },
    label: {},
    labelHidden: { type: Boolean, default: !1 },
    multiline: { type: Boolean, default: !1 },
    passwordReveal: { type: Boolean, default: !0 },
    name: {},
    placeholder: { default: null },
    readonly: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    type: { default: "text" },
    maxLength: { default: null }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = e, r = wr(e, "modelValue"), n = se(t.type), o = se(null), a = se(0), i = se(0);
    Lt(() => {
      t.multiline && o.value && (a.value = o.value.scrollHeight), h();
    });
    const s = t.id || Je("textField"), l = re(() => [
      { "pl-10": t.type === "search" || t.icon !== void 0 }
    ]), u = re(() => t.as ? t.as : t.multiline ? "textarea" : "input"), c = re(() => t.error ? Je("textFieldError") : void 0);
    function d(m) {
      r.value = m.target.value, Qe(() => {
        h();
      });
    }
    function h() {
      var m;
      t.maxLength && (i.value = ((m = r.value) == null ? void 0 : m.length) ?? 0), y();
    }
    function y() {
      t.multiline && o.value && (o.value.style.height = `${a.value}px`, o.value.style.height = `${o.value.scrollHeight}px`);
    }
    return tt("internalInputType", n), (m, p) => ($(), B("div", _I, [
      X("div", SI, [
        ie(S(Do), {
          id: `${S(s)}-label`,
          label: m.label,
          "label-for": S(s),
          "label-hidden": m.labelHidden
        }, null, 8, ["id", "label", "label-for", "label-hidden"])
      ]),
      X("div", {
        class: Te([{ "mt-1": !m.labelHidden }, "space-y-1"])
      }, [
        X("div", {
          class: Te([[
            m.error ? S(Qt)("focusWithin", "destructive") : S(Qt)("focusWithin"),
            { "border-red-500": m.error }
          ], "relative flex w-full items-center overflow-hidden rounded border shadow-sm dark:border-zinc-700"])
        }, [
          ($(), ne(er(u.value), We({
            id: S(s),
            ref_key: "$inputElement",
            ref: o,
            "aria-describedby": c.value,
            "aria-disabled": m.disabled,
            "aria-labelledby": `${S(s)}-label`,
            "aria-readonly": m.readonly,
            "aria-required": m.required,
            autocomplete: m.autoComplete,
            class: [l.value, "block w-full appearance-none border-none px-3 py-2 text-slate-700 outline-none placeholder:text-slate-400 disabled:cursor-not-allowed disabled:bg-slate-50 dark:bg-slate-900 dark:text-white"],
            disabled: m.disabled,
            maxlength: m.maxLength,
            name: m.name,
            placeholder: m.placeholder,
            readonly: m.readonly,
            required: m.required,
            type: n.value,
            value: r.value,
            style: { "max-height": "300px" }
          }, m.$attrs, { onInput: d }), null, 16, ["id", "aria-describedby", "aria-disabled", "aria-labelledby", "aria-readonly", "aria-required", "autocomplete", "class", "disabled", "maxlength", "name", "placeholder", "readonly", "required", "type", "value"])),
          m.icon ? ($(), ne(gI, {
            key: 0,
            icon: m.icon
          }, null, 8, ["icon"])) : _e("", !0),
          m.type === "search" ? ($(), ne(wI, { key: 1 })) : _e("", !0),
          m.type === "password" && m.passwordReveal && r.value ? ($(), ne(yI, { key: 2 })) : _e("", !0)
        ], 2),
        m.error && c.value ? ($(), ne(S(ol), {
          key: 0,
          id: c.value,
          message: m.error
        }, null, 8, ["id", "message"])) : _e("", !0),
        m.maxLength ? ($(), B("div", xI, Ie(i.value) + " / " + Ie(m.maxLength), 1)) : _e("", !0),
        m.helpText ? ($(), ne(S(Fw), { key: 2 }, {
          default: Y(() => [
            et(Ie(m.helpText), 1)
          ]),
          _: 1
        })) : _e("", !0)
      ], 2)
    ]));
  }
}), AI = { class: "w-[300px]" }, TI = { class: "rounded bg-white px-4 py-3 text-sm space-y-4" }, EI = { class: "flex items-center justify-between" }, OI = { class: "font-medium" }, $I = { class: "grid grid-cols-7" }, CI = { class: "grid grid-cols-7 gap-0.5" }, kI = ["onClick"], jR = /* @__PURE__ */ U({
  __name: "DatePicker",
  props: {
    modelValue: { required: !0 },
    modelModifiers: {}
  },
  emits: ["update:modelValue"],
  setup(e) {
    const t = wr(e, "modelValue"), r = je("datePickerLocale"), {
      displayDate: n,
      grid: o,
      monthName: a,
      next: i,
      previous: s,
      weekDays: l
    } = RS(r, t);
    return (u, c) => ($(), ne(S(jb), { alignment: "start" }, {
      default: Y(() => [
        ie(S(Wb), null, {
          default: Y(() => [
            ie(S(Qp), {
              icon: S(y2),
              "model-value": S(n),
              class: "cursor-pointer",
              label: "From date",
              name: "date",
              readonly: ""
            }, null, 8, ["icon", "model-value"])
          ]),
          _: 1
        }),
        ie(S(Ub), null, {
          default: Y(() => [
            X("div", AI, [
              X("div", TI, [
                X("div", EI, [
                  ie(S(Ir), {
                    "icon-only": "",
                    size: "small",
                    variant: "ghost",
                    onClick: S(s)
                  }, {
                    default: Y(() => [
                      ie(S(ii), { icon: S(cI) }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  X("p", OI, Ie(S(a)), 1),
                  ie(S(Ir), {
                    "icon-only": "",
                    size: "small",
                    variant: "ghost",
                    onClick: S(i)
                  }, {
                    default: Y(() => [
                      ie(S(ii), { icon: S(dI) }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                X("div", $I, [
                  ($(!0), B(qt, null, sr(S(l), (d) => ($(), B("div", {
                    key: d,
                    class: "text-center font-medium text-slate-500"
                  }, Ie(d), 1))), 128))
                ]),
                X("div", CI, [
                  ($(!0), B(qt, null, sr(S(o), (d) => ($(), B("div", {
                    key: d.toString(),
                    onClick: (h) => t.value = d.value
                  }, [
                    X("div", {
                      class: Te(["flex h-8 cursor-pointer items-center justify-center rounded", {
                        "text-slate-400": !d.inCurrentMonth,
                        "!bg-brand-500 text-white": d.selected,
                        "hover:bg-slate-200": !d.selected,
                        "bg-gray-100": d.isToday
                      }])
                    }, Ie(d.day), 3)
                  ], 8, kI))), 128))
                ])
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }));
  }
}), UR = /* @__PURE__ */ U({
  __name: "DescriptionList",
  props: {
    align: { default: "horizontal" }
  },
  setup(e) {
    return tt("descriptionListAlignment", e.align), (r, n) => ($(), B("dl", null, [
      V(r.$slots, "default")
    ]));
  }
}), PI = { class: "col-span-3" }, WR = /* @__PURE__ */ U({
  __name: "DescriptionListDescription",
  setup(e) {
    return (t, r) => ($(), B("dd", PI, [
      ie(S(Ve), { subdued: "" }, {
        default: Y(() => [
          V(t.$slots, "default")
        ]),
        _: 3
      })
    ]));
  }
}), VR = /* @__PURE__ */ U({
  __name: "DescriptionListItem",
  setup(e) {
    const t = je("descriptionListAlignment"), r = re(() => [
      { "grid-cols-4 gap-4 py-3": t === "horizontal" },
      { "py-2": t === "vertical" }
    ]);
    return (n, o) => ($(), B("div", {
      class: Te(["grid", r.value])
    }, [
      V(n.$slots, "default")
    ], 2));
  }
}), HR = /* @__PURE__ */ U({
  __name: "DescriptionListTerm",
  setup(e) {
    return (t, r) => ($(), B("dt", null, [
      ie(S(Ve), { strong: "" }, {
        default: Y(() => [
          V(t.$slots, "default")
        ]),
        _: 3
      })
    ]));
  }
}), II = ["aria-describedby", "aria-labelledby"], DI = { class: "py-8 flex min-h-full items-center justify-center" }, GR = /* @__PURE__ */ U({
  __name: "Dialog",
  props: {
    open: { type: Boolean, default: !1 }
  },
  emits: ["cancel"],
  setup(e, { emit: t }) {
    const r = t;
    function n() {
      r("cancel");
    }
    function o(s) {
      s.key === "Escape" && n();
    }
    Lt(() => {
      document.addEventListener("keydown", o);
    }), Co(() => {
      document.removeEventListener("keydown", o);
    });
    const a = Je("dialogLabel"), i = Je("dialogDescription");
    return tt("cancelDialog", n), tt("dialogLabelledBy", a), tt("dialogDescribedBy", i), (s, l) => s.open ? ($(), B("div", {
      key: 0,
      "aria-describedby": S(i),
      "aria-labelledby": S(a),
      class: "fixed inset-0 z-10 !m-0 overflow-y-auto bg-slate-500/50 px-2 text-sm dark:bg-zinc-900/50",
      role: "dialog"
    }, [
      X("div", DI, [
        V(s.$slots, "default")
      ])
    ], 8, II)) : _e("", !0);
  }
}), KR = /* @__PURE__ */ U({
  __name: "DialogCancelButton",
  setup(e) {
    const t = je("cancelDialog");
    return (r, n) => ($(), ne(S(Ir), {
      variant: "secondary",
      onClick: S(t)
    }, {
      default: Y(() => [
        V(r.$slots, "default")
      ]),
      _: 3
    }, 8, ["onClick"]));
  }
}), RI = { class: "absolute top-4 right-4" }, YR = /* @__PURE__ */ U({
  __name: "DialogContent",
  setup(e) {
    const t = je("cancelDialog"), r = se(null);
    return zs(r, () => t()), (n, o) => ($(), B("div", {
      ref_key: "target",
      ref: r,
      class: "relative w-full max-w-lg overflow-hidden rounded-lg bg-white dark:bg-zinc-950 dark:border dark:border-zinc-700 shadow-2xl"
    }, [
      X("div", RI, [
        ie(S(Ir), {
          "icon-only": "",
          size: "small",
          variant: "ghost",
          onClick: S(t)
        }, {
          default: Y(() => [
            ie(S(ii), { icon: S(ua) }, null, 8, ["icon"])
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      V(n.$slots, "default")
    ], 512));
  }
}), JR = /* @__PURE__ */ U({
  __name: "DialogDescription",
  setup(e) {
    const t = je("dialogLabelledBy");
    return (r, n) => ($(), B("p", null, [
      ie(S(Ve), {
        id: S(t),
        subdued: ""
      }, {
        default: Y(() => [
          V(r.$slots, "default")
        ]),
        _: 3
      }, 8, ["id"])
    ]));
  }
}), MI = { class: "bg-slate-100 dark:bg-zinc-900 px-4 py-3 flex items-center justify-end" }, ZR = /* @__PURE__ */ U({
  __name: "DialogFooter",
  setup(e) {
    return (t, r) => ($(), B("div", MI, [
      ie(S(Pp), null, {
        default: Y(() => [
          V(t.$slots, "default")
        ]),
        _: 3
      })
    ]));
  }
}), BI = {}, qI = { class: "flex flex-col p-6 space-y-2" };
function LI(e, t) {
  return $(), B("div", qI, [
    V(e.$slots, "default")
  ]);
}
const XR = /* @__PURE__ */ De(BI, [["render", LI]]), FI = {}, NI = { class: "px-6 py-4" };
function zI(e, t) {
  return $(), B("div", NI, [
    V(e.$slots, "default")
  ]);
}
const QR = /* @__PURE__ */ De(FI, [["render", zI]]), jI = { class: "mb-4 overflow-hidden rounded border bg-white bg-gradient-to-tl from-slate-100 p-1 shadow size-12 to-50%" }, eM = /* @__PURE__ */ U({
  __name: "DialogIcon",
  props: {
    alt: {},
    source: {}
  },
  setup(e) {
    return (t, r) => ($(), B("div", jI, [
      ie(S(fa), null, {
        default: Y(() => [
          ie(S(hi), {
            source: t.source,
            alt: t.alt,
            rounded: ""
          }, null, 8, ["source", "alt"])
        ]),
        _: 1
      })
    ]));
  }
}), tM = /* @__PURE__ */ U({
  __name: "DialogTitle",
  setup(e) {
    const t = je("dialogLabelledBy");
    return (r, n) => ($(), ne(S(gi), {
      id: S(t),
      level: "h2"
    }, {
      default: Y(() => [
        V(r.$slots, "default")
      ]),
      _: 3
    }, 8, ["id"]));
  }
}), UI = {
  key: 0,
  class: "fixed inset-0 z-10"
}, rM = /* @__PURE__ */ U({
  __name: "Drawer",
  props: {
    open: { type: Boolean, default: !1 }
  },
  emits: ["close"],
  setup(e, { emit: t }) {
    const r = t;
    function n() {
      r("close");
    }
    function o(a) {
      a.key === "Escape" && n();
    }
    return Lt(() => {
      document.addEventListener("keydown", o);
    }), Co(() => {
      document.removeEventListener("keydown", o);
    }), tt("cancelDialog", n), (a, i) => ($(), ne(lp, { name: "nested" }, {
      default: Y(() => [
        a.open ? ($(), B("div", UI, [
          i[0] || (i[0] = X("div", { class: "background fixed inset-0 flex bg-slate-500/50 dark:bg-zinc-900/50" }, null, -1)),
          V(a.$slots, "default")
        ])) : _e("", !0)
      ]),
      _: 3
    }));
  }
}), WI = { class: "absolute right-4 top-4" }, nM = /* @__PURE__ */ U({
  __name: "DrawerContent",
  setup(e) {
    const t = je("cancelDialog"), r = se(null);
    return zs(r, () => t()), (n, o) => ($(), B("div", {
      ref_key: "target",
      ref: r,
      class: "drawer absolute right-0 h-screen w-screen max-w-md bg-white p-6 shadow-2xl dark:border dark:border-zinc-700 dark:bg-zinc-950"
    }, [
      X("div", WI, [
        ie(S(Ir), {
          "icon-only": "",
          size: "small",
          variant: "ghost",
          onClick: S(t)
        }, {
          default: Y(() => [
            ie(S(ii), { icon: S(ua) }, null, 8, ["icon"])
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      V(n.$slots, "default")
    ], 512));
  }
}), oM = /* @__PURE__ */ U({
  __name: "DrawerDescription",
  setup(e) {
    return (t, r) => ($(), ne(S(Ve), { subdued: "" }, {
      default: Y(() => [
        V(t.$slots, "default")
      ]),
      _: 3
    }));
  }
}), VI = {}, HI = { class: "space-y-2 pb-6" };
function GI(e, t) {
  return $(), B("div", HI, [
    V(e.$slots, "default")
  ]);
}
const iM = /* @__PURE__ */ De(VI, [["render", GI]]), aM = /* @__PURE__ */ U({
  __name: "DrawerTitle",
  setup(e) {
    return (t, r) => ($(), ne(S(gi), { level: "h2" }, {
      default: Y(() => [
        V(t.$slots, "default")
      ]),
      _: 3
    }));
  }
}), sM = /* @__PURE__ */ U({
  __name: "DropdownMenu",
  props: {
    defaultOpen: { type: Boolean },
    open: { type: Boolean },
    dir: {},
    modal: { type: Boolean }
  },
  emits: ["update:open"],
  setup(e, { emit: t }) {
    const o = Io(e, t);
    return (a, i) => ($(), ne(S(yO), zr(ko(S(o))), {
      default: Y(() => [
        V(a.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), lM = /* @__PURE__ */ U({
  __name: "DropdownMenuContent",
  props: {
    forceMount: { type: Boolean },
    loop: { type: Boolean },
    side: {},
    sideOffset: { default: 6 },
    align: {},
    alignOffset: {},
    avoidCollisions: { type: Boolean },
    collisionBoundary: {},
    collisionPadding: {},
    arrowPadding: {},
    sticky: {},
    hideWhenDetached: { type: Boolean },
    updatePositionStrategy: {},
    prioritizePosition: { type: Boolean },
    asChild: { type: Boolean },
    as: {},
    class: { default: void 0 }
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "closeAutoFocus"],
  setup(e, { emit: t }) {
    const r = e, n = t, o = _p(r, "class"), a = Io(o, n);
    return (i, s) => ($(), ne(S(wO), null, {
      default: Y(() => [
        ie(S(_O), We(S(a), {
          class: S(da)([
            "z-50 min-w-[200px] overflow-hidden p-1 antialiased",
            // base styles
            "rounded-md border shadow-lg",
            // border and shadow
            "border-slate-300 bg-white",
            // border and background color
            "will-change-[transform,opacity] data-[state=closed]:animate-hide data-[state=open]:animate-slideDownAndFade"
            // animations
          ], r.class)
        }), {
          default: Y(() => [
            V(i.$slots, "default")
          ]),
          _: 3
        }, 16, ["class"])
      ]),
      _: 3
    }));
  }
}), KI = v1({
  base: [
    "flex cursor-pointer items-center rounded",
    "gap-x-3 px-3 py-2",
    "text-sm leading-none",
    "data-[disabled]:pointer-events-none data-[disabled]:opacity-40"
  ],
  variants: {
    variant: {
      default: "hover:bg-slate-200",
      destructive: [
        "text-red-600",
        "hover:bg-red-100"
      ]
    }
  },
  defaultVariants: {
    variant: "default"
  }
}), YI = { class: "flex w-full items-center justify-between" }, uM = /* @__PURE__ */ U({
  __name: "DropdownMenuItem",
  props: {
    disabled: { type: Boolean },
    textValue: {},
    asChild: { type: Boolean },
    as: {},
    class: {},
    icon: { type: [Function, Object, null] },
    variant: {}
  },
  setup(e) {
    const t = e, r = _p(t, "class"), n = Js(r);
    return (o, a) => ($(), ne(S(SO), We(S(n), {
      class: S(da)(S(KI)({ variant: o.variant }), t.class)
    }), {
      default: Y(() => [
        o.icon ? ($(), ne(er(o.icon), {
          key: 0,
          class: "size-4 shrink-0 opacity-80"
        })) : _e("", !0),
        X("span", YI, [
          V(o.$slots, "default")
        ])
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), JI = {}, ZI = { class: "pl-6 leading-none text-slate-500" };
function XI(e, t) {
  return $(), B("div", ZI, [
    V(e.$slots, "default")
  ]);
}
const cM = /* @__PURE__ */ De(JI, [["render", XI]]), dM = /* @__PURE__ */ U({
  __name: "DropdownMenuSeparator",
  props: {
    asChild: { type: Boolean },
    as: {},
    class: {}
  },
  setup(e) {
    const t = e, r = _p(t, "class");
    return (n, o) => ($(), ne(S(xO), We(S(r), {
      class: S(da)("-mx-1 my-1 h-px bg-slate-200", t.class)
    }), null, 16, ["class"]));
  }
}), fM = /* @__PURE__ */ U({
  __name: "DropdownMenuTrigger",
  props: {
    disabled: { type: Boolean },
    asChild: { type: Boolean },
    as: {}
  },
  setup(e) {
    const r = Js(e);
    return (n, o) => ($(), ne(S(bO), We({ class: "block outline-none" }, S(r)), {
      default: Y(() => [
        V(n.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), QI = { class: "flex flex-col justify-center px-4 py-12 space-y-4" }, eD = {
  key: 0,
  class: "block"
}, pM = /* @__PURE__ */ U({
  __name: "DropZone",
  props: /* @__PURE__ */ br({
    accepts: { default: "*" },
    label: {},
    actionLabel: {},
    multiple: { type: Boolean, default: !1 }
  }, {
    modelValue: {
      default: []
    },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = e, r = wr(e, "modelValue"), n = se(), o = re(() => {
      switch (t.accepts) {
        case "image":
          return "image/*";
        case "pdf":
          return "application/pdf";
        default:
          return "*";
      }
    }), { open: a, onChange: i } = xb({
      accept: o.value,
      multiple: t.multiple
    }), { isOverDropZone: s } = c2(n, {
      onDrop: l,
      // specify the types of data to be received.
      dataTypes: (c) => t.accepts === "*" ? !0 : t.accepts === "image" ? c.some((d) => d.startsWith("image")) : c.includes(t.accepts)
    });
    i((c) => {
      const d = Array.from(c || []);
      l(d);
    });
    function l(c) {
      c !== null && (r.value = t.multiple ? [...r.value, ...c] : [c[0]]);
    }
    const u = re(() => [
      { "bg-blue-500": s.value }
    ]);
    return (c, d) => ($(), B("button", {
      ref_key: "dropZoneRef",
      ref: n,
      class: Te([u.value, "block w-full cursor-pointer rounded border border-dashed bg-white hover:border-solid hover:bg-slate-50"]),
      onClick: d[0] || (d[0] = () => S(a)())
    }, [
      X("span", QI, [
        X("span", null, [
          ie(S(Ir), { variant: "secondary" }, {
            default: Y(() => [
              et(Ie(c.actionLabel), 1)
            ]),
            _: 1
          })
        ]),
        c.label ? ($(), B("span", eD, Ie(c.label), 1)) : _e("", !0)
      ])
    ], 2));
  }
}), tD = { class: "text-center my-12" }, hM = /* @__PURE__ */ U({
  __name: "EmptyState",
  setup(e) {
    return (t, r) => ($(), ne(S(Np), null, {
      default: Y(() => [
        ie(S(Kp), null, {
          default: Y(() => [
            X("div", tD, [
              V(t.$slots, "default")
            ])
          ]),
          _: 3
        })
      ]),
      _: 3
    }));
  }
}), rD = { class: "flex justify-center mt-12" }, mM = /* @__PURE__ */ U({
  __name: "EmptyStateActions",
  setup(e) {
    return (t, r) => ($(), B("div", rD, [
      ie(S(Pp), null, {
        default: Y(() => [
          V(t.$slots, "default")
        ]),
        _: 3
      })
    ]));
  }
}), nD = {}, oD = { class: "space-y-1.5" };
function iD(e, t) {
  return $(), B("div", oD, [
    V(e.$slots, "default")
  ]);
}
const vM = /* @__PURE__ */ De(nD, [["render", iD]]), gM = /* @__PURE__ */ U({
  __name: "EmptyStateDescription",
  setup(e) {
    return (t, r) => ($(), B("p", null, [
      ie(S(Ve), { subdued: "" }, {
        default: Y(() => [
          V(t.$slots, "default")
        ]),
        _: 3
      })
    ]));
  }
}), aD = {}, sD = { class: "text-xl font-semibold leading-none" };
function lD(e, t) {
  return $(), B("h3", sD, [
    V(e.$slots, "default")
  ]);
}
const yM = /* @__PURE__ */ De(aD, [["render", lD]]), uD = {}, cD = { class: "space-y-4" };
function dD(e, t) {
  return $(), B("ul", cD, [
    V(e.$slots, "default")
  ]);
}
const bM = /* @__PURE__ */ De(uD, [["render", dD]]), fD = { class: "flex items-start space-x-4" }, pD = { class: "flex h-5 w-5 items-center justify-center rounded-full bg-green-200" }, wM = /* @__PURE__ */ U({
  __name: "FeatureListItem",
  setup(e) {
    return (t, r) => ($(), B("li", fD, [
      X("div", pD, [
        ie(S(b2), { class: "h-4 w-4 text-green-700" })
      ]),
      X("p", null, [
        V(t.$slots, "default")
      ])
    ]));
  }
}), hD = {}, mD = { role: "list" };
function vD(e, t) {
  return $(), B("ul", mD, [
    V(e.$slots, "default")
  ]);
}
const _M = /* @__PURE__ */ De(hD, [["render", vD]]), gD = {}, yD = {
  class: "relative flex gap-x-2 [&:not(:last-child)]:pb-4",
  role: "listitem"
};
function bD(e, t) {
  return $(), B("li", yD, [
    t[0] || (t[0] = X("div", { class: "absolute top-0 -bottom-0 left-0 flex w-6 justify-center" }, [
      X("div", { class: "w-px bg-slate-200" })
    ], -1)),
    t[1] || (t[1] = X("div", { class: "relative flex h-5 w-6 flex-none items-center justify-center" }, [
      X("div", { class: "h-1 w-1 rounded-full bg-slate-100 ring-1 ring-slate-400" })
    ], -1)),
    V(e.$slots, "default")
  ]);
}
const SM = /* @__PURE__ */ De(gD, [["render", bD]]), wD = {}, _D = {
  class: "flex-auto rounded border bg-white/50 px-3 py-2 text-xs leading-5 shadow-sm",
  role: "note"
};
function SD(e, t) {
  return $(), B("div", _D, [
    V(e.$slots, "default")
  ]);
}
const xM = /* @__PURE__ */ De(wD, [["render", SD]]), xD = { class: "block" }, AM = /* @__PURE__ */ U({
  __name: "FeedItemDateIndicator",
  setup(e) {
    return (t, r) => ($(), B("div", xD, [
      ie(S(Ve), { subdued: "" }, {
        default: Y(() => [
          V(t.$slots, "default")
        ]),
        _: 3
      })
    ]));
  }
}), AD = { class: "h-4 w-4 text-white" }, TM = /* @__PURE__ */ U({
  __name: "FeedItemIcon",
  props: {
    color: {}
  },
  setup(e) {
    const t = e, r = re(() => ({
      backgroundColor: bt(t.color, "500")
    }));
    return (n, o) => ($(), B("div", {
      class: "absolute flex h-5 w-5 items-center justify-center rounded bg-green-400 ml-0.5",
      style: $t(r.value)
    }, [
      X("div", AD, [
        V(n.$slots, "default")
      ])
    ], 4));
  }
}), TD = {}, ED = { class: "flex-auto py-0 text-xs leading-5" };
function OD(e, t) {
  return $(), B("div", ED, [
    V(e.$slots, "default")
  ]);
}
const EM = /* @__PURE__ */ De(TD, [["render", OD]]), $D = { class: "w-full" }, CD = ["id", "accept", "aria-describedby", "aria-disabled", "aria-labelledby", "aria-required", "disabled", "multiple", "name", "required"], OM = /* @__PURE__ */ U({
  __name: "FileField",
  props: /* @__PURE__ */ br({
    disabled: { type: Boolean, default: !1 },
    error: { default: null },
    helpText: { default: null },
    id: { default: null },
    label: {},
    labelHidden: { type: Boolean, default: !1 },
    accept: { default: void 0 },
    name: {},
    multiple: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    filesizeLimit: { default: void 0 }
  }, {
    modelValue: {
      required: !0
    },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ br(["filesizeExceeded"], ["update:modelValue"]),
  setup(e, { emit: t }) {
    const r = e, n = wr(e, "modelValue"), o = t;
    function a(u) {
      const c = u.target, d = Array.from(c.files || []);
      for (const h of d)
        if (r.filesizeLimit && h.size >= r.filesizeLimit * 1024 * 1024) {
          o("filesizeExceeded");
          return;
        }
      r.multiple ? n.value = d : n.value = (d == null ? void 0 : d[0]) || null;
    }
    const i = r.id || Je("fileField"), s = re(() => r.error ? Je("fileFieldError") : void 0), l = re(() => {
      const u = {
        image: "image/*",
        video: "video/*",
        document: "application/pdf, application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint, text/plain"
      };
      return typeof r.accept == "string" ? u[r.accept] : (r.accept || []).map((c) => u[c]).join(", ");
    });
    return (u, c) => ($(), B("div", $D, [
      ie(S(Do), {
        id: `${S(i)}-label`,
        label: u.label,
        "label-for": S(i),
        "label-hidden": u.labelHidden
      }, null, 8, ["id", "label", "label-for", "label-hidden"]),
      X("div", {
        class: Te([{ "mt-1": !u.labelHidden }, "space-y-1"])
      }, [
        X("div", {
          class: Te([[
            u.error ? S(Qt)("focusWithin", "destructive") : S(Qt)("focusWithin"),
            { "border-red-500": u.error }
          ], "relative flex w-full items-center overflow-hidden rounded border shadow-sm dark:border-zinc-700"])
        }, [
          X("input", We({
            id: S(i),
            accept: l.value,
            "aria-describedby": s.value,
            "aria-disabled": u.disabled,
            "aria-labelledby": `${S(i)}-label`,
            "aria-required": u.required,
            disabled: u.disabled,
            multiple: u.multiple,
            name: u.name,
            required: u.required,
            class: "block w-full appearance-none border-none bg-white px-3 py-2 text-slate-700 outline-none file:-my-2 file:-ml-3 file:cursor-pointer file:rounded-l-[inherit] file:rounded-r-none file:border-0 file:border-solid file:border-slate-300 file:bg-slate-50 file:px-3 file:py-2 file:text-slate-500 file:outline-none file:[border-inline-end-width:1px] file:[margin-inline-end:0.5rem] file:hover:bg-slate-100 disabled:cursor-not-allowed disabled:bg-slate-50 dark:bg-slate-900 dark:text-white",
            type: "file"
          }, u.$attrs, { onChange: a }), null, 16, CD)
        ], 2),
        u.error && s.value ? ($(), ne(S(ol), {
          key: 0,
          id: s.value,
          message: u.error
        }, null, 8, ["id", "message"])) : _e("", !0),
        u.helpText ? ($(), ne(S(Fw), { key: 1 }, {
          default: Y(() => [
            et(Ie(u.helpText), 1)
          ]),
          _: 1
        })) : _e("", !0)
      ], 2)
    ]));
  }
}), $M = /* @__PURE__ */ U({
  __name: "FileUploadButton",
  props: /* @__PURE__ */ br({
    align: {},
    class: {},
    disabled: { type: Boolean },
    disclosure: { type: Boolean },
    external: { type: Boolean },
    fullWidth: { type: Boolean },
    href: {},
    iconOnly: { type: Boolean },
    loading: { type: Boolean },
    native: { type: Boolean },
    size: {},
    type: {},
    variant: {},
    accepts: { default: "*" },
    multiple: { type: Boolean, default: !1 }
  }, {
    modelValue: {
      default: []
    },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = e, r = wr(e, "modelValue"), n = re(() => {
      switch (t.accepts) {
        case "image":
          return "image/*";
        case "pdf":
          return "application/pdf";
        default:
          return "*";
      }
    }), { open: o, onChange: a } = xb({
      accept: n.value,
      multiple: t.multiple
    });
    a((s) => {
      const l = Array.from(s || []);
      i(l);
    });
    function i(s) {
      s !== null && (r.value = t.multiple ? [...r.value, ...s] : [s[0]]);
    }
    return (s, l) => ($(), ne(S(Ir), We(s.$props, { onClick: S(o) }), {
      default: Y(() => [
        V(s.$slots, "default")
      ]),
      _: 3
    }, 16, ["onClick"]));
  }
}), kD = ["id", "aria-label", "enctype"], CM = /* @__PURE__ */ U({
  __name: "Form",
  props: {
    accessibilityLabel: { default: void 0 },
    enctype: { default: void 0 },
    id: { default: null }
  },
  emits: ["submit"],
  setup(e) {
    const r = e.id || Je("form");
    return (n, o) => ($(), B("form", {
      id: S(r),
      "aria-label": n.accessibilityLabel,
      enctype: n.enctype,
      onSubmit: o[0] || (o[0] = Ss((a) => n.$emit("submit"), ["prevent"]))
    }, [
      V(n.$slots, "default")
    ], 40, kD));
  }
}), kM = /* @__PURE__ */ U({
  __name: "FormLayout",
  props: {
    columns: { default: 1 }
  },
  setup(e) {
    const t = e, r = re(() => [
      { "md:grid-cols-1": t.columns === 1 },
      { "md:grid-cols-2": t.columns === 2 },
      { "md:grid-cols-3": t.columns === 3 }
    ]);
    return (n, o) => ($(), B("div", {
      class: Te(["grid grid-cols-1 gap-4", r.value])
    }, [
      V(n.$slots, "default")
    ], 2));
  }
}), PD = { class: "flex items-center justify-center space-x-4 [&>*:nth-child(1)]:order-1 [&>*:nth-child(2)]:order-3 [&>*:nth-child(3)]:order-2" }, PM = /* @__PURE__ */ U({
  __name: "IntegrationConnection",
  setup(e) {
    return (t, r) => ($(), B("div", PD, [
      V(t.$slots, "default"),
      ie(S(uI), { class: "size-6 text-slate-400" })
    ]));
  }
}), ID = { class: "h-14 w-14 overflow-hidden rounded-md border bg-white bg-gradient-to-tl from-slate-100 p-1 shadow to-50%" }, IM = /* @__PURE__ */ U({
  __name: "IntegrationConnectionItem",
  props: {
    source: {},
    alt: {}
  },
  setup(e) {
    return (t, r) => ($(), B("div", ID, [
      ie(S(fa), { "aspect-ratio": "1:1" }, {
        default: Y(() => [
          ie(S(hi), {
            alt: t.alt,
            source: t.source,
            rounded: ""
          }, null, 8, ["alt", "source"])
        ]),
        _: 1
      })
    ]));
  }
}), DM = /* @__PURE__ */ U({
  __name: "KPICard",
  props: {
    orientation: { default: "horizontal" }
  },
  setup(e) {
    const t = e, r = re(() => ({
      "flex flex-col divide-y": t.orientation === "vertical",
      "flex flex-row divide-x": t.orientation === "horizontal"
    }));
    return (n, o) => ($(), ne(S(Np), null, {
      default: Y(() => [
        X("div", {
          class: Te([r.value, "[&>*]:flex-1 dark:divide-zinc-700"])
        }, [
          V(n.$slots, "default")
        ], 2)
      ]),
      _: 3
    }));
  }
}), DD = { class: "space-y-0.5" }, RD = {
  key: 0,
  class: "mt-6"
}, RM = /* @__PURE__ */ U({
  __name: "KPICardSection",
  props: {
    title: {},
    value: {}
  },
  setup(e) {
    return (t, r) => ($(), ne(S(Kp), null, {
      default: Y(() => [
        X("div", DD, [
          ie(S(Ve), { subdued: "" }, {
            default: Y(() => [
              et(Ie(t.title), 1)
            ]),
            _: 1
          }),
          ie(S(gi), { size: "2xl" }, {
            default: Y(() => [
              et(Ie(t.value), 1)
            ]),
            _: 1
          })
        ]),
        t.$slots.default ? ($(), B("div", RD, [
          V(t.$slots, "default")
        ])) : _e("", !0)
      ]),
      _: 3
    }));
  }
}), MD = {
  key: 0,
  textContent: " ↗"
}, MM = /* @__PURE__ */ U({
  inheritAttrs: !1,
  __name: "Link",
  props: {
    accessibilityLabel: { default: null },
    external: { type: Boolean },
    href: {},
    underline: { type: Boolean }
  },
  setup(e) {
    const t = e, r = re(() => t.external ? "a" : Hs), n = re(() => {
      const a = t.href.startsWith("mailto:");
      return t.external && !a ? "_blank" : "_self";
    }), o = re(() => [
      { underline: t.underline }
    ]);
    return (a, i) => ($(), ne(er(r.value), We({
      "aria-label": a.accessibilityLabel,
      href: a.href,
      target: n.value,
      "data-component": "link",
      class: ["cursor-pointer text-brand-500 hover:underline dark:text-blue-500", o.value]
    }, a.$attrs), {
      default: Y(() => [
        V(a.$slots, "default"),
        a.external ? ($(), B("span", MD)) : _e("", !0)
      ]),
      _: 3
    }, 16, ["aria-label", "href", "target", "class"]));
  }
}), BD = {}, qD = { role: "complementary" };
function LD(e, t) {
  return $(), B("aside", qD, [
    V(e.$slots, "default")
  ]);
}
const BM = /* @__PURE__ */ De(BD, [["render", LD]]), FD = { class: "flex items-center px-3 py-2 space-x-3" }, ND = {
  key: 0,
  class: "h-4 w-4 opacity-75"
}, qM = /* @__PURE__ */ U({
  __name: "NavigationItem",
  props: {
    active: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    href: {},
    icon: { type: [Function, Object, null], default: null }
  },
  setup(e) {
    const t = e, r = re(() => [
      { "relative bg-slate-200 dark:bg-zinc-800": t.active },
      { "text-slate-500 hover:bg-slate-100 dark:hover:bg-zinc-900 dark:text-zinc-500": !t.active },
      { "opacity-50 pointer-events-none": t.disabled }
    ]);
    return (n, o) => ($(), B("div", {
      class: Te(["block rounded", r.value])
    }, [
      ie(S(Hs), { href: n.href }, {
        default: Y(() => [
          X("div", FD, [
            n.icon ? ($(), B("span", ND, [
              ($(), ne(er(n.icon)))
            ])) : _e("", !0),
            X("span", {
              class: Te({ "font-medium": n.active })
            }, [
              V(n.$slots, "default")
            ], 2)
          ])
        ]),
        _: 3
      }, 8, ["href"])
    ], 2));
  }
}), zD = {}, jD = { class: "relative pl-0.5" }, UD = { class: "ml-6 pl-0.5 space-y-0.5" };
function WD(e, t) {
  return $(), B("div", jD, [
    t[0] || (t[0] = X("div", { class: "absolute top-0 bottom-0 border-l border-slate-300 w-10 ml-[17px]" }, null, -1)),
    X("div", UD, [
      V(e.$slots, "default")
    ])
  ]);
}
const LM = /* @__PURE__ */ De(zD, [["render", WD]]), VD = { class: "pb-8" }, HD = { class: "px-3 py-2" }, GD = { class: "space-y-0.5" }, FM = /* @__PURE__ */ U({
  __name: "NavigationSection",
  props: {
    label: { default: null }
  },
  setup(e) {
    return (t, r) => ($(), B("div", VD, [
      t.label ? ($(), ne(S(Ve), {
        key: 0,
        strong: ""
      }, {
        default: Y(() => [
          X("p", HD, Ie(t.label), 1)
        ]),
        _: 1
      })) : _e("", !0),
      X("div", GD, [
        V(t.$slots, "default")
      ])
    ]));
  }
}), KD = { class: "grid grid-cols-4 gap-x-8" }, YD = {
  key: 0,
  class: "col-span-1"
}, NM = /* @__PURE__ */ U({
  __name: "Page",
  props: {
    navigation: { default: null },
    size: { default: "default" }
  },
  setup(e) {
    const t = Zw(), r = re(() => e.navigation || !!t["page-navigation"]), n = e.navigation ? Cr(e.navigation) : Cr("div"), o = re(() => [
      { "max-w-8xl": e.size === "default" },
      { "max-w-3xl": e.size === "compact" }
    ]), a = re(() => r.value ? "col-span-3" : "col-span-4");
    return (i, s) => ($(), B("div", {
      class: Te(["mx-auto p-8", o.value])
    }, [
      X("div", KD, [
        r.value ? ($(), B("div", YD, [
          ie(S(n)),
          V(i.$slots, "page-navigation")
        ])) : _e("", !0),
        X("div", {
          class: Te(a.value)
        }, [
          V(i.$slots, "default")
        ], 2)
      ])
    ], 2));
  }
}), JD = {};
function ZD(e, t) {
  return $(), B("div", null, [
    V(e.$slots, "default")
  ]);
}
const zM = /* @__PURE__ */ De(JD, [["render", ZD]]), jM = /* @__PURE__ */ U({
  __name: "PageDescription",
  setup(e) {
    return (t, r) => ($(), B("p", null, [
      ie(S(Ve), { subdued: "" }, {
        default: Y(() => [
          V(t.$slots, "default")
        ]),
        _: 3
      })
    ]));
  }
}), XD = { class: "mb-8 flex gap-4" }, QD = {
  key: 0,
  class: "mt-1"
}, e4 = ["href", "title"], t4 = { class: "flex flex-grow flex-col space-y-1.5" }, UM = /* @__PURE__ */ U({
  __name: "PageHeader",
  props: {
    backAction: { default: null }
  },
  setup(e) {
    return (t, r) => ($(), B("div", XD, [
      t.backAction ? ($(), B("div", QD, [
        X("a", {
          href: t.backAction.href,
          title: t.backAction.content,
          class: "block rounded bg-slate-200 dark:bg-zinc-800 dark:hover:bg-zinc-700 p-1 hover:bg-slate-300"
        }, [
          ie(S(v2), { class: "size-4" })
        ], 8, e4)
      ])) : _e("", !0),
      X("div", t4, [
        V(t.$slots, "default")
      ]),
      V(t.$slots, "page-header-actions")
    ]));
  }
}), r4 = { class: "ml-1 hidden text-black group-hover:block" }, n4 = /* @__PURE__ */ U({
  __name: "PageHelp",
  props: {
    label: {},
    href: { default: void 0 },
    onClick: { type: Function, default: void 0 }
  },
  setup(e) {
    const t = e;
    return (r, n) => ($(), ne(er(t.href ? S(Aw) : "button"), We({
      href: r.href,
      class: "group ml-2 flex shrink-0 items-center rounded-full border border-transparent p-1 pr-2 text-xs font-normal leading-none text-slate-500 hover:border-slate-300 hover:bg-slate-100 dark:text-zinc-400",
      target: r.href ? "_blank" : void 0
    }, r.$attrs, { onClick: r.onClick }), {
      default: Y(() => [
        ie(S(Eb), { class: "size-4 group-hover:text-brand-500" }),
        X("span", r4, Ie(r.label), 1)
      ]),
      _: 1
    }, 16, ["href", "target", "onClick"]));
  }
}), o4 = { class: "flex items-center" }, i4 = { class: "truncate" }, WM = /* @__PURE__ */ U({
  __name: "PageTitle",
  props: {
    pageHelp: { default: null }
  },
  setup(e) {
    return (t, r) => ($(), ne(S(gi), {
      level: "h1",
      size: "2xl"
    }, {
      default: Y(() => [
        X("span", o4, [
          X("span", i4, [
            V(t.$slots, "default")
          ]),
          t.pageHelp ? ($(), ne(S(n4), zr(We({ key: 0 }, t.pageHelp)), null, 16)) : _e("", !0)
        ])
      ]),
      _: 3
    }));
  }
}), a4 = {}, s4 = { class: "flex space-x-1" };
function l4(e, t) {
  return $(), B("div", s4, [
    V(e.$slots, "default")
  ]);
}
const VM = /* @__PURE__ */ De(a4, [["render", l4]]), HM = /* @__PURE__ */ U({
  __name: "PaginationNextButton",
  props: {
    disabled: { type: Boolean, default: !1 },
    href: {}
  },
  setup(e) {
    return (t, r) => ($(), ne(S(Ir), {
      disabled: t.disabled,
      href: t.href,
      "icon-only": "",
      variant: "secondary"
    }, {
      default: Y(() => [
        ie(S(ii), { icon: S(Sp) }, null, 8, ["icon"])
      ]),
      _: 1
    }, 8, ["disabled", "href"]));
  }
}), GM = /* @__PURE__ */ U({
  __name: "PaginationPreviousButton",
  props: {
    disabled: { type: Boolean, default: !1 },
    href: {}
  },
  setup(e) {
    return (t, r) => ($(), ne(S(Ir), {
      disabled: t.disabled,
      href: t.href,
      "icon-only": "",
      variant: "secondary"
    }, {
      default: Y(() => [
        ie(S(ii), { icon: S(Tb) }, null, 8, ["icon"])
      ]),
      _: 1
    }, 8, ["disabled", "href"]));
  }
}), u4 = { class: "flex items-center space-x-2" }, c4 = ["onFocus"], KM = /* @__PURE__ */ U({
  __name: "PinInput",
  props: {
    inputs: { default: 6 }
  },
  emits: ["complete"],
  setup(e, { emit: t }) {
    const r = e, n = t, o = se([]), a = se(Array(r.inputs).fill("")), i = se(0);
    function s(f) {
      return !isNaN(Number(f)) && f.trim().length === 1;
    }
    function l(f) {
      const v = f.join("");
      v.length === r.inputs && n("complete", v);
    }
    function u(f) {
      a.value[i.value] = f, o.value[i.value].value = f, l(a.value);
    }
    function c(f) {
      const v = Math.max(Math.min(r.inputs - 1, f), 0);
      o.value[v] && (o.value[v].focus(), o.value[v].select(), i.value = v);
    }
    function d(f) {
      const v = f.target.value;
      s(v) && (u(v), c(i.value + 1));
    }
    function h(f, v) {
      i.value = f - 1, v.target.select();
    }
    function y(f) {
      const v = f.target, w = v.value;
      s(w) || (w.length === r.inputs && (w.split("").some((T) => !s(T)) || (l(w.split("")), c(r.inputs - 1))), v.value = "");
    }
    function m(f) {
      [f.code, f.key].includes("Backspace") ? (f.preventDefault(), u(""), c(i.value - 1)) : f.code === "Delete" ? (f.preventDefault(), u("")) : f.code === "ArrowLeft" ? (f.preventDefault(), c(i.value - 1)) : f.code === "ArrowRight" ? (f.preventDefault(), c(i.value + 1)) : f.code === "Spacebar" || f.code === "Space" || f.code === "ArrowUp" || f.code === "ArrowDown" ? f.preventDefault() : /^[0-9]$/i.test(f.key) && (f.preventDefault(), s(f.key) && (u(f.key), c(i.value + 1)));
    }
    function p(f) {
      f.preventDefault();
      const v = f.clipboardData.getData("text/plain").slice(0, r.inputs - i.value).split("");
      if (!v.some((w) => isNaN(Number(w)))) {
        for (let w = 0; w < r.inputs; ++w)
          if (w >= i.value && v.length > 0) {
            if (w >= v.length)
              break;
            u(v[w]), c(i.value + 1);
          }
      }
    }
    return (f, v) => ($(), B("div", u4, [
      ($(!0), B(qt, null, sr(f.inputs, (w) => ($(), B("input", {
        key: w,
        ref_for: !0,
        ref_key: "$otpInput",
        ref: o,
        autocomplete: "off",
        class: "border w-10 px-3 py-2 text-center rounded",
        pattern: "[0-9]",
        placeholder: "•",
        required: "",
        type: "text",
        inputmode: "numeric",
        onChange: d,
        onFocus: (_) => h(w, _),
        onInput: y,
        onKeydown: m,
        onPaste: p
      }, null, 40, c4))), 128))
    ]));
  }
}), d4 = {
  class: "space-y-2",
  role: "progressbar"
}, f4 = ["value"], p4 = { class: "h-2 overflow-hidden rounded bg-slate-300 dark:bg-zinc-800" }, YM = /* @__PURE__ */ U({
  __name: "ProgressBar",
  props: {
    color: { default: "slate" },
    value: {},
    indicatorPosition: { default: null }
  },
  setup(e) {
    const t = e, r = re(() => js().value ? bt(t.color, "300") : bt(t.color, "500"));
    return (n, o) => ($(), B("div", d4, [
      n.$slots.default && n.indicatorPosition === "above" ? V(n.$slots, "default", { key: 0 }) : _e("", !0),
      ie(S(pi), null, {
        default: Y(() => [
          X("progress", {
            value: n.value,
            max: "100"
          }, null, 8, f4)
        ]),
        _: 1
      }),
      X("div", p4, [
        X("div", {
          class: "h-full rounded",
          style: $t({
            width: `${n.value}%`,
            backgroundColor: r.value
          })
        }, null, 4)
      ]),
      n.$slots.default && n.indicatorPosition === "below" ? V(n.$slots, "default", { key: 1 }) : _e("", !0)
    ]));
  }
}), h4 = {};
function m4(e, t) {
  return $(), B("div", null, [
    V(e.$slots, "default")
  ]);
}
const JM = /* @__PURE__ */ De(h4, [["render", m4]]), v4 = { class: "flex items-start space-x-2" }, g4 = ["id", "value"], y4 = { class: "-mt-[2px] space-y-1" }, b4 = /* @__PURE__ */ U({
  __name: "RadioButton",
  props: /* @__PURE__ */ br({
    helpText: { default: null },
    id: { default: null },
    label: {},
    value: {}
  }, {
    modelValue: { type: [Boolean, String] },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = e, r = wr(e, "modelValue"), n = t.id || Je("radioButton");
    return (o, a) => ($(), B("div", v4, [
      Dr(X("input", {
        id: S(n),
        "onUpdate:modelValue": a[0] || (a[0] = (i) => r.value = i),
        class: Te([S(Qt)("focus"), "size-4 shrink-0 appearance-none rounded-full border border-slate-400 bg-white text-brand-500 shadow-sm dark:border-zinc-700 dark:bg-zinc-800 dark:text-blue-500"]),
        value: o.value,
        type: "radio"
      }, null, 10, g4), [
        [R0, r.value]
      ]),
      X("div", y4, [
        ie(S(Do), {
          label: o.label,
          "label-for": S(n)
        }, null, 8, ["label", "label-for"]),
        o.helpText ? ($(), ne(S(Ve), {
          key: 0,
          subdued: ""
        }, {
          default: Y(() => [
            et(Ie(o.helpText), 1)
          ]),
          _: 1
        })) : _e("", !0)
      ])
    ]));
  }
}), ZM = /* @__PURE__ */ De(b4, [["__scopeId", "data-v-39a2a8e6"]]), w4 = {}, _4 = { "aria-live": "polite" };
function S4(e, t) {
  return $(), B("ul", _4, [
    V(e.$slots, "default")
  ]);
}
const XM = /* @__PURE__ */ De(w4, [["render", S4]]), x4 = {}, A4 = { class: "flex items-center space-x-4 hover:bg-slate-100 dark:hover:bg-zinc-800 px-6 py-3 cursor-pointer" };
function T4(e, t) {
  return $(), B("li", A4, [
    V(e.$slots, "default")
  ]);
}
const QM = /* @__PURE__ */ De(x4, [["render", T4]]), E4 = {};
function O4(e, t) {
  return $(), B("div", null, [
    V(e.$slots, "default")
  ]);
}
const eB = /* @__PURE__ */ De(E4, [["render", O4]]), $4 = { class: "w-full" }, C4 = ["id", "aria-describedby", "aria-disabled", "aria-labelledby", "aria-readonly", "aria-required", "disabled", "name", "readonly"], k4 = {
  key: 0,
  value: null,
  disabled: "",
  selected: ""
}, P4 = { class: "pointer-events-none absolute right-2 top-2.5 size-4" }, I4 = { class: "text-sm text-slate-500" }, tB = /* @__PURE__ */ U({
  __name: "Select",
  props: /* @__PURE__ */ br({
    disabled: { type: Boolean, default: !1 },
    error: { default: null },
    helpText: { default: null },
    id: { default: null },
    label: {},
    labelHidden: { type: Boolean, default: !1 },
    name: {},
    placeholder: { default: null },
    readonly: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = e, r = wr(e, "modelValue"), n = t.id || Je("select"), o = re(() => t.error ? Je("selectError") : void 0);
    return (a, i) => ($(), B("div", $4, [
      ie(S(Do), {
        id: `${S(n)}-label`,
        label: a.label,
        "label-for": S(n),
        "label-hidden": a.labelHidden
      }, null, 8, ["id", "label", "label-for", "label-hidden"]),
      X("div", {
        class: Te([{ "mt-1": !a.labelHidden }, "space-y-1"])
      }, [
        X("div", {
          class: Te([[
            S(Qt)("focusWithin"),
            { "border-red-500": a.error }
          ], "relative flex w-full items-center overflow-hidden rounded border shadow-sm dark:border-zinc-700"])
        }, [
          Dr(X("select", {
            id: S(n),
            "onUpdate:modelValue": i[0] || (i[0] = (s) => r.value = s),
            "aria-describedby": o.value,
            "aria-disabled": a.disabled,
            "aria-labelledby": `${S(n)}-label`,
            "aria-readonly": a.readonly,
            "aria-required": a.required,
            class: Te([S(Qt)("focus"), "block w-full appearance-none border-none px-3 py-2 placeholder:text-slate-400 text-slate-700 outline-none placeholder-slate-400 disabled:cursor-not-allowed disabled:bg-slate-50 dark:bg-zinc-900 dark:text-white"]),
            disabled: a.disabled,
            name: a.name,
            readonly: a.readonly
          }, [
            i[1] || (i[1] = et(' " v-bind="$attrs" > ')),
            a.placeholder ? ($(), B("option", k4, Ie(a.placeholder), 1)) : _e("", !0),
            V(a.$slots, "default")
          ], 10, C4), [
            [Xw, r.value]
          ]),
          X("div", P4, [
            ie(S(w2))
          ])
        ], 2),
        a.error && o.value ? ($(), ne(S(ol), {
          key: 0,
          id: o.value,
          message: a.error
        }, null, 8, ["id", "message"])) : _e("", !0),
        X("p", I4, Ie(a.helpText), 1)
      ], 2)
    ]));
  }
}), D4 = ["label"], rB = /* @__PURE__ */ U({
  __name: "SelectGroup",
  props: {
    label: {}
  },
  setup(e) {
    return (t, r) => ($(), B("optgroup", { label: t.label }, [
      V(t.$slots, "default")
    ], 8, D4));
  }
}), R4 = ["value"], nB = /* @__PURE__ */ U({
  __name: "SelectOption",
  props: {
    value: {}
  },
  setup(e) {
    return (t, r) => ($(), B("option", { value: t.value }, [
      V(t.$slots, "default")
    ], 8, R4));
  }
}), M4 = { class: "relative flex h-12 items-center" }, B4 = {
  key: 0,
  class: "absolute left-1/2 -translate-x-1/2 bg-white dark:bg-zinc-950 px-4"
}, oB = /* @__PURE__ */ U({
  __name: "Separator",
  props: {
    label: { default: null }
  },
  setup(e) {
    return (t, r) => ($(), B("div", M4, [
      r[0] || (r[0] = X("div", { class: "w-full shrink-0 h-[1px] bg-slate-300 dark:bg-zinc-700" }, null, -1)),
      t.label ? ($(), B("span", B4, [
        ie(S(Ve), { subdued: "" }, {
          default: Y(() => [
            et(Ie(t.label), 1)
          ]),
          _: 1
        })
      ])) : _e("", !0)
    ]));
  }
}), q4 = ["aria-label", "role"], L4 = /* @__PURE__ */ U({
  __name: "Spinner",
  props: {
    accessibilityLabel: { default: void 0 },
    hasFocusableParent: { type: Boolean, default: !1 },
    variant: { default: "dark" }
  },
  setup(e) {
    const t = e, r = re(() => t.hasFocusableParent ? "status" : void 0);
    return (n, o) => ($(), B("div", {
      "aria-label": n.accessibilityLabel,
      role: r.value
    }, [
      ($(), B("svg", {
        class: Te(["animate-spin size-4", {
          "text-black": t.variant === "dark",
          "text-white": t.variant === "light"
        }]),
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24"
      }, o[0] || (o[0] = [
        X("path", {
          fill: "currentColor",
          d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        }, null, -1)
      ]), 2))
    ], 8, q4));
  }
}), F4 = ["aria-labelledby"], N4 = ["id"], iB = /* @__PURE__ */ U({
  __name: "StatusIndicator",
  props: {
    accessibilityLabel: { default: null },
    color: {},
    size: { default: "default" }
  },
  setup(e) {
    const t = e, r = Je("statusLabel"), n = re(() => js().value ? {
      backgroundColor: bt(t.color, "500")
    } : {
      backgroundColor: bt(t.color, "300"),
      color: bt(t.color, "900")
    }), o = re(() => [
      { "text-xs": t.size === "small" },
      { "text-sm": t.size === "default" }
    ]);
    return (a, i) => ($(), B("div", {
      "aria-labelledby": S(r),
      style: $t({ color: n.value.color }),
      "aria-live": "polite",
      class: Te(["inline-flex items-center space-x-2", o.value]),
      role: "status"
    }, [
      X("div", {
        class: "size-3 rounded-full dark:text-white",
        style: $t({ backgroundColor: n.value.backgroundColor })
      }, null, 4),
      ie(S(Ve), { strong: "" }, {
        default: Y(() => [
          X("span", { id: S(r) }, [
            V(a.$slots, "default")
          ], 8, N4)
        ]),
        _: 3
      })
    ], 14, F4));
  }
}), z4 = { class: "inline-flex select-none flex-col space-y-2" }, j4 = { class: "inline-flex items-stretch rounded border shadow-sm dark:border-zinc-700" }, U4 = ["disabled"], W4 = ["value"], V4 = ["disabled"], H4 = { class: "select-text text-center text-xs" }, G4 = /* @__PURE__ */ U({
  __name: "Stepper",
  props: /* @__PURE__ */ br({
    color: { default: null },
    label: {},
    max: { default: void 0 },
    min: { default: void 0 }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = e, r = wr(e, "modelValue");
    function n() {
      r.value <= t.min || r.value--;
    }
    function o() {
      r.value >= t.max || r.value++;
    }
    function a(l) {
      l.target.select();
    }
    function i(l) {
      const u = l.target;
      let c = Number(u.value);
      c > t.max && (c = t.max), c < t.min && (c = t.min), r.value = c, u.valueAsNumber = c;
    }
    const s = re(() => {
      const l = t.color ?? "slate";
      return js().value ? {
        borderColor: bt(l, "700"),
        backgroundColor: bt(l, "900")
      } : {
        borderColor: bt(l, "400"),
        backgroundColor: bt(l, "100")
      };
    });
    return (l, u) => ($(), B("div", z4, [
      X("div", j4, [
        X("button", {
          class: Te([S(Qt)("focus"), "rounded-l bg-white px-3 hover:bg-slate-100 focus:z-10 disabled:pointer-events-none disabled:opacity-20 dark:bg-zinc-900 dark:hover:bg-zinc-800"]),
          disabled: r.value === t.min,
          type: "button",
          onClick: n
        }, [
          ie(S(Tb), { class: "size-4" })
        ], 10, U4),
        X("input", {
          class: Te([S(Qt)("focus"), "relative -my-px w-12 border py-2 text-center ![appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none"]),
          style: $t({
            borderColor: s.value.borderColor,
            backgroundColor: s.value.backgroundColor
          }),
          value: r.value,
          inputmode: "numeric",
          type: "number",
          onFocus: a,
          onInput: i
        }, null, 46, W4),
        X("button", {
          class: Te([S(Qt)("focus"), "rounded-r bg-white px-3 hover:bg-slate-100 focus:z-10 disabled:pointer-events-none disabled:opacity-20 dark:bg-zinc-900 dark:hover:bg-zinc-800"]),
          disabled: r.value === t.max,
          type: "button",
          onClick: o
        }, [
          ie(S(Sp), { class: "size-4" })
        ], 10, V4)
      ]),
      X("div", H4, [
        ie(S(Ve), { subdued: "" }, {
          default: Y(() => [
            et(Ie(l.label), 1)
          ]),
          _: 1
        })
      ])
    ]));
  }
}), aB = /* @__PURE__ */ De(G4, [["__scopeId", "data-v-38bdd63a"]]), K4 = {
  class: "inline-flex rounded-md bg-slate-200 p-1",
  role: "tablist"
}, sB = /* @__PURE__ */ U({
  __name: "Tabs",
  setup(e) {
    const t = se(null);
    return tt("activeTabItem", t), (r, n) => ($(), B("div", K4, [
      V(r.$slots, "default")
    ]));
  }
}), lB = /* @__PURE__ */ U({
  __name: "TabTrigger",
  props: {
    active: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, r = Je("tabItem"), n = je("activeTabItem");
    Lt(() => {
      t.active && (n.value = r);
    });
    function o() {
      n.value = r;
    }
    const a = re(() => [
      { "bg-white shadow": n.value === r }
    ]);
    return (i, s) => ($(), B("button", {
      class: Te([a.value, "rounded px-3 py-2"]),
      role: "tab",
      onClick: o
    }, [
      ie(S(Ve), { strong: "" }, {
        default: Y(() => [
          V(i.$slots, "default")
        ]),
        _: 3
      })
    ], 2));
  }
}), Y4 = { class: "flex items-center space-x-2" }, uB = /* @__PURE__ */ U({
  __name: "Tag",
  props: {
    accessibilityLabel: { default: null },
    color: {}
  },
  emits: ["remove"],
  setup(e) {
    const t = e, r = re(() => ({
      backgroundColor: bt(t.color, "200"),
      color: bt(t.color, "900")
    }));
    return (n, o) => ($(), B("span", {
      class: "inline-flex items-center rounded bg-slate-200 py-1 pr-1 pl-2 text-xs",
      style: $t(r.value)
    }, [
      ie(S(Ve), { strong: "" }, {
        default: Y(() => [
          X("div", Y4, [
            V(n.$slots, "default")
          ])
        ]),
        _: 3
      }),
      X("button", {
        class: "ml-2 flex cursor-pointer items-center rounded hover:bg-black/10",
        onClick: o[0] || (o[0] = (a) => n.$emit("remove"))
      }, [
        ie(S(ua), { class: "h-4 w-4" })
      ]),
      n.accessibilityLabel ? ($(), ne(S(pi), { key: 0 }, {
        default: Y(() => [
          et(Ie(n.accessibilityLabel), 1)
        ]),
        _: 1
      })) : _e("", !0)
    ], 4));
  }
}), J4 = /* @__PURE__ */ U({
  __name: "DismissToastAction",
  props: {
    variant: { default: "default" }
  },
  emits: ["dismiss"],
  setup(e) {
    const t = e, r = re(() => ({
      "hover:bg-red-200 dark:hover:bg-red-600": t.variant === "destructive",
      "hover:bg-slate-200 dark:hover:bg-zinc-700": t.variant === "default"
    }));
    return (n, o) => ($(), B("button", {
      "aria-label": "Dismiss notification",
      class: Te(["flex size-5 items-center justify-center rounded", r.value]),
      type: "button",
      onClick: o[0] || (o[0] = (a) => n.$emit("dismiss"))
    }, [
      ie(S(ua), { class: "size-4" })
    ], 2));
  }
}), Z4 = { class: "mr-2" }, cB = /* @__PURE__ */ U({
  __name: "Toast",
  props: {
    open: { type: Boolean, default: !1 },
    duration: { default: 5e3 },
    variant: { default: "default" }
  },
  emits: ["close"],
  setup(e, { emit: t }) {
    const r = e, n = t;
    function o() {
      n("close");
    }
    at(() => r.open, async (i) => {
      i && setTimeout(() => o(), r.duration);
    }, { immediate: !0 });
    const a = re(() => [
      { "bg-white dark:border-zinc-700 dark:bg-zinc-900": r.variant === "default" },
      { "bg-red-50 border-red-500/40 dark:border-red-500 dark:bg-red-600": r.variant === "destructive" },
      { "bg-blue-50 border-blue-500/40 dark:border-blue-500 dark:bg-blue-600": r.variant === "informative" },
      { "bg-yellow-50 border-yellow-500/40 dark:border-yellow-500 dark:bg-yellow-600": r.variant === "warning" }
    ]);
    return (i, s) => ($(), B("div", {
      class: Te(["relative flex w-auto rounded border px-4 py-3 shadow-lg", a.value])
    }, [
      X("div", Z4, [
        V(i.$slots, "default")
      ]),
      ie(J4, {
        variant: i.variant,
        onDismiss: o
      }, null, 8, ["variant"])
    ], 2));
  }
}), X4 = {}, Q4 = { class: "fixed right-4 top-4 z-[999] flex flex-col-reverse items-end space-y-3 space-y-reverse" };
function e6(e, t) {
  return $(), B("div", Q4, [
    V(e.$slots, "default")
  ]);
}
const dB = /* @__PURE__ */ De(X4, [["render", e6]]), t6 = { class: "flex items-start" }, r6 = ["id", "disabled"], n6 = { class: "ml-4 space-y-1 font-normal" }, fB = /* @__PURE__ */ U({
  __name: "Toggle",
  props: /* @__PURE__ */ br({
    disabled: { type: Boolean, default: !1 },
    id: { default: null },
    label: {},
    helpText: { default: null }
  }, {
    modelValue: { type: Boolean, required: !0 },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = e, r = wr(e, "modelValue"), n = t.id || Je("toggle"), o = re(() => [
      // Color classes...
      { "bg-brand-500 border-brand-700": r.value },
      { "bg-slate-200 dark:bg-zinc-700 border-slate-300": !r.value },
      // Disabled classes...
      { "cursor-not-allowed opacity-50": t.disabled }
    ]), a = re(() => [
      { "translate-x-4 border-brand-600": r.value },
      { "translate-x-0 border-slate-300": !r.value }
    ]);
    return (i, s) => ($(), B("div", t6, [
      X("label", null, [
        Dr(X("input", {
          id: S(n),
          "onUpdate:modelValue": s[0] || (s[0] = (l) => r.value = l),
          disabled: i.disabled,
          class: "hidden",
          type: "checkbox"
        }, null, 8, r6), [
          [D0, r.value]
        ]),
        X("span", {
          class: Te(["relative inline-flex h-5 w-9 shrink-0 cursor-pointer items-center rounded-full shadow-inner transition-colors duration-150 ease-in-out", o.value])
        }, [
          X("span", {
            class: Te(["pointer-events-none ml-[2px] inline-block size-4 rounded-full bg-white ring-0 transition duration-150 ease-in-out", a.value])
          }, null, 2)
        ], 2)
      ]),
      X("span", n6, [
        ie(S(Do), {
          label: i.label,
          "label-for": S(n)
        }, null, 8, ["label", "label-for"]),
        i.helpText ? ($(), ne(S(Ve), {
          key: 0,
          subdued: ""
        }, {
          default: Y(() => [
            et(Ie(i.helpText), 1)
          ]),
          _: 1
        })) : _e("", !0)
      ])
    ]));
  }
}), o6 = { class: "rounded bg-black px-2 py-1 text-sm text-white" }, pB = /* @__PURE__ */ U({
  __name: "Tooltip",
  props: {
    content: {}
  },
  setup(e) {
    return (t, r) => ($(), ne(S(Fb), {
      timeout: 50,
      placement: "top",
      trigger: "hover"
    }, {
      default: Y(() => [
        ie(S(zb), null, {
          default: Y(() => [
            V(t.$slots, "default")
          ]),
          _: 3
        }),
        ie(S(Nb), null, {
          default: Y(() => [
            ie(S(vx)),
            X("div", o6, Ie(t.content), 1)
          ]),
          _: 1
        })
      ]),
      _: 3
    }));
  }
}), i6 = {}, a6 = { class: "sticky top-0 flex h-16 items-center border-b bg-white/50 px-4 shadow-sm backdrop-blur-lg space-x-4" };
function s6(e, t) {
  return $(), B("div", a6, [
    V(e.$slots, "default")
  ]);
}
const hB = /* @__PURE__ */ De(i6, [["render", s6]]), l6 = {}, u6 = { class: "flex h-10 w-10 items-center justify-center rounded text-white bg-brand-500" };
function c6(e, t) {
  return $(), B("div", u6, " logo ");
}
const mB = /* @__PURE__ */ De(l6, [["render", c6]]), d6 = {}, f6 = { class: "flex flex-1 space-x-2" };
function p6(e, t) {
  return $(), B("div", f6, [
    V(e.$slots, "default")
  ]);
}
const vB = /* @__PURE__ */ De(d6, [["render", p6]]), h6 = { role: "search" }, gB = /* @__PURE__ */ U({
  __name: "TopBarSearch",
  setup(e) {
    return (t, r) => ($(), B("form", h6, [
      ie(S(Qp), {
        label: "Search",
        "label-hidden": "",
        name: "search",
        type: "search",
        placeholder: "Search"
      })
    ]));
  }
});
export {
  v6 as Accordion,
  g6 as AccordionContent,
  b6 as AccordionItem,
  w6 as AccordionTrigger,
  _6 as ActionList,
  S6 as ActionListBody,
  A6 as ActionListItem,
  T6 as ActionListSection,
  E6 as ActionListTrigger,
  O6 as Alert,
  $6 as AlertDescription,
  k6 as AlertDialog,
  P6 as AlertDialogActionButton,
  I6 as AlertDialogCancelButton,
  D6 as AlertDialogContent,
  R6 as AlertDialogDescription,
  M6 as AlertDialogFooter,
  B6 as AlertDialogHeader,
  q6 as AlertDialogTitle,
  C6 as AlertTitle,
  fa as AspectRatio,
  U6 as Autocomplete,
  W6 as AutocompleteGroup,
  V6 as AutocompleteItem,
  H6 as Avatar,
  G6 as Badge,
  K6 as BadgeContent,
  Y6 as BadgeIcon,
  J6 as BarChart,
  Z6 as Breadcrumb,
  X6 as BreadcrumbEllipsis,
  Q6 as BreadcrumbItem,
  eR as BreadcrumbLink,
  tR as BreadcrumbList,
  rR as BreadcrumbPage,
  nR as BreadcrumbSeparator,
  Ir as Button,
  x6 as ButtonBadge,
  pA as ButtonContent,
  Pp as ButtonGroup,
  ii as ButtonIcon,
  Np as Card,
  oR as CardDescription,
  iR as CardFooter,
  aR as CardHeader,
  G3 as CardHelp,
  TR as CardIcon,
  ER as CardLayout,
  OR as CardMedia,
  Kp as CardSection,
  $R as CardSeparator,
  CR as CardTitle,
  kR as CategoryBar,
  PR as Checkbox,
  IR as CheckboxGroup,
  DR as Collapsible,
  RR as ColorInput,
  MR as ColorPalette,
  BR as DataList,
  qR as DataListContent,
  LR as DataListItem,
  FR as DataListItemLine,
  NR as DataTable,
  E0 as DataTableCell,
  zR as DataTableRoot,
  O0 as DataTableRow,
  jR as DatePicker,
  UR as DescriptionList,
  WR as DescriptionListDescription,
  VR as DescriptionListItem,
  HR as DescriptionListTerm,
  GR as Dialog,
  KR as DialogCancelButton,
  YR as DialogContent,
  JR as DialogDescription,
  ZR as DialogFooter,
  XR as DialogHeader,
  eM as DialogIcon,
  QR as DialogSection,
  tM as DialogTitle,
  rM as Drawer,
  nM as DrawerContent,
  oM as DrawerDescription,
  iM as DrawerHeader,
  aM as DrawerTitle,
  pM as DropZone,
  sM as DropdownMenu,
  lM as DropdownMenuContent,
  uM as DropdownMenuItem,
  cM as DropdownMenuItemShortcutIndicator,
  dM as DropdownMenuSeparator,
  fM as DropdownMenuTrigger,
  hM as EmptyState,
  mM as EmptyStateActions,
  vM as EmptyStateContent,
  gM as EmptyStateDescription,
  yM as EmptyStateTitle,
  bM as FeatureList,
  wM as FeatureListItem,
  _M as Feed,
  SM as FeedItem,
  xM as FeedItemBlock,
  AM as FeedItemDateIndicator,
  TM as FeedItemIcon,
  EM as FeedItemSimple,
  OM as FileField,
  $M as FileUploadButton,
  CM as Form,
  kM as FormLayout,
  gi as Heading,
  Fw as HelpText,
  hi as Image,
  Hs as InertiaLink,
  ol as InlineError,
  Do as InputLabel,
  PM as IntegrationConnection,
  IM as IntegrationConnectionItem,
  DM as KPICard,
  RM as KPICardSection,
  G5 as Legend,
  Y5 as LegendItem,
  MM as Link,
  BM as Navigation,
  qM as NavigationItem,
  LM as NavigationSecondarySection,
  FM as NavigationSection,
  NM as Page,
  zM as PageBody,
  jM as PageDescription,
  UM as PageHeader,
  n4 as PageHelp,
  WM as PageTitle,
  VM as Pagination,
  HM as PaginationNextButton,
  GM as PaginationPreviousButton,
  KM as PinInput,
  jb as Popover,
  Ub as PopoverBody,
  Wb as PopoverTrigger,
  Fb as Popper,
  vx as PopperArrow,
  Nb as PopperBody,
  zb as PopperTrigger,
  YM as ProgressBar,
  JM as ProgressBarIndicator,
  ZM as RadioButton,
  XM as ResourceList,
  QM as ResourceListItem,
  eB as ResourceListItemContent,
  tB as Select,
  rB as SelectGroup,
  nB as SelectOption,
  oB as Separator,
  L4 as Spinner,
  iB as StatusIndicator,
  aB as Stepper,
  lB as TabTrigger,
  sB as Tabs,
  uB as Tag,
  Qp as TextField,
  Ve as TextStyle,
  cB as Toast,
  dB as ToastGroup,
  fB as Toggle,
  pB as Tooltip,
  hB as TopBar,
  mB as TopBarLogo,
  vB as TopBarNavigation,
  gB as TopBarSearch,
  pi as VisuallyHidden,
  RS as useCalendar,
  js as useDark,
  DS as useDateFormatter,
  bt as useTailwindColor,
  Qt as useTheme,
  y6 as useToastNotifications,
  Je as useUniqueId
};
